(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire54eb"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire54eb"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5jmTd", function(module, exports) {

$parcel$export(module.exports, "_config", function () { return _config; });
$parcel$export(module.exports, "_isString", function () { return _isString; });
$parcel$export(module.exports, "_isUndefined", function () { return _isUndefined; });
$parcel$export(module.exports, "_numExp", function () { return _numExp; });
$parcel$export(module.exports, "_numWithUnitExp", function () { return _numWithUnitExp; });
$parcel$export(module.exports, "_relExp", function () { return _relExp; });
$parcel$export(module.exports, "gsap", function () { return gsap; });
$parcel$export(module.exports, "_missingPlugin", function () { return _missingPlugin; });
$parcel$export(module.exports, "_plugins", function () { return _plugins; });
$parcel$export(module.exports, "GSCache", function () { return GSCache; });
$parcel$export(module.exports, "_getCache", function () { return _getCache; });
$parcel$export(module.exports, "_getProperty", function () { return _getProperty; });
$parcel$export(module.exports, "_forEachName", function () { return _forEachName; });
$parcel$export(module.exports, "_round", function () { return _round; });
$parcel$export(module.exports, "_parseRelative", function () { return _parseRelative; });
$parcel$export(module.exports, "_ticker", function () { return _ticker; });
$parcel$export(module.exports, "getUnit", function () { return getUnit; });
$parcel$export(module.exports, "_replaceRandom", function () { return _replaceRandom; });
$parcel$export(module.exports, "_getSetter", function () { return _getSetter; });
$parcel$export(module.exports, "PropTween", function () { return PropTween; });
$parcel$export(module.exports, "_colorExp", function () { return _colorExp; });
$parcel$export(module.exports, "_colorStringFilter", function () { return _colorStringFilter; });
$parcel$export(module.exports, "_renderComplexString", function () { return _renderComplexString; });
$parcel$export(module.exports, "_checkPlugin", function () { return _checkPlugin; });
$parcel$export(module.exports, "_sortPropTweensByPriority", function () { return _sortPropTweensByPriority; });
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/*!
 * GSAP 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var _config = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: {
        lineHeight: ""
    }
}, _defaults = {
    duration: .5,
    overwrite: false,
    delay: 0
}, _suppressOverwrites, _reverting, _context, _bigNum = 1e8, _tinyNum = 1 / _bigNum, _2PI = Math.PI * 2, _HALF_PI = _2PI / 4, _gsID = 0, _sqrt = Math.sqrt, _cos = Math.cos, _sin = Math.sin, _isString = function _isString(value) {
    return typeof value === "string";
}, _isFunction = function _isFunction(value) {
    return typeof value === "function";
}, _isNumber = function _isNumber(value) {
    return typeof value === "number";
}, _isUndefined = function _isUndefined(value) {
    return typeof value === "undefined";
}, _isObject = function _isObject(value) {
    return typeof value === "object";
}, _isNotFalse = function _isNotFalse(value) {
    return value !== false;
}, _windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, _isFuncOrString = function _isFuncOrString(value) {
    return _isFunction(value) || _isString(value);
}, _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function() {}, // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
_isArray = Array.isArray, _strictNumExp = /(?:-?\.?\d|\.)+/gi, //only numbers (including negatives and decimals) but NOT relative values.
_numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
_numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
_relExp = /[+-]=-?[.\d]+/, _delimitedValueExp = /[^,'"\[\]\s]+/gi, // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
_unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, _globalTimeline, _win, _coreInitted, _doc, _globals = {}, _installScope = {}, _coreReady, _install = function _install(scope) {
    return (_installScope = _merge(scope, _globals)) && gsap;
}, _missingPlugin = function _missingPlugin(property, value) {
    return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
}, _warn = function _warn(message, suppress) {
    return !suppress && console.warn(message);
}, _addGlobal = function _addGlobal(name, obj) {
    return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
}, _emptyFunc = function _emptyFunc() {
    return 0;
}, _startAtRevertConfig = {
    suppressEvents: true,
    isStart: true,
    kill: false
}, _revertConfigNoKill = {
    suppressEvents: true,
    kill: false
}, _revertConfig = {
    suppressEvents: true
}, _reservedProps = {}, _lazyTweens = [], _lazyLookup = {}, _lastRenderedFrame, _plugins = {}, _effects = {}, _nextGCFrame = 30, _harnessPlugins = [], _callbackNames = "", _harness = function _harness(targets) {
    var target = targets[0], harnessPlugin, i;
    _isObject(target) || _isFunction(target) || (targets = [
        targets
    ]);
    if (!(harnessPlugin = (target._gsap || {}).harness)) {
        // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
        i = _harnessPlugins.length;
        while(i-- && !_harnessPlugins[i].targetTest(target));
        harnessPlugin = _harnessPlugins[i];
    }
    i = targets.length;
    while(i--)targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
    return targets;
}, _getCache = function _getCache(target) {
    return target._gsap || _harness(toArray(target))[0]._gsap;
}, _getProperty = function _getProperty(target, property, v) {
    return (v = target[property]) && _isFunction(v) ? target[property]() : _isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
}, _forEachName = function _forEachName(names, func) {
    return (names = names.split(",")).forEach(func) || names;
}, //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, _roundPrecise = function _roundPrecise(value) {
    return Math.round(value * 10000000) / 10000000 || 0;
}, // increased precision mostly for timing values.
_parseRelative = function _parseRelative(start, value) {
    var operator = value.charAt(0), end = parseFloat(value.substr(2));
    start = parseFloat(start);
    return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
}, _arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
    //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
    var l = toFind.length, i = 0;
    for(; toSearch.indexOf(toFind[i]) < 0 && ++i < l;);
    return i < l;
}, _lazyRender = function _lazyRender() {
    var l = _lazyTweens.length, a = _lazyTweens.slice(0), i, tween;
    _lazyLookup = {};
    _lazyTweens.length = 0;
    for(i = 0; i < l; i++){
        tween = a[i];
        tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
    }
}, _lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
    _lazyTweens.length && !_reverting && _lazyRender();
    animation.render(time, suppressEvents, force || _reverting && time < 0 && (animation._initted || animation._startAt));
    _lazyTweens.length && !_reverting && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
}, _numericIfPossible = function _numericIfPossible(value) {
    var n = parseFloat(value);
    return (n || n === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n : _isString(value) ? value.trim() : value;
}, _passThrough = function _passThrough(p) {
    return p;
}, _setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, _setKeyframeDefaults = function _setKeyframeDefaults(excludeDuration) {
    return function(obj, defaults) {
        for(var p in defaults)p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults[p]);
    };
}, _merge = function _merge(base, toMerge) {
    for(var p in toMerge)base[p] = toMerge[p];
    return base;
}, _mergeDeep = function _mergeDeep(base, toMerge) {
    for(var p in toMerge)p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = _isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
    return base;
}, _copyExcluding = function _copyExcluding(obj, excluding) {
    var copy = {}, p;
    for(p in obj)p in excluding || (copy[p] = obj[p]);
    return copy;
}, _inheritDefaults = function _inheritDefaults(vars) {
    var parent = vars.parent || _globalTimeline, func = vars.keyframes ? _setKeyframeDefaults(_isArray(vars.keyframes)) : _setDefaults;
    if (_isNotFalse(vars.inherit)) while(parent){
        func(vars, parent.vars.defaults);
        parent = parent.parent || parent._dp;
    }
    return vars;
}, _arraysMatch = function _arraysMatch(a1, a2) {
    var i = a1.length, match = i === a2.length;
    while(match && i-- && a1[i] === a2[i]);
    return i < 0;
}, _addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = parent[lastProp], t;
    if (sortBy) {
        t = child[sortBy];
        while(prev && prev[sortBy] > t)prev = prev._prev;
    }
    if (prev) {
        child._next = prev._next;
        prev._next = child;
    } else {
        child._next = parent[firstProp];
        parent[firstProp] = child;
    }
    if (child._next) child._next._prev = child;
    else parent[lastProp] = child;
    child._prev = prev;
    child.parent = child._dp = parent;
    return child;
}, _removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = child._prev, next = child._next;
    if (prev) prev._next = next;
    else if (parent[firstProp] === child) parent[firstProp] = next;
    if (next) next._prev = prev;
    else if (parent[lastProp] === child) parent[lastProp] = prev;
    child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
}, _removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
    child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
    child._act = 0;
}, _uncache = function _uncache(animation, child) {
    if (animation && (!child || child._end > animation._dur || child._start < 0)) {
        // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
        var a = animation;
        while(a){
            a._dirty = 1;
            a = a.parent;
        }
    }
    return animation;
}, _recacheAncestors = function _recacheAncestors(animation) {
    var parent = animation.parent;
    while(parent && parent.parent){
        //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
        parent._dirty = 1;
        parent.totalDuration();
        parent = parent.parent;
    }
    return animation;
}, _rewindStartAt = function _rewindStartAt(tween, totalTime, suppressEvents, force) {
    return tween._startAt && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
}, _hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
    return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
}, _elapsedCycleDuration = function _elapsedCycleDuration(animation) {
    return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
}, // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
_animationCycle = function _animationCycle(tTime, cycleDuration) {
    var whole = Math.floor(tTime /= cycleDuration);
    return tTime && whole === tTime ? whole - 1 : whole;
}, _parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
    return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
}, _setEnd = function _setEnd(animation) {
    return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
}, _alignPlayhead = function _alignPlayhead(animation, totalTime) {
    // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
    var parent = animation._dp;
    if (parent && parent.smoothChildTiming && animation._ts) {
        animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
        _setEnd(animation);
        parent._dirty || _uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
    }
    return animation;
}, /*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/ _postAddChecks = function _postAddChecks(timeline, child) {
    var t;
    if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
        // in case, for example, the _start is moved on a tween that has already rendered, or if it's being inserted into a timeline BEFORE where the playhead is currently. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning. Special case: if it's a timeline (has .add() method) and no duration, we can skip rendering because the user may be populating it AFTER adding it to a parent timeline (unconventional, but possible, and we wouldn't want it to get removed if the parent's autoRemoveChildren is true).
        t = _parentToChildTotalTime(timeline.rawTime(), child);
        if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) child.render(t, true);
    } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
    if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
        //in case any of the ancestors had completed but should now be enabled...
        if (timeline._dur < timeline.duration()) {
            t = timeline;
            while(t._dp){
                t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.
                t = t._dp;
            }
        }
        timeline._zTime = -_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
    }
}, _addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
    child.parent && _removeFromParent(child);
    child._start = _roundPrecise((_isNumber(position) ? position : position || timeline !== _globalTimeline ? _parsePosition(timeline, position, child) : timeline._time) + child._delay);
    child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
    _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);
    _isFromOrFromStart(child) || (timeline._recent = child);
    skipChecks || _postAddChecks(timeline, child);
    timeline._ts < 0 && _alignPlayhead(timeline, timeline._tTime); // if the timeline is reversed and the new child makes it longer, we may need to adjust the parent's _start (push it back)
    return timeline;
}, _scrollTrigger = function _scrollTrigger(animation, trigger) {
    return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
}, _attemptInitTween = function _attemptInitTween(tween, time, force, suppressEvents, tTime) {
    _initTween(tween, time, tTime);
    if (!tween._initted) return 1;
    if (!force && tween._pt && !_reverting && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
        _lazyTweens.push(tween);
        tween._lazy = [
            tTime,
            suppressEvents
        ];
        return 1;
    }
}, _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
    var parent = _ref.parent;
    return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
}, // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
_isFromOrFromStart = function _isFromOrFromStart(_ref2) {
    var data = _ref2.data;
    return data === "isFromStart" || data === "isStart";
}, _renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
    var prevRatio = tween.ratio, ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1, // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
    repeatDelay = tween._rDelay, tTime = 0, pt, iteration, prevIteration;
    if (repeatDelay && tween._repeat) {
        // in case there's a zero-duration tween that has a repeat with a repeatDelay
        tTime = _clamp(0, tween._tDur, totalTime);
        iteration = _animationCycle(tTime, repeatDelay);
        tween._yoyo && iteration & 1 && (ratio = 1 - ratio);
        if (iteration !== _animationCycle(tween._tTime, repeatDelay)) {
            // if iteration changed
            prevRatio = 1 - ratio;
            tween.vars.repeatRefresh && tween._initted && tween.invalidate();
        }
    }
    if (ratio !== prevRatio || _reverting || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
        if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
        return;
        prevIteration = tween._zTime;
        tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
        suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.
        tween.ratio = ratio;
        tween._from && (ratio = 1 - ratio);
        tween._time = 0;
        tween._tTime = tTime;
        pt = tween._pt;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        totalTime < 0 && _rewindStartAt(tween, totalTime, suppressEvents, true);
        tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
        tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");
        if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
            ratio && _removeFromParent(tween, 1);
            if (!suppressEvents && !_reverting) {
                _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);
                tween._prom && tween._prom();
            }
        }
    } else if (!tween._zTime) tween._zTime = totalTime;
}, _findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
    var child;
    if (time > prevTime) {
        child = animation._first;
        while(child && child._start <= time){
            if (child.data === "isPause" && child._start > prevTime) return child;
            child = child._next;
        }
    } else {
        child = animation._last;
        while(child && child._start >= time){
            if (child.data === "isPause" && child._start < prevTime) return child;
            child = child._prev;
        }
    }
}, _setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
    var repeat = animation._repeat, dur = _roundPrecise(duration) || 0, totalProgress = animation._tTime / animation._tDur;
    totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
    animation._dur = dur;
    animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
    totalProgress > 0 && !leavePlayhead && _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
    animation.parent && _setEnd(animation);
    skipUncache || _uncache(animation.parent, animation);
    return animation;
}, _onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
    return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
}, _zeroPosition = {
    _start: 0,
    endTime: _emptyFunc,
    totalDuration: _emptyFunc
}, _parsePosition = function _parsePosition(animation, position, percentAnimation) {
    var labels = animation.labels, recent = animation._recent || _zeroPosition, clippedDuration = animation.duration() >= _bigNum ? recent.endTime(false) : animation._dur, //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
    i, offset, isPercent;
    if (_isString(position) && (isNaN(position) || position in labels)) {
        //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
        offset = position.charAt(0);
        isPercent = position.substr(-1) === "%";
        i = position.indexOf("=");
        if (offset === "<" || offset === ">") {
            i >= 0 && (position = position.replace(/=/, ""));
            return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
        }
        if (i < 0) {
            position in labels || (labels[position] = clippedDuration);
            return labels[position];
        }
        offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));
        if (isPercent && percentAnimation) offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
        return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
    }
    return position == null ? clippedDuration : +position;
}, _createTweenType = function _createTweenType(type, params, timeline) {
    var isLegacy = _isNumber(params[1]), varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1), vars = params[varsIndex], irVars, parent;
    isLegacy && (vars.duration = params[1]);
    vars.parent = timeline;
    if (type) {
        irVars = vars;
        parent = timeline;
        while(parent && !("immediateRender" in irVars)){
            // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
            irVars = parent.vars.defaults || {};
            parent = _isNotFalse(parent.vars.inherit) && parent.parent;
        }
        vars.immediateRender = _isNotFalse(irVars.immediateRender);
        type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
    }
    return new Tween(params[0], vars, params[varsIndex + 1]);
}, _conditionalReturn = function _conditionalReturn(value, func) {
    return value || value === 0 ? func(value) : func;
}, _clamp = function _clamp(min, max, value) {
    return value < min ? min : value > max ? max : value;
}, getUnit = function getUnit(value, v) {
    return !_isString(value) || !(v = _unitExp.exec(value)) ? "" : v[1];
}, // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
clamp = function clamp(min, max, value) {
    return _conditionalReturn(value, function(v) {
        return _clamp(min, max, v);
    });
}, _slice = [].slice, _isArrayLike = function _isArrayLike(value, nonEmpty) {
    return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win;
}, _flatten = function _flatten(ar, leaveStrings, accumulator) {
    if (accumulator === void 0) accumulator = [];
    return ar.forEach(function(value) {
        var _accumulator;
        return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
    }) || accumulator;
}, //takes any value and returns an array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
toArray = function toArray(value, scope, leaveStrings) {
    return _context && !scope && _context.selector ? _context.selector(value) : _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [
        value
    ] : [];
}, selector = function selector(value) {
    value = toArray(value)[0] || _warn("Invalid scope") || {};
    return function(v) {
        var el = value.current || value.nativeElement || value;
        return toArray(v, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc.createElement("div") : value);
    };
}, shuffle = function shuffle(a) {
    return a.sort(function() {
        return .5 - Math.random();
    });
}, // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = Math.floor(Math.random() * i), v = a[--i], a[i] = a[j], a[j] = v); return a;
//for distributing values across an array. Can accept a number, a function or (most commonly) a function which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array. Recognizes the following
distribute = function distribute(v) {
    if (_isFunction(v)) return v;
    var vars = _isObject(v) ? v : {
        each: v
    }, //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
    ease = _parseEase(vars.ease), from = vars.from || 0, base = parseFloat(vars.base) || 0, cache = {}, isDecimal = from > 0 && from < 1, ratios = isNaN(from) || isDecimal, axis = vars.axis, ratioX = from, ratioY = from;
    if (_isString(from)) ratioX = ratioY = ({
        center: .5,
        edges: .5,
        end: 1
    })[from] || 0;
    else if (!isDecimal && ratios) {
        ratioX = from[0];
        ratioY = from[1];
    }
    return function(i, target, a) {
        var l = (a || vars).length, distances = cache[l], originX, originY, x, y, d, j, max, min, wrapAt;
        if (!distances) {
            wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [
                1,
                _bigNum
            ])[1];
            if (!wrapAt) {
                max = -_bigNum;
                while(max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l);
                wrapAt < l && wrapAt--;
            }
            distances = cache[l] = [];
            originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
            originY = wrapAt === _bigNum ? 0 : ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
            max = 0;
            min = _bigNum;
            for(j = 0; j < l; j++){
                x = j % wrapAt - originX;
                y = originY - (j / wrapAt | 0);
                distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
                d > max && (max = d);
                d < min && (min = d);
            }
            from === "random" && shuffle(distances);
            distances.max = max - min;
            distances.min = min;
            distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
            distances.b = l < 0 ? base - l : base;
            distances.u = getUnit(vars.amount || vars.each) || 0; //unit
            ease = ease && l < 0 ? _invertEase(ease) : ease;
        }
        l = (distances[i] - distances.min) / distances.max || 0;
        return _roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
    };
}, _roundModifier = function _roundModifier(v) {
    //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
    var p = Math.pow(10, ((v + "").split(".")[1] || "").length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())
    return function(raw) {
        var n = _roundPrecise(Math.round(parseFloat(raw) / v) * v * p);
        return (n - n % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
    };
}, snap = function snap(snapTo, value) {
    var isArray = _isArray(snapTo), radius, is2D;
    if (!isArray && _isObject(snapTo)) {
        radius = isArray = snapTo.radius || _bigNum;
        if (snapTo.values) {
            snapTo = toArray(snapTo.values);
            if (is2D = !_isNumber(snapTo[0])) radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
        } else snapTo = _roundModifier(snapTo.increment);
    }
    return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function(raw) {
        is2D = snapTo(raw);
        return Math.abs(is2D - raw) <= radius ? is2D : raw;
    } : function(raw) {
        var x = parseFloat(is2D ? raw.x : raw), y = parseFloat(is2D ? raw.y : 0), min = _bigNum, closest = 0, i = snapTo.length, dx, dy;
        while(i--){
            if (is2D) {
                dx = snapTo[i].x - x;
                dy = snapTo[i].y - y;
                dx = dx * dx + dy * dy;
            } else dx = Math.abs(snapTo[i] - x);
            if (dx < min) {
                min = dx;
                closest = i;
            }
        }
        closest = !radius || min <= radius ? snapTo[closest] : raw;
        return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
    });
}, random = function random(min, max, roundingIncrement, returnFunction) {
    return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? (roundingIncrement = 0, false) : !returnFunction, function() {
        return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5, returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
    });
}, pipe = function pipe() {
    for(var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++)functions[_key] = arguments[_key];
    return function(value) {
        return functions.reduce(function(v, f) {
            return f(v);
        }, value);
    };
}, unitize = function unitize(func, unit) {
    return function(value) {
        return func(parseFloat(value)) + (unit || getUnit(value));
    };
}, normalize = function normalize(min, max, value) {
    return mapRange(min, max, 0, 1, value);
}, _wrapArray = function _wrapArray(a, wrapper, value) {
    return _conditionalReturn(value, function(index) {
        return a[~~wrapper(index)];
    });
}, wrap = function wrap(min, max, value) {
    // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
    var range = max - min;
    return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, function(value) {
        return (range + (value - min) % range) % range + min;
    });
}, wrapYoyo = function wrapYoyo(min, max, value) {
    var range = max - min, total = range * 2;
    return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, function(value) {
        value = (total + (value - min) % total) % total || 0;
        return min + (value > range ? total - value : value);
    });
}, _replaceRandom = function _replaceRandom(value) {
    //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
    var prev = 0, s = "", i, nums, end, isArray;
    while(~(i = value.indexOf("random(", prev))){
        end = value.indexOf(")", i);
        isArray = value.charAt(i + 7) === "[";
        nums = value.substr(i + 7, end - i - 7).match(isArray ? _delimitedValueExp : _strictNumExp);
        s += value.substr(prev, i - prev) + random(isArray ? nums : +nums[0], isArray ? 0 : +nums[1], +nums[2] || 1e-5);
        prev = end + 1;
    }
    return s + value.substr(prev, value.length - prev);
}, mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
    var inRange = inMax - inMin, outRange = outMax - outMin;
    return _conditionalReturn(value, function(value) {
        return outMin + ((value - inMin) / inRange * outRange || 0);
    });
}, interpolate = function interpolate(start, end, progress, mutate) {
    var func = isNaN(start + end) ? 0 : function(p) {
        return (1 - p) * start + p * end;
    };
    if (!func) {
        var isString = _isString(start), master = {}, p, i, interpolators, l, il;
        progress === true && (mutate = 1) && (progress = null);
        if (isString) {
            start = {
                p: start
            };
            end = {
                p: end
            };
        } else if (_isArray(start) && !_isArray(end)) {
            interpolators = [];
            l = start.length;
            il = l - 2;
            for(i = 1; i < l; i++)interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
            l--;
            func = function func(p) {
                p *= l;
                var i = Math.min(il, ~~p);
                return interpolators[i](p - i);
            };
            progress = end;
        } else if (!mutate) start = _merge(_isArray(start) ? [] : {}, start);
        if (!interpolators) {
            for(p in end)_addPropTween.call(master, start, p, "get", end[p]);
            func = function func(p) {
                return _renderPropTweens(p, master) || (isString ? start.p : start);
            };
        }
    }
    return _conditionalReturn(progress, func);
}, _getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
    //used for nextLabel() and previousLabel()
    var labels = timeline.labels, min = _bigNum, p, distance, label;
    for(p in labels){
        distance = labels[p] - fromTime;
        if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
            label = p;
            min = distance;
        }
    }
    return label;
}, _callback = function _callback(animation, type, executeLazyFirst) {
    var v = animation.vars, callback = v[type], prevContext = _context, context = animation._ctx, params, scope, result;
    if (!callback) return;
    params = v[type + "Params"];
    scope = v.callbackScope || animation;
    executeLazyFirst && _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
    context && (_context = context);
    result = params ? callback.apply(scope, params) : callback.call(scope);
    _context = prevContext;
    return result;
}, _interrupt = function _interrupt(animation) {
    _removeFromParent(animation);
    animation.scrollTrigger && animation.scrollTrigger.kill(!!_reverting);
    animation.progress() < 1 && _callback(animation, "onInterrupt");
    return animation;
}, _quickTween, _registerPluginQueue = [], _createPlugin = function _createPlugin(config) {
    if (!config) return;
    config = !config.name && config["default"] || config; // UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.
    if (_windowExists() || config.headless) {
        // edge case: some build tools may pass in a null/undefined value
        var name = config.name, isFunc = _isFunction(config), Plugin = name && !isFunc && config.init ? function() {
            this._props = [];
        } : config, //in case someone passes in an object that's not a plugin, like CustomEase
        instanceDefaults = {
            init: _emptyFunc,
            render: _renderPropTweens,
            add: _addPropTween,
            kill: _killPropTweensOf,
            modifier: _addPluginModifier,
            rawVars: 0
        }, statics = {
            targetTest: 0,
            get: 0,
            getSetter: _getSetter,
            aliases: {},
            register: 0
        };
        _wake();
        if (config !== Plugin) {
            if (_plugins[name]) return;
            _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics)); //static methods
            _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics))); //instance methods
            _plugins[Plugin.prop = name] = Plugin;
            if (config.targetTest) {
                _harnessPlugins.push(Plugin);
                _reservedProps[name] = 1;
            }
            name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
        }
        _addGlobal(name, Plugin);
        config.register && config.register(gsap, Plugin, PropTween);
    } else _registerPluginQueue.push(config);
}, /*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */ _255 = 255, _colorLookup = {
    aqua: [
        0,
        _255,
        _255
    ],
    lime: [
        0,
        _255,
        0
    ],
    silver: [
        192,
        192,
        192
    ],
    black: [
        0,
        0,
        0
    ],
    maroon: [
        128,
        0,
        0
    ],
    teal: [
        0,
        128,
        128
    ],
    blue: [
        0,
        0,
        _255
    ],
    navy: [
        0,
        0,
        128
    ],
    white: [
        _255,
        _255,
        _255
    ],
    olive: [
        128,
        128,
        0
    ],
    yellow: [
        _255,
        _255,
        0
    ],
    orange: [
        _255,
        165,
        0
    ],
    gray: [
        128,
        128,
        128
    ],
    purple: [
        128,
        0,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    red: [
        _255,
        0,
        0
    ],
    pink: [
        _255,
        192,
        203
    ],
    cyan: [
        0,
        _255,
        _255
    ],
    transparent: [
        _255,
        _255,
        _255,
        0
    ]
}, // possible future idea to replace the hard-coded color name values - put this in the ticker.wake() where we set the _doc:
// let ctx = _doc.createElement("canvas").getContext("2d");
// _forEachName("aqua,lime,silver,black,maroon,teal,blue,navy,white,olive,yellow,orange,gray,purple,green,red,pink,cyan", color => {ctx.fillStyle = color; _colorLookup[color] = splitColor(ctx.fillStyle)});
_hue = function _hue(h, m1, m2) {
    h += h < 0 ? 1 : h > 1 ? -1 : 0;
    return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + .5 | 0;
}, splitColor = function splitColor(v, toHSL, forceAlpha) {
    var a = !v ? _colorLookup.black : _isNumber(v) ? [
        v >> 16,
        v >> 8 & _255,
        v & _255
    ] : 0, r, g, b, h, s, l, max, min, d, wasHSL;
    if (!a) {
        if (v.substr(-1) === ",") //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
        v = v.substr(0, v.length - 1);
        if (_colorLookup[v]) a = _colorLookup[v];
        else if (v.charAt(0) === "#") {
            if (v.length < 6) {
                //for shorthand like #9F0 or #9F0F (could have alpha)
                r = v.charAt(1);
                g = v.charAt(2);
                b = v.charAt(3);
                v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
            }
            if (v.length === 9) {
                // hex with alpha, like #fd5e53ff
                a = parseInt(v.substr(1, 6), 16);
                return [
                    a >> 16,
                    a >> 8 & _255,
                    a & _255,
                    parseInt(v.substr(7), 16) / 255
                ];
            }
            v = parseInt(v.substr(1), 16);
            a = [
                v >> 16,
                v >> 8 & _255,
                v & _255
            ];
        } else if (v.substr(0, 3) === "hsl") {
            a = wasHSL = v.match(_strictNumExp);
            if (!toHSL) {
                h = +a[0] % 360 / 360;
                s = +a[1] / 100;
                l = +a[2] / 100;
                g = l <= .5 ? l * (s + 1) : l + s - l * s;
                r = l * 2 - g;
                a.length > 3 && (a[3] *= 1); //cast as number
                a[0] = _hue(h + 1 / 3, r, g);
                a[1] = _hue(h, r, g);
                a[2] = _hue(h - 1 / 3, r, g);
            } else if (~v.indexOf("=")) {
                //if relative values are found, just return the raw strings with the relative prefixes in place.
                a = v.match(_numExp);
                forceAlpha && a.length < 4 && (a[3] = 1);
                return a;
            }
        } else a = v.match(_strictNumExp) || _colorLookup.transparent;
        a = a.map(Number);
    }
    if (toHSL && !wasHSL) {
        r = a[0] / _255;
        g = a[1] / _255;
        b = a[2] / _255;
        max = Math.max(r, g, b);
        min = Math.min(r, g, b);
        l = (max + min) / 2;
        if (max === min) h = s = 0;
        else {
            d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
            h *= 60;
        }
        a[0] = ~~(h + .5);
        a[1] = ~~(s * 100 + .5);
        a[2] = ~~(l * 100 + .5);
    }
    forceAlpha && a.length < 4 && (a[3] = 1);
    return a;
}, _colorOrderData = function _colorOrderData(v) {
    // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
    var values = [], c = [], i = -1;
    v.split(_colorExp).forEach(function(v) {
        var a = v.match(_numWithUnitExp) || [];
        values.push.apply(values, a);
        c.push(i += a.length + 1);
    });
    values.c = c;
    return values;
}, _formatColors = function _formatColors(s, toHSL, orderMatchData) {
    var result = "", colors = (s + result).match(_colorExp), type = toHSL ? "hsla(" : "rgba(", i = 0, c, shell, d, l;
    if (!colors) return s;
    colors = colors.map(function(color) {
        return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
    });
    if (orderMatchData) {
        d = _colorOrderData(s);
        c = orderMatchData.c;
        if (c.join(result) !== d.c.join(result)) {
            shell = s.replace(_colorExp, "1").split(_numWithUnitExp);
            l = shell.length - 1;
            for(; i < l; i++)result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
        }
    }
    if (!shell) {
        shell = s.split(_colorExp);
        l = shell.length - 1;
        for(; i < l; i++)result += shell[i] + colors[i];
    }
    return result + shell[l];
}, _colorExp = function() {
    var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
    p;
    for(p in _colorLookup)s += "|" + p + "\\b";
    return new RegExp(s + ")", "gi");
}(), _hslExp = /hsl[a]?\(/, _colorStringFilter = function _colorStringFilter(a) {
    var combined = a.join(" "), toHSL;
    _colorExp.lastIndex = 0;
    if (_colorExp.test(combined)) {
        toHSL = _hslExp.test(combined);
        a[1] = _formatColors(a[1], toHSL);
        a[0] = _formatColors(a[0], toHSL, _colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.
        return true;
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */ _tickerActive, _ticker = function() {
    var _getTime = Date.now, _lagThreshold = 500, _adjustedLag = 33, _startTime = _getTime(), _lastUpdate = _startTime, _gap = 1000 / 240, _nextTime = _gap, _listeners = [], _id, _req, _raf, _self, _delta, _i, _tick = function _tick(v) {
        var elapsed = _getTime() - _lastUpdate, manual = v === true, overlap, dispatch, time, frame;
        (elapsed > _lagThreshold || elapsed < 0) && (_startTime += elapsed - _adjustedLag);
        _lastUpdate += elapsed;
        time = _lastUpdate - _startTime;
        overlap = time - _nextTime;
        if (overlap > 0 || manual) {
            frame = ++_self.frame;
            _delta = time - _self.time * 1000;
            _self.time = time = time / 1000;
            _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
            dispatch = 1;
        }
        manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
        if (dispatch) for(_i = 0; _i < _listeners.length; _i++)// use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
    };
    _self = {
        time: 0,
        frame: 0,
        tick: function tick() {
            _tick(true);
        },
        deltaRatio: function deltaRatio(fps) {
            return _delta / (1000 / (fps || 60));
        },
        wake: function wake() {
            if (_coreReady) {
                if (!_coreInitted && _windowExists()) {
                    _win = _coreInitted = window;
                    _doc = _win.document || {};
                    _globals.gsap = gsap;
                    (_win.gsapVersions || (_win.gsapVersions = [])).push(gsap.version);
                    _install(_installScope || _win.GreenSockGlobals || !_win.gsap && _win || {});
                    _registerPluginQueue.forEach(_createPlugin);
                }
                _raf = typeof requestAnimationFrame !== "undefined" && requestAnimationFrame;
                _id && _self.sleep();
                _req = _raf || function(f) {
                    return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
                };
                _tickerActive = 1;
                _tick(2);
            }
        },
        sleep: function sleep() {
            (_raf ? cancelAnimationFrame : clearTimeout)(_id);
            _tickerActive = 0;
            _req = _emptyFunc;
        },
        lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
            _lagThreshold = threshold || Infinity; // zero should be interpreted as basically unlimited
            _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
        },
        fps: function fps(_fps) {
            _gap = 1000 / (_fps || 240);
            _nextTime = _self.time * 1000 + _gap;
        },
        add: function add(callback, once, prioritize) {
            var func = once ? function(t, d, f, v) {
                callback(t, d, f, v);
                _self.remove(func);
            } : callback;
            _self.remove(callback);
            _listeners[prioritize ? "unshift" : "push"](func);
            _wake();
            return func;
        },
        remove: function remove(callback, i) {
            ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
        },
        _listeners: _listeners
    };
    return _self;
}(), _wake = function _wake() {
    return !_tickerActive && _ticker.wake();
}, //also ensures the core classes are initialized.
/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/ _easeMap = {}, _customEaseExp = /^[\d.\-M][\d.\-,\s]/, _quotesExp = /["']/g, _parseObjectInString = function _parseObjectInString(value) {
    //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
    var obj = {}, split = value.substr(1, value.length - 3).split(":"), key = split[0], i = 1, l = split.length, index, val, parsedVal;
    for(; i < l; i++){
        val = split[i];
        index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
        parsedVal = val.substr(0, index);
        obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
        key = val.substr(index + 1).trim();
    }
    return obj;
}, _valueInParentheses = function _valueInParentheses(value) {
    var open = value.indexOf("(") + 1, close = value.indexOf(")"), nested = value.indexOf("(", open);
    return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
}, _configEaseFromString = function _configEaseFromString(name) {
    //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
    var split = (name + "").split("("), ease = _easeMap[split[0]];
    return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [
        _parseObjectInString(split[1])
    ] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
}, _invertEase = function _invertEase(ease) {
    return function(p) {
        return 1 - ease(1 - p);
    };
}, // allow yoyoEase to be set in children and have those affected when the parent/ancestor timeline yoyos.
_propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
    var child = timeline._first, ease;
    while(child){
        if (child instanceof Timeline) _propagateYoyoEase(child, isYoyo);
        else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
            if (child.timeline) _propagateYoyoEase(child.timeline, isYoyo);
            else {
                ease = child._ease;
                child._ease = child._yEase;
                child._yEase = ease;
                child._yoyo = isYoyo;
            }
        }
        child = child._next;
    }
}, _parseEase = function _parseEase(ease, defaultEase) {
    return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
}, _insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
    if (easeOut === void 0) easeOut = function easeOut(p) {
        return 1 - easeIn(1 - p);
    };
    if (easeInOut === void 0) easeInOut = function easeInOut(p) {
        return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
    var ease = {
        easeIn: easeIn,
        easeOut: easeOut,
        easeInOut: easeInOut
    }, lowercaseName;
    _forEachName(names, function(name) {
        _easeMap[name] = _globals[name] = ease;
        _easeMap[lowercaseName = name.toLowerCase()] = easeOut;
        for(var p in ease)_easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
    });
    return ease;
}, _easeInOutFromOut = function _easeInOutFromOut(easeOut) {
    return function(p) {
        return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
    };
}, _configElastic = function _configElastic(type, amplitude, period) {
    var p1 = amplitude >= 1 ? amplitude : 1, //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
    p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1), p3 = p2 / _2PI * (Math.asin(1 / p1) || 0), easeOut = function easeOut(p) {
        return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    p2 = _2PI / p2; //precalculate to optimize
    ease.config = function(amplitude, period) {
        return _configElastic(type, amplitude, period);
    };
    return ease;
}, _configBack = function _configBack(type, overshoot) {
    if (overshoot === void 0) overshoot = 1.70158;
    var easeOut = function easeOut(p) {
        return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    ease.config = function(overshoot) {
        return _configBack(type, overshoot);
    };
    return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };
_forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function(name, i) {
    var power = i < 5 ? i + 1 : i;
    _insertEase(name + ",Power" + (power - 1), i ? function(p) {
        return Math.pow(p, power);
    } : function(p) {
        return p;
    }, function(p) {
        return 1 - Math.pow(1 - p, power);
    }, function(p) {
        return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
    });
});
_easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;
_insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());
(function(n, c) {
    var n1 = 1 / c, n2 = 2 * n1, n3 = 2.5 * n1, easeOut = function easeOut(p) {
        return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
    };
    _insertEase("Bounce", function(p) {
        return 1 - easeOut(1 - p);
    }, easeOut);
})(7.5625, 2.75);
_insertEase("Expo", function(p) {
    return p ? Math.pow(2, 10 * (p - 1)) : 0;
});
_insertEase("Circ", function(p) {
    return -(_sqrt(1 - p * p) - 1);
});
_insertEase("Sine", function(p) {
    return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
});
_insertEase("Back", _configBack("in"), _configBack("out"), _configBack());
_easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
    config: function config(steps, immediateStart) {
        if (steps === void 0) steps = 1;
        var p1 = 1 / steps, p2 = steps + (immediateStart ? 0 : 1), p3 = immediateStart ? 1 : 0, max = 1 - _tinyNum;
        return function(p) {
            return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
        };
    }
};
_defaults.ease = _easeMap["quad.out"];
_forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(name) {
    return _callbackNames += name + "," + name + "Params,";
});
var GSCache = function GSCache(target, harness) {
    this.id = _gsID++;
    target._gsap = this;
    this.target = target;
    this.harness = harness;
    this.get = harness ? harness.get : _getProperty;
    this.set = harness ? harness.getSetter : _getSetter;
};
var Animation = /*#__PURE__*/ function() {
    function Animation(vars) {
        this.vars = vars;
        this._delay = +vars.delay || 0;
        if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
            // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
            this._rDelay = vars.repeatDelay || 0;
            this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
        }
        this._ts = 1;
        _setDuration(this, +vars.duration, 1, 1);
        this.data = vars.data;
        if (_context) {
            this._ctx = _context;
            _context.data.push(this);
        }
        _tickerActive || _ticker.wake();
    }
    var _proto = Animation.prototype;
    _proto.delay = function delay(value) {
        if (value || value === 0) {
            this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
            this._delay = value;
            return this;
        }
        return this._delay;
    };
    _proto.duration = function duration(value) {
        return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
    };
    _proto.totalDuration = function totalDuration(value) {
        if (!arguments.length) return this._tDur;
        this._dirty = 0;
        return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
    };
    _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
        _wake();
        if (!arguments.length) return this._tTime;
        var parent = this._dp;
        if (parent && parent.smoothChildTiming && this._ts) {
            _alignPlayhead(this, _totalTime);
            !parent._dp || parent.parent || _postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
            //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.
            while(parent && parent.parent){
                if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) parent.totalTime(parent._tTime, true);
                parent = parent.parent;
            }
            if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
            _addToTimeline(this._dp, this, this._start - this._delay);
        }
        if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
            // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
            this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
            //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
            //   this._lock = 1;
            _lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
        //}
        }
        return this;
    };
    _proto.time = function time(value, suppressEvents) {
        return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
    };
    _proto.totalProgress = function totalProgress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() > 0 ? 1 : 0;
    };
    _proto.progress = function progress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
    };
    _proto.iteration = function iteration(value, suppressEvents) {
        var cycleDuration = this.duration() + this._rDelay;
        return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
    } // potential future addition:
    ;
    _proto.timeScale = function timeScale(value, suppressEvents) {
        if (!arguments.length) return this._rts === -_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
        if (this._rts === value) return this;
        var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
        // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
        //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
        // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.
        this._rts = +value || 0;
        this._ts = this._ps || value === -_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.
        this.totalTime(_clamp(-Math.abs(this._delay), this._tDur, tTime), suppressEvents !== false);
        _setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.
        return _recacheAncestors(this);
    };
    _proto.paused = function paused(value) {
        if (!arguments.length) return this._ps;
        if (this._ps !== value) {
            this._ps = value;
            if (value) {
                this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.
                this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
            } else {
                _wake();
                this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.
                this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
            }
        }
        return this;
    };
    _proto.startTime = function startTime(value) {
        if (arguments.length) {
            this._start = value;
            var parent = this.parent || this._dp;
            parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, value - this._delay);
            return this;
        }
        return this._start;
    };
    _proto.endTime = function endTime(includeRepeats) {
        return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
    };
    _proto.rawTime = function rawTime(wrapRepeats) {
        var parent = this.parent || this._dp; // _dp = detached parent
        return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
    };
    _proto.revert = function revert(config) {
        if (config === void 0) config = _revertConfig;
        var prevIsReverting = _reverting;
        _reverting = config;
        if (this._initted || this._startAt) {
            this.timeline && this.timeline.revert(config);
            this.totalTime(-0.01, config.suppressEvents);
        }
        this.data !== "nested" && config.kill !== false && this.kill();
        _reverting = prevIsReverting;
        return this;
    };
    _proto.globalTime = function globalTime(rawTime) {
        var animation = this, time = arguments.length ? rawTime : animation.rawTime();
        while(animation){
            time = animation._start + time / (Math.abs(animation._ts) || 1);
            animation = animation._dp;
        }
        return !this.parent && this._sat ? this._sat.globalTime(rawTime) : time; // the _startAt tweens for .fromTo() and .from() that have immediateRender should always be FIRST in the timeline (important for context.revert()). "_sat" stands for _startAtTween, referring to the parent tween that created the _startAt. We must discern if that tween had immediateRender so that we can know whether or not to prioritize it in revert().
    };
    _proto.repeat = function repeat(value) {
        if (arguments.length) {
            this._repeat = value === Infinity ? -2 : value;
            return _onUpdateTotalDuration(this);
        }
        return this._repeat === -2 ? Infinity : this._repeat;
    };
    _proto.repeatDelay = function repeatDelay(value) {
        if (arguments.length) {
            var time = this._time;
            this._rDelay = value;
            _onUpdateTotalDuration(this);
            return time ? this.time(time) : this;
        }
        return this._rDelay;
    };
    _proto.yoyo = function yoyo(value) {
        if (arguments.length) {
            this._yoyo = value;
            return this;
        }
        return this._yoyo;
    };
    _proto.seek = function seek(position, suppressEvents) {
        return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
    };
    _proto.restart = function restart(includeDelay, suppressEvents) {
        return this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
    };
    _proto.play = function play(from, suppressEvents) {
        from != null && this.seek(from, suppressEvents);
        return this.reversed(false).paused(false);
    };
    _proto.reverse = function reverse(from, suppressEvents) {
        from != null && this.seek(from || this.totalDuration(), suppressEvents);
        return this.reversed(true).paused(false);
    };
    _proto.pause = function pause(atTime, suppressEvents) {
        atTime != null && this.seek(atTime, suppressEvents);
        return this.paused(true);
    };
    _proto.resume = function resume() {
        return this.paused(false);
    };
    _proto.reversed = function reversed(value) {
        if (arguments.length) {
            !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.
            return this;
        }
        return this._rts < 0;
    };
    _proto.invalidate = function invalidate() {
        this._initted = this._act = 0;
        this._zTime = -_tinyNum;
        return this;
    };
    _proto.isActive = function isActive() {
        var parent = this.parent || this._dp, start = this._start, rawTime;
        return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
    };
    _proto.eventCallback = function eventCallback(type, callback, params) {
        var vars = this.vars;
        if (arguments.length > 1) {
            if (!callback) delete vars[type];
            else {
                vars[type] = callback;
                params && (vars[type + "Params"] = params);
                type === "onUpdate" && (this._onUpdate = callback);
            }
            return this;
        }
        return vars[type];
    };
    _proto.then = function then(onFulfilled) {
        var self = this;
        return new Promise(function(resolve) {
            var f = _isFunction(onFulfilled) ? onFulfilled : _passThrough, _resolve = function _resolve() {
                var _then = self.then;
                self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)
                _isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
                resolve(f);
                self.then = _then;
            };
            if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) _resolve();
            else self._prom = _resolve;
        });
    };
    _proto.kill = function kill() {
        _interrupt(this);
    };
    return Animation;
}();
_setDefaults(Animation.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: false,
    parent: null,
    _initted: false,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -_tinyNum,
    _prom: 0,
    _ps: false,
    _rts: 1
});
var Timeline = /*#__PURE__*/ function(_Animation) {
    _inheritsLoose(Timeline, _Animation);
    function Timeline(vars, position) {
        var _this;
        if (vars === void 0) vars = {};
        _this = _Animation.call(this, vars) || this;
        _this.labels = {};
        _this.smoothChildTiming = !!vars.smoothChildTiming;
        _this.autoRemoveChildren = !!vars.autoRemoveChildren;
        _this._sort = _isNotFalse(vars.sortChildren);
        _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
        vars.reversed && _this.reverse();
        vars.paused && _this.paused(true);
        vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
        return _this;
    }
    var _proto2 = Timeline.prototype;
    _proto2.to = function to(targets, vars, position) {
        _createTweenType(0, arguments, this);
        return this;
    };
    _proto2.from = function from(targets, vars, position) {
        _createTweenType(1, arguments, this);
        return this;
    };
    _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
        _createTweenType(2, arguments, this);
        return this;
    };
    _proto2.set = function set(targets, vars, position) {
        vars.duration = 0;
        vars.parent = this;
        _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
        vars.immediateRender = !!vars.immediateRender;
        new Tween(targets, vars, _parsePosition(this, position), 1);
        return this;
    };
    _proto2.call = function call(callback, params, position) {
        return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
    } //ONLY for backward compatibility! Maybe delete?
    ;
    _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.duration = duration;
        vars.stagger = vars.stagger || stagger;
        vars.onComplete = onCompleteAll;
        vars.onCompleteParams = onCompleteAllParams;
        vars.parent = this;
        new Tween(targets, vars, _parsePosition(this, position));
        return this;
    };
    _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.runBackwards = 1;
        _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
        return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
        toVars.startAt = fromVars;
        _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
        return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._dirty ? this.totalDuration() : this._tDur, dur = this._dur, tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime), // if a paused timeline is resumed (or its _start is updated for another reason...which rounds it), that could result in the playhead shifting a **tiny** amount and a zero-duration child at that spot may get rendered at a different ratio, like its totalTime in render() may be 1e-17 instead of 0, for example.
        crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur), time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo, isYoyo;
        this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);
        if (tTime !== this._tTime || force || crossingStart) {
            if (prevTime !== this._time && dur) {
                //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
                tTime += this._time - prevTime;
                totalTime += this._time - prevTime;
            }
            time = tTime;
            prevStart = this._start;
            timeScale = this._ts;
            prevPaused = !timeScale;
            if (crossingStart) {
                dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
                (totalTime || !suppressEvents) && (this._zTime = totalTime);
            }
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                yoyo = this._yoyo;
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && totalTime < 0) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === tTime / cycleDuration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://gsap.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005 also, this._tTime - prevIteration * cycleDuration - this._dur <= 0 just checks to make sure it wasn't previously in the "repeatDelay" portion
                if (yoyo && iteration & 1) {
                    time = dur - time;
                    isYoyo = 1;
                }
                /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */ if (iteration !== prevIteration && !this._lock) {
                    var rewinding = yoyo && prevIteration & 1, doesWrap = rewinding === (yoyo && iteration & 1);
                    iteration < prevIteration && (rewinding = !rewinding);
                    prevTime = rewinding ? 0 : tTime % dur ? dur : tTime; // if the playhead is landing exactly at the end of an iteration, use that totalTime rather than only the duration, otherwise it'll skip the 2nd render since it's effectively at the same time.
                    this._lock = 1;
                    this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
                    this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.
                    !suppressEvents && this.parent && _callback(this, "onRepeat");
                    this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);
                    if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
                    return this;
                    dur = this._dur; // in case the duration changed in the onRepeat
                    tDur = this._tDur;
                    if (doesWrap) {
                        this._lock = 2;
                        prevTime = rewinding ? dur : -0.0001;
                        this.render(prevTime, true);
                        this.vars.repeatRefresh && !isYoyo && this.invalidate();
                    }
                    this._lock = 0;
                    if (!this._ts && !prevPaused) return this;
                     //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.
                    _propagateYoyoEase(this, isYoyo);
                }
            }
            if (this._hasPause && !this._forcing && this._lock < 2) {
                pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));
                if (pauseTween) tTime -= time - (time = pauseTween._start);
            }
            this._tTime = tTime;
            this._time = time;
            this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
            if (!this._initted) {
                this._onUpdate = this.vars.onUpdate;
                this._initted = 1;
                this._zTime = totalTime;
                prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
            }
            if (!prevTime && time && !suppressEvents && !iteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            if (time >= prevTime && totalTime >= 0) {
                child = this._first;
                while(child){
                    next = child._next;
                    if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = -_tinyNum); // it didn't finish rendering, so flag zTime as negative so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            } else {
                child = this._last;
                var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.
                while(child){
                    next = child._prev;
                    if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || _reverting && (child._initted || child._startAt)); // if reverting, we should always force renders of initted tweens (but remember that .fromTo() or .from() may have a _startAt but not _initted yet). If, for example, a .fromTo() tween with a stagger (which creates an internal timeline) gets reverted BEFORE some of its child tweens render for the first time, it may not properly trigger them to revert.
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            }
            if (pauseTween && !suppressEvents) {
                this.pause();
                pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;
                if (this._ts) {
                    //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
                    this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.
                    _setEnd(this);
                    return this.render(totalTime, suppressEvents, force);
                }
            }
            this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
            if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) {
                if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) {
                    if (!this._lock) {
                        // remember, a child's callback may alter this timeline's playhead or timeScale which is why we need to add some of these checks.
                        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
                            _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);
                            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                        }
                    }
                }
            }
        }
        return this;
    };
    _proto2.add = function add(child, position) {
        var _this2 = this;
        _isNumber(position) || (position = _parsePosition(this, position, child));
        if (!(child instanceof Animation)) {
            if (_isArray(child)) {
                child.forEach(function(obj) {
                    return _this2.add(obj, position);
                });
                return this;
            }
            if (_isString(child)) return this.addLabel(child, position);
            if (_isFunction(child)) child = Tween.delayedCall(0, child);
            else return this;
        }
        return this !== child ? _addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
    };
    _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
        if (nested === void 0) nested = true;
        if (tweens === void 0) tweens = true;
        if (timelines === void 0) timelines = true;
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = -_bigNum;
        var a = [], child = this._first;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                if (child instanceof Tween) tweens && a.push(child);
                else {
                    timelines && a.push(child);
                    nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
                }
            }
            child = child._next;
        }
        return a;
    };
    _proto2.getById = function getById(id) {
        var animations = this.getChildren(1, 1, 1), i = animations.length;
        while(i--){
            if (animations[i].vars.id === id) return animations[i];
        }
    };
    _proto2.remove = function remove(child) {
        if (_isString(child)) return this.removeLabel(child);
        if (_isFunction(child)) return this.killTweensOf(child);
        _removeLinkedListItem(this, child);
        if (child === this._recent) this._recent = this._last;
        return _uncache(this);
    };
    _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
        if (!arguments.length) return this._tTime;
        this._forcing = 1;
        if (!this._dp && this._ts) //special case for the global timeline (or any other that has no parent or detached parent).
        this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
        _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
        this._forcing = 0;
        return this;
    };
    _proto2.addLabel = function addLabel(label, position) {
        this.labels[label] = _parsePosition(this, position);
        return this;
    };
    _proto2.removeLabel = function removeLabel(label) {
        delete this.labels[label];
        return this;
    };
    _proto2.addPause = function addPause(position, callback, params) {
        var t = Tween.delayedCall(0, callback || _emptyFunc, params);
        t.data = "isPause";
        this._hasPause = 1;
        return _addToTimeline(this, t, _parsePosition(this, position));
    };
    _proto2.removePause = function removePause(position) {
        var child = this._first;
        position = _parsePosition(this, position);
        while(child){
            if (child._start === position && child.data === "isPause") _removeFromParent(child);
            child = child._next;
        }
    };
    _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        var tweens = this.getTweensOf(targets, onlyActive), i = tweens.length;
        while(i--)_overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
        return this;
    };
    _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
        var a = [], parsedTargets = toArray(targets), child = this._first, isGlobalTime = _isNumber(onlyActive), // a number is interpreted as a global time. If the animation spans
        children;
        while(child){
            if (child instanceof Tween) {
                if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
                a.push(child);
            } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) a.push.apply(a, children);
            child = child._next;
        }
        return a;
    } // potential future feature - targets() on timelines
    ;
    _proto2.tweenTo = function tweenTo(position, vars) {
        vars = vars || {};
        var tl = this, endTime = _parsePosition(tl, position), _vars = vars, startAt = _vars.startAt, _onStart = _vars.onStart, onStartParams = _vars.onStartParams, immediateRender = _vars.immediateRender, initted, tween = Tween.to(tl, _setDefaults({
            ease: vars.ease || "none",
            lazy: false,
            immediateRender: false,
            time: endTime,
            overwrite: "auto",
            duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
            onStart: function onStart() {
                tl.pause();
                if (!initted) {
                    var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
                    tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
                    initted = 1;
                }
                _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
            }
        }, vars));
        return immediateRender ? tween.render(0) : tween;
    };
    _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
        return this.tweenTo(toPosition, _setDefaults({
            startAt: {
                time: _parsePosition(this, fromPosition)
            }
        }, vars));
    };
    _proto2.recent = function recent() {
        return this._recent;
    };
    _proto2.nextLabel = function nextLabel(afterTime) {
        if (afterTime === void 0) afterTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, afterTime));
    };
    _proto2.previousLabel = function previousLabel(beforeTime) {
        if (beforeTime === void 0) beforeTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
    };
    _proto2.currentLabel = function currentLabel(value) {
        return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
    };
    _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = 0;
        var child = this._first, labels = this.labels, p;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                child._start += amount;
                child._end += amount;
            }
            child = child._next;
        }
        if (adjustLabels) {
            for(p in labels)if (labels[p] >= ignoreBeforeTime) labels[p] += amount;
        }
        return _uncache(this);
    };
    _proto2.invalidate = function invalidate(soft) {
        var child = this._first;
        this._lock = 0;
        while(child){
            child.invalidate(soft);
            child = child._next;
        }
        return _Animation.prototype.invalidate.call(this, soft);
    };
    _proto2.clear = function clear(includeLabels) {
        if (includeLabels === void 0) includeLabels = true;
        var child = this._first, next;
        while(child){
            next = child._next;
            this.remove(child);
            child = next;
        }
        this._dp && (this._time = this._tTime = this._pTime = 0);
        includeLabels && (this.labels = {});
        return _uncache(this);
    };
    _proto2.totalDuration = function totalDuration(value) {
        var max = 0, self = this, child = self._last, prevStart = _bigNum, prev, start, parent;
        if (arguments.length) return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
        if (self._dirty) {
            parent = self.parent;
            while(child){
                prev = child._prev; //record it here in case the tween changes position in the sequence...
                child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.
                start = child._start;
                if (start > prevStart && self._sort && child._ts && !self._lock) {
                    //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
                    self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().
                    _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
                } else prevStart = start;
                if (start < 0 && child._ts) {
                    //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
                    max -= start;
                    if (!parent && !self._dp || parent && parent.smoothChildTiming) {
                        self._start += start / self._ts;
                        self._time -= start;
                        self._tTime -= start;
                    }
                    self.shiftChildren(-start, false, -Infinity);
                    prevStart = 0;
                }
                child._end > max && child._ts && (max = child._end);
                child = prev;
            }
            _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);
            self._dirty = 0;
        }
        return self._tDur;
    };
    Timeline.updateRoot = function updateRoot(time) {
        if (_globalTimeline._ts) {
            _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));
            _lastRenderedFrame = _ticker.frame;
        }
        if (_ticker.frame >= _nextGCFrame) {
            _nextGCFrame += _config.autoSleep || 120;
            var child = _globalTimeline._first;
            if (!child || !child._ts) {
                if (_config.autoSleep && _ticker._listeners.length < 2) {
                    while(child && !child._ts)child = child._next;
                    child || _ticker.sleep();
                }
            }
        }
    };
    return Timeline;
}(Animation);
_setDefaults(Timeline.prototype, {
    _lock: 0,
    _hasPause: 0,
    _forcing: 0
});
var _addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
    //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter), index = 0, matchIndex = 0, result, startNums, color, endNum, chunk, startNum, hasRandom, a;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (hasRandom = ~end.indexOf("random(")) end = _replaceRandom(end);
    if (stringFilter) {
        a = [
            start,
            end
        ];
        stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
        start = a[0];
        end = a[1];
    }
    startNums = start.match(_complexStringNumExp) || [];
    while(result = _complexStringNumExp.exec(end)){
        endNum = result[0];
        chunk = end.substring(index, result.index);
        if (color) color = (color + 1) % 5;
        else if (chunk.substr(-5) === "rgba(") color = 1;
        if (endNum !== startNums[matchIndex++]) {
            startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
            pt._pt = {
                _next: pt._pt,
                p: chunk || matchIndex === 1 ? chunk : ",",
                //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                s: startNum,
                c: endNum.charAt(1) === "=" ? _parseRelative(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
                m: color && color < 4 ? Math.round : 0
            };
            index = _complexStringNumExp.lastIndex;
        }
    }
    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    pt.fp = funcParam;
    if (_relExp.test(end) || hasRandom) pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    return pt;
}, _addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
    _isFunction(end) && (end = end(index || 0, target, targets));
    var currentValue = target[prop], parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](), setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc, pt;
    if (_isString(end)) {
        if (~end.indexOf("random(")) end = _replaceRandom(end);
        if (end.charAt(1) === "=") {
            pt = _parseRelative(parsedStart, end) + (getUnit(parsedStart) || 0);
            if (pt || pt === 0) // to avoid isNaN, like if someone passes in a value like "!= whatever"
            end = pt;
        }
    }
    if (!optional || parsedStart !== end || _forceAllPropTweens) {
        if (!isNaN(parsedStart * end) && end !== "") {
            // fun fact: any number multiplied by "" is evaluated as the number 0!
            pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
            funcParam && (pt.fp = funcParam);
            modifier && pt.modifier(modifier, this, target);
            return this._pt = pt;
        }
        !currentValue && !(prop in target) && _missingPlugin(prop, end);
        return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
    }
}, //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
_processVars = function _processVars(vars, index, target, targets, tween) {
    _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));
    if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
    var copy = {}, p;
    for(p in vars)copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
    return copy;
}, _checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
    var plugin, pt, ptLookup, i;
    if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
        tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
        if (tween !== _quickTween) {
            ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.
            i = plugin._props.length;
            while(i--)ptLookup[plugin._props[i]] = pt;
        }
    }
    return plugin;
}, _overwritingTween, //store a reference temporarily so we can avoid overwriting itself.
_forceAllPropTweens, _initTween = function _initTween(tween, time, tTime) {
    var vars = tween.vars, ease = vars.ease, startAt = vars.startAt, immediateRender = vars.immediateRender, lazy = vars.lazy, onUpdate = vars.onUpdate, runBackwards = vars.runBackwards, yoyoEase = vars.yoyoEase, keyframes = vars.keyframes, autoRevert = vars.autoRevert, dur = tween._dur, prevStartAt = tween._startAt, targets = tween._targets, parent = tween.parent, fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets, autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites, tl = tween.timeline, cleanVars, i, p, pt, target, hasPriority, gsData, harness, plugin, ptLookup, index, harnessVars, overwritten;
    tl && (!keyframes || !ease) && (ease = "none");
    tween._ease = _parseEase(ease, _defaults.ease);
    tween._yEase = yoyoEase ? _invertEase(_parseEase(yoyoEase === true ? ease : yoyoEase, _defaults.ease)) : 0;
    if (yoyoEase && tween._yoyo && !tween._repeat) {
        //there must have been a parent timeline with yoyo:true that is currently in its yoyo phase, so flip the eases.
        yoyoEase = tween._yEase;
        tween._yEase = tween._ease;
        tween._ease = yoyoEase;
    }
    tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.
    if (!tl || keyframes && !vars.stagger) {
        //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
        harness = targets[0] ? _getCache(targets[0]).harness : 0;
        harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.
        cleanVars = _copyExcluding(vars, _reservedProps);
        if (prevStartAt) {
            prevStartAt._zTime < 0 && prevStartAt.progress(1); // in case it's a lazy startAt that hasn't rendered yet.
            time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? _revertConfigNoKill : _startAtRevertConfig); // if it's a "startAt" (not "from()" or runBackwards: true), we only need to do a shallow revert (keep transforms cached in CSSPlugin)
            // don't just _removeFromParent(prevStartAt.render(-1, true)) because that'll leave inline styles. We're creating a new _startAt for "startAt" tweens that re-capture things to ensure that if the pre-tween values changed since the tween was created, they're recorded.
            prevStartAt._lazy = 0;
        }
        if (startAt) {
            _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
                data: "isStart",
                overwrite: false,
                parent: parent,
                immediateRender: true,
                lazy: !prevStartAt && _isNotFalse(lazy),
                startAt: null,
                delay: 0,
                onUpdate: onUpdate && function() {
                    return _callback(tween, "onUpdate");
                },
                stagger: 0
            }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);
            tween._startAt._dp = 0; // don't allow it to get put back into root timeline! Like when revert() is called and totalTime() gets set.
            tween._startAt._sat = tween; // used in globalTime(). _sat stands for _startAtTween
            time < 0 && (_reverting || !immediateRender && !autoRevert) && tween._startAt.revert(_revertConfigNoKill); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.
            if (immediateRender) {
                if (dur && time <= 0 && tTime <= 0) {
                    // check tTime here because in the case of a yoyo tween whose playhead gets pushed to the end like tween.progress(1), we should allow it through so that the onComplete gets fired properly.
                    time && (tween._zTime = time);
                    return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
                }
            }
        } else if (runBackwards && dur) //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
        {
            if (!prevStartAt) {
                time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
                p = _setDefaults({
                    overwrite: false,
                    data: "isFromStart",
                    //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
                    lazy: immediateRender && !prevStartAt && _isNotFalse(lazy),
                    immediateRender: immediateRender,
                    //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
                    stagger: 0,
                    parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
                }, cleanVars);
                harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})
                _removeFromParent(tween._startAt = Tween.set(targets, p));
                tween._startAt._dp = 0; // don't allow it to get put back into root timeline!
                tween._startAt._sat = tween; // used in globalTime()
                time < 0 && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween._startAt.render(-1, true));
                tween._zTime = time;
                if (!immediateRender) _initTween(tween._startAt, _tinyNum, _tinyNum); //ensures that the initial values are recorded
                else if (!time) return;
            }
        }
        tween._pt = tween._ptCache = 0;
        lazy = dur && _isNotFalse(lazy) || lazy && !dur;
        for(i = 0; i < targets.length; i++){
            target = targets[i];
            gsData = target._gsap || _harness(targets)[i]._gsap;
            tween._ptLookup[i] = ptLookup = {};
            _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
            index = fullTargets === targets ? i : fullTargets.indexOf(target);
            if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
                tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
                plugin._props.forEach(function(name) {
                    ptLookup[name] = pt;
                });
                plugin.priority && (hasPriority = 1);
            }
            if (!harness || harnessVars) {
                for(p in cleanVars)if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) plugin.priority && (hasPriority = 1);
                else ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
            }
            tween._op && tween._op[i] && tween.kill(target, tween._op[i]);
            if (autoOverwrite && tween._pt) {
                _overwritingTween = tween;
                _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!
                overwritten = !tween.parent;
                _overwritingTween = 0;
            }
            tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
        }
        hasPriority && _sortPropTweensByPriority(tween);
        tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
    }
    tween._onUpdate = onUpdate;
    tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
    keyframes && time <= 0 && tl.render(_bigNum, true, true); // if there's a 0% keyframe, it'll render in the "before" state for any staggered/delayed animations thus when the following tween initializes, it'll use the "before" state instead of the "after" state as the initial values.
}, _updatePropTweens = function _updatePropTweens(tween, property, value, start, startIsRelative, ratio, time, skipRecursion) {
    var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property], pt, rootPT, lookup, i;
    if (!ptCache) {
        ptCache = tween._ptCache[property] = [];
        lookup = tween._ptLookup;
        i = tween._targets.length;
        while(i--){
            pt = lookup[i][property];
            if (pt && pt.d && pt.d._pt) {
                // it's a plugin, so find the nested PropTween
                pt = pt.d._pt;
                while(pt && pt.p !== property && pt.fp !== property)// "fp" is functionParam for things like setting CSS variables which require .setProperty("--var-name", value)
                pt = pt._next;
            }
            if (!pt) {
                // there is no PropTween associated with that property, so we must FORCE one to be created and ditch out of this
                // if the tween has other properties that already rendered at new positions, we'd normally have to rewind to put them back like tween.render(0, true) before forcing an _initTween(), but that can create another edge case like tweening a timeline's progress would trigger onUpdates to fire which could move other things around. It's better to just inform users that .resetTo() should ONLY be used for tweens that already have that property. For example, you can't gsap.to(...{ y: 0 }) and then tween.restTo("x", 200) for example.
                _forceAllPropTweens = 1; // otherwise, when we _addPropTween() and it finds no change between the start and end values, it skips creating a PropTween (for efficiency...why tween when there's no difference?) but in this case we NEED that PropTween created so we can edit it.
                tween.vars[property] = "+=0";
                _initTween(tween, time);
                _forceAllPropTweens = 0;
                return skipRecursion ? _warn(property + " not eligible for reset") : 1; // if someone tries to do a quickTo() on a special property like borderRadius which must get split into 4 different properties, that's not eligible for .resetTo().
            }
            ptCache.push(pt);
        }
    }
    i = ptCache.length;
    while(i--){
        rootPT = ptCache[i];
        pt = rootPT._pt || rootPT; // complex values may have nested PropTweens. We only accommodate the FIRST value.
        pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
        pt.c = value - pt.s;
        rootPT.e && (rootPT.e = _round(value) + getUnit(rootPT.e)); // mainly for CSSPlugin (end value)
        rootPT.b && (rootPT.b = pt.s + getUnit(rootPT.b)); // (beginning value)
    }
}, _addAliasesToVars = function _addAliasesToVars(targets, vars) {
    var harness = targets[0] ? _getCache(targets[0]).harness : 0, propertyAliases = harness && harness.aliases, copy, p, i, aliases;
    if (!propertyAliases) return vars;
    copy = _merge({}, vars);
    for(p in propertyAliases)if (p in copy) {
        aliases = propertyAliases[p].split(",");
        i = aliases.length;
        while(i--)copy[aliases[i]] = copy[p];
    }
    return copy;
}, // parses multiple formats, like {"0%": {x: 100}, {"50%": {x: -20}} and { x: {"0%": 100, "50%": -20} }, and an "ease" can be set on any object. We populate an "allProps" object with an Array for each property, like {x: [{}, {}], y:[{}, {}]} with data for each property tween. The objects have a "t" (time), "v", (value), and "e" (ease) property. This allows us to piece together a timeline later.
_parseKeyframe = function _parseKeyframe(prop, obj, allProps, easeEach) {
    var ease = obj.ease || easeEach || "power1.inOut", p, a;
    if (_isArray(obj)) {
        a = allProps[prop] || (allProps[prop] = []); // t = time (out of 100), v = value, e = ease
        obj.forEach(function(value, i) {
            return a.push({
                t: i / (obj.length - 1) * 100,
                v: value,
                e: ease
            });
        });
    } else for(p in obj){
        a = allProps[p] || (allProps[p] = []);
        p === "ease" || a.push({
            t: parseFloat(prop),
            v: obj[p],
            e: ease
        });
    }
}, _parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
    return _isFunction(value) ? value.call(tween, i, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
}, _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", _staggerPropsToSkip = {};
_forEachName(_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function(name) {
    return _staggerPropsToSkip[name] = 1;
});
var Tween = /*#__PURE__*/ function(_Animation2) {
    _inheritsLoose(Tween, _Animation2);
    function Tween(targets, vars, position, skipInherit) {
        var _this3;
        if (typeof vars === "number") {
            position.duration = vars;
            vars = position;
            position = null;
        }
        _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
        var _this3$vars = _this3.vars, duration = _this3$vars.duration, delay = _this3$vars.delay, immediateRender = _this3$vars.immediateRender, stagger = _this3$vars.stagger, overwrite = _this3$vars.overwrite, keyframes = _this3$vars.keyframes, defaults = _this3$vars.defaults, scrollTrigger = _this3$vars.scrollTrigger, yoyoEase = _this3$vars.yoyoEase, parent = vars.parent || _globalTimeline, parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [
            targets
        ] : toArray(targets), tl, i, copy, l, p, curTarget, staggerFunc, staggerVarsToMerge;
        _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://gsap.com", !_config.nullTargetWarn) || [];
        _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property
        _this3._overwrite = overwrite;
        if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
            vars = _this3.vars;
            tl = _this3.timeline = new Timeline({
                data: "nested",
                defaults: defaults || {},
                targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
            }); // we need to store the targets because for staggers and keyframes, we end up creating an individual tween for each but function-based values need to know the index and the whole Array of targets.
            tl.kill();
            tl.parent = tl._dp = _assertThisInitialized(_this3);
            tl._start = 0;
            if (stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
                l = parsedTargets.length;
                staggerFunc = stagger && distribute(stagger);
                if (_isObject(stagger)) {
                    //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
                    for(p in stagger)if (~_staggerTweenProps.indexOf(p)) {
                        staggerVarsToMerge || (staggerVarsToMerge = {});
                        staggerVarsToMerge[p] = stagger[p];
                    }
                }
                for(i = 0; i < l; i++){
                    copy = _copyExcluding(vars, _staggerPropsToSkip);
                    copy.stagger = 0;
                    yoyoEase && (copy.yoyoEase = yoyoEase);
                    staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
                    curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.
                    copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i, curTarget, parsedTargets);
                    copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;
                    if (!stagger && l === 1 && copy.delay) {
                        // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
                        _this3._delay = delay = copy.delay;
                        _this3._start += delay;
                        copy.delay = 0;
                    }
                    tl.to(curTarget, copy, staggerFunc ? staggerFunc(i, curTarget, parsedTargets) : 0);
                    tl._ease = _easeMap.none;
                }
                tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
            } else if (keyframes) {
                _inheritDefaults(_setDefaults(tl.vars.defaults, {
                    ease: "none"
                }));
                tl._ease = _parseEase(keyframes.ease || vars.ease || "none");
                var time = 0, a, kf, v;
                if (_isArray(keyframes)) {
                    keyframes.forEach(function(frame) {
                        return tl.to(parsedTargets, frame, ">");
                    });
                    tl.duration(); // to ensure tl._dur is cached because we tap into it for performance purposes in the render() method.
                } else {
                    copy = {};
                    for(p in keyframes)p === "ease" || p === "easeEach" || _parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
                    for(p in copy){
                        a = copy[p].sort(function(a, b) {
                            return a.t - b.t;
                        });
                        time = 0;
                        for(i = 0; i < a.length; i++){
                            kf = a[i];
                            v = {
                                ease: kf.e,
                                duration: (kf.t - (i ? a[i - 1].t : 0)) / 100 * duration
                            };
                            v[p] = kf.v;
                            tl.to(parsedTargets, v, time);
                            time += v.duration;
                        }
                    }
                    tl.duration() < duration && tl.to({}, {
                        duration: duration - tl.duration()
                    }); // in case keyframes didn't go to 100%
                }
            }
            duration || _this3.duration(duration = tl.duration());
        } else _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
        if (overwrite === true && !_suppressOverwrites) {
            _overwritingTween = _assertThisInitialized(_this3);
            _globalTimeline.killTweensOf(parsedTargets);
            _overwritingTween = 0;
        }
        _addToTimeline(parent, _assertThisInitialized(_this3), position);
        vars.reversed && _this3.reverse();
        vars.paused && _this3.paused(true);
        if (immediateRender || !duration && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
            _this3._tTime = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
            _this3.render(Math.max(0, -delay) || 0); //in case delay is negative
        }
        scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
        return _this3;
    }
    var _proto3 = Tween.prototype;
    _proto3.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._tDur, dur = this._dur, isNegative = totalTime < 0, tTime = totalTime > tDur - _tinyNum && !isNegative ? tDur : totalTime < _tinyNum ? 0 : totalTime, time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline, yoyoEase;
        if (!dur) _renderZeroDurationTween(this, totalTime, suppressEvents, force);
        else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative) {
            //this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
            time = tTime;
            timeline = this.timeline;
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && isNegative) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === _roundPrecise(tTime / cycleDuration)) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                isYoyo = this._yoyo && iteration & 1;
                if (isYoyo) {
                    yoyoEase = this._yEase;
                    time = dur - time;
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                if (time === prevTime && !force && this._initted && iteration === prevIteration) {
                    //could be during the repeatDelay part. No need to render and fire callbacks.
                    this._tTime = tTime;
                    return this;
                }
                if (iteration !== prevIteration) {
                    timeline && this._yEase && _propagateYoyoEase(timeline, isYoyo); //repeatRefresh functionality
                    if (this.vars.repeatRefresh && !isYoyo && !this._lock && this._time !== cycleDuration && this._initted) {
                        // this._time will === cycleDuration when we render at EXACTLY the end of an iteration. Without this condition, it'd often do the repeatRefresh render TWICE (again on the very next tick).
                        this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.
                        this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
                    }
                }
            }
            if (!this._initted) {
                if (_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
                    this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.
                    return this;
                }
                if (prevTime !== this._time && !(force && this.vars.repeatRefresh && iteration !== prevIteration)) // rare edge case - during initialization, an onUpdate in the _startAt (.fromTo()) might force this tween to render at a different spot in which case we should ditch this render() call so that it doesn't revert the values. But we also don't want to dump if we're doing a repeatRefresh render!
                return this;
                if (dur !== this._dur) // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
                return this.render(totalTime, suppressEvents, force);
            }
            this._tTime = tTime;
            this._time = time;
            if (!this._act && this._ts) {
                this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
                this._lazy = 0;
            }
            this.ratio = ratio = (yoyoEase || this._ease)(time / dur);
            if (this._from) this.ratio = ratio = 1 - ratio;
            if (time && !prevTime && !suppressEvents && !iteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            pt = this._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
            timeline && timeline.render(totalTime < 0 ? totalTime : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);
            if (this._onUpdate && !suppressEvents) {
                isNegative && _rewindStartAt(this, totalTime, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
                _callback(this, "onUpdate");
            }
            this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");
            if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
                isNegative && !this._onUpdate && _rewindStartAt(this, totalTime, true, true);
                (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
                    // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
                    _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
                    this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                }
            }
        }
        return this;
    };
    _proto3.targets = function targets() {
        return this._targets;
    };
    _proto3.invalidate = function invalidate(soft) {
        // "soft" gives us a way to clear out everything EXCEPT the recorded pre-"from" portion of from() tweens. Otherwise, for example, if you tween.progress(1).render(0, true true).invalidate(), the "from" values would persist and then on the next render, the from() tweens would initialize and the current value would match the "from" values, thus animate from the same value to the same value (no animation). We tap into this in ScrollTrigger's refresh() where we must push a tween to completion and then back again but honor its init state in case the tween is dependent on another tween further up on the page.
        (!soft || !this.vars.runBackwards) && (this._startAt = 0);
        this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
        this._ptLookup = [];
        this.timeline && this.timeline.invalidate(soft);
        return _Animation2.prototype.invalidate.call(this, soft);
    };
    _proto3.resetTo = function resetTo(property, value, start, startIsRelative, skipRecursion) {
        _tickerActive || _ticker.wake();
        this._ts || this.play();
        var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts), ratio;
        this._initted || _initTween(this, time);
        ratio = this._ease(time / this._dur); // don't just get tween.ratio because it may not have rendered yet.
        // possible future addition to allow an object with multiple values to update, like tween.resetTo({x: 100, y: 200}); At this point, it doesn't seem worth the added kb given the fact that most users will likely opt for the convenient gsap.quickTo() way of interacting with this method.
        // if (_isObject(property)) { // performance optimization
        // 	for (p in property) {
        // 		if (_updatePropTweens(this, p, property[p], value ? value[p] : null, start, ratio, time)) {
        // 			return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
        // 		}
        // 	}
        // } else {
        if (_updatePropTweens(this, property, value, start, startIsRelative, ratio, time, skipRecursion)) return this.resetTo(property, value, start, startIsRelative, 1); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
         //}
        _alignPlayhead(this, 0);
        this.parent || _addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
        return this.render(0);
    };
    _proto3.kill = function kill(targets, vars) {
        if (vars === void 0) vars = "all";
        if (!targets && (!vars || vars === "all")) {
            this._lazy = this._pt = 0;
            return this.parent ? _interrupt(this) : this;
        }
        if (this.timeline) {
            var tDur = this.timeline.totalDuration();
            this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this); // if nothing is left tweening, interrupt.
            this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.
            return this;
        }
        var parsedTargets = this._targets, killingTargets = targets ? toArray(targets) : parsedTargets, propTweenLookup = this._ptLookup, firstPT = this._pt, overwrittenProps, curLookup, curOverwriteProps, props, p, pt, i;
        if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
            vars === "all" && (this._pt = 0);
            return _interrupt(this);
        }
        overwrittenProps = this._op = this._op || [];
        if (vars !== "all") {
            //so people can pass in a comma-delimited list of property names
            if (_isString(vars)) {
                p = {};
                _forEachName(vars, function(name) {
                    return p[name] = 1;
                });
                vars = p;
            }
            vars = _addAliasesToVars(parsedTargets, vars);
        }
        i = parsedTargets.length;
        while(i--)if (~killingTargets.indexOf(parsedTargets[i])) {
            curLookup = propTweenLookup[i];
            if (vars === "all") {
                overwrittenProps[i] = vars;
                props = curLookup;
                curOverwriteProps = {};
            } else {
                curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
                props = vars;
            }
            for(p in props){
                pt = curLookup && curLookup[p];
                if (pt) {
                    if (!("kill" in pt.d) || pt.d.kill(p) === true) _removeLinkedListItem(this, pt, "_pt");
                    delete curLookup[p];
                }
                if (curOverwriteProps !== "all") curOverwriteProps[p] = 1;
            }
        }
        this._initted && !this._pt && firstPT && _interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
        return this;
    };
    Tween.to = function to(targets, vars) {
        return new Tween(targets, vars, arguments[2]);
    };
    Tween.from = function from(targets, vars) {
        return _createTweenType(1, arguments);
    };
    Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
        return new Tween(callback, 0, {
            immediateRender: false,
            lazy: false,
            overwrite: false,
            delay: delay,
            onComplete: callback,
            onReverseComplete: callback,
            onCompleteParams: params,
            onReverseCompleteParams: params,
            callbackScope: scope
        }); // we must use onReverseComplete too for things like timeline.add(() => {...}) which should be triggered in BOTH directions (forward and reverse)
    };
    Tween.fromTo = function fromTo(targets, fromVars, toVars) {
        return _createTweenType(2, arguments);
    };
    Tween.set = function set(targets, vars) {
        vars.duration = 0;
        vars.repeatDelay || (vars.repeat = 0);
        return new Tween(targets, vars);
    };
    Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        return _globalTimeline.killTweensOf(targets, props, onlyActive);
    };
    return Tween;
}(Animation);
_setDefaults(Tween.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.
_forEachName("staggerTo,staggerFrom,staggerFromTo", function(name) {
    Tween[name] = function() {
        var tl = new Timeline(), params = _slice.call(arguments, 0);
        params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
        return tl[name].apply(tl, params);
    };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */ var _setterPlain = function _setterPlain(target, property, value) {
    return target[property] = value;
}, _setterFunc = function _setterFunc(target, property, value) {
    return target[property](value);
}, _setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
    return target[property](data.fp, value);
}, _setterAttribute = function _setterAttribute(target, property, value) {
    return target.setAttribute(property, value);
}, _getSetter = function _getSetter(target, property) {
    return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
}, _renderPlain = function _renderPlain(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
}, _renderBoolean = function _renderBoolean(ratio, data) {
    return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
}, _renderComplexString = function _renderComplexString(ratio, data) {
    var pt = data._pt, s = "";
    if (!ratio && data.b) //b = beginning string
    s = data.b;
    else if (ratio === 1 && data.e) //e = ending string
    s = data.e;
    else {
        while(pt){
            s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.
            pt = pt._next;
        }
        s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
    }
    data.set(data.t, data.p, s, data);
}, _renderPropTweens = function _renderPropTweens(ratio, data) {
    var pt = data._pt;
    while(pt){
        pt.r(ratio, pt.d);
        pt = pt._next;
    }
}, _addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
    var pt = this._pt, next;
    while(pt){
        next = pt._next;
        pt.p === property && pt.modifier(modifier, tween, target);
        pt = next;
    }
}, _killPropTweensOf = function _killPropTweensOf(property) {
    var pt = this._pt, hasNonDependentRemaining, next;
    while(pt){
        next = pt._next;
        if (pt.p === property && !pt.op || pt.op === property) _removeLinkedListItem(this, pt, "_pt");
        else if (!pt.dep) hasNonDependentRemaining = 1;
        pt = next;
    }
    return !hasNonDependentRemaining;
}, _setterWithModifier = function _setterWithModifier(target, property, value, data) {
    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
}, _sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
    var pt = parent._pt, next, pt2, first, last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)
    while(pt){
        next = pt._next;
        pt2 = first;
        while(pt2 && pt2.pr > pt.pr)pt2 = pt2._next;
        if (pt._prev = pt2 ? pt2._prev : last) pt._prev._next = pt;
        else first = pt;
        if (pt._next = pt2) pt2._prev = pt;
        else last = pt;
        pt = next;
    }
    parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)
var PropTween = /*#__PURE__*/ function() {
    function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
        this.t = target;
        this.s = start;
        this.c = change;
        this.p = prop;
        this.r = renderer || _renderPlain;
        this.d = data || this;
        this.set = setter || _setterPlain;
        this.pr = priority || 0;
        this._next = next;
        if (next) next._prev = this;
    }
    var _proto4 = PropTween.prototype;
    _proto4.modifier = function modifier(func, tween, target) {
        this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)
        this.set = _setterWithModifier;
        this.m = func;
        this.mt = target; //modifier target
        this.tween = tween;
    };
    return PropTween;
}(); //Initialization tasks
_forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(name) {
    return _reservedProps[name] = 1;
});
_globals.TweenMax = _globals.TweenLite = Tween;
_globals.TimelineLite = _globals.TimelineMax = Timeline;
_globalTimeline = new Timeline({
    sortChildren: false,
    defaults: _defaults,
    autoRemoveChildren: true,
    id: "root",
    smoothChildTiming: true
});
_config.stringFilter = _colorStringFilter;
var _media = [], _listeners = {}, _emptyArray = [], _lastMediaTime = 0, _contextID = 0, _dispatch = function _dispatch(type) {
    return (_listeners[type] || _emptyArray).map(function(f) {
        return f();
    });
}, _onMediaChange = function _onMediaChange() {
    var time = Date.now(), matches = [];
    if (time - _lastMediaTime > 2) {
        _dispatch("matchMediaInit");
        _media.forEach(function(c) {
            var queries = c.queries, conditions = c.conditions, match, p, anyMatch, toggled;
            for(p in queries){
                match = _win.matchMedia(queries[p]).matches; // Firefox doesn't update the "matches" property of the MediaQueryList object correctly - it only does so as it calls its change handler - so we must re-create a media query here to ensure it's accurate.
                match && (anyMatch = 1);
                if (match !== conditions[p]) {
                    conditions[p] = match;
                    toggled = 1;
                }
            }
            if (toggled) {
                c.revert();
                anyMatch && matches.push(c);
            }
        });
        _dispatch("matchMediaRevert");
        matches.forEach(function(c) {
            return c.onMatch(c, function(func) {
                return c.add(null, func);
            });
        });
        _lastMediaTime = time;
        _dispatch("matchMedia");
    }
};
var Context = /*#__PURE__*/ function() {
    function Context(func, scope) {
        this.selector = scope && selector(scope);
        this.data = [];
        this._r = []; // returned/cleanup functions
        this.isReverted = false;
        this.id = _contextID++; // to work around issues that frameworks like Vue cause by making things into Proxies which make it impossible to do something like _media.indexOf(this) because "this" would no longer refer to the Context instance itself - it'd refer to a Proxy! We needed a way to identify the context uniquely
        func && this.add(func);
    }
    var _proto5 = Context.prototype;
    _proto5.add = function add(name, func, scope) {
        // possible future addition if we need the ability to add() an animation to a context and for whatever reason cannot create that animation inside of a context.add(() => {...}) function.
        // if (name && _isFunction(name.revert)) {
        // 	this.data.push(name);
        // 	return (name._ctx = this);
        // }
        if (_isFunction(name)) {
            scope = func;
            func = name;
            name = _isFunction;
        }
        var self = this, f = function f() {
            var prev = _context, prevSelector = self.selector, result;
            prev && prev !== self && prev.data.push(self);
            scope && (self.selector = selector(scope));
            _context = self;
            result = func.apply(self, arguments);
            _isFunction(result) && self._r.push(result);
            _context = prev;
            self.selector = prevSelector;
            self.isReverted = false;
            return result;
        };
        self.last = f;
        return name === _isFunction ? f(self, function(func) {
            return self.add(null, func);
        }) : name ? self[name] = f : f;
    };
    _proto5.ignore = function ignore(func) {
        var prev = _context;
        _context = null;
        func(this);
        _context = prev;
    };
    _proto5.getTweens = function getTweens() {
        var a = [];
        this.data.forEach(function(e) {
            return e instanceof Context ? a.push.apply(a, e.getTweens()) : e instanceof Tween && !(e.parent && e.parent.data === "nested") && a.push(e);
        });
        return a;
    };
    _proto5.clear = function clear() {
        this._r.length = this.data.length = 0;
    };
    _proto5.kill = function kill(revert, matchMedia) {
        var _this4 = this;
        if (revert) (function() {
            var tweens = _this4.getTweens(), i = _this4.data.length, t;
            while(i--){
                // Flip plugin tweens are very different in that they should actually be pushed to their end. The plugin replaces the timeline's .revert() method to do exactly that. But we also need to remove any of those nested tweens inside the flip timeline so that they don't get individually reverted.
                t = _this4.data[i];
                if (t.data === "isFlip") {
                    t.revert();
                    t.getChildren(true, true, false).forEach(function(tween) {
                        return tweens.splice(tweens.indexOf(tween), 1);
                    });
                }
            } // save as an object so that we can cache the globalTime for each tween to optimize performance during the sort
            tweens.map(function(t) {
                return {
                    g: t._dur || t._delay || t._sat && !t._sat.vars.immediateRender ? t.globalTime(0) : -Infinity,
                    t: t
                };
            }).sort(function(a, b) {
                return b.g - a.g || -Infinity;
            }).forEach(function(o) {
                return o.t.revert(revert);
            }); // note: all of the _startAt tweens should be reverted in reverse order that they were created, and they'll all have the same globalTime (-1) so the " || -1" in the sort keeps the order properly.
            i = _this4.data.length;
            while(i--){
                // make sure we loop backwards so that, for example, SplitTexts that were created later on the same element get reverted first
                t = _this4.data[i];
                if (t instanceof Timeline) {
                    if (t.data !== "nested") {
                        t.scrollTrigger && t.scrollTrigger.revert();
                        t.kill(); // don't revert() the timeline because that's duplicating efforts since we already reverted all the tweens
                    }
                } else !(t instanceof Tween) && t.revert && t.revert(revert);
            }
            _this4._r.forEach(function(f) {
                return f(revert, _this4);
            });
            _this4.isReverted = true;
        })();
        else this.data.forEach(function(e) {
            return e.kill && e.kill();
        });
        this.clear();
        if (matchMedia) {
            var i = _media.length;
            while(i--)// previously, we checked _media.indexOf(this), but some frameworks like Vue enforce Proxy objects that make it impossible to get the proper result that way, so we must use a unique ID number instead.
            _media[i].id === this.id && _media.splice(i, 1);
        }
    };
    _proto5.revert = function revert(config) {
        this.kill(config || {});
    };
    return Context;
}();
var MatchMedia = /*#__PURE__*/ function() {
    function MatchMedia(scope) {
        this.contexts = [];
        this.scope = scope;
        _context && _context.data.push(this);
    }
    var _proto6 = MatchMedia.prototype;
    _proto6.add = function add(conditions, func, scope) {
        _isObject(conditions) || (conditions = {
            matches: conditions
        });
        var context = new Context(0, scope || this.scope), cond = context.conditions = {}, mq, p, active;
        _context && !context.selector && (context.selector = _context.selector); // in case a context is created inside a context. Like a gsap.matchMedia() that's inside a scoped gsap.context()
        this.contexts.push(context);
        func = context.add("onMatch", func);
        context.queries = conditions;
        for(p in conditions)if (p === "all") active = 1;
        else {
            mq = _win.matchMedia(conditions[p]);
            if (mq) {
                _media.indexOf(context) < 0 && _media.push(context);
                (cond[p] = mq.matches) && (active = 1);
                mq.addListener ? mq.addListener(_onMediaChange) : mq.addEventListener("change", _onMediaChange);
            }
        }
        active && func(context, function(f) {
            return context.add(null, f);
        });
        return this;
    } // refresh() {
    ;
    _proto6.revert = function revert(config) {
        this.kill(config || {});
    };
    _proto6.kill = function kill(revert) {
        this.contexts.forEach(function(c) {
            return c.kill(revert, true);
        });
    };
    return MatchMedia;
}();
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */ var _gsap = {
    registerPlugin: function registerPlugin() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        args.forEach(function(config) {
            return _createPlugin(config);
        });
    },
    timeline: function timeline(vars) {
        return new Timeline(vars);
    },
    getTweensOf: function getTweensOf(targets, onlyActive) {
        return _globalTimeline.getTweensOf(targets, onlyActive);
    },
    getProperty: function getProperty(target, property, unit, uncache) {
        _isString(target) && (target = toArray(target)[0]); //in case selector text or an array is passed in
        var getter = _getCache(target || {}).get, format = unit ? _passThrough : _numericIfPossible;
        unit === "native" && (unit = "");
        return !target ? target : !property ? function(property, unit, uncache) {
            return format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
        } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
    },
    quickSetter: function quickSetter(target, property, unit) {
        target = toArray(target);
        if (target.length > 1) {
            var setters = target.map(function(t) {
                return gsap.quickSetter(t, property, unit);
            }), l = setters.length;
            return function(value) {
                var i = l;
                while(i--)setters[i](value);
            };
        }
        target = target[0] || {};
        var Plugin = _plugins[property], cache = _getCache(target), p = cache.harness && (cache.harness.aliases || {})[property] || property, // in case it's an alias, like "rotate" for "rotation".
        setter = Plugin ? function(value) {
            var p = new Plugin();
            _quickTween._pt = 0;
            p.init(target, unit ? value + unit : value, _quickTween, 0, [
                target
            ]);
            p.render(1, p);
            _quickTween._pt && _renderPropTweens(1, _quickTween);
        } : cache.set(target, p);
        return Plugin ? setter : function(value) {
            return setter(target, p, unit ? value + unit : value, cache, 1);
        };
    },
    quickTo: function quickTo(target, property, vars) {
        var _merge2;
        var tween = gsap.to(target, _merge((_merge2 = {}, _merge2[property] = "+=0.1", _merge2.paused = true, _merge2), vars || {})), func = function func(value, start, startIsRelative) {
            return tween.resetTo(property, value, start, startIsRelative);
        };
        func.tween = tween;
        return func;
    },
    isTweening: function isTweening(targets) {
        return _globalTimeline.getTweensOf(targets, true).length > 0;
    },
    defaults: function defaults(value) {
        value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
        return _mergeDeep(_defaults, value || {});
    },
    config: function config(value) {
        return _mergeDeep(_config, value || {});
    },
    registerEffect: function registerEffect(_ref3) {
        var name = _ref3.name, effect = _ref3.effect, plugins = _ref3.plugins, defaults = _ref3.defaults, extendTimeline = _ref3.extendTimeline;
        (plugins || "").split(",").forEach(function(pluginName) {
            return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
        });
        _effects[name] = function(targets, vars, tl) {
            return effect(toArray(targets), _setDefaults(vars || {}, defaults), tl);
        };
        if (extendTimeline) Timeline.prototype[name] = function(targets, vars, position) {
            return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
        };
    },
    registerEase: function registerEase(name, ease) {
        _easeMap[name] = _parseEase(ease);
    },
    parseEase: function parseEase(ease, defaultEase) {
        return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
    },
    getById: function getById(id) {
        return _globalTimeline.getById(id);
    },
    exportRoot: function exportRoot(vars, includeDelayedCalls) {
        if (vars === void 0) vars = {};
        var tl = new Timeline(vars), child, next;
        tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);
        _globalTimeline.remove(tl);
        tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).
        tl._time = tl._tTime = _globalTimeline._time;
        child = _globalTimeline._first;
        while(child){
            next = child._next;
            if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) _addToTimeline(tl, child, child._start - child._delay);
            child = next;
        }
        _addToTimeline(_globalTimeline, tl, 0);
        return tl;
    },
    context: function context(func, scope) {
        return func ? new Context(func, scope) : _context;
    },
    matchMedia: function matchMedia(scope) {
        return new MatchMedia(scope);
    },
    matchMediaRefresh: function matchMediaRefresh() {
        return _media.forEach(function(c) {
            var cond = c.conditions, found, p;
            for(p in cond)if (cond[p]) {
                cond[p] = false;
                found = 1;
            }
            found && c.revert();
        }) || _onMediaChange();
    },
    addEventListener: function addEventListener(type, callback) {
        var a = _listeners[type] || (_listeners[type] = []);
        ~a.indexOf(callback) || a.push(callback);
    },
    removeEventListener: function removeEventListener(type, callback) {
        var a = _listeners[type], i = a && a.indexOf(callback);
        i >= 0 && a.splice(i, 1);
    },
    utils: {
        wrap: wrap,
        wrapYoyo: wrapYoyo,
        distribute: distribute,
        random: random,
        snap: snap,
        normalize: normalize,
        getUnit: getUnit,
        clamp: clamp,
        splitColor: splitColor,
        toArray: toArray,
        selector: selector,
        mapRange: mapRange,
        pipe: pipe,
        unitize: unitize,
        interpolate: interpolate,
        shuffle: shuffle
    },
    install: _install,
    effects: _effects,
    ticker: _ticker,
    updateRoot: Timeline.updateRoot,
    plugins: _plugins,
    globalTimeline: _globalTimeline,
    core: {
        PropTween: PropTween,
        globals: _addGlobal,
        Tween: Tween,
        Timeline: Timeline,
        Animation: Animation,
        getCache: _getCache,
        _removeLinkedListItem: _removeLinkedListItem,
        reverting: function reverting() {
            return _reverting;
        },
        context: function context(toAdd) {
            if (toAdd && _context) {
                _context.data.push(toAdd);
                toAdd._ctx = _context;
            }
            return _context;
        },
        suppressOverwrites: function suppressOverwrites(value) {
            return _suppressOverwrites = value;
        }
    }
};
_forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function(name) {
    return _gsap[name] = Tween[name];
});
_ticker.add(Timeline.updateRoot);
_quickTween = _gsap.to({}, {
    duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------
var _getPluginPropTween = function _getPluginPropTween(plugin, prop) {
    var pt = plugin._pt;
    while(pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop)pt = pt._next;
    return pt;
}, _addModifiers = function _addModifiers(tween, modifiers) {
    var targets = tween._targets, p, i, pt;
    for(p in modifiers){
        i = targets.length;
        while(i--){
            pt = tween._ptLookup[i][p];
            if (pt && (pt = pt.d)) {
                if (pt._pt) // is a plugin
                pt = _getPluginPropTween(pt, p);
                pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
            }
        }
    }
}, _buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
    return {
        name: name,
        rawVars: 1,
        //don't pre-process function-based values or "random()" strings.
        init: function init(target, vars, tween) {
            tween._onInit = function(tween) {
                var temp, p;
                if (_isString(vars)) {
                    temp = {};
                    _forEachName(vars, function(name) {
                        return temp[name] = 1;
                    }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.
                    vars = temp;
                }
                if (modifier) {
                    temp = {};
                    for(p in vars)temp[p] = modifier(vars[p]);
                    vars = temp;
                }
                _addModifiers(tween, vars);
            };
        }
    };
}; //register core plugins
var gsap = _gsap.registerPlugin({
    name: "attr",
    init: function init(target, vars, tween, index, targets) {
        var p, pt, v;
        this.tween = tween;
        for(p in vars){
            v = target.getAttribute(p) || "";
            pt = this.add(target, "setAttribute", (v || 0) + "", vars[p], index, targets, 0, 0, p);
            pt.op = p;
            pt.b = v; // record the beginning value so we can revert()
            this._props.push(p);
        }
    },
    render: function render(ratio, data) {
        var pt = data._pt;
        while(pt){
            _reverting ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d); // if reverting, go back to the original (pt.b)
            pt = pt._next;
        }
    }
}, {
    name: "endArray",
    init: function init(target, value) {
        var i = value.length;
        while(i--)this.add(target, i, target[i] || 0, value[i], 0, 0, 0, 0, 0, 1);
    }
}, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.
Tween.version = Timeline.version = gsap.version = "3.12.5";
_coreReady = 1;
_windowExists() && _wake();
var Power0 = _easeMap.Power0, Power1 = _easeMap.Power1, Power2 = _easeMap.Power2, Power3 = _easeMap.Power3, Power4 = _easeMap.Power4, Linear = _easeMap.Linear, Quad = _easeMap.Quad, Cubic = _easeMap.Cubic, Quart = _easeMap.Quart, Quint = _easeMap.Quint, Strong = _easeMap.Strong, Elastic = _easeMap.Elastic, Back = _easeMap.Back, SteppedEase = _easeMap.SteppedEase, Bounce = _easeMap.Bounce, Sine = _easeMap.Sine, Expo = _easeMap.Expo, Circ = _easeMap.Circ;

});

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
const $1e1d691135efded8$var$vhUtils = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty("--vh", `${$1e1d691135efded8$var$vhUtils}px`);
// We listen to the resize event
window.addEventListener("resize", ()=>{
    // We execute the same script as before
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
});


var $6908e6e7096c5021$var$t = function() {
    return $6908e6e7096c5021$var$t = Object.assign || function(t) {
        for(var i, n = 1, s = arguments.length; n < s; n++)for(var a in i = arguments[n])Object.prototype.hasOwnProperty.call(i, a) && (t[a] = i[a]);
        return t;
    }, $6908e6e7096c5021$var$t.apply(this, arguments);
}, $6908e6e7096c5021$export$1567cc001e3d0c1d = function() {
    function i(i, n, s) {
        var a = this;
        this.endVal = n, this.options = s, this.version = "2.8.0", this.defaults = {
            startVal: 0,
            decimalPlaces: 0,
            duration: 2,
            useEasing: !0,
            useGrouping: !0,
            useIndianSeparators: !1,
            smartEasingThreshold: 999,
            smartEasingAmount: 333,
            separator: ",",
            decimal: ".",
            prefix: "",
            suffix: "",
            enableScrollSpy: !1,
            scrollSpyDelay: 200,
            scrollSpyOnce: !1
        }, this.finalEndVal = null, this.useEasing = !0, this.countDown = !1, this.error = "", this.startVal = 0, this.paused = !0, this.once = !1, this.count = function(t) {
            a.startTime || (a.startTime = t);
            var i = t - a.startTime;
            a.remaining = a.duration - i, a.useEasing ? a.countDown ? a.frameVal = a.startVal - a.easingFn(i, 0, a.startVal - a.endVal, a.duration) : a.frameVal = a.easingFn(i, a.startVal, a.endVal - a.startVal, a.duration) : a.frameVal = a.startVal + (a.endVal - a.startVal) * (i / a.duration);
            var n = a.countDown ? a.frameVal < a.endVal : a.frameVal > a.endVal;
            a.frameVal = n ? a.endVal : a.frameVal, a.frameVal = Number(a.frameVal.toFixed(a.options.decimalPlaces)), a.printValue(a.frameVal), i < a.duration ? a.rAF = requestAnimationFrame(a.count) : null !== a.finalEndVal ? a.update(a.finalEndVal) : a.options.onCompleteCallback && a.options.onCompleteCallback();
        }, this.formatNumber = function(t) {
            var i, n, s, e, o = t < 0 ? "-" : "";
            i = Math.abs(t).toFixed(a.options.decimalPlaces);
            var r = (i += "").split(".");
            if (n = r[0], s = r.length > 1 ? a.options.decimal + r[1] : "", a.options.useGrouping) {
                e = "";
                for(var l = 3, h = 0, u = 0, p = n.length; u < p; ++u)a.options.useIndianSeparators && 4 === u && (l = 2, h = 1), 0 !== u && h % l == 0 && (e = a.options.separator + e), h++, e = n[p - u - 1] + e;
                n = e;
            }
            return a.options.numerals && a.options.numerals.length && (n = n.replace(/[0-9]/g, function(t) {
                return a.options.numerals[+t];
            }), s = s.replace(/[0-9]/g, function(t) {
                return a.options.numerals[+t];
            })), o + a.options.prefix + n + s + a.options.suffix;
        }, this.easeOutExpo = function(t, i, n, s) {
            return n * (1 - Math.pow(2, -10 * t / s)) * 1024 / 1023 + i;
        }, this.options = $6908e6e7096c5021$var$t($6908e6e7096c5021$var$t({}, this.defaults), s), this.formattingFn = this.options.formattingFn ? this.options.formattingFn : this.formatNumber, this.easingFn = this.options.easingFn ? this.options.easingFn : this.easeOutExpo, this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.endVal = this.validateValue(n), this.options.decimalPlaces = Math.max(this.options.decimalPlaces), this.resetDuration(), this.options.separator = String(this.options.separator), this.useEasing = this.options.useEasing, "" === this.options.separator && (this.options.useGrouping = !1), this.el = "string" == typeof i ? document.getElementById(i) : i, this.el ? this.printValue(this.startVal) : this.error = "[CountUp] target is null or undefined", "undefined" != typeof window && this.options.enableScrollSpy && (this.error ? console.error(this.error, i) : (window.onScrollFns = window.onScrollFns || [], window.onScrollFns.push(function() {
            return a.handleScroll(a);
        }), window.onscroll = function() {
            window.onScrollFns.forEach(function(t) {
                return t();
            });
        }, this.handleScroll(this)));
    }
    return i.prototype.handleScroll = function(t) {
        if (t && window && !t.once) {
            var i = window.innerHeight + window.scrollY, n = t.el.getBoundingClientRect(), s = n.top + window.pageYOffset, a = n.top + n.height + window.pageYOffset;
            a < i && a > window.scrollY && t.paused ? (t.paused = !1, setTimeout(function() {
                return t.start();
            }, t.options.scrollSpyDelay), t.options.scrollSpyOnce && (t.once = !0)) : (window.scrollY > a || s > i) && !t.paused && t.reset();
        }
    }, i.prototype.determineDirectionAndSmartEasing = function() {
        var t = this.finalEndVal ? this.finalEndVal : this.endVal;
        this.countDown = this.startVal > t;
        var i = t - this.startVal;
        if (Math.abs(i) > this.options.smartEasingThreshold && this.options.useEasing) {
            this.finalEndVal = t;
            var n = this.countDown ? 1 : -1;
            this.endVal = t + n * this.options.smartEasingAmount, this.duration = this.duration / 2;
        } else this.endVal = t, this.finalEndVal = null;
        null !== this.finalEndVal ? this.useEasing = !1 : this.useEasing = this.options.useEasing;
    }, i.prototype.start = function(t) {
        this.error || (this.options.onStartCallback && this.options.onStartCallback(), t && (this.options.onCompleteCallback = t), this.duration > 0 ? (this.determineDirectionAndSmartEasing(), this.paused = !1, this.rAF = requestAnimationFrame(this.count)) : this.printValue(this.endVal));
    }, i.prototype.pauseResume = function() {
        this.paused ? (this.startTime = null, this.duration = this.remaining, this.startVal = this.frameVal, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count)) : cancelAnimationFrame(this.rAF), this.paused = !this.paused;
    }, i.prototype.reset = function() {
        cancelAnimationFrame(this.rAF), this.paused = !0, this.resetDuration(), this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.printValue(this.startVal);
    }, i.prototype.update = function(t) {
        cancelAnimationFrame(this.rAF), this.startTime = null, this.endVal = this.validateValue(t), this.endVal !== this.frameVal && (this.startVal = this.frameVal, null == this.finalEndVal && this.resetDuration(), this.finalEndVal = null, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count));
    }, i.prototype.printValue = function(t) {
        var i;
        if (this.el) {
            var n = this.formattingFn(t);
            if (null === (i = this.options.plugin) || void 0 === i ? void 0 : i.render) this.options.plugin.render(this.el, n);
            else if ("INPUT" === this.el.tagName) this.el.value = n;
            else "text" === this.el.tagName || "tspan" === this.el.tagName ? this.el.textContent = n : this.el.innerHTML = n;
        }
    }, i.prototype.ensureNumber = function(t) {
        return "number" == typeof t && !isNaN(t);
    }, i.prototype.validateValue = function(t) {
        var i = Number(t);
        return this.ensureNumber(i) ? i : (this.error = "[CountUp] invalid start or end value: ".concat(t), null);
    }, i.prototype.resetDuration = function() {
        this.startTime = null, this.duration = 1e3 * Number(this.options.duration), this.remaining = this.duration;
    }, i;
}();


/**
 * CountUp Metamorfosi function
 * (just add .count-up class anywhere and setup unique option in data attributes)
 * **/ const $fc573d5d472869fd$var$counts = Array.from(document.getElementsByClassName("count-up"));
if ($fc573d5d472869fd$var$counts) {
    const defaultOptions = {
        separator: " ",
        enableScrollSpy: true,
        scrollSpyOnce: true
    };
    let idNumber = 1;
    $fc573d5d472869fd$var$counts.forEach((count)=>{
        const id = `count-up-${idNumber}`;
        const value = parseFloat(count.innerHTML);
        let optionsFromDataAttr = {
            ...count.dataset
        };
        for(const key in optionsFromDataAttr)if (optionsFromDataAttr[key] === "") optionsFromDataAttr[key] = true;
        count.id = id;
        new (0, $6908e6e7096c5021$export$1567cc001e3d0c1d)(id, value, {
            ...defaultOptions,
            ...optionsFromDataAttr
        });
        idNumber++;
    });
}


const $6cce3a502c50d5fc$var$t = (t, e = 1e4)=>(t = parseFloat(t + "") || 0, Math.round((t + Number.EPSILON) * e) / e), $6cce3a502c50d5fc$var$e = function(t) {
    if (!(t && t instanceof Element && t.offsetParent)) return !1;
    const e = t.scrollHeight > t.clientHeight, i = window.getComputedStyle(t).overflowY, n = -1 !== i.indexOf("hidden"), s = -1 !== i.indexOf("visible");
    return e && !n && !s;
}, $6cce3a502c50d5fc$var$i = function(t, n) {
    return !(!t || t === document.body || n && t === n) && ($6cce3a502c50d5fc$var$e(t) ? t : $6cce3a502c50d5fc$var$i(t.parentElement, n));
}, $6cce3a502c50d5fc$var$n = function(t) {
    var e = (new DOMParser).parseFromString(t, "text/html").body;
    if (e.childElementCount > 1) {
        for(var i = document.createElement("div"); e.firstChild;)i.appendChild(e.firstChild);
        return i;
    }
    return e.firstChild;
}, $6cce3a502c50d5fc$var$s = (t)=>`${t || ""}`.split(" ").filter((t)=>!!t), $6cce3a502c50d5fc$var$o = (t, e, i)=>{
    t && $6cce3a502c50d5fc$var$s(e).forEach((e)=>{
        t.classList.toggle(e, i || !1);
    });
};
class $6cce3a502c50d5fc$var$a {
    constructor(t){
        Object.defineProperty(this, "pageX", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "pageY", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "clientX", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "clientY", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "id", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "time", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "nativePointer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this.nativePointer = t, this.pageX = t.pageX, this.pageY = t.pageY, this.clientX = t.clientX, this.clientY = t.clientY, this.id = self.Touch && t instanceof Touch ? t.identifier : -1, this.time = Date.now();
    }
}
const $6cce3a502c50d5fc$var$r = {
    passive: !1
};
class $6cce3a502c50d5fc$var$l {
    constructor(t, { start: e = ()=>!0, move: i = ()=>{}, end: n = ()=>{} }){
        Object.defineProperty(this, "element", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "startCallback", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "moveCallback", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "endCallback", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "currentPointers", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "startPointers", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), this.element = t, this.startCallback = e, this.moveCallback = i, this.endCallback = n;
        for (const t of [
            "onPointerStart",
            "onTouchStart",
            "onMove",
            "onTouchEnd",
            "onPointerEnd",
            "onWindowBlur"
        ])this[t] = this[t].bind(this);
        this.element.addEventListener("mousedown", this.onPointerStart, $6cce3a502c50d5fc$var$r), this.element.addEventListener("touchstart", this.onTouchStart, $6cce3a502c50d5fc$var$r), this.element.addEventListener("touchmove", this.onMove, $6cce3a502c50d5fc$var$r), this.element.addEventListener("touchend", this.onTouchEnd), this.element.addEventListener("touchcancel", this.onTouchEnd);
    }
    onPointerStart(t) {
        if (!t.buttons || 0 !== t.button) return;
        const e = new $6cce3a502c50d5fc$var$a(t);
        this.currentPointers.some((t)=>t.id === e.id) || this.triggerPointerStart(e, t) && (window.addEventListener("mousemove", this.onMove), window.addEventListener("mouseup", this.onPointerEnd), window.addEventListener("blur", this.onWindowBlur));
    }
    onTouchStart(t) {
        for (const e of Array.from(t.changedTouches || []))this.triggerPointerStart(new $6cce3a502c50d5fc$var$a(e), t);
        window.addEventListener("blur", this.onWindowBlur);
    }
    onMove(t) {
        const e = this.currentPointers.slice(), i = "changedTouches" in t ? Array.from(t.changedTouches || []).map((t)=>new $6cce3a502c50d5fc$var$a(t)) : [
            new $6cce3a502c50d5fc$var$a(t)
        ], n = [];
        for (const t of i){
            const e = this.currentPointers.findIndex((e)=>e.id === t.id);
            e < 0 || (n.push(t), this.currentPointers[e] = t);
        }
        n.length && this.moveCallback(t, this.currentPointers.slice(), e);
    }
    onPointerEnd(t) {
        t.buttons > 0 && 0 !== t.button || (this.triggerPointerEnd(t, new $6cce3a502c50d5fc$var$a(t)), window.removeEventListener("mousemove", this.onMove), window.removeEventListener("mouseup", this.onPointerEnd), window.removeEventListener("blur", this.onWindowBlur));
    }
    onTouchEnd(t) {
        for (const e of Array.from(t.changedTouches || []))this.triggerPointerEnd(t, new $6cce3a502c50d5fc$var$a(e));
    }
    triggerPointerStart(t, e) {
        return !!this.startCallback(e, t, this.currentPointers.slice()) && (this.currentPointers.push(t), this.startPointers.push(t), !0);
    }
    triggerPointerEnd(t, e) {
        const i = this.currentPointers.findIndex((t)=>t.id === e.id);
        i < 0 || (this.currentPointers.splice(i, 1), this.startPointers.splice(i, 1), this.endCallback(t, e, this.currentPointers.slice()));
    }
    onWindowBlur() {
        this.clear();
    }
    clear() {
        for(; this.currentPointers.length;){
            const t = this.currentPointers[this.currentPointers.length - 1];
            this.currentPointers.splice(this.currentPointers.length - 1, 1), this.startPointers.splice(this.currentPointers.length - 1, 1), this.endCallback(new Event("touchend", {
                bubbles: !0,
                cancelable: !0,
                clientX: t.clientX,
                clientY: t.clientY
            }), t, this.currentPointers.slice());
        }
    }
    stop() {
        this.element.removeEventListener("mousedown", this.onPointerStart, $6cce3a502c50d5fc$var$r), this.element.removeEventListener("touchstart", this.onTouchStart, $6cce3a502c50d5fc$var$r), this.element.removeEventListener("touchmove", this.onMove, $6cce3a502c50d5fc$var$r), this.element.removeEventListener("touchend", this.onTouchEnd), this.element.removeEventListener("touchcancel", this.onTouchEnd), window.removeEventListener("mousemove", this.onMove), window.removeEventListener("mouseup", this.onPointerEnd), window.removeEventListener("blur", this.onWindowBlur);
    }
}
function $6cce3a502c50d5fc$var$c(t, e) {
    return e ? Math.sqrt(Math.pow(e.clientX - t.clientX, 2) + Math.pow(e.clientY - t.clientY, 2)) : 0;
}
function $6cce3a502c50d5fc$var$h(t, e) {
    return e ? {
        clientX: (t.clientX + e.clientX) / 2,
        clientY: (t.clientY + e.clientY) / 2
    } : t;
}
const $6cce3a502c50d5fc$var$d = (t)=>"object" == typeof t && null !== t && t.constructor === Object && "[object Object]" === Object.prototype.toString.call(t), $6cce3a502c50d5fc$var$u = (t, ...e)=>{
    const i = e.length;
    for(let n = 0; n < i; n++){
        const i = e[n] || {};
        Object.entries(i).forEach(([e, i])=>{
            const n = Array.isArray(i) ? [] : {};
            t[e] || Object.assign(t, {
                [e]: n
            }), $6cce3a502c50d5fc$var$d(i) ? Object.assign(t[e], $6cce3a502c50d5fc$var$u(n, i)) : Array.isArray(i) ? Object.assign(t, {
                [e]: [
                    ...i
                ]
            }) : Object.assign(t, {
                [e]: i
            });
        });
    }
    return t;
}, $6cce3a502c50d5fc$var$p = function(t, e) {
    return t.split(".").reduce((t, e)=>"object" == typeof t ? t[e] : void 0, e);
};
class $6cce3a502c50d5fc$var$f {
    constructor(t = {}){
        Object.defineProperty(this, "options", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: t
        }), Object.defineProperty(this, "events", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: new Map
        }), this.setOptions(t);
        for (const t of Object.getOwnPropertyNames(Object.getPrototypeOf(this)))t.startsWith("on") && "function" == typeof this[t] && (this[t] = this[t].bind(this));
    }
    setOptions(t) {
        this.options = t ? $6cce3a502c50d5fc$var$u({}, this.constructor.defaults, t) : {};
        for (const [t, e] of Object.entries(this.option("on") || {}))this.on(t, e);
    }
    option(t, ...e) {
        let i = $6cce3a502c50d5fc$var$p(t, this.options);
        return i && "function" == typeof i && (i = i.call(this, this, ...e)), i;
    }
    optionFor(t, e, i, ...n) {
        let s = $6cce3a502c50d5fc$var$p(e, t);
        var o;
        "string" != typeof (o = s) || isNaN(o) || isNaN(parseFloat(o)) || (s = parseFloat(s)), "true" === s && (s = !0), "false" === s && (s = !1), s && "function" == typeof s && (s = s.call(this, this, t, ...n));
        let a = $6cce3a502c50d5fc$var$p(e, this.options);
        return a && "function" == typeof a ? s = a.call(this, this, t, ...n, s) : void 0 === s && (s = a), void 0 === s ? i : s;
    }
    cn(t) {
        const e = this.options.classes;
        return e && e[t] || "";
    }
    localize(t, e = []) {
        t = String(t).replace(/\{\{(\w+).?(\w+)?\}\}/g, (t, e, i)=>{
            let n = "";
            return i ? n = this.option(`${e[0] + e.toLowerCase().substring(1)}.l10n.${i}`) : e && (n = this.option(`l10n.${e}`)), n || (n = t), n;
        });
        for(let i = 0; i < e.length; i++)t = t.split(e[i][0]).join(e[i][1]);
        return t = t.replace(/\{\{(.*?)\}\}/g, (t, e)=>e);
    }
    on(t, e) {
        let i = [];
        "string" == typeof t ? i = t.split(" ") : Array.isArray(t) && (i = t), this.events || (this.events = new Map), i.forEach((t)=>{
            let i = this.events.get(t);
            i || (this.events.set(t, []), i = []), i.includes(e) || i.push(e), this.events.set(t, i);
        });
    }
    off(t, e) {
        let i = [];
        "string" == typeof t ? i = t.split(" ") : Array.isArray(t) && (i = t), i.forEach((t)=>{
            const i = this.events.get(t);
            if (Array.isArray(i)) {
                const t = i.indexOf(e);
                t > -1 && i.splice(t, 1);
            }
        });
    }
    emit(t, ...e) {
        [
            ...this.events.get(t) || []
        ].forEach((t)=>t(this, ...e)), "*" !== t && this.emit("*", t, ...e);
    }
}
Object.defineProperty($6cce3a502c50d5fc$var$f, "version", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: "5.0.36"
}), Object.defineProperty($6cce3a502c50d5fc$var$f, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {}
});
class $6cce3a502c50d5fc$var$g extends $6cce3a502c50d5fc$var$f {
    constructor(t = {}){
        super(t), Object.defineProperty(this, "plugins", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        });
    }
    attachPlugins(t = {}) {
        const e = new Map;
        for (const [i, n] of Object.entries(t)){
            const t = this.option(i), s = this.plugins[i];
            s || !1 === t ? s && !1 === t && (s.detach(), delete this.plugins[i]) : e.set(i, new n(this, t || {}));
        }
        for (const [t, i] of e)this.plugins[t] = i, i.attach();
    }
    detachPlugins(t) {
        t = t || Object.keys(this.plugins);
        for (const e of t){
            const t = this.plugins[e];
            t && t.detach(), delete this.plugins[e];
        }
        return this.emit("detachPlugins"), this;
    }
}
var $6cce3a502c50d5fc$var$m;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Error = 1] = "Error", t[t.Ready = 2] = "Ready", t[t.Panning = 3] = "Panning", t[t.Mousemove = 4] = "Mousemove", t[t.Destroy = 5] = "Destroy";
}($6cce3a502c50d5fc$var$m || ($6cce3a502c50d5fc$var$m = {}));
const $6cce3a502c50d5fc$var$v = [
    "a",
    "b",
    "c",
    "d",
    "e",
    "f"
], $6cce3a502c50d5fc$var$b = {
    PANUP: "Move up",
    PANDOWN: "Move down",
    PANLEFT: "Move left",
    PANRIGHT: "Move right",
    ZOOMIN: "Zoom in",
    ZOOMOUT: "Zoom out",
    TOGGLEZOOM: "Toggle zoom level",
    TOGGLE1TO1: "Toggle zoom level",
    ITERATEZOOM: "Toggle zoom level",
    ROTATECCW: "Rotate counterclockwise",
    ROTATECW: "Rotate clockwise",
    FLIPX: "Flip horizontally",
    FLIPY: "Flip vertically",
    FITX: "Fit horizontally",
    FITY: "Fit vertically",
    RESET: "Reset",
    TOGGLEFS: "Toggle fullscreen"
}, $6cce3a502c50d5fc$var$y = {
    content: null,
    width: "auto",
    height: "auto",
    panMode: "drag",
    touch: !0,
    dragMinThreshold: 3,
    lockAxis: !1,
    mouseMoveFactor: 1,
    mouseMoveFriction: .12,
    zoom: !0,
    pinchToZoom: !0,
    panOnlyZoomed: "auto",
    minScale: 1,
    maxScale: 2,
    friction: .25,
    dragFriction: .35,
    decelFriction: .05,
    click: "toggleZoom",
    dblClick: !1,
    wheel: "zoom",
    wheelLimit: 7,
    spinner: !0,
    bounds: "auto",
    infinite: !1,
    rubberband: !0,
    bounce: !0,
    maxVelocity: 75,
    transformParent: !1,
    classes: {
        content: "f-panzoom__content",
        isLoading: "is-loading",
        canZoomIn: "can-zoom_in",
        canZoomOut: "can-zoom_out",
        isDraggable: "is-draggable",
        isDragging: "is-dragging",
        inFullscreen: "in-fullscreen",
        htmlHasFullscreen: "with-panzoom-in-fullscreen"
    },
    l10n: $6cce3a502c50d5fc$var$b
}, $6cce3a502c50d5fc$var$w = '<circle cx="25" cy="25" r="20"></circle>', $6cce3a502c50d5fc$var$x = '<div class="f-spinner"><svg viewBox="0 0 50 50">' + $6cce3a502c50d5fc$var$w + $6cce3a502c50d5fc$var$w + "</svg></div>", $6cce3a502c50d5fc$var$E = (t)=>t && null !== t && t instanceof Element && "nodeType" in t, $6cce3a502c50d5fc$var$S = (t, e)=>{
    t && $6cce3a502c50d5fc$var$s(e).forEach((e)=>{
        t.classList.remove(e);
    });
}, $6cce3a502c50d5fc$var$P = (t, e)=>{
    t && $6cce3a502c50d5fc$var$s(e).forEach((e)=>{
        t.classList.add(e);
    });
}, $6cce3a502c50d5fc$var$C = {
    a: 1,
    b: 0,
    c: 0,
    d: 1,
    e: 0,
    f: 0
}, $6cce3a502c50d5fc$var$T = 1e5, $6cce3a502c50d5fc$var$M = 1e4, $6cce3a502c50d5fc$var$O = "mousemove", $6cce3a502c50d5fc$var$A = "drag", $6cce3a502c50d5fc$var$L = "content", $6cce3a502c50d5fc$var$z = "auto";
let $6cce3a502c50d5fc$var$R = null, $6cce3a502c50d5fc$var$k = null;
class $6cce3a502c50d5fc$export$b704d075ddd20210 extends $6cce3a502c50d5fc$var$g {
    get fits() {
        return this.contentRect.width - this.contentRect.fitWidth < 1 && this.contentRect.height - this.contentRect.fitHeight < 1;
    }
    get isTouchDevice() {
        return null === $6cce3a502c50d5fc$var$k && ($6cce3a502c50d5fc$var$k = window.matchMedia("(hover: none)").matches), $6cce3a502c50d5fc$var$k;
    }
    get isMobile() {
        return null === $6cce3a502c50d5fc$var$R && ($6cce3a502c50d5fc$var$R = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)), $6cce3a502c50d5fc$var$R;
    }
    get panMode() {
        return this.options.panMode !== $6cce3a502c50d5fc$var$O || this.isTouchDevice ? $6cce3a502c50d5fc$var$A : $6cce3a502c50d5fc$var$O;
    }
    get panOnlyZoomed() {
        const t = this.options.panOnlyZoomed;
        return t === $6cce3a502c50d5fc$var$z ? this.isTouchDevice : t;
    }
    get isInfinite() {
        return this.option("infinite");
    }
    get angle() {
        return 180 * Math.atan2(this.current.b, this.current.a) / Math.PI || 0;
    }
    get targetAngle() {
        return 180 * Math.atan2(this.target.b, this.target.a) / Math.PI || 0;
    }
    get scale() {
        const { a: t, b: e } = this.current;
        return Math.sqrt(t * t + e * e) || 1;
    }
    get targetScale() {
        const { a: t, b: e } = this.target;
        return Math.sqrt(t * t + e * e) || 1;
    }
    get minScale() {
        return this.option("minScale") || 1;
    }
    get fullScale() {
        const { contentRect: t } = this;
        return t.fullWidth / t.fitWidth || 1;
    }
    get maxScale() {
        return this.fullScale * (this.option("maxScale") || 1) || 1;
    }
    get coverScale() {
        const { containerRect: t, contentRect: e } = this, i = Math.max(t.height / e.fitHeight, t.width / e.fitWidth) || 1;
        return Math.min(this.fullScale, i);
    }
    get isScaling() {
        return Math.abs(this.targetScale - this.scale) > 1e-5 && !this.isResting;
    }
    get isContentLoading() {
        const t = this.content;
        return !!(t && t instanceof HTMLImageElement) && !t.complete;
    }
    get isResting() {
        if (this.isBouncingX || this.isBouncingY) return !1;
        for (const t of $6cce3a502c50d5fc$var$v){
            const e = "e" == t || "f" === t ? 1e-4 : 1e-5;
            if (Math.abs(this.target[t] - this.current[t]) > e) return !1;
        }
        return !(!this.ignoreBounds && !this.checkBounds().inBounds);
    }
    constructor(t, e = {}, i = {}){
        var s;
        if (super(e), Object.defineProperty(this, "pointerTracker", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "resizeObserver", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "updateTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "clickTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "rAF", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "isTicking", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "ignoreBounds", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "isBouncingX", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "isBouncingY", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "clicks", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "trackingPoints", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "pwt", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "cwd", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "pmme", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "friction", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $6cce3a502c50d5fc$var$m.Init
        }), Object.defineProperty(this, "isDragging", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "content", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "spinner", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "containerRect", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                width: 0,
                height: 0,
                innerWidth: 0,
                innerHeight: 0
            }
        }), Object.defineProperty(this, "contentRect", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                fullWidth: 0,
                fullHeight: 0,
                fitWidth: 0,
                fitHeight: 0,
                width: 0,
                height: 0
            }
        }), Object.defineProperty(this, "dragStart", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                x: 0,
                y: 0,
                top: 0,
                left: 0,
                time: 0
            }
        }), Object.defineProperty(this, "dragOffset", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                x: 0,
                y: 0,
                time: 0
            }
        }), Object.defineProperty(this, "current", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: Object.assign({}, $6cce3a502c50d5fc$var$C)
        }), Object.defineProperty(this, "target", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: Object.assign({}, $6cce3a502c50d5fc$var$C)
        }), Object.defineProperty(this, "velocity", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                a: 0,
                b: 0,
                c: 0,
                d: 0,
                e: 0,
                f: 0
            }
        }), Object.defineProperty(this, "lockedAxis", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), !t) throw new Error("Container Element Not Found");
        this.container = t, this.initContent(), this.attachPlugins(Object.assign(Object.assign({}, $6cce3a502c50d5fc$export$b704d075ddd20210.Plugins), i)), this.emit("attachPlugins"), this.emit("init");
        const o = this.content;
        if (o.addEventListener("load", this.onLoad), o.addEventListener("error", this.onError), this.isContentLoading) {
            if (this.option("spinner")) {
                t.classList.add(this.cn("isLoading"));
                const e = $6cce3a502c50d5fc$var$n($6cce3a502c50d5fc$var$x);
                !t.contains(o) || o.parentElement instanceof HTMLPictureElement ? this.spinner = t.appendChild(e) : this.spinner = (null === (s = o.parentElement) || void 0 === s ? void 0 : s.insertBefore(e, o)) || null;
            }
            this.emit("beforeLoad");
        } else queueMicrotask(()=>{
            this.enable();
        });
    }
    initContent() {
        const { container: t } = this, e = this.cn($6cce3a502c50d5fc$var$L);
        let i = this.option($6cce3a502c50d5fc$var$L) || t.querySelector(`.${e}`);
        if (i || (i = t.querySelector("img,picture") || t.firstElementChild, i && $6cce3a502c50d5fc$var$P(i, e)), i instanceof HTMLPictureElement && (i = i.querySelector("img")), !i) throw new Error("No content found");
        this.content = i;
    }
    onLoad() {
        const { spinner: t, container: e, state: i } = this;
        t && (t.remove(), this.spinner = null), this.option("spinner") && e.classList.remove(this.cn("isLoading")), this.emit("afterLoad"), i === $6cce3a502c50d5fc$var$m.Init ? this.enable() : this.updateMetrics();
    }
    onError() {
        this.state !== $6cce3a502c50d5fc$var$m.Destroy && (this.spinner && (this.spinner.remove(), this.spinner = null), this.stop(), this.detachEvents(), this.state = $6cce3a502c50d5fc$var$m.Error, this.emit("error"));
    }
    getNextScale(t) {
        const { fullScale: e, targetScale: i, coverScale: n, maxScale: s, minScale: o } = this;
        let a = o;
        switch(t){
            case "toggleMax":
                a = i - o < .5 * (s - o) ? s : o;
                break;
            case "toggleCover":
                a = i - o < .5 * (n - o) ? n : o;
                break;
            case "toggleZoom":
                a = i - o < .5 * (e - o) ? e : o;
                break;
            case "iterateZoom":
                let t1 = [
                    1,
                    e,
                    s
                ].sort((t, e)=>t - e), r = t1.findIndex((t)=>t > i + 1e-5);
                a = t1[r] || 1;
        }
        return a;
    }
    attachObserver() {
        var t;
        const e = ()=>{
            const { container: t, containerRect: e } = this;
            return Math.abs(e.width - t.getBoundingClientRect().width) > .1 || Math.abs(e.height - t.getBoundingClientRect().height) > .1;
        };
        this.resizeObserver || void 0 === window.ResizeObserver || (this.resizeObserver = new ResizeObserver(()=>{
            this.updateTimer || (e() ? (this.onResize(), this.isMobile && (this.updateTimer = setTimeout(()=>{
                e() && this.onResize(), this.updateTimer = null;
            }, 500))) : this.updateTimer && (clearTimeout(this.updateTimer), this.updateTimer = null));
        })), null === (t = this.resizeObserver) || void 0 === t || t.observe(this.container);
    }
    detachObserver() {
        var t;
        null === (t = this.resizeObserver) || void 0 === t || t.disconnect();
    }
    attachEvents() {
        const { container: t } = this;
        t.addEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), t.addEventListener("wheel", this.onWheel, {
            passive: !1
        }), this.pointerTracker = new $6cce3a502c50d5fc$var$l(t, {
            start: this.onPointerDown,
            move: this.onPointerMove,
            end: this.onPointerUp
        }), document.addEventListener($6cce3a502c50d5fc$var$O, this.onMouseMove);
    }
    detachEvents() {
        var t;
        const { container: e } = this;
        e.removeEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), e.removeEventListener("wheel", this.onWheel, {
            passive: !1
        }), null === (t = this.pointerTracker) || void 0 === t || t.stop(), this.pointerTracker = null, document.removeEventListener($6cce3a502c50d5fc$var$O, this.onMouseMove), document.removeEventListener("keydown", this.onKeydown, !0), this.clickTimer && (clearTimeout(this.clickTimer), this.clickTimer = null), this.updateTimer && (clearTimeout(this.updateTimer), this.updateTimer = null);
    }
    animate() {
        this.setTargetForce();
        const t = this.friction, e = this.option("maxVelocity");
        for (const i of $6cce3a502c50d5fc$var$v)t ? (this.velocity[i] *= 1 - t, e && !this.isScaling && (this.velocity[i] = Math.max(Math.min(this.velocity[i], e), -1 * e)), this.current[i] += this.velocity[i]) : this.current[i] = this.target[i];
        this.setTransform(), this.setEdgeForce(), !this.isResting || this.isDragging ? this.rAF = requestAnimationFrame(()=>this.animate()) : this.stop("current");
    }
    setTargetForce() {
        for (const t of $6cce3a502c50d5fc$var$v)"e" === t && this.isBouncingX || "f" === t && this.isBouncingY || (this.velocity[t] = (1 / (1 - this.friction) - 1) * (this.target[t] - this.current[t]));
    }
    checkBounds(t = 0, e = 0) {
        const { current: i } = this, n = i.e + t, s = i.f + e, o = this.getBounds(), { x: a, y: r } = o, l = a.min, c = a.max, h = r.min, d = r.max;
        let u = 0, p = 0;
        return l !== 1 / 0 && n < l ? u = l - n : c !== 1 / 0 && n > c && (u = c - n), h !== 1 / 0 && s < h ? p = h - s : d !== 1 / 0 && s > d && (p = d - s), Math.abs(u) < 1e-4 && (u = 0), Math.abs(p) < 1e-4 && (p = 0), Object.assign(Object.assign({}, o), {
            xDiff: u,
            yDiff: p,
            inBounds: !u && !p
        });
    }
    clampTargetBounds() {
        const { target: t } = this, { x: e, y: i } = this.getBounds();
        e.min !== 1 / 0 && (t.e = Math.max(t.e, e.min)), e.max !== 1 / 0 && (t.e = Math.min(t.e, e.max)), i.min !== 1 / 0 && (t.f = Math.max(t.f, i.min)), i.max !== 1 / 0 && (t.f = Math.min(t.f, i.max));
    }
    calculateContentDim(t = this.current) {
        const { content: e, contentRect: i } = this, { fitWidth: n, fitHeight: s, fullWidth: o, fullHeight: a } = i;
        let r = o, l = a;
        if (this.option("zoom") || 0 !== this.angle) {
            const i = !(e instanceof HTMLImageElement) && ("none" === window.getComputedStyle(e).maxWidth || "none" === window.getComputedStyle(e).maxHeight), c = i ? o : n, h = i ? a : s, d = this.getMatrix(t), u = new DOMPoint(0, 0).matrixTransform(d), p = new DOMPoint(0 + c, 0).matrixTransform(d), f = new DOMPoint(0 + c, 0 + h).matrixTransform(d), g = new DOMPoint(0, 0 + h).matrixTransform(d), m = Math.abs(f.x - u.x), v = Math.abs(f.y - u.y), b = Math.abs(g.x - p.x), y = Math.abs(g.y - p.y);
            r = Math.max(m, b), l = Math.max(v, y);
        }
        return {
            contentWidth: r,
            contentHeight: l
        };
    }
    setEdgeForce() {
        if (this.ignoreBounds || this.isDragging || this.panMode === $6cce3a502c50d5fc$var$O || this.targetScale < this.scale) return this.isBouncingX = !1, void (this.isBouncingY = !1);
        const { target: t } = this, { x: e, y: i, xDiff: n, yDiff: s } = this.checkBounds();
        const o = this.option("maxVelocity");
        let a = this.velocity.e, r = this.velocity.f;
        0 !== n ? (this.isBouncingX = !0, n * a <= 0 ? a += .14 * n : (a = .14 * n, e.min !== 1 / 0 && (this.target.e = Math.max(t.e, e.min)), e.max !== 1 / 0 && (this.target.e = Math.min(t.e, e.max))), o && (a = Math.max(Math.min(a, o), -1 * o))) : this.isBouncingX = !1, 0 !== s ? (this.isBouncingY = !0, s * r <= 0 ? r += .14 * s : (r = .14 * s, i.min !== 1 / 0 && (this.target.f = Math.max(t.f, i.min)), i.max !== 1 / 0 && (this.target.f = Math.min(t.f, i.max))), o && (r = Math.max(Math.min(r, o), -1 * o))) : this.isBouncingY = !1, this.isBouncingX && (this.velocity.e = a), this.isBouncingY && (this.velocity.f = r);
    }
    enable() {
        const { content: t } = this, e = new DOMMatrixReadOnly(window.getComputedStyle(t).transform);
        for (const t of $6cce3a502c50d5fc$var$v)this.current[t] = this.target[t] = e[t];
        this.updateMetrics(), this.attachObserver(), this.attachEvents(), this.state = $6cce3a502c50d5fc$var$m.Ready, this.emit("ready");
    }
    onClick(t) {
        var e;
        "click" === t.type && 0 === t.detail && (this.dragOffset.x = 0, this.dragOffset.y = 0), this.isDragging && (null === (e = this.pointerTracker) || void 0 === e || e.clear(), this.trackingPoints = [], this.startDecelAnim());
        const i = t.target;
        if (!i || t.defaultPrevented) return;
        if (i.hasAttribute("disabled")) return t.preventDefault(), void t.stopPropagation();
        if ((()=>{
            const t = window.getSelection();
            return t && "Range" === t.type;
        })() && !i.closest("button")) return;
        const n = i.closest("[data-panzoom-action]"), s = i.closest("[data-panzoom-change]"), o = n || s, a = o && $6cce3a502c50d5fc$var$E(o) ? o.dataset : null;
        if (a) {
            const e = a.panzoomChange, i = a.panzoomAction;
            if ((e || i) && t.preventDefault(), e) {
                let t = {};
                try {
                    t = JSON.parse(e);
                } catch (t) {
                    console && console.warn("The given data was not valid JSON");
                }
                return void this.applyChange(t);
            }
            if (i) return void (this[i] && this[i]());
        }
        if (Math.abs(this.dragOffset.x) > 3 || Math.abs(this.dragOffset.y) > 3) return t.preventDefault(), void t.stopPropagation();
        if (i.closest("[data-fancybox]")) return;
        const r = this.content.getBoundingClientRect(), l = this.dragStart;
        if (l.time && !this.canZoomOut() && (Math.abs(r.x - l.x) > 2 || Math.abs(r.y - l.y) > 2)) return;
        this.dragStart.time = 0;
        const c = (e)=>{
            this.option("zoom", t) && e && "string" == typeof e && /(iterateZoom)|(toggle(Zoom|Full|Cover|Max)|(zoomTo(Fit|Cover|Max)))/.test(e) && "function" == typeof this[e] && (t.preventDefault(), this[e]({
                event: t
            }));
        }, h = this.option("click", t), d = this.option("dblClick", t);
        d ? (this.clicks++, 1 == this.clicks && (this.clickTimer = setTimeout(()=>{
            1 === this.clicks ? (this.emit("click", t), !t.defaultPrevented && h && c(h)) : (this.emit("dblClick", t), t.defaultPrevented || c(d)), this.clicks = 0, this.clickTimer = null;
        }, 350))) : (this.emit("click", t), !t.defaultPrevented && h && c(h));
    }
    addTrackingPoint(t) {
        const e = this.trackingPoints.filter((t)=>t.time > Date.now() - 100);
        e.push(t), this.trackingPoints = e;
    }
    onPointerDown(t, e, i) {
        var n;
        if (!1 === this.option("touch", t)) return !1;
        this.pwt = 0, this.dragOffset = {
            x: 0,
            y: 0,
            time: 0
        }, this.trackingPoints = [];
        const s = this.content.getBoundingClientRect();
        if (this.dragStart = {
            x: s.x,
            y: s.y,
            top: s.top,
            left: s.left,
            time: Date.now()
        }, this.clickTimer) return !1;
        if (this.panMode === $6cce3a502c50d5fc$var$O && this.targetScale > 1) return t.preventDefault(), t.stopPropagation(), !1;
        const o = t.composedPath()[0];
        if (!i.length) {
            if ([
                "TEXTAREA",
                "OPTION",
                "INPUT",
                "SELECT",
                "VIDEO",
                "IFRAME"
            ].includes(o.nodeName) || o.closest("[contenteditable],[data-selectable],[data-draggable],[data-clickable],[data-panzoom-change],[data-panzoom-action]")) return !1;
            null === (n = window.getSelection()) || void 0 === n || n.removeAllRanges();
        }
        if ("mousedown" === t.type) [
            "A",
            "BUTTON"
        ].includes(o.nodeName) || t.preventDefault();
        else if (Math.abs(this.velocity.a) > .3) return !1;
        return this.target.e = this.current.e, this.target.f = this.current.f, this.stop(), this.isDragging || (this.isDragging = !0, this.addTrackingPoint(e), this.emit("touchStart", t)), !0;
    }
    onPointerMove(e, n, s) {
        if (!1 === this.option("touch", e)) return;
        if (!this.isDragging) return;
        if (n.length < 2 && this.panOnlyZoomed && $6cce3a502c50d5fc$var$t(this.targetScale) <= $6cce3a502c50d5fc$var$t(this.minScale)) return;
        if (this.emit("touchMove", e), e.defaultPrevented) return;
        this.addTrackingPoint(n[0]);
        const { content: o } = this, a = $6cce3a502c50d5fc$var$h(s[0], s[1]), r = $6cce3a502c50d5fc$var$h(n[0], n[1]);
        let l = 0, d = 0;
        if (n.length > 1) {
            const t = o.getBoundingClientRect();
            l = a.clientX - t.left - .5 * t.width, d = a.clientY - t.top - .5 * t.height;
        }
        const u = $6cce3a502c50d5fc$var$c(s[0], s[1]), p = $6cce3a502c50d5fc$var$c(n[0], n[1]);
        let f = u ? p / u : 1, g = r.clientX - a.clientX, m = r.clientY - a.clientY;
        this.dragOffset.x += g, this.dragOffset.y += m, this.dragOffset.time = Date.now() - this.dragStart.time;
        let v = $6cce3a502c50d5fc$var$t(this.targetScale) === $6cce3a502c50d5fc$var$t(this.minScale) && this.option("lockAxis");
        if (v && !this.lockedAxis) {
            if ("xy" === v || "y" === v || "touchmove" === e.type) {
                if (Math.abs(this.dragOffset.x) < 6 && Math.abs(this.dragOffset.y) < 6) return void e.preventDefault();
                const t = Math.abs(180 * Math.atan2(this.dragOffset.y, this.dragOffset.x) / Math.PI);
                this.lockedAxis = t > 45 && t < 135 ? "y" : "x", this.dragOffset.x = 0, this.dragOffset.y = 0, g = 0, m = 0;
            } else this.lockedAxis = v;
        }
        if ($6cce3a502c50d5fc$var$i(e.target, this.content) && (v = "x", this.dragOffset.y = 0), v && "xy" !== v && this.lockedAxis !== v && $6cce3a502c50d5fc$var$t(this.targetScale) === $6cce3a502c50d5fc$var$t(this.minScale)) return;
        e.cancelable && e.preventDefault(), this.container.classList.add(this.cn("isDragging"));
        const b = this.checkBounds(g, m);
        this.option("rubberband") ? ("x" !== this.isInfinite && (b.xDiff > 0 && g < 0 || b.xDiff < 0 && g > 0) && (g *= Math.max(0, .5 - Math.abs(.75 / this.contentRect.fitWidth * b.xDiff))), "y" !== this.isInfinite && (b.yDiff > 0 && m < 0 || b.yDiff < 0 && m > 0) && (m *= Math.max(0, .5 - Math.abs(.75 / this.contentRect.fitHeight * b.yDiff)))) : (b.xDiff && (g = 0), b.yDiff && (m = 0));
        const y = this.targetScale, w = this.minScale, x = this.maxScale;
        y < .5 * w && (f = Math.max(f, w)), y > 1.5 * x && (f = Math.min(f, x)), "y" === this.lockedAxis && $6cce3a502c50d5fc$var$t(y) === $6cce3a502c50d5fc$var$t(w) && (g = 0), "x" === this.lockedAxis && $6cce3a502c50d5fc$var$t(y) === $6cce3a502c50d5fc$var$t(w) && (m = 0), this.applyChange({
            originX: l,
            originY: d,
            panX: g,
            panY: m,
            scale: f,
            friction: this.option("dragFriction"),
            ignoreBounds: !0
        });
    }
    onPointerUp(t, e, n) {
        if (n.length) return this.dragOffset.x = 0, this.dragOffset.y = 0, void (this.trackingPoints = []);
        this.container.classList.remove(this.cn("isDragging")), this.isDragging && (this.addTrackingPoint(e), this.panOnlyZoomed && this.contentRect.width - this.contentRect.fitWidth < 1 && this.contentRect.height - this.contentRect.fitHeight < 1 && (this.trackingPoints = []), $6cce3a502c50d5fc$var$i(t.target, this.content) && "y" === this.lockedAxis && (this.trackingPoints = []), this.emit("touchEnd", t), this.isDragging = !1, this.lockedAxis = !1, this.state !== $6cce3a502c50d5fc$var$m.Destroy && (t.defaultPrevented || this.startDecelAnim()));
    }
    startDecelAnim() {
        var e;
        const i = this.isScaling;
        this.rAF && (cancelAnimationFrame(this.rAF), this.rAF = null), this.isBouncingX = !1, this.isBouncingY = !1;
        for (const t of $6cce3a502c50d5fc$var$v)this.velocity[t] = 0;
        this.target.e = this.current.e, this.target.f = this.current.f, $6cce3a502c50d5fc$var$S(this.container, "is-scaling"), $6cce3a502c50d5fc$var$S(this.container, "is-animating"), this.isTicking = !1;
        const { trackingPoints: n } = this, s = n[0], o = n[n.length - 1];
        let a = 0, r = 0, l = 0;
        o && s && (a = o.clientX - s.clientX, r = o.clientY - s.clientY, l = o.time - s.time);
        const c = (null === (e = window.visualViewport) || void 0 === e ? void 0 : e.scale) || 1;
        1 !== c && (a *= c, r *= c);
        let h = 0, d = 0, u = 0, p = 0, f = this.option("decelFriction");
        const g = this.targetScale;
        if (l > 0) {
            u = Math.abs(a) > 3 ? a / (l / 30) : 0, p = Math.abs(r) > 3 ? r / (l / 30) : 0;
            const t = this.option("maxVelocity");
            t && (u = Math.max(Math.min(u, t), -1 * t), p = Math.max(Math.min(p, t), -1 * t));
        }
        u && (h = u / (1 / (1 - f) - 1)), p && (d = p / (1 / (1 - f) - 1)), ("y" === this.option("lockAxis") || "xy" === this.option("lockAxis") && "y" === this.lockedAxis && $6cce3a502c50d5fc$var$t(g) === this.minScale) && (h = u = 0), ("x" === this.option("lockAxis") || "xy" === this.option("lockAxis") && "x" === this.lockedAxis && $6cce3a502c50d5fc$var$t(g) === this.minScale) && (d = p = 0);
        const m = this.dragOffset.x, b = this.dragOffset.y, y = this.option("dragMinThreshold") || 0;
        Math.abs(m) < y && Math.abs(b) < y && (h = d = 0, u = p = 0), (this.option("zoom") && (g < this.minScale - 1e-5 || g > this.maxScale + 1e-5) || i && !h && !d) && (f = .35), this.applyChange({
            panX: h,
            panY: d,
            friction: f
        }), this.emit("decel", u, p, m, b);
    }
    onWheel(t) {
        var e = [
            -t.deltaX || 0,
            -t.deltaY || 0,
            -t.detail || 0
        ].reduce(function(t, e) {
            return Math.abs(e) > Math.abs(t) ? e : t;
        });
        const i = Math.max(-1, Math.min(1, e));
        if (this.emit("wheel", t, i), this.panMode === $6cce3a502c50d5fc$var$O) return;
        if (t.defaultPrevented) return;
        const n = this.option("wheel");
        "pan" === n ? (t.preventDefault(), this.panOnlyZoomed && !this.canZoomOut() || this.applyChange({
            panX: 2 * -t.deltaX,
            panY: 2 * -t.deltaY,
            bounce: !1
        })) : "zoom" === n && !1 !== this.option("zoom") && this.zoomWithWheel(t);
    }
    onMouseMove(t) {
        this.panWithMouse(t);
    }
    onKeydown(t) {
        "Escape" === t.key && this.toggleFS();
    }
    onResize() {
        this.updateMetrics(), this.checkBounds().inBounds || this.requestTick();
    }
    setTransform() {
        this.emit("beforeTransform");
        const { current: e, target: i, content: n, contentRect: s } = this, o = Object.assign({}, $6cce3a502c50d5fc$var$C);
        for (const n of $6cce3a502c50d5fc$var$v){
            const s = "e" == n || "f" === n ? $6cce3a502c50d5fc$var$M : $6cce3a502c50d5fc$var$T;
            o[n] = $6cce3a502c50d5fc$var$t(e[n], s), Math.abs(i[n] - e[n]) < ("e" == n || "f" === n ? .51 : .001) && (e[n] = i[n]);
        }
        let { a: a, b: r, c: l, d: c, e: h, f: d } = o, u = `matrix(${a}, ${r}, ${l}, ${c}, ${h}, ${d})`, p = n.parentElement instanceof HTMLPictureElement ? n.parentElement : n;
        if (this.option("transformParent") && (p = p.parentElement || p), p.style.transform === u) return;
        p.style.transform = u;
        const { contentWidth: f, contentHeight: g } = this.calculateContentDim();
        s.width = f, s.height = g, this.emit("afterTransform");
    }
    updateMetrics(e = !1) {
        var i;
        if (!this || this.state === $6cce3a502c50d5fc$var$m.Destroy) return;
        if (this.isContentLoading) return;
        const n = Math.max(1, (null === (i = window.visualViewport) || void 0 === i ? void 0 : i.scale) || 1), { container: s, content: o } = this, a = o instanceof HTMLImageElement, r = s.getBoundingClientRect(), l = getComputedStyle(this.container);
        let c = r.width * n, h = r.height * n;
        const d = parseFloat(l.paddingTop) + parseFloat(l.paddingBottom), u = c - (parseFloat(l.paddingLeft) + parseFloat(l.paddingRight)), p = h - d;
        this.containerRect = {
            width: c,
            height: h,
            innerWidth: u,
            innerHeight: p
        };
        const f = parseFloat(o.dataset.width || "") || ((t)=>{
            let e = 0;
            return e = t instanceof HTMLImageElement ? t.naturalWidth : t instanceof SVGElement ? t.width.baseVal.value : Math.max(t.offsetWidth, t.scrollWidth), e || 0;
        })(o), g = parseFloat(o.dataset.height || "") || ((t)=>{
            let e = 0;
            return e = t instanceof HTMLImageElement ? t.naturalHeight : t instanceof SVGElement ? t.height.baseVal.value : Math.max(t.offsetHeight, t.scrollHeight), e || 0;
        })(o);
        let v = this.option("width", f) || $6cce3a502c50d5fc$var$z, b = this.option("height", g) || $6cce3a502c50d5fc$var$z;
        const y = v === $6cce3a502c50d5fc$var$z, w = b === $6cce3a502c50d5fc$var$z;
        "number" != typeof v && (v = f), "number" != typeof b && (b = g), y && (v = f * (b / g)), w && (b = g / (f / v));
        let x = o.parentElement instanceof HTMLPictureElement ? o.parentElement : o;
        this.option("transformParent") && (x = x.parentElement || x);
        const E = x.getAttribute("style") || "";
        x.style.setProperty("transform", "none", "important"), a && (x.style.width = "", x.style.height = ""), x.offsetHeight;
        const S = o.getBoundingClientRect();
        let P = S.width * n, C = S.height * n, T = P, M = C;
        P = Math.min(P, v), C = Math.min(C, b), a ? { width: P, height: C } = ((t, e, i, n)=>{
            const s = i / t, o = n / e, a = Math.min(s, o);
            return {
                width: t *= a,
                height: e *= a
            };
        })(v, b, P, C) : (P = Math.min(P, v), C = Math.min(C, b));
        let O = .5 * (M - C), A = .5 * (T - P);
        this.contentRect = Object.assign(Object.assign({}, this.contentRect), {
            top: S.top - r.top + O,
            bottom: r.bottom - S.bottom + O,
            left: S.left - r.left + A,
            right: r.right - S.right + A,
            fitWidth: P,
            fitHeight: C,
            width: P,
            height: C,
            fullWidth: v,
            fullHeight: b
        }), x.style.cssText = E, a && (x.style.width = `${P}px`, x.style.height = `${C}px`), this.setTransform(), !0 !== e && this.emit("refresh"), this.ignoreBounds || ($6cce3a502c50d5fc$var$t(this.targetScale) < $6cce3a502c50d5fc$var$t(this.minScale) ? this.zoomTo(this.minScale, {
            friction: 0
        }) : this.targetScale > this.maxScale ? this.zoomTo(this.maxScale, {
            friction: 0
        }) : this.state === $6cce3a502c50d5fc$var$m.Init || this.checkBounds().inBounds || this.requestTick()), this.updateControls();
    }
    calculateBounds() {
        const { contentWidth: e, contentHeight: i } = this.calculateContentDim(this.target), { targetScale: n, lockedAxis: s } = this, { fitWidth: o, fitHeight: a } = this.contentRect;
        let r = 0, l = 0, c = 0, h = 0;
        const d = this.option("infinite");
        if (!0 === d || s && d === s) r = -1 / 0, c = 1 / 0, l = -1 / 0, h = 1 / 0;
        else {
            let { containerRect: s, contentRect: d } = this, u = $6cce3a502c50d5fc$var$t(o * n, $6cce3a502c50d5fc$var$M), p = $6cce3a502c50d5fc$var$t(a * n, $6cce3a502c50d5fc$var$M), { innerWidth: f, innerHeight: g } = s;
            if (s.width === u && (f = s.width), s.width === p && (g = s.height), e > f) {
                c = .5 * (e - f), r = -1 * c;
                let t = .5 * (d.right - d.left);
                r += t, c += t;
            }
            if (o > f && e < f && (r -= .5 * (o - f), c -= .5 * (o - f)), i > g) {
                h = .5 * (i - g), l = -1 * h;
                let t = .5 * (d.bottom - d.top);
                l += t, h += t;
            }
            a > g && i < g && (r -= .5 * (a - g), c -= .5 * (a - g));
        }
        return {
            x: {
                min: r,
                max: c
            },
            y: {
                min: l,
                max: h
            }
        };
    }
    getBounds() {
        const t = this.option("bounds");
        return t !== $6cce3a502c50d5fc$var$z ? t : this.calculateBounds();
    }
    updateControls() {
        const e = this, i = e.container, { panMode: n, contentRect: s, targetScale: a, minScale: r } = e;
        let l = r, c = e.option("click") || !1;
        c && (l = e.getNextScale(c));
        let h = e.canZoomIn(), d = e.canZoomOut(), u = n === $6cce3a502c50d5fc$var$A && !!this.option("touch"), p = d && u;
        if (u && ($6cce3a502c50d5fc$var$t(a) < $6cce3a502c50d5fc$var$t(r) && !this.panOnlyZoomed && (p = !0), ($6cce3a502c50d5fc$var$t(s.width, 1) > $6cce3a502c50d5fc$var$t(s.fitWidth, 1) || $6cce3a502c50d5fc$var$t(s.height, 1) > $6cce3a502c50d5fc$var$t(s.fitHeight, 1)) && (p = !0)), $6cce3a502c50d5fc$var$t(s.width * a, 1) < $6cce3a502c50d5fc$var$t(s.fitWidth, 1) && (p = !1), n === $6cce3a502c50d5fc$var$O && (p = !1), $6cce3a502c50d5fc$var$o(i, this.cn("isDraggable"), p), !this.option("zoom")) return;
        let f = h && $6cce3a502c50d5fc$var$t(l) > $6cce3a502c50d5fc$var$t(a), g = !f && !p && d && $6cce3a502c50d5fc$var$t(l) < $6cce3a502c50d5fc$var$t(a);
        $6cce3a502c50d5fc$var$o(i, this.cn("canZoomIn"), f), $6cce3a502c50d5fc$var$o(i, this.cn("canZoomOut"), g);
        for (const t of i.querySelectorAll("[data-panzoom-action]")){
            let e = !1, i = !1;
            switch(t.dataset.panzoomAction){
                case "zoomIn":
                    h ? e = !0 : i = !0;
                    break;
                case "zoomOut":
                    d ? e = !0 : i = !0;
                    break;
                case "toggleZoom":
                case "iterateZoom":
                    h || d ? e = !0 : i = !0;
                    const n = t.querySelector("g");
                    n && (n.style.display = h ? "" : "none");
            }
            e ? (t.removeAttribute("disabled"), t.removeAttribute("tabindex")) : i && (t.setAttribute("disabled", ""), t.setAttribute("tabindex", "-1"));
        }
    }
    panTo({ x: t = this.target.e, y: e = this.target.f, scale: i = this.targetScale, friction: n = this.option("friction"), angle: s = 0, originX: o = 0, originY: a = 0, flipX: r = !1, flipY: l = !1, ignoreBounds: c = !1 }) {
        this.state !== $6cce3a502c50d5fc$var$m.Destroy && this.applyChange({
            panX: t - this.target.e,
            panY: e - this.target.f,
            scale: i / this.targetScale,
            angle: s,
            originX: o,
            originY: a,
            friction: n,
            flipX: r,
            flipY: l,
            ignoreBounds: c
        });
    }
    applyChange({ panX: e = 0, panY: i = 0, scale: n = 1, angle: s = 0, originX: o = -this.current.e, originY: a = -this.current.f, friction: r = this.option("friction"), flipX: l = !1, flipY: c = !1, ignoreBounds: h = !1, bounce: d = this.option("bounce") }) {
        const u = this.state;
        if (u === $6cce3a502c50d5fc$var$m.Destroy) return;
        this.rAF && (cancelAnimationFrame(this.rAF), this.rAF = null), this.friction = r || 0, this.ignoreBounds = h;
        const { current: p } = this, f = p.e, g = p.f, b = this.getMatrix(this.target);
        let y = (new DOMMatrix).translate(f, g).translate(o, a).translate(e, i);
        if (this.option("zoom")) {
            if (!h) {
                const t = this.targetScale, e = this.minScale, i = this.maxScale;
                t * n < e && (n = e / t), t * n > i && (n = i / t);
            }
            y = y.scale(n);
        }
        y = y.translate(-o, -a).translate(-f, -g).multiply(b), s && (y = y.rotate(s)), l && (y = y.scale(-1, 1)), c && (y = y.scale(1, -1));
        for (const e of $6cce3a502c50d5fc$var$v)"e" !== e && "f" !== e && (y[e] > this.minScale + 1e-5 || y[e] < this.minScale - 1e-5) ? this.target[e] = y[e] : this.target[e] = $6cce3a502c50d5fc$var$t(y[e], $6cce3a502c50d5fc$var$M);
        (this.targetScale < this.scale || Math.abs(n - 1) > .1 || this.panMode === $6cce3a502c50d5fc$var$O || !1 === d) && !h && this.clampTargetBounds(), u === $6cce3a502c50d5fc$var$m.Init ? this.animate() : this.isResting || (this.state = $6cce3a502c50d5fc$var$m.Panning, this.requestTick());
    }
    stop(t = !1) {
        if (this.state === $6cce3a502c50d5fc$var$m.Init || this.state === $6cce3a502c50d5fc$var$m.Destroy) return;
        const e = this.isTicking;
        this.rAF && (cancelAnimationFrame(this.rAF), this.rAF = null), this.isBouncingX = !1, this.isBouncingY = !1;
        for (const e of $6cce3a502c50d5fc$var$v)this.velocity[e] = 0, "current" === t ? this.current[e] = this.target[e] : "target" === t && (this.target[e] = this.current[e]);
        this.setTransform(), $6cce3a502c50d5fc$var$S(this.container, "is-scaling"), $6cce3a502c50d5fc$var$S(this.container, "is-animating"), this.isTicking = !1, this.state = $6cce3a502c50d5fc$var$m.Ready, e && (this.emit("endAnimation"), this.updateControls());
    }
    requestTick() {
        this.isTicking || (this.emit("startAnimation"), this.updateControls(), $6cce3a502c50d5fc$var$P(this.container, "is-animating"), this.isScaling && $6cce3a502c50d5fc$var$P(this.container, "is-scaling")), this.isTicking = !0, this.rAF || (this.rAF = requestAnimationFrame(()=>this.animate()));
    }
    panWithMouse(e, i = this.option("mouseMoveFriction")) {
        if (this.pmme = e, this.panMode !== $6cce3a502c50d5fc$var$O || !e) return;
        if ($6cce3a502c50d5fc$var$t(this.targetScale) <= $6cce3a502c50d5fc$var$t(this.minScale)) return;
        this.emit("mouseMove", e);
        const { container: n, containerRect: s, contentRect: o } = this, a = s.width, r = s.height, l = n.getBoundingClientRect(), c = (e.clientX || 0) - l.left, h = (e.clientY || 0) - l.top;
        let { contentWidth: d, contentHeight: u } = this.calculateContentDim(this.target);
        const p = this.option("mouseMoveFactor");
        p > 1 && (d !== a && (d *= p), u !== r && (u *= p));
        let f = .5 * (d - a) - c / a * 100 / 100 * (d - a);
        f += .5 * (o.right - o.left);
        let g = .5 * (u - r) - h / r * 100 / 100 * (u - r);
        g += .5 * (o.bottom - o.top), this.applyChange({
            panX: f - this.target.e,
            panY: g - this.target.f,
            friction: i
        });
    }
    zoomWithWheel(e) {
        if (this.state === $6cce3a502c50d5fc$var$m.Destroy || this.state === $6cce3a502c50d5fc$var$m.Init) return;
        const i = Date.now();
        if (i - this.pwt < 45) return void e.preventDefault();
        this.pwt = i;
        var n = [
            -e.deltaX || 0,
            -e.deltaY || 0,
            -e.detail || 0
        ].reduce(function(t, e) {
            return Math.abs(e) > Math.abs(t) ? e : t;
        });
        const s = Math.max(-1, Math.min(1, n)), { targetScale: o, maxScale: a, minScale: r } = this;
        let l = o * (100 + 45 * s) / 100;
        $6cce3a502c50d5fc$var$t(l) < $6cce3a502c50d5fc$var$t(r) && $6cce3a502c50d5fc$var$t(o) <= $6cce3a502c50d5fc$var$t(r) ? (this.cwd += Math.abs(s), l = r) : $6cce3a502c50d5fc$var$t(l) > $6cce3a502c50d5fc$var$t(a) && $6cce3a502c50d5fc$var$t(o) >= $6cce3a502c50d5fc$var$t(a) ? (this.cwd += Math.abs(s), l = a) : (this.cwd = 0, l = Math.max(Math.min(l, a), r)), this.cwd > this.option("wheelLimit") || (e.preventDefault(), $6cce3a502c50d5fc$var$t(l) !== $6cce3a502c50d5fc$var$t(o) && this.zoomTo(l, {
            event: e
        }));
    }
    canZoomIn() {
        return this.option("zoom") && ($6cce3a502c50d5fc$var$t(this.contentRect.width, 1) < $6cce3a502c50d5fc$var$t(this.contentRect.fitWidth, 1) || $6cce3a502c50d5fc$var$t(this.targetScale) < $6cce3a502c50d5fc$var$t(this.maxScale));
    }
    canZoomOut() {
        return this.option("zoom") && $6cce3a502c50d5fc$var$t(this.targetScale) > $6cce3a502c50d5fc$var$t(this.minScale);
    }
    zoomIn(t = 1.25, e) {
        this.zoomTo(this.targetScale * t, e);
    }
    zoomOut(t = .8, e) {
        this.zoomTo(this.targetScale * t, e);
    }
    zoomToFit(t) {
        this.zoomTo("fit", t);
    }
    zoomToCover(t) {
        this.zoomTo("cover", t);
    }
    zoomToFull(t) {
        this.zoomTo("full", t);
    }
    zoomToMax(t) {
        this.zoomTo("max", t);
    }
    toggleZoom(t) {
        this.zoomTo(this.getNextScale("toggleZoom"), t);
    }
    toggleMax(t) {
        this.zoomTo(this.getNextScale("toggleMax"), t);
    }
    toggleCover(t) {
        this.zoomTo(this.getNextScale("toggleCover"), t);
    }
    iterateZoom(t) {
        this.zoomTo("next", t);
    }
    zoomTo(t = 1, { friction: e = $6cce3a502c50d5fc$var$z, originX: i = $6cce3a502c50d5fc$var$z, originY: n = $6cce3a502c50d5fc$var$z, event: s } = {}) {
        if (this.isContentLoading || this.state === $6cce3a502c50d5fc$var$m.Destroy) return;
        const { targetScale: o, fullScale: a, maxScale: r, coverScale: l } = this;
        if (this.stop(), this.panMode === $6cce3a502c50d5fc$var$O && (s = this.pmme || s), s || i === $6cce3a502c50d5fc$var$z || n === $6cce3a502c50d5fc$var$z) {
            const t = this.content.getBoundingClientRect(), e = this.container.getBoundingClientRect(), o = s ? s.clientX : e.left + .5 * e.width, a = s ? s.clientY : e.top + .5 * e.height;
            i = o - t.left - .5 * t.width, n = a - t.top - .5 * t.height;
        }
        let c = 1;
        "number" == typeof t ? c = t : "full" === t ? c = a : "cover" === t ? c = l : "max" === t ? c = r : "fit" === t ? c = 1 : "next" === t && (c = this.getNextScale("iterateZoom")), c = c / o || 1, e = e === $6cce3a502c50d5fc$var$z ? c > 1 ? .15 : .25 : e, this.applyChange({
            scale: c,
            originX: i,
            originY: n,
            friction: e
        }), s && this.panMode === $6cce3a502c50d5fc$var$O && this.panWithMouse(s, e);
    }
    rotateCCW() {
        this.applyChange({
            angle: -90
        });
    }
    rotateCW() {
        this.applyChange({
            angle: 90
        });
    }
    flipX() {
        this.applyChange({
            flipX: !0
        });
    }
    flipY() {
        this.applyChange({
            flipY: !0
        });
    }
    fitX() {
        this.stop("target");
        const { containerRect: t, contentRect: e, target: i } = this;
        this.applyChange({
            panX: .5 * t.width - (e.left + .5 * e.fitWidth) - i.e,
            panY: .5 * t.height - (e.top + .5 * e.fitHeight) - i.f,
            scale: t.width / e.fitWidth / this.targetScale,
            originX: 0,
            originY: 0,
            ignoreBounds: !0
        });
    }
    fitY() {
        this.stop("target");
        const { containerRect: t, contentRect: e, target: i } = this;
        this.applyChange({
            panX: .5 * t.width - (e.left + .5 * e.fitWidth) - i.e,
            panY: .5 * t.innerHeight - (e.top + .5 * e.fitHeight) - i.f,
            scale: t.height / e.fitHeight / this.targetScale,
            originX: 0,
            originY: 0,
            ignoreBounds: !0
        });
    }
    toggleFS() {
        const { container: t } = this, e = this.cn("inFullscreen"), i = this.cn("htmlHasFullscreen");
        t.classList.toggle(e);
        const n = t.classList.contains(e);
        n ? (document.documentElement.classList.add(i), document.addEventListener("keydown", this.onKeydown, !0)) : (document.documentElement.classList.remove(i), document.removeEventListener("keydown", this.onKeydown, !0)), this.updateMetrics(), this.emit(n ? "enterFS" : "exitFS");
    }
    getMatrix(t = this.current) {
        const { a: e, b: i, c: n, d: s, e: o, f: a } = t;
        return new DOMMatrix([
            e,
            i,
            n,
            s,
            o,
            a
        ]);
    }
    reset(t) {
        if (this.state !== $6cce3a502c50d5fc$var$m.Init && this.state !== $6cce3a502c50d5fc$var$m.Destroy) {
            this.stop("current");
            for (const t of $6cce3a502c50d5fc$var$v)this.target[t] = $6cce3a502c50d5fc$var$C[t];
            this.target.a = this.minScale, this.target.d = this.minScale, this.clampTargetBounds(), this.isResting || (this.friction = void 0 === t ? this.option("friction") : t, this.state = $6cce3a502c50d5fc$var$m.Panning, this.requestTick());
        }
    }
    destroy() {
        this.stop(), this.state = $6cce3a502c50d5fc$var$m.Destroy, this.detachEvents(), this.detachObserver();
        const { container: t, content: e } = this, i = this.option("classes") || {};
        for (const e of Object.values(i))t.classList.remove(e + "");
        e && (e.removeEventListener("load", this.onLoad), e.removeEventListener("error", this.onError)), this.detachPlugins();
    }
}
Object.defineProperty($6cce3a502c50d5fc$export$b704d075ddd20210, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $6cce3a502c50d5fc$var$y
}), Object.defineProperty($6cce3a502c50d5fc$export$b704d075ddd20210, "Plugins", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {}
});
const $6cce3a502c50d5fc$var$D = function(t, e) {
    let i = !0;
    return (...n)=>{
        i && (i = !1, t(...n), setTimeout(()=>{
            i = !0;
        }, e));
    };
}, $6cce3a502c50d5fc$var$F = (t, e)=>{
    let i = [];
    return t.childNodes.forEach((t)=>{
        t.nodeType !== Node.ELEMENT_NODE || e && !t.matches(e) || i.push(t);
    }), i;
}, $6cce3a502c50d5fc$var$j = {
    viewport: null,
    track: null,
    enabled: !0,
    slides: [],
    axis: "x",
    transition: "fade",
    preload: 1,
    slidesPerPage: "auto",
    initialPage: 0,
    friction: .12,
    Panzoom: {
        decelFriction: .12
    },
    center: !0,
    infinite: !0,
    fill: !0,
    dragFree: !1,
    adaptiveHeight: !1,
    direction: "ltr",
    classes: {
        container: "f-carousel",
        viewport: "f-carousel__viewport",
        track: "f-carousel__track",
        slide: "f-carousel__slide",
        isLTR: "is-ltr",
        isRTL: "is-rtl",
        isHorizontal: "is-horizontal",
        isVertical: "is-vertical",
        inTransition: "in-transition",
        isSelected: "is-selected"
    },
    l10n: {
        NEXT: "Next slide",
        PREV: "Previous slide",
        GOTO: "Go to slide #%d"
    }
};
var $6cce3a502c50d5fc$var$B;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Destroy = 2] = "Destroy";
}($6cce3a502c50d5fc$var$B || ($6cce3a502c50d5fc$var$B = {}));
const $6cce3a502c50d5fc$var$H = (t)=>{
    if ("string" == typeof t || t instanceof HTMLElement) t = {
        html: t
    };
    else {
        const e = t.thumb;
        void 0 !== e && ("string" == typeof e && (t.thumbSrc = e), e instanceof HTMLImageElement && (t.thumbEl = e, t.thumbElSrc = e.src, t.thumbSrc = e.src), delete t.thumb);
    }
    return Object.assign({
        html: "",
        el: null,
        isDom: !1,
        class: "",
        customClass: "",
        index: -1,
        dim: 0,
        gap: 0,
        pos: 0,
        transition: !1
    }, t);
}, $6cce3a502c50d5fc$var$N = (t = {})=>Object.assign({
        index: -1,
        slides: [],
        dim: 0,
        pos: -1
    }, t);
class $6cce3a502c50d5fc$var$_ extends $6cce3a502c50d5fc$var$f {
    constructor(t, e){
        super(e), Object.defineProperty(this, "instance", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: t
        });
    }
    attach() {}
    detach() {}
}
const $6cce3a502c50d5fc$var$$ = {
    classes: {
        list: "f-carousel__dots",
        isDynamic: "is-dynamic",
        hasDots: "has-dots",
        dot: "f-carousel__dot",
        isBeforePrev: "is-before-prev",
        isPrev: "is-prev",
        isCurrent: "is-current",
        isNext: "is-next",
        isAfterNext: "is-after-next"
    },
    dotTpl: '<button type="button" data-carousel-page="%i" aria-label="{{GOTO}}"><span class="f-carousel__dot" aria-hidden="true"></span></button>',
    dynamicFrom: 11,
    maxCount: 1 / 0,
    minCount: 2
};
class $6cce3a502c50d5fc$var$W extends $6cce3a502c50d5fc$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "isDynamic", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "list", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    onRefresh() {
        this.refresh();
    }
    build() {
        let t = this.list;
        if (!t) {
            t = document.createElement("ul"), $6cce3a502c50d5fc$var$P(t, this.cn("list")), t.setAttribute("role", "tablist");
            const e = this.instance.container;
            e.appendChild(t), $6cce3a502c50d5fc$var$P(e, this.cn("hasDots")), this.list = t;
        }
        return t;
    }
    refresh() {
        var t;
        const e = this.instance.pages.length, i = Math.min(2, this.option("minCount")), n = Math.max(2e3, this.option("maxCount")), s = this.option("dynamicFrom");
        if (e < i || e > n) return void this.cleanup();
        const a = "number" == typeof s && e > 5 && e >= s, r = !this.list || this.isDynamic !== a || this.list.children.length !== e;
        r && this.cleanup();
        const l = this.build();
        if ($6cce3a502c50d5fc$var$o(l, this.cn("isDynamic"), !!a), r) for(let t = 0; t < e; t++)l.append(this.createItem(t));
        let c, h = 0;
        for (const e of [
            ...l.children
        ]){
            const i = h === this.instance.page;
            i && (c = e), $6cce3a502c50d5fc$var$o(e, this.cn("isCurrent"), i), null === (t = e.children[0]) || void 0 === t || t.setAttribute("aria-selected", i ? "true" : "false");
            for (const t of [
                "isBeforePrev",
                "isPrev",
                "isNext",
                "isAfterNext"
            ])$6cce3a502c50d5fc$var$S(e, this.cn(t));
            h++;
        }
        if (c = c || l.firstChild, a && c) {
            const t = c.previousElementSibling, e = t && t.previousElementSibling;
            $6cce3a502c50d5fc$var$P(t, this.cn("isPrev")), $6cce3a502c50d5fc$var$P(e, this.cn("isBeforePrev"));
            const i = c.nextElementSibling, n = i && i.nextElementSibling;
            $6cce3a502c50d5fc$var$P(i, this.cn("isNext")), $6cce3a502c50d5fc$var$P(n, this.cn("isAfterNext"));
        }
        this.isDynamic = a;
    }
    createItem(t = 0) {
        var e;
        const i = document.createElement("li");
        i.setAttribute("role", "presentation");
        const s = $6cce3a502c50d5fc$var$n(this.instance.localize(this.option("dotTpl"), [
            [
                "%d",
                t + 1
            ]
        ]).replace(/\%i/g, t + ""));
        return i.appendChild(s), null === (e = i.children[0]) || void 0 === e || e.setAttribute("role", "tab"), i;
    }
    cleanup() {
        this.list && (this.list.remove(), this.list = null), this.isDynamic = !1, $6cce3a502c50d5fc$var$S(this.instance.container, this.cn("hasDots"));
    }
    attach() {
        this.instance.on([
            "refresh",
            "change"
        ], this.onRefresh);
    }
    detach() {
        this.instance.off([
            "refresh",
            "change"
        ], this.onRefresh), this.cleanup();
    }
}
Object.defineProperty($6cce3a502c50d5fc$var$W, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $6cce3a502c50d5fc$var$$
});
const $6cce3a502c50d5fc$var$X = "disabled", $6cce3a502c50d5fc$var$q = "next", $6cce3a502c50d5fc$var$Y = "prev";
class $6cce3a502c50d5fc$var$V extends $6cce3a502c50d5fc$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "prev", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "next", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "isDom", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        });
    }
    onRefresh() {
        const t = this.instance, e = t.pages.length, i = t.page;
        if (e < 2) return void this.cleanup();
        this.build();
        let n = this.prev, s = this.next;
        n && s && (n.removeAttribute($6cce3a502c50d5fc$var$X), s.removeAttribute($6cce3a502c50d5fc$var$X), t.isInfinite || (i <= 0 && n.setAttribute($6cce3a502c50d5fc$var$X, ""), i >= e - 1 && s.setAttribute($6cce3a502c50d5fc$var$X, "")));
    }
    addBtn(t) {
        var e;
        const i = this.instance, n = document.createElement("button");
        n.setAttribute("tabindex", "0"), n.setAttribute("title", i.localize(`{{${t.toUpperCase()}}}`)), $6cce3a502c50d5fc$var$P(n, this.cn("button") + " " + this.cn(t === $6cce3a502c50d5fc$var$q ? "isNext" : "isPrev"));
        const s = i.isRTL ? t === $6cce3a502c50d5fc$var$q ? $6cce3a502c50d5fc$var$Y : $6cce3a502c50d5fc$var$q : t;
        var o;
        return n.innerHTML = i.localize(this.option(`${s}Tpl`)), n.dataset[`carousel${o = t, o ? o.match("^[a-z]") ? o.charAt(0).toUpperCase() + o.substring(1) : o : ""}`] = "true", null === (e = this.container) || void 0 === e || e.appendChild(n), n;
    }
    build() {
        const t = this.instance.container, e = this.cn("container");
        let { container: i, prev: n, next: s } = this;
        i || (i = t.querySelector("." + e), this.isDom = !!i), i || (i = document.createElement("div"), $6cce3a502c50d5fc$var$P(i, e), t.appendChild(i)), this.container = i, s || (s = i.querySelector("[data-carousel-next]")), s || (s = this.addBtn($6cce3a502c50d5fc$var$q)), this.next = s, n || (n = i.querySelector("[data-carousel-prev]")), n || (n = this.addBtn($6cce3a502c50d5fc$var$Y)), this.prev = n;
    }
    cleanup() {
        this.isDom || (this.prev && this.prev.remove(), this.next && this.next.remove(), this.container && this.container.remove()), this.prev = null, this.next = null, this.container = null, this.isDom = !1;
    }
    attach() {
        this.instance.on([
            "refresh",
            "change"
        ], this.onRefresh);
    }
    detach() {
        this.instance.off([
            "refresh",
            "change"
        ], this.onRefresh), this.cleanup();
    }
}
Object.defineProperty($6cce3a502c50d5fc$var$V, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        classes: {
            container: "f-carousel__nav",
            button: "f-button",
            isNext: "is-next",
            isPrev: "is-prev"
        },
        nextTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M9 3l9 9-9 9"/></svg>',
        prevTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M15 3l-9 9 9 9"/></svg>'
    }
});
class $6cce3a502c50d5fc$var$Z extends $6cce3a502c50d5fc$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "selectedIndex", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "target", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "nav", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    addAsTargetFor(t) {
        this.target = this.instance, this.nav = t, this.attachEvents();
    }
    addAsNavFor(t) {
        this.nav = this.instance, this.target = t, this.attachEvents();
    }
    attachEvents() {
        const { nav: t, target: e } = this;
        t && e && (t.options.initialSlide = e.options.initialPage, t.state === $6cce3a502c50d5fc$var$B.Ready ? this.onNavReady(t) : t.on("ready", this.onNavReady), e.state === $6cce3a502c50d5fc$var$B.Ready ? this.onTargetReady(e) : e.on("ready", this.onTargetReady));
    }
    onNavReady(t) {
        t.on("createSlide", this.onNavCreateSlide), t.on("Panzoom.click", this.onNavClick), t.on("Panzoom.touchEnd", this.onNavTouch), this.onTargetChange();
    }
    onTargetReady(t) {
        t.on("change", this.onTargetChange), t.on("Panzoom.refresh", this.onTargetChange), this.onTargetChange();
    }
    onNavClick(t, e, i) {
        this.onNavTouch(t, t.panzoom, i);
    }
    onNavTouch(t, e, i) {
        var n, s;
        if (Math.abs(e.dragOffset.x) > 3 || Math.abs(e.dragOffset.y) > 3) return;
        const o = i.target, { nav: a, target: r } = this;
        if (!a || !r || !o) return;
        const l = o.closest("[data-index]");
        if (i.stopPropagation(), i.preventDefault(), !l) return;
        const c = parseInt(l.dataset.index || "", 10) || 0, h = r.getPageForSlide(c), d = a.getPageForSlide(c);
        a.slideTo(d), r.slideTo(h, {
            friction: (null === (s = null === (n = this.nav) || void 0 === n ? void 0 : n.plugins) || void 0 === s ? void 0 : s.Sync.option("friction")) || 0
        }), this.markSelectedSlide(c);
    }
    onNavCreateSlide(t, e) {
        e.index === this.selectedIndex && this.markSelectedSlide(e.index);
    }
    onTargetChange() {
        var t, e;
        const { target: i, nav: n } = this;
        if (!i || !n) return;
        if (n.state !== $6cce3a502c50d5fc$var$B.Ready || i.state !== $6cce3a502c50d5fc$var$B.Ready) return;
        const s = null === (e = null === (t = i.pages[i.page]) || void 0 === t ? void 0 : t.slides[0]) || void 0 === e ? void 0 : e.index, o = n.getPageForSlide(s);
        this.markSelectedSlide(s), n.slideTo(o, null === n.prevPage && null === i.prevPage ? {
            friction: 0
        } : void 0);
    }
    markSelectedSlide(t) {
        const e = this.nav;
        e && e.state === $6cce3a502c50d5fc$var$B.Ready && (this.selectedIndex = t, [
            ...e.slides
        ].map((e)=>{
            e.el && e.el.classList[e.index === t ? "add" : "remove"]("is-nav-selected");
        }));
    }
    attach() {
        const t = this;
        let e = t.options.target, i = t.options.nav;
        e ? t.addAsNavFor(e) : i && t.addAsTargetFor(i);
    }
    detach() {
        const t = this, e = t.nav, i = t.target;
        e && (e.off("ready", t.onNavReady), e.off("createSlide", t.onNavCreateSlide), e.off("Panzoom.click", t.onNavClick), e.off("Panzoom.touchEnd", t.onNavTouch)), t.nav = null, i && (i.off("ready", t.onTargetReady), i.off("refresh", t.onTargetChange), i.off("change", t.onTargetChange)), t.target = null;
    }
}
Object.defineProperty($6cce3a502c50d5fc$var$Z, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        friction: .35
    }
});
const $6cce3a502c50d5fc$var$U = {
    Navigation: $6cce3a502c50d5fc$var$V,
    Dots: $6cce3a502c50d5fc$var$W,
    Sync: $6cce3a502c50d5fc$var$Z
}, $6cce3a502c50d5fc$var$G = "animationend", $6cce3a502c50d5fc$var$K = "isSelected", $6cce3a502c50d5fc$var$J = "slide";
class $6cce3a502c50d5fc$export$144901db2ea8e967 extends $6cce3a502c50d5fc$var$g {
    get axis() {
        return this.isHorizontal ? "e" : "f";
    }
    get isEnabled() {
        return this.state === $6cce3a502c50d5fc$var$B.Ready;
    }
    get isInfinite() {
        let t = !1;
        const { contentDim: e, viewportDim: i, pages: n, slides: s } = this, o = s[0];
        return n.length >= 2 && o && e + o.dim >= i && (t = this.option("infinite")), t;
    }
    get isRTL() {
        return "rtl" === this.option("direction");
    }
    get isHorizontal() {
        return "x" === this.option("axis");
    }
    constructor(t, e = {}, i = {}){
        if (super(), Object.defineProperty(this, "bp", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: ""
        }), Object.defineProperty(this, "lp", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "userOptions", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        }), Object.defineProperty(this, "userPlugins", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $6cce3a502c50d5fc$var$B.Init
        }), Object.defineProperty(this, "page", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "prevPage", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "viewport", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "track", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "slides", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "pages", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "panzoom", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "inTransition", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: new Set
        }), Object.defineProperty(this, "contentDim", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "viewportDim", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), "string" == typeof t && (t = document.querySelector(t)), !t || !$6cce3a502c50d5fc$var$E(t)) throw new Error("No Element found");
        this.container = t, this.slideNext = $6cce3a502c50d5fc$var$D(this.slideNext.bind(this), 150), this.slidePrev = $6cce3a502c50d5fc$var$D(this.slidePrev.bind(this), 150), this.userOptions = e, this.userPlugins = i, queueMicrotask(()=>{
            this.processOptions();
        });
    }
    processOptions() {
        var t, e;
        const i = $6cce3a502c50d5fc$var$u({}, $6cce3a502c50d5fc$export$144901db2ea8e967.defaults, this.userOptions);
        let n = "";
        const s = i.breakpoints;
        if (s && $6cce3a502c50d5fc$var$d(s)) for (const [t, e] of Object.entries(s))window.matchMedia(t).matches && $6cce3a502c50d5fc$var$d(e) && (n += t, $6cce3a502c50d5fc$var$u(i, e));
        n === this.bp && this.state !== $6cce3a502c50d5fc$var$B.Init || (this.bp = n, this.state === $6cce3a502c50d5fc$var$B.Ready && (i.initialSlide = (null === (e = null === (t = this.pages[this.page]) || void 0 === t ? void 0 : t.slides[0]) || void 0 === e ? void 0 : e.index) || 0), this.state !== $6cce3a502c50d5fc$var$B.Init && this.destroy(), super.setOptions(i), !1 === this.option("enabled") ? this.attachEvents() : setTimeout(()=>{
            this.init();
        }, 0));
    }
    init() {
        this.state = $6cce3a502c50d5fc$var$B.Init, this.emit("init"), this.attachPlugins(Object.assign(Object.assign({}, $6cce3a502c50d5fc$export$144901db2ea8e967.Plugins), this.userPlugins)), this.emit("attachPlugins"), this.initLayout(), this.initSlides(), this.updateMetrics(), this.setInitialPosition(), this.initPanzoom(), this.attachEvents(), this.state = $6cce3a502c50d5fc$var$B.Ready, this.emit("ready");
    }
    initLayout() {
        const { container: t } = this, e = this.option("classes");
        $6cce3a502c50d5fc$var$P(t, this.cn("container")), $6cce3a502c50d5fc$var$o(t, e.isLTR, !this.isRTL), $6cce3a502c50d5fc$var$o(t, e.isRTL, this.isRTL), $6cce3a502c50d5fc$var$o(t, e.isVertical, !this.isHorizontal), $6cce3a502c50d5fc$var$o(t, e.isHorizontal, this.isHorizontal);
        let i = this.option("viewport") || t.querySelector(`.${e.viewport}`);
        i || (i = document.createElement("div"), $6cce3a502c50d5fc$var$P(i, e.viewport), i.append(...$6cce3a502c50d5fc$var$F(t, `.${e.slide}`)), t.prepend(i)), i.addEventListener("scroll", this.onScroll);
        let n = this.option("track") || t.querySelector(`.${e.track}`);
        n || (n = document.createElement("div"), $6cce3a502c50d5fc$var$P(n, e.track), n.append(...Array.from(i.childNodes))), n.setAttribute("aria-live", "polite"), i.contains(n) || i.prepend(n), this.viewport = i, this.track = n, this.emit("initLayout");
    }
    initSlides() {
        const { track: t } = this;
        if (!t) return;
        const e = [
            ...this.slides
        ], i = [];
        [
            ...$6cce3a502c50d5fc$var$F(t, `.${this.cn($6cce3a502c50d5fc$var$J)}`)
        ].forEach((t)=>{
            if ($6cce3a502c50d5fc$var$E(t)) {
                const e = $6cce3a502c50d5fc$var$H({
                    el: t,
                    isDom: !0,
                    index: this.slides.length
                });
                i.push(e);
            }
        });
        for (let t of [
            ...this.option("slides", []) || [],
            ...e
        ])i.push($6cce3a502c50d5fc$var$H(t));
        this.slides = i;
        for(let t = 0; t < this.slides.length; t++)this.slides[t].index = t;
        for (const t of i)this.emit("beforeInitSlide", t, t.index), this.emit("initSlide", t, t.index);
        this.emit("initSlides");
    }
    setInitialPage() {
        const t = this.option("initialSlide");
        this.page = "number" == typeof t ? this.getPageForSlide(t) : parseInt(this.option("initialPage", 0) + "", 10) || 0;
    }
    setInitialPosition() {
        const { track: t, pages: e, isHorizontal: i } = this;
        if (!t || !e.length) return;
        let n = this.page;
        e[n] || (this.page = n = 0);
        const s = (e[n].pos || 0) * (this.isRTL && i ? 1 : -1), o = i ? `${s}px` : "0", a = i ? "0" : `${s}px`;
        t.style.transform = `translate3d(${o}, ${a}, 0) scale(1)`, this.option("adaptiveHeight") && this.setViewportHeight();
    }
    initPanzoom() {
        this.panzoom && (this.panzoom.destroy(), this.panzoom = null);
        const t = this.option("Panzoom") || {};
        this.panzoom = new $6cce3a502c50d5fc$export$b704d075ddd20210(this.viewport, $6cce3a502c50d5fc$var$u({}, {
            content: this.track,
            zoom: !1,
            panOnlyZoomed: !1,
            lockAxis: this.isHorizontal ? "x" : "y",
            infinite: this.isInfinite,
            click: !1,
            dblClick: !1,
            touch: (t)=>!(this.pages.length < 2 && !t.options.infinite),
            bounds: ()=>this.getBounds(),
            maxVelocity: (t)=>Math.abs(t.target[this.axis] - t.current[this.axis]) < 2 * this.viewportDim ? 100 : 0
        }, t)), this.panzoom.on("*", (t, e, ...i)=>{
            this.emit(`Panzoom.${e}`, t, ...i);
        }), this.panzoom.on("decel", this.onDecel), this.panzoom.on("refresh", this.onRefresh), this.panzoom.on("beforeTransform", this.onBeforeTransform), this.panzoom.on("endAnimation", this.onEndAnimation);
    }
    attachEvents() {
        const t = this.container;
        t && (t.addEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), t.addEventListener("slideTo", this.onSlideTo)), window.addEventListener("resize", this.onResize);
    }
    createPages() {
        let t = [];
        const { contentDim: e, viewportDim: i } = this;
        let n = this.option("slidesPerPage");
        n = ("auto" === n || e <= i) && !1 !== this.option("fill") ? 1 / 0 : parseFloat(n + "");
        let s = 0, o = 0, a = 0;
        for (const e of this.slides)(!t.length || o + e.dim - i > .05 || a >= n) && (t.push($6cce3a502c50d5fc$var$N()), s = t.length - 1, o = 0, a = 0), t[s].slides.push(e), o += e.dim + e.gap, a++;
        return t;
    }
    processPages() {
        const e = this.pages, { contentDim: i, viewportDim: n, isInfinite: s } = this, o = this.option("center"), a = this.option("fill"), r = a && o && i > n && !s;
        if (e.forEach((t, e)=>{
            var s;
            t.index = e, t.pos = (null === (s = t.slides[0]) || void 0 === s ? void 0 : s.pos) || 0, t.dim = 0;
            for (const [e, i] of t.slides.entries())t.dim += i.dim, e < t.slides.length - 1 && (t.dim += i.gap);
            r && t.pos + .5 * t.dim < .5 * n ? t.pos = 0 : r && t.pos + .5 * t.dim >= i - .5 * n ? t.pos = i - n : o && (t.pos += -0.5 * (n - t.dim));
        }), e.forEach((e)=>{
            a && !s && i > n && (e.pos = Math.max(e.pos, 0), e.pos = Math.min(e.pos, i - n)), e.pos = $6cce3a502c50d5fc$var$t(e.pos, 1e3), e.dim = $6cce3a502c50d5fc$var$t(e.dim, 1e3), Math.abs(e.pos) <= .1 && (e.pos = 0);
        }), s) return e;
        const l = [];
        let c;
        return e.forEach((t)=>{
            const e = Object.assign({}, t);
            c && e.pos === c.pos ? (c.dim += e.dim, c.slides = [
                ...c.slides,
                ...e.slides
            ]) : (e.index = l.length, c = e, l.push(e));
        }), l;
    }
    getPageFromIndex(t = 0) {
        const e = this.pages.length;
        let i;
        return t = parseInt((t || 0).toString()) || 0, i = this.isInfinite ? (t % e + e) % e : Math.max(Math.min(t, e - 1), 0), i;
    }
    getSlideMetrics(e) {
        var i, n;
        const s = this.isHorizontal ? "width" : "height";
        let o = 0, a = 0, r = e.el;
        const l = !(!r || r.parentNode);
        if (r ? o = parseFloat(r.dataset[s] || "") || 0 : (r = document.createElement("div"), r.style.visibility = "hidden", (this.track || document.body).prepend(r)), $6cce3a502c50d5fc$var$P(r, this.cn($6cce3a502c50d5fc$var$J) + " " + e.class + " " + e.customClass), o) r.style[s] = `${o}px`, r.style["width" === s ? "height" : "width"] = "";
        else {
            l && (this.track || document.body).prepend(r), o = r.getBoundingClientRect()[s] * Math.max(1, (null === (i = window.visualViewport) || void 0 === i ? void 0 : i.scale) || 1);
            let t = r[this.isHorizontal ? "offsetWidth" : "offsetHeight"];
            t - 1 > o && (o = t);
        }
        const c = getComputedStyle(r);
        return "content-box" === c.boxSizing && (this.isHorizontal ? (o += parseFloat(c.paddingLeft) || 0, o += parseFloat(c.paddingRight) || 0) : (o += parseFloat(c.paddingTop) || 0, o += parseFloat(c.paddingBottom) || 0)), a = parseFloat(c[this.isHorizontal ? "marginRight" : "marginBottom"]) || 0, l ? null === (n = r.parentElement) || void 0 === n || n.removeChild(r) : e.el || r.remove(), {
            dim: $6cce3a502c50d5fc$var$t(o, 1e3),
            gap: $6cce3a502c50d5fc$var$t(a, 1e3)
        };
    }
    getBounds() {
        const { isInfinite: t, isRTL: e, isHorizontal: i, pages: n } = this;
        let s = {
            min: 0,
            max: 0
        };
        if (t) s = {
            min: -1 / 0,
            max: 1 / 0
        };
        else if (n.length) {
            const t = n[0].pos, o = n[n.length - 1].pos;
            s = e && i ? {
                min: t,
                max: o
            } : {
                min: -1 * o,
                max: -1 * t
            };
        }
        return {
            x: i ? s : {
                min: 0,
                max: 0
            },
            y: i ? {
                min: 0,
                max: 0
            } : s
        };
    }
    repositionSlides() {
        let e, { isHorizontal: i, isRTL: n, isInfinite: s, viewport: o, viewportDim: a, contentDim: r, page: l, pages: c, slides: h, panzoom: d } = this, u = 0, p = 0, f = 0, g = 0;
        d ? g = -1 * d.current[this.axis] : c[l] && (g = c[l].pos || 0), e = i ? n ? "right" : "left" : "top", n && i && (g *= -1);
        for (const i of h){
            const n = i.el;
            n ? ("top" === e ? (n.style.right = "", n.style.left = "") : n.style.top = "", i.index !== u ? n.style[e] = 0 === p ? "" : `${$6cce3a502c50d5fc$var$t(p, 1e3)}px` : n.style[e] = "", f += i.dim + i.gap, u++) : p += i.dim + i.gap;
        }
        if (s && f && o) {
            let n = getComputedStyle(o), s = "padding", l = i ? "Right" : "Bottom", c = parseFloat(n[s + (i ? "Left" : "Top")]);
            g -= c, a += c, a += parseFloat(n[s + l]);
            for (const i of h)i.el && ($6cce3a502c50d5fc$var$t(i.pos) < $6cce3a502c50d5fc$var$t(a) && $6cce3a502c50d5fc$var$t(i.pos + i.dim + i.gap) < $6cce3a502c50d5fc$var$t(g) && $6cce3a502c50d5fc$var$t(g) > $6cce3a502c50d5fc$var$t(r - a) && (i.el.style[e] = `${$6cce3a502c50d5fc$var$t(p + f, 1e3)}px`), $6cce3a502c50d5fc$var$t(i.pos + i.gap) >= $6cce3a502c50d5fc$var$t(r - a) && $6cce3a502c50d5fc$var$t(i.pos) > $6cce3a502c50d5fc$var$t(g + a) && $6cce3a502c50d5fc$var$t(g) < $6cce3a502c50d5fc$var$t(a) && (i.el.style[e] = `-${$6cce3a502c50d5fc$var$t(f, 1e3)}px`));
        }
        let m, v, b = [
            ...this.inTransition
        ];
        if (b.length > 1 && (m = c[b[0]], v = c[b[1]]), m && v) {
            let i = 0;
            for (const n of h)n.el ? this.inTransition.has(n.index) && m.slides.indexOf(n) < 0 && (n.el.style[e] = `${$6cce3a502c50d5fc$var$t(i + (m.pos - v.pos), 1e3)}px`) : i += n.dim + n.gap;
        }
    }
    createSlideEl(t) {
        const { track: e, slides: i } = this;
        if (!e || !t) return;
        if (t.el && t.el.parentNode) return;
        const n = t.el || document.createElement("div");
        $6cce3a502c50d5fc$var$P(n, this.cn($6cce3a502c50d5fc$var$J)), $6cce3a502c50d5fc$var$P(n, t.class), $6cce3a502c50d5fc$var$P(n, t.customClass);
        const s = t.html;
        s && (s instanceof HTMLElement ? n.appendChild(s) : n.innerHTML = t.html + "");
        const o = [];
        i.forEach((t, e)=>{
            t.el && o.push(e);
        });
        const a = t.index;
        let r = null;
        if (o.length) r = i[o.reduce((t, e)=>Math.abs(e - a) < Math.abs(t - a) ? e : t)];
        const l = r && r.el && r.el.parentNode ? r.index < t.index ? r.el.nextSibling : r.el : null;
        e.insertBefore(n, e.contains(l) ? l : null), t.el = n, this.emit("createSlide", t);
    }
    removeSlideEl(t, e = !1) {
        const i = null == t ? void 0 : t.el;
        if (!i || !i.parentNode) return;
        const n = this.cn($6cce3a502c50d5fc$var$K);
        if (i.classList.contains(n) && ($6cce3a502c50d5fc$var$S(i, n), this.emit("unselectSlide", t)), t.isDom && !e) return i.removeAttribute("aria-hidden"), i.removeAttribute("data-index"), void (i.style.left = "");
        this.emit("removeSlide", t);
        const s = new CustomEvent($6cce3a502c50d5fc$var$G);
        i.dispatchEvent(s), t.el && (t.el.remove(), t.el = null);
    }
    transitionTo(t = 0, e = this.option("transition")) {
        var i, n, s, o;
        if (!e) return !1;
        const a = this.page, { pages: r, panzoom: l } = this;
        t = parseInt((t || 0).toString()) || 0;
        const c = this.getPageFromIndex(t);
        if (!l || !r[c] || r.length < 2 || Math.abs(((null === (n = null === (i = r[a]) || void 0 === i ? void 0 : i.slides[0]) || void 0 === n ? void 0 : n.dim) || 0) - this.viewportDim) > 1) return !1;
        let h = t > a ? 1 : -1;
        this.isInfinite && (0 === a && t === r.length - 1 && (h = -1), a === r.length - 1 && 0 === t && (h = 1));
        const d = r[c].pos * (this.isRTL ? 1 : -1);
        if (a === c && Math.abs(d - l.target[this.axis]) < 1) return !1;
        this.clearTransitions();
        const u = l.isResting;
        $6cce3a502c50d5fc$var$P(this.container, this.cn("inTransition"));
        const p = (null === (s = r[a]) || void 0 === s ? void 0 : s.slides[0]) || null, f = (null === (o = r[c]) || void 0 === o ? void 0 : o.slides[0]) || null;
        this.inTransition.add(f.index), this.createSlideEl(f);
        let g = p.el, m = f.el;
        u || e === $6cce3a502c50d5fc$var$J || (e = "fadeFast", g = null);
        const v = this.isRTL ? "next" : "prev", b = this.isRTL ? "prev" : "next";
        return g && (this.inTransition.add(p.index), p.transition = e, g.addEventListener($6cce3a502c50d5fc$var$G, this.onAnimationEnd), g.classList.add(`f-${e}Out`, `to-${h > 0 ? b : v}`)), m && (f.transition = e, m.addEventListener($6cce3a502c50d5fc$var$G, this.onAnimationEnd), m.classList.add(`f-${e}In`, `from-${h > 0 ? v : b}`)), l.current[this.axis] = d, l.target[this.axis] = d, l.requestTick(), this.onChange(c), !0;
    }
    manageSlideVisiblity() {
        const t = new Set, e = new Set, i = this.getVisibleSlides(parseFloat(this.option("preload", 0) + "") || 0);
        for (const n of this.slides)i.has(n) ? t.add(n) : e.add(n);
        for (const e of this.inTransition)t.add(this.slides[e]);
        for (const e of t)this.createSlideEl(e), this.lazyLoadSlide(e);
        for (const i of e)t.has(i) || this.removeSlideEl(i);
        this.markSelectedSlides(), this.repositionSlides();
    }
    markSelectedSlides() {
        if (!this.pages[this.page] || !this.pages[this.page].slides) return;
        const t = "aria-hidden";
        let e = this.cn($6cce3a502c50d5fc$var$K);
        if (e) for (const i of this.slides){
            const n = i.el;
            n && (n.dataset.index = `${i.index}`, n.classList.contains("f-thumbs__slide") ? this.getVisibleSlides(0).has(i) ? n.removeAttribute(t) : n.setAttribute(t, "true") : this.pages[this.page].slides.includes(i) ? (n.classList.contains(e) || ($6cce3a502c50d5fc$var$P(n, e), this.emit("selectSlide", i)), n.removeAttribute(t)) : (n.classList.contains(e) && ($6cce3a502c50d5fc$var$S(n, e), this.emit("unselectSlide", i)), n.setAttribute(t, "true")));
        }
    }
    flipInfiniteTrack() {
        const { axis: t, isHorizontal: e, isInfinite: i, isRTL: n, viewportDim: s, contentDim: o } = this, a = this.panzoom;
        if (!a || !i) return;
        let r = a.current[t], l = a.target[t] - r, c = 0, h = .5 * s;
        n && e ? (r < -h && (c = -1, r += o), r > o - h && (c = 1, r -= o)) : (r > h && (c = 1, r -= o), r < -o + h && (c = -1, r += o)), c && (a.current[t] = r, a.target[t] = r + l);
    }
    lazyLoadImg(t, e) {
        const i = this, s = "f-fadeIn", o = "is-preloading";
        let a = !1, r = null;
        const l = ()=>{
            a || (a = !0, r && (r.remove(), r = null), $6cce3a502c50d5fc$var$S(e, o), e.complete && ($6cce3a502c50d5fc$var$P(e, s), setTimeout(()=>{
                $6cce3a502c50d5fc$var$S(e, s);
            }, 350)), this.option("adaptiveHeight") && t.el && this.pages[this.page].slides.indexOf(t) > -1 && (i.updateMetrics(), i.setViewportHeight()), this.emit("load", t));
        };
        $6cce3a502c50d5fc$var$P(e, o), e.src = e.dataset.lazySrcset || e.dataset.lazySrc || "", delete e.dataset.lazySrc, delete e.dataset.lazySrcset, e.addEventListener("error", ()=>{
            l();
        }), e.addEventListener("load", ()=>{
            l();
        }), setTimeout(()=>{
            const i = e.parentNode;
            i && t.el && (e.complete ? l() : a || (r = $6cce3a502c50d5fc$var$n($6cce3a502c50d5fc$var$x), i.insertBefore(r, e)));
        }, 300);
    }
    lazyLoadSlide(t) {
        const e = t && t.el;
        if (!e) return;
        const i = new Set;
        let n = Array.from(e.querySelectorAll("[data-lazy-src],[data-lazy-srcset]"));
        e.dataset.lazySrc && n.push(e), n.map((t)=>{
            t instanceof HTMLImageElement ? i.add(t) : t instanceof HTMLElement && t.dataset.lazySrc && (t.style.backgroundImage = `url('${t.dataset.lazySrc}')`, delete t.dataset.lazySrc);
        });
        for (const e of i)this.lazyLoadImg(t, e);
    }
    onAnimationEnd(t) {
        var e;
        const i = t.target, n = i ? parseInt(i.dataset.index || "", 10) || 0 : -1, s = this.slides[n], o = t.animationName;
        if (!i || !s || !o) return;
        const a = !!this.inTransition.has(n) && s.transition;
        a && o.substring(0, a.length + 2) === `f-${a}` && this.inTransition.delete(n), this.inTransition.size || this.clearTransitions(), n === this.page && (null === (e = this.panzoom) || void 0 === e ? void 0 : e.isResting) && this.emit("settle");
    }
    onDecel(t, e = 0, i = 0, n = 0, s = 0) {
        if (this.option("dragFree")) return void this.setPageFromPosition();
        const { isRTL: o, isHorizontal: a, axis: r, pages: l } = this, c = l.length, h = Math.abs(Math.atan2(i, e) / (Math.PI / 180));
        let d = 0;
        if (d = h > 45 && h < 135 ? a ? 0 : i : a ? e : 0, !c) return;
        let u = this.page, p = o && a ? 1 : -1;
        const f = t.current[r] * p;
        let { pageIndex: g } = this.getPageFromPosition(f);
        Math.abs(d) > 5 ? (l[u].dim < document.documentElement["client" + (this.isHorizontal ? "Width" : "Height")] - 1 && (u = g), u = o && a ? d < 0 ? u - 1 : u + 1 : d < 0 ? u + 1 : u - 1) : u = 0 === n && 0 === s ? u : g, this.slideTo(u, {
            transition: !1,
            friction: t.option("decelFriction")
        });
    }
    onClick(t) {
        const e = t.target, i = e && $6cce3a502c50d5fc$var$E(e) ? e.dataset : null;
        let n, s;
        i && (void 0 !== i.carouselPage ? (s = "slideTo", n = i.carouselPage) : void 0 !== i.carouselNext ? s = "slideNext" : void 0 !== i.carouselPrev && (s = "slidePrev")), s ? (t.preventDefault(), t.stopPropagation(), e && !e.hasAttribute("disabled") && this[s](n)) : this.emit("click", t);
    }
    onSlideTo(t) {
        const e = t.detail || 0;
        this.slideTo(this.getPageForSlide(e), {
            friction: 0
        });
    }
    onChange(t, e = 0) {
        const i = this.page;
        this.prevPage = i, this.page = t, this.option("adaptiveHeight") && this.setViewportHeight(), t !== i && (this.markSelectedSlides(), this.emit("change", t, i, e));
    }
    onRefresh() {
        let t = this.contentDim, e = this.viewportDim;
        this.updateMetrics(), this.contentDim === t && this.viewportDim === e || this.slideTo(this.page, {
            friction: 0,
            transition: !1
        });
    }
    onScroll() {
        var t;
        null === (t = this.viewport) || void 0 === t || t.scroll(0, 0);
    }
    onResize() {
        this.option("breakpoints") && this.processOptions();
    }
    onBeforeTransform(t) {
        this.lp !== t.current[this.axis] && (this.flipInfiniteTrack(), this.manageSlideVisiblity()), this.lp = t.current.e;
    }
    onEndAnimation() {
        this.inTransition.size || this.emit("settle");
    }
    reInit(t = null, e = null) {
        this.destroy(), this.state = $6cce3a502c50d5fc$var$B.Init, this.prevPage = null, this.userOptions = t || this.userOptions, this.userPlugins = e || this.userPlugins, this.processOptions();
    }
    slideTo(t = 0, { friction: e = this.option("friction"), transition: i = this.option("transition") } = {}) {
        if (this.state === $6cce3a502c50d5fc$var$B.Destroy) return;
        t = parseInt((t || 0).toString()) || 0;
        const n = this.getPageFromIndex(t), { axis: s, isHorizontal: o, isRTL: a, pages: r, panzoom: l } = this, c = r.length, h = a && o ? 1 : -1;
        if (!l || !c) return;
        if (this.page !== n) {
            const e = new Event("beforeChange", {
                bubbles: !0,
                cancelable: !0
            });
            if (this.emit("beforeChange", e, t), e.defaultPrevented) return;
        }
        if (this.transitionTo(t, i)) return;
        let d = r[n].pos;
        if (this.isInfinite) {
            const e = this.contentDim, i = l.target[s] * h;
            if (2 === c) d += e * Math.floor(parseFloat(t + "") / 2);
            else d = [
                d,
                d - e,
                d + e
            ].reduce(function(t, e) {
                return Math.abs(e - i) < Math.abs(t - i) ? e : t;
            });
        }
        d *= h, Math.abs(l.target[s] - d) < 1 || (l.panTo({
            x: o ? d : 0,
            y: o ? 0 : d,
            friction: e
        }), this.onChange(n));
    }
    slideToClosest(t) {
        if (this.panzoom) {
            const { pageIndex: e } = this.getPageFromPosition();
            this.slideTo(e, t);
        }
    }
    slideNext() {
        this.slideTo(this.page + 1);
    }
    slidePrev() {
        this.slideTo(this.page - 1);
    }
    clearTransitions() {
        this.inTransition.clear(), $6cce3a502c50d5fc$var$S(this.container, this.cn("inTransition"));
        const t = [
            "to-prev",
            "to-next",
            "from-prev",
            "from-next"
        ];
        for (const e of this.slides){
            const i = e.el;
            if (i) {
                i.removeEventListener($6cce3a502c50d5fc$var$G, this.onAnimationEnd), i.classList.remove(...t);
                const n = e.transition;
                n && i.classList.remove(`f-${n}Out`, `f-${n}In`);
            }
        }
        this.manageSlideVisiblity();
    }
    addSlide(t, e) {
        var i, n, s, o;
        const a = this.panzoom, r = (null === (i = this.pages[this.page]) || void 0 === i ? void 0 : i.pos) || 0, l = (null === (n = this.pages[this.page]) || void 0 === n ? void 0 : n.dim) || 0, c = this.contentDim < this.viewportDim;
        let h = Array.isArray(e) ? e : [
            e
        ];
        const d = [];
        for (const t of h)d.push($6cce3a502c50d5fc$var$H(t));
        this.slides.splice(t, 0, ...d);
        for(let t = 0; t < this.slides.length; t++)this.slides[t].index = t;
        for (const t of d)this.emit("beforeInitSlide", t, t.index);
        if (this.page >= t && (this.page += d.length), this.updateMetrics(), a) {
            const e = (null === (s = this.pages[this.page]) || void 0 === s ? void 0 : s.pos) || 0, i = (null === (o = this.pages[this.page]) || void 0 === o ? void 0 : o.dim) || 0, n = this.pages.length || 1, h = this.isRTL ? l - i : i - l, d = this.isRTL ? r - e : e - r;
            c && 1 === n ? (t <= this.page && (a.current[this.axis] -= h, a.target[this.axis] -= h), a.panTo({
                [this.isHorizontal ? "x" : "y"]: -1 * e
            })) : d && t <= this.page && (a.target[this.axis] -= d, a.current[this.axis] -= d, a.requestTick());
        }
        for (const t of d)this.emit("initSlide", t, t.index);
    }
    prependSlide(t) {
        this.addSlide(0, t);
    }
    appendSlide(t) {
        this.addSlide(this.slides.length, t);
    }
    removeSlide(t) {
        const e = this.slides.length;
        t = (t % e + e) % e;
        const i = this.slides[t];
        if (i) {
            this.removeSlideEl(i, !0), this.slides.splice(t, 1);
            for(let t = 0; t < this.slides.length; t++)this.slides[t].index = t;
            this.updateMetrics(), this.slideTo(this.page, {
                friction: 0,
                transition: !1
            }), this.emit("destroySlide", i);
        }
    }
    updateMetrics() {
        const { panzoom: e, viewport: i, track: n, slides: s, isHorizontal: o, isInfinite: a } = this;
        if (!n) return;
        const r = o ? "width" : "height", l = o ? "offsetWidth" : "offsetHeight";
        if (i) {
            let e = Math.max(i[l], $6cce3a502c50d5fc$var$t(i.getBoundingClientRect()[r], 1e3)), n = getComputedStyle(i), s = "padding", a = o ? "Right" : "Bottom";
            e -= parseFloat(n[s + (o ? "Left" : "Top")]) + parseFloat(n[s + a]), this.viewportDim = e;
        }
        let c, h = 0;
        for (const [e, i] of s.entries()){
            let n = 0, o = 0;
            !i.el && c ? (n = c.dim, o = c.gap) : ({ dim: n, gap: o } = this.getSlideMetrics(i), c = i), n = $6cce3a502c50d5fc$var$t(n, 1e3), o = $6cce3a502c50d5fc$var$t(o, 1e3), i.dim = n, i.gap = o, i.pos = h, h += n, (a || e < s.length - 1) && (h += o);
        }
        h = $6cce3a502c50d5fc$var$t(h, 1e3), this.contentDim = h, e && (e.contentRect[r] = h, e.contentRect[o ? "fullWidth" : "fullHeight"] = h), this.pages = this.createPages(), this.pages = this.processPages(), this.state === $6cce3a502c50d5fc$var$B.Init && this.setInitialPage(), this.page = Math.max(0, Math.min(this.page, this.pages.length - 1)), this.manageSlideVisiblity(), this.emit("refresh");
    }
    getProgress(e, i = !1, n = !1) {
        void 0 === e && (e = this.page);
        const s = this, o = s.panzoom, a = s.contentDim, r = s.pages[e] || 0;
        if (!r || !o) return e > this.page ? -1 : 1;
        let l = -1 * o.current.e, c = $6cce3a502c50d5fc$var$t((l - r.pos) / (1 * r.dim), 1e3), h = c, d = c;
        this.isInfinite && !0 !== n && (h = $6cce3a502c50d5fc$var$t((l - r.pos + a) / (1 * r.dim), 1e3), d = $6cce3a502c50d5fc$var$t((l - r.pos - a) / (1 * r.dim), 1e3));
        let u = [
            c,
            h,
            d
        ].reduce(function(t, e) {
            return Math.abs(e) < Math.abs(t) ? e : t;
        });
        return i ? u : u > 1 ? 1 : u < -1 ? -1 : u;
    }
    setViewportHeight() {
        const { page: t, pages: e, viewport: i, isHorizontal: n } = this;
        if (!i || !e[t]) return;
        let s = 0;
        n && this.track && (this.track.style.height = "auto", e[t].slides.forEach((t)=>{
            t.el && (s = Math.max(s, t.el.offsetHeight));
        })), i.style.height = s ? `${s}px` : "";
    }
    getPageForSlide(t) {
        for (const e of this.pages)for (const i of e.slides)if (i.index === t) return e.index;
        return -1;
    }
    getVisibleSlides(t = 0) {
        var e;
        const i = new Set;
        let { panzoom: n, contentDim: s, viewportDim: o, pages: a, page: r } = this;
        if (o) {
            s = s + (null === (e = this.slides[this.slides.length - 1]) || void 0 === e ? void 0 : e.gap) || 0;
            let l = 0;
            l = n && n.state !== $6cce3a502c50d5fc$var$m.Init && n.state !== $6cce3a502c50d5fc$var$m.Destroy ? -1 * n.current[this.axis] : a[r] && a[r].pos || 0, this.isInfinite && (l -= Math.floor(l / s) * s), this.isRTL && this.isHorizontal && (l *= -1);
            const c = l - o * t, h = l + o * (t + 1), d = this.isInfinite ? [
                -1,
                0,
                1
            ] : [
                0
            ];
            for (const t of this.slides)for (const e of d){
                const n = t.pos + e * s, o = n + t.dim + t.gap;
                n < h && o > c && i.add(t);
            }
        }
        return i;
    }
    getPageFromPosition(t) {
        const { viewportDim: e, contentDim: i, slides: n, pages: s, panzoom: o } = this, a = s.length, r = n.length, l = n[0], c = n[r - 1], h = this.option("center");
        let d = 0, u = 0, p = 0, f = void 0 === t ? -1 * ((null == o ? void 0 : o.target[this.axis]) || 0) : t;
        h && (f += .5 * e), this.isInfinite ? (f < l.pos - .5 * c.gap && (f -= i, p = -1), f > c.pos + c.dim + .5 * c.gap && (f -= i, p = 1)) : f = Math.max(l.pos || 0, Math.min(f, c.pos));
        let g = c, m = n.find((t)=>{
            const e = t.pos - .5 * g.gap, i = t.pos + t.dim + .5 * t.gap;
            return g = t, f >= e && f < i;
        });
        return m || (m = c), u = this.getPageForSlide(m.index), d = u + p * a, {
            page: d,
            pageIndex: u
        };
    }
    setPageFromPosition() {
        const { pageIndex: t } = this.getPageFromPosition();
        this.onChange(t);
    }
    destroy() {
        if ([
            $6cce3a502c50d5fc$var$B.Destroy
        ].includes(this.state)) return;
        this.state = $6cce3a502c50d5fc$var$B.Destroy;
        const { container: t, viewport: e, track: i, slides: n, panzoom: s } = this, o = this.option("classes");
        t.removeEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), t.removeEventListener("slideTo", this.onSlideTo), window.removeEventListener("resize", this.onResize), s && (s.destroy(), this.panzoom = null), n && n.forEach((t)=>{
            this.removeSlideEl(t);
        }), this.detachPlugins(), e && (e.removeEventListener("scroll", this.onScroll), e.offsetParent && i && i.offsetParent && e.replaceWith(...i.childNodes));
        for (const [e, i] of Object.entries(o))"container" !== e && i && t.classList.remove(i);
        this.track = null, this.viewport = null, this.page = 0, this.slides = [];
        const a = this.events.get("ready");
        this.events = new Map, a && this.events.set("ready", a);
    }
}
Object.defineProperty($6cce3a502c50d5fc$export$144901db2ea8e967, "Panzoom", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $6cce3a502c50d5fc$export$b704d075ddd20210
}), Object.defineProperty($6cce3a502c50d5fc$export$144901db2ea8e967, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $6cce3a502c50d5fc$var$j
}), Object.defineProperty($6cce3a502c50d5fc$export$144901db2ea8e967, "Plugins", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $6cce3a502c50d5fc$var$U
});
const $6cce3a502c50d5fc$var$tt = function(t) {
    if (!$6cce3a502c50d5fc$var$E(t)) return 0;
    const e = window.scrollY, i = window.innerHeight, n = e + i, s = t.getBoundingClientRect(), o = s.y + e, a = s.height, r = o + a;
    if (e > r || n < o) return 0;
    if (e < o && n > r) return 100;
    if (o < e && r > n) return 100;
    let l = a;
    o < e && (l -= e - o), r > n && (l -= r - n);
    const c = l / i * 100;
    return Math.round(c);
}, $6cce3a502c50d5fc$var$et = !("undefined" == typeof window || !window.document || !window.document.createElement);
let $6cce3a502c50d5fc$var$it;
const $6cce3a502c50d5fc$var$nt = [
    "a[href]",
    "area[href]",
    'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
    "select:not([disabled]):not([aria-hidden])",
    "textarea:not([disabled]):not([aria-hidden])",
    "button:not([disabled]):not([aria-hidden]):not(.fancybox-focus-guard)",
    "iframe",
    "object",
    "embed",
    "video",
    "audio",
    "[contenteditable]",
    '[tabindex]:not([tabindex^="-"]):not([disabled]):not([aria-hidden])'
].join(","), $6cce3a502c50d5fc$var$st = (t)=>{
    if (t && $6cce3a502c50d5fc$var$et) {
        void 0 === $6cce3a502c50d5fc$var$it && document.createElement("div").focus({
            get preventScroll () {
                return $6cce3a502c50d5fc$var$it = !0, !1;
            }
        });
        try {
            if ($6cce3a502c50d5fc$var$it) t.focus({
                preventScroll: !0
            });
            else {
                const e = window.scrollY || document.body.scrollTop, i = window.scrollX || document.body.scrollLeft;
                t.focus(), document.body.scrollTo({
                    top: e,
                    left: i,
                    behavior: "auto"
                });
            }
        } catch (t) {}
    }
}, $6cce3a502c50d5fc$var$ot = ()=>{
    const t = document;
    let e, i = "", n = "", s = "";
    return t.fullscreenEnabled ? (i = "requestFullscreen", n = "exitFullscreen", s = "fullscreenElement") : t.webkitFullscreenEnabled && (i = "webkitRequestFullscreen", n = "webkitExitFullscreen", s = "webkitFullscreenElement"), i && (e = {
        request: function(e = t.documentElement) {
            return "webkitRequestFullscreen" === i ? e[i](Element.ALLOW_KEYBOARD_INPUT) : e[i]();
        },
        exit: function() {
            return t[s] && t[n]();
        },
        isFullscreen: function() {
            return t[s];
        }
    }), e;
}, $6cce3a502c50d5fc$var$at = {
    animated: !0,
    autoFocus: !0,
    backdropClick: "close",
    Carousel: {
        classes: {
            container: "fancybox__carousel",
            viewport: "fancybox__viewport",
            track: "fancybox__track",
            slide: "fancybox__slide"
        }
    },
    closeButton: "auto",
    closeExisting: !1,
    commonCaption: !1,
    compact: ()=>window.matchMedia("(max-width: 578px), (max-height: 578px)").matches,
    contentClick: "toggleZoom",
    contentDblClick: !1,
    defaultType: "image",
    defaultDisplay: "flex",
    dragToClose: !0,
    Fullscreen: {
        autoStart: !1
    },
    groupAll: !1,
    groupAttr: "data-fancybox",
    hideClass: "f-fadeOut",
    hideScrollbar: !0,
    idle: 3500,
    keyboard: {
        Escape: "close",
        Delete: "close",
        Backspace: "close",
        PageUp: "next",
        PageDown: "prev",
        ArrowUp: "prev",
        ArrowDown: "next",
        ArrowRight: "next",
        ArrowLeft: "prev"
    },
    l10n: Object.assign(Object.assign({}, $6cce3a502c50d5fc$var$b), {
        CLOSE: "Close",
        NEXT: "Next",
        PREV: "Previous",
        MODAL: "You can close this modal content with the ESC key",
        ERROR: "Something Went Wrong, Please Try Again Later",
        IMAGE_ERROR: "Image Not Found",
        ELEMENT_NOT_FOUND: "HTML Element Not Found",
        AJAX_NOT_FOUND: "Error Loading AJAX : Not Found",
        AJAX_FORBIDDEN: "Error Loading AJAX : Forbidden",
        IFRAME_ERROR: "Error Loading Page",
        TOGGLE_ZOOM: "Toggle zoom level",
        TOGGLE_THUMBS: "Toggle thumbnails",
        TOGGLE_SLIDESHOW: "Toggle slideshow",
        TOGGLE_FULLSCREEN: "Toggle full-screen mode",
        DOWNLOAD: "Download"
    }),
    parentEl: null,
    placeFocusBack: !0,
    showClass: "f-zoomInUp",
    startIndex: 0,
    tpl: {
        closeButton: '<button data-fancybox-close class="f-button is-close-btn" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M20 20L4 4m16 0L4 20"/></svg></button>',
        main: '<div class="fancybox__container" role="dialog" aria-modal="true" aria-label="{{MODAL}}" tabindex="-1">\n    <div class="fancybox__backdrop"></div>\n    <div class="fancybox__carousel"></div>\n    <div class="fancybox__footer"></div>\n  </div>'
    },
    trapFocus: !0,
    wheel: "zoom"
};
var $6cce3a502c50d5fc$var$rt, $6cce3a502c50d5fc$var$lt;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Closing = 2] = "Closing", t[t.CustomClosing = 3] = "CustomClosing", t[t.Destroy = 4] = "Destroy";
}($6cce3a502c50d5fc$var$rt || ($6cce3a502c50d5fc$var$rt = {})), function(t) {
    t[t.Loading = 0] = "Loading", t[t.Opening = 1] = "Opening", t[t.Ready = 2] = "Ready", t[t.Closing = 3] = "Closing";
}($6cce3a502c50d5fc$var$lt || ($6cce3a502c50d5fc$var$lt = {}));
let $6cce3a502c50d5fc$var$ct = "", $6cce3a502c50d5fc$var$ht = !1, $6cce3a502c50d5fc$var$dt = !1, $6cce3a502c50d5fc$var$ut = null;
const $6cce3a502c50d5fc$var$pt = ()=>{
    let t = "", e = "";
    const i = $6cce3a502c50d5fc$export$cb45b08d97cdc4fd.getInstance();
    if (i) {
        const n = i.carousel, s = i.getSlide();
        if (n && s) {
            let o = s.slug || void 0, a = s.triggerEl || void 0;
            e = o || i.option("slug") || "", !e && a && a.dataset && (e = a.dataset.fancybox || ""), e && "true" !== e && (t = "#" + e + (!o && n.slides.length > 1 ? "-" + (s.index + 1) : ""));
        }
    }
    return {
        hash: t,
        slug: e,
        index: 1
    };
}, $6cce3a502c50d5fc$var$ft = ()=>{
    const t = new URL(document.URL).hash, e = t.slice(1).split("-"), i = e[e.length - 1], n = i && /^\+?\d+$/.test(i) && parseInt(e.pop() || "1", 10) || 1;
    return {
        hash: t,
        slug: e.join("-"),
        index: n
    };
}, $6cce3a502c50d5fc$var$gt = ()=>{
    const { slug: t, index: e } = $6cce3a502c50d5fc$var$ft();
    if (!t) return;
    let i = document.querySelector(`[data-slug="${t}"]`);
    if (i && i.dispatchEvent(new CustomEvent("click", {
        bubbles: !0,
        cancelable: !0
    })), $6cce3a502c50d5fc$export$cb45b08d97cdc4fd.getInstance()) return;
    const n = document.querySelectorAll(`[data-fancybox="${t}"]`);
    n.length && (i = n[e - 1], i && i.dispatchEvent(new CustomEvent("click", {
        bubbles: !0,
        cancelable: !0
    })));
}, $6cce3a502c50d5fc$var$mt = ()=>{
    if (!1 === $6cce3a502c50d5fc$export$cb45b08d97cdc4fd.defaults.Hash) return;
    const t = $6cce3a502c50d5fc$export$cb45b08d97cdc4fd.getInstance();
    if (!1 === (null == t ? void 0 : t.options.Hash)) return;
    const { slug: e, index: i } = $6cce3a502c50d5fc$var$ft(), { slug: n } = $6cce3a502c50d5fc$var$pt();
    t && (e === n ? t.jumpTo(i - 1) : ($6cce3a502c50d5fc$var$ht = !0, t.close())), $6cce3a502c50d5fc$var$gt();
}, $6cce3a502c50d5fc$var$vt = ()=>{
    $6cce3a502c50d5fc$var$ut && clearTimeout($6cce3a502c50d5fc$var$ut), queueMicrotask(()=>{
        $6cce3a502c50d5fc$var$mt();
    });
}, $6cce3a502c50d5fc$var$bt = ()=>{
    window.addEventListener("hashchange", $6cce3a502c50d5fc$var$vt, !1), setTimeout(()=>{
        $6cce3a502c50d5fc$var$mt();
    }, 500);
};
$6cce3a502c50d5fc$var$et && (/complete|interactive|loaded/.test(document.readyState) ? $6cce3a502c50d5fc$var$bt() : document.addEventListener("DOMContentLoaded", $6cce3a502c50d5fc$var$bt));
const $6cce3a502c50d5fc$var$yt = "is-zooming-in";
class $6cce3a502c50d5fc$var$wt extends $6cce3a502c50d5fc$var$_ {
    onCreateSlide(t, e, i) {
        const n = this.instance.optionFor(i, "src") || "";
        i.el && "image" === i.type && "string" == typeof n && this.setImage(i, n);
    }
    onRemoveSlide(t, e, i) {
        i.panzoom && i.panzoom.destroy(), i.panzoom = void 0, i.imageEl = void 0;
    }
    onChange(t, e, i, n) {
        $6cce3a502c50d5fc$var$S(this.instance.container, $6cce3a502c50d5fc$var$yt);
        for (const t of e.slides){
            const e = t.panzoom;
            e && t.index !== i && e.reset(.35);
        }
    }
    onClose() {
        var t;
        const e = this.instance, i = e.container, n = e.getSlide();
        if (!i || !i.parentElement || !n) return;
        const { el: s, contentEl: o, panzoom: a, thumbElSrc: r } = n;
        if (!s || !r || !o || !a || a.isContentLoading || a.state === $6cce3a502c50d5fc$var$m.Init || a.state === $6cce3a502c50d5fc$var$m.Destroy) return;
        a.updateMetrics();
        let l = this.getZoomInfo(n);
        if (!l) return;
        this.instance.state = $6cce3a502c50d5fc$var$rt.CustomClosing, i.classList.remove($6cce3a502c50d5fc$var$yt), i.classList.add("is-zooming-out"), o.style.backgroundImage = `url('${r}')`;
        const c = i.getBoundingClientRect();
        1 === ((null === (t = window.visualViewport) || void 0 === t ? void 0 : t.scale) || 1) && Object.assign(i.style, {
            position: "absolute",
            top: `${i.offsetTop + window.scrollY}px`,
            left: `${i.offsetLeft + window.scrollX}px`,
            bottom: "auto",
            right: "auto",
            width: `${c.width}px`,
            height: `${c.height}px`,
            overflow: "hidden"
        });
        const { x: h, y: d, scale: u, opacity: p } = l;
        if (p) {
            const t = ((t, e, i, n)=>{
                const s = e - t, o = n - i;
                return (e)=>i + ((e - t) / s * o || 0);
            })(a.scale, u, 1, 0);
            a.on("afterTransform", ()=>{
                o.style.opacity = t(a.scale) + "";
            });
        }
        a.on("endAnimation", ()=>{
            e.destroy();
        }), a.target.a = u, a.target.b = 0, a.target.c = 0, a.target.d = u, a.panTo({
            x: h,
            y: d,
            scale: u,
            friction: p ? .2 : .33,
            ignoreBounds: !0
        }), a.isResting && e.destroy();
    }
    setImage(t, e) {
        const i = this.instance;
        t.src = e, this.process(t, e).then((e)=>{
            const { contentEl: n, imageEl: s, thumbElSrc: o, el: a } = t;
            if (i.isClosing() || !n || !s) return;
            n.offsetHeight;
            const r = !!i.isOpeningSlide(t) && this.getZoomInfo(t);
            if (this.option("protected") && a) {
                a.addEventListener("contextmenu", (t)=>{
                    t.preventDefault();
                });
                const t = document.createElement("div");
                $6cce3a502c50d5fc$var$P(t, "fancybox-protected"), n.appendChild(t);
            }
            if (o && r) {
                const s = e.contentRect, a = Math.max(s.fullWidth, s.fullHeight);
                let c = null;
                !r.opacity && a > 1200 && (c = document.createElement("img"), $6cce3a502c50d5fc$var$P(c, "fancybox-ghost"), c.src = o, n.appendChild(c));
                const h = ()=>{
                    c && ($6cce3a502c50d5fc$var$P(c, "f-fadeFastOut"), setTimeout(()=>{
                        c && (c.remove(), c = null);
                    }, 200));
                };
                (l = o, new Promise((t, e)=>{
                    const i = new Image;
                    i.onload = t, i.onerror = e, i.src = l;
                })).then(()=>{
                    i.hideLoading(t), t.state = $6cce3a502c50d5fc$var$lt.Opening, this.instance.emit("reveal", t), this.zoomIn(t).then(()=>{
                        h(), this.instance.done(t);
                    }, ()=>{}), c && setTimeout(()=>{
                        h();
                    }, a > 2500 ? 800 : 200);
                }, ()=>{
                    i.hideLoading(t), i.revealContent(t);
                });
            } else {
                const n = this.optionFor(t, "initialSize"), s = this.optionFor(t, "zoom"), o = {
                    event: i.prevMouseMoveEvent || i.options.event,
                    friction: s ? .12 : 0
                };
                let a = i.optionFor(t, "showClass") || void 0, r = !0;
                i.isOpeningSlide(t) && ("full" === n ? e.zoomToFull(o) : "cover" === n ? e.zoomToCover(o) : "max" === n ? e.zoomToMax(o) : r = !1, e.stop("current")), r && a && (a = e.isDragging ? "f-fadeIn" : ""), i.hideLoading(t), i.revealContent(t, a);
            }
            var l;
        }, ()=>{
            i.setError(t, "{{IMAGE_ERROR}}");
        });
    }
    process(t, e) {
        return new Promise((i, s)=>{
            var o;
            const a = this.instance, r = t.el;
            a.clearContent(t), a.showLoading(t);
            let l = this.optionFor(t, "content");
            if ("string" == typeof l && (l = $6cce3a502c50d5fc$var$n(l)), !l || !$6cce3a502c50d5fc$var$E(l)) {
                if (l = document.createElement("img"), l instanceof HTMLImageElement) {
                    let i = "", n = t.caption;
                    i = "string" == typeof n && n ? n.replace(/<[^>]+>/gi, "").substring(0, 1e3) : `Image ${t.index + 1} of ${(null === (o = a.carousel) || void 0 === o ? void 0 : o.pages.length) || 1}`, l.src = e || "", l.alt = i, l.draggable = !1, t.srcset && l.setAttribute("srcset", t.srcset), this.instance.isOpeningSlide(t) && (l.fetchPriority = "high");
                }
                t.sizes && l.setAttribute("sizes", t.sizes);
            }
            $6cce3a502c50d5fc$var$P(l, "fancybox-image"), t.imageEl = l, a.setContent(t, l, !1);
            t.panzoom = new $6cce3a502c50d5fc$export$b704d075ddd20210(r, $6cce3a502c50d5fc$var$u({
                transformParent: !0
            }, this.option("Panzoom") || {}, {
                content: l,
                width: (e, i)=>a.optionFor(t, "width", "auto", i) || "auto",
                height: (e, i)=>a.optionFor(t, "height", "auto", i) || "auto",
                wheel: ()=>{
                    const t = a.option("wheel");
                    return ("zoom" === t || "pan" == t) && t;
                },
                click: (e, i)=>{
                    var n, s;
                    if (a.isCompact || a.isClosing()) return !1;
                    if (t.index !== (null === (n = a.getSlide()) || void 0 === n ? void 0 : n.index)) return !1;
                    if (i) {
                        const t = i.composedPath()[0];
                        if ([
                            "A",
                            "BUTTON",
                            "TEXTAREA",
                            "OPTION",
                            "INPUT",
                            "SELECT",
                            "VIDEO"
                        ].includes(t.nodeName)) return !1;
                    }
                    let o = !i || i.target && (null === (s = t.contentEl) || void 0 === s ? void 0 : s.contains(i.target));
                    return a.option(o ? "contentClick" : "backdropClick") || !1;
                },
                dblClick: ()=>a.isCompact ? "toggleZoom" : a.option("contentDblClick") || !1,
                spinner: !1,
                panOnlyZoomed: !0,
                wheelLimit: 1 / 0,
                on: {
                    ready: (t)=>{
                        i(t);
                    },
                    error: ()=>{
                        s();
                    },
                    destroy: ()=>{
                        s();
                    }
                }
            }));
        });
    }
    zoomIn(t) {
        return new Promise((e, i)=>{
            const n = this.instance, s = n.container, { panzoom: o, contentEl: a, el: r } = t;
            o && o.updateMetrics();
            const l = this.getZoomInfo(t);
            if (!(l && r && a && o && s)) return void i();
            const { x: c, y: h, scale: d, opacity: u } = l, p = ()=>{
                t.state !== $6cce3a502c50d5fc$var$lt.Closing && (u && (a.style.opacity = Math.max(Math.min(1, 1 - (1 - o.scale) / (1 - d)), 0) + ""), o.scale >= 1 && o.scale > o.targetScale - .1 && e(o));
            }, f = (t)=>{
                (t.scale < .99 || t.scale > 1.01) && !t.isDragging || ($6cce3a502c50d5fc$var$S(s, $6cce3a502c50d5fc$var$yt), a.style.opacity = "", t.off("endAnimation", f), t.off("touchStart", f), t.off("afterTransform", p), e(t));
            };
            o.on("endAnimation", f), o.on("touchStart", f), o.on("afterTransform", p), o.on([
                "error",
                "destroy"
            ], ()=>{
                i();
            }), o.panTo({
                x: c,
                y: h,
                scale: d,
                friction: 0,
                ignoreBounds: !0
            }), o.stop("current");
            const g = {
                event: "mousemove" === o.panMode ? n.prevMouseMoveEvent || n.options.event : void 0
            }, m = this.optionFor(t, "initialSize");
            $6cce3a502c50d5fc$var$P(s, $6cce3a502c50d5fc$var$yt), n.hideLoading(t), "full" === m ? o.zoomToFull(g) : "cover" === m ? o.zoomToCover(g) : "max" === m ? o.zoomToMax(g) : o.reset(.172);
        });
    }
    getZoomInfo(t) {
        const { el: e, imageEl: i, thumbEl: n, panzoom: s } = t, o = this.instance, a = o.container;
        if (!e || !i || !n || !s || $6cce3a502c50d5fc$var$tt(n) < 3 || !this.optionFor(t, "zoom") || !a || o.state === $6cce3a502c50d5fc$var$rt.Destroy) return !1;
        if ("0" === getComputedStyle(a).getPropertyValue("--f-images-zoom")) return !1;
        const r = window.visualViewport || null;
        if (1 !== (r ? r.scale : 1)) return !1;
        let { top: l, left: c, width: h, height: d } = n.getBoundingClientRect(), { top: u, left: p, fitWidth: f, fitHeight: g } = s.contentRect;
        if (!(h && d && f && g)) return !1;
        const m = s.container.getBoundingClientRect();
        p += m.left, u += m.top;
        const v = -1 * (p + .5 * f - (c + .5 * h)), b = -1 * (u + .5 * g - (l + .5 * d)), y = h / f;
        let w = this.option("zoomOpacity") || !1;
        return "auto" === w && (w = Math.abs(h / d - f / g) > .1), {
            x: v,
            y: b,
            scale: y,
            opacity: w
        };
    }
    attach() {
        const t = this, e = t.instance;
        e.on("Carousel.change", t.onChange), e.on("Carousel.createSlide", t.onCreateSlide), e.on("Carousel.removeSlide", t.onRemoveSlide), e.on("close", t.onClose);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("Carousel.change", t.onChange), e.off("Carousel.createSlide", t.onCreateSlide), e.off("Carousel.removeSlide", t.onRemoveSlide), e.off("close", t.onClose);
    }
}
Object.defineProperty($6cce3a502c50d5fc$var$wt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        initialSize: "fit",
        Panzoom: {
            maxScale: 1
        },
        protected: !1,
        zoom: !0,
        zoomOpacity: "auto"
    }
}), "function" == typeof SuppressedError && SuppressedError;
const $6cce3a502c50d5fc$var$xt = "html", $6cce3a502c50d5fc$var$Et = "image", $6cce3a502c50d5fc$var$St = "map", $6cce3a502c50d5fc$var$Pt = "youtube", $6cce3a502c50d5fc$var$Ct = "vimeo", $6cce3a502c50d5fc$var$Tt = "html5video", $6cce3a502c50d5fc$var$Mt = (t, e = {})=>{
    const i = new URL(t), n = new URLSearchParams(i.search), s = new URLSearchParams;
    for (const [t, i] of [
        ...n,
        ...Object.entries(e)
    ]){
        let e = i + "";
        if ("t" === t) {
            let t = e.match(/((\d*)m)?(\d*)s?/);
            t && s.set("start", 60 * parseInt(t[2] || "0") + parseInt(t[3] || "0") + "");
        } else s.set(t, e);
    }
    let o = s + "", a = t.match(/#t=((.*)?\d+s)/);
    return a && (o += `#t=${a[1]}`), o;
}, $6cce3a502c50d5fc$var$Ot = {
    ajax: null,
    autoSize: !0,
    iframeAttr: {
        allow: "autoplay; fullscreen",
        scrolling: "auto"
    },
    preload: !0,
    videoAutoplay: !0,
    videoRatio: 16 / 9,
    videoTpl: '<video class="fancybox__html5video" playsinline controls controlsList="nodownload" poster="{{poster}}">\n  <source src="{{src}}" type="{{format}}" />Sorry, your browser doesn\'t support embedded videos.</video>',
    videoFormat: "",
    vimeo: {
        byline: 1,
        color: "00adef",
        controls: 1,
        dnt: 1,
        muted: 0
    },
    youtube: {
        controls: 1,
        enablejsapi: 1,
        nocookie: 1,
        rel: 0,
        fs: 1
    }
}, $6cce3a502c50d5fc$var$At = [
    "image",
    "html",
    "ajax",
    "inline",
    "clone",
    "iframe",
    "map",
    "pdf",
    "html5video",
    "youtube",
    "vimeo"
];
class $6cce3a502c50d5fc$var$Lt extends $6cce3a502c50d5fc$var$_ {
    onBeforeInitSlide(t, e, i) {
        this.processType(i);
    }
    onCreateSlide(t, e, i) {
        this.setContent(i);
    }
    onClearContent(t, e) {
        e.xhr && (e.xhr.abort(), e.xhr = null);
        const i = e.iframeEl;
        i && (i.onload = i.onerror = null, i.src = "//about:blank", e.iframeEl = null);
        const n = e.contentEl, s = e.placeholderEl;
        if ("inline" === e.type && n && s) n.classList.remove("fancybox__content"), "none" !== getComputedStyle(n).getPropertyValue("display") && (n.style.display = "none"), setTimeout(()=>{
            s && (n && s.parentNode && s.parentNode.insertBefore(n, s), s.remove());
        }, 0), e.contentEl = void 0, e.placeholderEl = void 0;
        else for(; e.el && e.el.firstChild;)e.el.removeChild(e.el.firstChild);
    }
    onSelectSlide(t, e, i) {
        i.state === $6cce3a502c50d5fc$var$lt.Ready && this.playVideo();
    }
    onUnselectSlide(t, e, i) {
        var n, s;
        if (i.type === $6cce3a502c50d5fc$var$Tt) {
            try {
                null === (s = null === (n = i.el) || void 0 === n ? void 0 : n.querySelector("video")) || void 0 === s || s.pause();
            } catch (t) {}
            return;
        }
        let o;
        i.type === $6cce3a502c50d5fc$var$Ct ? o = {
            method: "pause",
            value: "true"
        } : i.type === $6cce3a502c50d5fc$var$Pt && (o = {
            event: "command",
            func: "pauseVideo"
        }), o && i.iframeEl && i.iframeEl.contentWindow && i.iframeEl.contentWindow.postMessage(JSON.stringify(o), "*"), i.poller && clearTimeout(i.poller);
    }
    onDone(t, e) {
        t.isCurrentSlide(e) && !t.isClosing() && this.playVideo();
    }
    onRefresh(t, e) {
        e.slides.forEach((t)=>{
            t.el && (this.resizeIframe(t), this.setAspectRatio(t));
        });
    }
    onMessage(t) {
        try {
            let e = JSON.parse(t.data);
            if ("https://player.vimeo.com" === t.origin) {
                if ("ready" === e.event) for (let e of Array.from(document.getElementsByClassName("fancybox__iframe")))e instanceof HTMLIFrameElement && e.contentWindow === t.source && (e.dataset.ready = "true");
            } else if (t.origin.match(/^https:\/\/(www.)?youtube(-nocookie)?.com$/) && "onReady" === e.event) {
                const t = document.getElementById(e.id);
                t && (t.dataset.ready = "true");
            }
        } catch (t) {}
    }
    loadAjaxContent(t) {
        const e = this.instance.optionFor(t, "src") || "";
        this.instance.showLoading(t);
        const i = this.instance, n = new XMLHttpRequest;
        i.showLoading(t), n.onreadystatechange = function() {
            n.readyState === XMLHttpRequest.DONE && i.state === $6cce3a502c50d5fc$var$rt.Ready && (i.hideLoading(t), 200 === n.status ? i.setContent(t, n.responseText) : i.setError(t, 404 === n.status ? "{{AJAX_NOT_FOUND}}" : "{{AJAX_FORBIDDEN}}"));
        };
        const s = t.ajax || null;
        n.open(s ? "POST" : "GET", e + ""), n.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), n.setRequestHeader("X-Requested-With", "XMLHttpRequest"), n.send(s), t.xhr = n;
    }
    setInlineContent(t) {
        let e = null;
        if ($6cce3a502c50d5fc$var$E(t.src)) e = t.src;
        else if ("string" == typeof t.src) {
            const i = t.src.split("#", 2).pop();
            e = i ? document.getElementById(i) : null;
        }
        if (e) {
            if ("clone" === t.type || e.closest(".fancybox__slide")) {
                e = e.cloneNode(!0);
                const i = e.dataset.animationName;
                i && (e.classList.remove(i), delete e.dataset.animationName);
                let n = e.getAttribute("id");
                n = n ? `${n}--clone` : `clone-${this.instance.id}-${t.index}`, e.setAttribute("id", n);
            } else if (e.parentNode) {
                const i = document.createElement("div");
                i.classList.add("fancybox-placeholder"), e.parentNode.insertBefore(i, e), t.placeholderEl = i;
            }
            this.instance.setContent(t, e);
        } else this.instance.setError(t, "{{ELEMENT_NOT_FOUND}}");
    }
    setIframeContent(t) {
        const { src: e, el: i } = t;
        if (!e || "string" != typeof e || !i) return;
        i.classList.add("is-loading");
        const n = this.instance, s = document.createElement("iframe");
        s.className = "fancybox__iframe", s.setAttribute("id", `fancybox__iframe_${n.id}_${t.index}`);
        for (const [e, i] of Object.entries(this.optionFor(t, "iframeAttr") || {}))s.setAttribute(e, i);
        s.onerror = ()=>{
            n.setError(t, "{{IFRAME_ERROR}}");
        }, t.iframeEl = s;
        const o = this.optionFor(t, "preload");
        if ("iframe" !== t.type || !1 === o) return s.setAttribute("src", t.src + ""), n.setContent(t, s, !1), this.resizeIframe(t), void n.revealContent(t);
        n.showLoading(t), s.onload = ()=>{
            if (!s.src.length) return;
            const e = "true" !== s.dataset.ready;
            s.dataset.ready = "true", this.resizeIframe(t), e ? n.revealContent(t) : n.hideLoading(t);
        }, s.setAttribute("src", e), n.setContent(t, s, !1);
    }
    resizeIframe(t) {
        const { type: e, iframeEl: i } = t;
        if (e === $6cce3a502c50d5fc$var$Pt || e === $6cce3a502c50d5fc$var$Ct) return;
        const n = null == i ? void 0 : i.parentElement;
        if (!i || !n) return;
        let s = t.autoSize;
        void 0 === s && (s = this.optionFor(t, "autoSize"));
        let o = t.width || 0, a = t.height || 0;
        o && a && (s = !1);
        const r = n && n.style;
        if (!1 !== t.preload && !1 !== s && r) try {
            const t = window.getComputedStyle(n), e = parseFloat(t.paddingLeft) + parseFloat(t.paddingRight), s = parseFloat(t.paddingTop) + parseFloat(t.paddingBottom), l = i.contentWindow;
            if (l) {
                const t = l.document, i = t.getElementsByTagName($6cce3a502c50d5fc$var$xt)[0], n = t.body;
                r.width = "", n.style.overflow = "hidden", o = o || i.scrollWidth + e, r.width = `${o}px`, n.style.overflow = "", r.flex = "0 0 auto", r.height = `${n.scrollHeight}px`, a = i.scrollHeight + s;
            }
        } catch (t) {}
        if (o || a) {
            const t = {
                flex: "0 1 auto",
                width: "",
                height: ""
            };
            o && "auto" !== o && (t.width = `${o}px`), a && "auto" !== a && (t.height = `${a}px`), Object.assign(r, t);
        }
    }
    playVideo() {
        const t = this.instance.getSlide();
        if (!t) return;
        const { el: e } = t;
        if (!e || !e.offsetParent) return;
        if (!this.optionFor(t, "videoAutoplay")) return;
        if (t.type === $6cce3a502c50d5fc$var$Tt) try {
            const t = e.querySelector("video");
            if (t) {
                const e = t.play();
                void 0 !== e && e.then(()=>{}).catch((e)=>{
                    t.muted = !0, t.play();
                });
            }
        } catch (t) {}
        if (t.type !== $6cce3a502c50d5fc$var$Pt && t.type !== $6cce3a502c50d5fc$var$Ct) return;
        const i = ()=>{
            if (t.iframeEl && t.iframeEl.contentWindow) {
                let e;
                if ("true" === t.iframeEl.dataset.ready) return e = t.type === $6cce3a502c50d5fc$var$Pt ? {
                    event: "command",
                    func: "playVideo"
                } : {
                    method: "play",
                    value: "true"
                }, e && t.iframeEl.contentWindow.postMessage(JSON.stringify(e), "*"), void (t.poller = void 0);
                t.type === $6cce3a502c50d5fc$var$Pt && (e = {
                    event: "listening",
                    id: t.iframeEl.getAttribute("id")
                }, t.iframeEl.contentWindow.postMessage(JSON.stringify(e), "*"));
            }
            t.poller = setTimeout(i, 250);
        };
        i();
    }
    processType(t) {
        if (t.html) return t.type = $6cce3a502c50d5fc$var$xt, t.src = t.html, void (t.html = "");
        const e = this.instance.optionFor(t, "src", "");
        if (!e || "string" != typeof e) return;
        let i = t.type, n = null;
        if (n = e.match(/(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(?:watch\?(?:.*&)?v=|v\/|u\/|shorts\/|embed\/?)?(videoseries\?list=(?:.*)|[\w-]{11}|\?listType=(?:.*)&list=(?:.*))(?:.*)/i)) {
            const s = this.optionFor(t, $6cce3a502c50d5fc$var$Pt), { nocookie: o } = s, a = function(t, e) {
                var i = {};
                for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (i[n] = t[n]);
                if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
                    var s = 0;
                    for(n = Object.getOwnPropertySymbols(t); s < n.length; s++)e.indexOf(n[s]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[s]) && (i[n[s]] = t[n[s]]);
                }
                return i;
            }(s, [
                "nocookie"
            ]), r = `www.youtube${o ? "-nocookie" : ""}.com`, l = $6cce3a502c50d5fc$var$Mt(e, a), c = encodeURIComponent(n[2]);
            t.videoId = c, t.src = `https://${r}/embed/${c}?${l}`, t.thumbSrc = t.thumbSrc || `https://i.ytimg.com/vi/${c}/mqdefault.jpg`, i = $6cce3a502c50d5fc$var$Pt;
        } else if (n = e.match(/^.+vimeo.com\/(?:\/)?([\d]+)((\/|\?h=)([a-z0-9]+))?(.*)?/)) {
            const s = $6cce3a502c50d5fc$var$Mt(e, this.optionFor(t, $6cce3a502c50d5fc$var$Ct)), o = encodeURIComponent(n[1]), a = n[4] || "";
            t.videoId = o, t.src = `https://player.vimeo.com/video/${o}?${a ? `h=${a}${s ? "&" : ""}` : ""}${s}`, i = $6cce3a502c50d5fc$var$Ct;
        }
        if (!i && t.triggerEl) {
            const e = t.triggerEl.dataset.type;
            $6cce3a502c50d5fc$var$At.includes(e) && (i = e);
        }
        i || "string" == typeof e && ("#" === e.charAt(0) ? i = "inline" : (n = e.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i)) ? (i = $6cce3a502c50d5fc$var$Tt, t.videoFormat = t.videoFormat || "video/" + ("ogv" === n[1] ? "ogg" : n[1])) : e.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i) ? i = $6cce3a502c50d5fc$var$Et : e.match(/\.(pdf)((\?|#).*)?$/i) && (i = "pdf")), (n = e.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:(?:(?:maps\/(?:place\/(?:.*)\/)?\@(.*),(\d+.?\d+?)z))|(?:\?ll=))(.*)?/i)) ? (t.src = `https://maps.google.${n[1]}/?ll=${(n[2] ? n[2] + "&z=" + Math.floor(parseFloat(n[3])) + (n[4] ? n[4].replace(/^\//, "&") : "") : n[4] + "").replace(/\?/, "&")}&output=${n[4] && n[4].indexOf("layer=c") > 0 ? "svembed" : "embed"}`, i = $6cce3a502c50d5fc$var$St) : (n = e.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:maps\/search\/)(.*)/i)) && (t.src = `https://maps.google.${n[1]}/maps?q=${n[2].replace("query=", "q=").replace("api=1", "")}&output=embed`, i = $6cce3a502c50d5fc$var$St), i = i || this.instance.option("defaultType"), t.type = i, i === $6cce3a502c50d5fc$var$Et && (t.thumbSrc = t.thumbSrc || t.src);
    }
    setContent(t) {
        const e = this.instance.optionFor(t, "src") || "";
        if (t && t.type && e) {
            switch(t.type){
                case $6cce3a502c50d5fc$var$xt:
                    this.instance.setContent(t, e);
                    break;
                case $6cce3a502c50d5fc$var$Tt:
                    const i = this.option("videoTpl");
                    i && this.instance.setContent(t, i.replace(/\{\{src\}\}/gi, e + "").replace(/\{\{format\}\}/gi, this.optionFor(t, "videoFormat") || "").replace(/\{\{poster\}\}/gi, t.poster || t.thumbSrc || ""));
                    break;
                case "inline":
                case "clone":
                    this.setInlineContent(t);
                    break;
                case "ajax":
                    this.loadAjaxContent(t);
                    break;
                case "pdf":
                case $6cce3a502c50d5fc$var$St:
                case $6cce3a502c50d5fc$var$Pt:
                case $6cce3a502c50d5fc$var$Ct:
                    t.preload = !1;
                case "iframe":
                    this.setIframeContent(t);
            }
            this.setAspectRatio(t);
        }
    }
    setAspectRatio(t) {
        const e = t.contentEl;
        if (!(t.el && e && t.type && [
            $6cce3a502c50d5fc$var$Pt,
            $6cce3a502c50d5fc$var$Ct,
            $6cce3a502c50d5fc$var$Tt
        ].includes(t.type))) return;
        let i, n = t.width || "auto", s = t.height || "auto";
        if ("auto" === n || "auto" === s) {
            i = this.optionFor(t, "videoRatio");
            const e = (i + "").match(/(\d+)\s*\/\s?(\d+)/);
            i = e && e.length > 2 ? parseFloat(e[1]) / parseFloat(e[2]) : parseFloat(i + "");
        } else n && s && (i = n / s);
        if (!i) return;
        e.style.aspectRatio = "", e.style.width = "", e.style.height = "", e.offsetHeight;
        const o = e.getBoundingClientRect(), a = o.width || 1, r = o.height || 1;
        e.style.aspectRatio = i + "", i < a / r ? (s = "auto" === s ? r : Math.min(r, s), e.style.width = "auto", e.style.height = `${s}px`) : (n = "auto" === n ? a : Math.min(a, n), e.style.width = `${n}px`, e.style.height = "auto");
    }
    attach() {
        const t = this, e = t.instance;
        e.on("Carousel.beforeInitSlide", t.onBeforeInitSlide), e.on("Carousel.createSlide", t.onCreateSlide), e.on("Carousel.selectSlide", t.onSelectSlide), e.on("Carousel.unselectSlide", t.onUnselectSlide), e.on("Carousel.Panzoom.refresh", t.onRefresh), e.on("done", t.onDone), e.on("clearContent", t.onClearContent), window.addEventListener("message", t.onMessage);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("Carousel.beforeInitSlide", t.onBeforeInitSlide), e.off("Carousel.createSlide", t.onCreateSlide), e.off("Carousel.selectSlide", t.onSelectSlide), e.off("Carousel.unselectSlide", t.onUnselectSlide), e.off("Carousel.Panzoom.refresh", t.onRefresh), e.off("done", t.onDone), e.off("clearContent", t.onClearContent), window.removeEventListener("message", t.onMessage);
    }
}
Object.defineProperty($6cce3a502c50d5fc$var$Lt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $6cce3a502c50d5fc$var$Ot
});
const $6cce3a502c50d5fc$var$zt = "play", $6cce3a502c50d5fc$var$Rt = "pause", $6cce3a502c50d5fc$var$kt = "ready";
class $6cce3a502c50d5fc$var$It extends $6cce3a502c50d5fc$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $6cce3a502c50d5fc$var$kt
        }), Object.defineProperty(this, "inHover", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "timer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "progressBar", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    get isActive() {
        return this.state !== $6cce3a502c50d5fc$var$kt;
    }
    onReady(t) {
        this.option("autoStart") && (t.isInfinite || t.page < t.pages.length - 1) && this.start();
    }
    onChange() {
        this.removeProgressBar(), this.pause();
    }
    onSettle() {
        this.resume();
    }
    onVisibilityChange() {
        "visible" === document.visibilityState ? this.resume() : this.pause();
    }
    onMouseEnter() {
        this.inHover = !0, this.pause();
    }
    onMouseLeave() {
        var t;
        this.inHover = !1, (null === (t = this.instance.panzoom) || void 0 === t ? void 0 : t.isResting) && this.resume();
    }
    onTimerEnd() {
        const t = this.instance;
        "play" === this.state && (t.isInfinite || t.page !== t.pages.length - 1 ? t.slideNext() : t.slideTo(0));
    }
    removeProgressBar() {
        this.progressBar && (this.progressBar.remove(), this.progressBar = null);
    }
    createProgressBar() {
        var t;
        if (!this.option("showProgress")) return null;
        this.removeProgressBar();
        const e = this.instance, i = (null === (t = e.pages[e.page]) || void 0 === t ? void 0 : t.slides) || [];
        let n = this.option("progressParentEl");
        if (n || (n = (1 === i.length ? i[0].el : null) || e.viewport), !n) return null;
        const s = document.createElement("div");
        return $6cce3a502c50d5fc$var$P(s, "f-progress"), n.prepend(s), this.progressBar = s, s.offsetHeight, s;
    }
    set() {
        const t = this, e = t.instance;
        if (e.pages.length < 2) return;
        if (t.timer) return;
        const i = t.option("timeout");
        t.state = $6cce3a502c50d5fc$var$zt, $6cce3a502c50d5fc$var$P(e.container, "has-autoplay");
        let n = t.createProgressBar();
        n && (n.style.transitionDuration = `${i}ms`, n.style.transform = "scaleX(1)"), t.timer = setTimeout(()=>{
            t.timer = null, t.inHover || t.onTimerEnd();
        }, i), t.emit("set");
    }
    clear() {
        const t = this;
        t.timer && (clearTimeout(t.timer), t.timer = null), t.removeProgressBar();
    }
    start() {
        const t = this;
        if (t.set(), t.state !== $6cce3a502c50d5fc$var$kt) {
            if (t.option("pauseOnHover")) {
                const e = t.instance.container;
                e.addEventListener("mouseenter", t.onMouseEnter, !1), e.addEventListener("mouseleave", t.onMouseLeave, !1);
            }
            document.addEventListener("visibilitychange", t.onVisibilityChange, !1), t.emit("start");
        }
    }
    stop() {
        const t = this, e = t.state, i = t.instance.container;
        t.clear(), t.state = $6cce3a502c50d5fc$var$kt, i.removeEventListener("mouseenter", t.onMouseEnter, !1), i.removeEventListener("mouseleave", t.onMouseLeave, !1), document.removeEventListener("visibilitychange", t.onVisibilityChange, !1), $6cce3a502c50d5fc$var$S(i, "has-autoplay"), e !== $6cce3a502c50d5fc$var$kt && t.emit("stop");
    }
    pause() {
        const t = this;
        t.state === $6cce3a502c50d5fc$var$zt && (t.state = $6cce3a502c50d5fc$var$Rt, t.clear(), t.emit($6cce3a502c50d5fc$var$Rt));
    }
    resume() {
        const t = this, e = t.instance;
        if (e.isInfinite || e.page !== e.pages.length - 1) {
            if (t.state !== $6cce3a502c50d5fc$var$zt) {
                if (t.state === $6cce3a502c50d5fc$var$Rt && !t.inHover) {
                    const e = new Event("resume", {
                        bubbles: !0,
                        cancelable: !0
                    });
                    t.emit("resume", e), e.defaultPrevented || t.set();
                }
            } else t.set();
        } else t.stop();
    }
    toggle() {
        this.state === $6cce3a502c50d5fc$var$zt || this.state === $6cce3a502c50d5fc$var$Rt ? this.stop() : this.start();
    }
    attach() {
        const t = this, e = t.instance;
        e.on("ready", t.onReady), e.on("Panzoom.startAnimation", t.onChange), e.on("Panzoom.endAnimation", t.onSettle), e.on("Panzoom.touchMove", t.onChange);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("ready", t.onReady), e.off("Panzoom.startAnimation", t.onChange), e.off("Panzoom.endAnimation", t.onSettle), e.off("Panzoom.touchMove", t.onChange), t.stop();
    }
}
Object.defineProperty($6cce3a502c50d5fc$var$It, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        autoStart: !0,
        pauseOnHover: !0,
        progressParentEl: null,
        showProgress: !0,
        timeout: 3e3
    }
});
class $6cce3a502c50d5fc$var$Dt extends $6cce3a502c50d5fc$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "ref", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    onPrepare(t) {
        const e = t.carousel;
        if (!e) return;
        const i = t.container;
        i && (e.options.Autoplay = $6cce3a502c50d5fc$var$u({
            autoStart: !1
        }, this.option("Autoplay") || {}, {
            pauseOnHover: !1,
            timeout: this.option("timeout"),
            progressParentEl: ()=>this.option("progressParentEl") || null,
            on: {
                start: ()=>{
                    t.emit("startSlideshow");
                },
                set: (e)=>{
                    var n;
                    i.classList.add("has-slideshow"), (null === (n = t.getSlide()) || void 0 === n ? void 0 : n.state) !== $6cce3a502c50d5fc$var$lt.Ready && e.pause();
                },
                stop: ()=>{
                    i.classList.remove("has-slideshow"), t.isCompact || t.endIdle(), t.emit("endSlideshow");
                },
                resume: (e, i)=>{
                    var n, s, o;
                    !i || !i.cancelable || (null === (n = t.getSlide()) || void 0 === n ? void 0 : n.state) === $6cce3a502c50d5fc$var$lt.Ready && (null === (o = null === (s = t.carousel) || void 0 === s ? void 0 : s.panzoom) || void 0 === o ? void 0 : o.isResting) || i.preventDefault();
                }
            }
        }), e.attachPlugins({
            Autoplay: $6cce3a502c50d5fc$var$It
        }), this.ref = e.plugins.Autoplay);
    }
    onReady(t) {
        const e = t.carousel, i = this.ref;
        i && e && this.option("playOnStart") && (e.isInfinite || e.page < e.pages.length - 1) && i.start();
    }
    onDone(t, e) {
        const i = this.ref, n = t.carousel;
        if (!i || !n) return;
        const s = e.panzoom;
        s && s.on("startAnimation", ()=>{
            t.isCurrentSlide(e) && i.stop();
        }), t.isCurrentSlide(e) && i.resume();
    }
    onKeydown(t, e) {
        var i;
        const n = this.ref;
        n && e === this.option("key") && "BUTTON" !== (null === (i = document.activeElement) || void 0 === i ? void 0 : i.nodeName) && n.toggle();
    }
    attach() {
        const t = this, e = t.instance;
        e.on("Carousel.init", t.onPrepare), e.on("Carousel.ready", t.onReady), e.on("done", t.onDone), e.on("keydown", t.onKeydown);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("Carousel.init", t.onPrepare), e.off("Carousel.ready", t.onReady), e.off("done", t.onDone), e.off("keydown", t.onKeydown);
    }
}
Object.defineProperty($6cce3a502c50d5fc$var$Dt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        key: " ",
        playOnStart: !1,
        progressParentEl: (t)=>{
            var e;
            return (null === (e = t.instance.container) || void 0 === e ? void 0 : e.querySelector(".fancybox__toolbar [data-fancybox-toggle-slideshow]")) || t.instance.container;
        },
        timeout: 3e3
    }
});
const $6cce3a502c50d5fc$var$Ft = {
    classes: {
        container: "f-thumbs f-carousel__thumbs",
        viewport: "f-thumbs__viewport",
        track: "f-thumbs__track",
        slide: "f-thumbs__slide",
        isResting: "is-resting",
        isSelected: "is-selected",
        isLoading: "is-loading",
        hasThumbs: "has-thumbs"
    },
    minCount: 2,
    parentEl: null,
    thumbTpl: '<button class="f-thumbs__slide__button" tabindex="0" type="button" aria-label="{{GOTO}}" data-carousel-index="%i"><img class="f-thumbs__slide__img" data-lazy-src="{{%s}}" alt="" /></button>',
    type: "modern"
};
var $6cce3a502c50d5fc$var$jt;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Hidden = 2] = "Hidden";
}($6cce3a502c50d5fc$var$jt || ($6cce3a502c50d5fc$var$jt = {}));
const $6cce3a502c50d5fc$var$Bt = "isResting", $6cce3a502c50d5fc$var$Ht = "thumbWidth", $6cce3a502c50d5fc$var$Nt = "thumbHeight", $6cce3a502c50d5fc$var$_t = "thumbClipWidth";
let $6cce3a502c50d5fc$var$$t = class extends $6cce3a502c50d5fc$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "type", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "modern"
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "track", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "carousel", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "thumbWidth", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "thumbClipWidth", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "thumbHeight", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "thumbGap", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "thumbExtraGap", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $6cce3a502c50d5fc$var$jt.Init
        });
    }
    get isModern() {
        return "modern" === this.type;
    }
    onInitSlide(t, e) {
        const i = e.el ? e.el.dataset : void 0;
        i && (e.thumbSrc = i.thumbSrc || e.thumbSrc || "", e[$6cce3a502c50d5fc$var$_t] = parseFloat(i[$6cce3a502c50d5fc$var$_t] || "") || e[$6cce3a502c50d5fc$var$_t] || 0, e[$6cce3a502c50d5fc$var$Nt] = parseFloat(i.thumbHeight || "") || e[$6cce3a502c50d5fc$var$Nt] || 0), this.addSlide(e);
    }
    onInitSlides() {
        this.build();
    }
    onChange() {
        var t;
        if (!this.isModern) return;
        const e = this.container, i = this.instance, n = i.panzoom, s = this.carousel, a = s ? s.panzoom : null, r = i.page;
        if (n && s && a) {
            if (n.isDragging) {
                $6cce3a502c50d5fc$var$S(e, this.cn($6cce3a502c50d5fc$var$Bt));
                let n = (null === (t = s.pages[r]) || void 0 === t ? void 0 : t.pos) || 0;
                n += i.getProgress(r) * (this[$6cce3a502c50d5fc$var$_t] + this.thumbGap);
                let o = a.getBounds();
                -1 * n > o.x.min && -1 * n < o.x.max && a.panTo({
                    x: -1 * n,
                    friction: .12
                });
            } else $6cce3a502c50d5fc$var$o(e, this.cn($6cce3a502c50d5fc$var$Bt), n.isResting);
            this.shiftModern();
        }
    }
    onRefresh() {
        this.updateProps();
        for (const t of this.instance.slides || [])this.resizeModernSlide(t);
        this.shiftModern();
    }
    isDisabled() {
        const t = this.option("minCount") || 0;
        if (t) {
            const e = this.instance;
            let i = 0;
            for (const t of e.slides || [])t.thumbSrc && i++;
            if (i < t) return !0;
        }
        const e = this.option("type");
        return [
            "modern",
            "classic"
        ].indexOf(e) < 0;
    }
    getThumb(t) {
        const e = this.option("thumbTpl") || "";
        return {
            html: this.instance.localize(e, [
                [
                    "%i",
                    t.index
                ],
                [
                    "%d",
                    t.index + 1
                ],
                [
                    "%s",
                    t.thumbSrc || "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                ]
            ])
        };
    }
    addSlide(t) {
        const e = this.carousel;
        e && e.addSlide(t.index, this.getThumb(t));
    }
    getSlides() {
        const t = [];
        for (const e of this.instance.slides || [])t.push(this.getThumb(e));
        return t;
    }
    resizeModernSlide(t) {
        this.isModern && (t[$6cce3a502c50d5fc$var$Ht] = t[$6cce3a502c50d5fc$var$_t] && t[$6cce3a502c50d5fc$var$Nt] ? Math.round(this[$6cce3a502c50d5fc$var$Nt] * (t[$6cce3a502c50d5fc$var$_t] / t[$6cce3a502c50d5fc$var$Nt])) : this[$6cce3a502c50d5fc$var$Ht]);
    }
    updateProps() {
        const t = this.container;
        if (!t) return;
        const e = (e)=>parseFloat(getComputedStyle(t).getPropertyValue("--f-thumb-" + e)) || 0;
        this.thumbGap = e("gap"), this.thumbExtraGap = e("extra-gap"), this[$6cce3a502c50d5fc$var$Ht] = e("width") || 40, this[$6cce3a502c50d5fc$var$_t] = e("clip-width") || 40, this[$6cce3a502c50d5fc$var$Nt] = e("height") || 40;
    }
    build() {
        const t = this;
        if (t.state !== $6cce3a502c50d5fc$var$jt.Init) return;
        if (t.isDisabled()) return void t.emit("disabled");
        const e = t.instance, i = e.container, n = t.getSlides(), s = t.option("type");
        t.type = s;
        const o = t.option("parentEl"), a = t.cn("container"), r = t.cn("track");
        let l = null == o ? void 0 : o.querySelector("." + a);
        l || (l = document.createElement("div"), $6cce3a502c50d5fc$var$P(l, a), o ? o.appendChild(l) : i.after(l)), $6cce3a502c50d5fc$var$P(l, `is-${s}`), $6cce3a502c50d5fc$var$P(i, t.cn("hasThumbs")), t.container = l, t.updateProps();
        let c = l.querySelector("." + r);
        c || (c = document.createElement("div"), $6cce3a502c50d5fc$var$P(c, t.cn("track")), l.appendChild(c)), t.track = c;
        const h = $6cce3a502c50d5fc$var$u({}, {
            track: c,
            infinite: !1,
            center: !0,
            fill: "classic" === s,
            dragFree: !0,
            slidesPerPage: 1,
            transition: !1,
            preload: .25,
            friction: .12,
            Panzoom: {
                maxVelocity: 0
            },
            Dots: !1,
            Navigation: !1,
            classes: {
                container: "f-thumbs",
                viewport: "f-thumbs__viewport",
                track: "f-thumbs__track",
                slide: "f-thumbs__slide"
            }
        }, t.option("Carousel") || {}, {
            Sync: {
                target: e
            },
            slides: n
        }), d = new e.constructor(l, h);
        d.on("createSlide", (e, i)=>{
            t.setProps(i.index), t.emit("createSlide", i, i.el);
        }), d.on("ready", ()=>{
            t.shiftModern(), t.emit("ready");
        }), d.on("refresh", ()=>{
            t.shiftModern();
        }), d.on("Panzoom.click", (e, i, n)=>{
            t.onClick(n);
        }), t.carousel = d, t.state = $6cce3a502c50d5fc$var$jt.Ready;
    }
    onClick(t) {
        t.preventDefault(), t.stopPropagation();
        const e = this.instance, { pages: i, page: n } = e, s = (t)=>{
            if (t) {
                const e = t.closest("[data-carousel-index]");
                if (e) return [
                    parseInt(e.dataset.carouselIndex || "", 10) || 0,
                    e
                ];
            }
            return [
                -1,
                void 0
            ];
        }, o = (t, e)=>{
            const i = document.elementFromPoint(t, e);
            return i ? s(i) : [
                -1,
                void 0
            ];
        };
        let [a, r] = s(t.target);
        if (a > -1) return;
        const l = this[$6cce3a502c50d5fc$var$_t], c = t.clientX, h = t.clientY;
        let [d, u] = o(c - l, h), [p, f] = o(c + l, h);
        u && f ? (a = Math.abs(c - u.getBoundingClientRect().right) < Math.abs(c - f.getBoundingClientRect().left) ? d : p, a === n && (a = a === d ? p : d)) : u ? a = d : f && (a = p), a > -1 && i[a] && e.slideTo(a);
    }
    getShift(t) {
        var e;
        const i = this, { instance: n } = i, s = i.carousel;
        if (!n || !s) return 0;
        const o = i[$6cce3a502c50d5fc$var$Ht], a = i[$6cce3a502c50d5fc$var$_t], r = i.thumbGap, l = i.thumbExtraGap;
        if (!(null === (e = s.slides[t]) || void 0 === e ? void 0 : e.el)) return 0;
        const c = .5 * (o - a), h = n.pages.length - 1;
        let d = n.getProgress(0), u = n.getProgress(h), p = n.getProgress(t, !1, !0), f = 0, g = c + l + r;
        const m = d < 0 && d > -1, v = u > 0 && u < 1;
        return 0 === t ? (f = g * Math.abs(d), v && 1 === d && (f -= g * Math.abs(u))) : t === h ? (f = g * Math.abs(u) * -1, m && -1 === u && (f += g * Math.abs(d))) : m || v ? (f = -1 * g, f += g * Math.abs(d), f += g * (1 - Math.abs(u))) : f = g * p, f;
    }
    setProps(e) {
        var i;
        const n = this;
        if (!n.isModern) return;
        const { instance: s } = n, o = n.carousel;
        if (s && o) {
            const a = null === (i = o.slides[e]) || void 0 === i ? void 0 : i.el;
            if (a && a.childNodes.length) {
                let i = $6cce3a502c50d5fc$var$t(1 - Math.abs(s.getProgress(e))), o = $6cce3a502c50d5fc$var$t(n.getShift(e));
                a.style.setProperty("--progress", i ? i + "" : ""), a.style.setProperty("--shift", o + "");
            }
        }
    }
    shiftModern() {
        const t = this;
        if (!t.isModern) return;
        const { instance: e, track: i } = t, n = e.panzoom, s = t.carousel;
        if (!(e && i && n && s)) return;
        if (n.state === $6cce3a502c50d5fc$var$m.Init || n.state === $6cce3a502c50d5fc$var$m.Destroy) return;
        for (const i of e.slides)t.setProps(i.index);
        let o = (t[$6cce3a502c50d5fc$var$_t] + t.thumbGap) * (s.slides.length || 0);
        i.style.setProperty("--width", o + "");
    }
    cleanup() {
        const t = this;
        t.carousel && t.carousel.destroy(), t.carousel = null, t.container && t.container.remove(), t.container = null, t.track && t.track.remove(), t.track = null, t.state = $6cce3a502c50d5fc$var$jt.Init, $6cce3a502c50d5fc$var$S(t.instance.container, t.cn("hasThumbs"));
    }
    attach() {
        const t = this, e = t.instance;
        e.on("initSlide", t.onInitSlide), e.state === $6cce3a502c50d5fc$var$B.Init ? e.on("initSlides", t.onInitSlides) : t.onInitSlides(), e.on([
            "change",
            "Panzoom.afterTransform"
        ], t.onChange), e.on("Panzoom.refresh", t.onRefresh);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("initSlide", t.onInitSlide), e.off("initSlides", t.onInitSlides), e.off([
            "change",
            "Panzoom.afterTransform"
        ], t.onChange), e.off("Panzoom.refresh", t.onRefresh), t.cleanup();
    }
};
Object.defineProperty($6cce3a502c50d5fc$var$$t, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $6cce3a502c50d5fc$var$Ft
});
const $6cce3a502c50d5fc$var$Wt = Object.assign(Object.assign({}, $6cce3a502c50d5fc$var$Ft), {
    key: "t",
    showOnStart: !0,
    parentEl: null
}), $6cce3a502c50d5fc$var$Xt = "is-masked", $6cce3a502c50d5fc$var$qt = "aria-hidden";
class $6cce3a502c50d5fc$var$Yt extends $6cce3a502c50d5fc$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "ref", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "hidden", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        });
    }
    get isEnabled() {
        const t = this.ref;
        return t && !t.isDisabled();
    }
    get isHidden() {
        return this.hidden;
    }
    onClick(t, e) {
        e.stopPropagation();
    }
    onCreateSlide(t, e) {
        var i, n, s;
        const o = (null === (s = null === (n = null === (i = this.instance) || void 0 === i ? void 0 : i.carousel) || void 0 === n ? void 0 : n.slides[e.index]) || void 0 === s ? void 0 : s.type) || "", a = e.el;
        if (a && o) {
            let t = `for-${o}`;
            [
                "video",
                "youtube",
                "vimeo",
                "html5video"
            ].includes(o) && (t += " for-video"), $6cce3a502c50d5fc$var$P(a, t);
        }
    }
    onInit() {
        var t;
        const e = this, i = e.instance, n = i.carousel;
        if (e.ref || !n) return;
        const s = e.option("parentEl") || i.footer || i.container;
        if (!s) return;
        const o = $6cce3a502c50d5fc$var$u({}, e.options, {
            parentEl: s,
            classes: {
                container: "f-thumbs fancybox__thumbs"
            },
            Carousel: {
                Sync: {
                    friction: i.option("Carousel.friction") || 0
                }
            },
            on: {
                ready: (t)=>{
                    const i = t.container;
                    i && this.hidden && (e.refresh(), i.style.transition = "none", e.hide(), i.offsetHeight, queueMicrotask(()=>{
                        i.style.transition = "", e.show();
                    }));
                }
            }
        });
        o.Carousel = o.Carousel || {}, o.Carousel.on = $6cce3a502c50d5fc$var$u((null === (t = e.options.Carousel) || void 0 === t ? void 0 : t.on) || {}, {
            click: this.onClick,
            createSlide: this.onCreateSlide
        }), n.options.Thumbs = o, n.attachPlugins({
            Thumbs: $6cce3a502c50d5fc$var$$t
        }), e.ref = n.plugins.Thumbs, e.option("showOnStart") || (e.ref.state = $6cce3a502c50d5fc$var$jt.Hidden, e.hidden = !0);
    }
    onResize() {
        var t;
        const e = null === (t = this.ref) || void 0 === t ? void 0 : t.container;
        e && (e.style.maxHeight = "");
    }
    onKeydown(t, e) {
        const i = this.option("key");
        i && i === e && this.toggle();
    }
    toggle() {
        const t = this.ref;
        if (t && !t.isDisabled()) return t.state === $6cce3a502c50d5fc$var$jt.Hidden ? (t.state = $6cce3a502c50d5fc$var$jt.Init, void t.build()) : void (this.hidden ? this.show() : this.hide());
    }
    show() {
        const t = this.ref;
        if (!t || t.isDisabled()) return;
        const e = t.container;
        e && (this.refresh(), e.offsetHeight, e.removeAttribute($6cce3a502c50d5fc$var$qt), e.classList.remove($6cce3a502c50d5fc$var$Xt), this.hidden = !1);
    }
    hide() {
        const t = this.ref, e = t && t.container;
        e && (this.refresh(), e.offsetHeight, e.classList.add($6cce3a502c50d5fc$var$Xt), e.setAttribute($6cce3a502c50d5fc$var$qt, "true")), this.hidden = !0;
    }
    refresh() {
        const t = this.ref;
        if (!t || !t.state) return;
        const e = t.container, i = (null == e ? void 0 : e.firstChild) || null;
        e && i && i.childNodes.length && (e.style.maxHeight = `${i.getBoundingClientRect().height}px`);
    }
    attach() {
        const t = this, e = t.instance;
        e.state === $6cce3a502c50d5fc$var$rt.Init ? e.on("Carousel.init", t.onInit) : t.onInit(), e.on("resize", t.onResize), e.on("keydown", t.onKeydown);
    }
    detach() {
        var t;
        const e = this, i = e.instance;
        i.off("Carousel.init", e.onInit), i.off("resize", e.onResize), i.off("keydown", e.onKeydown), null === (t = i.carousel) || void 0 === t || t.detachPlugins([
            "Thumbs"
        ]), e.ref = null;
    }
}
Object.defineProperty($6cce3a502c50d5fc$var$Yt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $6cce3a502c50d5fc$var$Wt
});
const $6cce3a502c50d5fc$var$Vt = {
    panLeft: {
        icon: '<svg><path d="M5 12h14M5 12l6 6M5 12l6-6"/></svg>',
        change: {
            panX: -100
        }
    },
    panRight: {
        icon: '<svg><path d="M5 12h14M13 18l6-6M13 6l6 6"/></svg>',
        change: {
            panX: 100
        }
    },
    panUp: {
        icon: '<svg><path d="M12 5v14M18 11l-6-6M6 11l6-6"/></svg>',
        change: {
            panY: -100
        }
    },
    panDown: {
        icon: '<svg><path d="M12 5v14M18 13l-6 6M6 13l6 6"/></svg>',
        change: {
            panY: 100
        }
    },
    zoomIn: {
        icon: '<svg><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M11 8v6M8 11h6"/></svg>',
        action: "zoomIn"
    },
    zoomOut: {
        icon: '<svg><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>',
        action: "zoomOut"
    },
    toggle1to1: {
        icon: '<svg><path d="M3.51 3.07c5.74.02 11.48-.02 17.22.02 1.37.1 2.34 1.64 2.18 3.13 0 4.08.02 8.16 0 12.23-.1 1.54-1.47 2.64-2.79 2.46-5.61-.01-11.24.02-16.86-.01-1.36-.12-2.33-1.65-2.17-3.14 0-4.07-.02-8.16 0-12.23.1-1.36 1.22-2.48 2.42-2.46Z"/><path d="M5.65 8.54h1.49v6.92m8.94-6.92h1.49v6.92M11.5 9.4v.02m0 5.18v0"/></svg>',
        action: "toggleZoom"
    },
    toggleZoom: {
        icon: '<svg><g><line x1="11" y1="8" x2="11" y2="14"></line></g><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>',
        action: "toggleZoom"
    },
    iterateZoom: {
        icon: '<svg><g><line x1="11" y1="8" x2="11" y2="14"></line></g><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>',
        action: "iterateZoom"
    },
    rotateCCW: {
        icon: '<svg><path d="M15 4.55a8 8 0 0 0-6 14.9M9 15v5H4M18.37 7.16v.01M13 19.94v.01M16.84 18.37v.01M19.37 15.1v.01M19.94 11v.01"/></svg>',
        action: "rotateCCW"
    },
    rotateCW: {
        icon: '<svg><path d="M9 4.55a8 8 0 0 1 6 14.9M15 15v5h5M5.63 7.16v.01M4.06 11v.01M4.63 15.1v.01M7.16 18.37v.01M11 19.94v.01"/></svg>',
        action: "rotateCW"
    },
    flipX: {
        icon: '<svg style="stroke-width: 1.3"><path d="M12 3v18M16 7v10h5L16 7M8 7v10H3L8 7"/></svg>',
        action: "flipX"
    },
    flipY: {
        icon: '<svg style="stroke-width: 1.3"><path d="M3 12h18M7 16h10L7 21v-5M7 8h10L7 3v5"/></svg>',
        action: "flipY"
    },
    fitX: {
        icon: '<svg><path d="M4 12V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6M10 18H3M21 18h-7M6 15l-3 3 3 3M18 15l3 3-3 3"/></svg>',
        action: "fitX"
    },
    fitY: {
        icon: '<svg><path d="M12 20H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h6M18 14v7M18 3v7M15 18l3 3 3-3M15 6l3-3 3 3"/></svg>',
        action: "fitY"
    },
    reset: {
        icon: '<svg><path d="M20 11A8.1 8.1 0 0 0 4.5 9M4 5v4h4M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"/></svg>',
        action: "reset"
    },
    toggleFS: {
        icon: '<svg><g><path d="M14.5 9.5 21 3m0 0h-6m6 0v6M3 21l6.5-6.5M3 21v-6m0 6h6"/></g><g><path d="m14 10 7-7m-7 7h6m-6 0V4M3 21l7-7m0 0v6m0-6H4"/></g></svg>',
        action: "toggleFS"
    }
};
var $6cce3a502c50d5fc$var$Zt;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Disabled = 2] = "Disabled";
}($6cce3a502c50d5fc$var$Zt || ($6cce3a502c50d5fc$var$Zt = {}));
const $6cce3a502c50d5fc$var$Ut = {
    absolute: "auto",
    display: {
        left: [
            "infobar"
        ],
        middle: [],
        right: [
            "iterateZoom",
            "slideshow",
            "fullscreen",
            "thumbs",
            "close"
        ]
    },
    enabled: "auto",
    items: {
        infobar: {
            tpl: '<div class="fancybox__infobar" tabindex="-1"><span data-fancybox-current-index></span>/<span data-fancybox-count></span></div>'
        },
        download: {
            tpl: '<a class="f-button" title="{{DOWNLOAD}}" data-fancybox-download href="javasript:;"><svg><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2M7 11l5 5 5-5M12 4v12"/></svg></a>'
        },
        prev: {
            tpl: '<button class="f-button" title="{{PREV}}" data-fancybox-prev><svg><path d="m15 6-6 6 6 6"/></svg></button>'
        },
        next: {
            tpl: '<button class="f-button" title="{{NEXT}}" data-fancybox-next><svg><path d="m9 6 6 6-6 6"/></svg></button>'
        },
        slideshow: {
            tpl: '<button class="f-button" title="{{TOGGLE_SLIDESHOW}}" data-fancybox-toggle-slideshow><svg><g><path d="M8 4v16l13 -8z"></path></g><g><path d="M8 4v15M17 4v15"/></g></svg></button>'
        },
        fullscreen: {
            tpl: '<button class="f-button" title="{{TOGGLE_FULLSCREEN}}" data-fancybox-toggle-fullscreen><svg><g><path d="M4 8V6a2 2 0 0 1 2-2h2M4 16v2a2 2 0 0 0 2 2h2M16 4h2a2 2 0 0 1 2 2v2M16 20h2a2 2 0 0 0 2-2v-2"/></g><g><path d="M15 19v-2a2 2 0 0 1 2-2h2M15 5v2a2 2 0 0 0 2 2h2M5 15h2a2 2 0 0 1 2 2v2M5 9h2a2 2 0 0 0 2-2V5"/></g></svg></button>'
        },
        thumbs: {
            tpl: '<button class="f-button" title="{{TOGGLE_THUMBS}}" data-fancybox-toggle-thumbs><svg><circle cx="5.5" cy="5.5" r="1"/><circle cx="12" cy="5.5" r="1"/><circle cx="18.5" cy="5.5" r="1"/><circle cx="5.5" cy="12" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="18.5" cy="12" r="1"/><circle cx="5.5" cy="18.5" r="1"/><circle cx="12" cy="18.5" r="1"/><circle cx="18.5" cy="18.5" r="1"/></svg></button>'
        },
        close: {
            tpl: '<button class="f-button" title="{{CLOSE}}" data-fancybox-close><svg><path d="m19.5 4.5-15 15M4.5 4.5l15 15"/></svg></button>'
        }
    },
    parentEl: null
}, $6cce3a502c50d5fc$var$Gt = {
    tabindex: "-1",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
}, $6cce3a502c50d5fc$var$Kt = "has-toolbar", $6cce3a502c50d5fc$var$Jt = "fancybox__toolbar";
class $6cce3a502c50d5fc$var$Qt extends $6cce3a502c50d5fc$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $6cce3a502c50d5fc$var$Zt.Init
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    onReady(t) {
        var e;
        if (!t.carousel) return;
        let i = this.option("display"), n = this.option("absolute"), s = this.option("enabled");
        if ("auto" === s) {
            const t = this.instance.carousel;
            let e = 0;
            if (t) for (const i of t.slides)(i.panzoom || "image" === i.type) && e++;
            e || (s = !1);
        }
        s || (i = void 0);
        let o = 0;
        const a = {
            left: [],
            middle: [],
            right: []
        };
        if (i) for (const t of [
            "left",
            "middle",
            "right"
        ])for (const n of i[t]){
            const i = this.createEl(n);
            i && (null === (e = a[t]) || void 0 === e || e.push(i), o++);
        }
        let r = null;
        if (o && (r = this.createContainer()), r) {
            for (const [t, e] of Object.entries(a)){
                const i = document.createElement("div");
                $6cce3a502c50d5fc$var$P(i, $6cce3a502c50d5fc$var$Jt + "__column is-" + t);
                for (const t of e)i.appendChild(t);
                "auto" !== n || "middle" !== t || e.length || (n = !0), r.appendChild(i);
            }
            !0 === n && $6cce3a502c50d5fc$var$P(r, "is-absolute"), this.state = $6cce3a502c50d5fc$var$Zt.Ready, this.onRefresh();
        } else this.state = $6cce3a502c50d5fc$var$Zt.Disabled;
    }
    onClick(t) {
        var e, i;
        const n = this.instance, s = n.getSlide(), o = null == s ? void 0 : s.panzoom, a = t.target, r = a && $6cce3a502c50d5fc$var$E(a) ? a.dataset : null;
        if (!r) return;
        if (void 0 !== r.fancyboxToggleThumbs) return t.preventDefault(), t.stopPropagation(), void (null === (e = n.plugins.Thumbs) || void 0 === e || e.toggle());
        if (void 0 !== r.fancyboxToggleFullscreen) return t.preventDefault(), t.stopPropagation(), void this.instance.toggleFullscreen();
        if (void 0 !== r.fancyboxToggleSlideshow) {
            t.preventDefault(), t.stopPropagation();
            const e = null === (i = n.carousel) || void 0 === i ? void 0 : i.plugins.Autoplay;
            let s = e.isActive;
            return o && "mousemove" === o.panMode && !s && o.reset(), void (s ? e.stop() : e.start());
        }
        const l = r.panzoomAction, c = r.panzoomChange;
        if ((c || l) && (t.preventDefault(), t.stopPropagation()), c) {
            let t = {};
            try {
                t = JSON.parse(c);
            } catch (t) {}
            o && o.applyChange(t);
        } else l && o && o[l] && o[l]();
    }
    onChange() {
        this.onRefresh();
    }
    onRefresh() {
        if (this.instance.isClosing()) return;
        const t = this.container;
        if (!t) return;
        const e = this.instance.getSlide();
        if (!e || e.state !== $6cce3a502c50d5fc$var$lt.Ready) return;
        const i = e && !e.error && e.panzoom;
        for (const e of t.querySelectorAll("[data-panzoom-action]"))i ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
        let n = i && i.canZoomIn(), s = i && i.canZoomOut();
        for (const e of t.querySelectorAll('[data-panzoom-action="zoomIn"]'))n ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
        for (const e of t.querySelectorAll('[data-panzoom-action="zoomOut"]'))s ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
        for (const e of t.querySelectorAll('[data-panzoom-action="toggleZoom"],[data-panzoom-action="iterateZoom"]')){
            s || n ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
            const t = e.querySelector("g");
            t && (t.style.display = n ? "" : "none");
        }
    }
    onDone(t, e) {
        var i;
        null === (i = e.panzoom) || void 0 === i || i.on("afterTransform", ()=>{
            this.instance.isCurrentSlide(e) && this.onRefresh();
        }), this.instance.isCurrentSlide(e) && this.onRefresh();
    }
    createContainer() {
        const t = this.instance.container;
        if (!t) return null;
        const e = this.option("parentEl") || t;
        let i = e.querySelector("." + $6cce3a502c50d5fc$var$Jt);
        return i || (i = document.createElement("div"), $6cce3a502c50d5fc$var$P(i, $6cce3a502c50d5fc$var$Jt), e.prepend(i)), i.addEventListener("click", this.onClick, {
            passive: !1,
            capture: !0
        }), t && $6cce3a502c50d5fc$var$P(t, $6cce3a502c50d5fc$var$Kt), this.container = i, i;
    }
    createEl(t) {
        const e = this.instance, i = e.carousel;
        if (!i) return null;
        if ("toggleFS" === t) return null;
        if ("fullscreen" === t && !$6cce3a502c50d5fc$var$ot()) return null;
        let s = null;
        const o = i.slides.length || 0;
        let a = 0, r = 0;
        for (const t of i.slides)(t.panzoom || "image" === t.type) && a++, ("image" === t.type || t.downloadSrc) && r++;
        if (o < 2 && [
            "infobar",
            "prev",
            "next"
        ].includes(t)) return s;
        if (void 0 !== $6cce3a502c50d5fc$var$Vt[t] && !a) return null;
        if ("download" === t && !r) return null;
        if ("thumbs" === t) {
            const t = e.plugins.Thumbs;
            if (!t || !t.isEnabled) return null;
        }
        if ("slideshow" === t) {
            if (!i.plugins.Autoplay || o < 2) return null;
        }
        if (void 0 !== $6cce3a502c50d5fc$var$Vt[t]) {
            const e = $6cce3a502c50d5fc$var$Vt[t];
            s = document.createElement("button"), s.setAttribute("title", this.instance.localize(`{{${t.toUpperCase()}}}`)), $6cce3a502c50d5fc$var$P(s, "f-button"), e.action && (s.dataset.panzoomAction = e.action), e.change && (s.dataset.panzoomChange = JSON.stringify(e.change)), s.appendChild($6cce3a502c50d5fc$var$n(this.instance.localize(e.icon)));
        } else {
            const e = (this.option("items") || [])[t];
            e && (s = $6cce3a502c50d5fc$var$n(this.instance.localize(e.tpl)), "function" == typeof e.click && s.addEventListener("click", (t)=>{
                t.preventDefault(), t.stopPropagation(), "function" == typeof e.click && e.click.call(this, this, t);
            }));
        }
        const l = null == s ? void 0 : s.querySelector("svg");
        if (l) for (const [t, e] of Object.entries($6cce3a502c50d5fc$var$Gt))l.getAttribute(t) || l.setAttribute(t, String(e));
        return s;
    }
    removeContainer() {
        const t = this.container;
        t && t.remove(), this.container = null, this.state = $6cce3a502c50d5fc$var$Zt.Disabled;
        const e = this.instance.container;
        e && $6cce3a502c50d5fc$var$S(e, $6cce3a502c50d5fc$var$Kt);
    }
    attach() {
        const t = this, e = t.instance;
        e.on("Carousel.initSlides", t.onReady), e.on("done", t.onDone), e.on([
            "reveal",
            "Carousel.change"
        ], t.onChange), t.onReady(t.instance);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("Carousel.initSlides", t.onReady), e.off("done", t.onDone), e.off([
            "reveal",
            "Carousel.change"
        ], t.onChange), t.removeContainer();
    }
}
Object.defineProperty($6cce3a502c50d5fc$var$Qt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $6cce3a502c50d5fc$var$Ut
});
const $6cce3a502c50d5fc$var$te = {
    Hash: class extends $6cce3a502c50d5fc$var$_ {
        onReady() {
            $6cce3a502c50d5fc$var$ht = !1;
        }
        onChange(t) {
            $6cce3a502c50d5fc$var$ut && clearTimeout($6cce3a502c50d5fc$var$ut);
            const { hash: e } = $6cce3a502c50d5fc$var$pt(), { hash: i } = $6cce3a502c50d5fc$var$ft(), n = t.isOpeningSlide(t.getSlide());
            n && ($6cce3a502c50d5fc$var$ct = i === e ? "" : i), e && e !== i && ($6cce3a502c50d5fc$var$ut = setTimeout(()=>{
                try {
                    if (t.state === $6cce3a502c50d5fc$var$rt.Ready) {
                        let t = "replaceState";
                        n && !$6cce3a502c50d5fc$var$dt && (t = "pushState", $6cce3a502c50d5fc$var$dt = !0), window.history[t]({}, document.title, window.location.pathname + window.location.search + e);
                    }
                } catch (t) {}
            }, 300));
        }
        onClose(t) {
            if ($6cce3a502c50d5fc$var$ut && clearTimeout($6cce3a502c50d5fc$var$ut), !$6cce3a502c50d5fc$var$ht && $6cce3a502c50d5fc$var$dt) return $6cce3a502c50d5fc$var$dt = !1, $6cce3a502c50d5fc$var$ht = !1, void window.history.back();
            if (!$6cce3a502c50d5fc$var$ht) try {
                window.history.replaceState({}, document.title, window.location.pathname + window.location.search + ($6cce3a502c50d5fc$var$ct || ""));
            } catch (t) {}
        }
        attach() {
            const t = this.instance;
            t.on("ready", this.onReady), t.on([
                "Carousel.ready",
                "Carousel.change"
            ], this.onChange), t.on("close", this.onClose);
        }
        detach() {
            const t = this.instance;
            t.off("ready", this.onReady), t.off([
                "Carousel.ready",
                "Carousel.change"
            ], this.onChange), t.off("close", this.onClose);
        }
        static parseURL() {
            return $6cce3a502c50d5fc$var$ft();
        }
        static startFromUrl() {
            $6cce3a502c50d5fc$var$gt();
        }
        static destroy() {
            window.removeEventListener("hashchange", $6cce3a502c50d5fc$var$vt, !1);
        }
    },
    Html: $6cce3a502c50d5fc$var$Lt,
    Images: $6cce3a502c50d5fc$var$wt,
    Slideshow: $6cce3a502c50d5fc$var$Dt,
    Thumbs: $6cce3a502c50d5fc$var$Yt,
    Toolbar: $6cce3a502c50d5fc$var$Qt
}, $6cce3a502c50d5fc$var$ee = "with-fancybox", $6cce3a502c50d5fc$var$ie = "hide-scrollbar", $6cce3a502c50d5fc$var$ne = "--fancybox-scrollbar-compensate", $6cce3a502c50d5fc$var$se = "--fancybox-body-margin", $6cce3a502c50d5fc$var$oe = "aria-hidden", $6cce3a502c50d5fc$var$ae = "is-using-tab", $6cce3a502c50d5fc$var$re = "is-animated", $6cce3a502c50d5fc$var$le = "is-compact", $6cce3a502c50d5fc$var$ce = "is-loading", $6cce3a502c50d5fc$var$he = "is-opening", $6cce3a502c50d5fc$var$de = "has-caption", $6cce3a502c50d5fc$var$ue = "disabled", $6cce3a502c50d5fc$var$pe = "tabindex", $6cce3a502c50d5fc$var$fe = "download", $6cce3a502c50d5fc$var$ge = "href", $6cce3a502c50d5fc$var$me = "src", $6cce3a502c50d5fc$var$ve = (t)=>"string" == typeof t, $6cce3a502c50d5fc$var$be = function() {
    var t = window.getSelection();
    return !!t && "Range" === t.type;
};
let $6cce3a502c50d5fc$var$ye, $6cce3a502c50d5fc$var$we = null, $6cce3a502c50d5fc$var$xe = null, $6cce3a502c50d5fc$var$Ee = 0, $6cce3a502c50d5fc$var$Se = 0, $6cce3a502c50d5fc$var$Pe = 0, $6cce3a502c50d5fc$var$Ce = 0;
const $6cce3a502c50d5fc$var$Te = new Map;
let $6cce3a502c50d5fc$var$Me = 0;
class $6cce3a502c50d5fc$export$cb45b08d97cdc4fd extends $6cce3a502c50d5fc$var$g {
    get isIdle() {
        return this.idle;
    }
    get isCompact() {
        return this.option("compact");
    }
    constructor(t = [], e = {}, i = {}){
        super(e), Object.defineProperty(this, "userSlides", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "userPlugins", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        }), Object.defineProperty(this, "idle", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "idleTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "clickTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "pwt", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "ignoreFocusChange", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "startedFs", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $6cce3a502c50d5fc$var$rt.Init
        }), Object.defineProperty(this, "id", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "caption", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "footer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "carousel", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "lastFocus", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "prevMouseMoveEvent", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), $6cce3a502c50d5fc$var$ye || ($6cce3a502c50d5fc$var$ye = $6cce3a502c50d5fc$var$ot()), this.id = e.id || ++$6cce3a502c50d5fc$var$Me, $6cce3a502c50d5fc$var$Te.set(this.id, this), this.userSlides = t, this.userPlugins = i, queueMicrotask(()=>{
            this.init();
        });
    }
    init() {
        if (this.state === $6cce3a502c50d5fc$var$rt.Destroy) return;
        this.state = $6cce3a502c50d5fc$var$rt.Init, this.attachPlugins(Object.assign(Object.assign({}, $6cce3a502c50d5fc$export$cb45b08d97cdc4fd.Plugins), this.userPlugins)), this.emit("init"), this.emit("attachPlugins"), !0 === this.option("hideScrollbar") && (()=>{
            if (!$6cce3a502c50d5fc$var$et) return;
            const t = document, e = t.body, i = t.documentElement;
            if (e.classList.contains($6cce3a502c50d5fc$var$ie)) return;
            let n = window.innerWidth - i.getBoundingClientRect().width;
            const s = parseFloat(window.getComputedStyle(e).marginRight);
            n < 0 && (n = 0), i.style.setProperty($6cce3a502c50d5fc$var$ne, `${n}px`), s && e.style.setProperty($6cce3a502c50d5fc$var$se, `${s}px`), e.classList.add($6cce3a502c50d5fc$var$ie);
        })(), this.initLayout(), this.scale();
        const t = ()=>{
            this.initCarousel(this.userSlides), this.state = $6cce3a502c50d5fc$var$rt.Ready, this.attachEvents(), this.emit("ready"), setTimeout(()=>{
                this.container && this.container.setAttribute($6cce3a502c50d5fc$var$oe, "false");
            }, 16);
        };
        this.option("Fullscreen.autoStart") && $6cce3a502c50d5fc$var$ye && !$6cce3a502c50d5fc$var$ye.isFullscreen() ? $6cce3a502c50d5fc$var$ye.request().then(()=>{
            this.startedFs = !0, t();
        }).catch(()=>t()) : t();
    }
    initLayout() {
        var t, e;
        const i = this.option("parentEl") || document.body, s = $6cce3a502c50d5fc$var$n(this.localize(this.option("tpl.main") || ""));
        if (s) {
            if (s.setAttribute("id", `fancybox-${this.id}`), s.setAttribute("aria-label", this.localize("{{MODAL}}")), s.classList.toggle($6cce3a502c50d5fc$var$le, this.isCompact), $6cce3a502c50d5fc$var$P(s, this.option("mainClass") || ""), $6cce3a502c50d5fc$var$P(s, $6cce3a502c50d5fc$var$he), this.container = s, this.footer = s.querySelector(".fancybox__footer"), i.appendChild(s), $6cce3a502c50d5fc$var$P(document.documentElement, $6cce3a502c50d5fc$var$ee), $6cce3a502c50d5fc$var$we && $6cce3a502c50d5fc$var$xe || ($6cce3a502c50d5fc$var$we = document.createElement("span"), $6cce3a502c50d5fc$var$P($6cce3a502c50d5fc$var$we, "fancybox-focus-guard"), $6cce3a502c50d5fc$var$we.setAttribute($6cce3a502c50d5fc$var$pe, "0"), $6cce3a502c50d5fc$var$we.setAttribute($6cce3a502c50d5fc$var$oe, "true"), $6cce3a502c50d5fc$var$we.setAttribute("aria-label", "Focus guard"), $6cce3a502c50d5fc$var$xe = $6cce3a502c50d5fc$var$we.cloneNode(), null === (t = s.parentElement) || void 0 === t || t.insertBefore($6cce3a502c50d5fc$var$we, s), null === (e = s.parentElement) || void 0 === e || e.append($6cce3a502c50d5fc$var$xe)), s.addEventListener("mousedown", (t)=>{
                $6cce3a502c50d5fc$var$Ee = t.pageX, $6cce3a502c50d5fc$var$Se = t.pageY, $6cce3a502c50d5fc$var$S(s, $6cce3a502c50d5fc$var$ae);
            }), this.option("closeExisting")) for (const t of $6cce3a502c50d5fc$var$Te.values())t.id !== this.id && t.close();
            else this.option("animated") && ($6cce3a502c50d5fc$var$P(s, $6cce3a502c50d5fc$var$re), setTimeout(()=>{
                this.isClosing() || $6cce3a502c50d5fc$var$S(s, $6cce3a502c50d5fc$var$re);
            }, 350));
            this.emit("initLayout");
        }
    }
    initCarousel(t) {
        const i = this.container;
        if (!i) return;
        const n = i.querySelector(".fancybox__carousel");
        if (!n) return;
        const s = this.carousel = new $6cce3a502c50d5fc$export$144901db2ea8e967(n, $6cce3a502c50d5fc$var$u({}, {
            slides: t,
            transition: "fade",
            Panzoom: {
                lockAxis: this.option("dragToClose") ? "xy" : "x",
                infinite: !!this.option("dragToClose") && "y"
            },
            Dots: !1,
            Navigation: {
                classes: {
                    container: "fancybox__nav",
                    button: "f-button",
                    isNext: "is-next",
                    isPrev: "is-prev"
                }
            },
            initialPage: this.option("startIndex"),
            l10n: this.option("l10n")
        }, this.option("Carousel") || {}));
        s.on("*", (t, e, ...i)=>{
            this.emit(`Carousel.${e}`, t, ...i);
        }), s.on([
            "ready",
            "change"
        ], ()=>{
            this.manageCaption();
        }), this.on("Carousel.removeSlide", (t, e, i)=>{
            this.clearContent(i), i.state = void 0;
        }), s.on("Panzoom.touchStart", ()=>{
            var t, e;
            this.isCompact || this.endIdle(), (null === (t = document.activeElement) || void 0 === t ? void 0 : t.closest(".f-thumbs")) && (null === (e = this.container) || void 0 === e || e.focus());
        }), s.on("settle", ()=>{
            this.idleTimer || this.isCompact || !this.option("idle") || this.setIdle(), this.option("autoFocus") && !this.isClosing && this.checkFocus();
        }), this.option("dragToClose") && (s.on("Panzoom.afterTransform", (t, i)=>{
            const n = this.getSlide();
            if (n && $6cce3a502c50d5fc$var$e(n.el)) return;
            const s = this.container;
            if (s) {
                const t = Math.abs(i.current.f), e = t < 1 ? "" : Math.max(.5, Math.min(1, 1 - t / i.contentRect.fitHeight * 1.5));
                s.style.setProperty("--fancybox-ts", e ? "0s" : ""), s.style.setProperty("--fancybox-opacity", e + "");
            }
        }), s.on("Panzoom.touchEnd", (t, i, n)=>{
            var s;
            const o = this.getSlide();
            if (o && $6cce3a502c50d5fc$var$e(o.el)) return;
            if (i.isMobile && document.activeElement && -1 !== [
                "TEXTAREA",
                "INPUT"
            ].indexOf(null === (s = document.activeElement) || void 0 === s ? void 0 : s.nodeName)) return;
            const a = Math.abs(i.dragOffset.y);
            "y" === i.lockedAxis && (a >= 200 || a >= 50 && i.dragOffset.time < 300) && (n && n.cancelable && n.preventDefault(), this.close(n, "f-throwOut" + (i.current.f < 0 ? "Up" : "Down")));
        })), s.on("change", (t)=>{
            var e;
            let i = null === (e = this.getSlide()) || void 0 === e ? void 0 : e.triggerEl;
            if (i) {
                const e = new CustomEvent("slideTo", {
                    bubbles: !0,
                    cancelable: !0,
                    detail: t.page
                });
                i.dispatchEvent(e);
            }
        }), s.on([
            "refresh",
            "change"
        ], (t)=>{
            const e = this.container;
            if (!e) return;
            for (const i of e.querySelectorAll("[data-fancybox-current-index]"))i.innerHTML = t.page + 1;
            for (const i of e.querySelectorAll("[data-fancybox-count]"))i.innerHTML = t.pages.length;
            if (!t.isInfinite) {
                for (const i of e.querySelectorAll("[data-fancybox-next]"))t.page < t.pages.length - 1 ? (i.removeAttribute($6cce3a502c50d5fc$var$ue), i.removeAttribute($6cce3a502c50d5fc$var$pe)) : (i.setAttribute($6cce3a502c50d5fc$var$ue, ""), i.setAttribute($6cce3a502c50d5fc$var$pe, "-1"));
                for (const i of e.querySelectorAll("[data-fancybox-prev]"))t.page > 0 ? (i.removeAttribute($6cce3a502c50d5fc$var$ue), i.removeAttribute($6cce3a502c50d5fc$var$pe)) : (i.setAttribute($6cce3a502c50d5fc$var$ue, ""), i.setAttribute($6cce3a502c50d5fc$var$pe, "-1"));
            }
            const i = this.getSlide();
            if (!i) return;
            let n = i.downloadSrc || "";
            n || "image" !== i.type || i.error || !$6cce3a502c50d5fc$var$ve(i[$6cce3a502c50d5fc$var$me]) || (n = i[$6cce3a502c50d5fc$var$me]);
            for (const t of e.querySelectorAll("[data-fancybox-download]")){
                const e = i.downloadFilename;
                n ? (t.removeAttribute($6cce3a502c50d5fc$var$ue), t.removeAttribute($6cce3a502c50d5fc$var$pe), t.setAttribute($6cce3a502c50d5fc$var$ge, n), t.setAttribute($6cce3a502c50d5fc$var$fe, e || n), t.setAttribute("target", "_blank")) : (t.setAttribute($6cce3a502c50d5fc$var$ue, ""), t.setAttribute($6cce3a502c50d5fc$var$pe, "-1"), t.removeAttribute($6cce3a502c50d5fc$var$ge), t.removeAttribute($6cce3a502c50d5fc$var$fe));
            }
        }), this.emit("initCarousel");
    }
    attachEvents() {
        const t = this, e = t.container;
        if (!e) return;
        e.addEventListener("click", t.onClick, {
            passive: !1,
            capture: !1
        }), e.addEventListener("wheel", t.onWheel, {
            passive: !1,
            capture: !1
        }), document.addEventListener("keydown", t.onKeydown, {
            passive: !1,
            capture: !0
        }), document.addEventListener("visibilitychange", t.onVisibilityChange, !1), document.addEventListener("mousemove", t.onMousemove), t.option("trapFocus") && document.addEventListener("focus", t.onFocus, !0), window.addEventListener("resize", t.onResize);
        const i = window.visualViewport;
        i && (i.addEventListener("scroll", t.onResize), i.addEventListener("resize", t.onResize));
    }
    detachEvents() {
        const t = this, e = t.container;
        if (!e) return;
        document.removeEventListener("keydown", t.onKeydown, {
            passive: !1,
            capture: !0
        }), e.removeEventListener("wheel", t.onWheel, {
            passive: !1,
            capture: !1
        }), e.removeEventListener("click", t.onClick, {
            passive: !1,
            capture: !1
        }), document.removeEventListener("mousemove", t.onMousemove), window.removeEventListener("resize", t.onResize);
        const i = window.visualViewport;
        i && (i.removeEventListener("resize", t.onResize), i.removeEventListener("scroll", t.onResize)), document.removeEventListener("visibilitychange", t.onVisibilityChange, !1), document.removeEventListener("focus", t.onFocus, !0);
    }
    scale() {
        const t = this.container;
        if (!t) return;
        const e = window.visualViewport, i = Math.max(1, (null == e ? void 0 : e.scale) || 1);
        let n = "", s = "", o = "";
        if (e && i > 1) {
            let t = `${e.offsetLeft}px`, a = `${e.offsetTop}px`;
            n = e.width * i + "px", s = e.height * i + "px", o = `translate3d(${t}, ${a}, 0) scale(${1 / i})`;
        }
        t.style.transform = o, t.style.width = n, t.style.height = s;
    }
    onClick(t) {
        var e;
        const { container: i, isCompact: n } = this;
        if (!i || this.isClosing()) return;
        !n && this.option("idle") && this.resetIdle();
        const s = t.composedPath()[0];
        if (s.closest(".fancybox-spinner") || s.closest("[data-fancybox-close]")) return t.preventDefault(), void this.close(t);
        if (s.closest("[data-fancybox-prev]")) return t.preventDefault(), void this.prev();
        if (s.closest("[data-fancybox-next]")) return t.preventDefault(), void this.next();
        if ("click" === t.type && 0 === t.detail) return;
        if (Math.abs(t.pageX - $6cce3a502c50d5fc$var$Ee) > 30 || Math.abs(t.pageY - $6cce3a502c50d5fc$var$Se) > 30) return;
        const o = document.activeElement;
        if ($6cce3a502c50d5fc$var$be() && o && i.contains(o)) return;
        if (n && "image" === (null === (e = this.getSlide()) || void 0 === e ? void 0 : e.type)) return void (this.clickTimer ? (clearTimeout(this.clickTimer), this.clickTimer = null) : this.clickTimer = setTimeout(()=>{
            this.toggleIdle(), this.clickTimer = null;
        }, 350));
        if (this.emit("click", t), t.defaultPrevented) return;
        let a = !1;
        if (s.closest(".fancybox__content")) {
            if (o) {
                if (o.closest("[contenteditable]")) return;
                s.matches($6cce3a502c50d5fc$var$nt) || o.blur();
            }
            if ($6cce3a502c50d5fc$var$be()) return;
            a = this.option("contentClick");
        } else s.closest(".fancybox__carousel") && !s.matches($6cce3a502c50d5fc$var$nt) && (a = this.option("backdropClick"));
        "close" === a ? (t.preventDefault(), this.close(t)) : "next" === a ? (t.preventDefault(), this.next()) : "prev" === a && (t.preventDefault(), this.prev());
    }
    onWheel(t) {
        const e = t.target;
        let n = this.option("wheel", t);
        e.closest(".fancybox__thumbs") && (n = "slide");
        const s = "slide" === n, o = [
            -t.deltaX || 0,
            -t.deltaY || 0,
            -t.detail || 0
        ].reduce(function(t, e) {
            return Math.abs(e) > Math.abs(t) ? e : t;
        }), a = Math.max(-1, Math.min(1, o)), r = Date.now();
        this.pwt && r - this.pwt < 300 ? s && t.preventDefault() : (this.pwt = r, this.emit("wheel", t, a), t.defaultPrevented || ("close" === n ? (t.preventDefault(), this.close(t)) : "slide" === n && ($6cce3a502c50d5fc$var$i(e) || (t.preventDefault(), this[a > 0 ? "prev" : "next"]()))));
    }
    onScroll() {
        window.scrollTo($6cce3a502c50d5fc$var$Pe, $6cce3a502c50d5fc$var$Ce);
    }
    onKeydown(t) {
        if (!this.isTopmost()) return;
        this.isCompact || !this.option("idle") || this.isClosing() || this.resetIdle();
        const e = t.key, i = this.option("keyboard");
        if (!i) return;
        const n = t.composedPath()[0], s = document.activeElement && document.activeElement.classList, o = s && s.contains("f-button") || n.dataset.carouselPage || n.dataset.carouselIndex;
        if ("Escape" !== e && !o && $6cce3a502c50d5fc$var$E(n)) {
            if (n.isContentEditable || -1 !== [
                "TEXTAREA",
                "OPTION",
                "INPUT",
                "SELECT",
                "VIDEO"
            ].indexOf(n.nodeName)) return;
        }
        if ("Tab" === t.key ? $6cce3a502c50d5fc$var$P(this.container, $6cce3a502c50d5fc$var$ae) : $6cce3a502c50d5fc$var$S(this.container, $6cce3a502c50d5fc$var$ae), t.ctrlKey || t.altKey || t.shiftKey) return;
        this.emit("keydown", e, t);
        const a = i[e];
        a && "function" == typeof this[a] && (t.preventDefault(), this[a]());
    }
    onResize() {
        const t = this.container;
        if (!t) return;
        const e = this.isCompact;
        t.classList.toggle($6cce3a502c50d5fc$var$le, e), this.manageCaption(this.getSlide()), this.isCompact ? this.clearIdle() : this.endIdle(), this.scale(), this.emit("resize");
    }
    onFocus(t) {
        this.isTopmost() && this.checkFocus(t);
    }
    onMousemove(t) {
        this.prevMouseMoveEvent = t, !this.isCompact && this.option("idle") && this.resetIdle();
    }
    onVisibilityChange() {
        "visible" === document.visibilityState ? this.checkFocus() : this.endIdle();
    }
    manageCloseBtn(t) {
        const e = this.optionFor(t, "closeButton") || !1;
        if ("auto" === e) {
            const t = this.plugins.Toolbar;
            if (t && t.state === $6cce3a502c50d5fc$var$Zt.Ready) return;
        }
        if (!e) return;
        if (!t.contentEl || t.closeBtnEl) return;
        const i = this.option("tpl.closeButton");
        if (i) {
            const e = $6cce3a502c50d5fc$var$n(this.localize(i));
            t.closeBtnEl = t.contentEl.appendChild(e), t.el && $6cce3a502c50d5fc$var$P(t.el, "has-close-btn");
        }
    }
    manageCaption(t) {
        var e, i;
        const n = "fancybox__caption", s = this.container;
        if (!s) return;
        $6cce3a502c50d5fc$var$S(s, $6cce3a502c50d5fc$var$de);
        const o = this.isCompact || this.option("commonCaption"), a = !o;
        if (this.caption && this.stop(this.caption), a && this.caption && (this.caption.remove(), this.caption = null), o && !this.caption) for (const t of (null === (e = this.carousel) || void 0 === e ? void 0 : e.slides) || [])t.captionEl && (t.captionEl.remove(), t.captionEl = void 0, $6cce3a502c50d5fc$var$S(t.el, $6cce3a502c50d5fc$var$de), null === (i = t.el) || void 0 === i || i.removeAttribute("aria-labelledby"));
        if (t || (t = this.getSlide()), !t || o && !this.isCurrentSlide(t)) return;
        const r = t.el;
        let l = this.optionFor(t, "caption", "");
        if (!l) return void (o && this.caption && this.animate(this.caption, "f-fadeOut", ()=>{
            this.caption && (this.caption.innerHTML = "");
        }));
        let c = null;
        if (a) {
            if (c = t.captionEl || null, r && !c) {
                const e = n + `_${this.id}_${t.index}`;
                c = document.createElement("div"), $6cce3a502c50d5fc$var$P(c, n), c.setAttribute("id", e), t.captionEl = r.appendChild(c), $6cce3a502c50d5fc$var$P(r, $6cce3a502c50d5fc$var$de), r.setAttribute("aria-labelledby", e);
            }
        } else {
            if (c = this.caption, c || (c = s.querySelector("." + n)), !c) {
                c = document.createElement("div"), c.dataset.fancyboxCaption = "", $6cce3a502c50d5fc$var$P(c, n);
                (this.footer || s).prepend(c);
            }
            $6cce3a502c50d5fc$var$P(s, $6cce3a502c50d5fc$var$de), this.caption = c;
        }
        c && (c.innerHTML = "", $6cce3a502c50d5fc$var$ve(l) || "number" == typeof l ? c.innerHTML = l + "" : l instanceof HTMLElement && c.appendChild(l));
    }
    checkFocus(t) {
        this.focus(t);
    }
    focus(t) {
        var e;
        if (this.ignoreFocusChange) return;
        const i = document.activeElement || null, n = (null == t ? void 0 : t.target) || null, s = this.container, o = null === (e = this.carousel) || void 0 === e ? void 0 : e.viewport;
        if (!s || !o) return;
        if (!t && i && s.contains(i)) return;
        const a = this.getSlide(), r = a && a.state === $6cce3a502c50d5fc$var$lt.Ready ? a.el : null;
        if (!r || r.contains(i) || s === i) return;
        t && t.cancelable && t.preventDefault(), this.ignoreFocusChange = !0;
        const l = Array.from(s.querySelectorAll($6cce3a502c50d5fc$var$nt));
        let c = [], h = null;
        for (let t of l){
            const e = !t.offsetParent || !!t.closest('[aria-hidden="true"]'), i = r && r.contains(t), n = !o.contains(t);
            if (t === s || (i || n) && !e) {
                c.push(t);
                const e = t.dataset.origTabindex;
                void 0 !== e && e && (t.tabIndex = parseFloat(e)), t.removeAttribute("data-orig-tabindex"), !t.hasAttribute("autoFocus") && h || (h = t);
            } else {
                const e = void 0 === t.dataset.origTabindex ? t.getAttribute("tabindex") || "" : t.dataset.origTabindex;
                e && (t.dataset.origTabindex = e), t.tabIndex = -1;
            }
        }
        let d = null;
        t ? (!n || c.indexOf(n) < 0) && (d = h || s, c.length && (i === $6cce3a502c50d5fc$var$xe ? d = c[0] : this.lastFocus !== s && i !== $6cce3a502c50d5fc$var$we || (d = c[c.length - 1]))) : d = a && "image" === a.type ? s : h || s, d && $6cce3a502c50d5fc$var$st(d), this.lastFocus = document.activeElement, this.ignoreFocusChange = !1;
    }
    next() {
        const t = this.carousel;
        t && t.pages.length > 1 && t.slideNext();
    }
    prev() {
        const t = this.carousel;
        t && t.pages.length > 1 && t.slidePrev();
    }
    jumpTo(...t) {
        this.carousel && this.carousel.slideTo(...t);
    }
    isTopmost() {
        var t;
        return (null === (t = $6cce3a502c50d5fc$export$cb45b08d97cdc4fd.getInstance()) || void 0 === t ? void 0 : t.id) == this.id;
    }
    animate(t = null, e = "", i) {
        if (!t || !e) return void (i && i());
        this.stop(t);
        const n = (s)=>{
            s.target === t && t.dataset.animationName && (t.removeEventListener("animationend", n), delete t.dataset.animationName, i && i(), $6cce3a502c50d5fc$var$S(t, e));
        };
        t.dataset.animationName = e, t.addEventListener("animationend", n), $6cce3a502c50d5fc$var$P(t, e);
    }
    stop(t) {
        t && t.dispatchEvent(new CustomEvent("animationend", {
            bubbles: !1,
            cancelable: !0,
            currentTarget: t
        }));
    }
    setContent(t, e = "", i = !0) {
        if (this.isClosing()) return;
        const s = t.el;
        if (!s) return;
        let o = null;
        if ($6cce3a502c50d5fc$var$E(e) ? o = e : (o = $6cce3a502c50d5fc$var$n(e + ""), $6cce3a502c50d5fc$var$E(o) || (o = document.createElement("div"), o.innerHTML = e + "")), [
            "img",
            "picture",
            "iframe",
            "video",
            "audio"
        ].includes(o.nodeName.toLowerCase())) {
            const t = document.createElement("div");
            t.appendChild(o), o = t;
        }
        $6cce3a502c50d5fc$var$E(o) && t.filter && !t.error && (o = o.querySelector(t.filter)), o && $6cce3a502c50d5fc$var$E(o) ? ($6cce3a502c50d5fc$var$P(o, "fancybox__content"), t.id && o.setAttribute("id", t.id), s.classList.add(`has-${t.error ? "error" : t.type || "unknown"}`), s.prepend(o), "none" === o.style.display && (o.style.display = ""), "none" === getComputedStyle(o).getPropertyValue("display") && (o.style.display = t.display || this.option("defaultDisplay") || "flex"), t.contentEl = o, i && this.revealContent(t), this.manageCloseBtn(t), this.manageCaption(t)) : this.setError(t, "{{ELEMENT_NOT_FOUND}}");
    }
    revealContent(t, e) {
        const i = t.el, n = t.contentEl;
        i && n && (this.emit("reveal", t), this.hideLoading(t), t.state = $6cce3a502c50d5fc$var$lt.Opening, (e = this.isOpeningSlide(t) ? void 0 === e ? this.optionFor(t, "showClass") : e : "f-fadeIn") ? this.animate(n, e, ()=>{
            this.done(t);
        }) : this.done(t));
    }
    done(t) {
        this.isClosing() || (t.state = $6cce3a502c50d5fc$var$lt.Ready, this.emit("done", t), $6cce3a502c50d5fc$var$P(t.el, "is-done"), this.isCurrentSlide(t) && this.option("autoFocus") && queueMicrotask(()=>{
            var e;
            null === (e = t.panzoom) || void 0 === e || e.updateControls(), this.option("autoFocus") && this.focus();
        }), this.isOpeningSlide(t) && ($6cce3a502c50d5fc$var$S(this.container, $6cce3a502c50d5fc$var$he), !this.isCompact && this.option("idle") && this.setIdle()));
    }
    isCurrentSlide(t) {
        const e = this.getSlide();
        return !(!t || !e) && e.index === t.index;
    }
    isOpeningSlide(t) {
        var e, i;
        return null === (null === (e = this.carousel) || void 0 === e ? void 0 : e.prevPage) && t && t.index === (null === (i = this.getSlide()) || void 0 === i ? void 0 : i.index);
    }
    showLoading(t) {
        t.state = $6cce3a502c50d5fc$var$lt.Loading;
        const e = t.el;
        if (!e) return;
        $6cce3a502c50d5fc$var$P(e, $6cce3a502c50d5fc$var$ce), this.emit("loading", t), t.spinnerEl || setTimeout(()=>{
            if (!this.isClosing() && !t.spinnerEl && t.state === $6cce3a502c50d5fc$var$lt.Loading) {
                let i = $6cce3a502c50d5fc$var$n($6cce3a502c50d5fc$var$x);
                $6cce3a502c50d5fc$var$P(i, "fancybox-spinner"), t.spinnerEl = i, e.prepend(i), this.animate(i, "f-fadeIn");
            }
        }, 250);
    }
    hideLoading(t) {
        const e = t.el;
        if (!e) return;
        const i = t.spinnerEl;
        this.isClosing() ? null == i || i.remove() : ($6cce3a502c50d5fc$var$S(e, $6cce3a502c50d5fc$var$ce), i && this.animate(i, "f-fadeOut", ()=>{
            i.remove();
        }), t.state === $6cce3a502c50d5fc$var$lt.Loading && (this.emit("loaded", t), t.state = $6cce3a502c50d5fc$var$lt.Ready));
    }
    setError(t, e) {
        if (this.isClosing()) return;
        const i = new Event("error", {
            bubbles: !0,
            cancelable: !0
        });
        if (this.emit("error", i, t), i.defaultPrevented) return;
        t.error = e, this.hideLoading(t), this.clearContent(t);
        const n = document.createElement("div");
        n.classList.add("fancybox-error"), n.innerHTML = this.localize(e || "<p>{{ERROR}}</p>"), this.setContent(t, n);
    }
    clearContent(t) {
        if (void 0 === t.state) return;
        this.emit("clearContent", t), t.contentEl && (t.contentEl.remove(), t.contentEl = void 0);
        const e = t.el;
        e && ($6cce3a502c50d5fc$var$S(e, "has-error"), $6cce3a502c50d5fc$var$S(e, "has-unknown"), $6cce3a502c50d5fc$var$S(e, `has-${t.type || "unknown"}`)), t.closeBtnEl && t.closeBtnEl.remove(), t.closeBtnEl = void 0, t.captionEl && t.captionEl.remove(), t.captionEl = void 0, t.spinnerEl && t.spinnerEl.remove(), t.spinnerEl = void 0;
    }
    getSlide() {
        var t;
        const e = this.carousel;
        return (null === (t = null == e ? void 0 : e.pages[null == e ? void 0 : e.page]) || void 0 === t ? void 0 : t.slides[0]) || void 0;
    }
    close(t, e) {
        if (this.isClosing()) return;
        const i = new Event("shouldClose", {
            bubbles: !0,
            cancelable: !0
        });
        if (this.emit("shouldClose", i, t), i.defaultPrevented) return;
        t && t.cancelable && (t.preventDefault(), t.stopPropagation());
        const n = ()=>{
            this.proceedClose(t, e);
        };
        this.startedFs && $6cce3a502c50d5fc$var$ye && $6cce3a502c50d5fc$var$ye.isFullscreen() ? Promise.resolve($6cce3a502c50d5fc$var$ye.exit()).then(()=>n()) : n();
    }
    clearIdle() {
        this.idleTimer && clearTimeout(this.idleTimer), this.idleTimer = null;
    }
    setIdle(t = !1) {
        const e = ()=>{
            this.clearIdle(), this.idle = !0, $6cce3a502c50d5fc$var$P(this.container, "is-idle"), this.emit("setIdle");
        };
        if (this.clearIdle(), !this.isClosing()) {
            if (t) e();
            else {
                const t = this.option("idle");
                t && (this.idleTimer = setTimeout(e, t));
            }
        }
    }
    endIdle() {
        this.clearIdle(), this.idle && !this.isClosing() && (this.idle = !1, $6cce3a502c50d5fc$var$S(this.container, "is-idle"), this.emit("endIdle"));
    }
    resetIdle() {
        this.endIdle(), this.setIdle();
    }
    toggleIdle() {
        this.idle ? this.endIdle() : this.setIdle(!0);
    }
    toggleFullscreen() {
        $6cce3a502c50d5fc$var$ye && ($6cce3a502c50d5fc$var$ye.isFullscreen() ? $6cce3a502c50d5fc$var$ye.exit() : $6cce3a502c50d5fc$var$ye.request().then(()=>{
            this.startedFs = !0;
        }));
    }
    isClosing() {
        return [
            $6cce3a502c50d5fc$var$rt.Closing,
            $6cce3a502c50d5fc$var$rt.CustomClosing,
            $6cce3a502c50d5fc$var$rt.Destroy
        ].includes(this.state);
    }
    proceedClose(t, e) {
        var i, n;
        this.state = $6cce3a502c50d5fc$var$rt.Closing, this.clearIdle(), this.detachEvents();
        const s = this.container, o = this.carousel, a = this.getSlide(), r = a && this.option("placeFocusBack") ? a.triggerEl || this.option("triggerEl") : null;
        if (r && ($6cce3a502c50d5fc$var$tt(r) ? $6cce3a502c50d5fc$var$st(r) : r.focus()), s && ($6cce3a502c50d5fc$var$S(s, $6cce3a502c50d5fc$var$he), $6cce3a502c50d5fc$var$P(s, "is-closing"), s.setAttribute($6cce3a502c50d5fc$var$oe, "true"), this.option("animated") && $6cce3a502c50d5fc$var$P(s, $6cce3a502c50d5fc$var$re), s.style.pointerEvents = "none"), o) {
            o.clearTransitions(), null === (i = o.panzoom) || void 0 === i || i.destroy(), null === (n = o.plugins.Navigation) || void 0 === n || n.detach();
            for (const t of o.slides){
                t.state = $6cce3a502c50d5fc$var$lt.Closing, this.hideLoading(t);
                const e = t.contentEl;
                e && this.stop(e);
                const i = null == t ? void 0 : t.panzoom;
                i && (i.stop(), i.detachEvents(), i.detachObserver()), this.isCurrentSlide(t) || o.emit("removeSlide", t);
            }
        }
        $6cce3a502c50d5fc$var$Pe = window.scrollX, $6cce3a502c50d5fc$var$Ce = window.scrollY, window.addEventListener("scroll", this.onScroll), this.emit("close", t), this.state !== $6cce3a502c50d5fc$var$rt.CustomClosing ? (void 0 === e && a && (e = this.optionFor(a, "hideClass")), e && a ? (this.animate(a.contentEl, e, ()=>{
            o && o.emit("removeSlide", a);
        }), setTimeout(()=>{
            this.destroy();
        }, 500)) : this.destroy()) : setTimeout(()=>{
            this.destroy();
        }, 500);
    }
    destroy() {
        var t;
        if (this.state === $6cce3a502c50d5fc$var$rt.Destroy) return;
        window.removeEventListener("scroll", this.onScroll), this.state = $6cce3a502c50d5fc$var$rt.Destroy, null === (t = this.carousel) || void 0 === t || t.destroy();
        const e = this.container;
        e && e.remove(), $6cce3a502c50d5fc$var$Te.delete(this.id);
        const i = $6cce3a502c50d5fc$export$cb45b08d97cdc4fd.getInstance();
        i ? i.focus() : ($6cce3a502c50d5fc$var$we && ($6cce3a502c50d5fc$var$we.remove(), $6cce3a502c50d5fc$var$we = null), $6cce3a502c50d5fc$var$xe && ($6cce3a502c50d5fc$var$xe.remove(), $6cce3a502c50d5fc$var$xe = null), $6cce3a502c50d5fc$var$S(document.documentElement, $6cce3a502c50d5fc$var$ee), (()=>{
            if (!$6cce3a502c50d5fc$var$et) return;
            const t = document, e = t.body;
            e.classList.remove($6cce3a502c50d5fc$var$ie), e.style.setProperty($6cce3a502c50d5fc$var$se, ""), t.documentElement.style.setProperty($6cce3a502c50d5fc$var$ne, "");
        })(), this.emit("destroy"));
    }
    static bind(t, e, i) {
        if (!$6cce3a502c50d5fc$var$et) return;
        let n, s = "", o = {};
        if (void 0 === t ? n = document.body : $6cce3a502c50d5fc$var$ve(t) ? (n = document.body, s = t, "object" == typeof e && (o = e || {})) : (n = t, $6cce3a502c50d5fc$var$ve(e) && (s = e), "object" == typeof i && (o = i || {})), !n || !$6cce3a502c50d5fc$var$E(n)) return;
        s = s || "[data-fancybox]";
        const a = $6cce3a502c50d5fc$export$cb45b08d97cdc4fd.openers.get(n) || new Map;
        a.set(s, o), $6cce3a502c50d5fc$export$cb45b08d97cdc4fd.openers.set(n, a), 1 === a.size && n.addEventListener("click", $6cce3a502c50d5fc$export$cb45b08d97cdc4fd.fromEvent);
    }
    static unbind(t, e) {
        let i, n = "";
        if ($6cce3a502c50d5fc$var$ve(t) ? (i = document.body, n = t) : (i = t, $6cce3a502c50d5fc$var$ve(e) && (n = e)), !i) return;
        const s = $6cce3a502c50d5fc$export$cb45b08d97cdc4fd.openers.get(i);
        s && n && s.delete(n), n && s || ($6cce3a502c50d5fc$export$cb45b08d97cdc4fd.openers.delete(i), i.removeEventListener("click", $6cce3a502c50d5fc$export$cb45b08d97cdc4fd.fromEvent));
    }
    static destroy() {
        let t;
        for(; t = $6cce3a502c50d5fc$export$cb45b08d97cdc4fd.getInstance();)t.destroy();
        for (const t of $6cce3a502c50d5fc$export$cb45b08d97cdc4fd.openers.keys())t.removeEventListener("click", $6cce3a502c50d5fc$export$cb45b08d97cdc4fd.fromEvent);
        $6cce3a502c50d5fc$export$cb45b08d97cdc4fd.openers = new Map;
    }
    static fromEvent(t) {
        if (t.defaultPrevented) return;
        if (t.button && 0 !== t.button) return;
        if (t.ctrlKey || t.metaKey || t.shiftKey) return;
        let e = t.composedPath()[0];
        const i = e.closest("[data-fancybox-trigger]");
        if (i) {
            const t = i.dataset.fancyboxTrigger || "", n = document.querySelectorAll(`[data-fancybox="${t}"]`), s = parseInt(i.dataset.fancyboxIndex || "", 10) || 0;
            e = n[s] || e;
        }
        if (!(e && e instanceof Element)) return;
        let n, s, o, a;
        if ([
            ...$6cce3a502c50d5fc$export$cb45b08d97cdc4fd.openers
        ].reverse().find(([t, i])=>!(!t.contains(e) || ![
                ...i
            ].reverse().find(([i, r])=>{
                let l = e.closest(i);
                return !!l && (n = t, s = i, o = l, a = r, !0);
            }))), !n || !s || !o) return;
        a = a || {}, t.preventDefault(), e = o;
        let r = [], l = $6cce3a502c50d5fc$var$u({}, $6cce3a502c50d5fc$var$at, a);
        l.event = t, l.triggerEl = e, l.delegate = i;
        const c = l.groupAll, h = l.groupAttr, d = h && e ? e.getAttribute(`${h}`) : "";
        if ((!e || d || c) && (r = [].slice.call(n.querySelectorAll(s))), e && !c && (r = d ? r.filter((t)=>t.getAttribute(`${h}`) === d) : [
            e
        ]), !r.length) return;
        const p = $6cce3a502c50d5fc$export$cb45b08d97cdc4fd.getInstance();
        return p && p.options.triggerEl && r.indexOf(p.options.triggerEl) > -1 ? void 0 : (e && (l.startIndex = r.indexOf(e)), $6cce3a502c50d5fc$export$cb45b08d97cdc4fd.fromNodes(r, l));
    }
    static fromSelector(t, e, i) {
        let n = null, s = "", o = {};
        if ($6cce3a502c50d5fc$var$ve(t) ? (n = document.body, s = t, "object" == typeof e && (o = e || {})) : t instanceof HTMLElement && $6cce3a502c50d5fc$var$ve(e) && (n = t, s = e, "object" == typeof i && (o = i || {})), !n || !s) return !1;
        const a = $6cce3a502c50d5fc$export$cb45b08d97cdc4fd.openers.get(n);
        return !!a && (o = $6cce3a502c50d5fc$var$u({}, a.get(s) || {}, o), !!o && $6cce3a502c50d5fc$export$cb45b08d97cdc4fd.fromNodes(Array.from(n.querySelectorAll(s)), o));
    }
    static fromNodes(t, e) {
        e = $6cce3a502c50d5fc$var$u({}, $6cce3a502c50d5fc$var$at, e || {});
        const i = [];
        for (const n of t){
            const t = n.dataset || {}, s = t[$6cce3a502c50d5fc$var$me] || n.getAttribute($6cce3a502c50d5fc$var$ge) || n.getAttribute("currentSrc") || n.getAttribute($6cce3a502c50d5fc$var$me) || void 0;
            let o;
            const a = e.delegate;
            let r;
            a && i.length === e.startIndex && (o = a instanceof HTMLImageElement ? a : a.querySelector("img:not([aria-hidden])")), o || (o = n instanceof HTMLImageElement ? n : n.querySelector("img:not([aria-hidden])")), o && (r = o.currentSrc || o[$6cce3a502c50d5fc$var$me] || void 0, !r && o.dataset && (r = o.dataset.lazySrc || o.dataset[$6cce3a502c50d5fc$var$me] || void 0));
            const l = {
                src: s,
                triggerEl: n,
                thumbEl: o,
                thumbElSrc: r,
                thumbSrc: r
            };
            for(const e in t){
                let i = t[e] + "";
                i = "false" !== i && ("true" === i || i), l[e] = i;
            }
            i.push(l);
        }
        return new $6cce3a502c50d5fc$export$cb45b08d97cdc4fd(i, e);
    }
    static getInstance(t) {
        if (t) return $6cce3a502c50d5fc$var$Te.get(t);
        return Array.from($6cce3a502c50d5fc$var$Te.values()).reverse().find((t)=>!t.isClosing() && t) || null;
    }
    static getSlide() {
        var t;
        return (null === (t = $6cce3a502c50d5fc$export$cb45b08d97cdc4fd.getInstance()) || void 0 === t ? void 0 : t.getSlide()) || null;
    }
    static show(t = [], e = {}) {
        return new $6cce3a502c50d5fc$export$cb45b08d97cdc4fd(t, e);
    }
    static next() {
        const t = $6cce3a502c50d5fc$export$cb45b08d97cdc4fd.getInstance();
        t && t.next();
    }
    static prev() {
        const t = $6cce3a502c50d5fc$export$cb45b08d97cdc4fd.getInstance();
        t && t.prev();
    }
    static close(t = !0, ...e) {
        if (t) for (const t of $6cce3a502c50d5fc$var$Te.values())t.close(...e);
        else {
            const t = $6cce3a502c50d5fc$export$cb45b08d97cdc4fd.getInstance();
            t && t.close(...e);
        }
    }
}
Object.defineProperty($6cce3a502c50d5fc$export$cb45b08d97cdc4fd, "version", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: "5.0.36"
}), Object.defineProperty($6cce3a502c50d5fc$export$cb45b08d97cdc4fd, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $6cce3a502c50d5fc$var$at
}), Object.defineProperty($6cce3a502c50d5fc$export$cb45b08d97cdc4fd, "Plugins", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $6cce3a502c50d5fc$var$te
}), Object.defineProperty($6cce3a502c50d5fc$export$cb45b08d97cdc4fd, "openers", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: new Map
});


(0, $6cce3a502c50d5fc$export$cb45b08d97cdc4fd).bind('[data-fancybox="gallery"] img');


var $d850daeb1ad1950b$exports = {};
"object" == typeof navigator && function(e, t) {
    $d850daeb1ad1950b$exports = t();
}($d850daeb1ad1950b$exports, function() {
    "use strict";
    function e(e, t, i) {
        return (t = function(e) {
            var t = function(e, t) {
                if ("object" != typeof e || null === e) return e;
                var i = e[Symbol.toPrimitive];
                if (void 0 !== i) {
                    var s = i.call(e, t || "default");
                    if ("object" != typeof s) return s;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === t ? String : Number)(e);
            }(e, "string");
            return "symbol" == typeof t ? t : String(t);
        }(t)) in e ? Object.defineProperty(e, t, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = i, e;
    }
    function t(e, t) {
        for(var i = 0; i < t.length; i++){
            var s = t[i];
            s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(e, s.key, s);
        }
    }
    function i(e, t, i) {
        return t in e ? Object.defineProperty(e, t, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = i, e;
    }
    function s(e, t) {
        var i = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var s = Object.getOwnPropertySymbols(e);
            t && (s = s.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), i.push.apply(i, s);
        }
        return i;
    }
    function n(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? s(Object(n), !0).forEach(function(t) {
                i(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
        }
        return e;
    }
    var a = {
        addCSS: !0,
        thumbWidth: 15,
        watch: !0
    };
    var l = function(e) {
        return null != e ? e.constructor : null;
    }, r = function(e, t) {
        return !!(e && t && e instanceof t);
    }, o = function(e) {
        return null == e;
    }, c = function(e) {
        return l(e) === Object;
    }, u = function(e) {
        return l(e) === String;
    }, h = function(e) {
        return Array.isArray(e);
    }, d = function(e) {
        return r(e, NodeList);
    }, m = {
        nullOrUndefined: o,
        object: c,
        number: function(e) {
            return l(e) === Number && !Number.isNaN(e);
        },
        string: u,
        boolean: function(e) {
            return l(e) === Boolean;
        },
        function: function(e) {
            return l(e) === Function;
        },
        array: h,
        nodeList: d,
        element: function(e) {
            return r(e, Element);
        },
        event: function(e) {
            return r(e, Event);
        },
        empty: function(e) {
            return o(e) || (u(e) || h(e) || d(e)) && !e.length || c(e) && !Object.keys(e).length;
        }
    };
    function p(e, t) {
        if (1 > t) {
            var i = function(e) {
                var t = "".concat(e).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
                return t ? Math.max(0, (t[1] ? t[1].length : 0) - (t[2] ? +t[2] : 0)) : 0;
            }(t);
            return parseFloat(e.toFixed(i));
        }
        return Math.round(e / t) * t;
    }
    var g = function() {
        function e(t, i) {
            (function(e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            })(this, e), m.element(t) ? this.element = t : m.string(t) && (this.element = document.querySelector(t)), m.element(this.element) && m.empty(this.element.rangeTouch) && (this.config = n({}, a, {}, i), this.init());
        }
        return function(e, i, s) {
            i && t(e.prototype, i), s && t(e, s);
        }(e, [
            {
                key: "init",
                value: function() {
                    e.enabled && (this.config.addCSS && (this.element.style.userSelect = "none", this.element.style.webKitUserSelect = "none", this.element.style.touchAction = "manipulation"), this.listeners(!0), this.element.rangeTouch = this);
                }
            },
            {
                key: "destroy",
                value: function() {
                    e.enabled && (this.config.addCSS && (this.element.style.userSelect = "", this.element.style.webKitUserSelect = "", this.element.style.touchAction = ""), this.listeners(!1), this.element.rangeTouch = null);
                }
            },
            {
                key: "listeners",
                value: function(e) {
                    var t = this, i = e ? "addEventListener" : "removeEventListener";
                    [
                        "touchstart",
                        "touchmove",
                        "touchend"
                    ].forEach(function(e) {
                        t.element[i](e, function(e) {
                            return t.set(e);
                        }, !1);
                    });
                }
            },
            {
                key: "get",
                value: function(t) {
                    if (!e.enabled || !m.event(t)) return null;
                    var i, s = t.target, n = t.changedTouches[0], a = parseFloat(s.getAttribute("min")) || 0, l = parseFloat(s.getAttribute("max")) || 100, r = parseFloat(s.getAttribute("step")) || 1, o = s.getBoundingClientRect(), c = 100 / o.width * (this.config.thumbWidth / 2) / 100;
                    return 0 > (i = 100 / o.width * (n.clientX - o.left)) ? i = 0 : 100 < i && (i = 100), 50 > i ? i -= (100 - 2 * i) * c : 50 < i && (i += 2 * (i - 50) * c), a + p(i / 100 * (l - a), r);
                }
            },
            {
                key: "set",
                value: function(t) {
                    e.enabled && m.event(t) && !t.target.disabled && (t.preventDefault(), t.target.value = this.get(t), function(e, t) {
                        if (e && t) {
                            var i = new Event(t, {
                                bubbles: !0
                            });
                            e.dispatchEvent(i);
                        }
                    }(t.target, "touchend" === t.type ? "change" : "input"));
                }
            }
        ], [
            {
                key: "setup",
                value: function(t) {
                    var i = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}, s = null;
                    if (m.empty(t) || m.string(t) ? s = Array.from(document.querySelectorAll(m.string(t) ? t : 'input[type="range"]')) : m.element(t) ? s = [
                        t
                    ] : m.nodeList(t) ? s = Array.from(t) : m.array(t) && (s = t.filter(m.element)), m.empty(s)) return null;
                    var l = n({}, a, {}, i);
                    if (m.string(t) && l.watch) {
                        var r = new MutationObserver(function(i) {
                            Array.from(i).forEach(function(i) {
                                Array.from(i.addedNodes).forEach(function(i) {
                                    m.element(i) && function(e, t) {
                                        return (function() {
                                            return Array.from(document.querySelectorAll(t)).includes(this);
                                        }).call(e, t);
                                    }(i, t) && new e(i, l);
                                });
                            });
                        });
                        r.observe(document.body, {
                            childList: !0,
                            subtree: !0
                        });
                    }
                    return s.map(function(t) {
                        return new e(t, i);
                    });
                }
            },
            {
                key: "enabled",
                get: function() {
                    return "ontouchstart" in document.documentElement;
                }
            }
        ]), e;
    }();
    const f = (e)=>null != e ? e.constructor : null, y = (e, t)=>Boolean(e && t && e instanceof t), b = (e)=>null == e, v = (e)=>f(e) === Object, w = (e)=>f(e) === String, T = (e)=>"function" == typeof e, k = (e)=>Array.isArray(e), C = (e)=>y(e, NodeList), A = (e)=>b(e) || (w(e) || k(e) || C(e)) && !e.length || v(e) && !Object.keys(e).length;
    var S = {
        nullOrUndefined: b,
        object: v,
        number: (e)=>f(e) === Number && !Number.isNaN(e),
        string: w,
        boolean: (e)=>f(e) === Boolean,
        function: T,
        array: k,
        weakMap: (e)=>y(e, WeakMap),
        nodeList: C,
        element: (e)=>null !== e && "object" == typeof e && 1 === e.nodeType && "object" == typeof e.style && "object" == typeof e.ownerDocument,
        textNode: (e)=>f(e) === Text,
        event: (e)=>y(e, Event),
        keyboardEvent: (e)=>y(e, KeyboardEvent),
        cue: (e)=>y(e, window.TextTrackCue) || y(e, window.VTTCue),
        track: (e)=>y(e, TextTrack) || !b(e) && w(e.kind),
        promise: (e)=>y(e, Promise) && T(e.then),
        url: (e)=>{
            if (y(e, window.URL)) return !0;
            if (!w(e)) return !1;
            let t = e;
            e.startsWith("http://") && e.startsWith("https://") || (t = `http://${e}`);
            try {
                return !A(new URL(t).hostname);
            } catch (e) {
                return !1;
            }
        },
        empty: A
    };
    const E = (()=>{
        const e = document.createElement("span"), t = {
            WebkitTransition: "webkitTransitionEnd",
            MozTransition: "transitionend",
            OTransition: "oTransitionEnd otransitionend",
            transition: "transitionend"
        }, i = Object.keys(t).find((t)=>void 0 !== e.style[t]);
        return !!S.string(i) && t[i];
    })();
    function P(e, t) {
        setTimeout(()=>{
            try {
                e.hidden = !0, e.offsetHeight, e.hidden = !1;
            } catch (e) {}
        }, t);
    }
    var M = {
        isIE: Boolean(window.document.documentMode),
        isEdge: /Edge/g.test(navigator.userAgent),
        isWebKit: "WebkitAppearance" in document.documentElement.style && !/Edge/g.test(navigator.userAgent),
        isIPhone: /iPhone|iPod/gi.test(navigator.userAgent) && navigator.maxTouchPoints > 1,
        isIPadOS: "MacIntel" === navigator.platform && navigator.maxTouchPoints > 1,
        isIos: /iPad|iPhone|iPod/gi.test(navigator.userAgent) && navigator.maxTouchPoints > 1
    };
    function N(e, t) {
        return t.split(".").reduce((e, t)=>e && e[t], e);
    }
    function x(e = {}, ...t) {
        if (!t.length) return e;
        const i = t.shift();
        return S.object(i) ? (Object.keys(i).forEach((t)=>{
            S.object(i[t]) ? (Object.keys(e).includes(t) || Object.assign(e, {
                [t]: {}
            }), x(e[t], i[t])) : Object.assign(e, {
                [t]: i[t]
            });
        }), x(e, ...t)) : e;
    }
    function L(e, t) {
        const i = e.length ? e : [
            e
        ];
        Array.from(i).reverse().forEach((e, i)=>{
            const s = i > 0 ? t.cloneNode(!0) : t, n = e.parentNode, a = e.nextSibling;
            s.appendChild(e), a ? n.insertBefore(s, a) : n.appendChild(s);
        });
    }
    function I(e, t) {
        S.element(e) && !S.empty(t) && Object.entries(t).filter(([, e])=>!S.nullOrUndefined(e)).forEach(([t, i])=>e.setAttribute(t, i));
    }
    function $(e, t, i) {
        const s = document.createElement(e);
        return S.object(t) && I(s, t), S.string(i) && (s.innerText = i), s;
    }
    function _(e, t, i, s) {
        S.element(t) && t.appendChild($(e, i, s));
    }
    function O(e) {
        S.nodeList(e) || S.array(e) ? Array.from(e).forEach(O) : S.element(e) && S.element(e.parentNode) && e.parentNode.removeChild(e);
    }
    function j(e) {
        if (!S.element(e)) return;
        let { length: t } = e.childNodes;
        for(; t > 0;)e.removeChild(e.lastChild), t -= 1;
    }
    function q(e, t) {
        return S.element(t) && S.element(t.parentNode) && S.element(e) ? (t.parentNode.replaceChild(e, t), e) : null;
    }
    function D(e, t) {
        if (!S.string(e) || S.empty(e)) return {};
        const i = {}, s = x({}, t);
        return e.split(",").forEach((e)=>{
            const t = e.trim(), n = t.replace(".", ""), a = t.replace(/[[\]]/g, "").split("="), [l] = a, r = a.length > 1 ? a[1].replace(/["']/g, "") : "";
            switch(t.charAt(0)){
                case ".":
                    S.string(s.class) ? i.class = `${s.class} ${n}` : i.class = n;
                    break;
                case "#":
                    i.id = t.replace("#", "");
                    break;
                case "[":
                    i[l] = r;
            }
        }), x(s, i);
    }
    function H(e, t) {
        if (!S.element(e)) return;
        let i = t;
        S.boolean(i) || (i = !e.hidden), e.hidden = i;
    }
    function R(e, t, i) {
        if (S.nodeList(e)) return Array.from(e).map((e)=>R(e, t, i));
        if (S.element(e)) {
            let s = "toggle";
            return void 0 !== i && (s = i ? "add" : "remove"), e.classList[s](t), e.classList.contains(t);
        }
        return !1;
    }
    function F(e, t) {
        return S.element(e) && e.classList.contains(t);
    }
    function V(e, t) {
        const { prototype: i } = Element;
        return (i.matches || i.webkitMatchesSelector || i.mozMatchesSelector || i.msMatchesSelector || function() {
            return Array.from(document.querySelectorAll(t)).includes(this);
        }).call(e, t);
    }
    function U(e) {
        return this.elements.container.querySelectorAll(e);
    }
    function B(e) {
        return this.elements.container.querySelector(e);
    }
    function W(e = null, t = !1) {
        S.element(e) && e.focus({
            preventScroll: !0,
            focusVisible: t
        });
    }
    const z = {
        "audio/ogg": "vorbis",
        "audio/wav": "1",
        "video/webm": "vp8, vorbis",
        "video/mp4": "avc1.42E01E, mp4a.40.2",
        "video/ogg": "theora"
    }, K = {
        audio: "canPlayType" in document.createElement("audio"),
        video: "canPlayType" in document.createElement("video"),
        check (e, t) {
            const i = K[e] || "html5" !== t;
            return {
                api: i,
                ui: i && K.rangeInput
            };
        },
        pip: !(M.isIPhone || !S.function($("video").webkitSetPresentationMode) && (!document.pictureInPictureEnabled || $("video").disablePictureInPicture)),
        airplay: S.function(window.WebKitPlaybackTargetAvailabilityEvent),
        playsinline: "playsInline" in document.createElement("video"),
        mime (e) {
            if (S.empty(e)) return !1;
            const [t] = e.split("/");
            let i = e;
            if (!this.isHTML5 || t !== this.type) return !1;
            Object.keys(z).includes(i) && (i += `; codecs="${z[e]}"`);
            try {
                return Boolean(i && this.media.canPlayType(i).replace(/no/, ""));
            } catch (e) {
                return !1;
            }
        },
        textTracks: "textTracks" in document.createElement("video"),
        rangeInput: (()=>{
            const e = document.createElement("input");
            return e.type = "range", "range" === e.type;
        })(),
        touch: "ontouchstart" in document.documentElement,
        transitions: !1 !== E,
        reducedMotion: "matchMedia" in window && window.matchMedia("(prefers-reduced-motion)").matches
    }, Y = (()=>{
        let e = !1;
        try {
            const t = Object.defineProperty({}, "passive", {
                get: ()=>(e = !0, null)
            });
            window.addEventListener("test", null, t), window.removeEventListener("test", null, t);
        } catch (e) {}
        return e;
    })();
    function Q(e, t, i, s = !1, n = !0, a = !1) {
        if (!e || !("addEventListener" in e) || S.empty(t) || !S.function(i)) return;
        const l = t.split(" ");
        let r = a;
        Y && (r = {
            passive: n,
            capture: a
        }), l.forEach((t)=>{
            this && this.eventListeners && s && this.eventListeners.push({
                element: e,
                type: t,
                callback: i,
                options: r
            }), e[s ? "addEventListener" : "removeEventListener"](t, i, r);
        });
    }
    function X(e, t = "", i, s = !0, n = !1) {
        Q.call(this, e, t, i, !0, s, n);
    }
    function J(e, t = "", i, s = !0, n = !1) {
        Q.call(this, e, t, i, !1, s, n);
    }
    function G(e, t = "", i, s = !0, n = !1) {
        const a = (...l)=>{
            J(e, t, a, s, n), i.apply(this, l);
        };
        Q.call(this, e, t, a, !0, s, n);
    }
    function Z(e, t = "", i = !1, s = {}) {
        if (!S.element(e) || S.empty(t)) return;
        const n = new CustomEvent(t, {
            bubbles: i,
            detail: {
                ...s,
                plyr: this
            }
        });
        e.dispatchEvent(n);
    }
    function ee() {
        this && this.eventListeners && (this.eventListeners.forEach((e)=>{
            const { element: t, type: i, callback: s, options: n } = e;
            t.removeEventListener(i, s, n);
        }), this.eventListeners = []);
    }
    function te() {
        return new Promise((e)=>this.ready ? setTimeout(e, 0) : X.call(this, this.elements.container, "ready", e)).then(()=>{});
    }
    function ie(e) {
        S.promise(e) && e.then(null, ()=>{});
    }
    function se(e) {
        return S.array(e) ? e.filter((t, i)=>e.indexOf(t) === i) : e;
    }
    function ne(e, t) {
        return S.array(e) && e.length ? e.reduce((e, i)=>Math.abs(i - t) < Math.abs(e - t) ? i : e) : null;
    }
    function ae(e) {
        return !(!window || !window.CSS) && window.CSS.supports(e);
    }
    const le = [
        [
            1,
            1
        ],
        [
            4,
            3
        ],
        [
            3,
            4
        ],
        [
            5,
            4
        ],
        [
            4,
            5
        ],
        [
            3,
            2
        ],
        [
            2,
            3
        ],
        [
            16,
            10
        ],
        [
            10,
            16
        ],
        [
            16,
            9
        ],
        [
            9,
            16
        ],
        [
            21,
            9
        ],
        [
            9,
            21
        ],
        [
            32,
            9
        ],
        [
            9,
            32
        ]
    ].reduce((e, [t, i])=>({
            ...e,
            [t / i]: [
                t,
                i
            ]
        }), {});
    function re(e) {
        if (!(S.array(e) || S.string(e) && e.includes(":"))) return !1;
        return (S.array(e) ? e : e.split(":")).map(Number).every(S.number);
    }
    function oe(e) {
        if (!S.array(e) || !e.every(S.number)) return null;
        const [t, i] = e, s = (e, t)=>0 === t ? e : s(t, e % t), n = s(t, i);
        return [
            t / n,
            i / n
        ];
    }
    function ce(e) {
        const t = (e)=>re(e) ? e.split(":").map(Number) : null;
        let i = t(e);
        if (null === i && (i = t(this.config.ratio)), null === i && !S.empty(this.embed) && S.array(this.embed.ratio) && ({ ratio: i } = this.embed), null === i && this.isHTML5) {
            const { videoWidth: e, videoHeight: t } = this.media;
            i = [
                e,
                t
            ];
        }
        return oe(i);
    }
    function ue(e) {
        if (!this.isVideo) return {};
        const { wrapper: t } = this.elements, i = ce.call(this, e);
        if (!S.array(i)) return {};
        const [s, n] = oe(i), a = 100 / s * n;
        if (ae(`aspect-ratio: ${s}/${n}`) ? t.style.aspectRatio = `${s}/${n}` : t.style.paddingBottom = `${a}%`, this.isVimeo && !this.config.vimeo.premium && this.supported.ui) {
            const e = 100 / this.media.offsetWidth * parseInt(window.getComputedStyle(this.media).paddingBottom, 10), i = (e - a) / (e / 50);
            this.fullscreen.active ? t.style.paddingBottom = null : this.media.style.transform = `translateY(-${i}%)`;
        } else this.isHTML5 && t.classList.add(this.config.classNames.videoFixedRatio);
        return {
            padding: a,
            ratio: i
        };
    }
    function he(e, t, i = .05) {
        const s = e / t, n = ne(Object.keys(le), s);
        return Math.abs(n - s) <= i ? le[n] : [
            e,
            t
        ];
    }
    const de = {
        getSources () {
            if (!this.isHTML5) return [];
            return Array.from(this.media.querySelectorAll("source")).filter((e)=>{
                const t = e.getAttribute("type");
                return !!S.empty(t) || K.mime.call(this, t);
            });
        },
        getQualityOptions () {
            return this.config.quality.forced ? this.config.quality.options : de.getSources.call(this).map((e)=>Number(e.getAttribute("size"))).filter(Boolean);
        },
        setup () {
            if (!this.isHTML5) return;
            const e = this;
            e.options.speed = e.config.speed.options, S.empty(this.config.ratio) || ue.call(e), Object.defineProperty(e.media, "quality", {
                get () {
                    const t = de.getSources.call(e).find((t)=>t.getAttribute("src") === e.source);
                    return t && Number(t.getAttribute("size"));
                },
                set (t) {
                    if (e.quality !== t) {
                        if (e.config.quality.forced && S.function(e.config.quality.onChange)) e.config.quality.onChange(t);
                        else {
                            const i = de.getSources.call(e).find((e)=>Number(e.getAttribute("size")) === t);
                            if (!i) return;
                            const { currentTime: s, paused: n, preload: a, readyState: l, playbackRate: r } = e.media;
                            e.media.src = i.getAttribute("src"), ("none" !== a || l) && (e.once("loadedmetadata", ()=>{
                                e.speed = r, e.currentTime = s, n || ie(e.play());
                            }), e.media.load());
                        }
                        Z.call(e, e.media, "qualitychange", !1, {
                            quality: t
                        });
                    }
                }
            });
        },
        cancelRequests () {
            this.isHTML5 && (O(de.getSources.call(this)), this.media.setAttribute("src", this.config.blankVideo), this.media.load(), this.debug.log("Cancelled network requests"));
        }
    };
    function me(e, ...t) {
        return S.empty(e) ? e : e.toString().replace(/{(\d+)}/g, (e, i)=>t[i].toString());
    }
    const pe = (e = "", t = "", i = "")=>e.replace(new RegExp(t.toString().replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1"), "g"), i.toString()), ge = (e = "")=>e.toString().replace(/\w\S*/g, (e)=>e.charAt(0).toUpperCase() + e.slice(1).toLowerCase());
    function fe(e = "") {
        let t = e.toString();
        return t = function(e = "") {
            let t = e.toString();
            return t = pe(t, "-", " "), t = pe(t, "_", " "), t = ge(t), pe(t, " ", "");
        }(t), t.charAt(0).toLowerCase() + t.slice(1);
    }
    function ye(e) {
        const t = document.createElement("div");
        return t.appendChild(e), t.innerHTML;
    }
    const be = {
        pip: "PIP",
        airplay: "AirPlay",
        html5: "HTML5",
        vimeo: "Vimeo",
        youtube: "YouTube"
    }, ve = {
        get (e = "", t = {}) {
            if (S.empty(e) || S.empty(t)) return "";
            let i = N(t.i18n, e);
            if (S.empty(i)) return Object.keys(be).includes(e) ? be[e] : "";
            const s = {
                "{seektime}": t.seekTime,
                "{title}": t.title
            };
            return Object.entries(s).forEach(([e, t])=>{
                i = pe(i, e, t);
            }), i;
        }
    };
    class we {
        constructor(t){
            e(this, "get", (e)=>{
                if (!we.supported || !this.enabled) return null;
                const t = window.localStorage.getItem(this.key);
                if (S.empty(t)) return null;
                const i = JSON.parse(t);
                return S.string(e) && e.length ? i[e] : i;
            }), e(this, "set", (e)=>{
                if (!we.supported || !this.enabled) return;
                if (!S.object(e)) return;
                let t = this.get();
                S.empty(t) && (t = {}), x(t, e);
                try {
                    window.localStorage.setItem(this.key, JSON.stringify(t));
                } catch (e) {}
            }), this.enabled = t.config.storage.enabled, this.key = t.config.storage.key;
        }
        static get supported() {
            try {
                if (!("localStorage" in window)) return !1;
                const e = "___test";
                return window.localStorage.setItem(e, e), window.localStorage.removeItem(e), !0;
            } catch (e) {
                return !1;
            }
        }
    }
    function Te(e, t = "text") {
        return new Promise((i, s)=>{
            try {
                const s = new XMLHttpRequest;
                if (!("withCredentials" in s)) return;
                s.addEventListener("load", ()=>{
                    if ("text" === t) try {
                        i(JSON.parse(s.responseText));
                    } catch (e) {
                        i(s.responseText);
                    }
                    else i(s.response);
                }), s.addEventListener("error", ()=>{
                    throw new Error(s.status);
                }), s.open("GET", e, !0), s.responseType = t, s.send();
            } catch (e) {
                s(e);
            }
        });
    }
    function ke(e, t) {
        if (!S.string(e)) return;
        const i = "cache", s = S.string(t);
        let n = !1;
        const a = ()=>null !== document.getElementById(t), l = (e, t)=>{
            e.innerHTML = t, s && a() || document.body.insertAdjacentElement("afterbegin", e);
        };
        if (!s || !a()) {
            const a = we.supported, r = document.createElement("div");
            if (r.setAttribute("hidden", ""), s && r.setAttribute("id", t), a) {
                const e = window.localStorage.getItem(`${i}-${t}`);
                if (n = null !== e, n) {
                    const t = JSON.parse(e);
                    l(r, t.content);
                }
            }
            Te(e).then((e)=>{
                if (!S.empty(e)) {
                    if (a) try {
                        window.localStorage.setItem(`${i}-${t}`, JSON.stringify({
                            content: e
                        }));
                    } catch (e) {}
                    l(r, e);
                }
            }).catch(()=>{});
        }
    }
    const Ce = (e)=>Math.trunc(e / 60 / 60 % 60, 10), Ae = (e)=>Math.trunc(e / 60 % 60, 10), Se = (e)=>Math.trunc(e % 60, 10);
    function Ee(e = 0, t = !1, i = !1) {
        if (!S.number(e)) return Ee(void 0, t, i);
        const s = (e)=>`0${e}`.slice(-2);
        let n = Ce(e);
        const a = Ae(e), l = Se(e);
        return n = t || n > 0 ? `${n}:` : "", `${i && e > 0 ? "-" : ""}${n}${s(a)}:${s(l)}`;
    }
    const Pe = {
        getIconUrl () {
            const e = new URL(this.config.iconUrl, window.location), t = window.location.host ? window.location.host : window.top.location.host, i = e.host !== t || M.isIE && !window.svg4everybody;
            return {
                url: this.config.iconUrl,
                cors: i
            };
        },
        findElements () {
            try {
                return this.elements.controls = B.call(this, this.config.selectors.controls.wrapper), this.elements.buttons = {
                    play: U.call(this, this.config.selectors.buttons.play),
                    pause: B.call(this, this.config.selectors.buttons.pause),
                    restart: B.call(this, this.config.selectors.buttons.restart),
                    rewind: B.call(this, this.config.selectors.buttons.rewind),
                    fastForward: B.call(this, this.config.selectors.buttons.fastForward),
                    mute: B.call(this, this.config.selectors.buttons.mute),
                    pip: B.call(this, this.config.selectors.buttons.pip),
                    airplay: B.call(this, this.config.selectors.buttons.airplay),
                    settings: B.call(this, this.config.selectors.buttons.settings),
                    captions: B.call(this, this.config.selectors.buttons.captions),
                    fullscreen: B.call(this, this.config.selectors.buttons.fullscreen)
                }, this.elements.progress = B.call(this, this.config.selectors.progress), this.elements.inputs = {
                    seek: B.call(this, this.config.selectors.inputs.seek),
                    volume: B.call(this, this.config.selectors.inputs.volume)
                }, this.elements.display = {
                    buffer: B.call(this, this.config.selectors.display.buffer),
                    currentTime: B.call(this, this.config.selectors.display.currentTime),
                    duration: B.call(this, this.config.selectors.display.duration)
                }, S.element(this.elements.progress) && (this.elements.display.seekTooltip = this.elements.progress.querySelector(`.${this.config.classNames.tooltip}`)), !0;
            } catch (e) {
                return this.debug.warn("It looks like there is a problem with your custom controls HTML", e), this.toggleNativeControls(!0), !1;
            }
        },
        createIcon (e, t) {
            const i = "http://www.w3.org/2000/svg", s = Pe.getIconUrl.call(this), n = `${s.cors ? "" : s.url}#${this.config.iconPrefix}`, a = document.createElementNS(i, "svg");
            I(a, x(t, {
                "aria-hidden": "true",
                focusable: "false"
            }));
            const l = document.createElementNS(i, "use"), r = `${n}-${e}`;
            return "href" in l && l.setAttributeNS("http://www.w3.org/1999/xlink", "href", r), l.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", r), a.appendChild(l), a;
        },
        createLabel (e, t = {}) {
            const i = ve.get(e, this.config);
            return $("span", {
                ...t,
                class: [
                    t.class,
                    this.config.classNames.hidden
                ].filter(Boolean).join(" ")
            }, i);
        },
        createBadge (e) {
            if (S.empty(e)) return null;
            const t = $("span", {
                class: this.config.classNames.menu.value
            });
            return t.appendChild($("span", {
                class: this.config.classNames.menu.badge
            }, e)), t;
        },
        createButton (e, t) {
            const i = x({}, t);
            let s = fe(e);
            const n = {
                element: "button",
                toggle: !1,
                label: null,
                icon: null,
                labelPressed: null,
                iconPressed: null
            };
            switch([
                "element",
                "icon",
                "label"
            ].forEach((e)=>{
                Object.keys(i).includes(e) && (n[e] = i[e], delete i[e]);
            }), "button" !== n.element || Object.keys(i).includes("type") || (i.type = "button"), Object.keys(i).includes("class") ? i.class.split(" ").some((e)=>e === this.config.classNames.control) || x(i, {
                class: `${i.class} ${this.config.classNames.control}`
            }) : i.class = this.config.classNames.control, e){
                case "play":
                    n.toggle = !0, n.label = "play", n.labelPressed = "pause", n.icon = "play", n.iconPressed = "pause";
                    break;
                case "mute":
                    n.toggle = !0, n.label = "mute", n.labelPressed = "unmute", n.icon = "volume", n.iconPressed = "muted";
                    break;
                case "captions":
                    n.toggle = !0, n.label = "enableCaptions", n.labelPressed = "disableCaptions", n.icon = "captions-off", n.iconPressed = "captions-on";
                    break;
                case "fullscreen":
                    n.toggle = !0, n.label = "enterFullscreen", n.labelPressed = "exitFullscreen", n.icon = "enter-fullscreen", n.iconPressed = "exit-fullscreen";
                    break;
                case "play-large":
                    i.class += ` ${this.config.classNames.control}--overlaid`, s = "play", n.label = "play", n.icon = "play";
                    break;
                default:
                    S.empty(n.label) && (n.label = s), S.empty(n.icon) && (n.icon = e);
            }
            const a = $(n.element);
            return n.toggle ? (a.appendChild(Pe.createIcon.call(this, n.iconPressed, {
                class: "icon--pressed"
            })), a.appendChild(Pe.createIcon.call(this, n.icon, {
                class: "icon--not-pressed"
            })), a.appendChild(Pe.createLabel.call(this, n.labelPressed, {
                class: "label--pressed"
            })), a.appendChild(Pe.createLabel.call(this, n.label, {
                class: "label--not-pressed"
            }))) : (a.appendChild(Pe.createIcon.call(this, n.icon)), a.appendChild(Pe.createLabel.call(this, n.label))), x(i, D(this.config.selectors.buttons[s], i)), I(a, i), "play" === s ? (S.array(this.elements.buttons[s]) || (this.elements.buttons[s] = []), this.elements.buttons[s].push(a)) : this.elements.buttons[s] = a, a;
        },
        createRange (e, t) {
            const i = $("input", x(D(this.config.selectors.inputs[e]), {
                type: "range",
                min: 0,
                max: 100,
                step: .01,
                value: 0,
                autocomplete: "off",
                role: "slider",
                "aria-label": ve.get(e, this.config),
                "aria-valuemin": 0,
                "aria-valuemax": 100,
                "aria-valuenow": 0
            }, t));
            return this.elements.inputs[e] = i, Pe.updateRangeFill.call(this, i), g.setup(i), i;
        },
        createProgress (e, t) {
            const i = $("progress", x(D(this.config.selectors.display[e]), {
                min: 0,
                max: 100,
                value: 0,
                role: "progressbar",
                "aria-hidden": !0
            }, t));
            if ("volume" !== e) {
                i.appendChild($("span", null, "0"));
                const t = {
                    played: "played",
                    buffer: "buffered"
                }[e], s = t ? ve.get(t, this.config) : "";
                i.innerText = `% ${s.toLowerCase()}`;
            }
            return this.elements.display[e] = i, i;
        },
        createTime (e, t) {
            const i = D(this.config.selectors.display[e], t), s = $("div", x(i, {
                class: `${i.class ? i.class : ""} ${this.config.classNames.display.time} `.trim(),
                "aria-label": ve.get(e, this.config),
                role: "timer"
            }), "00:00");
            return this.elements.display[e] = s, s;
        },
        bindMenuItemShortcuts (e, t) {
            X.call(this, e, "keydown keyup", (i)=>{
                if (![
                    " ",
                    "ArrowUp",
                    "ArrowDown",
                    "ArrowRight"
                ].includes(i.key)) return;
                if (i.preventDefault(), i.stopPropagation(), "keydown" === i.type) return;
                const s = V(e, '[role="menuitemradio"]');
                if (!s && [
                    " ",
                    "ArrowRight"
                ].includes(i.key)) Pe.showMenuPanel.call(this, t, !0);
                else {
                    let t;
                    " " !== i.key && ("ArrowDown" === i.key || s && "ArrowRight" === i.key ? (t = e.nextElementSibling, S.element(t) || (t = e.parentNode.firstElementChild)) : (t = e.previousElementSibling, S.element(t) || (t = e.parentNode.lastElementChild)), W.call(this, t, !0));
                }
            }, !1), X.call(this, e, "keyup", (e)=>{
                "Return" === e.key && Pe.focusFirstMenuItem.call(this, null, !0);
            });
        },
        createMenuItem ({ value: e, list: t, type: i, title: s, badge: n = null, checked: a = !1 }) {
            const l = D(this.config.selectors.inputs[i]), r = $("button", x(l, {
                type: "button",
                role: "menuitemradio",
                class: `${this.config.classNames.control} ${l.class ? l.class : ""}`.trim(),
                "aria-checked": a,
                value: e
            })), o = $("span");
            o.innerHTML = s, S.element(n) && o.appendChild(n), r.appendChild(o), Object.defineProperty(r, "checked", {
                enumerable: !0,
                get: ()=>"true" === r.getAttribute("aria-checked"),
                set (e) {
                    e && Array.from(r.parentNode.children).filter((e)=>V(e, '[role="menuitemradio"]')).forEach((e)=>e.setAttribute("aria-checked", "false")), r.setAttribute("aria-checked", e ? "true" : "false");
                }
            }), this.listeners.bind(r, "click keyup", (t)=>{
                if (!S.keyboardEvent(t) || " " === t.key) {
                    switch(t.preventDefault(), t.stopPropagation(), r.checked = !0, i){
                        case "language":
                            this.currentTrack = Number(e);
                            break;
                        case "quality":
                            this.quality = e;
                            break;
                        case "speed":
                            this.speed = parseFloat(e);
                    }
                    Pe.showMenuPanel.call(this, "home", S.keyboardEvent(t));
                }
            }, i, !1), Pe.bindMenuItemShortcuts.call(this, r, i), t.appendChild(r);
        },
        formatTime (e = 0, t = !1) {
            if (!S.number(e)) return e;
            return Ee(e, Ce(this.duration) > 0, t);
        },
        updateTimeDisplay (e = null, t = 0, i = !1) {
            S.element(e) && S.number(t) && (e.innerText = Pe.formatTime(t, i));
        },
        updateVolume () {
            this.supported.ui && (S.element(this.elements.inputs.volume) && Pe.setRange.call(this, this.elements.inputs.volume, this.muted ? 0 : this.volume), S.element(this.elements.buttons.mute) && (this.elements.buttons.mute.pressed = this.muted || 0 === this.volume));
        },
        setRange (e, t = 0) {
            S.element(e) && (e.value = t, Pe.updateRangeFill.call(this, e));
        },
        updateProgress (e) {
            if (!this.supported.ui || !S.event(e)) return;
            let t = 0;
            const i = (e, t)=>{
                const i = S.number(t) ? t : 0, s = S.element(e) ? e : this.elements.display.buffer;
                if (S.element(s)) {
                    s.value = i;
                    const e = s.getElementsByTagName("span")[0];
                    S.element(e) && (e.childNodes[0].nodeValue = i);
                }
            };
            if (e) switch(e.type){
                case "timeupdate":
                case "seeking":
                case "seeked":
                    s = this.currentTime, n = this.duration, t = 0 === s || 0 === n || Number.isNaN(s) || Number.isNaN(n) ? 0 : (s / n * 100).toFixed(2), "timeupdate" === e.type && Pe.setRange.call(this, this.elements.inputs.seek, t);
                    break;
                case "playing":
                case "progress":
                    i(this.elements.display.buffer, 100 * this.buffered);
            }
            var s, n;
        },
        updateRangeFill (e) {
            const t = S.event(e) ? e.target : e;
            if (S.element(t) && "range" === t.getAttribute("type")) {
                if (V(t, this.config.selectors.inputs.seek)) {
                    t.setAttribute("aria-valuenow", this.currentTime);
                    const e = Pe.formatTime(this.currentTime), i = Pe.formatTime(this.duration), s = ve.get("seekLabel", this.config);
                    t.setAttribute("aria-valuetext", s.replace("{currentTime}", e).replace("{duration}", i));
                } else if (V(t, this.config.selectors.inputs.volume)) {
                    const e = 100 * t.value;
                    t.setAttribute("aria-valuenow", e), t.setAttribute("aria-valuetext", `${e.toFixed(1)}%`);
                } else t.setAttribute("aria-valuenow", t.value);
                (M.isWebKit || M.isIPadOS) && t.style.setProperty("--value", t.value / t.max * 100 + "%");
            }
        },
        updateSeekTooltip (e) {
            var t, i;
            if (!this.config.tooltips.seek || !S.element(this.elements.inputs.seek) || !S.element(this.elements.display.seekTooltip) || 0 === this.duration) return;
            const s = this.elements.display.seekTooltip, n = `${this.config.classNames.tooltip}--visible`, a = (e)=>R(s, n, e);
            if (this.touch) return void a(!1);
            let l = 0;
            const r = this.elements.progress.getBoundingClientRect();
            if (S.event(e)) l = 100 / r.width * (e.pageX - r.left);
            else {
                if (!F(s, n)) return;
                l = parseFloat(s.style.left, 10);
            }
            l < 0 ? l = 0 : l > 100 && (l = 100);
            const o = this.duration / 100 * l;
            s.innerText = Pe.formatTime(o);
            const c = null === (t = this.config.markers) || void 0 === t || null === (i = t.points) || void 0 === i ? void 0 : i.find(({ time: e })=>e === Math.round(o));
            c && s.insertAdjacentHTML("afterbegin", `${c.label}<br>`), s.style.left = `${l}%`, S.event(e) && [
                "mouseenter",
                "mouseleave"
            ].includes(e.type) && a("mouseenter" === e.type);
        },
        timeUpdate (e) {
            const t = !S.element(this.elements.display.duration) && this.config.invertTime;
            Pe.updateTimeDisplay.call(this, this.elements.display.currentTime, t ? this.duration - this.currentTime : this.currentTime, t), e && "timeupdate" === e.type && this.media.seeking || Pe.updateProgress.call(this, e);
        },
        durationUpdate () {
            if (!this.supported.ui || !this.config.invertTime && this.currentTime) return;
            if (this.duration >= 2 ** 32) return H(this.elements.display.currentTime, !0), void H(this.elements.progress, !0);
            S.element(this.elements.inputs.seek) && this.elements.inputs.seek.setAttribute("aria-valuemax", this.duration);
            const e = S.element(this.elements.display.duration);
            !e && this.config.displayDuration && this.paused && Pe.updateTimeDisplay.call(this, this.elements.display.currentTime, this.duration), e && Pe.updateTimeDisplay.call(this, this.elements.display.duration, this.duration), this.config.markers.enabled && Pe.setMarkers.call(this), Pe.updateSeekTooltip.call(this);
        },
        toggleMenuButton (e, t) {
            H(this.elements.settings.buttons[e], !t);
        },
        updateSetting (e, t, i) {
            const s = this.elements.settings.panels[e];
            let n = null, a = t;
            if ("captions" === e) n = this.currentTrack;
            else {
                if (n = S.empty(i) ? this[e] : i, S.empty(n) && (n = this.config[e].default), !S.empty(this.options[e]) && !this.options[e].includes(n)) return void this.debug.warn(`Unsupported value of '${n}' for ${e}`);
                if (!this.config[e].options.includes(n)) return void this.debug.warn(`Disabled value of '${n}' for ${e}`);
            }
            if (S.element(a) || (a = s && s.querySelector('[role="menu"]')), !S.element(a)) return;
            this.elements.settings.buttons[e].querySelector(`.${this.config.classNames.menu.value}`).innerHTML = Pe.getLabel.call(this, e, n);
            const l = a && a.querySelector(`[value="${n}"]`);
            S.element(l) && (l.checked = !0);
        },
        getLabel (e, t) {
            switch(e){
                case "speed":
                    return 1 === t ? ve.get("normal", this.config) : `${t}&times;`;
                case "quality":
                    if (S.number(t)) {
                        const e = ve.get(`qualityLabel.${t}`, this.config);
                        return e.length ? e : `${t}p`;
                    }
                    return ge(t);
                case "captions":
                    return xe.getLabel.call(this);
                default:
                    return null;
            }
        },
        setQualityMenu (e) {
            if (!S.element(this.elements.settings.panels.quality)) return;
            const t = "quality", i = this.elements.settings.panels.quality.querySelector('[role="menu"]');
            S.array(e) && (this.options.quality = se(e).filter((e)=>this.config.quality.options.includes(e)));
            const s = !S.empty(this.options.quality) && this.options.quality.length > 1;
            if (Pe.toggleMenuButton.call(this, t, s), j(i), Pe.checkMenu.call(this), !s) return;
            const n = (e)=>{
                const t = ve.get(`qualityBadge.${e}`, this.config);
                return t.length ? Pe.createBadge.call(this, t) : null;
            };
            this.options.quality.sort((e, t)=>{
                const i = this.config.quality.options;
                return i.indexOf(e) > i.indexOf(t) ? 1 : -1;
            }).forEach((e)=>{
                Pe.createMenuItem.call(this, {
                    value: e,
                    list: i,
                    type: t,
                    title: Pe.getLabel.call(this, "quality", e),
                    badge: n(e)
                });
            }), Pe.updateSetting.call(this, t, i);
        },
        setCaptionsMenu () {
            if (!S.element(this.elements.settings.panels.captions)) return;
            const e = "captions", t = this.elements.settings.panels.captions.querySelector('[role="menu"]'), i = xe.getTracks.call(this), s = Boolean(i.length);
            if (Pe.toggleMenuButton.call(this, e, s), j(t), Pe.checkMenu.call(this), !s) return;
            const n = i.map((e, i)=>({
                    value: i,
                    checked: this.captions.toggled && this.currentTrack === i,
                    title: xe.getLabel.call(this, e),
                    badge: e.language && Pe.createBadge.call(this, e.language.toUpperCase()),
                    list: t,
                    type: "language"
                }));
            n.unshift({
                value: -1,
                checked: !this.captions.toggled,
                title: ve.get("disabled", this.config),
                list: t,
                type: "language"
            }), n.forEach(Pe.createMenuItem.bind(this)), Pe.updateSetting.call(this, e, t);
        },
        setSpeedMenu () {
            if (!S.element(this.elements.settings.panels.speed)) return;
            const e = "speed", t = this.elements.settings.panels.speed.querySelector('[role="menu"]');
            this.options.speed = this.options.speed.filter((e)=>e >= this.minimumSpeed && e <= this.maximumSpeed);
            const i = !S.empty(this.options.speed) && this.options.speed.length > 1;
            Pe.toggleMenuButton.call(this, e, i), j(t), Pe.checkMenu.call(this), i && (this.options.speed.forEach((i)=>{
                Pe.createMenuItem.call(this, {
                    value: i,
                    list: t,
                    type: e,
                    title: Pe.getLabel.call(this, "speed", i)
                });
            }), Pe.updateSetting.call(this, e, t));
        },
        checkMenu () {
            const { buttons: e } = this.elements.settings, t = !S.empty(e) && Object.values(e).some((e)=>!e.hidden);
            H(this.elements.settings.menu, !t);
        },
        focusFirstMenuItem (e, t = !1) {
            if (this.elements.settings.popup.hidden) return;
            let i = e;
            S.element(i) || (i = Object.values(this.elements.settings.panels).find((e)=>!e.hidden));
            const s = i.querySelector('[role^="menuitem"]');
            W.call(this, s, t);
        },
        toggleMenu (e) {
            const { popup: t } = this.elements.settings, i = this.elements.buttons.settings;
            if (!S.element(t) || !S.element(i)) return;
            const { hidden: s } = t;
            let n = s;
            if (S.boolean(e)) n = e;
            else if (S.keyboardEvent(e) && "Escape" === e.key) n = !1;
            else if (S.event(e)) {
                const s = S.function(e.composedPath) ? e.composedPath()[0] : e.target, a = t.contains(s);
                if (a || !a && e.target !== i && n) return;
            }
            i.setAttribute("aria-expanded", n), H(t, !n), R(this.elements.container, this.config.classNames.menu.open, n), n && S.keyboardEvent(e) ? Pe.focusFirstMenuItem.call(this, null, !0) : n || s || W.call(this, i, S.keyboardEvent(e));
        },
        getMenuSize (e) {
            const t = e.cloneNode(!0);
            t.style.position = "absolute", t.style.opacity = 0, t.removeAttribute("hidden"), e.parentNode.appendChild(t);
            const i = t.scrollWidth, s = t.scrollHeight;
            return O(t), {
                width: i,
                height: s
            };
        },
        showMenuPanel (e = "", t = !1) {
            const i = this.elements.container.querySelector(`#plyr-settings-${this.id}-${e}`);
            if (!S.element(i)) return;
            const s = i.parentNode, n = Array.from(s.children).find((e)=>!e.hidden);
            if (K.transitions && !K.reducedMotion) {
                s.style.width = `${n.scrollWidth}px`, s.style.height = `${n.scrollHeight}px`;
                const e = Pe.getMenuSize.call(this, i), t = (e)=>{
                    e.target === s && [
                        "width",
                        "height"
                    ].includes(e.propertyName) && (s.style.width = "", s.style.height = "", J.call(this, s, E, t));
                };
                X.call(this, s, E, t), s.style.width = `${e.width}px`, s.style.height = `${e.height}px`;
            }
            H(n, !0), H(i, !1), Pe.focusFirstMenuItem.call(this, i, t);
        },
        setDownloadUrl () {
            const e = this.elements.buttons.download;
            S.element(e) && e.setAttribute("href", this.download);
        },
        create (e) {
            const { bindMenuItemShortcuts: t, createButton: i, createProgress: s, createRange: n, createTime: a, setQualityMenu: l, setSpeedMenu: r, showMenuPanel: o } = Pe;
            this.elements.controls = null, S.array(this.config.controls) && this.config.controls.includes("play-large") && this.elements.container.appendChild(i.call(this, "play-large"));
            const c = $("div", D(this.config.selectors.controls.wrapper));
            this.elements.controls = c;
            const u = {
                class: "plyr__controls__item"
            };
            return se(S.array(this.config.controls) ? this.config.controls : []).forEach((l)=>{
                if ("restart" === l && c.appendChild(i.call(this, "restart", u)), "rewind" === l && c.appendChild(i.call(this, "rewind", u)), "play" === l && c.appendChild(i.call(this, "play", u)), "fast-forward" === l && c.appendChild(i.call(this, "fast-forward", u)), "progress" === l) {
                    const t = $("div", {
                        class: `${u.class} plyr__progress__container`
                    }), i = $("div", D(this.config.selectors.progress));
                    if (i.appendChild(n.call(this, "seek", {
                        id: `plyr-seek-${e.id}`
                    })), i.appendChild(s.call(this, "buffer")), this.config.tooltips.seek) {
                        const e = $("span", {
                            class: this.config.classNames.tooltip
                        }, "00:00");
                        i.appendChild(e), this.elements.display.seekTooltip = e;
                    }
                    this.elements.progress = i, t.appendChild(this.elements.progress), c.appendChild(t);
                }
                if ("current-time" === l && c.appendChild(a.call(this, "currentTime", u)), "duration" === l && c.appendChild(a.call(this, "duration", u)), "mute" === l || "volume" === l) {
                    let { volume: t } = this.elements;
                    if (S.element(t) && c.contains(t) || (t = $("div", x({}, u, {
                        class: `${u.class} plyr__volume`.trim()
                    })), this.elements.volume = t, c.appendChild(t)), "mute" === l && t.appendChild(i.call(this, "mute")), "volume" === l && !M.isIos && !M.isIPadOS) {
                        const i = {
                            max: 1,
                            step: .05,
                            value: this.config.volume
                        };
                        t.appendChild(n.call(this, "volume", x(i, {
                            id: `plyr-volume-${e.id}`
                        })));
                    }
                }
                if ("captions" === l && c.appendChild(i.call(this, "captions", u)), "settings" === l && !S.empty(this.config.settings)) {
                    const s = $("div", x({}, u, {
                        class: `${u.class} plyr__menu`.trim(),
                        hidden: ""
                    }));
                    s.appendChild(i.call(this, "settings", {
                        "aria-haspopup": !0,
                        "aria-controls": `plyr-settings-${e.id}`,
                        "aria-expanded": !1
                    }));
                    const n = $("div", {
                        class: "plyr__menu__container",
                        id: `plyr-settings-${e.id}`,
                        hidden: ""
                    }), a = $("div"), l = $("div", {
                        id: `plyr-settings-${e.id}-home`
                    }), r = $("div", {
                        role: "menu"
                    });
                    l.appendChild(r), a.appendChild(l), this.elements.settings.panels.home = l, this.config.settings.forEach((i)=>{
                        const s = $("button", x(D(this.config.selectors.buttons.settings), {
                            type: "button",
                            class: `${this.config.classNames.control} ${this.config.classNames.control}--forward`,
                            role: "menuitem",
                            "aria-haspopup": !0,
                            hidden: ""
                        }));
                        t.call(this, s, i), X.call(this, s, "click", ()=>{
                            o.call(this, i, !1);
                        });
                        const n = $("span", null, ve.get(i, this.config)), l = $("span", {
                            class: this.config.classNames.menu.value
                        });
                        l.innerHTML = e[i], n.appendChild(l), s.appendChild(n), r.appendChild(s);
                        const c = $("div", {
                            id: `plyr-settings-${e.id}-${i}`,
                            hidden: ""
                        }), u = $("button", {
                            type: "button",
                            class: `${this.config.classNames.control} ${this.config.classNames.control}--back`
                        });
                        u.appendChild($("span", {
                            "aria-hidden": !0
                        }, ve.get(i, this.config))), u.appendChild($("span", {
                            class: this.config.classNames.hidden
                        }, ve.get("menuBack", this.config))), X.call(this, c, "keydown", (e)=>{
                            "ArrowLeft" === e.key && (e.preventDefault(), e.stopPropagation(), o.call(this, "home", !0));
                        }, !1), X.call(this, u, "click", ()=>{
                            o.call(this, "home", !1);
                        }), c.appendChild(u), c.appendChild($("div", {
                            role: "menu"
                        })), a.appendChild(c), this.elements.settings.buttons[i] = s, this.elements.settings.panels[i] = c;
                    }), n.appendChild(a), s.appendChild(n), c.appendChild(s), this.elements.settings.popup = n, this.elements.settings.menu = s;
                }
                if ("pip" === l && K.pip && c.appendChild(i.call(this, "pip", u)), "airplay" === l && K.airplay && c.appendChild(i.call(this, "airplay", u)), "download" === l) {
                    const e = x({}, u, {
                        element: "a",
                        href: this.download,
                        target: "_blank"
                    });
                    this.isHTML5 && (e.download = "");
                    const { download: t } = this.config.urls;
                    !S.url(t) && this.isEmbed && x(e, {
                        icon: `logo-${this.provider}`,
                        label: this.provider
                    }), c.appendChild(i.call(this, "download", e));
                }
                "fullscreen" === l && c.appendChild(i.call(this, "fullscreen", u));
            }), this.isHTML5 && l.call(this, de.getQualityOptions.call(this)), r.call(this), c;
        },
        inject () {
            if (this.config.loadSprite) {
                const e = Pe.getIconUrl.call(this);
                e.cors && ke(e.url, "sprite-plyr");
            }
            this.id = Math.floor(1e4 * Math.random());
            let e = null;
            this.elements.controls = null;
            const t = {
                id: this.id,
                seektime: this.config.seekTime,
                title: this.config.title
            };
            let i = !0;
            S.function(this.config.controls) && (this.config.controls = this.config.controls.call(this, t)), this.config.controls || (this.config.controls = []), S.element(this.config.controls) || S.string(this.config.controls) ? e = this.config.controls : (e = Pe.create.call(this, {
                id: this.id,
                seektime: this.config.seekTime,
                speed: this.speed,
                quality: this.quality,
                captions: xe.getLabel.call(this)
            }), i = !1);
            let s;
            i && S.string(this.config.controls) && (e = ((e)=>{
                let i = e;
                return Object.entries(t).forEach(([e, t])=>{
                    i = pe(i, `{${e}}`, t);
                }), i;
            })(e)), S.string(this.config.selectors.controls.container) && (s = document.querySelector(this.config.selectors.controls.container)), S.element(s) || (s = this.elements.container);
            if (s[S.element(e) ? "insertAdjacentElement" : "insertAdjacentHTML"]("afterbegin", e), S.element(this.elements.controls) || Pe.findElements.call(this), !S.empty(this.elements.buttons)) {
                const e = (e)=>{
                    const t = this.config.classNames.controlPressed;
                    e.setAttribute("aria-pressed", "false"), Object.defineProperty(e, "pressed", {
                        configurable: !0,
                        enumerable: !0,
                        get: ()=>F(e, t),
                        set (i = !1) {
                            R(e, t, i), e.setAttribute("aria-pressed", i ? "true" : "false");
                        }
                    });
                };
                Object.values(this.elements.buttons).filter(Boolean).forEach((t)=>{
                    S.array(t) || S.nodeList(t) ? Array.from(t).filter(Boolean).forEach(e) : e(t);
                });
            }
            if (M.isEdge && P(s), this.config.tooltips.controls) {
                const { classNames: e, selectors: t } = this.config, i = `${t.controls.wrapper} ${t.labels} .${e.hidden}`, s = U.call(this, i);
                Array.from(s).forEach((e)=>{
                    R(e, this.config.classNames.hidden, !1), R(e, this.config.classNames.tooltip, !0);
                });
            }
        },
        setMediaMetadata () {
            try {
                "mediaSession" in navigator && (navigator.mediaSession.metadata = new window.MediaMetadata({
                    title: this.config.mediaMetadata.title,
                    artist: this.config.mediaMetadata.artist,
                    album: this.config.mediaMetadata.album,
                    artwork: this.config.mediaMetadata.artwork
                }));
            } catch (e) {}
        },
        setMarkers () {
            var e, t;
            if (!this.duration || this.elements.markers) return;
            const i = null === (e = this.config.markers) || void 0 === e || null === (t = e.points) || void 0 === t ? void 0 : t.filter(({ time: e })=>e > 0 && e < this.duration);
            if (null == i || !i.length) return;
            const s = document.createDocumentFragment(), n = document.createDocumentFragment();
            let a = null;
            const l = `${this.config.classNames.tooltip}--visible`, r = (e)=>R(a, l, e);
            i.forEach((e)=>{
                const t = $("span", {
                    class: this.config.classNames.marker
                }, ""), i = e.time / this.duration * 100 + "%";
                a && (t.addEventListener("mouseenter", ()=>{
                    e.label || (a.style.left = i, a.innerHTML = e.label, r(!0));
                }), t.addEventListener("mouseleave", ()=>{
                    r(!1);
                })), t.addEventListener("click", ()=>{
                    this.currentTime = e.time;
                }), t.style.left = i, n.appendChild(t);
            }), s.appendChild(n), this.config.tooltips.seek || (a = $("span", {
                class: this.config.classNames.tooltip
            }, ""), s.appendChild(a)), this.elements.markers = {
                points: n,
                tip: a
            }, this.elements.progress.appendChild(s);
        }
    };
    function Me(e, t = !0) {
        let i = e;
        if (t) {
            const e = document.createElement("a");
            e.href = i, i = e.href;
        }
        try {
            return new URL(i);
        } catch (e) {
            return null;
        }
    }
    function Ne(e) {
        const t = new URLSearchParams;
        return S.object(e) && Object.entries(e).forEach(([e, i])=>{
            t.set(e, i);
        }), t;
    }
    const xe = {
        setup () {
            if (!this.supported.ui) return;
            if (!this.isVideo || this.isYouTube || this.isHTML5 && !K.textTracks) return void (S.array(this.config.controls) && this.config.controls.includes("settings") && this.config.settings.includes("captions") && Pe.setCaptionsMenu.call(this));
            var e, t;
            if (S.element(this.elements.captions) || (this.elements.captions = $("div", D(this.config.selectors.captions)), this.elements.captions.setAttribute("dir", "auto"), e = this.elements.captions, t = this.elements.wrapper, S.element(e) && S.element(t) && t.parentNode.insertBefore(e, t.nextSibling)), M.isIE && window.URL) {
                const e = this.media.querySelectorAll("track");
                Array.from(e).forEach((e)=>{
                    const t = e.getAttribute("src"), i = Me(t);
                    null !== i && i.hostname !== window.location.href.hostname && [
                        "http:",
                        "https:"
                    ].includes(i.protocol) && Te(t, "blob").then((t)=>{
                        e.setAttribute("src", window.URL.createObjectURL(t));
                    }).catch(()=>{
                        O(e);
                    });
                });
            }
            const i = se((navigator.languages || [
                navigator.language || navigator.userLanguage || "en"
            ]).map((e)=>e.split("-")[0]));
            let s = (this.storage.get("language") || this.config.captions.language || "auto").toLowerCase();
            "auto" === s && ([s] = i);
            let n = this.storage.get("captions");
            if (S.boolean(n) || ({ active: n } = this.config.captions), Object.assign(this.captions, {
                toggled: !1,
                active: n,
                language: s,
                languages: i
            }), this.isHTML5) {
                const e = this.config.captions.update ? "addtrack removetrack" : "removetrack";
                X.call(this, this.media.textTracks, e, xe.update.bind(this));
            }
            setTimeout(xe.update.bind(this), 0);
        },
        update () {
            const e = xe.getTracks.call(this, !0), { active: t, language: i, meta: s, currentTrackNode: n } = this.captions, a = Boolean(e.find((e)=>e.language === i));
            this.isHTML5 && this.isVideo && e.filter((e)=>!s.get(e)).forEach((e)=>{
                this.debug.log("Track added", e), s.set(e, {
                    default: "showing" === e.mode
                }), "showing" === e.mode && (e.mode = "hidden"), X.call(this, e, "cuechange", ()=>xe.updateCues.call(this));
            }), (a && this.language !== i || !e.includes(n)) && (xe.setLanguage.call(this, i), xe.toggle.call(this, t && a)), this.elements && R(this.elements.container, this.config.classNames.captions.enabled, !S.empty(e)), S.array(this.config.controls) && this.config.controls.includes("settings") && this.config.settings.includes("captions") && Pe.setCaptionsMenu.call(this);
        },
        toggle (e, t = !0) {
            if (!this.supported.ui) return;
            const { toggled: i } = this.captions, s = this.config.classNames.captions.active, n = S.nullOrUndefined(e) ? !i : e;
            if (n !== i) {
                if (t || (this.captions.active = n, this.storage.set({
                    captions: n
                })), !this.language && n && !t) {
                    const e = xe.getTracks.call(this), t = xe.findTrack.call(this, [
                        this.captions.language,
                        ...this.captions.languages
                    ], !0);
                    return this.captions.language = t.language, void xe.set.call(this, e.indexOf(t));
                }
                this.elements.buttons.captions && (this.elements.buttons.captions.pressed = n), R(this.elements.container, s, n), this.captions.toggled = n, Pe.updateSetting.call(this, "captions"), Z.call(this, this.media, n ? "captionsenabled" : "captionsdisabled");
            }
            setTimeout(()=>{
                n && this.captions.toggled && (this.captions.currentTrackNode.mode = "hidden");
            });
        },
        set (e, t = !0) {
            const i = xe.getTracks.call(this);
            if (-1 !== e) {
                if (S.number(e)) {
                    if (e in i) {
                        if (this.captions.currentTrack !== e) {
                            this.captions.currentTrack = e;
                            const s = i[e], { language: n } = s || {};
                            this.captions.currentTrackNode = s, Pe.updateSetting.call(this, "captions"), t || (this.captions.language = n, this.storage.set({
                                language: n
                            })), this.isVimeo && this.embed.enableTextTrack(n), Z.call(this, this.media, "languagechange");
                        }
                        xe.toggle.call(this, !0, t), this.isHTML5 && this.isVideo && xe.updateCues.call(this);
                    } else this.debug.warn("Track not found", e);
                } else this.debug.warn("Invalid caption argument", e);
            } else xe.toggle.call(this, !1, t);
        },
        setLanguage (e, t = !0) {
            if (!S.string(e)) return void this.debug.warn("Invalid language argument", e);
            const i = e.toLowerCase();
            this.captions.language = i;
            const s = xe.getTracks.call(this), n = xe.findTrack.call(this, [
                i
            ]);
            xe.set.call(this, s.indexOf(n), t);
        },
        getTracks (e = !1) {
            return Array.from((this.media || {}).textTracks || []).filter((t)=>!this.isHTML5 || e || this.captions.meta.has(t)).filter((e)=>[
                    "captions",
                    "subtitles"
                ].includes(e.kind));
        },
        findTrack (e, t = !1) {
            const i = xe.getTracks.call(this), s = (e)=>Number((this.captions.meta.get(e) || {}).default), n = Array.from(i).sort((e, t)=>s(t) - s(e));
            let a;
            return e.every((e)=>(a = n.find((t)=>t.language === e), !a)), a || (t ? n[0] : void 0);
        },
        getCurrentTrack () {
            return xe.getTracks.call(this)[this.currentTrack];
        },
        getLabel (e) {
            let t = e;
            return !S.track(t) && K.textTracks && this.captions.toggled && (t = xe.getCurrentTrack.call(this)), S.track(t) ? S.empty(t.label) ? S.empty(t.language) ? ve.get("enabled", this.config) : e.language.toUpperCase() : t.label : ve.get("disabled", this.config);
        },
        updateCues (e) {
            if (!this.supported.ui) return;
            if (!S.element(this.elements.captions)) return void this.debug.warn("No captions element to render to");
            if (!S.nullOrUndefined(e) && !Array.isArray(e)) return void this.debug.warn("updateCues: Invalid input", e);
            let t = e;
            if (!t) {
                const e = xe.getCurrentTrack.call(this);
                t = Array.from((e || {}).activeCues || []).map((e)=>e.getCueAsHTML()).map(ye);
            }
            const i = t.map((e)=>e.trim()).join("\n");
            if (i !== this.elements.captions.innerHTML) {
                j(this.elements.captions);
                const e = $("span", D(this.config.selectors.caption));
                e.innerHTML = i, this.elements.captions.appendChild(e), Z.call(this, this.media, "cuechange");
            }
        }
    }, Le = {
        enabled: !0,
        title: "",
        debug: !1,
        autoplay: !1,
        autopause: !0,
        playsinline: !0,
        seekTime: 10,
        volume: 1,
        muted: !1,
        duration: null,
        displayDuration: !0,
        invertTime: !0,
        toggleInvert: !0,
        ratio: null,
        clickToPlay: !0,
        hideControls: !0,
        resetOnEnd: !1,
        disableContextMenu: !0,
        loadSprite: !0,
        iconPrefix: "plyr",
        iconUrl: "https://cdn.plyr.io/3.7.8/plyr.svg",
        blankVideo: "https://cdn.plyr.io/static/blank.mp4",
        quality: {
            default: 576,
            options: [
                4320,
                2880,
                2160,
                1440,
                1080,
                720,
                576,
                480,
                360,
                240
            ],
            forced: !1,
            onChange: null
        },
        loop: {
            active: !1
        },
        speed: {
            selected: 1,
            options: [
                .5,
                .75,
                1,
                1.25,
                1.5,
                1.75,
                2,
                4
            ]
        },
        keyboard: {
            focused: !0,
            global: !1
        },
        tooltips: {
            controls: !1,
            seek: !0
        },
        captions: {
            active: !1,
            language: "auto",
            update: !1
        },
        fullscreen: {
            enabled: !0,
            fallback: !0,
            iosNative: !1
        },
        storage: {
            enabled: !0,
            key: "plyr"
        },
        controls: [
            "play-large",
            "play",
            "progress",
            "current-time",
            "mute",
            "volume",
            "captions",
            "settings",
            "pip",
            "airplay",
            "fullscreen"
        ],
        settings: [
            "captions",
            "quality",
            "speed"
        ],
        i18n: {
            restart: "Restart",
            rewind: "Rewind {seektime}s",
            play: "Play",
            pause: "Pause",
            fastForward: "Forward {seektime}s",
            seek: "Seek",
            seekLabel: "{currentTime} of {duration}",
            played: "Played",
            buffered: "Buffered",
            currentTime: "Current time",
            duration: "Duration",
            volume: "Volume",
            mute: "Mute",
            unmute: "Unmute",
            enableCaptions: "Enable captions",
            disableCaptions: "Disable captions",
            download: "Download",
            enterFullscreen: "Enter fullscreen",
            exitFullscreen: "Exit fullscreen",
            frameTitle: "Player for {title}",
            captions: "Captions",
            settings: "Settings",
            pip: "PIP",
            menuBack: "Go back to previous menu",
            speed: "Speed",
            normal: "Normal",
            quality: "Quality",
            loop: "Loop",
            start: "Start",
            end: "End",
            all: "All",
            reset: "Reset",
            disabled: "Disabled",
            enabled: "Enabled",
            advertisement: "Ad",
            qualityBadge: {
                2160: "4K",
                1440: "HD",
                1080: "HD",
                720: "HD",
                576: "SD",
                480: "SD"
            }
        },
        urls: {
            download: null,
            vimeo: {
                sdk: "https://player.vimeo.com/api/player.js",
                iframe: "https://player.vimeo.com/video/{0}?{1}",
                api: "https://vimeo.com/api/oembed.json?url={0}"
            },
            youtube: {
                sdk: "https://www.youtube.com/iframe_api",
                api: "https://noembed.com/embed?url=https://www.youtube.com/watch?v={0}"
            },
            googleIMA: {
                sdk: "https://imasdk.googleapis.com/js/sdkloader/ima3.js"
            }
        },
        listeners: {
            seek: null,
            play: null,
            pause: null,
            restart: null,
            rewind: null,
            fastForward: null,
            mute: null,
            volume: null,
            captions: null,
            download: null,
            fullscreen: null,
            pip: null,
            airplay: null,
            speed: null,
            quality: null,
            loop: null,
            language: null
        },
        events: [
            "ended",
            "progress",
            "stalled",
            "playing",
            "waiting",
            "canplay",
            "canplaythrough",
            "loadstart",
            "loadeddata",
            "loadedmetadata",
            "timeupdate",
            "volumechange",
            "play",
            "pause",
            "error",
            "seeking",
            "seeked",
            "emptied",
            "ratechange",
            "cuechange",
            "download",
            "enterfullscreen",
            "exitfullscreen",
            "captionsenabled",
            "captionsdisabled",
            "languagechange",
            "controlshidden",
            "controlsshown",
            "ready",
            "statechange",
            "qualitychange",
            "adsloaded",
            "adscontentpause",
            "adscontentresume",
            "adstarted",
            "adsmidpoint",
            "adscomplete",
            "adsallcomplete",
            "adsimpression",
            "adsclick"
        ],
        selectors: {
            editable: "input, textarea, select, [contenteditable]",
            container: ".plyr",
            controls: {
                container: null,
                wrapper: ".plyr__controls"
            },
            labels: "[data-plyr]",
            buttons: {
                play: '[data-plyr="play"]',
                pause: '[data-plyr="pause"]',
                restart: '[data-plyr="restart"]',
                rewind: '[data-plyr="rewind"]',
                fastForward: '[data-plyr="fast-forward"]',
                mute: '[data-plyr="mute"]',
                captions: '[data-plyr="captions"]',
                download: '[data-plyr="download"]',
                fullscreen: '[data-plyr="fullscreen"]',
                pip: '[data-plyr="pip"]',
                airplay: '[data-plyr="airplay"]',
                settings: '[data-plyr="settings"]',
                loop: '[data-plyr="loop"]'
            },
            inputs: {
                seek: '[data-plyr="seek"]',
                volume: '[data-plyr="volume"]',
                speed: '[data-plyr="speed"]',
                language: '[data-plyr="language"]',
                quality: '[data-plyr="quality"]'
            },
            display: {
                currentTime: ".plyr__time--current",
                duration: ".plyr__time--duration",
                buffer: ".plyr__progress__buffer",
                loop: ".plyr__progress__loop",
                volume: ".plyr__volume--display"
            },
            progress: ".plyr__progress",
            captions: ".plyr__captions",
            caption: ".plyr__caption"
        },
        classNames: {
            type: "plyr--{0}",
            provider: "plyr--{0}",
            video: "plyr__video-wrapper",
            embed: "plyr__video-embed",
            videoFixedRatio: "plyr__video-wrapper--fixed-ratio",
            embedContainer: "plyr__video-embed__container",
            poster: "plyr__poster",
            posterEnabled: "plyr__poster-enabled",
            ads: "plyr__ads",
            control: "plyr__control",
            controlPressed: "plyr__control--pressed",
            playing: "plyr--playing",
            paused: "plyr--paused",
            stopped: "plyr--stopped",
            loading: "plyr--loading",
            hover: "plyr--hover",
            tooltip: "plyr__tooltip",
            cues: "plyr__cues",
            marker: "plyr__progress__marker",
            hidden: "plyr__sr-only",
            hideControls: "plyr--hide-controls",
            isTouch: "plyr--is-touch",
            uiSupported: "plyr--full-ui",
            noTransition: "plyr--no-transition",
            display: {
                time: "plyr__time"
            },
            menu: {
                value: "plyr__menu__value",
                badge: "plyr__badge",
                open: "plyr--menu-open"
            },
            captions: {
                enabled: "plyr--captions-enabled",
                active: "plyr--captions-active"
            },
            fullscreen: {
                enabled: "plyr--fullscreen-enabled",
                fallback: "plyr--fullscreen-fallback"
            },
            pip: {
                supported: "plyr--pip-supported",
                active: "plyr--pip-active"
            },
            airplay: {
                supported: "plyr--airplay-supported",
                active: "plyr--airplay-active"
            },
            previewThumbnails: {
                thumbContainer: "plyr__preview-thumb",
                thumbContainerShown: "plyr__preview-thumb--is-shown",
                imageContainer: "plyr__preview-thumb__image-container",
                timeContainer: "plyr__preview-thumb__time-container",
                scrubbingContainer: "plyr__preview-scrubbing",
                scrubbingContainerShown: "plyr__preview-scrubbing--is-shown"
            }
        },
        attributes: {
            embed: {
                provider: "data-plyr-provider",
                id: "data-plyr-embed-id",
                hash: "data-plyr-embed-hash"
            }
        },
        ads: {
            enabled: !1,
            publisherId: "",
            tagUrl: ""
        },
        previewThumbnails: {
            enabled: !1,
            src: ""
        },
        vimeo: {
            byline: !1,
            portrait: !1,
            title: !1,
            speed: !0,
            transparent: !1,
            customControls: !0,
            referrerPolicy: null,
            premium: !1
        },
        youtube: {
            rel: 0,
            showinfo: 0,
            iv_load_policy: 3,
            modestbranding: 1,
            customControls: !0,
            noCookie: !1
        },
        mediaMetadata: {
            title: "",
            artist: "",
            album: "",
            artwork: []
        },
        markers: {
            enabled: !1,
            points: []
        }
    }, Ie = "picture-in-picture", $e = "inline", _e = {
        html5: "html5",
        youtube: "youtube",
        vimeo: "vimeo"
    }, Oe = "audio", je = "video";
    const qe = ()=>{};
    class De {
        constructor(e = !1){
            this.enabled = window.console && e, this.enabled && this.log("Debugging enabled");
        }
        get log() {
            return this.enabled ? Function.prototype.bind.call(console.log, console) : qe;
        }
        get warn() {
            return this.enabled ? Function.prototype.bind.call(console.warn, console) : qe;
        }
        get error() {
            return this.enabled ? Function.prototype.bind.call(console.error, console) : qe;
        }
    }
    class He {
        constructor(t){
            e(this, "onChange", ()=>{
                if (!this.supported) return;
                const e = this.player.elements.buttons.fullscreen;
                S.element(e) && (e.pressed = this.active);
                const t = this.target === this.player.media ? this.target : this.player.elements.container;
                Z.call(this.player, t, this.active ? "enterfullscreen" : "exitfullscreen", !0);
            }), e(this, "toggleFallback", (e = !1)=>{
                if (e ? this.scrollPosition = {
                    x: window.scrollX ?? 0,
                    y: window.scrollY ?? 0
                } : window.scrollTo(this.scrollPosition.x, this.scrollPosition.y), document.body.style.overflow = e ? "hidden" : "", R(this.target, this.player.config.classNames.fullscreen.fallback, e), M.isIos) {
                    let t = document.head.querySelector('meta[name="viewport"]');
                    const i = "viewport-fit=cover";
                    t || (t = document.createElement("meta"), t.setAttribute("name", "viewport"));
                    const s = S.string(t.content) && t.content.includes(i);
                    e ? (this.cleanupViewport = !s, s || (t.content += `,${i}`)) : this.cleanupViewport && (t.content = t.content.split(",").filter((e)=>e.trim() !== i).join(","));
                }
                this.onChange();
            }), e(this, "trapFocus", (e)=>{
                if (M.isIos || M.isIPadOS || !this.active || "Tab" !== e.key) return;
                const t = document.activeElement, i = U.call(this.player, "a[href], button:not(:disabled), input:not(:disabled), [tabindex]"), [s] = i, n = i[i.length - 1];
                t !== n || e.shiftKey ? t === s && e.shiftKey && (n.focus(), e.preventDefault()) : (s.focus(), e.preventDefault());
            }), e(this, "update", ()=>{
                if (this.supported) {
                    let e;
                    e = this.forceFallback ? "Fallback (forced)" : He.nativeSupported ? "Native" : "Fallback", this.player.debug.log(`${e} fullscreen enabled`);
                } else this.player.debug.log("Fullscreen not supported and fallback disabled");
                R(this.player.elements.container, this.player.config.classNames.fullscreen.enabled, this.supported);
            }), e(this, "enter", ()=>{
                this.supported && (M.isIos && this.player.config.fullscreen.iosNative ? this.player.isVimeo ? this.player.embed.requestFullscreen() : this.target.webkitEnterFullscreen() : !He.nativeSupported || this.forceFallback ? this.toggleFallback(!0) : this.prefix ? S.empty(this.prefix) || this.target[`${this.prefix}Request${this.property}`]() : this.target.requestFullscreen({
                    navigationUI: "hide"
                }));
            }), e(this, "exit", ()=>{
                if (this.supported) {
                    if (M.isIos && this.player.config.fullscreen.iosNative) this.player.isVimeo ? this.player.embed.exitFullscreen() : this.target.webkitEnterFullscreen(), ie(this.player.play());
                    else if (!He.nativeSupported || this.forceFallback) this.toggleFallback(!1);
                    else if (this.prefix) {
                        if (!S.empty(this.prefix)) {
                            const e = "moz" === this.prefix ? "Cancel" : "Exit";
                            document[`${this.prefix}${e}${this.property}`]();
                        }
                    } else (document.cancelFullScreen || document.exitFullscreen).call(document);
                }
            }), e(this, "toggle", ()=>{
                this.active ? this.exit() : this.enter();
            }), this.player = t, this.prefix = He.prefix, this.property = He.property, this.scrollPosition = {
                x: 0,
                y: 0
            }, this.forceFallback = "force" === t.config.fullscreen.fallback, this.player.elements.fullscreen = t.config.fullscreen.container && function(e, t) {
                const { prototype: i } = Element;
                return (i.closest || function() {
                    let e = this;
                    do {
                        if (V.matches(e, t)) return e;
                        e = e.parentElement || e.parentNode;
                    }while (null !== e && 1 === e.nodeType);
                    return null;
                }).call(e, t);
            }(this.player.elements.container, t.config.fullscreen.container), X.call(this.player, document, "ms" === this.prefix ? "MSFullscreenChange" : `${this.prefix}fullscreenchange`, ()=>{
                this.onChange();
            }), X.call(this.player, this.player.elements.container, "dblclick", (e)=>{
                S.element(this.player.elements.controls) && this.player.elements.controls.contains(e.target) || this.player.listeners.proxy(e, this.toggle, "fullscreen");
            }), X.call(this, this.player.elements.container, "keydown", (e)=>this.trapFocus(e)), this.update();
        }
        static get nativeSupported() {
            return !!(document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled);
        }
        get useNative() {
            return He.nativeSupported && !this.forceFallback;
        }
        static get prefix() {
            if (S.function(document.exitFullscreen)) return "";
            let e = "";
            return [
                "webkit",
                "moz",
                "ms"
            ].some((t)=>!(!S.function(document[`${t}ExitFullscreen`]) && !S.function(document[`${t}CancelFullScreen`])) && (e = t, !0)), e;
        }
        static get property() {
            return "moz" === this.prefix ? "FullScreen" : "Fullscreen";
        }
        get supported() {
            return [
                this.player.config.fullscreen.enabled,
                this.player.isVideo,
                He.nativeSupported || this.player.config.fullscreen.fallback,
                !this.player.isYouTube || He.nativeSupported || !M.isIos || this.player.config.playsinline && !this.player.config.fullscreen.iosNative
            ].every(Boolean);
        }
        get active() {
            if (!this.supported) return !1;
            if (!He.nativeSupported || this.forceFallback) return F(this.target, this.player.config.classNames.fullscreen.fallback);
            const e = this.prefix ? this.target.getRootNode()[`${this.prefix}${this.property}Element`] : this.target.getRootNode().fullscreenElement;
            return e && e.shadowRoot ? e === this.target.getRootNode().host : e === this.target;
        }
        get target() {
            return M.isIos && this.player.config.fullscreen.iosNative ? this.player.media : this.player.elements.fullscreen ?? this.player.elements.container;
        }
    }
    function Re(e, t = 1) {
        return new Promise((i, s)=>{
            const n = new Image, a = ()=>{
                delete n.onload, delete n.onerror, (n.naturalWidth >= t ? i : s)(n);
            };
            Object.assign(n, {
                onload: a,
                onerror: a,
                src: e
            });
        });
    }
    const Fe = {
        addStyleHook () {
            R(this.elements.container, this.config.selectors.container.replace(".", ""), !0), R(this.elements.container, this.config.classNames.uiSupported, this.supported.ui);
        },
        toggleNativeControls (e = !1) {
            e && this.isHTML5 ? this.media.setAttribute("controls", "") : this.media.removeAttribute("controls");
        },
        build () {
            if (this.listeners.media(), !this.supported.ui) return this.debug.warn(`Basic support only for ${this.provider} ${this.type}`), void Fe.toggleNativeControls.call(this, !0);
            S.element(this.elements.controls) || (Pe.inject.call(this), this.listeners.controls()), Fe.toggleNativeControls.call(this), this.isHTML5 && xe.setup.call(this), this.volume = null, this.muted = null, this.loop = null, this.quality = null, this.speed = null, Pe.updateVolume.call(this), Pe.timeUpdate.call(this), Pe.durationUpdate.call(this), Fe.checkPlaying.call(this), R(this.elements.container, this.config.classNames.pip.supported, K.pip && this.isHTML5 && this.isVideo), R(this.elements.container, this.config.classNames.airplay.supported, K.airplay && this.isHTML5), R(this.elements.container, this.config.classNames.isTouch, this.touch), this.ready = !0, setTimeout(()=>{
                Z.call(this, this.media, "ready");
            }, 0), Fe.setTitle.call(this), this.poster && Fe.setPoster.call(this, this.poster, !1).catch(()=>{}), this.config.duration && Pe.durationUpdate.call(this), this.config.mediaMetadata && Pe.setMediaMetadata.call(this);
        },
        setTitle () {
            let e = ve.get("play", this.config);
            if (S.string(this.config.title) && !S.empty(this.config.title) && (e += `, ${this.config.title}`), Array.from(this.elements.buttons.play || []).forEach((t)=>{
                t.setAttribute("aria-label", e);
            }), this.isEmbed) {
                const e = B.call(this, "iframe");
                if (!S.element(e)) return;
                const t = S.empty(this.config.title) ? "video" : this.config.title, i = ve.get("frameTitle", this.config);
                e.setAttribute("title", i.replace("{title}", t));
            }
        },
        togglePoster (e) {
            R(this.elements.container, this.config.classNames.posterEnabled, e);
        },
        setPoster (e, t = !0) {
            return t && this.poster ? Promise.reject(new Error("Poster already set")) : (this.media.setAttribute("data-poster", e), this.elements.poster.removeAttribute("hidden"), te.call(this).then(()=>Re(e)).catch((t)=>{
                throw e === this.poster && Fe.togglePoster.call(this, !1), t;
            }).then(()=>{
                if (e !== this.poster) throw new Error("setPoster cancelled by later call to setPoster");
            }).then(()=>(Object.assign(this.elements.poster.style, {
                    backgroundImage: `url('${e}')`,
                    backgroundSize: ""
                }), Fe.togglePoster.call(this, !0), e)));
        },
        checkPlaying (e) {
            R(this.elements.container, this.config.classNames.playing, this.playing), R(this.elements.container, this.config.classNames.paused, this.paused), R(this.elements.container, this.config.classNames.stopped, this.stopped), Array.from(this.elements.buttons.play || []).forEach((e)=>{
                Object.assign(e, {
                    pressed: this.playing
                }), e.setAttribute("aria-label", ve.get(this.playing ? "pause" : "play", this.config));
            }), S.event(e) && "timeupdate" === e.type || Fe.toggleControls.call(this);
        },
        checkLoading (e) {
            this.loading = [
                "stalled",
                "waiting"
            ].includes(e.type), clearTimeout(this.timers.loading), this.timers.loading = setTimeout(()=>{
                R(this.elements.container, this.config.classNames.loading, this.loading), Fe.toggleControls.call(this);
            }, this.loading ? 250 : 0);
        },
        toggleControls (e) {
            const { controls: t } = this.elements;
            if (t && this.config.hideControls) {
                const i = this.touch && this.lastSeekTime + 2e3 > Date.now();
                this.toggleControls(Boolean(e || this.loading || this.paused || t.pressed || t.hover || i));
            }
        },
        migrateStyles () {
            Object.values({
                ...this.media.style
            }).filter((e)=>!S.empty(e) && S.string(e) && e.startsWith("--plyr")).forEach((e)=>{
                this.elements.container.style.setProperty(e, this.media.style.getPropertyValue(e)), this.media.style.removeProperty(e);
            }), S.empty(this.media.style) && this.media.removeAttribute("style");
        }
    };
    class Ve {
        constructor(t){
            e(this, "firstTouch", ()=>{
                const { player: e } = this, { elements: t } = e;
                e.touch = !0, R(t.container, e.config.classNames.isTouch, !0);
            }), e(this, "global", (e = !0)=>{
                const { player: t } = this;
                t.config.keyboard.global && Q.call(t, window, "keydown keyup", this.handleKey, e, !1), Q.call(t, document.body, "click", this.toggleMenu, e), G.call(t, document.body, "touchstart", this.firstTouch);
            }), e(this, "container", ()=>{
                const { player: e } = this, { config: t, elements: i, timers: s } = e;
                !t.keyboard.global && t.keyboard.focused && X.call(e, i.container, "keydown keyup", this.handleKey, !1), X.call(e, i.container, "mousemove mouseleave touchstart touchmove enterfullscreen exitfullscreen", (t)=>{
                    const { controls: n } = i;
                    n && "enterfullscreen" === t.type && (n.pressed = !1, n.hover = !1);
                    let a = 0;
                    [
                        "touchstart",
                        "touchmove",
                        "mousemove"
                    ].includes(t.type) && (Fe.toggleControls.call(e, !0), a = e.touch ? 3e3 : 2e3), clearTimeout(s.controls), s.controls = setTimeout(()=>Fe.toggleControls.call(e, !1), a);
                });
                const n = ()=>{
                    if (!e.isVimeo || e.config.vimeo.premium) return;
                    const t = i.wrapper, { active: s } = e.fullscreen, [n, a] = ce.call(e), l = ae(`aspect-ratio: ${n} / ${a}`);
                    if (!s) return void (l ? (t.style.width = null, t.style.height = null) : (t.style.maxWidth = null, t.style.margin = null));
                    const [r, o] = [
                        Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0),
                        Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
                    ], c = r / o > n / a;
                    l ? (t.style.width = c ? "auto" : "100%", t.style.height = c ? "100%" : "auto") : (t.style.maxWidth = c ? o / a * n + "px" : null, t.style.margin = c ? "0 auto" : null);
                }, a = ()=>{
                    clearTimeout(s.resized), s.resized = setTimeout(n, 50);
                };
                X.call(e, i.container, "enterfullscreen exitfullscreen", (t)=>{
                    const { target: s } = e.fullscreen;
                    if (s !== i.container) return;
                    if (!e.isEmbed && S.empty(e.config.ratio)) return;
                    n();
                    ("enterfullscreen" === t.type ? X : J).call(e, window, "resize", a);
                });
            }), e(this, "media", ()=>{
                const { player: e } = this, { elements: t } = e;
                if (X.call(e, e.media, "timeupdate seeking seeked", (t)=>Pe.timeUpdate.call(e, t)), X.call(e, e.media, "durationchange loadeddata loadedmetadata", (t)=>Pe.durationUpdate.call(e, t)), X.call(e, e.media, "ended", ()=>{
                    e.isHTML5 && e.isVideo && e.config.resetOnEnd && (e.restart(), e.pause());
                }), X.call(e, e.media, "progress playing seeking seeked", (t)=>Pe.updateProgress.call(e, t)), X.call(e, e.media, "volumechange", (t)=>Pe.updateVolume.call(e, t)), X.call(e, e.media, "playing play pause ended emptied timeupdate", (t)=>Fe.checkPlaying.call(e, t)), X.call(e, e.media, "waiting canplay seeked playing", (t)=>Fe.checkLoading.call(e, t)), e.supported.ui && e.config.clickToPlay && !e.isAudio) {
                    const i = B.call(e, `.${e.config.classNames.video}`);
                    if (!S.element(i)) return;
                    X.call(e, t.container, "click", (s)=>{
                        ([
                            t.container,
                            i
                        ].includes(s.target) || i.contains(s.target)) && (e.touch && e.config.hideControls || (e.ended ? (this.proxy(s, e.restart, "restart"), this.proxy(s, ()=>{
                            ie(e.play());
                        }, "play")) : this.proxy(s, ()=>{
                            ie(e.togglePlay());
                        }, "play")));
                    });
                }
                e.supported.ui && e.config.disableContextMenu && X.call(e, t.wrapper, "contextmenu", (e)=>{
                    e.preventDefault();
                }, !1), X.call(e, e.media, "volumechange", ()=>{
                    e.storage.set({
                        volume: e.volume,
                        muted: e.muted
                    });
                }), X.call(e, e.media, "ratechange", ()=>{
                    Pe.updateSetting.call(e, "speed"), e.storage.set({
                        speed: e.speed
                    });
                }), X.call(e, e.media, "qualitychange", (t)=>{
                    Pe.updateSetting.call(e, "quality", null, t.detail.quality);
                }), X.call(e, e.media, "ready qualitychange", ()=>{
                    Pe.setDownloadUrl.call(e);
                });
                const i = e.config.events.concat([
                    "keyup",
                    "keydown"
                ]).join(" ");
                X.call(e, e.media, i, (i)=>{
                    let { detail: s = {} } = i;
                    "error" === i.type && (s = e.media.error), Z.call(e, t.container, i.type, !0, s);
                });
            }), e(this, "proxy", (e, t, i)=>{
                const { player: s } = this, n = s.config.listeners[i];
                let a = !0;
                S.function(n) && (a = n.call(s, e)), !1 !== a && S.function(t) && t.call(s, e);
            }), e(this, "bind", (e, t, i, s, n = !0)=>{
                const { player: a } = this, l = a.config.listeners[s], r = S.function(l);
                X.call(a, e, t, (e)=>this.proxy(e, i, s), n && !r);
            }), e(this, "controls", ()=>{
                const { player: e } = this, { elements: t } = e, i = M.isIE ? "change" : "input";
                if (t.buttons.play && Array.from(t.buttons.play).forEach((t)=>{
                    this.bind(t, "click", ()=>{
                        ie(e.togglePlay());
                    }, "play");
                }), this.bind(t.buttons.restart, "click", e.restart, "restart"), this.bind(t.buttons.rewind, "click", ()=>{
                    e.lastSeekTime = Date.now(), e.rewind();
                }, "rewind"), this.bind(t.buttons.fastForward, "click", ()=>{
                    e.lastSeekTime = Date.now(), e.forward();
                }, "fastForward"), this.bind(t.buttons.mute, "click", ()=>{
                    e.muted = !e.muted;
                }, "mute"), this.bind(t.buttons.captions, "click", ()=>e.toggleCaptions()), this.bind(t.buttons.download, "click", ()=>{
                    Z.call(e, e.media, "download");
                }, "download"), this.bind(t.buttons.fullscreen, "click", ()=>{
                    e.fullscreen.toggle();
                }, "fullscreen"), this.bind(t.buttons.pip, "click", ()=>{
                    e.pip = "toggle";
                }, "pip"), this.bind(t.buttons.airplay, "click", e.airplay, "airplay"), this.bind(t.buttons.settings, "click", (t)=>{
                    t.stopPropagation(), t.preventDefault(), Pe.toggleMenu.call(e, t);
                }, null, !1), this.bind(t.buttons.settings, "keyup", (t)=>{
                    [
                        " ",
                        "Enter"
                    ].includes(t.key) && ("Enter" !== t.key ? (t.preventDefault(), t.stopPropagation(), Pe.toggleMenu.call(e, t)) : Pe.focusFirstMenuItem.call(e, null, !0));
                }, null, !1), this.bind(t.settings.menu, "keydown", (t)=>{
                    "Escape" === t.key && Pe.toggleMenu.call(e, t);
                }), this.bind(t.inputs.seek, "mousedown mousemove", (e)=>{
                    const i = t.progress.getBoundingClientRect(), s = 100 / i.width * (e.pageX - i.left);
                    e.currentTarget.setAttribute("seek-value", s);
                }), this.bind(t.inputs.seek, "mousedown mouseup keydown keyup touchstart touchend", (t)=>{
                    const i = t.currentTarget, s = "play-on-seeked";
                    if (S.keyboardEvent(t) && ![
                        "ArrowLeft",
                        "ArrowRight"
                    ].includes(t.key)) return;
                    e.lastSeekTime = Date.now();
                    const n = i.hasAttribute(s), a = [
                        "mouseup",
                        "touchend",
                        "keyup"
                    ].includes(t.type);
                    n && a ? (i.removeAttribute(s), ie(e.play())) : !a && e.playing && (i.setAttribute(s, ""), e.pause());
                }), M.isIos) {
                    const t = U.call(e, 'input[type="range"]');
                    Array.from(t).forEach((e)=>this.bind(e, i, (e)=>P(e.target)));
                }
                this.bind(t.inputs.seek, i, (t)=>{
                    const i = t.currentTarget;
                    let s = i.getAttribute("seek-value");
                    S.empty(s) && (s = i.value), i.removeAttribute("seek-value"), e.currentTime = s / i.max * e.duration;
                }, "seek"), this.bind(t.progress, "mouseenter mouseleave mousemove", (t)=>Pe.updateSeekTooltip.call(e, t)), this.bind(t.progress, "mousemove touchmove", (t)=>{
                    const { previewThumbnails: i } = e;
                    i && i.loaded && i.startMove(t);
                }), this.bind(t.progress, "mouseleave touchend click", ()=>{
                    const { previewThumbnails: t } = e;
                    t && t.loaded && t.endMove(!1, !0);
                }), this.bind(t.progress, "mousedown touchstart", (t)=>{
                    const { previewThumbnails: i } = e;
                    i && i.loaded && i.startScrubbing(t);
                }), this.bind(t.progress, "mouseup touchend", (t)=>{
                    const { previewThumbnails: i } = e;
                    i && i.loaded && i.endScrubbing(t);
                }), M.isWebKit && Array.from(U.call(e, 'input[type="range"]')).forEach((t)=>{
                    this.bind(t, "input", (t)=>Pe.updateRangeFill.call(e, t.target));
                }), e.config.toggleInvert && !S.element(t.display.duration) && this.bind(t.display.currentTime, "click", ()=>{
                    0 !== e.currentTime && (e.config.invertTime = !e.config.invertTime, Pe.timeUpdate.call(e));
                }), this.bind(t.inputs.volume, i, (t)=>{
                    e.volume = t.target.value;
                }, "volume"), this.bind(t.controls, "mouseenter mouseleave", (i)=>{
                    t.controls.hover = !e.touch && "mouseenter" === i.type;
                }), t.fullscreen && Array.from(t.fullscreen.children).filter((e)=>!e.contains(t.container)).forEach((i)=>{
                    this.bind(i, "mouseenter mouseleave", (i)=>{
                        t.controls && (t.controls.hover = !e.touch && "mouseenter" === i.type);
                    });
                }), this.bind(t.controls, "mousedown mouseup touchstart touchend touchcancel", (e)=>{
                    t.controls.pressed = [
                        "mousedown",
                        "touchstart"
                    ].includes(e.type);
                }), this.bind(t.controls, "focusin", ()=>{
                    const { config: i, timers: s } = e;
                    R(t.controls, i.classNames.noTransition, !0), Fe.toggleControls.call(e, !0), setTimeout(()=>{
                        R(t.controls, i.classNames.noTransition, !1);
                    }, 0);
                    const n = this.touch ? 3e3 : 4e3;
                    clearTimeout(s.controls), s.controls = setTimeout(()=>Fe.toggleControls.call(e, !1), n);
                }), this.bind(t.inputs.volume, "wheel", (t)=>{
                    const i = t.webkitDirectionInvertedFromDevice, [s, n] = [
                        t.deltaX,
                        -t.deltaY
                    ].map((e)=>i ? -e : e), a = Math.sign(Math.abs(s) > Math.abs(n) ? s : n);
                    e.increaseVolume(a / 50);
                    const { volume: l } = e.media;
                    (1 === a && l < 1 || -1 === a && l > 0) && t.preventDefault();
                }, "volume", !1);
            }), this.player = t, this.lastKey = null, this.focusTimer = null, this.lastKeyDown = null, this.handleKey = this.handleKey.bind(this), this.toggleMenu = this.toggleMenu.bind(this), this.firstTouch = this.firstTouch.bind(this);
        }
        handleKey(e) {
            const { player: t } = this, { elements: i } = t, { key: s, type: n, altKey: a, ctrlKey: l, metaKey: r, shiftKey: o } = e, c = "keydown" === n, u = c && s === this.lastKey;
            if (a || l || r || o) return;
            if (!s) return;
            if (c) {
                const n = document.activeElement;
                if (S.element(n)) {
                    const { editable: s } = t.config.selectors, { seek: a } = i.inputs;
                    if (n !== a && V(n, s)) return;
                    if (" " === e.key && V(n, 'button, [role^="menuitem"]')) return;
                }
                switch([
                    " ",
                    "ArrowLeft",
                    "ArrowUp",
                    "ArrowRight",
                    "ArrowDown",
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5",
                    "6",
                    "7",
                    "8",
                    "9",
                    "c",
                    "f",
                    "k",
                    "l",
                    "m"
                ].includes(s) && (e.preventDefault(), e.stopPropagation()), s){
                    case "0":
                    case "1":
                    case "2":
                    case "3":
                    case "4":
                    case "5":
                    case "6":
                    case "7":
                    case "8":
                    case "9":
                        u || (h = parseInt(s, 10), t.currentTime = t.duration / 10 * h);
                        break;
                    case " ":
                    case "k":
                        u || ie(t.togglePlay());
                        break;
                    case "ArrowUp":
                        t.increaseVolume(.1);
                        break;
                    case "ArrowDown":
                        t.decreaseVolume(.1);
                        break;
                    case "m":
                        u || (t.muted = !t.muted);
                        break;
                    case "ArrowRight":
                        t.forward();
                        break;
                    case "ArrowLeft":
                        t.rewind();
                        break;
                    case "f":
                        t.fullscreen.toggle();
                        break;
                    case "c":
                        u || t.toggleCaptions();
                        break;
                    case "l":
                        t.loop = !t.loop;
                }
                "Escape" === s && !t.fullscreen.usingNative && t.fullscreen.active && t.fullscreen.toggle(), this.lastKey = s;
            } else this.lastKey = null;
            var h;
        }
        toggleMenu(e) {
            Pe.toggleMenu.call(this.player, e);
        }
    }
    "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self && self;
    var Ue = function(e, t) {
        return e(t = {
            exports: {}
        }, t.exports), t.exports;
    }(function(e, t) {
        e.exports = function() {
            var e = function() {}, t = {}, i = {}, s = {};
            function n(e, t) {
                e = e.push ? e : [
                    e
                ];
                var n, a, l, r = [], o = e.length, c = o;
                for(n = function(e, i) {
                    i.length && r.push(e), --c || t(r);
                }; o--;)a = e[o], (l = i[a]) ? n(a, l) : (s[a] = s[a] || []).push(n);
            }
            function a(e, t) {
                if (e) {
                    var n = s[e];
                    if (i[e] = t, n) for(; n.length;)n[0](e, t), n.splice(0, 1);
                }
            }
            function l(t, i) {
                t.call && (t = {
                    success: t
                }), i.length ? (t.error || e)(i) : (t.success || e)(t);
            }
            function r(t, i, s, n) {
                var a, l, o = document, c = s.async, u = (s.numRetries || 0) + 1, h = s.before || e, d = t.replace(/[\?|#].*$/, ""), m = t.replace(/^(css|img)!/, "");
                n = n || 0, /(^css!|\.css$)/.test(d) ? ((l = o.createElement("link")).rel = "stylesheet", l.href = m, (a = "hideFocus" in l) && l.relList && (a = 0, l.rel = "preload", l.as = "style")) : /(^img!|\.(png|gif|jpg|svg|webp)$)/.test(d) ? (l = o.createElement("img")).src = m : ((l = o.createElement("script")).src = t, l.async = void 0 === c || c), l.onload = l.onerror = l.onbeforeload = function(e) {
                    var o = e.type[0];
                    if (a) try {
                        l.sheet.cssText.length || (o = "e");
                    } catch (e) {
                        18 != e.code && (o = "e");
                    }
                    if ("e" == o) {
                        if ((n += 1) < u) return r(t, i, s, n);
                    } else if ("preload" == l.rel && "style" == l.as) return l.rel = "stylesheet";
                    i(t, o, e.defaultPrevented);
                }, !1 !== h(t, l) && o.head.appendChild(l);
            }
            function o(e, t, i) {
                var s, n, a = (e = e.push ? e : [
                    e
                ]).length, l = a, o = [];
                for(s = function(e, i, s) {
                    if ("e" == i && o.push(e), "b" == i) {
                        if (!s) return;
                        o.push(e);
                    }
                    --a || t(o);
                }, n = 0; n < l; n++)r(e[n], s, i);
            }
            function c(e, i, s) {
                var n, r;
                if (i && i.trim && (n = i), r = (n ? s : i) || {}, n) {
                    if (n in t) throw "LoadJS";
                    t[n] = !0;
                }
                function c(t, i) {
                    o(e, function(e) {
                        l(r, e), t && l({
                            success: t,
                            error: i
                        }, e), a(n, e);
                    }, r);
                }
                if (r.returnPromise) return new Promise(c);
                c();
            }
            return c.ready = function(e, t) {
                return n(e, function(e) {
                    l(t, e);
                }), c;
            }, c.done = function(e) {
                a(e, []);
            }, c.reset = function() {
                t = {}, i = {}, s = {};
            }, c.isDefined = function(e) {
                return e in t;
            }, c;
        }();
    });
    function Be(e) {
        return new Promise((t, i)=>{
            Ue(e, {
                success: t,
                error: i
            });
        });
    }
    function We(e) {
        e && !this.embed.hasPlayed && (this.embed.hasPlayed = !0), this.media.paused === e && (this.media.paused = !e, Z.call(this, this.media, e ? "play" : "pause"));
    }
    const ze = {
        setup () {
            const e = this;
            R(e.elements.wrapper, e.config.classNames.embed, !0), e.options.speed = e.config.speed.options, ue.call(e), S.object(window.Vimeo) ? ze.ready.call(e) : Be(e.config.urls.vimeo.sdk).then(()=>{
                ze.ready.call(e);
            }).catch((t)=>{
                e.debug.warn("Vimeo SDK (player.js) failed to load", t);
            });
        },
        ready () {
            const e = this, t = e.config.vimeo, { premium: i, referrerPolicy: s, ...n } = t;
            let a = e.media.getAttribute("src"), l = "";
            S.empty(a) ? (a = e.media.getAttribute(e.config.attributes.embed.id), l = e.media.getAttribute(e.config.attributes.embed.hash)) : l = function(e) {
                const t = e.match(/^.*(vimeo.com\/|video\/)(\d+)(\?.*&*h=|\/)+([\d,a-f]+)/);
                return t && 5 === t.length ? t[4] : null;
            }(a);
            const r = l ? {
                h: l
            } : {};
            i && Object.assign(n, {
                controls: !1,
                sidedock: !1
            });
            const o = Ne({
                loop: e.config.loop.active,
                autoplay: e.autoplay,
                muted: e.muted,
                gesture: "media",
                playsinline: e.config.playsinline,
                ...r,
                ...n
            }), c = (u = a, S.empty(u) ? null : S.number(Number(u)) ? u : u.match(/^.*(vimeo.com\/|video\/)(\d+).*/) ? RegExp.$2 : u);
            var u;
            const h = $("iframe"), d = me(e.config.urls.vimeo.iframe, c, o);
            if (h.setAttribute("src", d), h.setAttribute("allowfullscreen", ""), h.setAttribute("allow", [
                "autoplay",
                "fullscreen",
                "picture-in-picture",
                "encrypted-media",
                "accelerometer",
                "gyroscope"
            ].join("; ")), S.empty(s) || h.setAttribute("referrerPolicy", s), i || !t.customControls) h.setAttribute("data-poster", e.poster), e.media = q(h, e.media);
            else {
                const t = $("div", {
                    class: e.config.classNames.embedContainer,
                    "data-poster": e.poster
                });
                t.appendChild(h), e.media = q(t, e.media);
            }
            t.customControls || Te(me(e.config.urls.vimeo.api, d)).then((t)=>{
                !S.empty(t) && t.thumbnail_url && Fe.setPoster.call(e, t.thumbnail_url).catch(()=>{});
            }), e.embed = new window.Vimeo.Player(h, {
                autopause: e.config.autopause,
                muted: e.muted
            }), e.media.paused = !0, e.media.currentTime = 0, e.supported.ui && e.embed.disableTextTrack(), e.media.play = ()=>(We.call(e, !0), e.embed.play()), e.media.pause = ()=>(We.call(e, !1), e.embed.pause()), e.media.stop = ()=>{
                e.pause(), e.currentTime = 0;
            };
            let { currentTime: m } = e.media;
            Object.defineProperty(e.media, "currentTime", {
                get: ()=>m,
                set (t) {
                    const { embed: i, media: s, paused: n, volume: a } = e, l = n && !i.hasPlayed;
                    s.seeking = !0, Z.call(e, s, "seeking"), Promise.resolve(l && i.setVolume(0)).then(()=>i.setCurrentTime(t)).then(()=>l && i.pause()).then(()=>l && i.setVolume(a)).catch(()=>{});
                }
            });
            let p = e.config.speed.selected;
            Object.defineProperty(e.media, "playbackRate", {
                get: ()=>p,
                set (t) {
                    e.embed.setPlaybackRate(t).then(()=>{
                        p = t, Z.call(e, e.media, "ratechange");
                    }).catch(()=>{
                        e.options.speed = [
                            1
                        ];
                    });
                }
            });
            let { volume: g } = e.config;
            Object.defineProperty(e.media, "volume", {
                get: ()=>g,
                set (t) {
                    e.embed.setVolume(t).then(()=>{
                        g = t, Z.call(e, e.media, "volumechange");
                    });
                }
            });
            let { muted: f } = e.config;
            Object.defineProperty(e.media, "muted", {
                get: ()=>f,
                set (t) {
                    const i = !!S.boolean(t) && t;
                    e.embed.setMuted(!!i || e.config.muted).then(()=>{
                        f = i, Z.call(e, e.media, "volumechange");
                    });
                }
            });
            let y, { loop: b } = e.config;
            Object.defineProperty(e.media, "loop", {
                get: ()=>b,
                set (t) {
                    const i = S.boolean(t) ? t : e.config.loop.active;
                    e.embed.setLoop(i).then(()=>{
                        b = i;
                    });
                }
            }), e.embed.getVideoUrl().then((t)=>{
                y = t, Pe.setDownloadUrl.call(e);
            }).catch((e)=>{
                this.debug.warn(e);
            }), Object.defineProperty(e.media, "currentSrc", {
                get: ()=>y
            }), Object.defineProperty(e.media, "ended", {
                get: ()=>e.currentTime === e.duration
            }), Promise.all([
                e.embed.getVideoWidth(),
                e.embed.getVideoHeight()
            ]).then((t)=>{
                const [i, s] = t;
                e.embed.ratio = he(i, s), ue.call(this);
            }), e.embed.setAutopause(e.config.autopause).then((t)=>{
                e.config.autopause = t;
            }), e.embed.getVideoTitle().then((t)=>{
                e.config.title = t, Fe.setTitle.call(this);
            }), e.embed.getCurrentTime().then((t)=>{
                m = t, Z.call(e, e.media, "timeupdate");
            }), e.embed.getDuration().then((t)=>{
                e.media.duration = t, Z.call(e, e.media, "durationchange");
            }), e.embed.getTextTracks().then((t)=>{
                e.media.textTracks = t, xe.setup.call(e);
            }), e.embed.on("cuechange", ({ cues: t = [] })=>{
                const i = t.map((e)=>(function(e) {
                        const t = document.createDocumentFragment(), i = document.createElement("div");
                        return t.appendChild(i), i.innerHTML = e, t.firstChild.innerText;
                    })(e.text));
                xe.updateCues.call(e, i);
            }), e.embed.on("loaded", ()=>{
                if (e.embed.getPaused().then((t)=>{
                    We.call(e, !t), t || Z.call(e, e.media, "playing");
                }), S.element(e.embed.element) && e.supported.ui) e.embed.element.setAttribute("tabindex", -1);
            }), e.embed.on("bufferstart", ()=>{
                Z.call(e, e.media, "waiting");
            }), e.embed.on("bufferend", ()=>{
                Z.call(e, e.media, "playing");
            }), e.embed.on("play", ()=>{
                We.call(e, !0), Z.call(e, e.media, "playing");
            }), e.embed.on("pause", ()=>{
                We.call(e, !1);
            }), e.embed.on("timeupdate", (t)=>{
                e.media.seeking = !1, m = t.seconds, Z.call(e, e.media, "timeupdate");
            }), e.embed.on("progress", (t)=>{
                e.media.buffered = t.percent, Z.call(e, e.media, "progress"), 1 === parseInt(t.percent, 10) && Z.call(e, e.media, "canplaythrough"), e.embed.getDuration().then((t)=>{
                    t !== e.media.duration && (e.media.duration = t, Z.call(e, e.media, "durationchange"));
                });
            }), e.embed.on("seeked", ()=>{
                e.media.seeking = !1, Z.call(e, e.media, "seeked");
            }), e.embed.on("ended", ()=>{
                e.media.paused = !0, Z.call(e, e.media, "ended");
            }), e.embed.on("error", (t)=>{
                e.media.error = t, Z.call(e, e.media, "error");
            }), t.customControls && setTimeout(()=>Fe.build.call(e), 0);
        }
    };
    function Ke(e) {
        e && !this.embed.hasPlayed && (this.embed.hasPlayed = !0), this.media.paused === e && (this.media.paused = !e, Z.call(this, this.media, e ? "play" : "pause"));
    }
    function Ye(e) {
        return e.noCookie ? "https://www.youtube-nocookie.com" : "http:" === window.location.protocol ? "http://www.youtube.com" : void 0;
    }
    const Qe = {
        setup () {
            if (R(this.elements.wrapper, this.config.classNames.embed, !0), S.object(window.YT) && S.function(window.YT.Player)) Qe.ready.call(this);
            else {
                const e = window.onYouTubeIframeAPIReady;
                window.onYouTubeIframeAPIReady = ()=>{
                    S.function(e) && e(), Qe.ready.call(this);
                }, Be(this.config.urls.youtube.sdk).catch((e)=>{
                    this.debug.warn("YouTube API failed to load", e);
                });
            }
        },
        getTitle (e) {
            Te(me(this.config.urls.youtube.api, e)).then((e)=>{
                if (S.object(e)) {
                    const { title: t, height: i, width: s } = e;
                    this.config.title = t, Fe.setTitle.call(this), this.embed.ratio = he(s, i);
                }
                ue.call(this);
            }).catch(()=>{
                ue.call(this);
            });
        },
        ready () {
            const e = this, t = e.config.youtube, i = e.media && e.media.getAttribute("id");
            if (!S.empty(i) && i.startsWith("youtube-")) return;
            let s = e.media.getAttribute("src");
            S.empty(s) && (s = e.media.getAttribute(this.config.attributes.embed.id));
            const n = (a = s, S.empty(a) ? null : a.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/) ? RegExp.$2 : a);
            var a;
            const l = $("div", {
                id: `${e.provider}-${Math.floor(1e4 * Math.random())}`,
                "data-poster": t.customControls ? e.poster : void 0
            });
            if (e.media = q(l, e.media), t.customControls) {
                const t = (e)=>`https://i.ytimg.com/vi/${n}/${e}default.jpg`;
                Re(t("maxres"), 121).catch(()=>Re(t("sd"), 121)).catch(()=>Re(t("hq"))).then((t)=>Fe.setPoster.call(e, t.src)).then((t)=>{
                    t.includes("maxres") || (e.elements.poster.style.backgroundSize = "cover");
                }).catch(()=>{});
            }
            e.embed = new window.YT.Player(e.media, {
                videoId: n,
                host: Ye(t),
                playerVars: x({}, {
                    autoplay: e.config.autoplay ? 1 : 0,
                    hl: e.config.hl,
                    controls: e.supported.ui && t.customControls ? 0 : 1,
                    disablekb: 1,
                    playsinline: e.config.playsinline && !e.config.fullscreen.iosNative ? 1 : 0,
                    cc_load_policy: e.captions.active ? 1 : 0,
                    cc_lang_pref: e.config.captions.language,
                    widget_referrer: window ? window.location.href : null
                }, t),
                events: {
                    onError (t) {
                        if (!e.media.error) {
                            const i = t.data, s = {
                                2: "The request contains an invalid parameter value. For example, this error occurs if you specify a video ID that does not have 11 characters, or if the video ID contains invalid characters, such as exclamation points or asterisks.",
                                5: "The requested content cannot be played in an HTML5 player or another error related to the HTML5 player has occurred.",
                                100: "The video requested was not found. This error occurs when a video has been removed (for any reason) or has been marked as private.",
                                101: "The owner of the requested video does not allow it to be played in embedded players.",
                                150: "The owner of the requested video does not allow it to be played in embedded players."
                            }[i] || "An unknown error occurred";
                            e.media.error = {
                                code: i,
                                message: s
                            }, Z.call(e, e.media, "error");
                        }
                    },
                    onPlaybackRateChange (t) {
                        const i = t.target;
                        e.media.playbackRate = i.getPlaybackRate(), Z.call(e, e.media, "ratechange");
                    },
                    onReady (i) {
                        if (S.function(e.media.play)) return;
                        const s = i.target;
                        Qe.getTitle.call(e, n), e.media.play = ()=>{
                            Ke.call(e, !0), s.playVideo();
                        }, e.media.pause = ()=>{
                            Ke.call(e, !1), s.pauseVideo();
                        }, e.media.stop = ()=>{
                            s.stopVideo();
                        }, e.media.duration = s.getDuration(), e.media.paused = !0, e.media.currentTime = 0, Object.defineProperty(e.media, "currentTime", {
                            get: ()=>Number(s.getCurrentTime()),
                            set (t) {
                                e.paused && !e.embed.hasPlayed && e.embed.mute(), e.media.seeking = !0, Z.call(e, e.media, "seeking"), s.seekTo(t);
                            }
                        }), Object.defineProperty(e.media, "playbackRate", {
                            get: ()=>s.getPlaybackRate(),
                            set (e) {
                                s.setPlaybackRate(e);
                            }
                        });
                        let { volume: a } = e.config;
                        Object.defineProperty(e.media, "volume", {
                            get: ()=>a,
                            set (t) {
                                a = t, s.setVolume(100 * a), Z.call(e, e.media, "volumechange");
                            }
                        });
                        let { muted: l } = e.config;
                        Object.defineProperty(e.media, "muted", {
                            get: ()=>l,
                            set (t) {
                                const i = S.boolean(t) ? t : l;
                                l = i, s[i ? "mute" : "unMute"](), s.setVolume(100 * a), Z.call(e, e.media, "volumechange");
                            }
                        }), Object.defineProperty(e.media, "currentSrc", {
                            get: ()=>s.getVideoUrl()
                        }), Object.defineProperty(e.media, "ended", {
                            get: ()=>e.currentTime === e.duration
                        });
                        const r = s.getAvailablePlaybackRates();
                        e.options.speed = r.filter((t)=>e.config.speed.options.includes(t)), e.supported.ui && t.customControls && e.media.setAttribute("tabindex", -1), Z.call(e, e.media, "timeupdate"), Z.call(e, e.media, "durationchange"), clearInterval(e.timers.buffering), e.timers.buffering = setInterval(()=>{
                            e.media.buffered = s.getVideoLoadedFraction(), (null === e.media.lastBuffered || e.media.lastBuffered < e.media.buffered) && Z.call(e, e.media, "progress"), e.media.lastBuffered = e.media.buffered, 1 === e.media.buffered && (clearInterval(e.timers.buffering), Z.call(e, e.media, "canplaythrough"));
                        }, 200), t.customControls && setTimeout(()=>Fe.build.call(e), 50);
                    },
                    onStateChange (i) {
                        const s = i.target;
                        clearInterval(e.timers.playing);
                        switch(e.media.seeking && [
                            1,
                            2
                        ].includes(i.data) && (e.media.seeking = !1, Z.call(e, e.media, "seeked")), i.data){
                            case -1:
                                Z.call(e, e.media, "timeupdate"), e.media.buffered = s.getVideoLoadedFraction(), Z.call(e, e.media, "progress");
                                break;
                            case 0:
                                Ke.call(e, !1), e.media.loop ? (s.stopVideo(), s.playVideo()) : Z.call(e, e.media, "ended");
                                break;
                            case 1:
                                t.customControls && !e.config.autoplay && e.media.paused && !e.embed.hasPlayed ? e.media.pause() : (Ke.call(e, !0), Z.call(e, e.media, "playing"), e.timers.playing = setInterval(()=>{
                                    Z.call(e, e.media, "timeupdate");
                                }, 50), e.media.duration !== s.getDuration() && (e.media.duration = s.getDuration(), Z.call(e, e.media, "durationchange")));
                                break;
                            case 2:
                                e.muted || e.embed.unMute(), Ke.call(e, !1);
                                break;
                            case 3:
                                Z.call(e, e.media, "waiting");
                        }
                        Z.call(e, e.elements.container, "statechange", !1, {
                            code: i.data
                        });
                    }
                }
            });
        }
    }, Xe = {
        setup () {
            this.media ? (R(this.elements.container, this.config.classNames.type.replace("{0}", this.type), !0), R(this.elements.container, this.config.classNames.provider.replace("{0}", this.provider), !0), this.isEmbed && R(this.elements.container, this.config.classNames.type.replace("{0}", "video"), !0), this.isVideo && (this.elements.wrapper = $("div", {
                class: this.config.classNames.video
            }), L(this.media, this.elements.wrapper), this.elements.poster = $("div", {
                class: this.config.classNames.poster
            }), this.elements.wrapper.appendChild(this.elements.poster)), this.isHTML5 ? de.setup.call(this) : this.isYouTube ? Qe.setup.call(this) : this.isVimeo && ze.setup.call(this)) : this.debug.warn("No media element found!");
        }
    };
    class Je {
        constructor(t){
            e(this, "load", ()=>{
                this.enabled && (S.object(window.google) && S.object(window.google.ima) ? this.ready() : Be(this.player.config.urls.googleIMA.sdk).then(()=>{
                    this.ready();
                }).catch(()=>{
                    this.trigger("error", new Error("Google IMA SDK failed to load"));
                }));
            }), e(this, "ready", ()=>{
                var e;
                this.enabled || ((e = this).manager && e.manager.destroy(), e.elements.displayContainer && e.elements.displayContainer.destroy(), e.elements.container.remove()), this.startSafetyTimer(12e3, "ready()"), this.managerPromise.then(()=>{
                    this.clearSafetyTimer("onAdsManagerLoaded()");
                }), this.listeners(), this.setupIMA();
            }), e(this, "setupIMA", ()=>{
                this.elements.container = $("div", {
                    class: this.player.config.classNames.ads
                }), this.player.elements.container.appendChild(this.elements.container), google.ima.settings.setVpaidMode(google.ima.ImaSdkSettings.VpaidMode.ENABLED), google.ima.settings.setLocale(this.player.config.ads.language), google.ima.settings.setDisableCustomPlaybackForIOS10Plus(this.player.config.playsinline), this.elements.displayContainer = new google.ima.AdDisplayContainer(this.elements.container, this.player.media), this.loader = new google.ima.AdsLoader(this.elements.displayContainer), this.loader.addEventListener(google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, (e)=>this.onAdsManagerLoaded(e), !1), this.loader.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, (e)=>this.onAdError(e), !1), this.requestAds();
            }), e(this, "requestAds", ()=>{
                const { container: e } = this.player.elements;
                try {
                    const t = new google.ima.AdsRequest;
                    t.adTagUrl = this.tagUrl, t.linearAdSlotWidth = e.offsetWidth, t.linearAdSlotHeight = e.offsetHeight, t.nonLinearAdSlotWidth = e.offsetWidth, t.nonLinearAdSlotHeight = e.offsetHeight, t.forceNonLinearFullSlot = !1, t.setAdWillPlayMuted(!this.player.muted), this.loader.requestAds(t);
                } catch (e) {
                    this.onAdError(e);
                }
            }), e(this, "pollCountdown", (e = !1)=>{
                if (!e) return clearInterval(this.countdownTimer), void this.elements.container.removeAttribute("data-badge-text");
                this.countdownTimer = setInterval(()=>{
                    const e = Ee(Math.max(this.manager.getRemainingTime(), 0)), t = `${ve.get("advertisement", this.player.config)} - ${e}`;
                    this.elements.container.setAttribute("data-badge-text", t);
                }, 100);
            }), e(this, "onAdsManagerLoaded", (e)=>{
                if (!this.enabled) return;
                const t = new google.ima.AdsRenderingSettings;
                t.restoreCustomPlaybackStateOnAdBreakComplete = !0, t.enablePreloading = !0, this.manager = e.getAdsManager(this.player, t), this.cuePoints = this.manager.getCuePoints(), this.manager.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, (e)=>this.onAdError(e)), Object.keys(google.ima.AdEvent.Type).forEach((e)=>{
                    this.manager.addEventListener(google.ima.AdEvent.Type[e], (e)=>this.onAdEvent(e));
                }), this.trigger("loaded");
            }), e(this, "addCuePoints", ()=>{
                S.empty(this.cuePoints) || this.cuePoints.forEach((e)=>{
                    if (0 !== e && -1 !== e && e < this.player.duration) {
                        const t = this.player.elements.progress;
                        if (S.element(t)) {
                            const i = 100 / this.player.duration * e, s = $("span", {
                                class: this.player.config.classNames.cues
                            });
                            s.style.left = `${i.toString()}%`, t.appendChild(s);
                        }
                    }
                });
            }), e(this, "onAdEvent", (e)=>{
                const { container: t } = this.player.elements, i = e.getAd(), s = e.getAdData();
                switch(((e)=>{
                    Z.call(this.player, this.player.media, `ads${e.replace(/_/g, "").toLowerCase()}`);
                })(e.type), e.type){
                    case google.ima.AdEvent.Type.LOADED:
                        this.trigger("loaded"), this.pollCountdown(!0), i.isLinear() || (i.width = t.offsetWidth, i.height = t.offsetHeight);
                        break;
                    case google.ima.AdEvent.Type.STARTED:
                        this.manager.setVolume(this.player.volume);
                        break;
                    case google.ima.AdEvent.Type.ALL_ADS_COMPLETED:
                        this.player.ended ? this.loadAds() : this.loader.contentComplete();
                        break;
                    case google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED:
                        this.pauseContent();
                        break;
                    case google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED:
                        this.pollCountdown(), this.resumeContent();
                        break;
                    case google.ima.AdEvent.Type.LOG:
                        s.adError && this.player.debug.warn(`Non-fatal ad error: ${s.adError.getMessage()}`);
                }
            }), e(this, "onAdError", (e)=>{
                this.cancel(), this.player.debug.warn("Ads error", e);
            }), e(this, "listeners", ()=>{
                const { container: e } = this.player.elements;
                let t;
                this.player.on("canplay", ()=>{
                    this.addCuePoints();
                }), this.player.on("ended", ()=>{
                    this.loader.contentComplete();
                }), this.player.on("timeupdate", ()=>{
                    t = this.player.currentTime;
                }), this.player.on("seeked", ()=>{
                    const e = this.player.currentTime;
                    S.empty(this.cuePoints) || this.cuePoints.forEach((i, s)=>{
                        t < i && i < e && (this.manager.discardAdBreak(), this.cuePoints.splice(s, 1));
                    });
                }), window.addEventListener("resize", ()=>{
                    this.manager && this.manager.resize(e.offsetWidth, e.offsetHeight, google.ima.ViewMode.NORMAL);
                });
            }), e(this, "play", ()=>{
                const { container: e } = this.player.elements;
                this.managerPromise || this.resumeContent(), this.managerPromise.then(()=>{
                    this.manager.setVolume(this.player.volume), this.elements.displayContainer.initialize();
                    try {
                        this.initialized || (this.manager.init(e.offsetWidth, e.offsetHeight, google.ima.ViewMode.NORMAL), this.manager.start()), this.initialized = !0;
                    } catch (e) {
                        this.onAdError(e);
                    }
                }).catch(()=>{});
            }), e(this, "resumeContent", ()=>{
                this.elements.container.style.zIndex = "", this.playing = !1, ie(this.player.media.play());
            }), e(this, "pauseContent", ()=>{
                this.elements.container.style.zIndex = 3, this.playing = !0, this.player.media.pause();
            }), e(this, "cancel", ()=>{
                this.initialized && this.resumeContent(), this.trigger("error"), this.loadAds();
            }), e(this, "loadAds", ()=>{
                this.managerPromise.then(()=>{
                    this.manager && this.manager.destroy(), this.managerPromise = new Promise((e)=>{
                        this.on("loaded", e), this.player.debug.log(this.manager);
                    }), this.initialized = !1, this.requestAds();
                }).catch(()=>{});
            }), e(this, "trigger", (e, ...t)=>{
                const i = this.events[e];
                S.array(i) && i.forEach((e)=>{
                    S.function(e) && e.apply(this, t);
                });
            }), e(this, "on", (e, t)=>(S.array(this.events[e]) || (this.events[e] = []), this.events[e].push(t), this)), e(this, "startSafetyTimer", (e, t)=>{
                this.player.debug.log(`Safety timer invoked from: ${t}`), this.safetyTimer = setTimeout(()=>{
                    this.cancel(), this.clearSafetyTimer("startSafetyTimer()");
                }, e);
            }), e(this, "clearSafetyTimer", (e)=>{
                S.nullOrUndefined(this.safetyTimer) || (this.player.debug.log(`Safety timer cleared from: ${e}`), clearTimeout(this.safetyTimer), this.safetyTimer = null);
            }), this.player = t, this.config = t.config.ads, this.playing = !1, this.initialized = !1, this.elements = {
                container: null,
                displayContainer: null
            }, this.manager = null, this.loader = null, this.cuePoints = null, this.events = {}, this.safetyTimer = null, this.countdownTimer = null, this.managerPromise = new Promise((e, t)=>{
                this.on("loaded", e), this.on("error", t);
            }), this.load();
        }
        get enabled() {
            const { config: e } = this;
            return this.player.isHTML5 && this.player.isVideo && e.enabled && (!S.empty(e.publisherId) || S.url(e.tagUrl));
        }
        get tagUrl() {
            const { config: e } = this;
            if (S.url(e.tagUrl)) return e.tagUrl;
            return `https://go.aniview.com/api/adserver6/vast/?${Ne({
                AV_PUBLISHERID: "58c25bb0073ef448b1087ad6",
                AV_CHANNELID: "5a0458dc28a06145e4519d21",
                AV_URL: window.location.hostname,
                cb: Date.now(),
                AV_WIDTH: 640,
                AV_HEIGHT: 480,
                AV_CDIM2: e.publisherId
            })}`;
        }
    }
    function Ge(e = 0, t = 0, i = 255) {
        return Math.min(Math.max(e, t), i);
    }
    const Ze = (e)=>{
        const t = [];
        return e.split(/\r\n\r\n|\n\n|\r\r/).forEach((e)=>{
            const i = {};
            e.split(/\r\n|\n|\r/).forEach((e)=>{
                if (S.number(i.startTime)) {
                    if (!S.empty(e.trim()) && S.empty(i.text)) {
                        const t = e.trim().split("#xywh=");
                        [i.text] = t, t[1] && ([i.x, i.y, i.w, i.h] = t[1].split(","));
                    }
                } else {
                    const t = e.match(/([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})( ?--> ?)([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})/);
                    t && (i.startTime = 60 * Number(t[1] || 0) * 60 + 60 * Number(t[2]) + Number(t[3]) + Number(`0.${t[4]}`), i.endTime = 60 * Number(t[6] || 0) * 60 + 60 * Number(t[7]) + Number(t[8]) + Number(`0.${t[9]}`));
                }
            }), i.text && t.push(i);
        }), t;
    }, et = (e, t)=>{
        const i = {};
        return e > t.width / t.height ? (i.width = t.width, i.height = 1 / e * t.width) : (i.height = t.height, i.width = e * t.height), i;
    };
    class tt {
        constructor(t){
            e(this, "load", ()=>{
                this.player.elements.display.seekTooltip && (this.player.elements.display.seekTooltip.hidden = this.enabled), this.enabled && this.getThumbnails().then(()=>{
                    this.enabled && (this.render(), this.determineContainerAutoSizing(), this.listeners(), this.loaded = !0);
                });
            }), e(this, "getThumbnails", ()=>new Promise((e)=>{
                    const { src: t } = this.player.config.previewThumbnails;
                    if (S.empty(t)) throw new Error("Missing previewThumbnails.src config attribute");
                    const i = ()=>{
                        this.thumbnails.sort((e, t)=>e.height - t.height), this.player.debug.log("Preview thumbnails", this.thumbnails), e();
                    };
                    if (S.function(t)) t((e)=>{
                        this.thumbnails = e, i();
                    });
                    else {
                        const e = (S.string(t) ? [
                            t
                        ] : t).map((e)=>this.getThumbnail(e));
                        Promise.all(e).then(i);
                    }
                })), e(this, "getThumbnail", (e)=>new Promise((t)=>{
                    Te(e).then((i)=>{
                        const s = {
                            frames: Ze(i),
                            height: null,
                            urlPrefix: ""
                        };
                        s.frames[0].text.startsWith("/") || s.frames[0].text.startsWith("http://") || s.frames[0].text.startsWith("https://") || (s.urlPrefix = e.substring(0, e.lastIndexOf("/") + 1));
                        const n = new Image;
                        n.onload = ()=>{
                            s.height = n.naturalHeight, s.width = n.naturalWidth, this.thumbnails.push(s), t();
                        }, n.src = s.urlPrefix + s.frames[0].text;
                    });
                })), e(this, "startMove", (e)=>{
                if (this.loaded && S.event(e) && [
                    "touchmove",
                    "mousemove"
                ].includes(e.type) && this.player.media.duration) {
                    if ("touchmove" === e.type) this.seekTime = this.player.media.duration * (this.player.elements.inputs.seek.value / 100);
                    else {
                        var t, i;
                        const s = this.player.elements.progress.getBoundingClientRect(), n = 100 / s.width * (e.pageX - s.left);
                        this.seekTime = this.player.media.duration * (n / 100), this.seekTime < 0 && (this.seekTime = 0), this.seekTime > this.player.media.duration - 1 && (this.seekTime = this.player.media.duration - 1), this.mousePosX = e.pageX, this.elements.thumb.time.innerText = Ee(this.seekTime);
                        const a = null === (t = this.player.config.markers) || void 0 === t || null === (i = t.points) || void 0 === i ? void 0 : i.find(({ time: e })=>e === Math.round(this.seekTime));
                        a && this.elements.thumb.time.insertAdjacentHTML("afterbegin", `${a.label}<br>`);
                    }
                    this.showImageAtCurrentTime();
                }
            }), e(this, "endMove", ()=>{
                this.toggleThumbContainer(!1, !0);
            }), e(this, "startScrubbing", (e)=>{
                (S.nullOrUndefined(e.button) || !1 === e.button || 0 === e.button) && (this.mouseDown = !0, this.player.media.duration && (this.toggleScrubbingContainer(!0), this.toggleThumbContainer(!1, !0), this.showImageAtCurrentTime()));
            }), e(this, "endScrubbing", ()=>{
                this.mouseDown = !1, Math.ceil(this.lastTime) === Math.ceil(this.player.media.currentTime) ? this.toggleScrubbingContainer(!1) : G.call(this.player, this.player.media, "timeupdate", ()=>{
                    this.mouseDown || this.toggleScrubbingContainer(!1);
                });
            }), e(this, "listeners", ()=>{
                this.player.on("play", ()=>{
                    this.toggleThumbContainer(!1, !0);
                }), this.player.on("seeked", ()=>{
                    this.toggleThumbContainer(!1);
                }), this.player.on("timeupdate", ()=>{
                    this.lastTime = this.player.media.currentTime;
                });
            }), e(this, "render", ()=>{
                this.elements.thumb.container = $("div", {
                    class: this.player.config.classNames.previewThumbnails.thumbContainer
                }), this.elements.thumb.imageContainer = $("div", {
                    class: this.player.config.classNames.previewThumbnails.imageContainer
                }), this.elements.thumb.container.appendChild(this.elements.thumb.imageContainer);
                const e = $("div", {
                    class: this.player.config.classNames.previewThumbnails.timeContainer
                });
                this.elements.thumb.time = $("span", {}, "00:00"), e.appendChild(this.elements.thumb.time), this.elements.thumb.imageContainer.appendChild(e), S.element(this.player.elements.progress) && this.player.elements.progress.appendChild(this.elements.thumb.container), this.elements.scrubbing.container = $("div", {
                    class: this.player.config.classNames.previewThumbnails.scrubbingContainer
                }), this.player.elements.wrapper.appendChild(this.elements.scrubbing.container);
            }), e(this, "destroy", ()=>{
                this.elements.thumb.container && this.elements.thumb.container.remove(), this.elements.scrubbing.container && this.elements.scrubbing.container.remove();
            }), e(this, "showImageAtCurrentTime", ()=>{
                this.mouseDown ? this.setScrubbingContainerSize() : this.setThumbContainerSizeAndPos();
                const e = this.thumbnails[0].frames.findIndex((e)=>this.seekTime >= e.startTime && this.seekTime <= e.endTime), t = e >= 0;
                let i = 0;
                this.mouseDown || this.toggleThumbContainer(t), t && (this.thumbnails.forEach((t, s)=>{
                    this.loadedImages.includes(t.frames[e].text) && (i = s);
                }), e !== this.showingThumb && (this.showingThumb = e, this.loadImage(i)));
            }), e(this, "loadImage", (e = 0)=>{
                const t = this.showingThumb, i = this.thumbnails[e], { urlPrefix: s } = i, n = i.frames[t], a = i.frames[t].text, l = s + a;
                if (this.currentImageElement && this.currentImageElement.dataset.filename === a) this.showImage(this.currentImageElement, n, e, t, a, !1), this.currentImageElement.dataset.index = t, this.removeOldImages(this.currentImageElement);
                else {
                    this.loadingImage && this.usingSprites && (this.loadingImage.onload = null);
                    const i = new Image;
                    i.src = l, i.dataset.index = t, i.dataset.filename = a, this.showingThumbFilename = a, this.player.debug.log(`Loading image: ${l}`), i.onload = ()=>this.showImage(i, n, e, t, a, !0), this.loadingImage = i, this.removeOldImages(i);
                }
            }), e(this, "showImage", (e, t, i, s, n, a = !0)=>{
                this.player.debug.log(`Showing thumb: ${n}. num: ${s}. qual: ${i}. newimg: ${a}`), this.setImageSizeAndOffset(e, t), a && (this.currentImageContainer.appendChild(e), this.currentImageElement = e, this.loadedImages.includes(n) || this.loadedImages.push(n)), this.preloadNearby(s, !0).then(this.preloadNearby(s, !1)).then(this.getHigherQuality(i, e, t, n));
            }), e(this, "removeOldImages", (e)=>{
                Array.from(this.currentImageContainer.children).forEach((t)=>{
                    if ("img" !== t.tagName.toLowerCase()) return;
                    const i = this.usingSprites ? 500 : 1e3;
                    if (t.dataset.index !== e.dataset.index && !t.dataset.deleting) {
                        t.dataset.deleting = !0;
                        const { currentImageContainer: e } = this;
                        setTimeout(()=>{
                            e.removeChild(t), this.player.debug.log(`Removing thumb: ${t.dataset.filename}`);
                        }, i);
                    }
                });
            }), e(this, "preloadNearby", (e, t = !0)=>new Promise((i)=>{
                    setTimeout(()=>{
                        const s = this.thumbnails[0].frames[e].text;
                        if (this.showingThumbFilename === s) {
                            let n;
                            n = t ? this.thumbnails[0].frames.slice(e) : this.thumbnails[0].frames.slice(0, e).reverse();
                            let a = !1;
                            n.forEach((e)=>{
                                const t = e.text;
                                if (t !== s && !this.loadedImages.includes(t)) {
                                    a = !0, this.player.debug.log(`Preloading thumb filename: ${t}`);
                                    const { urlPrefix: e } = this.thumbnails[0], s = e + t, n = new Image;
                                    n.src = s, n.onload = ()=>{
                                        this.player.debug.log(`Preloaded thumb filename: ${t}`), this.loadedImages.includes(t) || this.loadedImages.push(t), i();
                                    };
                                }
                            }), a || i();
                        }
                    }, 300);
                })), e(this, "getHigherQuality", (e, t, i, s)=>{
                if (e < this.thumbnails.length - 1) {
                    let n = t.naturalHeight;
                    this.usingSprites && (n = i.h), n < this.thumbContainerHeight && setTimeout(()=>{
                        this.showingThumbFilename === s && (this.player.debug.log(`Showing higher quality thumb for: ${s}`), this.loadImage(e + 1));
                    }, 300);
                }
            }), e(this, "toggleThumbContainer", (e = !1, t = !1)=>{
                const i = this.player.config.classNames.previewThumbnails.thumbContainerShown;
                this.elements.thumb.container.classList.toggle(i, e), !e && t && (this.showingThumb = null, this.showingThumbFilename = null);
            }), e(this, "toggleScrubbingContainer", (e = !1)=>{
                const t = this.player.config.classNames.previewThumbnails.scrubbingContainerShown;
                this.elements.scrubbing.container.classList.toggle(t, e), e || (this.showingThumb = null, this.showingThumbFilename = null);
            }), e(this, "determineContainerAutoSizing", ()=>{
                (this.elements.thumb.imageContainer.clientHeight > 20 || this.elements.thumb.imageContainer.clientWidth > 20) && (this.sizeSpecifiedInCSS = !0);
            }), e(this, "setThumbContainerSizeAndPos", ()=>{
                const { imageContainer: e } = this.elements.thumb;
                if (this.sizeSpecifiedInCSS) {
                    if (e.clientHeight > 20 && e.clientWidth < 20) {
                        const t = Math.floor(e.clientHeight * this.thumbAspectRatio);
                        e.style.width = `${t}px`;
                    } else if (e.clientHeight < 20 && e.clientWidth > 20) {
                        const t = Math.floor(e.clientWidth / this.thumbAspectRatio);
                        e.style.height = `${t}px`;
                    }
                } else {
                    const t = Math.floor(this.thumbContainerHeight * this.thumbAspectRatio);
                    e.style.height = `${this.thumbContainerHeight}px`, e.style.width = `${t}px`;
                }
                this.setThumbContainerPos();
            }), e(this, "setThumbContainerPos", ()=>{
                const e = this.player.elements.progress.getBoundingClientRect(), t = this.player.elements.container.getBoundingClientRect(), { container: i } = this.elements.thumb, s = t.left - e.left + 10, n = t.right - e.left - i.clientWidth - 10, a = this.mousePosX - e.left - i.clientWidth / 2, l = Ge(a, s, n);
                i.style.left = `${l}px`, i.style.setProperty("--preview-arrow-offset", a - l + "px");
            }), e(this, "setScrubbingContainerSize", ()=>{
                const { width: e, height: t } = et(this.thumbAspectRatio, {
                    width: this.player.media.clientWidth,
                    height: this.player.media.clientHeight
                });
                this.elements.scrubbing.container.style.width = `${e}px`, this.elements.scrubbing.container.style.height = `${t}px`;
            }), e(this, "setImageSizeAndOffset", (e, t)=>{
                if (!this.usingSprites) return;
                const i = this.thumbContainerHeight / t.h;
                e.style.height = e.naturalHeight * i + "px", e.style.width = e.naturalWidth * i + "px", e.style.left = `-${t.x * i}px`, e.style.top = `-${t.y * i}px`;
            }), this.player = t, this.thumbnails = [], this.loaded = !1, this.lastMouseMoveTime = Date.now(), this.mouseDown = !1, this.loadedImages = [], this.elements = {
                thumb: {},
                scrubbing: {}
            }, this.load();
        }
        get enabled() {
            return this.player.isHTML5 && this.player.isVideo && this.player.config.previewThumbnails.enabled;
        }
        get currentImageContainer() {
            return this.mouseDown ? this.elements.scrubbing.container : this.elements.thumb.imageContainer;
        }
        get usingSprites() {
            return Object.keys(this.thumbnails[0].frames[0]).includes("w");
        }
        get thumbAspectRatio() {
            return this.usingSprites ? this.thumbnails[0].frames[0].w / this.thumbnails[0].frames[0].h : this.thumbnails[0].width / this.thumbnails[0].height;
        }
        get thumbContainerHeight() {
            if (this.mouseDown) {
                const { height: e } = et(this.thumbAspectRatio, {
                    width: this.player.media.clientWidth,
                    height: this.player.media.clientHeight
                });
                return e;
            }
            return this.sizeSpecifiedInCSS ? this.elements.thumb.imageContainer.clientHeight : Math.floor(this.player.media.clientWidth / this.thumbAspectRatio / 4);
        }
        get currentImageElement() {
            return this.mouseDown ? this.currentScrubbingImageElement : this.currentThumbnailImageElement;
        }
        set currentImageElement(e) {
            this.mouseDown ? this.currentScrubbingImageElement = e : this.currentThumbnailImageElement = e;
        }
    }
    const it = {
        insertElements (e, t) {
            S.string(t) ? _(e, this.media, {
                src: t
            }) : S.array(t) && t.forEach((t)=>{
                _(e, this.media, t);
            });
        },
        change (e) {
            N(e, "sources.length") ? (de.cancelRequests.call(this), this.destroy.call(this, ()=>{
                this.options.quality = [], O(this.media), this.media = null, S.element(this.elements.container) && this.elements.container.removeAttribute("class");
                const { sources: t, type: i } = e, [{ provider: s = _e.html5, src: n }] = t, a = "html5" === s ? i : "div", l = "html5" === s ? {} : {
                    src: n
                };
                Object.assign(this, {
                    provider: s,
                    type: i,
                    supported: K.check(i, s, this.config.playsinline),
                    media: $(a, l)
                }), this.elements.container.appendChild(this.media), S.boolean(e.autoplay) && (this.config.autoplay = e.autoplay), this.isHTML5 && (this.config.crossorigin && this.media.setAttribute("crossorigin", ""), this.config.autoplay && this.media.setAttribute("autoplay", ""), S.empty(e.poster) || (this.poster = e.poster), this.config.loop.active && this.media.setAttribute("loop", ""), this.config.muted && this.media.setAttribute("muted", ""), this.config.playsinline && this.media.setAttribute("playsinline", "")), Fe.addStyleHook.call(this), this.isHTML5 && it.insertElements.call(this, "source", t), this.config.title = e.title, Xe.setup.call(this), this.isHTML5 && Object.keys(e).includes("tracks") && it.insertElements.call(this, "track", e.tracks), (this.isHTML5 || this.isEmbed && !this.supported.ui) && Fe.build.call(this), this.isHTML5 && this.media.load(), S.empty(e.previewThumbnails) || (Object.assign(this.config.previewThumbnails, e.previewThumbnails), this.previewThumbnails && this.previewThumbnails.loaded && (this.previewThumbnails.destroy(), this.previewThumbnails = null), this.config.previewThumbnails.enabled && (this.previewThumbnails = new tt(this))), this.fullscreen.update();
            }, !0)) : this.debug.warn("Invalid source format");
        }
    };
    class st {
        constructor(t, i){
            if (e(this, "play", ()=>S.function(this.media.play) ? (this.ads && this.ads.enabled && this.ads.managerPromise.then(()=>this.ads.play()).catch(()=>ie(this.media.play())), this.media.play()) : null), e(this, "pause", ()=>this.playing && S.function(this.media.pause) ? this.media.pause() : null), e(this, "togglePlay", (e)=>(S.boolean(e) ? e : !this.playing) ? this.play() : this.pause()), e(this, "stop", ()=>{
                this.isHTML5 ? (this.pause(), this.restart()) : S.function(this.media.stop) && this.media.stop();
            }), e(this, "restart", ()=>{
                this.currentTime = 0;
            }), e(this, "rewind", (e)=>{
                this.currentTime -= S.number(e) ? e : this.config.seekTime;
            }), e(this, "forward", (e)=>{
                this.currentTime += S.number(e) ? e : this.config.seekTime;
            }), e(this, "increaseVolume", (e)=>{
                const t = this.media.muted ? 0 : this.volume;
                this.volume = t + (S.number(e) ? e : 0);
            }), e(this, "decreaseVolume", (e)=>{
                this.increaseVolume(-e);
            }), e(this, "airplay", ()=>{
                K.airplay && this.media.webkitShowPlaybackTargetPicker();
            }), e(this, "toggleControls", (e)=>{
                if (this.supported.ui && !this.isAudio) {
                    const t = F(this.elements.container, this.config.classNames.hideControls), i = void 0 === e ? void 0 : !e, s = R(this.elements.container, this.config.classNames.hideControls, i);
                    if (s && S.array(this.config.controls) && this.config.controls.includes("settings") && !S.empty(this.config.settings) && Pe.toggleMenu.call(this, !1), s !== t) {
                        const e = s ? "controlshidden" : "controlsshown";
                        Z.call(this, this.media, e);
                    }
                    return !s;
                }
                return !1;
            }), e(this, "on", (e, t)=>{
                X.call(this, this.elements.container, e, t);
            }), e(this, "once", (e, t)=>{
                G.call(this, this.elements.container, e, t);
            }), e(this, "off", (e, t)=>{
                J(this.elements.container, e, t);
            }), e(this, "destroy", (e, t = !1)=>{
                if (!this.ready) return;
                const i = ()=>{
                    document.body.style.overflow = "", this.embed = null, t ? (Object.keys(this.elements).length && (O(this.elements.buttons.play), O(this.elements.captions), O(this.elements.controls), O(this.elements.wrapper), this.elements.buttons.play = null, this.elements.captions = null, this.elements.controls = null, this.elements.wrapper = null), S.function(e) && e()) : (ee.call(this), de.cancelRequests.call(this), q(this.elements.original, this.elements.container), Z.call(this, this.elements.original, "destroyed", !0), S.function(e) && e.call(this.elements.original), this.ready = !1, setTimeout(()=>{
                        this.elements = null, this.media = null;
                    }, 200));
                };
                this.stop(), clearTimeout(this.timers.loading), clearTimeout(this.timers.controls), clearTimeout(this.timers.resized), this.isHTML5 ? (Fe.toggleNativeControls.call(this, !0), i()) : this.isYouTube ? (clearInterval(this.timers.buffering), clearInterval(this.timers.playing), null !== this.embed && S.function(this.embed.destroy) && this.embed.destroy(), i()) : this.isVimeo && (null !== this.embed && this.embed.unload().then(i), setTimeout(i, 200));
            }), e(this, "supports", (e)=>K.mime.call(this, e)), this.timers = {}, this.ready = !1, this.loading = !1, this.failed = !1, this.touch = K.touch, this.media = t, S.string(this.media) && (this.media = document.querySelectorAll(this.media)), (window.jQuery && this.media instanceof jQuery || S.nodeList(this.media) || S.array(this.media)) && (this.media = this.media[0]), this.config = x({}, Le, st.defaults, i || {}, (()=>{
                try {
                    return JSON.parse(this.media.getAttribute("data-plyr-config"));
                } catch (e) {
                    return {};
                }
            })()), this.elements = {
                container: null,
                fullscreen: null,
                captions: null,
                buttons: {},
                display: {},
                progress: {},
                inputs: {},
                settings: {
                    popup: null,
                    menu: null,
                    panels: {},
                    buttons: {}
                }
            }, this.captions = {
                active: null,
                currentTrack: -1,
                meta: new WeakMap
            }, this.fullscreen = {
                active: !1
            }, this.options = {
                speed: [],
                quality: []
            }, this.debug = new De(this.config.debug), this.debug.log("Config", this.config), this.debug.log("Support", K), S.nullOrUndefined(this.media) || !S.element(this.media)) return void this.debug.error("Setup failed: no suitable element passed");
            if (this.media.plyr) return void this.debug.warn("Target already setup");
            if (!this.config.enabled) return void this.debug.error("Setup failed: disabled by config");
            if (!K.check().api) return void this.debug.error("Setup failed: no support");
            const s = this.media.cloneNode(!0);
            s.autoplay = !1, this.elements.original = s;
            const n = this.media.tagName.toLowerCase();
            let a = null, l = null;
            switch(n){
                case "div":
                    if (a = this.media.querySelector("iframe"), S.element(a)) {
                        if (l = Me(a.getAttribute("src")), this.provider = function(e) {
                            return /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(e) ? _e.youtube : /^https?:\/\/player.vimeo.com\/video\/\d{0,9}(?=\b|\/)/.test(e) ? _e.vimeo : null;
                        }(l.toString()), this.elements.container = this.media, this.media = a, this.elements.container.className = "", l.search.length) {
                            const e = [
                                "1",
                                "true"
                            ];
                            e.includes(l.searchParams.get("autoplay")) && (this.config.autoplay = !0), e.includes(l.searchParams.get("loop")) && (this.config.loop.active = !0), this.isYouTube ? (this.config.playsinline = e.includes(l.searchParams.get("playsinline")), this.config.youtube.hl = l.searchParams.get("hl")) : this.config.playsinline = !0;
                        }
                    } else this.provider = this.media.getAttribute(this.config.attributes.embed.provider), this.media.removeAttribute(this.config.attributes.embed.provider);
                    if (S.empty(this.provider) || !Object.values(_e).includes(this.provider)) return void this.debug.error("Setup failed: Invalid provider");
                    this.type = je;
                    break;
                case "video":
                case "audio":
                    this.type = n, this.provider = _e.html5, this.media.hasAttribute("crossorigin") && (this.config.crossorigin = !0), this.media.hasAttribute("autoplay") && (this.config.autoplay = !0), (this.media.hasAttribute("playsinline") || this.media.hasAttribute("webkit-playsinline")) && (this.config.playsinline = !0), this.media.hasAttribute("muted") && (this.config.muted = !0), this.media.hasAttribute("loop") && (this.config.loop.active = !0);
                    break;
                default:
                    return void this.debug.error("Setup failed: unsupported type");
            }
            this.supported = K.check(this.type, this.provider), this.supported.api ? (this.eventListeners = [], this.listeners = new Ve(this), this.storage = new we(this), this.media.plyr = this, S.element(this.elements.container) || (this.elements.container = $("div"), L(this.media, this.elements.container)), Fe.migrateStyles.call(this), Fe.addStyleHook.call(this), Xe.setup.call(this), this.config.debug && X.call(this, this.elements.container, this.config.events.join(" "), (e)=>{
                this.debug.log(`event: ${e.type}`);
            }), this.fullscreen = new He(this), (this.isHTML5 || this.isEmbed && !this.supported.ui) && Fe.build.call(this), this.listeners.container(), this.listeners.global(), this.config.ads.enabled && (this.ads = new Je(this)), this.isHTML5 && this.config.autoplay && this.once("canplay", ()=>ie(this.play())), this.lastSeekTime = 0, this.config.previewThumbnails.enabled && (this.previewThumbnails = new tt(this))) : this.debug.error("Setup failed: no support");
        }
        get isHTML5() {
            return this.provider === _e.html5;
        }
        get isEmbed() {
            return this.isYouTube || this.isVimeo;
        }
        get isYouTube() {
            return this.provider === _e.youtube;
        }
        get isVimeo() {
            return this.provider === _e.vimeo;
        }
        get isVideo() {
            return this.type === je;
        }
        get isAudio() {
            return this.type === Oe;
        }
        get playing() {
            return Boolean(this.ready && !this.paused && !this.ended);
        }
        get paused() {
            return Boolean(this.media.paused);
        }
        get stopped() {
            return Boolean(this.paused && 0 === this.currentTime);
        }
        get ended() {
            return Boolean(this.media.ended);
        }
        set currentTime(e) {
            if (!this.duration) return;
            const t = S.number(e) && e > 0;
            this.media.currentTime = t ? Math.min(e, this.duration) : 0, this.debug.log(`Seeking to ${this.currentTime} seconds`);
        }
        get currentTime() {
            return Number(this.media.currentTime);
        }
        get buffered() {
            const { buffered: e } = this.media;
            return S.number(e) ? e : e && e.length && this.duration > 0 ? e.end(0) / this.duration : 0;
        }
        get seeking() {
            return Boolean(this.media.seeking);
        }
        get duration() {
            const e = parseFloat(this.config.duration), t = (this.media || {}).duration, i = S.number(t) && t !== 1 / 0 ? t : 0;
            return e || i;
        }
        set volume(e) {
            let t = e;
            S.string(t) && (t = Number(t)), S.number(t) || (t = this.storage.get("volume")), S.number(t) || ({ volume: t } = this.config), t > 1 && (t = 1), t < 0 && (t = 0), this.config.volume = t, this.media.volume = t, !S.empty(e) && this.muted && t > 0 && (this.muted = !1);
        }
        get volume() {
            return Number(this.media.volume);
        }
        set muted(e) {
            let t = e;
            S.boolean(t) || (t = this.storage.get("muted")), S.boolean(t) || (t = this.config.muted), this.config.muted = t, this.media.muted = t;
        }
        get muted() {
            return Boolean(this.media.muted);
        }
        get hasAudio() {
            return !this.isHTML5 || !!this.isAudio || Boolean(this.media.mozHasAudio) || Boolean(this.media.webkitAudioDecodedByteCount) || Boolean(this.media.audioTracks && this.media.audioTracks.length);
        }
        set speed(e) {
            let t = null;
            S.number(e) && (t = e), S.number(t) || (t = this.storage.get("speed")), S.number(t) || (t = this.config.speed.selected);
            const { minimumSpeed: i, maximumSpeed: s } = this;
            t = Ge(t, i, s), this.config.speed.selected = t, setTimeout(()=>{
                this.media && (this.media.playbackRate = t);
            }, 0);
        }
        get speed() {
            return Number(this.media.playbackRate);
        }
        get minimumSpeed() {
            return this.isYouTube ? Math.min(...this.options.speed) : this.isVimeo ? .5 : .0625;
        }
        get maximumSpeed() {
            return this.isYouTube ? Math.max(...this.options.speed) : this.isVimeo ? 2 : 16;
        }
        set quality(e) {
            const t = this.config.quality, i = this.options.quality;
            if (!i.length) return;
            let s = [
                !S.empty(e) && Number(e),
                this.storage.get("quality"),
                t.selected,
                t.default
            ].find(S.number), n = !0;
            if (!i.includes(s)) {
                const e = ne(i, s);
                this.debug.warn(`Unsupported quality option: ${s}, using ${e} instead`), s = e, n = !1;
            }
            t.selected = s, this.media.quality = s, n && this.storage.set({
                quality: s
            });
        }
        get quality() {
            return this.media.quality;
        }
        set loop(e) {
            const t = S.boolean(e) ? e : this.config.loop.active;
            this.config.loop.active = t, this.media.loop = t;
        }
        get loop() {
            return Boolean(this.media.loop);
        }
        set source(e) {
            it.change.call(this, e);
        }
        get source() {
            return this.media.currentSrc;
        }
        get download() {
            const { download: e } = this.config.urls;
            return S.url(e) ? e : this.source;
        }
        set download(e) {
            S.url(e) && (this.config.urls.download = e, Pe.setDownloadUrl.call(this));
        }
        set poster(e) {
            this.isVideo ? Fe.setPoster.call(this, e, !1).catch(()=>{}) : this.debug.warn("Poster can only be set for video");
        }
        get poster() {
            return this.isVideo ? this.media.getAttribute("poster") || this.media.getAttribute("data-poster") : null;
        }
        get ratio() {
            if (!this.isVideo) return null;
            const e = oe(ce.call(this));
            return S.array(e) ? e.join(":") : e;
        }
        set ratio(e) {
            this.isVideo ? S.string(e) && re(e) ? (this.config.ratio = oe(e), ue.call(this)) : this.debug.error(`Invalid aspect ratio specified (${e})`) : this.debug.warn("Aspect ratio can only be set for video");
        }
        set autoplay(e) {
            this.config.autoplay = S.boolean(e) ? e : this.config.autoplay;
        }
        get autoplay() {
            return Boolean(this.config.autoplay);
        }
        toggleCaptions(e) {
            xe.toggle.call(this, e, !1);
        }
        set currentTrack(e) {
            xe.set.call(this, e, !1), xe.setup.call(this);
        }
        get currentTrack() {
            const { toggled: e, currentTrack: t } = this.captions;
            return e ? t : -1;
        }
        set language(e) {
            xe.setLanguage.call(this, e, !1);
        }
        get language() {
            return (xe.getCurrentTrack.call(this) || {}).language;
        }
        set pip(e) {
            if (!K.pip) return;
            const t = S.boolean(e) ? e : !this.pip;
            S.function(this.media.webkitSetPresentationMode) && this.media.webkitSetPresentationMode(t ? Ie : $e), S.function(this.media.requestPictureInPicture) && (!this.pip && t ? this.media.requestPictureInPicture() : this.pip && !t && document.exitPictureInPicture());
        }
        get pip() {
            return K.pip ? S.empty(this.media.webkitPresentationMode) ? this.media === document.pictureInPictureElement : this.media.webkitPresentationMode === Ie : null;
        }
        setPreviewThumbnails(e) {
            this.previewThumbnails && this.previewThumbnails.loaded && (this.previewThumbnails.destroy(), this.previewThumbnails = null), Object.assign(this.config.previewThumbnails, e), this.config.previewThumbnails.enabled && (this.previewThumbnails = new tt(this));
        }
        static supported(e, t) {
            return K.check(e, t);
        }
        static loadSprite(e, t) {
            return ke(e, t);
        }
        static setup(e, t = {}) {
            let i = null;
            return S.string(e) ? i = Array.from(document.querySelectorAll(e)) : S.nodeList(e) ? i = Array.from(e) : S.array(e) && (i = e.filter(S.element)), S.empty(i) ? null : i.map((e)=>new st(e, t));
        }
    }
    var nt;
    return st.defaults = (nt = Le, JSON.parse(JSON.stringify(nt))), st;
});


const $0890d11936b843d8$var$videos = document.querySelectorAll("[data-plyr]");
const $0890d11936b843d8$var$plyrs = [];
$0890d11936b843d8$var$videos.forEach((video)=>{
    const player = new (0, (/*@__PURE__*/$parcel$interopDefault($d850daeb1ad1950b$exports)))(video, {
        quality: {
            forced: true,
            default: 1080,
            options: [
                1080,
                720,
                480,
                360
            ]
        },
        captions: {
            active: false
        }
    });
    console.log(player);
    $0890d11936b843d8$var$plyrs.push(player);
});
const $0890d11936b843d8$export$b5a871295b086ce9 = ()=>{
    $0890d11936b843d8$var$plyrs.forEach((player)=>{
        player.pause();
    });
};




window.uploadFile = function uploadFile1() {
    if (document.querySelector("[data-upload-file-animation]")) {
        const uploadFileBlocksArr = document.querySelectorAll("[data-upload-file-animation]");
        uploadFileBlocksArr.forEach((fileUpload)=>{
            fileUpload.addEventListener("dragover", function() {
                this.classList.add("drag");
                this.classList.remove("drop", "done");
            });
            fileUpload.addEventListener("dragleave", function() {
                this.classList.remove("drag");
            });
            fileUpload.addEventListener("drop", start, false);
            fileUpload.addEventListener("change", start, false);
            function start() {
                this.classList.remove("drag");
                this.classList.add("drop");
                setTimeout(()=>this.classList.add("done"), 500);
            }
        });
    }
};
uploadFile();


window.autosizeTextarea = function autosizeTextarea1() {
    if (document.querySelector("textarea[data-autosize]")) {
        const autosizeTextareaElements = document.querySelectorAll("textarea[data-autosize]");
        autosizeTextareaElements.forEach((textarea)=>{
            const startHeight = textarea.offsetHeight;
            textarea.addEventListener("input", autosize);
            function autosize() {
                const el = this;
                const newHeight = el.scrollHeight;
                if (newHeight > startHeight) el.style.minHeight = `${el.scrollHeight}px`;
                else el.style.minHeight = startHeight;
            }
        });
    }
};
autosizeTextarea();


/**
 * Swiper 11.1.9
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2024 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: July 31, 2024
 */ /**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */ /* eslint-disable no-param-reassign */ function $d0093adbb79ad712$var$isObject(obj) {
    return obj !== null && typeof obj === "object" && "constructor" in obj && obj.constructor === Object;
}
function $d0093adbb79ad712$var$extend(target, src) {
    if (target === void 0) target = {};
    if (src === void 0) src = {};
    Object.keys(src).forEach((key)=>{
        if (typeof target[key] === "undefined") target[key] = src[key];
        else if ($d0093adbb79ad712$var$isObject(src[key]) && $d0093adbb79ad712$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $d0093adbb79ad712$var$extend(target[key], src[key]);
    });
}
const $d0093adbb79ad712$var$ssrDocument = {
    body: {},
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ""
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    },
    createElementNS () {
        return {};
    },
    importNode () {
        return null;
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    }
};
function $d0093adbb79ad712$export$39b482c5e57630a8() {
    const doc = typeof document !== "undefined" ? document : {};
    $d0093adbb79ad712$var$extend(doc, $d0093adbb79ad712$var$ssrDocument);
    return doc;
}
const $d0093adbb79ad712$var$ssrWindow = {
    document: $d0093adbb79ad712$var$ssrDocument,
    navigator: {
        userAgent: ""
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    },
    history: {
        replaceState () {},
        pushState () {},
        go () {},
        back () {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener () {},
    removeEventListener () {},
    getComputedStyle () {
        return {
            getPropertyValue () {
                return "";
            }
        };
    },
    Image () {},
    Date () {},
    screen: {},
    setTimeout () {},
    clearTimeout () {},
    matchMedia () {
        return {};
    },
    requestAnimationFrame (callback) {
        if (typeof setTimeout === "undefined") {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame (id) {
        if (typeof setTimeout === "undefined") return;
        clearTimeout(id);
    }
};
function $d0093adbb79ad712$export$407448d2b89b1813() {
    const win = typeof window !== "undefined" ? window : {};
    $d0093adbb79ad712$var$extend(win, $d0093adbb79ad712$var$ssrWindow);
    return win;
}



function $2a089bf12e68a35c$export$23f2a1d2818174ef(classes) {
    if (classes === void 0) classes = "";
    return classes.trim().split(" ").filter((c)=>!!c.trim());
}
function $2a089bf12e68a35c$export$d141bba7fdc215a3(obj) {
    const object = obj;
    Object.keys(object).forEach((key)=>{
        try {
            object[key] = null;
        } catch (e) {
        // no getter for object
        }
        try {
            delete object[key];
        } catch (e) {
        // something got wrong
        }
    });
}
function $2a089bf12e68a35c$export$7ccc53e8f1e7dfc5(callback, delay) {
    if (delay === void 0) delay = 0;
    return setTimeout(callback, delay);
}
function $2a089bf12e68a35c$export$4368d992c4eafac0() {
    return Date.now();
}
function $2a089bf12e68a35c$var$getComputedStyle(el) {
    const window1 = (0, $d0093adbb79ad712$export$407448d2b89b1813)();
    let style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $2a089bf12e68a35c$export$35e795649ee09318(el, axis) {
    if (axis === void 0) axis = "x";
    const window1 = (0, $d0093adbb79ad712$export$407448d2b89b1813)();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = $2a089bf12e68a35c$var$getComputedStyle(el);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(",").length > 6) curTransform = curTransform.split(", ").map((a)=>a.replace(",", ".")).join(", ");
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === "none" ? "" : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
        matrix = transformMatrix.toString().split(",");
    }
    if (axis === "x") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === "y") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $2a089bf12e68a35c$export$882b5998b3b9117c(o) {
    return typeof o === "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object";
}
function $2a089bf12e68a35c$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== "undefined" && typeof window.HTMLElement !== "undefined") return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $2a089bf12e68a35c$export$efccba1c4a2ef57b() {
    const to = Object(arguments.length <= 0 ? undefined : arguments[0]);
    const noExtend = [
        "__proto__",
        "constructor",
        "prototype"
    ];
    for(let i = 1; i < arguments.length; i += 1){
        const nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];
        if (nextSource !== undefined && nextSource !== null && !$2a089bf12e68a35c$var$isNode(nextSource)) {
            const keysArray = Object.keys(Object(nextSource)).filter((key)=>noExtend.indexOf(key) < 0);
            for(let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                const nextKey = keysArray[nextIndex];
                const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($2a089bf12e68a35c$export$882b5998b3b9117c(to[nextKey]) && $2a089bf12e68a35c$export$882b5998b3b9117c(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $2a089bf12e68a35c$export$efccba1c4a2ef57b(to[nextKey], nextSource[nextKey]);
                    } else if (!$2a089bf12e68a35c$export$882b5998b3b9117c(to[nextKey]) && $2a089bf12e68a35c$export$882b5998b3b9117c(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $2a089bf12e68a35c$export$efccba1c4a2ef57b(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function $2a089bf12e68a35c$export$2408f22a0fab9ae5(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $2a089bf12e68a35c$export$625550452a3fa3ec(_ref) {
    let { swiper: swiper, targetPosition: targetPosition, side: side } = _ref;
    const window1 = (0, $d0093adbb79ad712$export$407448d2b89b1813)();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = "none";
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? "next" : "prev";
    const isOutOfBound = (current, target)=>{
        return dir === "next" && current >= target || dir === "prev" && current <= target;
    };
    const animate = ()=>{
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo({
            [side]: currentPosition
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.scrollSnapType = "";
            setTimeout(()=>{
                swiper.wrapperEl.style.overflow = "";
                swiper.wrapperEl.scrollTo({
                    [side]: currentPosition
                });
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}
function $2a089bf12e68a35c$export$39b482c5e57630a8(slideEl) {
    return slideEl.querySelector(".swiper-slide-transform") || slideEl.shadowRoot && slideEl.shadowRoot.querySelector(".swiper-slide-transform") || slideEl;
}
function $2a089bf12e68a35c$export$f1e1789686576879(element, selector) {
    if (selector === void 0) selector = "";
    const children = [
        ...element.children
    ];
    if (element instanceof HTMLSlotElement) children.push(...element.assignedElements());
    if (!selector) return children;
    return children.filter((el)=>el.matches(selector));
}
function $2a089bf12e68a35c$export$90a7f3efeed30595(el, parent) {
    const isChild = parent.contains(el);
    if (!isChild && parent instanceof HTMLSlotElement) {
        const children = [
            ...parent.assignedElements()
        ];
        return children.includes(el);
    }
    return isChild;
}
function $2a089bf12e68a35c$export$3b14a55fb2447963(text) {
    try {
        console.warn(text);
        return;
    } catch (err) {
    // err
    }
}
function $2a089bf12e68a35c$export$db3b6bfb95261072(tag, classes) {
    if (classes === void 0) classes = [];
    const el = document.createElement(tag);
    el.classList.add(...Array.isArray(classes) ? classes : $2a089bf12e68a35c$export$23f2a1d2818174ef(classes));
    return el;
}
function $2a089bf12e68a35c$export$8b22cf2602fb60ce(el) {
    const window1 = (0, $d0093adbb79ad712$export$407448d2b89b1813)();
    const document1 = (0, $d0093adbb79ad712$export$39b482c5e57630a8)();
    const box = el.getBoundingClientRect();
    const body = document1.body;
    const clientTop = el.clientTop || body.clientTop || 0;
    const clientLeft = el.clientLeft || body.clientLeft || 0;
    const scrollTop = el === window1 ? window1.scrollY : el.scrollTop;
    const scrollLeft = el === window1 ? window1.scrollX : el.scrollLeft;
    return {
        top: box.top + scrollTop - clientTop,
        left: box.left + scrollLeft - clientLeft
    };
}
function $2a089bf12e68a35c$export$43caf9889c228507(el, selector) {
    const prevEls = [];
    while(el.previousElementSibling){
        const prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if (prev.matches(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return prevEls;
}
function $2a089bf12e68a35c$export$9e5f44173e64f162(el, selector) {
    const nextEls = [];
    while(el.nextElementSibling){
        const next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if (next.matches(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return nextEls;
}
function $2a089bf12e68a35c$export$ffb5f4729a158638(el, prop) {
    const window1 = (0, $d0093adbb79ad712$export$407448d2b89b1813)();
    return window1.getComputedStyle(el, null).getPropertyValue(prop);
}
function $2a089bf12e68a35c$export$dda1d9f60106f0e9(el) {
    let child = el;
    let i;
    if (child) {
        i = 0;
        // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function $2a089bf12e68a35c$export$407448d2b89b1813(el, selector) {
    const parents = []; // eslint-disable-line
    let parent = el.parentElement; // eslint-disable-line
    while(parent){
        if (selector) {
            if (parent.matches(selector)) parents.push(parent);
        } else parents.push(parent);
        parent = parent.parentElement;
    }
    return parents;
}
function $2a089bf12e68a35c$export$342063e11d6c3cad(el, callback) {
    function fireCallBack(e) {
        if (e.target !== el) return;
        callback.call(el, e);
        el.removeEventListener("transitionend", fireCallBack);
    }
    if (callback) el.addEventListener("transitionend", fireCallBack);
}
function $2a089bf12e68a35c$export$2d1720544b23b823(el, size, includeMargins) {
    const window1 = (0, $d0093adbb79ad712$export$407448d2b89b1813)();
    if (includeMargins) return el[size === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-right" : "margin-top")) + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-left" : "margin-bottom"));
    return el.offsetWidth;
}
function $2a089bf12e68a35c$export$953cecd6e717a553(el) {
    return (Array.isArray(el) ? el : [
        el
    ]).filter((e)=>!!e);
}
function $2a089bf12e68a35c$export$ae1af26003f05816(swiper) {
    return (v)=>{
        if (Math.abs(v) > 0 && swiper.browser && swiper.browser.need3dFix && Math.abs(v) % 90 === 0) return v + 0.001;
        return v;
    };
}


let $7b90f2d36df6fcf3$var$support;
function $7b90f2d36df6fcf3$var$calcSupport() {
    const window1 = (0, $d0093adbb79ad712$export$407448d2b89b1813)();
    const document1 = (0, $d0093adbb79ad712$export$39b482c5e57630a8)();
    return {
        smoothScroll: document1.documentElement && document1.documentElement.style && "scrollBehavior" in document1.documentElement.style,
        touch: !!("ontouchstart" in window1 || window1.DocumentTouch && document1 instanceof window1.DocumentTouch)
    };
}
function $7b90f2d36df6fcf3$var$getSupport() {
    if (!$7b90f2d36df6fcf3$var$support) $7b90f2d36df6fcf3$var$support = $7b90f2d36df6fcf3$var$calcSupport();
    return $7b90f2d36df6fcf3$var$support;
}
let $7b90f2d36df6fcf3$var$deviceCached;
function $7b90f2d36df6fcf3$var$calcDevice(_temp) {
    let { userAgent: userAgent } = _temp === void 0 ? {} : _temp;
    const support = $7b90f2d36df6fcf3$var$getSupport();
    const window1 = (0, $d0093adbb79ad712$export$407448d2b89b1813)();
    const platform = window1.navigator.platform;
    const ua = userAgent || window1.navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const screenWidth = window1.screen.width;
    const screenHeight = window1.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === "Win32";
    let macos = platform === "MacIntel";
    // iPadOs 13 fix
    const iPadScreens = [
        "1024x1366",
        "1366x1024",
        "834x1194",
        "1194x834",
        "834x1112",
        "1112x834",
        "768x1024",
        "1024x768",
        "820x1180",
        "1180x820",
        "810x1080",
        "1080x810"
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            "13_0_0"
        ];
        macos = false;
    }
    // Android
    if (android && !windows) {
        device.os = "android";
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = "ios";
        device.ios = true;
    }
    // Export object
    return device;
}
function $7b90f2d36df6fcf3$var$getDevice(overrides) {
    if (overrides === void 0) overrides = {};
    if (!$7b90f2d36df6fcf3$var$deviceCached) $7b90f2d36df6fcf3$var$deviceCached = $7b90f2d36df6fcf3$var$calcDevice(overrides);
    return $7b90f2d36df6fcf3$var$deviceCached;
}
let $7b90f2d36df6fcf3$var$browser;
function $7b90f2d36df6fcf3$var$calcBrowser() {
    const window1 = (0, $d0093adbb79ad712$export$407448d2b89b1813)();
    const device = $7b90f2d36df6fcf3$var$getDevice();
    let needPerspectiveFix = false;
    function isSafari() {
        const ua = window1.navigator.userAgent.toLowerCase();
        return ua.indexOf("safari") >= 0 && ua.indexOf("chrome") < 0 && ua.indexOf("android") < 0;
    }
    if (isSafari()) {
        const ua = String(window1.navigator.userAgent);
        if (ua.includes("Version/")) {
            const [major, minor] = ua.split("Version/")[1].split(" ")[0].split(".").map((num)=>Number(num));
            needPerspectiveFix = major < 16 || major === 16 && minor < 2;
        }
    }
    const isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window1.navigator.userAgent);
    const isSafariBrowser = isSafari();
    const need3dFix = isSafariBrowser || isWebView && device.ios;
    return {
        isSafari: needPerspectiveFix || isSafariBrowser,
        needPerspectiveFix: needPerspectiveFix,
        need3dFix: need3dFix,
        isWebView: isWebView
    };
}
function $7b90f2d36df6fcf3$var$getBrowser() {
    if (!$7b90f2d36df6fcf3$var$browser) $7b90f2d36df6fcf3$var$browser = $7b90f2d36df6fcf3$var$calcBrowser();
    return $7b90f2d36df6fcf3$var$browser;
}
function $7b90f2d36df6fcf3$var$Resize(_ref) {
    let { swiper: swiper, on: on, emit: emit } = _ref;
    const window1 = (0, $d0093adbb79ad712$export$407448d2b89b1813)();
    let observer = null;
    let animationFrame = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("beforeResize");
        emit("resize");
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries)=>{
            animationFrame = window1.requestAnimationFrame(()=>{
                const { width: width, height: height } = swiper;
                let newWidth = width;
                let newHeight = height;
                entries.forEach((_ref2)=>{
                    let { contentBoxSize: contentBoxSize, contentRect: contentRect, target: target } = _ref2;
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (animationFrame) window1.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("orientationchange");
    };
    on("init", ()=>{
        if (swiper.params.resizeObserver && typeof window1.ResizeObserver !== "undefined") {
            createObserver();
            return;
        }
        window1.addEventListener("resize", resizeHandler);
        window1.addEventListener("orientationchange", orientationChangeHandler);
    });
    on("destroy", ()=>{
        removeObserver();
        window1.removeEventListener("resize", resizeHandler);
        window1.removeEventListener("orientationchange", orientationChangeHandler);
    });
}
function $7b90f2d36df6fcf3$var$Observer(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const observers = [];
    const window1 = (0, $d0093adbb79ad712$export$407448d2b89b1813)();
    const attach = function(target, options) {
        if (options === void 0) options = {};
        const ObserverFunc = window1.MutationObserver || window1.WebkitMutationObserver;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (swiper.__preventObserver__) return;
            if (mutations.length === 1) {
                emit("observerUpdate", mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                emit("observerUpdate", mutations[0]);
            };
            if (window1.requestAnimationFrame) window1.requestAnimationFrame(observerUpdate);
            else window1.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === "undefined" ? true : options.attributes,
            childList: swiper.isElement || (typeof options.childList === "undefined" ? true : options).childList,
            characterData: typeof options.characterData === "undefined" ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = (0, $2a089bf12e68a35c$export$407448d2b89b1813)(swiper.hostEl);
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        }
        // Observe container
        attach(swiper.hostEl, {
            childList: swiper.params.observeSlideChildren
        });
        // Observe wrapper
        attach(swiper.wrapperEl, {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on("init", init);
    on("destroy", destroy);
}
/* eslint-disable no-underscore-dangle */ var $7b90f2d36df6fcf3$var$eventsEmitter = {
    on (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        const method = priority ? "unshift" : "push";
        events.split(" ").forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        function onceHandler() {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        const method = priority ? "unshift" : "push";
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(" ").forEach((event)=>{
            if (typeof handler === "undefined") self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit () {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        if (typeof args[0] === "string" || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(" ");
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};
function $7b90f2d36df6fcf3$var$updateSize() {
    const swiper = this;
    let width;
    let height;
    const el = swiper.el;
    if (typeof swiper.params.width !== "undefined" && swiper.params.width !== null) width = swiper.params.width;
    else width = el.clientWidth;
    if (typeof swiper.params.height !== "undefined" && swiper.params.height !== null) height = swiper.params.height;
    else height = el.clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
    // Subtract paddings
    width = width - parseInt((0, $2a089bf12e68a35c$export$ffb5f4729a158638)(el, "padding-left") || 0, 10) - parseInt((0, $2a089bf12e68a35c$export$ffb5f4729a158638)(el, "padding-right") || 0, 10);
    height = height - parseInt((0, $2a089bf12e68a35c$export$ffb5f4729a158638)(el, "padding-top") || 0, 10) - parseInt((0, $2a089bf12e68a35c$export$ffb5f4729a158638)(el, "padding-bottom") || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}
function $7b90f2d36df6fcf3$var$updateSlides() {
    const swiper = this;
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const { wrapperEl: wrapperEl, slidesEl: slidesEl, size: swiperSize, rtlTranslate: rtl, wrongRTL: wrongRTL } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = (0, $2a089bf12e68a35c$export$f1e1789686576879)(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === "function") offsetBefore = params.slidesOffsetBefore.call(swiper);
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === "function") offsetAfter = params.slidesOffsetAfter.call(swiper);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === "undefined") return;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiperSize;
    else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
    swiper.virtualSize = -spaceBetween;
    // reset margins
    slides.forEach((slideEl)=>{
        if (rtl) slideEl.style.marginLeft = "";
        else slideEl.style.marginRight = "";
        slideEl.style.marginBottom = "";
        slideEl.style.marginTop = "";
    });
    // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $2a089bf12e68a35c$export$2408f22a0fab9ae5)(wrapperEl, "--swiper-centered-offset-before", "");
        (0, $2a089bf12e68a35c$export$2408f22a0fab9ae5)(wrapperEl, "--swiper-centered-offset-after", "");
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slides);
    else if (swiper.grid) swiper.grid.unsetSlides();
    // Calc slides
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === "auto" && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        return typeof params.breakpoints[key].slidesPerView !== "undefined";
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        let slide;
        if (slides[i]) slide = slides[i];
        if (gridEnabled) swiper.grid.updateSlide(i, slide, slides);
        if (slides[i] && (0, $2a089bf12e68a35c$export$ffb5f4729a158638)(slide, "display") === "none") continue; // eslint-disable-line
        if (params.slidesPerView === "auto") {
            if (shouldResetSlideSize) slides[i].style[swiper.getDirectionLabel("width")] = ``;
            const slideStyles = getComputedStyle(slide);
            const currentTransform = slide.style.transform;
            const currentWebKitTransform = slide.style.webkitTransform;
            if (currentTransform) slide.style.transform = "none";
            if (currentWebKitTransform) slide.style.webkitTransform = "none";
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? (0, $2a089bf12e68a35c$export$2d1720544b23b823)(slide, "width", true) : (0, $2a089bf12e68a35c$export$2d1720544b23b823)(slide, "height", true);
            else {
                // eslint-disable-next-line
                const width = getDirectionPropertyValue(slideStyles, "width");
                const paddingLeft = getDirectionPropertyValue(slideStyles, "padding-left");
                const paddingRight = getDirectionPropertyValue(slideStyles, "padding-right");
                const marginLeft = getDirectionPropertyValue(slideStyles, "margin-left");
                const marginRight = getDirectionPropertyValue(slideStyles, "margin-right");
                const boxSizing = slideStyles.getPropertyValue("box-sizing");
                if (boxSizing && boxSizing === "border-box") slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth: clientWidth, offsetWidth: offsetWidth } = slide;
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide.style.transform = currentTransform;
            if (currentWebKitTransform) slide.style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[swiper.getDirectionLabel("width")] = `${slideSize}px`;
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === "slide" || params.effect === "coverflow")) wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
    if (params.setWrapperSize) wrapperEl.style[swiper.getDirectionLabel("width")] = `${swiper.virtualSize + spaceBetween}px`;
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid);
    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (isVirtual && params.loop) {
        const size = slidesSizesGrid[0] + spaceBetween;
        if (params.slidesPerGroup > 1) {
            const groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
            const groupSize = size * params.slidesPerGroup;
            for(let i = 0; i < groups; i += 1)snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
        }
        for(let i = 0; i < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i += 1){
            if (params.slidesPerGroup === 1) snapGrid.push(snapGrid[snapGrid.length - 1] + size);
            slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
            swiper.virtualSize += size;
        }
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? "marginLeft" : swiper.getDirectionLabel("marginRight");
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode || params.loop) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).forEach((slideEl)=>{
            slideEl.style[key] = `${spaceBetween}px`;
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const maxSnap = allSlidesSize - swiperSize;
        snapGrid = snapGrid.map((snap)=>{
            if (snap <= 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const offsetSize = (params.slidesOffsetBefore || 0) + (params.slidesOffsetAfter || 0);
        if (allSlidesSize + offsetSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize - offsetSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $2a089bf12e68a35c$export$2408f22a0fab9ae5)(wrapperEl, "--swiper-centered-offset-before", `${-snapGrid[0]}px`);
        (0, $2a089bf12e68a35c$export$2408f22a0fab9ae5)(wrapperEl, "--swiper-centered-offset-after", `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit("slidesLengthChange");
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit("snapGridLengthChange");
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit("slidesGridLengthChange");
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    swiper.emit("slidesUpdated");
    if (!isVirtual && !params.cssMode && (params.effect === "slide" || params.effect === "fade")) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.el.classList.remove(backFaceHiddenClass);
    }
}
function $7b90f2d36df6fcf3$var$updateAutoHeight(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === "number") swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides[swiper.getSlideIndexByData(index)];
        return swiper.slides[index];
    };
    // Find slides currently in view
    if (swiper.params.slidesPerView !== "auto" && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || []).forEach((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
    // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== "undefined") {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
    // Update Height
    if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = `${newHeight}px`;
}
function $7b90f2d36df6fcf3$var$updateSlidesOffset() {
    const swiper = this;
    const slides = swiper.slides;
    // eslint-disable-next-line
    const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
}
const $7b90f2d36df6fcf3$var$toggleSlideClasses$1 = (slideEl, condition, className)=>{
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $7b90f2d36df6fcf3$var$updateSlidesProgress(translate) {
    if (translate === void 0) translate = this && this.translate || 0;
    const swiper = this;
    const params = swiper.params;
    const { slides: slides, rtlTranslate: rtl, snapGrid: snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === "undefined") swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate;
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    let spaceBetween = params.spaceBetween;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiper.size;
    else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
        }
        $7b90f2d36df6fcf3$var$toggleSlideClasses$1(slide, isVisible, params.slideVisibleClass);
        $7b90f2d36df6fcf3$var$toggleSlideClasses$1(slide, isFullyVisible, params.slideFullyVisibleClass);
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
}
function $7b90f2d36df6fcf3$var$updateProgress(translate) {
    const swiper = this;
    if (typeof translate === "undefined") {
        const multiplier = swiper.rtlTranslate ? -1 : 1;
        // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress: progress, isBeginning: isBeginning, isEnd: isEnd, progressLoop: progressLoop } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        const isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
        const isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
        isBeginning = isBeginningRounded || progress <= 0;
        isEnd = isEndRounded || progress >= 1;
        if (isBeginningRounded) progress = 0;
        if (isEndRounded) progress = 1;
    }
    if (params.loop) {
        const firstSlideIndex = swiper.getSlideIndexByData(0);
        const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
        const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
        const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
        const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
        const translateAbs = Math.abs(translate);
        if (translateAbs >= firstSlideTranslate) progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
        else progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
        if (progressLoop > 1) progressLoop -= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        progressLoop: progressLoop,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit("reachBeginning toEdge");
    if (isEnd && !wasEnd) swiper.emit("reachEnd toEdge");
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit("fromEdge");
    swiper.emit("progress", progress);
}
const $7b90f2d36df6fcf3$var$toggleSlideClasses = (slideEl, condition, className)=>{
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $7b90f2d36df6fcf3$var$updateSlidesClasses() {
    const swiper = this;
    const { slides: slides, params: params, slidesEl: slidesEl, activeIndex: activeIndex } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    const getFilteredSlide = (selector)=>{
        return (0, $2a089bf12e68a35c$export$f1e1789686576879)(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
    };
    let activeSlide;
    let prevSlide;
    let nextSlide;
    if (isVirtual) {
        if (params.loop) {
            let slideIndex = activeIndex - swiper.virtual.slidesBefore;
            if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
            if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
            activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
        } else activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
    } else if (gridEnabled) {
        activeSlide = slides.filter((slideEl)=>slideEl.column === activeIndex)[0];
        nextSlide = slides.filter((slideEl)=>slideEl.column === activeIndex + 1)[0];
        prevSlide = slides.filter((slideEl)=>slideEl.column === activeIndex - 1)[0];
    } else activeSlide = slides[activeIndex];
    if (activeSlide) {
        if (!gridEnabled) {
            // Next Slide
            nextSlide = (0, $2a089bf12e68a35c$export$9e5f44173e64f162)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            if (params.loop && !nextSlide) nextSlide = slides[0];
            // Prev Slide
            prevSlide = (0, $2a089bf12e68a35c$export$43caf9889c228507)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            params.loop;
        }
    }
    slides.forEach((slideEl)=>{
        $7b90f2d36df6fcf3$var$toggleSlideClasses(slideEl, slideEl === activeSlide, params.slideActiveClass);
        $7b90f2d36df6fcf3$var$toggleSlideClasses(slideEl, slideEl === nextSlide, params.slideNextClass);
        $7b90f2d36df6fcf3$var$toggleSlideClasses(slideEl, slideEl === prevSlide, params.slidePrevClass);
    });
    swiper.emitSlidesClasses();
}
const $7b90f2d36df6fcf3$var$processLazyPreloader = (swiper, imageEl)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    const slideSelector = ()=>swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    const slideEl = imageEl.closest(slideSelector());
    if (slideEl) {
        let lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
        if (!lazyEl && swiper.isElement) {
            if (slideEl.shadowRoot) lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
            else // init later
            requestAnimationFrame(()=>{
                if (slideEl.shadowRoot) {
                    lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
                    if (lazyEl) lazyEl.remove();
                }
            });
        }
        if (lazyEl) lazyEl.remove();
    }
};
const $7b90f2d36df6fcf3$var$unlazy = (swiper, index)=>{
    if (!swiper.slides[index]) return;
    const imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
    if (imageEl) imageEl.removeAttribute("loading");
};
const $7b90f2d36df6fcf3$var$preload = (swiper)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    let amount = swiper.params.lazyPreloadPrevNext;
    const len = swiper.slides.length;
    if (!len || !amount || amount < 0) return;
    amount = Math.min(amount, len);
    const slidesPerView = swiper.params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
    const activeIndex = swiper.activeIndex;
    if (swiper.params.grid && swiper.params.grid.rows > 1) {
        const activeColumn = activeIndex;
        const preloadColumns = [
            activeColumn - amount
        ];
        preloadColumns.push(...Array.from({
            length: amount
        }).map((_, i)=>{
            return activeColumn + slidesPerView + i;
        }));
        swiper.slides.forEach((slideEl, i)=>{
            if (preloadColumns.includes(slideEl.column)) $7b90f2d36df6fcf3$var$unlazy(swiper, i);
        });
        return;
    }
    const slideIndexLastInView = activeIndex + slidesPerView - 1;
    if (swiper.params.rewind || swiper.params.loop) for(let i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1){
        const realIndex = (i % len + len) % len;
        if (realIndex < activeIndex || realIndex > slideIndexLastInView) $7b90f2d36df6fcf3$var$unlazy(swiper, realIndex);
    }
    else {
        for(let i = Math.max(activeIndex - amount, 0); i <= Math.min(slideIndexLastInView + amount, len - 1); i += 1)if (i !== activeIndex && (i > slideIndexLastInView || i < activeIndex)) $7b90f2d36df6fcf3$var$unlazy(swiper, i);
    }
};
function $7b90f2d36df6fcf3$var$getActiveIndexByTranslate(swiper) {
    const { slidesGrid: slidesGrid, params: params } = swiper;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    let activeIndex;
    for(let i = 0; i < slidesGrid.length; i += 1){
        if (typeof slidesGrid[i + 1] !== "undefined") {
            if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
            else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
        } else if (translate >= slidesGrid[i]) activeIndex = i;
    }
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === "undefined") activeIndex = 0;
    }
    return activeIndex;
}
function $7b90f2d36df6fcf3$var$updateActiveIndex(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { snapGrid: snapGrid, params: params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    const getVirtualRealIndex = (aIndex)=>{
        let realIndex = aIndex - swiper.virtual.slidesBefore;
        if (realIndex < 0) realIndex = swiper.virtual.slides.length + realIndex;
        if (realIndex >= swiper.virtual.slides.length) realIndex -= swiper.virtual.slides.length;
        return realIndex;
    };
    if (typeof activeIndex === "undefined") activeIndex = $7b90f2d36df6fcf3$var$getActiveIndexByTranslate(swiper);
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex && !swiper.params.loop) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit("snapIndexChange");
        }
        return;
    }
    if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
        swiper.realIndex = getVirtualRealIndex(activeIndex);
        return;
    }
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    // Get real index
    let realIndex;
    if (swiper.virtual && params.virtual.enabled && params.loop) realIndex = getVirtualRealIndex(activeIndex);
    else if (gridEnabled) {
        const firstSlideInColumn = swiper.slides.filter((slideEl)=>slideEl.column === activeIndex)[0];
        let activeSlideIndex = parseInt(firstSlideInColumn.getAttribute("data-swiper-slide-index"), 10);
        if (Number.isNaN(activeSlideIndex)) activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
        realIndex = Math.floor(activeSlideIndex / params.grid.rows);
    } else if (swiper.slides[activeIndex]) {
        const slideIndex = swiper.slides[activeIndex].getAttribute("data-swiper-slide-index");
        if (slideIndex) realIndex = parseInt(slideIndex, 10);
        else realIndex = activeIndex;
    } else realIndex = activeIndex;
    Object.assign(swiper, {
        previousSnapIndex: previousSnapIndex,
        snapIndex: snapIndex,
        previousRealIndex: previousRealIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    if (swiper.initialized) $7b90f2d36df6fcf3$var$preload(swiper);
    swiper.emit("activeIndexChange");
    swiper.emit("snapIndexChange");
    if (swiper.initialized || swiper.params.runCallbacksOnInit) {
        if (previousRealIndex !== realIndex) swiper.emit("realIndexChange");
        swiper.emit("slideChange");
    }
}
function $7b90f2d36df6fcf3$var$updateClickedSlide(el, path) {
    const swiper = this;
    const params = swiper.params;
    let slide = el.closest(`.${params.slideClass}, swiper-slide`);
    if (!slide && swiper.isElement && path && path.length > 1 && path.includes(el)) [
        ...path.slice(path.indexOf(el) + 1, path.length)
    ].forEach((pathEl)=>{
        if (!slide && pathEl.matches && pathEl.matches(`.${params.slideClass}, swiper-slide`)) slide = pathEl;
    });
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt(slide.getAttribute("data-swiper-slide-index"), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}
var $7b90f2d36df6fcf3$var$update = {
    updateSize: $7b90f2d36df6fcf3$var$updateSize,
    updateSlides: $7b90f2d36df6fcf3$var$updateSlides,
    updateAutoHeight: $7b90f2d36df6fcf3$var$updateAutoHeight,
    updateSlidesOffset: $7b90f2d36df6fcf3$var$updateSlidesOffset,
    updateSlidesProgress: $7b90f2d36df6fcf3$var$updateSlidesProgress,
    updateProgress: $7b90f2d36df6fcf3$var$updateProgress,
    updateSlidesClasses: $7b90f2d36df6fcf3$var$updateSlidesClasses,
    updateActiveIndex: $7b90f2d36df6fcf3$var$updateActiveIndex,
    updateClickedSlide: $7b90f2d36df6fcf3$var$updateClickedSlide
};
function $7b90f2d36df6fcf3$var$getSwiperTranslate(axis) {
    if (axis === void 0) axis = this.isHorizontal() ? "x" : "y";
    const swiper = this;
    const { params: params, rtlTranslate: rtl, translate: translate, wrapperEl: wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, $2a089bf12e68a35c$export$35e795649ee09318)(wrapperEl, axis);
    currentTranslate += swiper.cssOverflowAdjustment();
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}
function $7b90f2d36df6fcf3$var$setTranslate(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params: params, wrapperEl: wrapperEl, progress: progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? "scrollLeft" : "scrollTop"] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) {
        if (swiper.isHorizontal()) x -= swiper.cssOverflowAdjustment();
        else y -= swiper.cssOverflowAdjustment();
        wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z}px)`;
    }
    // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit("setTranslate", swiper.translate, byController);
}
function $7b90f2d36df6fcf3$var$minTranslate() {
    return -this.snapGrid[0];
}
function $7b90f2d36df6fcf3$var$maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
}
function $7b90f2d36df6fcf3$var$translateTo(translate, speed, runCallbacks, translateBounds, internal) {
    if (translate === void 0) translate = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (translateBounds === void 0) translateBounds = true;
    const swiper = this;
    const { params: params, wrapperEl: wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate;
    // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $2a089bf12e68a35c$export$625550452a3fa3ec)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? "left" : "top"]: -newTranslate,
                behavior: "smooth"
            });
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionEnd");
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionStart");
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.wrapperEl.removeEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                swiper.animating = false;
                if (runCallbacks) swiper.emit("transitionEnd");
            };
            swiper.wrapperEl.addEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}
var $7b90f2d36df6fcf3$var$translate = {
    getTranslate: $7b90f2d36df6fcf3$var$getSwiperTranslate,
    setTranslate: $7b90f2d36df6fcf3$var$setTranslate,
    minTranslate: $7b90f2d36df6fcf3$var$minTranslate,
    maxTranslate: $7b90f2d36df6fcf3$var$maxTranslate,
    translateTo: $7b90f2d36df6fcf3$var$translateTo
};
function $7b90f2d36df6fcf3$var$setTransition(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) {
        swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
        swiper.wrapperEl.style.transitionDelay = duration === 0 ? `0ms` : "";
    }
    swiper.emit("setTransition", duration, byController);
}
function $7b90f2d36df6fcf3$var$transitionEmit(_ref) {
    let { swiper: swiper, runCallbacks: runCallbacks, direction: direction, step: step } = _ref;
    const { activeIndex: activeIndex, previousIndex: previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = "next";
        else if (activeIndex < previousIndex) dir = "prev";
        else dir = "reset";
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === "reset") {
            swiper.emit(`slideResetTransition${step}`);
            return;
        }
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === "next") swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}
function $7b90f2d36df6fcf3$var$transitionStart(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    $7b90f2d36df6fcf3$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "Start"
    });
}
function $7b90f2d36df6fcf3$var$transitionEnd(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    $7b90f2d36df6fcf3$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "End"
    });
}
var $7b90f2d36df6fcf3$var$transition = {
    setTransition: $7b90f2d36df6fcf3$var$setTransition,
    transitionStart: $7b90f2d36df6fcf3$var$transitionStart,
    transitionEnd: $7b90f2d36df6fcf3$var$transitionEnd
};
function $7b90f2d36df6fcf3$var$slideTo(index, speed, runCallbacks, internal, initial) {
    if (index === void 0) index = 0;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === "string") index = parseInt(index, 10);
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, previousIndex: previousIndex, activeIndex: activeIndex, rtlTranslate: rtl, wrapperEl: wrapperEl, enabled: enabled } = swiper;
    if (!enabled && !internal && !initial || swiper.destroyed || swiper.animating && params.preventInteractionOnTransition) return false;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate = -snapGrid[snapIndex];
    // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== "undefined") {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit("beforeSlideChangeStart");
    // Update progress
    swiper.updateProgress(translate);
    let direction;
    if (slideIndex > activeIndex) direction = "next";
    else if (slideIndex < activeIndex) direction = "prev";
    else direction = "reset";
    // Update Index
    if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
        swiper.updateActiveIndex(slideIndex);
        // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== "slide") swiper.setTranslate(translate);
        if (direction !== "reset") {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = "none";
                swiper._immediateVirtual = true;
            }
            if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
                swiper._cssModeVirtualInitialSet = true;
                requestAnimationFrame(()=>{
                    wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
                });
            } else wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = "";
                swiper._immediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $2a089bf12e68a35c$export$625550452a3fa3ec)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? "left" : "top"]: t,
                behavior: "smooth"
            });
        }
        return true;
    }
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit("beforeTransitionStart", speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.wrapperEl.removeEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.wrapperEl.addEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}
function $7b90f2d36df6fcf3$var$slideToLoop(index, speed, runCallbacks, internal) {
    if (index === void 0) index = 0;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === "string") {
        const indexAsNumber = parseInt(index, 10);
        index = indexAsNumber;
    }
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    const gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    let newIndex = index;
    if (swiper.params.loop) {
        if (swiper.virtual && swiper.params.virtual.enabled) // eslint-disable-next-line
        newIndex = newIndex + swiper.virtual.slidesBefore;
        else {
            let targetSlideIndex;
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                targetSlideIndex = swiper.slides.filter((slideEl)=>slideEl.getAttribute("data-swiper-slide-index") * 1 === slideIndex)[0].column;
            } else targetSlideIndex = swiper.getSlideIndexByData(newIndex);
            const cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
            const { centeredSlides: centeredSlides } = swiper.params;
            let slidesPerView = swiper.params.slidesPerView;
            if (slidesPerView === "auto") slidesPerView = swiper.slidesPerViewDynamic();
            else {
                slidesPerView = Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
                if (centeredSlides && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
            }
            let needLoopFix = cols - targetSlideIndex < slidesPerView;
            if (centeredSlides) needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
            if (internal && centeredSlides && swiper.params.slidesPerView !== "auto" && !gridEnabled) needLoopFix = false;
            if (needLoopFix) {
                const direction = centeredSlides ? targetSlideIndex < swiper.activeIndex ? "prev" : "next" : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? "next" : "prev";
                swiper.loopFix({
                    direction: direction,
                    slideTo: true,
                    activeSlideIndex: direction === "next" ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
                    slideRealIndex: direction === "next" ? swiper.realIndex : undefined
                });
            }
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                newIndex = swiper.slides.filter((slideEl)=>slideEl.getAttribute("data-swiper-slide-index") * 1 === slideIndex)[0].column;
            } else newIndex = swiper.getSlideIndexByData(newIndex);
        }
    }
    requestAnimationFrame(()=>{
        swiper.slideTo(newIndex, speed, runCallbacks, internal);
    });
    return swiper;
}
/* eslint no-unused-vars: "off" */ function $7b90f2d36df6fcf3$var$slideNext(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { enabled: enabled, params: params, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic("current", true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: "next"
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
        if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
            requestAnimationFrame(()=>{
                swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
            });
            return true;
        }
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $7b90f2d36df6fcf3$var$slidePrev(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, rtlTranslate: rtlTranslate, enabled: enabled, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: "prev"
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === "undefined" && params.cssMode) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== "undefined") prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== "undefined") {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic("previous", true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
        requestAnimationFrame(()=>{
            swiper.slideTo(prevIndex, speed, runCallbacks, internal);
        });
        return true;
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $7b90f2d36df6fcf3$var$slideReset(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $7b90f2d36df6fcf3$var$slideToClosest(speed, runCallbacks, internal, threshold) {
    if (runCallbacks === void 0) runCallbacks = true;
    if (threshold === void 0) threshold = 0.5;
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}
function $7b90f2d36df6fcf3$var$slideToClickedSlide() {
    const swiper = this;
    if (swiper.destroyed) return;
    const { params: params, slidesEl: slidesEl } = swiper;
    const slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.clickedIndex;
    let realIndex;
    const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt(swiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = swiper.getSlideIndex((0, $2a089bf12e68a35c$export$f1e1789686576879)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
                (0, $2a089bf12e68a35c$export$7ccc53e8f1e7dfc5)(()=>{
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = swiper.getSlideIndex((0, $2a089bf12e68a35c$export$f1e1789686576879)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
            (0, $2a089bf12e68a35c$export$7ccc53e8f1e7dfc5)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}
var $7b90f2d36df6fcf3$var$slide = {
    slideTo: $7b90f2d36df6fcf3$var$slideTo,
    slideToLoop: $7b90f2d36df6fcf3$var$slideToLoop,
    slideNext: $7b90f2d36df6fcf3$var$slideNext,
    slidePrev: $7b90f2d36df6fcf3$var$slidePrev,
    slideReset: $7b90f2d36df6fcf3$var$slideReset,
    slideToClosest: $7b90f2d36df6fcf3$var$slideToClosest,
    slideToClickedSlide: $7b90f2d36df6fcf3$var$slideToClickedSlide
};
function $7b90f2d36df6fcf3$var$loopCreate(slideRealIndex) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    const initSlides = ()=>{
        const slides = (0, $2a089bf12e68a35c$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        slides.forEach((el, index)=>{
            el.setAttribute("data-swiper-slide-index", index);
        });
    };
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    const slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
    const shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
    const shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
    const addBlankSlides = (amountOfSlides)=>{
        for(let i = 0; i < amountOfSlides; i += 1){
            const slideEl = swiper.isElement ? (0, $2a089bf12e68a35c$export$db3b6bfb95261072)("swiper-slide", [
                params.slideBlankClass
            ]) : (0, $2a089bf12e68a35c$export$db3b6bfb95261072)("div", [
                params.slideClass,
                params.slideBlankClass
            ]);
            swiper.slidesEl.append(slideEl);
        }
    };
    if (shouldFillGroup) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $2a089bf12e68a35c$export$3b14a55fb2447963)("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
        initSlides();
    } else if (shouldFillGrid) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = params.grid.rows - swiper.slides.length % params.grid.rows;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $2a089bf12e68a35c$export$3b14a55fb2447963)("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
        initSlides();
    } else initSlides();
    swiper.loopFix({
        slideRealIndex: slideRealIndex,
        direction: params.centeredSlides ? undefined : "next"
    });
}
function $7b90f2d36df6fcf3$var$loopFix(_temp) {
    let { slideRealIndex: slideRealIndex, slideTo: slideTo = true, direction: direction, setTranslate: setTranslate, activeSlideIndex: activeSlideIndex, byController: byController, byMousewheel: byMousewheel } = _temp === void 0 ? {} : _temp;
    const swiper = this;
    if (!swiper.params.loop) return;
    swiper.emit("beforeLoopFix");
    const { slides: slides, allowSlidePrev: allowSlidePrev, allowSlideNext: allowSlideNext, slidesEl: slidesEl, params: params } = swiper;
    const { centeredSlides: centeredSlides } = params;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    if (swiper.virtual && params.virtual.enabled) {
        if (slideTo) {
            if (!params.centeredSlides && swiper.snapIndex === 0) swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
            else if (params.centeredSlides && swiper.snapIndex < params.slidesPerView) swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
            else if (swiper.snapIndex === swiper.snapGrid.length - 1) swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
        }
        swiper.allowSlidePrev = allowSlidePrev;
        swiper.allowSlideNext = allowSlideNext;
        swiper.emit("loopFix");
        return;
    }
    let slidesPerView = params.slidesPerView;
    if (slidesPerView === "auto") slidesPerView = swiper.slidesPerViewDynamic();
    else {
        slidesPerView = Math.ceil(parseFloat(params.slidesPerView, 10));
        if (centeredSlides && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
    }
    const slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
    let loopedSlides = slidesPerGroup;
    if (loopedSlides % slidesPerGroup !== 0) loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
    loopedSlides += params.loopAdditionalSlides;
    swiper.loopedSlides = loopedSlides;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (slides.length < slidesPerView + loopedSlides) (0, $2a089bf12e68a35c$export$3b14a55fb2447963)("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters");
    else if (gridEnabled && params.grid.fill === "row") (0, $2a089bf12e68a35c$export$3b14a55fb2447963)("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
    const prependSlidesIndexes = [];
    const appendSlidesIndexes = [];
    let activeIndex = swiper.activeIndex;
    if (typeof activeSlideIndex === "undefined") activeSlideIndex = swiper.getSlideIndex(slides.filter((el)=>el.classList.contains(params.slideActiveClass))[0]);
    else activeIndex = activeSlideIndex;
    const isNext = direction === "next" || !direction;
    const isPrev = direction === "prev" || !direction;
    let slidesPrepended = 0;
    let slidesAppended = 0;
    const cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
    const activeColIndex = gridEnabled ? slides[activeSlideIndex].column : activeSlideIndex;
    const activeColIndexWithShift = activeColIndex + (centeredSlides && typeof setTranslate === "undefined" ? -slidesPerView / 2 + 0.5 : 0);
    // prepend last slides before start
    if (activeColIndexWithShift < loopedSlides) {
        slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
        for(let i = 0; i < loopedSlides - activeColIndexWithShift; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) {
                const colIndexToPrepend = cols - index - 1;
                for(let i = slides.length - 1; i >= 0; i -= 1)if (slides[i].column === colIndexToPrepend) prependSlidesIndexes.push(i);
            // slides.forEach((slide, slideIndex) => {
            //   if (slide.column === colIndexToPrepend) prependSlidesIndexes.push(slideIndex);
            // });
            } else prependSlidesIndexes.push(cols - index - 1);
        }
    } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
        slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);
        for(let i = 0; i < slidesAppended; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) slides.forEach((slide, slideIndex)=>{
                if (slide.column === index) appendSlidesIndexes.push(slideIndex);
            });
            else appendSlidesIndexes.push(index);
        }
    }
    swiper.__preventObserver__ = true;
    requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
    if (isPrev) prependSlidesIndexes.forEach((index)=>{
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.prepend(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    if (isNext) appendSlidesIndexes.forEach((index)=>{
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.append(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    swiper.recalcSlides();
    if (params.slidesPerView === "auto") swiper.updateSlides();
    else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) swiper.slides.forEach((slide, slideIndex)=>{
        swiper.grid.updateSlide(slideIndex, slide, swiper.slides);
    });
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (slideTo) {
        if (prependSlidesIndexes.length > 0 && isPrev) {
            if (typeof slideRealIndex === "undefined") {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex + Math.ceil(slidesPrepended), 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else if (setTranslate) {
                const shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
                swiper.touchEventsData.currentTranslate = swiper.translate;
            }
        } else if (appendSlidesIndexes.length > 0 && isNext) {
            if (typeof slideRealIndex === "undefined") {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else {
                const shift = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex - shift, 0, false, true);
            }
        }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.controller && swiper.controller.control && !byController) {
        const loopParams = {
            slideRealIndex: slideRealIndex,
            direction: direction,
            setTranslate: setTranslate,
            activeSlideIndex: activeSlideIndex,
            byController: true
        };
        if (Array.isArray(swiper.controller.control)) swiper.controller.control.forEach((c)=>{
            if (!c.destroyed && c.params.loop) c.loopFix({
                ...loopParams,
                slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo : false
            });
        });
        else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) swiper.controller.control.loopFix({
            ...loopParams,
            slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? slideTo : false
        });
    }
    swiper.emit("loopFix");
}
function $7b90f2d36df6fcf3$var$loopDestroy() {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    swiper.recalcSlides();
    const newSlidesOrder = [];
    swiper.slides.forEach((slideEl)=>{
        const index = typeof slideEl.swiperSlideIndex === "undefined" ? slideEl.getAttribute("data-swiper-slide-index") * 1 : slideEl.swiperSlideIndex;
        newSlidesOrder[index] = slideEl;
    });
    swiper.slides.forEach((slideEl)=>{
        slideEl.removeAttribute("data-swiper-slide-index");
    });
    newSlidesOrder.forEach((slideEl)=>{
        slidesEl.append(slideEl);
    });
    swiper.recalcSlides();
    swiper.slideTo(swiper.realIndex, 0);
}
var $7b90f2d36df6fcf3$var$loop = {
    loopCreate: $7b90f2d36df6fcf3$var$loopCreate,
    loopFix: $7b90f2d36df6fcf3$var$loopFix,
    loopDestroy: $7b90f2d36df6fcf3$var$loopDestroy
};
function $7b90f2d36df6fcf3$var$setGrabCursor(moving) {
    const swiper = this;
    if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === "container" ? swiper.el : swiper.wrapperEl;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    el.style.cursor = "move";
    el.style.cursor = moving ? "grabbing" : "grab";
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
function $7b90f2d36df6fcf3$var$unsetGrabCursor() {
    const swiper = this;
    if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    swiper[swiper.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "";
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
var $7b90f2d36df6fcf3$var$grabCursor = {
    setGrabCursor: $7b90f2d36df6fcf3$var$setGrabCursor,
    unsetGrabCursor: $7b90f2d36df6fcf3$var$unsetGrabCursor
};
// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function $7b90f2d36df6fcf3$var$closestElement(selector, base) {
    if (base === void 0) base = this;
    function __closestFrom(el) {
        if (!el || el === (0, $d0093adbb79ad712$export$39b482c5e57630a8)() || el === (0, $d0093adbb79ad712$export$407448d2b89b1813)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $7b90f2d36df6fcf3$var$preventEdgeSwipe(swiper, event, startX) {
    const window1 = (0, $d0093adbb79ad712$export$407448d2b89b1813)();
    const { params: params } = swiper;
    const edgeSwipeDetection = params.edgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window1.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === "prevent") {
            event.preventDefault();
            return true;
        }
        return false;
    }
    return true;
}
function $7b90f2d36df6fcf3$var$onTouchStart(event) {
    const swiper = this;
    const document1 = (0, $d0093adbb79ad712$export$39b482c5e57630a8)();
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    const data = swiper.touchEventsData;
    if (e.type === "pointerdown") {
        if (data.pointerId !== null && data.pointerId !== e.pointerId) return;
        data.pointerId = e.pointerId;
    } else if (e.type === "touchstart" && e.targetTouches.length === 1) data.touchId = e.targetTouches[0].identifier;
    if (e.type === "touchstart") {
        // don't proceed touch event
        $7b90f2d36df6fcf3$var$preventEdgeSwipe(swiper, e, e.targetTouches[0].pageX);
        return;
    }
    const { params: params, touches: touches, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === "mouse") return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let targetEl = e.target;
    if (params.touchEventsTarget === "wrapper") {
        if (!(0, $2a089bf12e68a35c$export$90a7f3efeed30595)(targetEl, swiper.wrapperEl)) return;
    }
    if ("which" in e && e.which === 3) return;
    if ("button" in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return;
    // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== "";
    // eslint-disable-next-line
    const eventPath = e.composedPath ? e.composedPath() : e.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) targetEl = eventPath[0];
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot);
    // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $7b90f2d36df6fcf3$var$closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!targetEl.closest(params.swipeHandler)) return;
    }
    touches.currentX = e.pageX;
    touches.currentY = e.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY;
    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    if (!$7b90f2d36df6fcf3$var$preventEdgeSwipe(swiper, e, startX)) return;
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $2a089bf12e68a35c$export$4368d992c4eafac0)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    let preventDefault = true;
    if (targetEl.matches(data.focusableElements)) {
        preventDefault = false;
        if (targetEl.nodeName === "SELECT") data.isTouched = false;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== targetEl) document1.activeElement.blur();
    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) e.preventDefault();
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit("touchStart", e);
}
function $7b90f2d36df6fcf3$var$onTouchMove(event) {
    const document1 = (0, $d0093adbb79ad712$export$39b482c5e57630a8)();
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === "mouse") return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (e.type === "pointermove") {
        if (data.touchId !== null) return; // return from pointer if we use touch
        const id = e.pointerId;
        if (id !== data.pointerId) return;
    }
    let targetTouch;
    if (e.type === "touchmove") {
        targetTouch = [
            ...e.changedTouches
        ].filter((t)=>t.identifier === data.touchId)[0];
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    } else targetTouch = e;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit("touchMoveOpposite", e);
        return;
    }
    const pageX = targetTouch.pageX;
    const pageY = targetTouch.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!e.target.matches(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $2a089bf12e68a35c$export$4368d992c4eafac0)();
        }
        return;
    }
    if (params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) return;
    }
    if (document1.activeElement) {
        if (e.target === document1.activeElement && e.target.matches(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit("touchMove", e);
    touches.previousX = touches.currentX;
    touches.previousY = touches.currentY;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === "undefined") {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit("touchMoveOpposite", e);
    if (typeof data.startMoving === "undefined") {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling || e.type === "touchmove" && data.preventTouchMoveFromPointerMove) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    let diff = swiper.isHorizontal() ? diffX : diffY;
    let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
    if (params.oneWayMovement) {
        diff = Math.abs(diff) * (rtl ? 1 : -1);
        touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
    }
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) {
        diff = -diff;
        touchesDiff = -touchesDiff;
    }
    const prevTouchesDirection = swiper.touchesDirection;
    swiper.swipeDirection = diff > 0 ? "prev" : "next";
    swiper.touchesDirection = touchesDiff > 0 ? "prev" : "next";
    const isLoop = swiper.params.loop && !params.cssMode;
    const allowLoopFix = swiper.touchesDirection === "next" && swiper.allowSlideNext || swiper.touchesDirection === "prev" && swiper.allowSlidePrev;
    if (!data.isMoved) {
        if (isLoop && allowLoopFix) swiper.loopFix({
            direction: swiper.swipeDirection
        });
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
            const evt = new window.CustomEvent("transitionend", {
                bubbles: true,
                cancelable: true,
                detail: {
                    bySwiperTouchMove: true
                }
            });
            swiper.wrapperEl.dispatchEvent(evt);
        }
        data.allowMomentumBounce = false;
        // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit("sliderFirstMove", e);
    }
    let loopFixed;
    new Date().getTime();
    if (data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
        Object.assign(touches, {
            startX: pageX,
            startY: pageY,
            currentX: pageX,
            currentY: pageY,
            startTranslate: data.currentTranslate
        });
        data.loopSwapReset = true;
        data.startTranslate = data.currentTranslate;
        return;
    }
    swiper.emit("sliderMove", e);
    data.isMoved = true;
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] - (params.slidesPerView !== "auto" && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.activeIndex + 1] + swiper.params.spaceBetween : 0) - swiper.params.spaceBetween : swiper.minTranslate())) swiper.loopFix({
            direction: "prev",
            setTranslate: true,
            activeSlideIndex: 0
        });
        if (data.currentTranslate > swiper.minTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
        }
    } else if (diff < 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween + (params.slidesPerView !== "auto" && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween : 0) : swiper.maxTranslate())) swiper.loopFix({
            direction: "next",
            setTranslate: true,
            activeSlideIndex: swiper.slides.length - (params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
        });
        if (data.currentTranslate < swiper.maxTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
        }
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === "next" && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === "prev" && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
    // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return;
    // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate);
}
function $7b90f2d36df6fcf3$var$onTouchEnd(event) {
    const swiper = this;
    const data = swiper.touchEventsData;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    let targetTouch;
    const isTouchEvent = e.type === "touchend" || e.type === "touchcancel";
    if (!isTouchEvent) {
        if (data.touchId !== null) return; // return from pointer if we use touch
        if (e.pointerId !== data.pointerId) return;
        targetTouch = e;
    } else {
        targetTouch = [
            ...e.changedTouches
        ].filter((t)=>t.identifier === data.touchId)[0];
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    }
    if ([
        "pointercancel",
        "pointerout",
        "pointerleave",
        "contextmenu"
    ].includes(e.type)) {
        const proceed = [
            "pointercancel",
            "contextmenu"
        ].includes(e.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
        if (!proceed) return;
    }
    data.pointerId = null;
    data.touchId = null;
    const { params: params, touches: touches, rtlTranslate: rtl, slidesGrid: slidesGrid, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === "mouse") return;
    if (data.allowTouchCallbacks) swiper.emit("touchEnd", e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
    // Time diff
    const touchEndTime = (0, $2a089bf12e68a35c$export$4368d992c4eafac0)();
    const timeDiff = touchEndTime - data.touchStartTime;
    // Tap, doubleTap, Click
    if (swiper.allowClick) {
        const pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target, pathTree);
        swiper.emit("tap click", e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit("doubleTap doubleClick", e);
    }
    data.lastClickTime = (0, $2a089bf12e68a35c$export$4368d992c4eafac0)();
    (0, $2a089bf12e68a35c$export$7ccc53e8f1e7dfc5)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    }
    // Find current slide
    const swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== "undefined") {
            if (swipeToLast || currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (swipeToLast || currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    }
    // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === "next") {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === "prev") {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === "next") swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
            if (swiper.swipeDirection === "prev") swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}
function $7b90f2d36df6fcf3$var$onResize() {
    const swiper = this;
    const { params: params, el: el } = swiper;
    if (el && el.offsetWidth === 0) return;
    // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
    // Save locks
    const { allowSlideNext: allowSlideNext, allowSlidePrev: allowSlidePrev, snapGrid: snapGrid } = swiper;
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    const isVirtualLoop = isVirtual && params.loop;
    if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else if (swiper.params.loop && !isVirtual) swiper.slideToLoop(swiper.realIndex, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        clearTimeout(swiper.autoplay.resizeTimeout);
        swiper.autoplay.resizeTimeout = setTimeout(()=>{
            if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.resume();
        }, 500);
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}
function $7b90f2d36df6fcf3$var$onClick(e) {
    const swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}
function $7b90f2d36df6fcf3$var$onScroll() {
    const swiper = this;
    const { wrapperEl: wrapperEl, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
    // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit("setTranslate", swiper.translate, false);
}
function $7b90f2d36df6fcf3$var$onLoad(e) {
    const swiper = this;
    $7b90f2d36df6fcf3$var$processLazyPreloader(swiper, e.target);
    if (swiper.params.cssMode || swiper.params.slidesPerView !== "auto" && !swiper.params.autoHeight) return;
    swiper.update();
}
function $7b90f2d36df6fcf3$var$onDocumentTouchStart() {
    const swiper = this;
    if (swiper.documentTouchHandlerProceeded) return;
    swiper.documentTouchHandlerProceeded = true;
    if (swiper.params.touchReleaseOnEdges) swiper.el.style.touchAction = "auto";
}
const $7b90f2d36df6fcf3$var$events = (swiper, method)=>{
    const document1 = (0, $d0093adbb79ad712$export$39b482c5e57630a8)();
    const { params: params, el: el, wrapperEl: wrapperEl, device: device } = swiper;
    const capture = !!params.nested;
    const domMethod = method === "on" ? "addEventListener" : "removeEventListener";
    const swiperMethod = method;
    if (!el || typeof el === "string") return;
    // Touch Events
    document1[domMethod]("touchstart", swiper.onDocumentTouchStart, {
        passive: false,
        capture: capture
    });
    el[domMethod]("touchstart", swiper.onTouchStart, {
        passive: false
    });
    el[domMethod]("pointerdown", swiper.onTouchStart, {
        passive: false
    });
    document1[domMethod]("touchmove", swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]("pointermove", swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]("touchend", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointerup", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointercancel", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("touchcancel", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointerout", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointerleave", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("contextmenu", swiper.onTouchEnd, {
        passive: true
    });
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]("click", swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]("scroll", swiper.onScroll);
    // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", $7b90f2d36df6fcf3$var$onResize, true);
    else swiper[swiperMethod]("observerUpdate", $7b90f2d36df6fcf3$var$onResize, true);
    // Images loader
    el[domMethod]("load", swiper.onLoad, {
        capture: true
    });
};
function $7b90f2d36df6fcf3$var$attachEvents() {
    const swiper = this;
    const { params: params } = swiper;
    swiper.onTouchStart = $7b90f2d36df6fcf3$var$onTouchStart.bind(swiper);
    swiper.onTouchMove = $7b90f2d36df6fcf3$var$onTouchMove.bind(swiper);
    swiper.onTouchEnd = $7b90f2d36df6fcf3$var$onTouchEnd.bind(swiper);
    swiper.onDocumentTouchStart = $7b90f2d36df6fcf3$var$onDocumentTouchStart.bind(swiper);
    if (params.cssMode) swiper.onScroll = $7b90f2d36df6fcf3$var$onScroll.bind(swiper);
    swiper.onClick = $7b90f2d36df6fcf3$var$onClick.bind(swiper);
    swiper.onLoad = $7b90f2d36df6fcf3$var$onLoad.bind(swiper);
    $7b90f2d36df6fcf3$var$events(swiper, "on");
}
function $7b90f2d36df6fcf3$var$detachEvents() {
    const swiper = this;
    $7b90f2d36df6fcf3$var$events(swiper, "off");
}
var $7b90f2d36df6fcf3$var$events$1 = {
    attachEvents: $7b90f2d36df6fcf3$var$attachEvents,
    detachEvents: $7b90f2d36df6fcf3$var$detachEvents
};
const $7b90f2d36df6fcf3$var$isGridEnabled = (swiper, params)=>{
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $7b90f2d36df6fcf3$var$setBreakpoint() {
    const swiper = this;
    const { realIndex: realIndex, initialized: initialized, params: params, el: el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
    // Get breakpoint for window width and update parameters
    const breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = $7b90f2d36df6fcf3$var$isGridEnabled(swiper, params);
    const isMultiRow = $7b90f2d36df6fcf3$var$isGridEnabled(swiper, breakpointParams);
    const wasGrabCursor = swiper.params.grabCursor;
    const isGrabCursor = breakpointParams.grabCursor;
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        el.classList.add(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === "column" || !breakpointParams.grid.fill && params.grid.fill === "column") el.classList.add(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    }
    if (wasGrabCursor && !isGrabCursor) swiper.unsetGrabCursor();
    else if (!wasGrabCursor && isGrabCursor) swiper.setGrabCursor();
    // Toggle navigation, pagination, scrollbar
    [
        "navigation",
        "pagination",
        "scrollbar"
    ].forEach((prop)=>{
        if (typeof breakpointParams[prop] === "undefined") return;
        const wasModuleEnabled = params[prop] && params[prop].enabled;
        const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    const wasLoop = params.loop;
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $2a089bf12e68a35c$export$efccba1c4a2ef57b)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    const hasLoop = swiper.params.loop;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit("_beforeBreakpoint", breakpointParams);
    if (initialized) {
        if (needsReLoop) {
            swiper.loopDestroy();
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (!wasLoop && hasLoop) {
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (wasLoop && !hasLoop) swiper.loopDestroy();
    }
    swiper.emit("breakpoint", breakpointParams);
}
function $7b90f2d36df6fcf3$var$getBreakpoint(breakpoints, base, containerEl) {
    if (base === void 0) base = "window";
    if (!breakpoints || base === "container" && !containerEl) return undefined;
    let breakpoint = false;
    const window1 = (0, $d0093adbb79ad712$export$407448d2b89b1813)();
    const currentHeight = base === "window" ? window1.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === "string" && point.indexOf("@") === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort((a, b)=>parseInt(a.value, 10) - parseInt(b.value, 10));
    for(let i = 0; i < points.length; i += 1){
        const { point: point, value: value } = points[i];
        if (base === "window") {
            if (window1.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || "max";
}
var $7b90f2d36df6fcf3$var$breakpoints = {
    setBreakpoint: $7b90f2d36df6fcf3$var$setBreakpoint,
    getBreakpoint: $7b90f2d36df6fcf3$var$getBreakpoint
};
function $7b90f2d36df6fcf3$var$prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === "object") Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === "string") resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $7b90f2d36df6fcf3$var$addClasses() {
    const swiper = this;
    const { classNames: classNames, params: params, rtl: rtl, el: el, device: device } = swiper;
    // prettier-ignore
    const suffixes = $7b90f2d36df6fcf3$var$prepareClasses([
        "initialized",
        params.direction,
        {
            "free-mode": swiper.params.freeMode && params.freeMode.enabled
        },
        {
            "autoheight": params.autoHeight
        },
        {
            "rtl": rtl
        },
        {
            "grid": params.grid && params.grid.rows > 1
        },
        {
            "grid-column": params.grid && params.grid.rows > 1 && params.grid.fill === "column"
        },
        {
            "android": device.android
        },
        {
            "ios": device.ios
        },
        {
            "css-mode": params.cssMode
        },
        {
            "centered": params.cssMode && params.centeredSlides
        },
        {
            "watch-progress": params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    el.classList.add(...classNames);
    swiper.emitContainerClasses();
}
function $7b90f2d36df6fcf3$var$removeClasses() {
    const swiper = this;
    const { el: el, classNames: classNames } = swiper;
    if (!el || typeof el === "string") return;
    el.classList.remove(...classNames);
    swiper.emitContainerClasses();
}
var $7b90f2d36df6fcf3$var$classes = {
    addClasses: $7b90f2d36df6fcf3$var$addClasses,
    removeClasses: $7b90f2d36df6fcf3$var$removeClasses
};
function $7b90f2d36df6fcf3$var$checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params: params } = swiper;
    const { slidesOffsetBefore: slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? "lock" : "unlock");
}
var $7b90f2d36df6fcf3$var$checkOverflow$1 = {
    checkOverflow: $7b90f2d36df6fcf3$var$checkOverflow
};
var $7b90f2d36df6fcf3$export$4368d992c4eafac0 = {
    init: true,
    direction: "horizontal",
    oneWayMovement: false,
    swiperElementNodeName: "SWIPER-CONTAINER",
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    eventsPrefix: "swiper",
    enabled: true,
    focusableElements: "input, select, option, textarea, button, video, label",
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: "slide",
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: "window",
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 5,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // loop
    loop: false,
    loopAddBlankSlides: true,
    loopAdditionalSlides: 0,
    loopPreventsSliding: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: "swiper-",
    // NEW
    slideClass: "swiper-slide",
    slideBlankClass: "swiper-slide-blank",
    slideActiveClass: "swiper-slide-active",
    slideVisibleClass: "swiper-slide-visible",
    slideFullyVisibleClass: "swiper-slide-fully-visible",
    slideNextClass: "swiper-slide-next",
    slidePrevClass: "swiper-slide-prev",
    wrapperClass: "swiper-wrapper",
    lazyPreloaderClass: "swiper-lazy-preloader",
    lazyPreloadPrevNext: 0,
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};
function $7b90f2d36df6fcf3$var$moduleExtendParams(params, allModulesParams) {
    return function extendParams(obj) {
        if (obj === void 0) obj = {};
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== "object" || moduleParams === null) {
            (0, $2a089bf12e68a35c$export$efccba1c4a2ef57b)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (moduleParamName === "navigation" && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) params[moduleParamName].auto = true;
        if ([
            "pagination",
            "scrollbar"
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) params[moduleParamName].auto = true;
        if (!(moduleParamName in params && "enabled" in moduleParams)) {
            (0, $2a089bf12e68a35c$export$efccba1c4a2ef57b)(allModulesParams, obj);
            return;
        }
        if (typeof params[moduleParamName] === "object" && !("enabled" in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $2a089bf12e68a35c$export$efccba1c4a2ef57b)(allModulesParams, obj);
    };
}
/* eslint no-param-reassign: "off" */ const $7b90f2d36df6fcf3$var$prototypes = {
    eventsEmitter: $7b90f2d36df6fcf3$var$eventsEmitter,
    update: $7b90f2d36df6fcf3$var$update,
    translate: $7b90f2d36df6fcf3$var$translate,
    transition: $7b90f2d36df6fcf3$var$transition,
    slide: $7b90f2d36df6fcf3$var$slide,
    loop: $7b90f2d36df6fcf3$var$loop,
    grabCursor: $7b90f2d36df6fcf3$var$grabCursor,
    events: $7b90f2d36df6fcf3$var$events$1,
    breakpoints: $7b90f2d36df6fcf3$var$breakpoints,
    checkOverflow: $7b90f2d36df6fcf3$var$checkOverflow$1,
    classes: $7b90f2d36df6fcf3$var$classes
};
const $7b90f2d36df6fcf3$var$extendedDefaults = {};
class $7b90f2d36df6fcf3$export$25ce5a424b770e84 {
    constructor(){
        let el;
        let params;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === "Object") params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, $2a089bf12e68a35c$export$efccba1c4a2ef57b)({}, params);
        if (el && !params.el) params.el = el;
        const document1 = (0, $d0093adbb79ad712$export$39b482c5e57630a8)();
        if (params.el && typeof params.el === "string" && document1.querySelectorAll(params.el).length > 1) {
            const swipers = [];
            document1.querySelectorAll(params.el).forEach((containerEl)=>{
                const newParams = (0, $2a089bf12e68a35c$export$efccba1c4a2ef57b)({}, params, {
                    el: containerEl
                });
                swipers.push(new $7b90f2d36df6fcf3$export$25ce5a424b770e84(newParams));
            });
            // eslint-disable-next-line no-constructor-return
            return swipers;
        }
        // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = $7b90f2d36df6fcf3$var$getSupport();
        swiper.device = $7b90f2d36df6fcf3$var$getDevice({
            userAgent: params.userAgent
        });
        swiper.browser = $7b90f2d36df6fcf3$var$getBrowser();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__
        ];
        if (params.modules && Array.isArray(params.modules)) swiper.modules.push(...params.modules);
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                params: params,
                swiper: swiper,
                extendParams: $7b90f2d36df6fcf3$var$moduleExtendParams(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        });
        // Extend defaults with modules params
        const swiperParams = (0, $2a089bf12e68a35c$export$efccba1c4a2ef57b)({}, $7b90f2d36df6fcf3$export$4368d992c4eafac0, allModulesParams);
        // Extend defaults with passed params
        swiper.params = (0, $2a089bf12e68a35c$export$efccba1c4a2ef57b)({}, swiperParams, $7b90f2d36df6fcf3$var$extendedDefaults, params);
        swiper.originalParams = (0, $2a089bf12e68a35c$export$efccba1c4a2ef57b)({}, swiper.params);
        swiper.passedParams = (0, $2a089bf12e68a35c$export$efccba1c4a2ef57b)({}, params);
        // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach((eventName)=>{
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
        // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: [],
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === "horizontal";
            },
            isVertical () {
                return swiper.params.direction === "vertical";
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            cssOverflowAdjustment () {
                // Returns 0 unless `translate` is > 2**23
                // Should be subtracted from css values to prevent overflow
                return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
            },
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: 0,
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                startMoving: undefined,
                pointerId: null,
                touchId: null
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit("_swiper");
        // Init
        if (swiper.params.init) swiper.init();
        // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
    getDirectionLabel(property) {
        if (this.isHorizontal()) return property;
        // prettier-ignore
        return ({
            "width": "height",
            "margin-top": "margin-left",
            "margin-bottom ": "margin-right",
            "margin-left": "margin-top",
            "margin-right": "margin-bottom",
            "padding-left": "padding-top",
            "padding-right": "padding-bottom",
            "marginRight": "marginBottom"
        })[property];
    }
    getSlideIndex(slideEl) {
        const { slidesEl: slidesEl, params: params } = this;
        const slides = (0, $2a089bf12e68a35c$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        const firstSlideIndex = (0, $2a089bf12e68a35c$export$dda1d9f60106f0e9)(slides[0]);
        return (0, $2a089bf12e68a35c$export$dda1d9f60106f0e9)(slideEl) - firstSlideIndex;
    }
    getSlideIndexByData(index) {
        return this.getSlideIndex(this.slides.filter((slideEl)=>slideEl.getAttribute("data-swiper-slide-index") * 1 === index)[0]);
    }
    recalcSlides() {
        const swiper = this;
        const { slidesEl: slidesEl, params: params } = swiper;
        swiper.slides = (0, $2a089bf12e68a35c$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
    }
    enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit("enable");
    }
    disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit("disable");
    }
    setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === "undefined" ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(" ").filter((className)=>{
            return className.indexOf("swiper") === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit("_containerClasses", cls.join(" "));
    }
    getSlideClasses(slideEl) {
        const swiper = this;
        if (swiper.destroyed) return "";
        return slideEl.className.split(" ").filter((className)=>{
            return className.indexOf("swiper-slide") === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(" ");
    }
    emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.forEach((slideEl)=>{
            const classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            swiper.emit("_slideClass", slideEl, classNames);
        });
        swiper.emit("_slideClasses", updates);
    }
    slidesPerViewDynamic(view, exact) {
        if (view === void 0) view = "current";
        if (exact === void 0) exact = false;
        const swiper = this;
        const { params: params, slides: slides, slidesGrid: slidesGrid, slidesSizesGrid: slidesSizesGrid, size: swiperSize, activeIndex: activeIndex } = swiper;
        let spv = 1;
        if (typeof params.slidesPerView === "number") return params.slidesPerView;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex] ? Math.ceil(slides[activeIndex].swiperSlideSize) : 0;
            let breakLoop;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += Math.ceil(slides[i].swiperSlideSize);
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            // eslint-disable-next-line
            if (view === "current") for(let i = activeIndex + 1; i < slides.length; i += 1){
                const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
                if (slideInView) spv += 1;
            }
            else // previous
            for(let i = activeIndex - 1; i >= 0; i -= 1){
                const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
                if (slideInView) spv += 1;
            }
        }
        return spv;
    }
    update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid: snapGrid, params: params } = swiper;
        // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ].forEach((imageEl)=>{
            if (imageEl.complete) $7b90f2d36df6fcf3$var$processLazyPreloader(swiper, imageEl);
        });
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
            setTranslate();
            if (params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
                const slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
                translated = swiper.slideTo(slides.length - 1, 0, false, true);
            } else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit("update");
    }
    changeDirection(newDirection, needUpdate) {
        if (needUpdate === void 0) needUpdate = true;
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === "horizontal" ? "vertical" : "horizontal";
        if (newDirection === currentDirection || newDirection !== "horizontal" && newDirection !== "vertical") return swiper;
        swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
        swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.forEach((slideEl)=>{
            if (newDirection === "vertical") slideEl.style.width = "";
            else slideEl.style.height = "";
        });
        swiper.emit("changeDirection");
        if (needUpdate) swiper.update();
        return swiper;
    }
    changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === "rtl" || !swiper.rtl && direction === "ltr") return;
        swiper.rtl = direction === "rtl";
        swiper.rtlTranslate = swiper.params.direction === "horizontal" && swiper.rtl;
        if (swiper.rtl) {
            swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = "rtl";
        } else {
            swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = "ltr";
        }
        swiper.update();
    }
    mount(element) {
        const swiper = this;
        if (swiper.mounted) return true;
        // Find el
        let el = element || swiper.params.el;
        if (typeof el === "string") el = document.querySelector(el);
        if (!el) return false;
        el.swiper = swiper;
        if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) swiper.isElement = true;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || "").trim().split(" ").join(".")}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                const res = el.shadowRoot.querySelector(getWrapperSelector());
                // Children needs to return slot items
                return res;
            }
            return (0, $2a089bf12e68a35c$export$f1e1789686576879)(el, getWrapperSelector())[0];
        };
        // Find Wrapper
        let wrapperEl = getWrapper();
        if (!wrapperEl && swiper.params.createElements) {
            wrapperEl = (0, $2a089bf12e68a35c$export$db3b6bfb95261072)("div", swiper.params.wrapperClass);
            el.append(wrapperEl);
            (0, $2a089bf12e68a35c$export$f1e1789686576879)(el, `.${swiper.params.slideClass}`).forEach((slideEl)=>{
                wrapperEl.append(slideEl);
            });
        }
        Object.assign(swiper, {
            el: el,
            wrapperEl: wrapperEl,
            slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
            hostEl: swiper.isElement ? el.parentNode.host : el,
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === "rtl" || (0, $2a089bf12e68a35c$export$ffb5f4729a158638)(el, "direction") === "rtl",
            rtlTranslate: swiper.params.direction === "horizontal" && (el.dir.toLowerCase() === "rtl" || (0, $2a089bf12e68a35c$export$ffb5f4729a158638)(el, "direction") === "rtl"),
            wrongRTL: (0, $2a089bf12e68a35c$export$ffb5f4729a158638)(wrapperEl, "display") === "-webkit-box"
        });
        return true;
    }
    init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit("beforeInit");
        // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
        // Add Classes
        swiper.addClasses();
        // Update size
        swiper.updateSize();
        // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        // Slide To Initial Slide
        if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
        // Create loop
        if (swiper.params.loop) swiper.loopCreate();
        // Attach events
        swiper.attachEvents();
        const lazyElements = [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ];
        if (swiper.isElement) lazyElements.push(...swiper.hostEl.querySelectorAll('[loading="lazy"]'));
        lazyElements.forEach((imageEl)=>{
            if (imageEl.complete) $7b90f2d36df6fcf3$var$processLazyPreloader(swiper, imageEl);
            else imageEl.addEventListener("load", (e)=>{
                $7b90f2d36df6fcf3$var$processLazyPreloader(swiper, e.target);
            });
        });
        $7b90f2d36df6fcf3$var$preload(swiper);
        // Init Flag
        swiper.initialized = true;
        $7b90f2d36df6fcf3$var$preload(swiper);
        // Emit
        swiper.emit("init");
        swiper.emit("afterInit");
        return swiper;
    }
    destroy(deleteInstance, cleanStyles) {
        if (deleteInstance === void 0) deleteInstance = true;
        if (cleanStyles === void 0) cleanStyles = true;
        const swiper = this;
        const { params: params, el: el, wrapperEl: wrapperEl, slides: slides } = swiper;
        if (typeof swiper.params === "undefined" || swiper.destroyed) return null;
        swiper.emit("beforeDestroy");
        // Init Flag
        swiper.initialized = false;
        // Detach events
        swiper.detachEvents();
        // Destroy loop
        if (params.loop) swiper.loopDestroy();
        // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            if (el && typeof el !== "string") el.removeAttribute("style");
            if (wrapperEl) wrapperEl.removeAttribute("style");
            if (slides && slides.length) slides.forEach((slideEl)=>{
                slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
                slideEl.removeAttribute("style");
                slideEl.removeAttribute("data-swiper-slide-index");
            });
        }
        swiper.emit("destroy");
        // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            if (swiper.el && typeof swiper.el !== "string") swiper.el.swiper = null;
            (0, $2a089bf12e68a35c$export$d141bba7fdc215a3)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, $2a089bf12e68a35c$export$efccba1c4a2ef57b)($7b90f2d36df6fcf3$var$extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
        return $7b90f2d36df6fcf3$var$extendedDefaults;
    }
    static get defaults() {
        return $7b90f2d36df6fcf3$export$4368d992c4eafac0;
    }
    static installModule(mod) {
        if (!$7b90f2d36df6fcf3$export$25ce5a424b770e84.prototype.__modules__) $7b90f2d36df6fcf3$export$25ce5a424b770e84.prototype.__modules__ = [];
        const modules = $7b90f2d36df6fcf3$export$25ce5a424b770e84.prototype.__modules__;
        if (typeof mod === "function" && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>$7b90f2d36df6fcf3$export$25ce5a424b770e84.installModule(m));
            return $7b90f2d36df6fcf3$export$25ce5a424b770e84;
        }
        $7b90f2d36df6fcf3$export$25ce5a424b770e84.installModule(module);
        return $7b90f2d36df6fcf3$export$25ce5a424b770e84;
    }
}
Object.keys($7b90f2d36df6fcf3$var$prototypes).forEach((prototypeGroup)=>{
    Object.keys($7b90f2d36df6fcf3$var$prototypes[prototypeGroup]).forEach((protoMethod)=>{
        $7b90f2d36df6fcf3$export$25ce5a424b770e84.prototype[protoMethod] = $7b90f2d36df6fcf3$var$prototypes[prototypeGroup][protoMethod];
    });
});
$7b90f2d36df6fcf3$export$25ce5a424b770e84.use([
    $7b90f2d36df6fcf3$var$Resize,
    $7b90f2d36df6fcf3$var$Observer
]);






function $550bac18248e9178$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    let cssModeTimeout;
    const document = (0, $d0093adbb79ad712$export$39b482c5e57630a8)();
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    const tempDOM = document.createElement("div");
    function renderSlide(slide, index) {
        const params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        // eslint-disable-next-line
        let slideEl;
        if (params.renderSlide) {
            slideEl = params.renderSlide.call(swiper, slide, index);
            if (typeof slideEl === "string") {
                tempDOM.innerHTML = slideEl;
                slideEl = tempDOM.children[0];
            }
        } else if (swiper.isElement) slideEl = (0, $2a089bf12e68a35c$export$db3b6bfb95261072)("swiper-slide");
        else slideEl = (0, $2a089bf12e68a35c$export$db3b6bfb95261072)("div", swiper.params.slideClass);
        slideEl.setAttribute("data-swiper-slide-index", index);
        if (!params.renderSlide) slideEl.innerHTML = slide;
        if (params.cache) swiper.virtual.cache[index] = slideEl;
        return slideEl;
    }
    function update(force, beforeInit) {
        const { slidesPerView: slidesPerView, slidesPerGroup: slidesPerGroup, centeredSlides: centeredSlides, loop: isLoop, initialSlide: initialSlide } = swiper.params;
        if (beforeInit && !isLoop && initialSlide > 0) return;
        const { addSlidesBefore: addSlidesBefore, addSlidesAfter: addSlidesAfter } = swiper.params.virtual;
        const { from: previousFrom, to: previousTo, slides: slides, slidesGrid: previousSlidesGrid, offset: previousOffset } = swiper.virtual;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        const activeIndex = swiper.activeIndex || 0;
        let offsetProp;
        if (swiper.rtlTranslate) offsetProp = "right";
        else offsetProp = swiper.isHorizontal() ? "left" : "top";
        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = (isLoop ? slidesPerView : slidesPerGroup) + addSlidesBefore;
        }
        let from = activeIndex - slidesBefore;
        let to = activeIndex + slidesAfter;
        if (!isLoop) {
            from = Math.max(from, 0);
            to = Math.min(to, slides.length - 1);
        }
        let offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        if (isLoop && activeIndex >= slidesBefore) {
            from -= slidesBefore;
            if (!centeredSlides) offset += swiper.slidesGrid[0];
        } else if (isLoop && activeIndex < slidesBefore) {
            from = -slidesBefore;
            if (centeredSlides) offset += swiper.slidesGrid[0];
        }
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid,
            slidesBefore: slidesBefore,
            slidesAfter: slidesAfter
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            emit("virtualUpdate");
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.forEach((slideEl)=>{
                slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
            });
            swiper.updateProgress();
            emit("virtualUpdate");
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    const slidesToRender = [];
                    for(let i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            else emit("virtualUpdate");
            return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        const getSlideIndex = (index)=>{
            let slideIndex = index;
            if (index < 0) slideIndex = slides.length + index;
            else if (slideIndex >= slides.length) // eslint-disable-next-line
            slideIndex = slideIndex - slides.length;
            return slideIndex;
        };
        if (force) swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`)).forEach((slideEl)=>{
            slideEl.remove();
        });
        else {
            for(let i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) {
                const slideIndex = getSlideIndex(i);
                swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}[data-swiper-slide-index="${slideIndex}"], swiper-slide[data-swiper-slide-index="${slideIndex}"]`)).forEach((slideEl)=>{
                    slideEl.remove();
                });
            }
        }
        const loopFrom = isLoop ? -slides.length : 0;
        const loopTo = isLoop ? slides.length * 2 : slides.length;
        for(let i = loopFrom; i < loopTo; i += 1)if (i >= from && i <= to) {
            const slideIndex = getSlideIndex(i);
            if (typeof previousTo === "undefined" || force) appendIndexes.push(slideIndex);
            else {
                if (i > previousTo) appendIndexes.push(slideIndex);
                if (i < previousFrom) prependIndexes.push(slideIndex);
            }
        }
        appendIndexes.forEach((index)=>{
            swiper.slidesEl.append(renderSlide(slides[index], index));
        });
        if (isLoop) for(let i = prependIndexes.length - 1; i >= 0; i -= 1){
            const index = prependIndexes[i];
            swiper.slidesEl.prepend(renderSlide(slides[index], index));
        }
        else {
            prependIndexes.sort((a, b)=>b - a);
            prependIndexes.forEach((index)=>{
                swiper.slidesEl.prepend(renderSlide(slides[index], index));
            });
        }
        (0, $2a089bf12e68a35c$export$f1e1789686576879)(swiper.slidesEl, ".swiper-slide, swiper-slide").forEach((slideEl)=>{
            slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
        });
        onRendered();
    }
    function appendSlide(slides) {
        if (typeof slides === "object" && "length" in slides) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            const cache = swiper.virtual.cache;
            const newCache = {};
            Object.keys(cache).forEach((cachedIndex)=>{
                const cachedEl = cache[cachedIndex];
                const cachedElIndex = cachedEl.getAttribute("data-swiper-slide-index");
                if (cachedElIndex) cachedEl.setAttribute("data-swiper-slide-index", parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === "undefined" || slidesIndexes === null) return;
        let activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(let i = slidesIndexes.length - 1; i >= 0; i -= 1){
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes[i]];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach((key)=>{
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute("data-swiper-slide-index", key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach((key)=>{
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute("data-swiper-slide-index", key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on("beforeInit", ()=>{
        if (!swiper.params.virtual.enabled) return;
        let domSlidesAssigned;
        if (typeof swiper.passedParams.virtual.slides === "undefined") {
            const slides = [
                ...swiper.slidesEl.children
            ].filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`));
            if (slides && slides.length) {
                swiper.virtual.slides = [
                    ...slides
                ];
                domSlidesAssigned = true;
                slides.forEach((slideEl, slideIndex)=>{
                    slideEl.setAttribute("data-swiper-slide-index", slideIndex);
                    swiper.virtual.cache[slideIndex] = slideEl;
                    slideEl.remove();
                });
            }
        }
        if (!domSlidesAssigned) swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        update(false, true);
    });
    on("setTranslate", ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(()=>{
                update();
            }, 100);
        } else update();
    });
    on("init update resize", ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, $2a089bf12e68a35c$export$2408f22a0fab9ae5)(swiper.wrapperEl, "--swiper-virtual-size", `${swiper.virtualSize}px`);
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
}




/* eslint-disable consistent-return */ function $8db1b859d66134e0$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const document = (0, $d0093adbb79ad712$export$39b482c5e57630a8)();
    const window = (0, $d0093adbb79ad712$export$407448d2b89b1813)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    });
    function handle(event) {
        if (!swiper.enabled) return;
        const { rtlTranslate: rtl } = swiper;
        let e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        const kc = e.keyCode || e.charCode;
        const pageUpDown = swiper.params.keyboard.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40;
        // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === "input" || document.activeElement.nodeName.toLowerCase() === "textarea")) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            let inView = false;
            // Check that swiper should be inside of visible area of window
            if ((0, $2a089bf12e68a35c$export$407448d2b89b1813)(swiper.el, `.${swiper.params.slideClass}, swiper-slide`).length > 0 && (0, $2a089bf12e68a35c$export$407448d2b89b1813)(swiper.el, `.${swiper.params.slideActiveClass}`).length === 0) return undefined;
            const el = swiper.el;
            const swiperWidth = el.clientWidth;
            const swiperHeight = el.clientHeight;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const swiperOffset = (0, $2a089bf12e68a35c$export$8b22cf2602fb60ce)(el);
            if (rtl) swiperOffset.left -= el.scrollLeft;
            const swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(let i = 0; i < swiperCoord.length; i += 1){
                const point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        emit("keyPress", kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        document.addEventListener("keydown", handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        document.removeEventListener("keydown", handle);
        swiper.keyboard.enabled = false;
    }
    on("init", ()=>{
        if (swiper.params.keyboard.enabled) enable();
    });
    on("destroy", ()=>{
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable: enable,
        disable: disable
    });
}




/* eslint-disable consistent-return */ function $4bb0c980088ca0d4$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const window = (0, $d0093adbb79ad712$export$407448d2b89b1813)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: "container",
            thresholdDelta: null,
            thresholdTime: null,
            noMousewheelClass: "swiper-no-mousewheel"
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    let timeout;
    let lastScrollTime = (0, $2a089bf12e68a35c$export$4368d992c4eafac0)();
    let lastEventBeforeSnap;
    const recentWheelEvents = [];
    function normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        let sX = 0;
        let sY = 0; // spinX, spinY
        let pX = 0;
        let pY = 0; // pixelX, pixelY
        // Legacy
        if ("detail" in e) sY = e.detail;
        if ("wheelDelta" in e) sY = -e.wheelDelta / 120;
        if ("wheelDeltaY" in e) sY = -e.wheelDeltaY / 120;
        if ("wheelDeltaX" in e) sX = -e.wheelDeltaX / 120;
        // side scrolling on FF with DOMMouseScroll
        if ("axis" in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ("deltaY" in e) pY = e.deltaY;
        if ("deltaX" in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        }
        // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    }
    function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, $2a089bf12e68a35c$export$4368d992c4eafac0)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
        // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $2a089bf12e68a35c$export$4368d992c4eafac0)() - lastScrollTime < 60) // Return false as a default
        return true;
        // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit("scroll", newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit("scroll", newEvent.raw);
        }
        // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime();
        // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        const params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event1) {
        let e = event1;
        let disableParentSwiper = true;
        if (!swiper.enabled) return;
        // Ignore event if the target or its parents have the swiper-no-mousewheel class
        if (event1.target.closest(`.${swiper.params.mousewheel.noMousewheelClass}`)) return;
        const params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== "container") targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        const targetElContainsTarget = targetEl && targetEl.contains(e.target);
        if (!swiper.mouseEntered && !targetElContainsTarget && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta;
        // Get the scroll positions
        let positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate();
        // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            const newEvent = {
                time: (0, $2a089bf12e68a35c$export$4368d992c4eafac0)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            };
            // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent);
            // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
            // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            const newEvent = {
                time: (0, $2a089bf12e68a35c$export$4368d992c4eafac0)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                let position = swiper.getTranslate() + delta * params.sensitivity;
                const wasBeginning = swiper.isBeginning;
                const wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.loop) swiper.loopFix({
                    direction: newEvent.direction < 0 ? "next" : "prev",
                    byMousewheel: true
                });
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    const firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent);
                    if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        timeout = (0, $2a089bf12e68a35c$export$7ccc53e8f1e7dfc5)(()=>{
                            if (swiper.destroyed || !swiper.params) return;
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, $2a089bf12e68a35c$export$7ccc53e8f1e7dfc5)(()=>{
                        if (swiper.destroyed || !swiper.params) return;
                        const snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                }
                // Emit event
                if (!ignoreWheelEvents) emit("scroll", e);
                // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop();
                // Return page scroll on edge positions
                if (params.releaseOnEdges && (position === swiper.minTranslate() || position === swiper.maxTranslate())) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    }
    function events(method) {
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== "container") targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        targetEl[method]("mouseenter", handleMouseEnter);
        targetEl[method]("mouseleave", handleMouseLeave);
        targetEl[method]("wheel", handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener("wheel", handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events("addEventListener");
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events("removeEventListener");
        swiper.mousewheel.enabled = false;
        return true;
    }
    on("init", ()=>{
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on("destroy", ()=>{
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable: enable,
        disable: disable
    });
}



function $1e1ada34a0c8bf7a$export$db3b6bfb95261072(swiper, originalParams, params, checkProps) {
    if (swiper.params.createElements) Object.keys(checkProps).forEach((key)=>{
        if (!params[key] && params.auto === true) {
            let element = (0, $2a089bf12e68a35c$export$f1e1789686576879)(swiper.el, `.${checkProps[key]}`)[0];
            if (!element) {
                element = (0, $2a089bf12e68a35c$export$db3b6bfb95261072)("div", checkProps[key]);
                element.className = checkProps[key];
                swiper.el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}



function $56d57b52593640f1$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: "swiper-button-disabled",
            hiddenClass: "swiper-button-hidden",
            lockClass: "swiper-button-lock",
            navigationDisabledClass: "swiper-navigation-disabled"
        }
    });
    swiper.navigation = {
        nextEl: null,
        prevEl: null
    };
    function getEl(el) {
        let res;
        if (el && typeof el === "string" && swiper.isElement) {
            res = swiper.el.querySelector(el);
            if (res) return res;
        }
        if (el) {
            if (typeof el === "string") res = [
                ...document.querySelectorAll(el)
            ];
            if (swiper.params.uniqueNavElements && typeof el === "string" && res && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) res = swiper.el.querySelector(el);
            else if (res && res.length === 1) res = res[0];
        }
        if (el && !res) return el;
        // if (Array.isArray(res) && res.length === 1) res = res[0];
        return res;
    }
    function toggleEl(el, disabled) {
        const params = swiper.params.navigation;
        el = (0, $2a089bf12e68a35c$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            if (subEl) {
                subEl.classList[disabled ? "add" : "remove"](...params.disabledClass.split(" "));
                if (subEl.tagName === "BUTTON") subEl.disabled = disabled;
                if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? "add" : "remove"](params.lockClass);
            }
        });
    }
    function update() {
        // Update Navigation Buttons
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (swiper.params.loop) {
            toggleEl(prevEl, false);
            toggleEl(nextEl, false);
            return;
        }
        toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit("navigationPrev");
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit("navigationNext");
    }
    function init() {
        const params = swiper.params.navigation;
        swiper.params.navigation = (0, $1e1ada34a0c8bf7a$export$db3b6bfb95261072)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: "swiper-button-next",
            prevEl: "swiper-button-prev"
        });
        if (!(params.nextEl || params.prevEl)) return;
        let nextEl = getEl(params.nextEl);
        let prevEl = getEl(params.prevEl);
        Object.assign(swiper.navigation, {
            nextEl: nextEl,
            prevEl: prevEl
        });
        nextEl = (0, $2a089bf12e68a35c$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $2a089bf12e68a35c$export$953cecd6e717a553)(prevEl);
        const initButton = (el, dir)=>{
            if (el) el.addEventListener("click", dir === "next" ? onNextClick : onPrevClick);
            if (!swiper.enabled && el) el.classList.add(...params.lockClass.split(" "));
        };
        nextEl.forEach((el)=>initButton(el, "next"));
        prevEl.forEach((el)=>initButton(el, "prev"));
    }
    function destroy() {
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $2a089bf12e68a35c$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $2a089bf12e68a35c$export$953cecd6e717a553)(prevEl);
        const destroyButton = (el, dir)=>{
            el.removeEventListener("click", dir === "next" ? onNextClick : onPrevClick);
            el.classList.remove(...swiper.params.navigation.disabledClass.split(" "));
        };
        nextEl.forEach((el)=>destroyButton(el, "next"));
        prevEl.forEach((el)=>destroyButton(el, "prev"));
    }
    on("init", ()=>{
        if (swiper.params.navigation.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            update();
        }
    });
    on("toEdge fromEdge lock unlock", ()=>{
        update();
    });
    on("destroy", ()=>{
        destroy();
    });
    on("enable disable", ()=>{
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $2a089bf12e68a35c$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $2a089bf12e68a35c$export$953cecd6e717a553)(prevEl);
        if (swiper.enabled) {
            update();
            return;
        }
        [
            ...nextEl,
            ...prevEl
        ].filter((el)=>!!el).forEach((el)=>el.classList.add(swiper.params.navigation.lockClass));
    });
    on("click", (_s, e)=>{
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $2a089bf12e68a35c$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $2a089bf12e68a35c$export$953cecd6e717a553)(prevEl);
        const targetEl = e.target;
        let targetIsButton = prevEl.includes(targetEl) || nextEl.includes(targetEl);
        if (swiper.isElement && !targetIsButton) {
            const path = e.path || e.composedPath && e.composedPath();
            if (path) targetIsButton = path.find((pathEl)=>nextEl.includes(pathEl) || prevEl.includes(pathEl));
        }
        if (swiper.params.navigation.hideOnClick && !targetIsButton) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            let isHidden;
            if (nextEl.length) isHidden = nextEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            else if (prevEl.length) isHidden = prevEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit("navigationShow");
            else emit("navigationHide");
            [
                ...nextEl,
                ...prevEl
            ].filter((el)=>!!el).forEach((el)=>el.classList.toggle(swiper.params.navigation.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(...swiper.params.navigation.navigationDisabledClass.split(" "));
        init();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(...swiper.params.navigation.navigationDisabledClass.split(" "));
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable: enable,
        disable: disable,
        update: update,
        init: init,
        destroy: destroy
    });
}


function $b38557946c7d8a27$export$db3b6bfb95261072(classes) {
    if (classes === void 0) classes = "";
    return `.${classes.trim().replace(/([\.:!+\/])/g, "\\$1") // eslint-disable-line
    .replace(/ /g, ".")}`;
}




function $b976be8888348c09$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const pfx = "swiper-pagination";
    extendParams({
        pagination: {
            el: null,
            bulletElement: "span",
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: "bullets",
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: (number)=>number,
            formatFractionTotal: (number)=>number,
            bulletClass: `${pfx}-bullet`,
            bulletActiveClass: `${pfx}-bullet-active`,
            modifierClass: `${pfx}-`,
            currentClass: `${pfx}-current`,
            totalClass: `${pfx}-total`,
            hiddenClass: `${pfx}-hidden`,
            progressbarFillClass: `${pfx}-progressbar-fill`,
            progressbarOppositeClass: `${pfx}-progressbar-opposite`,
            clickableClass: `${pfx}-clickable`,
            lockClass: `${pfx}-lock`,
            horizontalClass: `${pfx}-horizontal`,
            verticalClass: `${pfx}-vertical`,
            paginationDisabledClass: `${pfx}-disabled`
        }
    });
    swiper.pagination = {
        el: null,
        bullets: []
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
    }
    function setSideBullets(bulletEl, position) {
        const { bulletActiveClass: bulletActiveClass } = swiper.params.pagination;
        if (!bulletEl) return;
        bulletEl = bulletEl[`${position === "prev" ? "previous" : "next"}ElementSibling`];
        if (bulletEl) {
            bulletEl.classList.add(`${bulletActiveClass}-${position}`);
            bulletEl = bulletEl[`${position === "prev" ? "previous" : "next"}ElementSibling`];
            if (bulletEl) bulletEl.classList.add(`${bulletActiveClass}-${position}-${position}`);
        }
    }
    function onBulletClick(e) {
        const bulletEl = e.target.closest((0, $b38557946c7d8a27$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass));
        if (!bulletEl) return;
        e.preventDefault();
        const index = (0, $2a089bf12e68a35c$export$dda1d9f60106f0e9)(bulletEl) * swiper.params.slidesPerGroup;
        if (swiper.params.loop) {
            if (swiper.realIndex === index) return;
            swiper.slideToLoop(index);
        } else swiper.slideTo(index);
    }
    function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        el = (0, $2a089bf12e68a35c$export$953cecd6e717a553)(el);
        // Current/Total
        let current;
        let previousIndex;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const total = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            previousIndex = swiper.previousRealIndex || 0;
            current = swiper.params.slidesPerGroup > 1 ? Math.floor(swiper.realIndex / swiper.params.slidesPerGroup) : swiper.realIndex;
        } else if (typeof swiper.snapIndex !== "undefined") {
            current = swiper.snapIndex;
            previousIndex = swiper.previousSnapIndex;
        } else {
            previousIndex = swiper.previousIndex || 0;
            current = swiper.activeIndex || 0;
        }
        // Types
        if (params.type === "bullets" && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            const bullets = swiper.pagination.bullets;
            let firstIndex;
            let lastIndex;
            let midIndex;
            if (params.dynamicBullets) {
                bulletSize = (0, $2a089bf12e68a35c$export$2d1720544b23b823)(bullets[0], swiper.isHorizontal() ? "width" : "height", true);
                el.forEach((subEl)=>{
                    subEl.style[swiper.isHorizontal() ? "width" : "height"] = `${bulletSize * (params.dynamicMainBullets + 4)}px`;
                });
                if (params.dynamicMainBullets > 1 && previousIndex !== undefined) {
                    dynamicBulletIndex += current - (previousIndex || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.forEach((bulletEl)=>{
                const classesToRemove = [
                    ...[
                        "",
                        "-next",
                        "-next-next",
                        "-prev",
                        "-prev-prev",
                        "-main"
                    ].map((suffix)=>`${params.bulletActiveClass}${suffix}`)
                ].map((s)=>typeof s === "string" && s.includes(" ") ? s.split(" ") : s).flat();
                bulletEl.classList.remove(...classesToRemove);
            });
            if (el.length > 1) bullets.forEach((bullet)=>{
                const bulletIndex = (0, $2a089bf12e68a35c$export$dda1d9f60106f0e9)(bullet);
                if (bulletIndex === current) bullet.classList.add(...params.bulletActiveClass.split(" "));
                else if (swiper.isElement) bullet.setAttribute("part", "bullet");
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) bullet.classList.add(...`${params.bulletActiveClass}-main`.split(" "));
                    if (bulletIndex === firstIndex) setSideBullets(bullet, "prev");
                    if (bulletIndex === lastIndex) setSideBullets(bullet, "next");
                }
            });
            else {
                const bullet = bullets[current];
                if (bullet) bullet.classList.add(...params.bulletActiveClass.split(" "));
                if (swiper.isElement) bullets.forEach((bulletEl, bulletIndex)=>{
                    bulletEl.setAttribute("part", bulletIndex === current ? "bullet-active" : "bullet");
                });
                if (params.dynamicBullets) {
                    const firstDisplayedBullet = bullets[firstIndex];
                    const lastDisplayedBullet = bullets[lastIndex];
                    for(let i = firstIndex; i <= lastIndex; i += 1)if (bullets[i]) bullets[i].classList.add(...`${params.bulletActiveClass}-main`.split(" "));
                    setSideBullets(firstDisplayedBullet, "prev");
                    setSideBullets(lastDisplayedBullet, "next");
                }
            }
            if (params.dynamicBullets) {
                const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                const offsetProp = rtl ? "right" : "left";
                bullets.forEach((bullet)=>{
                    bullet.style[swiper.isHorizontal() ? offsetProp : "top"] = `${bulletsOffset}px`;
                });
            }
        }
        el.forEach((subEl, subElIndex)=>{
            if (params.type === "fraction") {
                subEl.querySelectorAll((0, $b38557946c7d8a27$export$db3b6bfb95261072)(params.currentClass)).forEach((fractionEl)=>{
                    fractionEl.textContent = params.formatFractionCurrent(current + 1);
                });
                subEl.querySelectorAll((0, $b38557946c7d8a27$export$db3b6bfb95261072)(params.totalClass)).forEach((totalEl)=>{
                    totalEl.textContent = params.formatFractionTotal(total);
                });
            }
            if (params.type === "progressbar") {
                let progressbarDirection;
                if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? "vertical" : "horizontal";
                else progressbarDirection = swiper.isHorizontal() ? "horizontal" : "vertical";
                const scale = (current + 1) / total;
                let scaleX = 1;
                let scaleY = 1;
                if (progressbarDirection === "horizontal") scaleX = scale;
                else scaleY = scale;
                subEl.querySelectorAll((0, $b38557946c7d8a27$export$db3b6bfb95261072)(params.progressbarFillClass)).forEach((progressEl)=>{
                    progressEl.style.transform = `translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`;
                    progressEl.style.transitionDuration = `${swiper.params.speed}ms`;
                });
            }
            if (params.type === "custom" && params.renderCustom) {
                subEl.innerHTML = params.renderCustom(swiper, current + 1, total);
                if (subElIndex === 0) emit("paginationRender", subEl);
            } else {
                if (subElIndex === 0) emit("paginationRender", subEl);
                emit("paginationUpdate", subEl);
            }
            if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? "add" : "remove"](params.lockClass);
        });
    }
    function render() {
        // Render Container
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.grid && swiper.params.grid.rows > 1 ? swiper.slides.length / Math.ceil(swiper.params.grid.rows) : swiper.slides.length;
        let el = swiper.pagination.el;
        el = (0, $2a089bf12e68a35c$export$953cecd6e717a553)(el);
        let paginationHTML = "";
        if (params.type === "bullets") {
            let numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(let i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else // prettier-ignore
            paginationHTML += `<${params.bulletElement} ${swiper.isElement ? 'part="bullet"' : ""} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
        if (params.type === "fraction") {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = `<span class="${params.currentClass}"></span>` + " / " + `<span class="${params.totalClass}"></span>`;
        }
        if (params.type === "progressbar") {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
        }
        swiper.pagination.bullets = [];
        el.forEach((subEl)=>{
            if (params.type !== "custom") subEl.innerHTML = paginationHTML || "";
            if (params.type === "bullets") swiper.pagination.bullets.push(...subEl.querySelectorAll((0, $b38557946c7d8a27$export$db3b6bfb95261072)(params.bulletClass)));
        });
        if (params.type !== "custom") emit("paginationRender", el[0]);
    }
    function init() {
        swiper.params.pagination = (0, $1e1ada34a0c8bf7a$export$db3b6bfb95261072)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: "swiper-pagination"
        });
        const params = swiper.params.pagination;
        if (!params.el) return;
        let el;
        if (typeof params.el === "string" && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === "string") el = [
            ...document.querySelectorAll(params.el)
        ];
        if (!el) el = params.el;
        if (!el || el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && Array.isArray(el) && el.length > 1) {
            el = [
                ...swiper.el.querySelectorAll(params.el)
            ];
            // check if it belongs to another nested Swiper
            if (el.length > 1) el = el.filter((subEl)=>{
                if ((0, $2a089bf12e68a35c$export$407448d2b89b1813)(subEl, ".swiper")[0] !== swiper.el) return false;
                return true;
            })[0];
        }
        if (Array.isArray(el) && el.length === 1) el = el[0];
        Object.assign(swiper.pagination, {
            el: el
        });
        el = (0, $2a089bf12e68a35c$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            if (params.type === "bullets" && params.clickable) subEl.classList.add(...(params.clickableClass || "").split(" "));
            subEl.classList.add(params.modifierClass + params.type);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
            if (params.type === "bullets" && params.dynamicBullets) {
                subEl.classList.add(`${params.modifierClass}${params.type}-dynamic`);
                dynamicBulletIndex = 0;
                if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
            }
            if (params.type === "progressbar" && params.progressbarOpposite) subEl.classList.add(params.progressbarOppositeClass);
            if (params.clickable) subEl.addEventListener("click", onBulletClick);
            if (!swiper.enabled) subEl.classList.add(params.lockClass);
        });
    }
    function destroy() {
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        if (el) {
            el = (0, $2a089bf12e68a35c$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>{
                subEl.classList.remove(params.hiddenClass);
                subEl.classList.remove(params.modifierClass + params.type);
                subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
                if (params.clickable) {
                    subEl.classList.remove(...(params.clickableClass || "").split(" "));
                    subEl.removeEventListener("click", onBulletClick);
                }
            });
        }
        if (swiper.pagination.bullets) swiper.pagination.bullets.forEach((subEl)=>subEl.classList.remove(...params.bulletActiveClass.split(" ")));
    }
    on("changeDirection", ()=>{
        if (!swiper.pagination || !swiper.pagination.el) return;
        const params = swiper.params.pagination;
        let { el: el } = swiper.pagination;
        el = (0, $2a089bf12e68a35c$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on("init", ()=>{
        if (swiper.params.pagination.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            render();
            update();
        }
    });
    on("activeIndexChange", ()=>{
        if (typeof swiper.snapIndex === "undefined") update();
    });
    on("snapIndexChange", ()=>{
        update();
    });
    on("snapGridLengthChange", ()=>{
        render();
        update();
    });
    on("destroy", ()=>{
        destroy();
    });
    on("enable disable", ()=>{
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $2a089bf12e68a35c$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList[swiper.enabled ? "remove" : "add"](swiper.params.pagination.lockClass));
        }
    });
    on("lock unlock", ()=>{
        update();
    });
    on("click", (_s, e)=>{
        const targetEl = e.target;
        const el = (0, $2a089bf12e68a35c$export$953cecd6e717a553)(swiper.pagination.el);
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && el && el.length > 0 && !targetEl.classList.contains(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            const isHidden = el[0].classList.contains(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit("paginationShow");
            else emit("paginationHide");
            el.forEach((subEl)=>subEl.classList.toggle(swiper.params.pagination.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(swiper.params.pagination.paginationDisabledClass);
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $2a089bf12e68a35c$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList.remove(swiper.params.pagination.paginationDisabledClass));
        }
        init();
        render();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(swiper.params.pagination.paginationDisabledClass);
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $2a089bf12e68a35c$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList.add(swiper.params.pagination.paginationDisabledClass));
        }
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable: enable,
        disable: disable,
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
}






function $993c6fe6a8dc81c4$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const document = (0, $d0093adbb79ad712$export$39b482c5e57630a8)();
    let isTouched = false;
    let timeout = null;
    let dragTimeout = null;
    let dragStartPos;
    let dragSize;
    let trackSize;
    let divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: "auto",
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: "swiper-scrollbar-lock",
            dragClass: "swiper-scrollbar-drag",
            scrollbarDisabledClass: "swiper-scrollbar-disabled",
            horizontalClass: `swiper-scrollbar-horizontal`,
            verticalClass: `swiper-scrollbar-vertical`
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null
    };
    function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        const params = swiper.params.scrollbar;
        const progress = swiper.params.loop ? swiper.progressLoop : swiper.progress;
        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            dragEl.style.transform = `translate3d(${newPos}px, 0, 0)`;
            dragEl.style.width = `${newSize}px`;
        } else {
            dragEl.style.transform = `translate3d(0px, ${newPos}px, 0)`;
            dragEl.style.height = `${newSize}px`;
        }
        if (params.hide) {
            clearTimeout(timeout);
            el.style.opacity = 1;
            timeout = setTimeout(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = "400ms";
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.dragEl.style.transitionDuration = `${duration}ms`;
    }
    function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        dragEl.style.width = "";
        dragEl.style.height = "";
        trackSize = swiper.isHorizontal() ? el.offsetWidth : el.offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === "auto") dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) dragEl.style.width = `${dragSize}px`;
        else dragEl.style.height = `${dragSize}px`;
        if (divider >= 1) el.style.display = "none";
        else el.style.display = "";
        if (swiper.params.scrollbar.hide) el.style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.el.classList[swiper.isLocked ? "add" : "remove"](swiper.params.scrollbar.lockClass);
    }
    function getPointerPosition(e) {
        return swiper.isHorizontal() ? e.clientX : e.clientY;
    }
    function setDragPosition(e) {
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { el: el } = scrollbar;
        let positionRatio;
        positionRatio = (getPointerPosition(e) - (0, $2a089bf12e68a35c$export$8b22cf2602fb60ce)(el)[swiper.isHorizontal() ? "left" : "top"] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        isTouched = true;
        dragStartPos = e.target === dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? "left" : "top"] : null;
        e.preventDefault();
        e.stopPropagation();
        wrapperEl.style.transitionDuration = "100ms";
        dragEl.style.transitionDuration = "100ms";
        setDragPosition(e);
        clearTimeout(dragTimeout);
        el.style.transitionDuration = "0ms";
        if (params.hide) el.style.opacity = 1;
        if (swiper.params.cssMode) swiper.wrapperEl.style["scroll-snap-type"] = "none";
        emit("scrollbarDragStart", e);
    }
    function onDragMove(e) {
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        if (!isTouched) return;
        if (e.preventDefault && e.cancelable) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        wrapperEl.style.transitionDuration = "0ms";
        el.style.transitionDuration = "0ms";
        dragEl.style.transitionDuration = "0ms";
        emit("scrollbarDragMove", e);
    }
    function onDragEnd(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el } = scrollbar;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style["scroll-snap-type"] = "";
            wrapperEl.style.transitionDuration = "";
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, $2a089bf12e68a35c$export$7ccc53e8f1e7dfc5)(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = "400ms";
            }, 1000);
        }
        emit("scrollbarDragEnd", e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        const { scrollbar: scrollbar, params: params } = swiper;
        const el = scrollbar.el;
        if (!el) return;
        const target = el;
        const activeListener = params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        const passiveListener = params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        const eventMethod = method === "on" ? "addEventListener" : "removeEventListener";
        target[eventMethod]("pointerdown", onDragStart, activeListener);
        document[eventMethod]("pointermove", onDragMove, activeListener);
        document[eventMethod]("pointerup", onDragEnd, passiveListener);
    }
    function enableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events("on");
    }
    function disableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events("off");
    }
    function init() {
        const { scrollbar: scrollbar, el: swiperEl } = swiper;
        swiper.params.scrollbar = (0, $1e1ada34a0c8bf7a$export$db3b6bfb95261072)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: "swiper-scrollbar"
        });
        const params = swiper.params.scrollbar;
        if (!params.el) return;
        let el;
        if (typeof params.el === "string" && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === "string") {
            el = document.querySelectorAll(params.el);
            if (!el.length) return;
        } else if (!el) el = params.el;
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && el.length > 1 && swiperEl.querySelectorAll(params.el).length === 1) el = swiperEl.querySelector(params.el);
        if (el.length > 0) el = el[0];
        el.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        let dragEl;
        if (el) {
            dragEl = el.querySelector((0, $b38557946c7d8a27$export$db3b6bfb95261072)(swiper.params.scrollbar.dragClass));
            if (!dragEl) {
                dragEl = (0, $2a089bf12e68a35c$export$db3b6bfb95261072)("div", swiper.params.scrollbar.dragClass);
                el.append(dragEl);
            }
        }
        Object.assign(scrollbar, {
            el: el,
            dragEl: dragEl
        });
        if (params.draggable) enableDraggable();
        if (el) el.classList[swiper.enabled ? "remove" : "add"](...(0, $2a089bf12e68a35c$export$23f2a1d2818174ef)(swiper.params.scrollbar.lockClass));
    }
    function destroy() {
        const params = swiper.params.scrollbar;
        const el = swiper.scrollbar.el;
        if (el) el.classList.remove(...(0, $2a089bf12e68a35c$export$23f2a1d2818174ef)(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass));
        disableDraggable();
    }
    on("changeDirection", ()=>{
        if (!swiper.scrollbar || !swiper.scrollbar.el) return;
        const params = swiper.params.scrollbar;
        let { el: el } = swiper.scrollbar;
        el = (0, $2a089bf12e68a35c$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on("init", ()=>{
        if (swiper.params.scrollbar.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on("update resize observerUpdate lock unlock changeDirection", ()=>{
        updateSize();
    });
    on("setTranslate", ()=>{
        setTranslate();
    });
    on("setTransition", (_s, duration)=>{
        setTransition(duration);
    });
    on("enable disable", ()=>{
        const { el: el } = swiper.scrollbar;
        if (el) el.classList[swiper.enabled ? "remove" : "add"](...(0, $2a089bf12e68a35c$export$23f2a1d2818174ef)(swiper.params.scrollbar.lockClass));
    });
    on("destroy", ()=>{
        destroy();
    });
    const enable = ()=>{
        swiper.el.classList.remove(...(0, $2a089bf12e68a35c$export$23f2a1d2818174ef)(swiper.params.scrollbar.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.remove(...(0, $2a089bf12e68a35c$export$23f2a1d2818174ef)(swiper.params.scrollbar.scrollbarDisabledClass));
        init();
        updateSize();
        setTranslate();
    };
    const disable = ()=>{
        swiper.el.classList.add(...(0, $2a089bf12e68a35c$export$23f2a1d2818174ef)(swiper.params.scrollbar.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.add(...(0, $2a089bf12e68a35c$export$23f2a1d2818174ef)(swiper.params.scrollbar.scrollbarDisabledClass));
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable: enable,
        disable: disable,
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
}



function $f8cf52e5e61c63f8$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        parallax: {
            enabled: false
        }
    });
    const elementsSelector = "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]";
    const setTransform = (el, progress)=>{
        const { rtl: rtl } = swiper;
        const rtlFactor = rtl ? -1 : 1;
        const p = el.getAttribute("data-swiper-parallax") || "0";
        let x = el.getAttribute("data-swiper-parallax-x");
        let y = el.getAttribute("data-swiper-parallax-y");
        const scale = el.getAttribute("data-swiper-parallax-scale");
        const opacity = el.getAttribute("data-swiper-parallax-opacity");
        const rotate = el.getAttribute("data-swiper-parallax-rotate");
        if (x || y) {
            x = x || "0";
            y = y || "0";
        } else if (swiper.isHorizontal()) {
            x = p;
            y = "0";
        } else {
            y = p;
            x = "0";
        }
        if (x.indexOf("%") >= 0) x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        else x = `${x * progress * rtlFactor}px`;
        if (y.indexOf("%") >= 0) y = `${parseInt(y, 10) * progress}%`;
        else y = `${y * progress}px`;
        if (typeof opacity !== "undefined" && opacity !== null) {
            const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            el.style.opacity = currentOpacity;
        }
        let transform = `translate3d(${x}, ${y}, 0px)`;
        if (typeof scale !== "undefined" && scale !== null) {
            const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            transform += ` scale(${currentScale})`;
        }
        if (rotate && typeof rotate !== "undefined" && rotate !== null) {
            const currentRotate = rotate * progress * -1;
            transform += ` rotate(${currentRotate}deg)`;
        }
        el.style.transform = transform;
    };
    const setTranslate = ()=>{
        const { el: el, slides: slides, progress: progress, snapGrid: snapGrid, isElement: isElement } = swiper;
        const elements = (0, $2a089bf12e68a35c$export$f1e1789686576879)(el, elementsSelector);
        if (swiper.isElement) elements.push(...(0, $2a089bf12e68a35c$export$f1e1789686576879)(swiper.hostEl, elementsSelector));
        elements.forEach((subEl)=>{
            setTransform(subEl, progress);
        });
        slides.forEach((slideEl, slideIndex)=>{
            let slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== "auto") slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            slideEl.querySelectorAll(`${elementsSelector}, [data-swiper-parallax-rotate]`).forEach((subEl)=>{
                setTransform(subEl, slideProgress);
            });
        });
    };
    const setTransition = function(duration) {
        if (duration === void 0) duration = swiper.params.speed;
        const { el: el, hostEl: hostEl } = swiper;
        const elements = [
            ...el.querySelectorAll(elementsSelector)
        ];
        if (swiper.isElement) elements.push(...hostEl.querySelectorAll(elementsSelector));
        elements.forEach((parallaxEl)=>{
            let parallaxDuration = parseInt(parallaxEl.getAttribute("data-swiper-parallax-duration"), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            parallaxEl.style.transitionDuration = `${parallaxDuration}ms`;
        });
    };
    on("beforeInit", ()=>{
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on("init", ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on("setTranslate", ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on("setTransition", (_swiper, duration)=>{
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}




function $214f596eaaac294c$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const window = (0, $d0093adbb79ad712$export$407448d2b89b1813)();
    extendParams({
        zoom: {
            enabled: false,
            limitToOriginalSize: false,
            maxRatio: 3,
            minRatio: 1,
            toggle: true,
            containerClass: "swiper-zoom-container",
            zoomedSlideClass: "swiper-slide-zoomed"
        }
    });
    swiper.zoom = {
        enabled: false
    };
    let currentScale = 1;
    let isScaling = false;
    let fakeGestureTouched;
    let fakeGestureMoved;
    const evCache = [];
    const gesture = {
        originX: 0,
        originY: 0,
        slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        imageEl: undefined,
        imageWrapEl: undefined,
        maxRatio: 3
    };
    const image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    const velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    let scale = 1;
    Object.defineProperty(swiper.zoom, "scale", {
        get () {
            return scale;
        },
        set (value) {
            if (scale !== value) {
                const imageEl = gesture.imageEl;
                const slideEl = gesture.slideEl;
                emit("zoomChange", value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches() {
        if (evCache.length < 2) return 1;
        const x1 = evCache[0].pageX;
        const y1 = evCache[0].pageY;
        const x2 = evCache[1].pageX;
        const y2 = evCache[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
    }
    function getMaxRatio() {
        const params = swiper.params.zoom;
        const maxRatio = gesture.imageWrapEl.getAttribute("data-swiper-zoom") || params.maxRatio;
        if (params.limitToOriginalSize && gesture.imageEl && gesture.imageEl.naturalWidth) {
            const imageMaxRatio = gesture.imageEl.naturalWidth / gesture.imageEl.offsetWidth;
            return Math.min(imageMaxRatio, maxRatio);
        }
        return maxRatio;
    }
    function getScaleOrigin() {
        if (evCache.length < 2) return {
            x: null,
            y: null
        };
        const box = gesture.imageEl.getBoundingClientRect();
        return [
            (evCache[0].pageX + (evCache[1].pageX - evCache[0].pageX) / 2 - box.x - window.scrollX) / currentScale,
            (evCache[0].pageY + (evCache[1].pageY - evCache[0].pageY) / 2 - box.y - window.scrollY) / currentScale
        ];
    }
    function getSlideSelector() {
        return swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    }
    function eventWithinSlide(e) {
        const slideSelector = getSlideSelector();
        if (e.target.matches(slideSelector)) return true;
        if (swiper.slides.filter((slideEl)=>slideEl.contains(e.target)).length > 0) return true;
        return false;
    }
    function eventWithinZoomContainer(e) {
        const selector = `.${swiper.params.zoom.containerClass}`;
        if (e.target.matches(selector)) return true;
        if ([
            ...swiper.hostEl.querySelectorAll(selector)
        ].filter((containerEl)=>containerEl.contains(e.target)).length > 0) return true;
        return false;
    }
    // Events
    function onGestureStart(e) {
        if (e.pointerType === "mouse") evCache.splice(0, evCache.length);
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        evCache.push(e);
        if (evCache.length < 2) return;
        fakeGestureTouched = true;
        gesture.scaleStart = getDistanceBetweenTouches();
        if (!gesture.slideEl) {
            gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $2a089bf12e68a35c$export$407448d2b89b1813)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
            if (!gesture.imageWrapEl) {
                gesture.imageEl = undefined;
                return;
            }
            gesture.maxRatio = getMaxRatio();
        }
        if (gesture.imageEl) {
            const [originX, originY] = getScaleOrigin();
            gesture.originX = originX;
            gesture.originY = originY;
            gesture.imageEl.style.transitionDuration = "0ms";
        }
        isScaling = true;
    }
    function onGestureChange(e) {
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache[pointerIndex] = e;
        if (evCache.length < 2) return;
        fakeGestureMoved = true;
        gesture.scaleMove = getDistanceBetweenTouches();
        if (!gesture.imageEl) return;
        zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function onGestureEnd(e) {
        if (!eventWithinSlide(e)) return;
        if (e.pointerType === "mouse" && e.type === "pointerout") return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache.splice(pointerIndex, 1);
        if (!fakeGestureTouched || !fakeGestureMoved) return;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!gesture.imageEl) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.imageEl.style.transitionDuration = `${swiper.params.speed}ms`;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale > 1 && gesture.slideEl) gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        else if (zoom.scale <= 1 && gesture.slideEl) gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        if (zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
            gesture.slideEl = undefined;
        }
    }
    let allowTouchMoveTimeout;
    function allowTouchMove() {
        swiper.touchEventsData.preventTouchMoveFromPointerMove = false;
    }
    function preventTouchMove() {
        clearTimeout(allowTouchMoveTimeout);
        swiper.touchEventsData.preventTouchMoveFromPointerMove = true;
        allowTouchMoveTimeout = setTimeout(()=>{
            allowTouchMove();
        });
    }
    function onTouchStart(e) {
        const device = swiper.device;
        if (!gesture.imageEl) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        const event = evCache.length > 0 ? evCache[0] : e;
        image.touchesStart.x = event.pageX;
        image.touchesStart.y = event.pageY;
    }
    function onTouchMove(e) {
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        const zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !gesture.slideEl) return;
        if (!image.isMoved) {
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            image.startX = (0, $2a089bf12e68a35c$export$35e795649ee09318)(gesture.imageWrapEl, "x") || 0;
            image.startY = (0, $2a089bf12e68a35c$export$35e795649ee09318)(gesture.imageWrapEl, "y") || 0;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            gesture.imageWrapEl.style.transitionDuration = "0ms";
        }
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = evCache.length > 0 ? evCache[0].pageX : e.pageX;
        image.touchesCurrent.y = evCache.length > 0 ? evCache[0].pageY : e.pageY;
        const touchesDiff = Math.max(Math.abs(image.touchesCurrent.x - image.touchesStart.x), Math.abs(image.touchesCurrent.y - image.touchesStart.y));
        if (touchesDiff > 5) swiper.allowClick = false;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        preventTouchMove();
        image.isMoved = true;
        const scaleRatio = (zoom.scale - currentScale) / (gesture.maxRatio - swiper.params.zoom.minRatio);
        const { originX: originX, originY: originY } = gesture;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX + scaleRatio * (image.width - originX * 2);
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY + scaleRatio * (image.height - originY * 2);
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
        // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTouchEnd() {
        const zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const momentumDistanceX = velocity.x * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocity.y * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY;
        // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY;
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.imageWrapEl.style.transitionDuration = `${momentumDuration}ms`;
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTransitionEnd() {
        const zoom = swiper.zoom;
        if (gesture.slideEl && swiper.activeIndex !== swiper.slides.indexOf(gesture.slideEl)) {
            if (gesture.imageEl) gesture.imageEl.style.transform = "translate3d(0,0,0) scale(1)";
            if (gesture.imageWrapEl) gesture.imageWrapEl.style.transform = "translate3d(0,0,0)";
            gesture.slideEl.classList.remove(`${swiper.params.zoom.zoomedSlideClass}`);
            zoom.scale = 1;
            currentScale = 1;
            gesture.slideEl = undefined;
            gesture.imageEl = undefined;
            gesture.imageWrapEl = undefined;
            gesture.originX = 0;
            gesture.originY = 0;
        }
    }
    function zoomIn(e) {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (e && e.target) gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $2a089bf12e68a35c$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
                else gesture.slideEl = swiper.slides[swiper.activeIndex];
            }
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $2a089bf12e68a35c$export$407448d2b89b1813)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.touchAction = "none";
        }
        gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;
        if (typeof image.touchesStart.x === "undefined" && e) {
            touchX = e.pageX;
            touchY = e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        const forceZoomRatio = typeof e === "number" ? e : null;
        if (currentScale === 1 && forceZoomRatio) {
            touchX = undefined;
            touchY = undefined;
        }
        const maxRatio = getMaxRatio();
        zoom.scale = forceZoomRatio || maxRatio;
        currentScale = forceZoomRatio || maxRatio;
        if (e && !(currentScale === 1 && forceZoomRatio)) {
            slideWidth = gesture.slideEl.offsetWidth;
            slideHeight = gesture.slideEl.offsetHeight;
            offsetX = (0, $2a089bf12e68a35c$export$8b22cf2602fb60ce)(gesture.slideEl).left + window.scrollX;
            offsetY = (0, $2a089bf12e68a35c$export$8b22cf2602fb60ce)(gesture.slideEl).top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            imageHeight = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            translateX = diffX * zoom.scale;
            translateY = diffY * zoom.scale;
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        if (forceZoomRatio && zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
        }
        gesture.imageWrapEl.style.transitionDuration = "300ms";
        gesture.imageWrapEl.style.transform = `translate3d(${translateX}px, ${translateY}px,0)`;
        gesture.imageEl.style.transitionDuration = "300ms";
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function zoomOut() {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $2a089bf12e68a35c$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
            else gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $2a089bf12e68a35c$export$407448d2b89b1813)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = "";
            swiper.wrapperEl.style.touchAction = "";
        }
        zoom.scale = 1;
        currentScale = 1;
        gesture.imageWrapEl.style.transitionDuration = "300ms";
        gesture.imageWrapEl.style.transform = "translate3d(0,0,0)";
        gesture.imageEl.style.transitionDuration = "300ms";
        gesture.imageEl.style.transform = "translate3d(0,0,0) scale(1)";
        gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        gesture.slideEl = undefined;
        gesture.originX = 0;
        gesture.originY = 0;
    }
    // Toggle Zoom
    function zoomToggle(e) {
        const zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        const passiveListener = swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const activeListenerWithCapture = swiper.params.passiveListeners ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    // Attach/Detach Events
    function enable() {
        const zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.addEventListener("pointerdown", onGestureStart, passiveListener);
        swiper.wrapperEl.addEventListener("pointermove", onGestureChange, activeListenerWithCapture);
        [
            "pointerup",
            "pointercancel",
            "pointerout"
        ].forEach((eventName)=>{
            swiper.wrapperEl.addEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.addEventListener("pointermove", onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        const zoom = swiper.zoom;
        if (!zoom.enabled) return;
        zoom.enabled = false;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.removeEventListener("pointerdown", onGestureStart, passiveListener);
        swiper.wrapperEl.removeEventListener("pointermove", onGestureChange, activeListenerWithCapture);
        [
            "pointerup",
            "pointercancel",
            "pointerout"
        ].forEach((eventName)=>{
            swiper.wrapperEl.removeEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.removeEventListener("pointermove", onTouchMove, activeListenerWithCapture);
    }
    on("init", ()=>{
        if (swiper.params.zoom.enabled) enable();
    });
    on("destroy", ()=>{
        disable();
    });
    on("touchStart", (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on("touchEnd", (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchEnd();
    });
    on("doubleTap", (_s, e)=>{
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on("transitionEnd", ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on("slideChange", ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}



/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ function $281a36194fc2eddc$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: "slide" // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function LinearSpline(x, y) {
        const binarySearch = function search() {
            let maxIndex;
            let minIndex;
            let guess;
            return (array, val)=>{
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1;
        // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        let i1;
        let i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0;
            // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1;
            // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    }
    function getInterpolateFunction(c) {
        swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        const Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            if (c.destroyed) return;
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === "slide") {
                getInterpolateFunction(c);
                // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === "container") {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                if (Number.isNaN(multiplier) || !Number.isFinite(multiplier)) multiplier = 1;
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(let i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        const Swiper = swiper.constructor;
        const controlled = swiper.controller.control;
        let i;
        function setControlledTransition(c) {
            if (c.destroyed) return;
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $2a089bf12e68a35c$export$7ccc53e8f1e7dfc5)(()=>{
                    c.updateAutoHeight();
                });
                (0, $2a089bf12e68a35c$export$342063e11d6c3cad)(c.wrapperEl, ()=>{
                    if (!controlled) return;
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on("beforeInit", ()=>{
        if (typeof window !== "undefined" && // eslint-disable-line
        (typeof swiper.params.controller.control === "string" || swiper.params.controller.control instanceof HTMLElement)) {
            const controlElements = typeof swiper.params.controller.control === "string" ? [
                ...document.querySelectorAll(swiper.params.controller.control)
            ] : [
                swiper.params.controller.control
            ];
            controlElements.forEach((controlElement)=>{
                if (!swiper.controller.control) swiper.controller.control = [];
                if (controlElement && controlElement.swiper) swiper.controller.control.push(controlElement.swiper);
                else if (controlElement) {
                    const eventName = `${swiper.params.eventsPrefix}init`;
                    const onControllerSwiper = (e)=>{
                        swiper.controller.control.push(e.detail[0]);
                        swiper.update();
                        controlElement.removeEventListener(eventName, onControllerSwiper);
                    };
                    controlElement.addEventListener(eventName, onControllerSwiper);
                }
            });
            return;
        }
        swiper.controller.control = swiper.params.controller.control;
    });
    on("update", ()=>{
        removeSpline();
    });
    on("resize", ()=>{
        removeSpline();
    });
    on("observerUpdate", ()=>{
        removeSpline();
    });
    on("setTranslate", (_s, translate, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on("setTransition", (_s, duration, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
}





function $567819daaf3e8114$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: "swiper-notification",
            prevSlideMessage: "Previous slide",
            nextSlideMessage: "Next slide",
            firstSlideMessage: "This is the first slide",
            lastSlideMessage: "This is the last slide",
            paginationBulletMessage: "Go to slide {{index}}",
            slideLabelMessage: "{{index}} / {{slidesLength}}",
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            itemRoleDescriptionMessage: null,
            slideRole: "group",
            id: null,
            scrollOnFocus: true
        }
    });
    swiper.a11y = {
        clicked: false
    };
    let liveRegion = null;
    let preventFocusHandler;
    let focusTargetSlideEl;
    let visibilityChangedTimestamp = new Date().getTime();
    function notify(message) {
        const notification = liveRegion;
        if (notification.length === 0) return;
        notification.innerHTML = "";
        notification.innerHTML = message;
    }
    function getRandomNumber(size) {
        if (size === void 0) size = 16;
        const randomChar = ()=>Math.round(16 * Math.random()).toString(16);
        return "x".repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable(el) {
        el = (0, $2a089bf12e68a35c$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("tabIndex", "0");
        });
    }
    function makeElNotFocusable(el) {
        el = (0, $2a089bf12e68a35c$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("tabIndex", "-1");
        });
    }
    function addElRole(el, role) {
        el = (0, $2a089bf12e68a35c$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("role", role);
        });
    }
    function addElRoleDescription(el, description) {
        el = (0, $2a089bf12e68a35c$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-roledescription", description);
        });
    }
    function addElControls(el, controls) {
        el = (0, $2a089bf12e68a35c$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-controls", controls);
        });
    }
    function addElLabel(el, label) {
        el = (0, $2a089bf12e68a35c$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-label", label);
        });
    }
    function addElId(el, id) {
        el = (0, $2a089bf12e68a35c$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("id", id);
        });
    }
    function addElLive(el, live) {
        el = (0, $2a089bf12e68a35c$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-live", live);
        });
    }
    function disableEl(el) {
        el = (0, $2a089bf12e68a35c$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-disabled", true);
        });
    }
    function enableEl(el) {
        el = (0, $2a089bf12e68a35c$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-disabled", false);
        });
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        const params = swiper.params.a11y;
        const targetEl = e.target;
        if (swiper.pagination && swiper.pagination.el && (targetEl === swiper.pagination.el || swiper.pagination.el.contains(e.target))) {
            if (!e.target.matches((0, $b38557946c7d8a27$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass))) return;
        }
        if (swiper.navigation && swiper.navigation.prevEl && swiper.navigation.nextEl) {
            const prevEls = (0, $2a089bf12e68a35c$export$953cecd6e717a553)(swiper.navigation.prevEl);
            const nextEls = (0, $2a089bf12e68a35c$export$953cecd6e717a553)(swiper.navigation.nextEl);
            if (nextEls.includes(targetEl)) {
                if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
                if (swiper.isEnd) notify(params.lastSlideMessage);
                else notify(params.nextSlideMessage);
            }
            if (prevEls.includes(targetEl)) {
                if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
                if (swiper.isBeginning) notify(params.firstSlideMessage);
                else notify(params.prevSlideMessage);
            }
        }
        if (swiper.pagination && targetEl.matches((0, $b38557946c7d8a27$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass))) targetEl.click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (prevEl) {
            if (swiper.isBeginning) {
                disableEl(prevEl);
                makeElNotFocusable(prevEl);
            } else {
                enableEl(prevEl);
                makeElFocusable(prevEl);
            }
        }
        if (nextEl) {
            if (swiper.isEnd) {
                disableEl(nextEl);
                makeElNotFocusable(nextEl);
            } else {
                enableEl(nextEl);
                makeElFocusable(nextEl);
            }
        }
    }
    function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    }
    function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    }
    function updatePagination() {
        const params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.forEach((bulletEl)=>{
            if (swiper.params.pagination.clickable) {
                makeElFocusable(bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole(bulletEl, "button");
                    addElLabel(bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, (0, $2a089bf12e68a35c$export$dda1d9f60106f0e9)(bulletEl) + 1));
                }
            }
            if (bulletEl.matches((0, $b38557946c7d8a27$export$db3b6bfb95261072)(swiper.params.pagination.bulletActiveClass))) bulletEl.setAttribute("aria-current", "true");
            else bulletEl.removeAttribute("aria-current");
        });
    }
    const initNavEl = (el, wrapperId, message)=>{
        makeElFocusable(el);
        if (el.tagName !== "BUTTON") {
            addElRole(el, "button");
            el.addEventListener("keydown", onEnterOrSpaceKey);
        }
        addElLabel(el, message);
        addElControls(el, wrapperId);
    };
    const handlePointerDown = (e)=>{
        if (focusTargetSlideEl && focusTargetSlideEl !== e.target && !focusTargetSlideEl.contains(e.target)) preventFocusHandler = true;
        swiper.a11y.clicked = true;
    };
    const handlePointerUp = ()=>{
        preventFocusHandler = false;
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    const onVisibilityChange = (e)=>{
        visibilityChangedTimestamp = new Date().getTime();
    };
    const handleFocus = (e)=>{
        if (swiper.a11y.clicked || !swiper.params.a11y.scrollOnFocus) return;
        if (new Date().getTime() - visibilityChangedTimestamp < 100) return;
        const slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        focusTargetSlideEl = slideEl;
        const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
        const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        requestAnimationFrame(()=>{
            if (preventFocusHandler) return;
            if (swiper.params.loop) swiper.slideToLoop(parseInt(slideEl.getAttribute("data-swiper-slide-index")), 0);
            else swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
            preventFocusHandler = false;
        });
    };
    const initSlides = ()=>{
        const params = swiper.params.a11y;
        if (params.itemRoleDescriptionMessage) addElRoleDescription(swiper.slides, params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole(swiper.slides, params.slideRole);
        const slidesLength = swiper.slides.length;
        if (params.slideLabelMessage) swiper.slides.forEach((slideEl, index)=>{
            const slideIndex = swiper.params.loop ? parseInt(slideEl.getAttribute("data-swiper-slide-index"), 10) : index;
            const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel(slideEl, ariaLabelMessage);
        });
    };
    const init = ()=>{
        const params = swiper.params.a11y;
        swiper.el.append(liveRegion);
        // Container
        const containerEl = swiper.el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription(containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel(containerEl, params.containerMessage);
        // Wrapper
        const wrapperEl = swiper.wrapperEl;
        const wrapperId = params.id || wrapperEl.getAttribute("id") || `swiper-wrapper-${getRandomNumber(16)}`;
        const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? "off" : "polite";
        addElId(wrapperEl, wrapperId);
        addElLive(wrapperEl, live);
        // Slide
        initSlides();
        // Navigation
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = (0, $2a089bf12e68a35c$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $2a089bf12e68a35c$export$953cecd6e717a553)(prevEl);
        if (nextEl) nextEl.forEach((el)=>initNavEl(el, wrapperId, params.nextSlideMessage));
        if (prevEl) prevEl.forEach((el)=>initNavEl(el, wrapperId, params.prevSlideMessage));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0, $2a089bf12e68a35c$export$953cecd6e717a553)(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.addEventListener("keydown", onEnterOrSpaceKey);
            });
        }
        // Tab focus
        const document = (0, $d0093adbb79ad712$export$39b482c5e57630a8)();
        document.addEventListener("visibilitychange", onVisibilityChange);
        swiper.el.addEventListener("focus", handleFocus, true);
        swiper.el.addEventListener("focus", handleFocus, true);
        swiper.el.addEventListener("pointerdown", handlePointerDown, true);
        swiper.el.addEventListener("pointerup", handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion) liveRegion.remove();
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = (0, $2a089bf12e68a35c$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $2a089bf12e68a35c$export$953cecd6e717a553)(prevEl);
        if (nextEl) nextEl.forEach((el)=>el.removeEventListener("keydown", onEnterOrSpaceKey));
        if (prevEl) prevEl.forEach((el)=>el.removeEventListener("keydown", onEnterOrSpaceKey));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0, $2a089bf12e68a35c$export$953cecd6e717a553)(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.removeEventListener("keydown", onEnterOrSpaceKey);
            });
        }
        const document = (0, $d0093adbb79ad712$export$39b482c5e57630a8)();
        document.removeEventListener("visibilitychange", onVisibilityChange);
        // Tab focus
        if (swiper.el && typeof swiper.el !== "string") {
            swiper.el.removeEventListener("focus", handleFocus, true);
            swiper.el.removeEventListener("pointerdown", handlePointerDown, true);
            swiper.el.removeEventListener("pointerup", handlePointerUp, true);
        }
    }
    on("beforeInit", ()=>{
        liveRegion = (0, $2a089bf12e68a35c$export$db3b6bfb95261072)("span", swiper.params.a11y.notificationClass);
        liveRegion.setAttribute("aria-live", "assertive");
        liveRegion.setAttribute("aria-atomic", "true");
    });
    on("afterInit", ()=>{
        if (!swiper.params.a11y.enabled) return;
        init();
    });
    on("slidesLengthChange snapGridLengthChange slidesGridLengthChange", ()=>{
        if (!swiper.params.a11y.enabled) return;
        initSlides();
    });
    on("fromEdge toEdge afterInit lock unlock", ()=>{
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on("paginationUpdate", ()=>{
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on("destroy", ()=>{
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}



function $a5e37ae5a1e1228a$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        history: {
            enabled: false,
            root: "",
            replaceState: false,
            key: "slides",
            keepQuery: false
        }
    });
    let initialized = false;
    let paths = {};
    const slugify = (text)=>{
        return text.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
    };
    const getPathValues = (urlOverride)=>{
        const window = (0, $d0093adbb79ad712$export$407448d2b89b1813)();
        let location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        const pathArray = location.pathname.slice(1).split("/").filter((part)=>part !== "");
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    const setHistory = (key, index)=>{
        const window = (0, $d0093adbb79ad712$export$407448d2b89b1813)();
        if (!initialized || !swiper.params.history.enabled) return;
        let location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        const slide = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${index}"]`) : swiper.slides[index];
        let value = slugify(slide.getAttribute("data-history"));
        if (swiper.params.history.root.length > 0) {
            let root = swiper.params.history.root;
            if (root[root.length - 1] === "/") root = root.slice(0, root.length - 1);
            value = `${root}/${key ? `${key}/` : ""}${value}`;
        } else if (!location.pathname.includes(key)) value = `${key ? `${key}/` : ""}${value}`;
        if (swiper.params.history.keepQuery) value += location.search;
        const currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    };
    const scrollToSlide = (speed, value, runCallbacks)=>{
        if (value) for(let i = 0, length = swiper.slides.length; i < length; i += 1){
            const slide = swiper.slides[i];
            const slideHistory = slugify(slide.getAttribute("data-history"));
            if (slideHistory === value) {
                const index = swiper.getSlideIndex(slide);
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    const setHistoryPopState = ()=>{
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    const init = ()=>{
        const window = (0, $d0093adbb79ad712$export$407448d2b89b1813)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) {
            if (!swiper.params.history.replaceState) window.addEventListener("popstate", setHistoryPopState);
            return;
        }
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener("popstate", setHistoryPopState);
    };
    const destroy = ()=>{
        const window = (0, $d0093adbb79ad712$export$407448d2b89b1813)();
        if (!swiper.params.history.replaceState) window.removeEventListener("popstate", setHistoryPopState);
    };
    on("init", ()=>{
        if (swiper.params.history.enabled) init();
    });
    on("destroy", ()=>{
        if (swiper.params.history.enabled) destroy();
    });
    on("transitionEnd _freeModeNoMomentumRelease", ()=>{
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on("slideChange", ()=>{
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}




function $c3ed1217b8736f4f$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, emit: emit, on: on } = _ref;
    let initialized = false;
    const document = (0, $d0093adbb79ad712$export$39b482c5e57630a8)();
    const window = (0, $d0093adbb79ad712$export$407448d2b89b1813)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false,
            getSlideIndex (_s, hash) {
                if (swiper.virtual && swiper.params.virtual.enabled) {
                    const slideWithHash = swiper.slides.filter((slideEl)=>slideEl.getAttribute("data-hash") === hash)[0];
                    if (!slideWithHash) return 0;
                    const index = parseInt(slideWithHash.getAttribute("data-swiper-slide-index"), 10);
                    return index;
                }
                return swiper.getSlideIndex((0, $2a089bf12e68a35c$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideClass}[data-hash="${hash}"], swiper-slide[data-hash="${hash}"]`)[0]);
            }
        }
    });
    const onHashChange = ()=>{
        emit("hashChange");
        const newHash = document.location.hash.replace("#", "");
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute("data-hash") : "";
        if (newHash !== activeSlideHash) {
            const newIndex = swiper.params.hashNavigation.getSlideIndex(swiper, newHash);
            if (typeof newIndex === "undefined" || Number.isNaN(newIndex)) return;
            swiper.slideTo(newIndex);
        }
    };
    const setHash = ()=>{
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute("data-hash") || activeSlideEl.getAttribute("data-history") : "";
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, `#${activeSlideHash}` || "");
            emit("hashSet");
        } else {
            document.location.hash = activeSlideHash || "";
            emit("hashSet");
        }
    };
    const init = ()=>{
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        const hash = document.location.hash.replace("#", "");
        if (hash) {
            const speed = 0;
            const index = swiper.params.hashNavigation.getSlideIndex(swiper, hash);
            swiper.slideTo(index || 0, speed, swiper.params.runCallbacksOnInit, true);
        }
        if (swiper.params.hashNavigation.watchState) window.addEventListener("hashchange", onHashChange);
    };
    const destroy = ()=>{
        if (swiper.params.hashNavigation.watchState) window.removeEventListener("hashchange", onHashChange);
    };
    on("init", ()=>{
        if (swiper.params.hashNavigation.enabled) init();
    });
    on("destroy", ()=>{
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on("transitionEnd _freeModeNoMomentumRelease", ()=>{
        if (initialized) setHash();
    });
    on("slideChange", ()=>{
        if (initialized && swiper.params.cssMode) setHash();
    });
}



/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ function $2379c5c9b1bbe31a$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit, params: params } = _ref;
    swiper.autoplay = {
        running: false,
        paused: false,
        timeLeft: 0
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: false,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    let timeout;
    let raf;
    let autoplayDelayTotal = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayDelayCurrent = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayTimeLeft;
    let autoplayStartTime = new Date().getTime();
    let wasPaused;
    let isTouched;
    let pausedByTouch;
    let touchStartTimeout;
    let slideChanged;
    let pausedByInteraction;
    let pausedByPointerEnter;
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.wrapperEl) return;
        if (e.target !== swiper.wrapperEl) return;
        swiper.wrapperEl.removeEventListener("transitionend", onTransitionEnd);
        if (pausedByPointerEnter || e.detail && e.detail.bySwiperTouchMove) return;
        resume();
    }
    const calcTimeLeft = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.autoplay.paused) wasPaused = true;
        else if (wasPaused) {
            autoplayDelayCurrent = autoplayTimeLeft;
            wasPaused = false;
        }
        const timeLeft = swiper.autoplay.paused ? autoplayTimeLeft : autoplayStartTime + autoplayDelayCurrent - new Date().getTime();
        swiper.autoplay.timeLeft = timeLeft;
        emit("autoplayTimeLeft", timeLeft, timeLeft / autoplayDelayTotal);
        raf = requestAnimationFrame(()=>{
            calcTimeLeft();
        });
    };
    const getSlideDelay = ()=>{
        let activeSlideEl;
        if (swiper.virtual && swiper.params.virtual.enabled) activeSlideEl = swiper.slides.filter((slideEl)=>slideEl.classList.contains("swiper-slide-active"))[0];
        else activeSlideEl = swiper.slides[swiper.activeIndex];
        if (!activeSlideEl) return undefined;
        const currentSlideDelay = parseInt(activeSlideEl.getAttribute("data-swiper-autoplay"), 10);
        return currentSlideDelay;
    };
    const run = (delayForce)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        cancelAnimationFrame(raf);
        calcTimeLeft();
        let delay = typeof delayForce === "undefined" ? swiper.params.autoplay.delay : delayForce;
        autoplayDelayTotal = swiper.params.autoplay.delay;
        autoplayDelayCurrent = swiper.params.autoplay.delay;
        const currentSlideDelay = getSlideDelay();
        if (!Number.isNaN(currentSlideDelay) && currentSlideDelay > 0 && typeof delayForce === "undefined") {
            delay = currentSlideDelay;
            autoplayDelayTotal = currentSlideDelay;
            autoplayDelayCurrent = currentSlideDelay;
        }
        autoplayTimeLeft = delay;
        const speed = swiper.params.speed;
        const proceed = ()=>{
            if (!swiper || swiper.destroyed) return;
            if (swiper.params.autoplay.reverseDirection) {
                if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
                    swiper.slidePrev(speed, true, true);
                    emit("autoplay");
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(swiper.slides.length - 1, speed, true, true);
                    emit("autoplay");
                }
            } else {
                if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
                    swiper.slideNext(speed, true, true);
                    emit("autoplay");
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(0, speed, true, true);
                    emit("autoplay");
                }
            }
            if (swiper.params.cssMode) {
                autoplayStartTime = new Date().getTime();
                requestAnimationFrame(()=>{
                    run();
                });
            }
        };
        if (delay > 0) {
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                proceed();
            }, delay);
        } else requestAnimationFrame(()=>{
            proceed();
        });
        // eslint-disable-next-line
        return delay;
    };
    const start = ()=>{
        autoplayStartTime = new Date().getTime();
        swiper.autoplay.running = true;
        run();
        emit("autoplayStart");
    };
    const stop = ()=>{
        swiper.autoplay.running = false;
        clearTimeout(timeout);
        cancelAnimationFrame(raf);
        emit("autoplayStop");
    };
    const pause = (internal, reset)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        clearTimeout(timeout);
        if (!internal) pausedByInteraction = true;
        const proceed = ()=>{
            emit("autoplayPause");
            if (swiper.params.autoplay.waitForTransition) swiper.wrapperEl.addEventListener("transitionend", onTransitionEnd);
            else resume();
        };
        swiper.autoplay.paused = true;
        if (reset) {
            if (slideChanged) autoplayTimeLeft = swiper.params.autoplay.delay;
            slideChanged = false;
            proceed();
            return;
        }
        const delay = autoplayTimeLeft || swiper.params.autoplay.delay;
        autoplayTimeLeft = delay - (new Date().getTime() - autoplayStartTime);
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) return;
        if (autoplayTimeLeft < 0) autoplayTimeLeft = 0;
        proceed();
    };
    const resume = ()=>{
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop || swiper.destroyed || !swiper.autoplay.running) return;
        autoplayStartTime = new Date().getTime();
        if (pausedByInteraction) {
            pausedByInteraction = false;
            run(autoplayTimeLeft);
        } else run();
        swiper.autoplay.paused = false;
        emit("autoplayResume");
    };
    const onVisibilityChange = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        const document = (0, $d0093adbb79ad712$export$39b482c5e57630a8)();
        if (document.visibilityState === "hidden") {
            pausedByInteraction = true;
            pause(true);
        }
        if (document.visibilityState === "visible") resume();
    };
    const onPointerEnter = (e)=>{
        if (e.pointerType !== "mouse") return;
        pausedByInteraction = true;
        pausedByPointerEnter = true;
        if (swiper.animating || swiper.autoplay.paused) return;
        pause(true);
    };
    const onPointerLeave = (e)=>{
        if (e.pointerType !== "mouse") return;
        pausedByPointerEnter = false;
        if (swiper.autoplay.paused) resume();
    };
    const attachMouseEvents = ()=>{
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.el.addEventListener("pointerenter", onPointerEnter);
            swiper.el.addEventListener("pointerleave", onPointerLeave);
        }
    };
    const detachMouseEvents = ()=>{
        if (swiper.el && typeof swiper.el !== "string") {
            swiper.el.removeEventListener("pointerenter", onPointerEnter);
            swiper.el.removeEventListener("pointerleave", onPointerLeave);
        }
    };
    const attachDocumentEvents = ()=>{
        const document = (0, $d0093adbb79ad712$export$39b482c5e57630a8)();
        document.addEventListener("visibilitychange", onVisibilityChange);
    };
    const detachDocumentEvents = ()=>{
        const document = (0, $d0093adbb79ad712$export$39b482c5e57630a8)();
        document.removeEventListener("visibilitychange", onVisibilityChange);
    };
    on("init", ()=>{
        if (swiper.params.autoplay.enabled) {
            attachMouseEvents();
            attachDocumentEvents();
            start();
        }
    });
    on("destroy", ()=>{
        detachMouseEvents();
        detachDocumentEvents();
        if (swiper.autoplay.running) stop();
    });
    on("_freeModeStaticRelease", ()=>{
        if (pausedByTouch || pausedByInteraction) resume();
    });
    on("_freeModeNoMomentumRelease", ()=>{
        if (!swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on("beforeTransitionStart", (_s, speed, internal)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (internal || !swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on("sliderFirstMove", ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.params.autoplay.disableOnInteraction) {
            stop();
            return;
        }
        isTouched = true;
        pausedByTouch = false;
        pausedByInteraction = false;
        touchStartTimeout = setTimeout(()=>{
            pausedByInteraction = true;
            pausedByTouch = true;
            pause(true);
        }, 200);
    });
    on("touchEnd", ()=>{
        if (swiper.destroyed || !swiper.autoplay.running || !isTouched) return;
        clearTimeout(touchStartTimeout);
        clearTimeout(timeout);
        if (swiper.params.autoplay.disableOnInteraction) {
            pausedByTouch = false;
            isTouched = false;
            return;
        }
        if (pausedByTouch && swiper.params.cssMode) resume();
        pausedByTouch = false;
        isTouched = false;
    });
    on("slideChange", ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        slideChanged = true;
    });
    Object.assign(swiper.autoplay, {
        start: start,
        stop: stop,
        pause: pause,
        resume: resume
    });
}




function $3f5bb98d6513b5fa$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: "swiper-slide-thumb-active",
            thumbsContainerClass: "swiper-thumbs"
        }
    });
    let initialized = false;
    let swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && clickedSlide.classList.contains(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === "undefined" || clickedIndex === null) return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt(thumbsSwiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) swiper.slideToLoop(slideToIndex);
        else swiper.slideTo(slideToIndex);
    }
    function init() {
        const { thumbs: thumbsParams } = swiper.params;
        if (initialized) return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper.update();
        } else if ((0, $2a089bf12e68a35c$export$882b5998b3b9117c)(thumbsParams.swiper)) {
            const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.el.classList.add(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on("tap", onThumbClick);
        return true;
    }
    function update(initial) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const slidesPerView = thumbsSwiper.params.slidesPerView === "auto" ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
        // Activate thumbs
        let thumbsToActivate = 1;
        const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.forEach((slideEl)=>slideEl.classList.remove(thumbActiveClass));
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for(let i = 0; i < thumbsToActivate; i += 1)(0, $2a089bf12e68a35c$export$f1e1789686576879)(thumbsSwiper.slidesEl, `[data-swiper-slide-index="${swiper.realIndex + i}"]`).forEach((slideEl)=>{
            slideEl.classList.add(thumbActiveClass);
        });
        else {
            for(let i = 0; i < thumbsToActivate; i += 1)if (thumbsSwiper.slides[swiper.realIndex + i]) thumbsSwiper.slides[swiper.realIndex + i].classList.add(thumbActiveClass);
        }
        const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            const currentThumbsIndex = thumbsSwiper.activeIndex;
            let newThumbsIndex;
            let direction;
            if (thumbsSwiper.params.loop) {
                const newThumbsSlide = thumbsSwiper.slides.filter((slideEl)=>slideEl.getAttribute("data-swiper-slide-index") === `${swiper.realIndex}`)[0];
                newThumbsIndex = thumbsSwiper.slides.indexOf(newThumbsSlide);
                direction = swiper.activeIndex > swiper.previousIndex ? "next" : "prev";
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? "next" : "prev";
            }
            if (useOffset) newThumbsIndex += direction === "next" ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        }
    }
    on("beforeInit", ()=>{
        const { thumbs: thumbs } = swiper.params;
        if (!thumbs || !thumbs.swiper) return;
        if (typeof thumbs.swiper === "string" || thumbs.swiper instanceof HTMLElement) {
            const document = (0, $d0093adbb79ad712$export$39b482c5e57630a8)();
            const getThumbsElementAndInit = ()=>{
                const thumbsElement = typeof thumbs.swiper === "string" ? document.querySelector(thumbs.swiper) : thumbs.swiper;
                if (thumbsElement && thumbsElement.swiper) {
                    thumbs.swiper = thumbsElement.swiper;
                    init();
                    update(true);
                } else if (thumbsElement) {
                    const eventName = `${swiper.params.eventsPrefix}init`;
                    const onThumbsSwiper = (e)=>{
                        thumbs.swiper = e.detail[0];
                        thumbsElement.removeEventListener(eventName, onThumbsSwiper);
                        init();
                        update(true);
                        thumbs.swiper.update();
                        swiper.update();
                    };
                    thumbsElement.addEventListener(eventName, onThumbsSwiper);
                }
                return thumbsElement;
            };
            const watchForThumbsToAppear = ()=>{
                if (swiper.destroyed) return;
                const thumbsElement = getThumbsElementAndInit();
                if (!thumbsElement) requestAnimationFrame(watchForThumbsToAppear);
            };
            requestAnimationFrame(watchForThumbsToAppear);
        } else {
            init();
            update(true);
        }
    });
    on("slideChange update resize observerUpdate", ()=>{
        update();
    });
    on("setTransition", (_s, duration)=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on("beforeDestroy", ()=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
}



function $1f874d2c0d74f834$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, emit: emit, once: once } = _ref;
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function onTouchStart() {
        if (swiper.params.cssMode) return;
        const translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        if (swiper.params.cssMode) return;
        const { touchEventsData: data, touches: touches } = swiper;
        // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? "startX" : "startY"],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? "currentX" : "currentY"],
            time: (0, $2a089bf12e68a35c$export$4368d992c4eafac0)()
        });
    }
    function onTouchEnd(_ref2) {
        let { currentPos: currentPos } = _ref2;
        if (swiper.params.cssMode) return;
        const { params: params, wrapperEl: wrapperEl, rtlTranslate: rtl, snapGrid: snapGrid, touchEventsData: data } = swiper;
        // Time diff
        const touchEndTime = (0, $2a089bf12e68a35c$export$4368d992c4eafac0)();
        const timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                const lastMoveEvent = data.velocities.pop();
                const velocityEvent = data.velocities.pop();
                const distance = lastMoveEvent.position - velocityEvent.position;
                const time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $2a089bf12e68a35c$export$4368d992c4eafac0)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            let momentumDuration = 1000 * params.freeMode.momentumRatio;
            const momentumDistance = swiper.velocity * momentumDuration;
            let newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            let doBounce = false;
            let afterBouncePosition;
            const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            let needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                let nextSlide;
                for(let j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === "next") newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once("transitionEnd", ()=>{
                swiper.loopFix();
            });
            // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                (0, $2a089bf12e68a35c$export$342063e11d6c3cad)(wrapperEl, ()=>{
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit("momentumBounce");
                    swiper.setTransition(params.speed);
                    setTimeout(()=>{
                        swiper.setTranslate(afterBouncePosition);
                        (0, $2a089bf12e68a35c$export$342063e11d6c3cad)(wrapperEl, ()=>{
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit("_freeModeNoMomentumRelease");
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    (0, $2a089bf12e68a35c$export$342063e11d6c3cad)(wrapperEl, ()=>{
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit("_freeModeNoMomentumRelease");
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            emit("_freeModeStaticRelease");
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    Object.assign(swiper, {
        freeMode: {
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        }
    });
}


function $74753db82ffb3d54$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        grid: {
            rows: 1,
            fill: "column"
        }
    });
    let slidesNumberEvenToRows;
    let slidesPerRow;
    let numFullColumns;
    let wasMultiRow;
    const getSpaceBetween = ()=>{
        let spaceBetween = swiper.params.spaceBetween;
        if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiper.size;
        else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
        return spaceBetween;
    };
    const initSlides = (slides)=>{
        const { slidesPerView: slidesPerView } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== "auto" && fill === "row") slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
        slidesPerRow = slidesNumberEvenToRows / rows;
    };
    const unsetSlides = ()=>{
        if (swiper.slides) swiper.slides.forEach((slide)=>{
            if (slide.swiperSlideGridSet) {
                slide.style.height = "";
                slide.style[swiper.getDirectionLabel("margin-top")] = "";
            }
        });
    };
    const updateSlide = (i, slide, slides)=>{
        const { slidesPerGroup: slidesPerGroup } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows, fill: fill } = swiper.params.grid;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        // Set slides order
        let newSlideOrderIndex;
        let column;
        let row;
        if (fill === "row" && slidesPerGroup > 1) {
            const groupIndex = Math.floor(i / (slidesPerGroup * rows));
            const slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            const columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.style.order = newSlideOrderIndex;
        } else if (fill === "column") {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.row = row;
        slide.column = column;
        slide.style.height = `calc((100% - ${(rows - 1) * spaceBetween}px) / ${rows})`;
        slide.style[swiper.getDirectionLabel("margin-top")] = row !== 0 ? spaceBetween && `${spaceBetween}px` : "";
        slide.swiperSlideGridSet = true;
    };
    const updateWrapperSize = (slideSize, snapGrid)=>{
        const { centeredSlides: centeredSlides, roundLengths: roundLengths } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows } = swiper.params.grid;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        if (!swiper.params.cssMode) swiper.wrapperEl.style[swiper.getDirectionLabel("width")] = `${swiper.virtualSize + spaceBetween}px`;
        if (centeredSlides) {
            const newSlidesGrid = [];
            for(let i = 0; i < snapGrid.length; i += 1){
                let slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.splice(0, snapGrid.length);
            snapGrid.push(...newSlidesGrid);
        }
    };
    const onInit = ()=>{
        wasMultiRow = swiper.params.grid && swiper.params.grid.rows > 1;
    };
    const onUpdate = ()=>{
        const { params: params, el: el } = swiper;
        const isMultiRow = params.grid && params.grid.rows > 1;
        if (wasMultiRow && !isMultiRow) {
            el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
            numFullColumns = 1;
            swiper.emitContainerClasses();
        } else if (!wasMultiRow && isMultiRow) {
            el.classList.add(`${params.containerModifierClass}grid`);
            if (params.grid.fill === "column") el.classList.add(`${params.containerModifierClass}grid-column`);
            swiper.emitContainerClasses();
        }
        wasMultiRow = isMultiRow;
    };
    on("init", onInit);
    on("update", onUpdate);
    swiper.grid = {
        initSlides: initSlides,
        unsetSlides: unsetSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
}


function $8574c5978ce04a89$var$appendSlide(slides) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    const appendElement = (slideEl)=>{
        if (typeof slideEl === "string") {
            const tempDOM = document.createElement("div");
            tempDOM.innerHTML = slideEl;
            slidesEl.append(tempDOM.children[0]);
            tempDOM.innerHTML = "";
        } else slidesEl.append(slideEl);
    };
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) appendElement(slides[i]);
    } else appendElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
}
function $8574c5978ce04a89$var$prependSlide(slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    let newActiveIndex = activeIndex + 1;
    const prependElement = (slideEl)=>{
        if (typeof slideEl === "string") {
            const tempDOM = document.createElement("div");
            tempDOM.innerHTML = slideEl;
            slidesEl.prepend(tempDOM.children[0]);
            tempDOM.innerHTML = "";
        } else slidesEl.prepend(slideEl);
    };
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) prependElement(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else prependElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}
function $8574c5978ce04a89$var$addSlide(index, slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.recalcSlides();
    }
    const baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    const slidesBuffer = [];
    for(let i = baseLength - 1; i >= index; i -= 1){
        const currentSlide = swiper.slides[i];
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) slidesEl.append(slides[i]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else slidesEl.append(slides);
    for(let i = 0; i < slidesBuffer.length; i += 1)slidesEl.append(slidesBuffer[i]);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $8574c5978ce04a89$var$removeSlide(slidesIndexes) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
    }
    let newActiveIndex = activeIndexBuffer;
    let indexToRemove;
    if (typeof slidesIndexes === "object" && "length" in slidesIndexes) {
        for(let i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $8574c5978ce04a89$var$removeAllSlides() {
    const swiper = this;
    const slidesIndexes = [];
    for(let i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}
function $8574c5978ce04a89$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper } = _ref;
    Object.assign(swiper, {
        appendSlide: $8574c5978ce04a89$var$appendSlide.bind(swiper),
        prependSlide: $8574c5978ce04a89$var$prependSlide.bind(swiper),
        addSlide: $8574c5978ce04a89$var$addSlide.bind(swiper),
        removeSlide: $8574c5978ce04a89$var$removeSlide.bind(swiper),
        removeAllSlides: $8574c5978ce04a89$var$removeAllSlides.bind(swiper)
    });
}


function $0cebc2162ca3b983$export$f1e1789686576879(params) {
    const { effect: effect, swiper: swiper, on: on, setTranslate: setTranslate, setTransition: setTransition, overwriteParams: overwriteParams, perspective: perspective, recreateShadows: recreateShadows, getEffectParams: getEffectParams } = params;
    on("beforeInit", ()=>{
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on("setTranslate", ()=>{
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on("setTransition", (_s, duration)=>{
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on("transitionEnd", ()=>{
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            if (!getEffectParams || !getEffectParams().slideShadows) return;
            // remove shadows
            swiper.slides.forEach((slideEl)=>{
                slideEl.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((shadowEl)=>shadowEl.remove());
            });
            // create new one
            recreateShadows();
        }
    });
    let requireUpdateOnVirtual;
    on("virtualUpdate", ()=>{
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(()=>{
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}



function $a8fb34de7e290781$export$f1e1789686576879(effectParams, slideEl) {
    const transformEl = (0, $2a089bf12e68a35c$export$39b482c5e57630a8)(slideEl);
    if (transformEl !== slideEl) {
        transformEl.style.backfaceVisibility = "hidden";
        transformEl.style["-webkit-backface-visibility"] = "hidden";
    }
    return transformEl;
}



function $3018dc92633065cc$export$f1e1789686576879(_ref) {
    let { swiper: swiper, duration: duration, transformElements: transformElements, allSlides: allSlides } = _ref;
    const { activeIndex: activeIndex } = swiper;
    const getSlide = (el)=>{
        if (!el.parentElement) {
            // assume shadow root
            const slide = swiper.slides.filter((slideEl)=>slideEl.shadowRoot && slideEl.shadowRoot === el.parentNode)[0];
            return slide;
        }
        return el.parentElement;
    };
    if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let transitionEndTarget;
        if (allSlides) transitionEndTarget = transformElements;
        else transitionEndTarget = transformElements.filter((transformEl)=>{
            const el = transformEl.classList.contains("swiper-slide-transform") ? getSlide(transformEl) : transformEl;
            return swiper.getSlideIndex(el) === activeIndex;
        });
        transitionEndTarget.forEach((el)=>{
            (0, $2a089bf12e68a35c$export$342063e11d6c3cad)(el, ()=>{
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return;
                eventTriggered = true;
                swiper.animating = false;
                const evt = new window.CustomEvent("transitionend", {
                    bubbles: true,
                    cancelable: true
                });
                swiper.wrapperEl.dispatchEvent(evt);
            });
        });
    }
}



function $f2e37268f745efca$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        fadeEffect: {
            crossFade: false
        }
    });
    const setTranslate = ()=>{
        const { slides: slides } = swiper;
        const params = swiper.params.fadeEffect;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = swiper.slides[i];
            const offset = slideEl.swiperSlideOffset;
            let tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(slideEl.progress), 0) : 1 + Math.min(Math.max(slideEl.progress, -1), 0);
            const targetEl = (0, $a8fb34de7e290781$export$f1e1789686576879)(params, slideEl);
            targetEl.style.opacity = slideOpacity;
            targetEl.style.transform = `translate3d(${tx}px, ${ty}px, 0px)`;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $2a089bf12e68a35c$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
        });
        (0, $3018dc92633065cc$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $0cebc2162ca3b983$export$f1e1789686576879)({
        effect: "fade",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




function $f6656dd4390c8b57$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    const createSlideShadows = (slideEl, progress, isHorizontal)=>{
        let shadowBefore = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
        let shadowAfter = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
        if (!shadowBefore) {
            shadowBefore = (0, $2a089bf12e68a35c$export$db3b6bfb95261072)("div", `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? "left" : "top"}`.split(" "));
            slideEl.append(shadowBefore);
        }
        if (!shadowAfter) {
            shadowAfter = (0, $2a089bf12e68a35c$export$db3b6bfb95261072)("div", `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? "right" : "bottom"}`.split(" "));
            slideEl.append(shadowAfter);
        }
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // create new ones
        const isHorizontal = swiper.isHorizontal();
        swiper.slides.forEach((slideEl)=>{
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress, isHorizontal);
        });
    };
    const setTranslate = ()=>{
        const { el: el, wrapperEl: wrapperEl, slides: slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize, browser: browser } = swiper;
        const r = (0, $2a089bf12e68a35c$export$ae1af26003f05816)(swiper);
        const params = swiper.params.cubeEffect;
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        let wrapperRotate = 0;
        let cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                cubeShadowEl = swiper.wrapperEl.querySelector(".swiper-cube-shadow");
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $2a089bf12e68a35c$export$db3b6bfb95261072)("div", "swiper-cube-shadow");
                    swiper.wrapperEl.append(cubeShadowEl);
                }
                cubeShadowEl.style.height = `${swiperWidth}px`;
            } else {
                cubeShadowEl = el.querySelector(".swiper-cube-shadow");
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $2a089bf12e68a35c$export$db3b6bfb95261072)("div", "swiper-cube-shadow");
                    el.append(cubeShadowEl);
                }
            }
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let slideIndex = i;
            if (isVirtual) slideIndex = parseInt(slideEl.getAttribute("data-swiper-slide-index"), 10);
            let slideAngle = slideIndex * 90;
            let round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            let tx = 0;
            let ty = 0;
            let tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            const transform = `rotateX(${r(isHorizontal ? 0 : -slideAngle)}deg) rotateY(${r(isHorizontal ? slideAngle : 0)}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            slideEl.style.transform = transform;
            if (params.slideShadows) createSlideShadows(slideEl, progress, isHorizontal);
        }
        wrapperEl.style.transformOrigin = `50% 50% -${swiperSize / 2}px`;
        wrapperEl.style["-webkit-transform-origin"] = `50% 50% -${swiperSize / 2}px`;
        if (params.shadow) {
            if (isHorizontal) cubeShadowEl.style.transform = `translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${params.shadowScale})`;
            else {
                const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                const scale1 = params.shadowScale;
                const scale2 = params.shadowScale / multiplier;
                const offset = params.shadowOffset;
                cubeShadowEl.style.transform = `scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-89.99deg)`;
            }
        }
        const zFactor = (browser.isSafari || browser.isWebView) && browser.needPerspectiveFix ? -swiperSize / 2 : 0;
        wrapperEl.style.transform = `translate3d(0px,0,${zFactor}px) rotateX(${r(swiper.isHorizontal() ? 0 : wrapperRotate)}deg) rotateY(${r(swiper.isHorizontal() ? -wrapperRotate : 0)}deg)`;
        wrapperEl.style.setProperty("--swiper-cube-translate-z", `${zFactor}px`);
    };
    const setTransition = (duration)=>{
        const { el: el, slides: slides } = swiper;
        slides.forEach((slideEl)=>{
            slideEl.style.transitionDuration = `${duration}ms`;
            slideEl.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((subEl)=>{
                subEl.style.transitionDuration = `${duration}ms`;
            });
        });
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
            const shadowEl = el.querySelector(".swiper-cube-shadow");
            if (shadowEl) shadowEl.style.transitionDuration = `${duration}ms`;
        }
    };
    (0, $0cebc2162ca3b983$export$f1e1789686576879)({
        effect: "cube",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.cubeEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            })
    });
}



function $8c2033f77b512ced$export$db3b6bfb95261072(suffix, slideEl, side) {
    const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ""}${suffix ? ` swiper-slide-shadow-${suffix}` : ""}`;
    const shadowContainer = (0, $2a089bf12e68a35c$export$39b482c5e57630a8)(slideEl);
    let shadowEl = shadowContainer.querySelector(`.${shadowClass.split(" ").join(".")}`);
    if (!shadowEl) {
        shadowEl = (0, $2a089bf12e68a35c$export$db3b6bfb95261072)("div", shadowClass.split(" "));
        shadowContainer.append(shadowEl);
    }
    return shadowEl;
}






function $6e675efcf9dbdcbf$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true
        }
    });
    const createSlideShadows = (slideEl, progress)=>{
        let shadowBefore = swiper.isHorizontal() ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
        let shadowAfter = swiper.isHorizontal() ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
        if (!shadowBefore) shadowBefore = (0, $8c2033f77b512ced$export$db3b6bfb95261072)("flip", slideEl, swiper.isHorizontal() ? "left" : "top");
        if (!shadowAfter) shadowAfter = (0, $8c2033f77b512ced$export$db3b6bfb95261072)("flip", slideEl, swiper.isHorizontal() ? "right" : "bottom");
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // Set shadows
        swiper.params.flipEffect;
        swiper.slides.forEach((slideEl)=>{
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress);
        });
    };
    const setTranslate = ()=>{
        const { slides: slides, rtlTranslate: rtl } = swiper;
        const params = swiper.params.flipEffect;
        const rotateFix = (0, $2a089bf12e68a35c$export$ae1af26003f05816)(swiper);
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            const offset = slideEl.swiperSlideOffset;
            const rotate = -180 * progress;
            let rotateY = rotate;
            let rotateX = 0;
            let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            slideEl.style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) createSlideShadows(slideEl, progress);
            const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateFix(rotateX)}deg) rotateY(${rotateFix(rotateY)}deg)`;
            const targetEl = (0, $a8fb34de7e290781$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $2a089bf12e68a35c$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $3018dc92633065cc$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $0cebc2162ca3b983$export$f1e1789686576879)({
        effect: "flip",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.flipEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}






function $23a4c7bcf59ecc6f$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true
        }
    });
    const setTranslate = ()=>{
        const { width: swiperWidth, height: swiperHeight, slides: slides, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.coverflowEffect;
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth;
        const r = (0, $2a089bf12e68a35c$export$ae1af26003f05816)(swiper);
        // Each slide offset from center
        for(let i = 0, length = slides.length; i < length; i += 1){
            const slideEl = slides[i];
            const slideSize = slidesSizesGrid[i];
            const slideOffset = slideEl.swiperSlideOffset;
            const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            const offsetMultiplier = typeof params.modifier === "function" ? params.modifier(centerOffset) : centerOffset * params.modifier;
            let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
            // var rotateZ = 0
            let translateZ = -translate * Math.abs(offsetMultiplier);
            let stretch = params.stretch;
            // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === "string" && stretch.indexOf("%") !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);
            // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${r(rotateX)}deg) rotateY(${r(rotateY)}deg) scale(${scale})`;
            const targetEl = (0, $a8fb34de7e290781$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = slideTransform;
            slideEl.style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                let shadowBeforeEl = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
                let shadowAfterEl = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
                if (!shadowBeforeEl) shadowBeforeEl = (0, $8c2033f77b512ced$export$db3b6bfb95261072)("coverflow", slideEl, isHorizontal ? "left" : "top");
                if (!shadowAfterEl) shadowAfterEl = (0, $8c2033f77b512ced$export$db3b6bfb95261072)("coverflow", slideEl, isHorizontal ? "right" : "bottom");
                if (shadowBeforeEl) shadowBeforeEl.style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if (shadowAfterEl) shadowAfterEl.style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $2a089bf12e68a35c$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
    };
    (0, $0cebc2162ca3b983$export$f1e1789686576879)({
        effect: "coverflow",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true
            })
    });
}







function $9df61b3466b3b499$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        creativeEffect: {
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    const getTranslateValue = (value)=>{
        if (typeof value === "string") return value;
        return `${value}px`;
    };
    const setTranslate = ()=>{
        const { slides: slides, wrapperEl: wrapperEl, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.creativeEffect;
        const { progressMultiplier: multiplier } = params;
        const isCenteredSlides = swiper.params.centeredSlides;
        const rotateFix = (0, $2a089bf12e68a35c$export$ae1af26003f05816)(swiper);
        if (isCenteredSlides) {
            const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            wrapperEl.style.transform = `translateX(calc(50% - ${margin}px))`;
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideEl.progress, -params.limitProgress), params.limitProgress);
            let originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max(slideEl.originalProgress, -params.limitProgress), params.limitProgress);
            const offset = slideEl.swiperSlideOffset;
            const t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            const r = [
                0,
                0,
                0
            ];
            let custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            let data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            }
            // set translate
            t.forEach((value, index)=>{
                t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
            });
            // set rotates
            r.forEach((value, index)=>{
                let val = data.rotate[index] * Math.abs(progress * multiplier);
                r[index] = val;
            });
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const translateString = t.join(", ");
            const rotateString = `rotateX(${rotateFix(r[0])}deg) rotateY(${rotateFix(r[1])}deg) rotateZ(${rotateFix(r[2])}deg)`;
            const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
            const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`;
            // Set shadows
            if (custom && data.shadow || !custom) {
                let shadowEl = slideEl.querySelector(".swiper-slide-shadow");
                if (!shadowEl && data.shadow) shadowEl = (0, $8c2033f77b512ced$export$db3b6bfb95261072)("creative", slideEl);
                if (shadowEl) {
                    const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    shadowEl.style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            const targetEl = (0, $a8fb34de7e290781$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
            targetEl.style.opacity = opacityString;
            if (data.origin) targetEl.style.transformOrigin = data.origin;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $2a089bf12e68a35c$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(".swiper-slide-shadow").forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $3018dc92633065cc$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $0cebc2162ca3b983$export$f1e1789686576879)({
        effect: "creative",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>swiper.params.creativeEffect.perspective,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}







function $4a7d2e1866409b5f$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        cardsEffect: {
            slideShadows: true,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    const setTranslate = ()=>{
        const { slides: slides, activeIndex: activeIndex, rtlTranslate: rtl } = swiper;
        const params = swiper.params.cardsEffect;
        const { startTranslate: startTranslate, isTouched: isTouched } = swiper.touchEventsData;
        const currentTranslate = rtl ? -swiper.translate : swiper.translate;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideProgress, -4), 4);
            let offset = slideEl.swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.wrapperEl.style.transform = `translateX(${swiper.minTranslate()}px)`;
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let tY = 0;
            const tZ = -100 * Math.abs(progress);
            let scale = 1;
            let rotate = -params.perSlideRotate * progress;
            let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
            const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${-25 * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) // next
            tX = `calc(${tX}px ${rtl ? "-" : "+"} (${tXAdd * Math.abs(progress)}%))`;
            else if (progress > 0) // prev
            tX = `calc(${tX}px ${rtl ? "-" : "+"} (-${tXAdd * Math.abs(progress)}%))`;
            else tX = `${tX}px`;
            if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
            }
            const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            /* eslint-disable */ const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rtl ? -rotate : rotate : 0}deg)
        scale(${scaleString})
      `;
            /* eslint-enable */ if (params.slideShadows) {
                // Set shadows
                let shadowEl = slideEl.querySelector(".swiper-slide-shadow");
                if (!shadowEl) shadowEl = (0, $8c2033f77b512ced$export$db3b6bfb95261072)("cards", slideEl);
                if (shadowEl) shadowEl.style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const targetEl = (0, $a8fb34de7e290781$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $2a089bf12e68a35c$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(".swiper-slide-shadow").forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $3018dc92633065cc$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $0cebc2162ca3b983$export$f1e1789686576879)({
        effect: "cards",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




const $c4597c8fb1de6074$var$achievementsSection = document.querySelector(".achievements-section");
if ($c4597c8fb1de6074$var$achievementsSection) {
    const tabBtnsArray = document.querySelectorAll(".achievements__tabs-nav-item");
    const tabBtns = [
        ...tabBtnsArray
    ].reduce((acc, btn)=>{
        acc[btn.dataset.tabId] = btn;
        return acc;
    }, {});
    let currentTabId = document.querySelector(".achievements__tabs-nav-item.active").dataset.tabId;
    const screenshotNavButnPrev = document.querySelector(".achievements__slider-nav-btn.prev");
    const screenshotNavButnNext = document.querySelector(".achievements__slider-nav-btn.next");
    const tabSwiper = new (0, $7b90f2d36df6fcf3$export$25ce5a424b770e84)(".achievements__tab-slider", {
        slidesPerView: 1,
        spaceBetween: 20,
        effect: "fade",
        allowTouchMove: false,
        autoHeight: true,
        fadeEffect: {
            crossFade: true
        },
        modules: [
            (0, $f2e37268f745efca$export$2e2bcd8739ae039)
        ]
    });
    const tabScreenshotSwiperArray = document.querySelectorAll(".achievements__screenshot-slider");
    const screenshotSwiperArray = [];
    tabScreenshotSwiperArray.forEach((el)=>{
        const swiper = new (0, $7b90f2d36df6fcf3$export$25ce5a424b770e84)(el, {
            slidesPerView: 1,
            spaceBetween: 20,
            rewind: true,
            pagination: {
                type: "bullets",
                el: el.querySelector(".achievements__screenshot-slider-bullets")
            },
            navigation: {
                nextEl: el.querySelector(".achievements__screenshot-slider-nav-btn.next"),
                prevEl: el.querySelector(".achievements__screenshot-slider-nav-btn.prev")
            },
            modules: [
                (0, $b976be8888348c09$export$2e2bcd8739ae039),
                (0, $56d57b52593640f1$export$2e2bcd8739ae039)
            ]
        });
        screenshotSwiperArray.push(swiper);
    });
    const screenshotSwipers = screenshotSwiperArray.reduce((acc, swiper)=>{
        const { tabId: tabId } = swiper.el.closest(".achievements__bottom").dataset;
        acc[tabId] = swiper;
        return acc;
    }, {});
    screenshotNavButnPrev.addEventListener("click", ()=>{
        screenshotSwipers[currentTabId].slidePrev();
    });
    screenshotNavButnNext.addEventListener("click", ()=>{
        screenshotSwipers[currentTabId].slideNext();
    });
    const setActiveTab = (tab)=>{
        const tabToActivate = tabBtns[tab];
        const activeTab = tabBtns[currentTabId];
        activeTab.classList.remove("active");
        tabToActivate.classList.add("active");
        tabSwiper.slideTo(tab);
        currentTabId = tab;
    };
    Object.values(tabBtns).forEach((btn)=>{
        const { tabId: tabId } = btn.dataset;
        btn.addEventListener("click", ()=>{
            setActiveTab(tabId);
        });
    });
}



var $5jmTd = parcelRequire("5jmTd");
/*!
 * CSSPlugin 3.12.5
 * https://gsap.com
 *
 * Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ 
var $5jmTd = parcelRequire("5jmTd");
var $9bb2aff8416fba65$var$_win, $9bb2aff8416fba65$var$_doc, $9bb2aff8416fba65$var$_docElement, $9bb2aff8416fba65$var$_pluginInitted, $9bb2aff8416fba65$var$_tempDiv, $9bb2aff8416fba65$var$_tempDivStyler, $9bb2aff8416fba65$var$_recentSetterPlugin, $9bb2aff8416fba65$var$_reverting, $9bb2aff8416fba65$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $9bb2aff8416fba65$var$_transformProps = {}, $9bb2aff8416fba65$var$_RAD2DEG = 180 / Math.PI, $9bb2aff8416fba65$var$_DEG2RAD = Math.PI / 180, $9bb2aff8416fba65$var$_atan2 = Math.atan2, $9bb2aff8416fba65$var$_bigNum = 1e8, $9bb2aff8416fba65$var$_capsExp = /([A-Z])/g, $9bb2aff8416fba65$var$_horizontalExp = /(left|right|width|margin|padding|x)/i, $9bb2aff8416fba65$var$_complexExp = /[\s,\(]\S/, $9bb2aff8416fba65$var$_propertyAliases = {
    autoAlpha: "opacity,visibility",
    scale: "scaleX,scaleY",
    alpha: "opacity"
}, $9bb2aff8416fba65$var$_renderCSSProp = function _renderCSSProp(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $9bb2aff8416fba65$var$_renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $9bb2aff8416fba65$var$_renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
    return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$9bb2aff8416fba65$var$_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
    var value = data.s + data.c * ratio;
    data.set(data.t, data.p, ~~(value + (value < 0 ? -0.5 : .5)) + data.u, data);
}, $9bb2aff8416fba65$var$_renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
    return data.set(data.t, data.p, ratio ? data.e : data.b, data);
}, $9bb2aff8416fba65$var$_renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
    return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
}, $9bb2aff8416fba65$var$_setterCSSStyle = function _setterCSSStyle(target, property, value) {
    return target.style[property] = value;
}, $9bb2aff8416fba65$var$_setterCSSProp = function _setterCSSProp(target, property, value) {
    return target.style.setProperty(property, value);
}, $9bb2aff8416fba65$var$_setterTransform = function _setterTransform(target, property, value) {
    return target._gsap[property] = value;
}, $9bb2aff8416fba65$var$_setterScale = function _setterScale(target, property, value) {
    return target._gsap.scaleX = target._gsap.scaleY = value;
}, $9bb2aff8416fba65$var$_setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache.scaleX = cache.scaleY = value;
    cache.renderTransform(ratio, cache);
}, $9bb2aff8416fba65$var$_setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache[property] = value;
    cache.renderTransform(ratio, cache);
}, $9bb2aff8416fba65$var$_transformProp = "transform", $9bb2aff8416fba65$var$_transformOriginProp = $9bb2aff8416fba65$var$_transformProp + "Origin", $9bb2aff8416fba65$var$_saveStyle = function _saveStyle(property, isNotCSS) {
    var _this = this;
    var target = this.target, style = target.style, cache = target._gsap;
    if (property in $9bb2aff8416fba65$var$_transformProps && style) {
        this.tfm = this.tfm || {};
        if (property !== "transform") {
            property = $9bb2aff8416fba65$var$_propertyAliases[property] || property;
            ~property.indexOf(",") ? property.split(",").forEach(function(a) {
                return _this.tfm[a] = $9bb2aff8416fba65$var$_get(target, a);
            }) : this.tfm[property] = cache.x ? cache[property] : $9bb2aff8416fba65$var$_get(target, property); // note: scale would map to "scaleX,scaleY", thus we loop and apply them both.
            property === $9bb2aff8416fba65$var$_transformOriginProp && (this.tfm.zOrigin = cache.zOrigin);
        } else return $9bb2aff8416fba65$var$_propertyAliases.transform.split(",").forEach(function(p) {
            return _saveStyle.call(_this, p, isNotCSS);
        });
        if (this.props.indexOf($9bb2aff8416fba65$var$_transformProp) >= 0) return;
        if (cache.svg) {
            this.svgo = target.getAttribute("data-svg-origin");
            this.props.push($9bb2aff8416fba65$var$_transformOriginProp, isNotCSS, "");
        }
        property = $9bb2aff8416fba65$var$_transformProp;
    }
    (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
}, $9bb2aff8416fba65$var$_removeIndependentTransforms = function _removeIndependentTransforms(style) {
    if (style.translate) {
        style.removeProperty("translate");
        style.removeProperty("scale");
        style.removeProperty("rotate");
    }
}, $9bb2aff8416fba65$var$_revertStyle = function _revertStyle() {
    var props = this.props, target = this.target, style = target.style, cache = target._gsap, i, p;
    for(i = 0; i < props.length; i += 3)// stored like this: property, isNotCSS, value
    props[i + 1] ? target[props[i]] = props[i + 2] : props[i + 2] ? style[props[i]] = props[i + 2] : style.removeProperty(props[i].substr(0, 2) === "--" ? props[i] : props[i].replace($9bb2aff8416fba65$var$_capsExp, "-$1").toLowerCase());
    if (this.tfm) {
        for(p in this.tfm)cache[p] = this.tfm[p];
        if (cache.svg) {
            cache.renderTransform();
            target.setAttribute("data-svg-origin", this.svgo || "");
        }
        i = $9bb2aff8416fba65$var$_reverting();
        if ((!i || !i.isStart) && !style[$9bb2aff8416fba65$var$_transformProp]) {
            $9bb2aff8416fba65$var$_removeIndependentTransforms(style);
            if (cache.zOrigin && style[$9bb2aff8416fba65$var$_transformOriginProp]) {
                style[$9bb2aff8416fba65$var$_transformOriginProp] += " " + cache.zOrigin + "px"; // since we're uncaching, we must put the zOrigin back into the transformOrigin so that we can pull it out accurately when we parse again. Otherwise, we'd lose the z portion of the origin since we extract it to protect from Safari bugs.
                cache.zOrigin = 0;
                cache.renderTransform();
            }
            cache.uncache = 1; // if it's a startAt that's being reverted in the _initTween() of the core, we don't need to uncache transforms. This is purely a performance optimization.
        }
    }
}, $9bb2aff8416fba65$var$_getStyleSaver = function _getStyleSaver(target, properties) {
    var saver = {
        target: target,
        props: [],
        revert: $9bb2aff8416fba65$var$_revertStyle,
        save: $9bb2aff8416fba65$var$_saveStyle
    };
    target._gsap || (0, $5jmTd.gsap).core.getCache(target); // just make sure there's a _gsap cache defined because we read from it in _saveStyle() and it's more efficient to just check it here once.
    properties && properties.split(",").forEach(function(p) {
        return saver.save(p);
    });
    return saver;
}, $9bb2aff8416fba65$var$_supports3D, $9bb2aff8416fba65$export$a232bb0480ae674a = function _createElement(type, ns) {
    var e = $9bb2aff8416fba65$var$_doc.createElementNS ? $9bb2aff8416fba65$var$_doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : $9bb2aff8416fba65$var$_doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.
    return e && e.style ? e : $9bb2aff8416fba65$var$_doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://gsap.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
}, $9bb2aff8416fba65$var$_getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
    var cs = getComputedStyle(target);
    return cs[property] || cs.getPropertyValue(property.replace($9bb2aff8416fba65$var$_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, $9bb2aff8416fba65$export$8cbef5dd49a09c8b(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
}, $9bb2aff8416fba65$var$_prefixes = "O,Moz,ms,Ms,Webkit".split(","), $9bb2aff8416fba65$export$8cbef5dd49a09c8b = function _checkPropPrefix(property, element, preferPrefix) {
    var e = element || $9bb2aff8416fba65$var$_tempDiv, s = e.style, i = 5;
    if (property in s && !preferPrefix) return property;
    property = property.charAt(0).toUpperCase() + property.substr(1);
    while(i-- && !($9bb2aff8416fba65$var$_prefixes[i] + property in s));
    return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? $9bb2aff8416fba65$var$_prefixes[i] : "") + property;
}, $9bb2aff8416fba65$var$_initCore = function _initCore() {
    if ($9bb2aff8416fba65$var$_windowExists() && window.document) {
        $9bb2aff8416fba65$var$_win = window;
        $9bb2aff8416fba65$var$_doc = $9bb2aff8416fba65$var$_win.document;
        $9bb2aff8416fba65$var$_docElement = $9bb2aff8416fba65$var$_doc.documentElement;
        $9bb2aff8416fba65$var$_tempDiv = $9bb2aff8416fba65$export$a232bb0480ae674a("div") || {
            style: {}
        };
        $9bb2aff8416fba65$var$_tempDivStyler = $9bb2aff8416fba65$export$a232bb0480ae674a("div");
        $9bb2aff8416fba65$var$_transformProp = $9bb2aff8416fba65$export$8cbef5dd49a09c8b($9bb2aff8416fba65$var$_transformProp);
        $9bb2aff8416fba65$var$_transformOriginProp = $9bb2aff8416fba65$var$_transformProp + "Origin";
        $9bb2aff8416fba65$var$_tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.
        $9bb2aff8416fba65$var$_supports3D = !!$9bb2aff8416fba65$export$8cbef5dd49a09c8b("perspective");
        $9bb2aff8416fba65$var$_reverting = (0, $5jmTd.gsap).core.reverting;
        $9bb2aff8416fba65$var$_pluginInitted = 1;
    }
}, $9bb2aff8416fba65$var$_getBBoxHack = function _getBBoxHack(swapIfPossible) {
    //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
    var svg = $9bb2aff8416fba65$export$a232bb0480ae674a("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), oldParent = this.parentNode, oldSibling = this.nextSibling, oldCSS = this.style.cssText, bbox;
    $9bb2aff8416fba65$var$_docElement.appendChild(svg);
    svg.appendChild(this);
    this.style.display = "block";
    if (swapIfPossible) try {
        bbox = this.getBBox();
        this._gsapBBox = this.getBBox; //store the original
        this.getBBox = _getBBoxHack;
    } catch (e) {}
    else if (this._gsapBBox) bbox = this._gsapBBox();
    if (oldParent) {
        if (oldSibling) oldParent.insertBefore(this, oldSibling);
        else oldParent.appendChild(this);
    }
    $9bb2aff8416fba65$var$_docElement.removeChild(svg);
    this.style.cssText = oldCSS;
    return bbox;
}, $9bb2aff8416fba65$var$_getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
    var i = attributesArray.length;
    while(i--){
        if (target.hasAttribute(attributesArray[i])) return target.getAttribute(attributesArray[i]);
    }
}, $9bb2aff8416fba65$export$41bc7c2d1e04f11b = function _getBBox(target) {
    var bounds;
    try {
        bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
    } catch (error) {
        bounds = $9bb2aff8416fba65$var$_getBBoxHack.call(target, true);
    }
    bounds && (bounds.width || bounds.height) || target.getBBox === $9bb2aff8416fba65$var$_getBBoxHack || (bounds = $9bb2aff8416fba65$var$_getBBoxHack.call(target, true)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
    return bounds && !bounds.width && !bounds.x && !bounds.y ? {
        x: +$9bb2aff8416fba65$var$_getAttributeFallbacks(target, [
            "x",
            "cx",
            "x1"
        ]) || 0,
        y: +$9bb2aff8416fba65$var$_getAttributeFallbacks(target, [
            "y",
            "cy",
            "y1"
        ]) || 0,
        width: 0,
        height: 0
    } : bounds;
}, $9bb2aff8416fba65$var$_isSVG = function _isSVG(e) {
    return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && $9bb2aff8416fba65$export$41bc7c2d1e04f11b(e));
}, //reports if the element is an SVG on which getBBox() actually works
$9bb2aff8416fba65$var$_removeProperty = function _removeProperty(target, property) {
    if (property) {
        var style = target.style, first2Chars;
        if (property in $9bb2aff8416fba65$var$_transformProps && property !== $9bb2aff8416fba65$var$_transformOriginProp) property = $9bb2aff8416fba65$var$_transformProp;
        if (style.removeProperty) {
            first2Chars = property.substr(0, 2);
            if (first2Chars === "ms" || property.substr(0, 6) === "webkit") //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
            property = "-" + property;
            style.removeProperty(first2Chars === "--" ? property : property.replace($9bb2aff8416fba65$var$_capsExp, "-$1").toLowerCase());
        } else //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
        style.removeAttribute(property);
    }
}, $9bb2aff8416fba65$var$_addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
    var pt = new (0, $5jmTd.PropTween)(plugin._pt, target, property, 0, 1, onlySetAtEnd ? $9bb2aff8416fba65$var$_renderNonTweeningValueOnlyAtEnd : $9bb2aff8416fba65$var$_renderNonTweeningValue);
    plugin._pt = pt;
    pt.b = beginning;
    pt.e = end;
    plugin._props.push(property);
    return pt;
}, $9bb2aff8416fba65$var$_nonConvertibleUnits = {
    deg: 1,
    rad: 1,
    turn: 1
}, $9bb2aff8416fba65$var$_nonStandardLayouts = {
    grid: 1,
    flex: 1
}, //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
$9bb2aff8416fba65$var$_convertToUnit = function _convertToUnit(target, property, value, unit) {
    var curValue = parseFloat(value) || 0, curUnit = (value + "").trim().substr((curValue + "").length) || "px", // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
    style = $9bb2aff8416fba65$var$_tempDiv.style, horizontal = $9bb2aff8416fba65$var$_horizontalExp.test(property), isRootSVG = target.tagName.toLowerCase() === "svg", measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"), amount = 100, toPixels = unit === "px", toPercent = unit === "%", px, parent, cache, isSVG;
    if (unit === curUnit || !curValue || $9bb2aff8416fba65$var$_nonConvertibleUnits[unit] || $9bb2aff8416fba65$var$_nonConvertibleUnits[curUnit]) return curValue;
    curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
    isSVG = target.getCTM && $9bb2aff8416fba65$var$_isSVG(target);
    if ((toPercent || curUnit === "%") && ($9bb2aff8416fba65$var$_transformProps[property] || ~property.indexOf("adius"))) {
        px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
        return (0, $5jmTd._round)(toPercent ? curValue / px * amount : curValue / 100 * px);
    }
    style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
    parent = ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
    if (isSVG) parent = (target.ownerSVGElement || {}).parentNode;
    if (!parent || parent === $9bb2aff8416fba65$var$_doc || !parent.appendChild) parent = $9bb2aff8416fba65$var$_doc.body;
    cache = parent._gsap;
    if (cache && toPercent && cache.width && horizontal && cache.time === (0, $5jmTd._ticker).time && !cache.uncache) return (0, $5jmTd._round)(curValue / cache.width * amount);
    else {
        if (toPercent && (property === "height" || property === "width")) {
            // if we're dealing with width/height that's inside a container with padding and/or it's a flexbox/grid container, we must apply it to the target itself rather than the _tempDiv in order to ensure complete accuracy, factoring in the parent's padding.
            var v = target.style[property];
            target.style[property] = amount + unit;
            px = target[measureProperty];
            v ? target.style[property] = v : $9bb2aff8416fba65$var$_removeProperty(target, property);
        } else {
            (toPercent || curUnit === "%") && !$9bb2aff8416fba65$var$_nonStandardLayouts[$9bb2aff8416fba65$var$_getComputedProperty(parent, "display")] && (style.position = $9bb2aff8416fba65$var$_getComputedProperty(target, "position"));
            parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.
            parent.appendChild($9bb2aff8416fba65$var$_tempDiv);
            px = $9bb2aff8416fba65$var$_tempDiv[measureProperty];
            parent.removeChild($9bb2aff8416fba65$var$_tempDiv);
            style.position = "absolute";
        }
        if (horizontal && toPercent) {
            cache = (0, $5jmTd._getCache)(parent);
            cache.time = (0, $5jmTd._ticker).time;
            cache.width = parent[measureProperty];
        }
    }
    return (0, $5jmTd._round)(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
}, $9bb2aff8416fba65$var$_get = function _get(target, property, unit, uncache) {
    var value;
    $9bb2aff8416fba65$var$_pluginInitted || $9bb2aff8416fba65$var$_initCore();
    if (property in $9bb2aff8416fba65$var$_propertyAliases && property !== "transform") {
        property = $9bb2aff8416fba65$var$_propertyAliases[property];
        if (~property.indexOf(",")) property = property.split(",")[0];
    }
    if ($9bb2aff8416fba65$var$_transformProps[property] && property !== "transform") {
        value = $9bb2aff8416fba65$var$_parseTransform(target, uncache);
        value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : $9bb2aff8416fba65$var$_firstTwoOnly($9bb2aff8416fba65$var$_getComputedProperty(target, $9bb2aff8416fba65$var$_transformOriginProp)) + " " + value.zOrigin + "px";
    } else {
        value = target.style[property];
        if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) value = $9bb2aff8416fba65$var$_specialProps[property] && $9bb2aff8416fba65$var$_specialProps[property](target, property, unit) || $9bb2aff8416fba65$var$_getComputedProperty(target, property) || (0, $5jmTd._getProperty)(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
    return unit && !~(value + "").trim().indexOf(" ") ? $9bb2aff8416fba65$var$_convertToUnit(target, property, value, unit) + unit : value;
}, $9bb2aff8416fba65$var$_tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
    // note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    if (!start || start === "none") {
        // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://gsap.com/forums/topic/18310-clippath-doesnt-work-on-ios/
        var p = $9bb2aff8416fba65$export$8cbef5dd49a09c8b(prop, target, 1), s = p && $9bb2aff8416fba65$var$_getComputedProperty(target, p, 1);
        if (s && s !== start) {
            prop = p;
            start = s;
        } else if (prop === "borderColor") start = $9bb2aff8416fba65$var$_getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://gsap.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
    var pt = new (0, $5jmTd.PropTween)(this._pt, target.style, prop, 0, 1, (0, $5jmTd._renderComplexString)), index = 0, matchIndex = 0, a, result, startValues, startNum, color, startValue, endValue, endNum, chunk, endUnit, startUnit, endValues;
    pt.b = start;
    pt.e = end;
    start += ""; // ensure values are strings
    end += "";
    if (end === "auto") {
        startValue = target.style[prop];
        target.style[prop] = end;
        end = $9bb2aff8416fba65$var$_getComputedProperty(target, prop) || end;
        startValue ? target.style[prop] = startValue : $9bb2aff8416fba65$var$_removeProperty(target, prop);
    }
    a = [
        start,
        end
    ];
    (0, $5jmTd._colorStringFilter)(a); // pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().
    start = a[0];
    end = a[1];
    startValues = start.match((0, $5jmTd._numWithUnitExp)) || [];
    endValues = end.match((0, $5jmTd._numWithUnitExp)) || [];
    if (endValues.length) {
        while(result = (0, $5jmTd._numWithUnitExp).exec(end)){
            endValue = result[0];
            chunk = end.substring(index, result.index);
            if (color) color = (color + 1) % 5;
            else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") color = 1;
            if (endValue !== (startValue = startValues[matchIndex++] || "")) {
                startNum = parseFloat(startValue) || 0;
                startUnit = startValue.substr((startNum + "").length);
                endValue.charAt(1) === "=" && (endValue = (0, $5jmTd._parseRelative)(startNum, endValue) + startUnit);
                endNum = parseFloat(endValue);
                endUnit = endValue.substr((endNum + "").length);
                index = (0, $5jmTd._numWithUnitExp).lastIndex - endUnit.length;
                if (!endUnit) {
                    //if something like "perspective:300" is passed in and we must add a unit to the end
                    endUnit = endUnit || (0, $5jmTd._config).units[prop] || startUnit;
                    if (index === end.length) {
                        end += endUnit;
                        pt.e += endUnit;
                    }
                }
                if (startUnit !== endUnit) startNum = $9bb2aff8416fba65$var$_convertToUnit(target, prop, startValue, endUnit) || 0;
                 // these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
                pt._pt = {
                    _next: pt._pt,
                    p: chunk || matchIndex === 1 ? chunk : ",",
                    //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                    s: startNum,
                    c: endNum - startNum,
                    m: color && color < 4 || prop === "zIndex" ? Math.round : 0
                };
            }
        }
        pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    } else pt.r = prop === "display" && end === "none" ? $9bb2aff8416fba65$var$_renderNonTweeningValueOnlyAtEnd : $9bb2aff8416fba65$var$_renderNonTweeningValue;
    (0, $5jmTd._relExp).test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.
    return pt;
}, $9bb2aff8416fba65$var$_keywordToPercent = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
}, $9bb2aff8416fba65$var$_convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
    var split = value.split(" "), x = split[0], y = split[1] || "50%";
    if (x === "top" || x === "bottom" || y === "left" || y === "right") {
        //the user provided them in the wrong order, so flip them
        value = x;
        x = y;
        y = value;
    }
    split[0] = $9bb2aff8416fba65$var$_keywordToPercent[x] || x;
    split[1] = $9bb2aff8416fba65$var$_keywordToPercent[y] || y;
    return split.join(" ");
}, $9bb2aff8416fba65$var$_renderClearProps = function _renderClearProps(ratio, data) {
    if (data.tween && data.tween._time === data.tween._dur) {
        var target = data.t, style = target.style, props = data.u, cache = target._gsap, prop, clearTransforms, i;
        if (props === "all" || props === true) {
            style.cssText = "";
            clearTransforms = 1;
        } else {
            props = props.split(",");
            i = props.length;
            while(--i > -1){
                prop = props[i];
                if ($9bb2aff8416fba65$var$_transformProps[prop]) {
                    clearTransforms = 1;
                    prop = prop === "transformOrigin" ? $9bb2aff8416fba65$var$_transformOriginProp : $9bb2aff8416fba65$var$_transformProp;
                }
                $9bb2aff8416fba65$var$_removeProperty(target, prop);
            }
        }
        if (clearTransforms) {
            $9bb2aff8416fba65$var$_removeProperty(target, $9bb2aff8416fba65$var$_transformProp);
            if (cache) {
                cache.svg && target.removeAttribute("transform");
                $9bb2aff8416fba65$var$_parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.
                cache.uncache = 1;
                $9bb2aff8416fba65$var$_removeIndependentTransforms(style);
            }
        }
    }
}, // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
$9bb2aff8416fba65$var$_specialProps = {
    clearProps: function clearProps(plugin, target, property, endValue, tween) {
        if (tween.data !== "isFromStart") {
            var pt = plugin._pt = new (0, $5jmTd.PropTween)(plugin._pt, target, property, 0, 0, $9bb2aff8416fba65$var$_renderClearProps);
            pt.u = endValue;
            pt.pr = -10;
            pt.tween = tween;
            plugin._props.push(property);
            return 1;
        }
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */ $9bb2aff8416fba65$var$_identity2DMatrix = [
    1,
    0,
    0,
    1,
    0,
    0
], $9bb2aff8416fba65$var$_rotationalProperties = {}, $9bb2aff8416fba65$var$_isNullTransform = function _isNullTransform(value) {
    return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
}, $9bb2aff8416fba65$var$_getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
    var matrixString = $9bb2aff8416fba65$var$_getComputedProperty(target, $9bb2aff8416fba65$var$_transformProp);
    return $9bb2aff8416fba65$var$_isNullTransform(matrixString) ? $9bb2aff8416fba65$var$_identity2DMatrix : matrixString.substr(7).match((0, $5jmTd._numExp)).map((0, $5jmTd._round));
}, $9bb2aff8416fba65$var$_getMatrix = function _getMatrix(target, force2D) {
    var cache = target._gsap || (0, $5jmTd._getCache)(target), style = target.style, matrix = $9bb2aff8416fba65$var$_getComputedTransformMatrixAsArray(target), parent, nextSibling, temp, addedToDOM;
    if (cache.svg && target.getAttribute("transform")) {
        temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
        matrix = [
            temp.a,
            temp.b,
            temp.c,
            temp.d,
            temp.e,
            temp.f
        ];
        return matrix.join(",") === "1,0,0,1,0,0" ? $9bb2aff8416fba65$var$_identity2DMatrix : matrix;
    } else if (matrix === $9bb2aff8416fba65$var$_identity2DMatrix && !target.offsetParent && target !== $9bb2aff8416fba65$var$_docElement && !cache.svg) {
        //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
        //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
        temp = style.display;
        style.display = "block";
        parent = target.parentNode;
        if (!parent || !target.offsetParent) {
            // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375
            addedToDOM = 1; //flag
            nextSibling = target.nextElementSibling;
            $9bb2aff8416fba65$var$_docElement.appendChild(target); //we must add it to the DOM in order to get values properly
        }
        matrix = $9bb2aff8416fba65$var$_getComputedTransformMatrixAsArray(target);
        temp ? style.display = temp : $9bb2aff8416fba65$var$_removeProperty(target, "display");
        if (addedToDOM) nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : $9bb2aff8416fba65$var$_docElement.removeChild(target);
    }
    return force2D && matrix.length > 6 ? [
        matrix[0],
        matrix[1],
        matrix[4],
        matrix[5],
        matrix[12],
        matrix[13]
    ] : matrix;
}, $9bb2aff8416fba65$var$_applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
    var cache = target._gsap, matrix = matrixArray || $9bb2aff8416fba65$var$_getMatrix(target, true), xOriginOld = cache.xOrigin || 0, yOriginOld = cache.yOrigin || 0, xOffsetOld = cache.xOffset || 0, yOffsetOld = cache.yOffset || 0, a = matrix[0], b = matrix[1], c = matrix[2], d = matrix[3], tx = matrix[4], ty = matrix[5], originSplit = origin.split(" "), xOrigin = parseFloat(originSplit[0]) || 0, yOrigin = parseFloat(originSplit[1]) || 0, bounds, determinant, x, y;
    if (!originIsAbsolute) {
        bounds = $9bb2aff8416fba65$export$41bc7c2d1e04f11b(target);
        xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
        yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin); // if (!("xOrigin" in cache) && (xOrigin || yOrigin)) { // added in 3.12.3, reverted in 3.12.4; requires more exploration
    // 	xOrigin -= bounds.x;
    // 	yOrigin -= bounds.y;
    // }
    } else if (matrix !== $9bb2aff8416fba65$var$_identity2DMatrix && (determinant = a * d - b * c)) {
        //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
        x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
        y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
        xOrigin = x;
        yOrigin = y; // theory: we only had to do this for smoothing and it assumes that the previous one was not originIsAbsolute.
    }
    if (smooth || smooth !== false && cache.smooth) {
        tx = xOrigin - xOriginOld;
        ty = yOrigin - yOriginOld;
        cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
        cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
    } else cache.xOffset = cache.yOffset = 0;
    cache.xOrigin = xOrigin;
    cache.yOrigin = yOrigin;
    cache.smooth = !!smooth;
    cache.origin = origin;
    cache.originIsAbsolute = !!originIsAbsolute;
    target.style[$9bb2aff8416fba65$var$_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).
    if (pluginToAddPropTweensTo) {
        $9bb2aff8416fba65$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
        $9bb2aff8416fba65$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
        $9bb2aff8416fba65$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
        $9bb2aff8416fba65$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
    }
    target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
}, $9bb2aff8416fba65$var$_parseTransform = function _parseTransform(target, uncache) {
    var cache = target._gsap || new (0, $5jmTd.GSCache)(target);
    if ("x" in cache && !uncache && !cache.uncache) return cache;
    var style = target.style, invertedScaleX = cache.scaleX < 0, px = "px", deg = "deg", cs = getComputedStyle(target), origin = $9bb2aff8416fba65$var$_getComputedProperty(target, $9bb2aff8416fba65$var$_transformOriginProp) || "0", x, y, z, scaleX, scaleY, rotation, rotationX, rotationY, skewX, skewY, perspective, xOrigin, yOrigin, matrix, angle, cos, sin, a, b, c, d, a12, a22, t1, t2, t3, a13, a23, a33, a42, a43, a32;
    x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
    scaleX = scaleY = 1;
    cache.svg = !!(target.getCTM && $9bb2aff8416fba65$var$_isSVG(target));
    if (cs.translate) {
        // accommodate independent transforms by combining them into normal ones.
        if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") style[$9bb2aff8416fba65$var$_transformProp] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[$9bb2aff8416fba65$var$_transformProp] !== "none" ? cs[$9bb2aff8416fba65$var$_transformProp] : "");
        style.scale = style.rotate = style.translate = "none";
    }
    matrix = $9bb2aff8416fba65$var$_getMatrix(target, cache.svg);
    if (cache.svg) {
        if (cache.uncache) {
            // if cache.uncache is true (and maybe if origin is 0,0), we need to set element.style.transformOrigin = (cache.xOrigin - bbox.x) + "px " + (cache.yOrigin - bbox.y) + "px". Previously we let the data-svg-origin stay instead, but when introducing revert(), it complicated things.
            t2 = target.getBBox();
            origin = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
            t1 = "";
        } else t1 = !uncache && target.getAttribute("data-svg-origin"); //  Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.
        $9bb2aff8416fba65$var$_applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
    }
    xOrigin = cache.xOrigin || 0;
    yOrigin = cache.yOrigin || 0;
    if (matrix !== $9bb2aff8416fba65$var$_identity2DMatrix) {
        a = matrix[0]; //a11
        b = matrix[1]; //a21
        c = matrix[2]; //a31
        d = matrix[3]; //a41
        x = a12 = matrix[4];
        y = a22 = matrix[5]; //2D matrix
        if (matrix.length === 6) {
            scaleX = Math.sqrt(a * a + b * b);
            scaleY = Math.sqrt(d * d + c * c);
            rotation = a || b ? $9bb2aff8416fba65$var$_atan2(b, a) * $9bb2aff8416fba65$var$_RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
            skewX = c || d ? $9bb2aff8416fba65$var$_atan2(c, d) * $9bb2aff8416fba65$var$_RAD2DEG + rotation : 0;
            skewX && (scaleY *= Math.abs(Math.cos(skewX * $9bb2aff8416fba65$var$_DEG2RAD)));
            if (cache.svg) {
                x -= xOrigin - (xOrigin * a + yOrigin * c);
                y -= yOrigin - (xOrigin * b + yOrigin * d);
            } //3D matrix
        } else {
            a32 = matrix[6];
            a42 = matrix[7];
            a13 = matrix[8];
            a23 = matrix[9];
            a33 = matrix[10];
            a43 = matrix[11];
            x = matrix[12];
            y = matrix[13];
            z = matrix[14];
            angle = $9bb2aff8416fba65$var$_atan2(a32, a33);
            rotationX = angle * $9bb2aff8416fba65$var$_RAD2DEG; //rotationX
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a12 * cos + a13 * sin;
                t2 = a22 * cos + a23 * sin;
                t3 = a32 * cos + a33 * sin;
                a13 = a12 * -sin + a13 * cos;
                a23 = a22 * -sin + a23 * cos;
                a33 = a32 * -sin + a33 * cos;
                a43 = a42 * -sin + a43 * cos;
                a12 = t1;
                a22 = t2;
                a32 = t3;
            } //rotationY
            angle = $9bb2aff8416fba65$var$_atan2(-c, a33);
            rotationY = angle * $9bb2aff8416fba65$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a * cos - a13 * sin;
                t2 = b * cos - a23 * sin;
                t3 = c * cos - a33 * sin;
                a43 = d * sin + a43 * cos;
                a = t1;
                b = t2;
                c = t3;
            } //rotationZ
            angle = $9bb2aff8416fba65$var$_atan2(b, a);
            rotation = angle * $9bb2aff8416fba65$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(angle);
                sin = Math.sin(angle);
                t1 = a * cos + b * sin;
                t2 = a12 * cos + a22 * sin;
                b = b * cos - a * sin;
                a22 = a22 * cos - a12 * sin;
                a = t1;
                a12 = t2;
            }
            if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
                //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
                rotationX = rotation = 0;
                rotationY = 180 - rotationY;
            }
            scaleX = (0, $5jmTd._round)(Math.sqrt(a * a + b * b + c * c));
            scaleY = (0, $5jmTd._round)(Math.sqrt(a22 * a22 + a32 * a32));
            angle = $9bb2aff8416fba65$var$_atan2(a12, a22);
            skewX = Math.abs(angle) > 0.0002 ? angle * $9bb2aff8416fba65$var$_RAD2DEG : 0;
            perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
        }
        if (cache.svg) {
            //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
            t1 = target.getAttribute("transform");
            cache.forceCSS = target.setAttribute("transform", "") || !$9bb2aff8416fba65$var$_isNullTransform($9bb2aff8416fba65$var$_getComputedProperty(target, $9bb2aff8416fba65$var$_transformProp));
            t1 && target.setAttribute("transform", t1);
        }
    }
    if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
        if (invertedScaleX) {
            scaleX *= -1;
            skewX += rotation <= 0 ? 180 : -180;
            rotation += rotation <= 0 ? 180 : -180;
        } else {
            scaleY *= -1;
            skewX += skewX <= 0 ? 180 : -180;
        }
    }
    uncache = uncache || cache.uncache;
    cache.x = x - ((cache.xPercent = x && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
    cache.y = y - ((cache.yPercent = y && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
    cache.z = z + px;
    cache.scaleX = (0, $5jmTd._round)(scaleX);
    cache.scaleY = (0, $5jmTd._round)(scaleY);
    cache.rotation = (0, $5jmTd._round)(rotation) + deg;
    cache.rotationX = (0, $5jmTd._round)(rotationX) + deg;
    cache.rotationY = (0, $5jmTd._round)(rotationY) + deg;
    cache.skewX = skewX + deg;
    cache.skewY = skewY + deg;
    cache.transformPerspective = perspective + px;
    if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || !uncache && cache.zOrigin || 0) style[$9bb2aff8416fba65$var$_transformOriginProp] = $9bb2aff8416fba65$var$_firstTwoOnly(origin);
    cache.xOffset = cache.yOffset = 0;
    cache.force3D = (0, $5jmTd._config).force3D;
    cache.renderTransform = cache.svg ? $9bb2aff8416fba65$var$_renderSVGTransforms : $9bb2aff8416fba65$var$_supports3D ? $9bb2aff8416fba65$var$_renderCSSTransforms : $9bb2aff8416fba65$var$_renderNon3DTransforms;
    cache.uncache = 0;
    return cache;
}, $9bb2aff8416fba65$var$_firstTwoOnly = function _firstTwoOnly(value) {
    return (value = value.split(" "))[0] + " " + value[1];
}, //for handling transformOrigin values, stripping out the 3rd dimension
$9bb2aff8416fba65$var$_addPxTranslate = function _addPxTranslate(target, start, value) {
    var unit = (0, $5jmTd.getUnit)(start);
    return (0, $5jmTd._round)(parseFloat(start) + parseFloat($9bb2aff8416fba65$var$_convertToUnit(target, "x", value + "px", unit))) + unit;
}, $9bb2aff8416fba65$var$_renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
    cache.z = "0px";
    cache.rotationY = cache.rotationX = "0deg";
    cache.force3D = 0;
    $9bb2aff8416fba65$var$_renderCSSTransforms(ratio, cache);
}, $9bb2aff8416fba65$var$_zeroDeg = "0deg", $9bb2aff8416fba65$var$_zeroPx = "0px", $9bb2aff8416fba65$var$_endParenthesis = ") ", $9bb2aff8416fba65$var$_renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
    var _ref = cache || this, xPercent = _ref.xPercent, yPercent = _ref.yPercent, x = _ref.x, y = _ref.y, z = _ref.z, rotation = _ref.rotation, rotationY = _ref.rotationY, rotationX = _ref.rotationX, skewX = _ref.skewX, skewY = _ref.skewY, scaleX = _ref.scaleX, scaleY = _ref.scaleY, transformPerspective = _ref.transformPerspective, force3D = _ref.force3D, target = _ref.target, zOrigin = _ref.zOrigin, transforms = "", use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)
    if (zOrigin && (rotationX !== $9bb2aff8416fba65$var$_zeroDeg || rotationY !== $9bb2aff8416fba65$var$_zeroDeg)) {
        var angle = parseFloat(rotationY) * $9bb2aff8416fba65$var$_DEG2RAD, a13 = Math.sin(angle), a33 = Math.cos(angle), cos;
        angle = parseFloat(rotationX) * $9bb2aff8416fba65$var$_DEG2RAD;
        cos = Math.cos(angle);
        x = $9bb2aff8416fba65$var$_addPxTranslate(target, x, a13 * cos * -zOrigin);
        y = $9bb2aff8416fba65$var$_addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
        z = $9bb2aff8416fba65$var$_addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
    }
    if (transformPerspective !== $9bb2aff8416fba65$var$_zeroPx) transforms += "perspective(" + transformPerspective + $9bb2aff8416fba65$var$_endParenthesis;
    if (xPercent || yPercent) transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
    if (use3D || x !== $9bb2aff8416fba65$var$_zeroPx || y !== $9bb2aff8416fba65$var$_zeroPx || z !== $9bb2aff8416fba65$var$_zeroPx) transforms += z !== $9bb2aff8416fba65$var$_zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + $9bb2aff8416fba65$var$_endParenthesis;
    if (rotation !== $9bb2aff8416fba65$var$_zeroDeg) transforms += "rotate(" + rotation + $9bb2aff8416fba65$var$_endParenthesis;
    if (rotationY !== $9bb2aff8416fba65$var$_zeroDeg) transforms += "rotateY(" + rotationY + $9bb2aff8416fba65$var$_endParenthesis;
    if (rotationX !== $9bb2aff8416fba65$var$_zeroDeg) transforms += "rotateX(" + rotationX + $9bb2aff8416fba65$var$_endParenthesis;
    if (skewX !== $9bb2aff8416fba65$var$_zeroDeg || skewY !== $9bb2aff8416fba65$var$_zeroDeg) transforms += "skew(" + skewX + ", " + skewY + $9bb2aff8416fba65$var$_endParenthesis;
    if (scaleX !== 1 || scaleY !== 1) transforms += "scale(" + scaleX + ", " + scaleY + $9bb2aff8416fba65$var$_endParenthesis;
    target.style[$9bb2aff8416fba65$var$_transformProp] = transforms || "translate(0, 0)";
}, $9bb2aff8416fba65$var$_renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
    var _ref2 = cache || this, xPercent = _ref2.xPercent, yPercent = _ref2.yPercent, x = _ref2.x, y = _ref2.y, rotation = _ref2.rotation, skewX = _ref2.skewX, skewY = _ref2.skewY, scaleX = _ref2.scaleX, scaleY = _ref2.scaleY, target = _ref2.target, xOrigin = _ref2.xOrigin, yOrigin = _ref2.yOrigin, xOffset = _ref2.xOffset, yOffset = _ref2.yOffset, forceCSS = _ref2.forceCSS, tx = parseFloat(x), ty = parseFloat(y), a11, a21, a12, a22, temp;
    rotation = parseFloat(rotation);
    skewX = parseFloat(skewX);
    skewY = parseFloat(skewY);
    if (skewY) {
        //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
        skewY = parseFloat(skewY);
        skewX += skewY;
        rotation += skewY;
    }
    if (rotation || skewX) {
        rotation *= $9bb2aff8416fba65$var$_DEG2RAD;
        skewX *= $9bb2aff8416fba65$var$_DEG2RAD;
        a11 = Math.cos(rotation) * scaleX;
        a21 = Math.sin(rotation) * scaleX;
        a12 = Math.sin(rotation - skewX) * -scaleY;
        a22 = Math.cos(rotation - skewX) * scaleY;
        if (skewX) {
            skewY *= $9bb2aff8416fba65$var$_DEG2RAD;
            temp = Math.tan(skewX - skewY);
            temp = Math.sqrt(1 + temp * temp);
            a12 *= temp;
            a22 *= temp;
            if (skewY) {
                temp = Math.tan(skewY);
                temp = Math.sqrt(1 + temp * temp);
                a11 *= temp;
                a21 *= temp;
            }
        }
        a11 = (0, $5jmTd._round)(a11);
        a21 = (0, $5jmTd._round)(a21);
        a12 = (0, $5jmTd._round)(a12);
        a22 = (0, $5jmTd._round)(a22);
    } else {
        a11 = scaleX;
        a22 = scaleY;
        a21 = a12 = 0;
    }
    if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
        tx = $9bb2aff8416fba65$var$_convertToUnit(target, "x", x, "px");
        ty = $9bb2aff8416fba65$var$_convertToUnit(target, "y", y, "px");
    }
    if (xOrigin || yOrigin || xOffset || yOffset) {
        tx = (0, $5jmTd._round)(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
        ty = (0, $5jmTd._round)(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
    }
    if (xPercent || yPercent) {
        //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
        temp = target.getBBox();
        tx = (0, $5jmTd._round)(tx + xPercent / 100 * temp.width);
        ty = (0, $5jmTd._round)(ty + yPercent / 100 * temp.height);
    }
    temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
    target.setAttribute("transform", temp);
    forceCSS && (target.style[$9bb2aff8416fba65$var$_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the transform attribute changes!)
}, $9bb2aff8416fba65$var$_addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue) {
    var cap = 360, isString = (0, $5jmTd._isString)(endValue), endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? $9bb2aff8416fba65$var$_RAD2DEG : 1), change = endNum - startNum, finalValue = startNum + change + "deg", direction, pt;
    if (isString) {
        direction = endValue.split("_")[1];
        if (direction === "short") {
            change %= cap;
            if (change !== change % (cap / 2)) change += change < 0 ? cap : -cap;
        }
        if (direction === "cw" && change < 0) change = (change + cap * $9bb2aff8416fba65$var$_bigNum) % cap - ~~(change / cap) * cap;
        else if (direction === "ccw" && change > 0) change = (change - cap * $9bb2aff8416fba65$var$_bigNum) % cap - ~~(change / cap) * cap;
    }
    plugin._pt = pt = new (0, $5jmTd.PropTween)(plugin._pt, target, property, startNum, change, $9bb2aff8416fba65$var$_renderPropWithEnd);
    pt.e = finalValue;
    pt.u = "deg";
    plugin._props.push(property);
    return pt;
}, $9bb2aff8416fba65$var$_assign = function _assign(target, source) {
    // Internet Explorer doesn't have Object.assign(), so we recreate it here.
    for(var p in source)target[p] = source[p];
    return target;
}, $9bb2aff8416fba65$var$_addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
    //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
    var startCache = $9bb2aff8416fba65$var$_assign({}, target._gsap), exclude = "perspective,force3D,transformOrigin,svgOrigin", style = target.style, endCache, p, startValue, endValue, startNum, endNum, startUnit, endUnit;
    if (startCache.svg) {
        startValue = target.getAttribute("transform");
        target.setAttribute("transform", "");
        style[$9bb2aff8416fba65$var$_transformProp] = transforms;
        endCache = $9bb2aff8416fba65$var$_parseTransform(target, 1);
        $9bb2aff8416fba65$var$_removeProperty(target, $9bb2aff8416fba65$var$_transformProp);
        target.setAttribute("transform", startValue);
    } else {
        startValue = getComputedStyle(target)[$9bb2aff8416fba65$var$_transformProp];
        style[$9bb2aff8416fba65$var$_transformProp] = transforms;
        endCache = $9bb2aff8416fba65$var$_parseTransform(target, 1);
        style[$9bb2aff8416fba65$var$_transformProp] = startValue;
    }
    for(p in $9bb2aff8416fba65$var$_transformProps){
        startValue = startCache[p];
        endValue = endCache[p];
        if (startValue !== endValue && exclude.indexOf(p) < 0) {
            //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
            startUnit = (0, $5jmTd.getUnit)(startValue);
            endUnit = (0, $5jmTd.getUnit)(endValue);
            startNum = startUnit !== endUnit ? $9bb2aff8416fba65$var$_convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
            endNum = parseFloat(endValue);
            plugin._pt = new (0, $5jmTd.PropTween)(plugin._pt, endCache, p, startNum, endNum - startNum, $9bb2aff8416fba65$var$_renderCSSProp);
            plugin._pt.u = endUnit || 0;
            plugin._props.push(p);
        }
    }
    $9bb2aff8416fba65$var$_assign(endCache, startCache);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.
(0, $5jmTd._forEachName)("padding,margin,Width,Radius", function(name, index) {
    var t = "Top", r = "Right", b = "Bottom", l = "Left", props = (index < 3 ? [
        t,
        r,
        b,
        l
    ] : [
        t + l,
        t + r,
        b + r,
        b + l
    ]).map(function(side) {
        return index < 2 ? name + side : "border" + side + name;
    });
    $9bb2aff8416fba65$var$_specialProps[index > 1 ? "border" + name : name] = function(plugin, target, property, endValue, tween) {
        var a, vars;
        if (arguments.length < 4) {
            // getter, passed target, property, and unit (from _get())
            a = props.map(function(prop) {
                return $9bb2aff8416fba65$var$_get(plugin, prop, property);
            });
            vars = a.join(" ");
            return vars.split(a[0]).length === 5 ? a[0] : vars;
        }
        a = (endValue + "").split(" ");
        vars = {};
        props.forEach(function(prop, i) {
            return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
        });
        plugin.init(target, vars, tween);
    };
});
var $9bb2aff8416fba65$export$855822f522f18eef = {
    name: "css",
    register: $9bb2aff8416fba65$var$_initCore,
    targetTest: function targetTest(target) {
        return target.style && target.nodeType;
    },
    init: function init(target, vars, tween, index, targets) {
        var props = this._props, style = target.style, startAt = tween.vars.startAt, startValue, endValue, endNum, startNum, type, specialProp, p, startUnit, endUnit, relative, isTransformRelated, transformPropTween, cache, smooth, hasPriority, inlineProps;
        $9bb2aff8416fba65$var$_pluginInitted || $9bb2aff8416fba65$var$_initCore(); // we may call init() multiple times on the same plugin instance, like when adding special properties, so make sure we don't overwrite the revert data or inlineProps
        this.styles = this.styles || $9bb2aff8416fba65$var$_getStyleSaver(target);
        inlineProps = this.styles.props;
        this.tween = tween;
        for(p in vars){
            if (p === "autoRound") continue;
            endValue = vars[p];
            if ((0, $5jmTd._plugins)[p] && (0, $5jmTd._checkPlugin)(p, vars, tween, index, target, targets)) continue;
            type = typeof endValue;
            specialProp = $9bb2aff8416fba65$var$_specialProps[p];
            if (type === "function") {
                endValue = endValue.call(tween, index, target, targets);
                type = typeof endValue;
            }
            if (type === "string" && ~endValue.indexOf("random(")) endValue = (0, $5jmTd._replaceRandom)(endValue);
            if (specialProp) specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
            else if (p.substr(0, 2) === "--") {
                //CSS variable
                startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
                endValue += "";
                (0, $5jmTd._colorExp).lastIndex = 0;
                if (!(0, $5jmTd._colorExp).test(startValue)) {
                    // colors don't have units
                    startUnit = (0, $5jmTd.getUnit)(startValue);
                    endUnit = (0, $5jmTd.getUnit)(endValue);
                }
                endUnit ? startUnit !== endUnit && (startValue = $9bb2aff8416fba65$var$_convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
                this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
                props.push(p);
                inlineProps.push(p, 0, style[p]);
            } else if (type !== "undefined") {
                if (startAt && p in startAt) {
                    // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
                    startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
                    (0, $5jmTd._isString)(startValue) && ~startValue.indexOf("random(") && (startValue = (0, $5jmTd._replaceRandom)(startValue));
                    (0, $5jmTd.getUnit)(startValue + "") || startValue === "auto" || (startValue += (0, $5jmTd._config).units[p] || (0, $5jmTd.getUnit)($9bb2aff8416fba65$var$_get(target, p)) || ""); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.
                    (startValue + "").charAt(1) === "=" && (startValue = $9bb2aff8416fba65$var$_get(target, p)); // can't work with relative values
                } else startValue = $9bb2aff8416fba65$var$_get(target, p);
                startNum = parseFloat(startValue);
                relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
                relative && (endValue = endValue.substr(2));
                endNum = parseFloat(endValue);
                if (p in $9bb2aff8416fba65$var$_propertyAliases) {
                    if (p === "autoAlpha") {
                        //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
                        if (startNum === 1 && $9bb2aff8416fba65$var$_get(target, "visibility") === "hidden" && endNum) //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
                        startNum = 0;
                        inlineProps.push("visibility", 0, style.visibility);
                        $9bb2aff8416fba65$var$_addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
                    }
                    if (p !== "scale" && p !== "transform") {
                        p = $9bb2aff8416fba65$var$_propertyAliases[p];
                        ~p.indexOf(",") && (p = p.split(",")[0]);
                    }
                }
                isTransformRelated = p in $9bb2aff8416fba65$var$_transformProps; //--- TRANSFORM-RELATED ---
                if (isTransformRelated) {
                    this.styles.save(p);
                    if (!transformPropTween) {
                        cache = target._gsap;
                        cache.renderTransform && !vars.parseTransform || $9bb2aff8416fba65$var$_parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.
                        smooth = vars.smoothOrigin !== false && cache.smooth;
                        transformPropTween = this._pt = new (0, $5jmTd.PropTween)(this._pt, style, $9bb2aff8416fba65$var$_transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)
                        transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
                    }
                    if (p === "scale") {
                        this._pt = new (0, $5jmTd.PropTween)(this._pt, cache, "scaleY", cache.scaleY, (relative ? (0, $5jmTd._parseRelative)(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, $9bb2aff8416fba65$var$_renderCSSProp);
                        this._pt.u = 0;
                        props.push("scaleY", p);
                        p += "X";
                    } else if (p === "transformOrigin") {
                        inlineProps.push($9bb2aff8416fba65$var$_transformOriginProp, 0, style[$9bb2aff8416fba65$var$_transformOriginProp]);
                        endValue = $9bb2aff8416fba65$var$_convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.
                        if (cache.svg) $9bb2aff8416fba65$var$_applySVGOrigin(target, endValue, 0, smooth, 0, this);
                        else {
                            endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!
                            endUnit !== cache.zOrigin && $9bb2aff8416fba65$var$_addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
                            $9bb2aff8416fba65$var$_addNonTweeningPT(this, style, p, $9bb2aff8416fba65$var$_firstTwoOnly(startValue), $9bb2aff8416fba65$var$_firstTwoOnly(endValue));
                        }
                        continue;
                    } else if (p === "svgOrigin") {
                        $9bb2aff8416fba65$var$_applySVGOrigin(target, endValue, 1, smooth, 0, this);
                        continue;
                    } else if (p in $9bb2aff8416fba65$var$_rotationalProperties) {
                        $9bb2aff8416fba65$var$_addRotationalPropTween(this, cache, p, startNum, relative ? (0, $5jmTd._parseRelative)(startNum, relative + endValue) : endValue);
                        continue;
                    } else if (p === "smoothOrigin") {
                        $9bb2aff8416fba65$var$_addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
                        continue;
                    } else if (p === "force3D") {
                        cache[p] = endValue;
                        continue;
                    } else if (p === "transform") {
                        $9bb2aff8416fba65$var$_addRawTransformPTs(this, endValue, target);
                        continue;
                    }
                } else if (!(p in style)) p = $9bb2aff8416fba65$export$8cbef5dd49a09c8b(p) || p;
                if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !$9bb2aff8416fba65$var$_complexExp.test(endValue) && p in style) {
                    startUnit = (startValue + "").substr((startNum + "").length);
                    endNum || (endNum = 0); // protect against NaN
                    endUnit = (0, $5jmTd.getUnit)(endValue) || (p in (0, $5jmTd._config).units ? (0, $5jmTd._config).units[p] : startUnit);
                    startUnit !== endUnit && (startNum = $9bb2aff8416fba65$var$_convertToUnit(target, p, startValue, endUnit));
                    this._pt = new (0, $5jmTd.PropTween)(this._pt, isTransformRelated ? cache : style, p, startNum, (relative ? (0, $5jmTd._parseRelative)(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? $9bb2aff8416fba65$var$_renderRoundedCSSProp : $9bb2aff8416fba65$var$_renderCSSProp);
                    this._pt.u = endUnit || 0;
                    if (startUnit !== endUnit && endUnit !== "%") {
                        //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
                        this._pt.b = startValue;
                        this._pt.r = $9bb2aff8416fba65$var$_renderCSSPropWithBeginning;
                    }
                } else if (!(p in style)) {
                    if (p in target) //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
                    this.add(target, p, startValue || target[p], relative ? relative + endValue : endValue, index, targets);
                    else if (p !== "parseTransform") {
                        (0, $5jmTd._missingPlugin)(p, endValue);
                        continue;
                    }
                } else $9bb2aff8416fba65$var$_tweenComplexCSSString.call(this, target, p, startValue, relative ? relative + endValue : endValue);
                isTransformRelated || (p in style ? inlineProps.push(p, 0, style[p]) : inlineProps.push(p, 1, startValue || target[p]));
                props.push(p);
            }
        }
        hasPriority && (0, $5jmTd._sortPropTweensByPriority)(this);
    },
    render: function render(ratio, data) {
        if (data.tween._time || !$9bb2aff8416fba65$var$_reverting()) {
            var pt = data._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
        } else data.styles.revert();
    },
    get: $9bb2aff8416fba65$var$_get,
    aliases: $9bb2aff8416fba65$var$_propertyAliases,
    getSetter: function getSetter(target, property, plugin) {
        //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
        var p = $9bb2aff8416fba65$var$_propertyAliases[property];
        p && p.indexOf(",") < 0 && (property = p);
        return property in $9bb2aff8416fba65$var$_transformProps && property !== $9bb2aff8416fba65$var$_transformOriginProp && (target._gsap.x || $9bb2aff8416fba65$var$_get(target, "x")) ? plugin && $9bb2aff8416fba65$var$_recentSetterPlugin === plugin ? property === "scale" ? $9bb2aff8416fba65$var$_setterScale : $9bb2aff8416fba65$var$_setterTransform : ($9bb2aff8416fba65$var$_recentSetterPlugin = plugin || {}, property === "scale" ? $9bb2aff8416fba65$var$_setterScaleWithRender : $9bb2aff8416fba65$var$_setterTransformWithRender) : target.style && !(0, $5jmTd._isUndefined)(target.style[property]) ? $9bb2aff8416fba65$var$_setterCSSStyle : ~property.indexOf("-") ? $9bb2aff8416fba65$var$_setterCSSProp : (0, $5jmTd._getSetter)(target, property);
    },
    core: {
        _removeProperty: $9bb2aff8416fba65$var$_removeProperty,
        _getMatrix: $9bb2aff8416fba65$var$_getMatrix
    }
};
(0, $5jmTd.gsap).utils.checkPrefix = $9bb2aff8416fba65$export$8cbef5dd49a09c8b;
(0, $5jmTd.gsap).core.getStyleSaver = $9bb2aff8416fba65$var$_getStyleSaver;
(function(positionAndScale, rotation, others, aliases) {
    var all = (0, $5jmTd._forEachName)(positionAndScale + "," + rotation + "," + others, function(name) {
        $9bb2aff8416fba65$var$_transformProps[name] = 1;
    });
    (0, $5jmTd._forEachName)(rotation, function(name) {
        (0, $5jmTd._config).units[name] = "deg";
        $9bb2aff8416fba65$var$_rotationalProperties[name] = 1;
    });
    $9bb2aff8416fba65$var$_propertyAliases[all[13]] = positionAndScale + "," + rotation;
    (0, $5jmTd._forEachName)(aliases, function(name) {
        var split = name.split(":");
        $9bb2aff8416fba65$var$_propertyAliases[split[1]] = all[split[0]];
    });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
(0, $5jmTd._forEachName)("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(name) {
    (0, $5jmTd._config).units[name] = "px";
});
(0, $5jmTd.gsap).registerPlugin($9bb2aff8416fba65$export$855822f522f18eef);


var $b57bb984cb8a78c2$export$99ee26438460406a = (0, $5jmTd.gsap).registerPlugin((0, $9bb2aff8416fba65$export$855822f522f18eef)) || (0, $5jmTd.gsap), // to protect from tree shaking
$b57bb984cb8a78c2$export$7b23975ad686bf91 = $b57bb984cb8a78c2$export$99ee26438460406a.core.Tween;


const $25a997d08116e9dc$var$scalpingSection = document.querySelector("#scalping");
if ($25a997d08116e9dc$var$scalpingSection) {
    let svgns = "http://www.w3.org/2000/svg";
    let root = document.querySelector(".glow-svg");
    let ease = 0.75;
    let pointer = {
        x: window.innerWidth / 2,
        y: window.innerHeight / 2
    };
    const handleMouseMove = (event)=>{
        const scalpingSectionRect = $25a997d08116e9dc$var$scalpingSection.getBoundingClientRect();
        if (event.clientY - scalpingSectionRect.top <= 300) (0, $b57bb984cb8a78c2$export$99ee26438460406a).to("line", {
            opacity: 0,
            y: 300
        });
        else if (scalpingSectionRect.top + scalpingSectionRect.height - event.clientY <= 300) (0, $b57bb984cb8a78c2$export$99ee26438460406a).to("line", {
            opacity: 0,
            y: scalpingSectionRect.height - 300
        });
        else (0, $b57bb984cb8a78c2$export$99ee26438460406a).to("line", {
            opacity: 1
        });
        pointer.x = event.clientX - scalpingSectionRect.left;
        pointer.y = event.clientY - scalpingSectionRect.top;
    };
    $25a997d08116e9dc$var$scalpingSection.addEventListener("mousemove", handleMouseMove);
    let leader = (prop)=>{
        return prop === "x" ? pointer.x : pointer.y;
    };
    const createLine = (leader, i)=>{
        let line = document.createElementNS(svgns, "line");
        root.appendChild(line);
        (0, $b57bb984cb8a78c2$export$99ee26438460406a).set(line, {
            x: -15,
            y: -15,
            opacity: (total - i) / total
        });
        let pos = (0, $b57bb984cb8a78c2$export$99ee26438460406a).getProperty(line);
        (0, $b57bb984cb8a78c2$export$99ee26438460406a).to(line, {
            duration: 0.1,
            x: "+=1",
            y: "+=1",
            repeat: -1,
            ease: "none",
            modifiers: {
                x: ()=>{
                    let posX = pos("x");
                    let leaderX = leader("x");
                    let x = posX + (leaderX - posX) * ease;
                    line.setAttribute("x2", leaderX - x);
                    return x;
                },
                y: ()=>{
                    let posY = pos("y");
                    let leaderY = leader("y");
                    let y = posY + (leaderY - posY) * ease;
                    line.setAttribute("y2", leaderY - y);
                    return y;
                }
            }
        });
        return pos;
    };
    let total = 150;
    for(let i = 0; i < total; i++)leader = createLine(leader, i);
}





const $030b0e797b9b5804$var$scalpingPopupSlider = document.querySelector(".scalping-videos-slider");
if ($030b0e797b9b5804$var$scalpingPopupSlider) new (0, $7b90f2d36df6fcf3$export$25ce5a424b770e84)($030b0e797b9b5804$var$scalpingPopupSlider, {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    navigation: {
        nextEl: ".scalping-videos-slider__nav-btn.next",
        prevEl: ".scalping-videos-slider__nav-btn.prev"
    },
    modules: [
        (0, $56d57b52593640f1$export$2e2bcd8739ae039)
    ],
    on: {
        slideChange: (0, $0890d11936b843d8$export$b5a871295b086ce9)
    }
});
const $030b0e797b9b5804$var$studentsStatsSlider = document.querySelector(".studets-stats-slider");
if ($030b0e797b9b5804$var$studentsStatsSlider) new (0, $7b90f2d36df6fcf3$export$25ce5a424b770e84)($030b0e797b9b5804$var$studentsStatsSlider, {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    loopAdditionalSlides: 1,
    initialSlide: 2,
    navigation: {
        nextEl: ".studets-stats-slider__nav-btn.next",
        prevEl: ".studets-stats-slider__nav-btn.prev"
    },
    effect: "creative",
    creativeEffect: {
        prev: {
            shadow: true,
            translate: [
                "-95%",
                0,
                -700
            ]
        },
        next: {
            shadow: true,
            translate: [
                "95%",
                0,
                -700
            ]
        }
    },
    modules: [
        (0, $56d57b52593640f1$export$2e2bcd8739ae039),
        (0, $9df61b3466b3b499$export$2e2bcd8739ae039)
    ]
});
const $030b0e797b9b5804$var$reviewsSlider = document.querySelector(".reviews-slider");
if ($030b0e797b9b5804$var$reviewsSlider) new (0, $7b90f2d36df6fcf3$export$25ce5a424b770e84)($030b0e797b9b5804$var$reviewsSlider, {
    slidesPerView: 1,
    centeredSlides: true,
    spaceBetween: 56,
    loop: true,
    loopAdditionalSlides: 1,
    allowTouchMove: false,
    navigation: {
        nextEl: ".reviews-slider__btn.next",
        prevEl: ".reviews-slider__btn.prev"
    },
    modules: [
        (0, $56d57b52593640f1$export$2e2bcd8739ae039)
    ],
    initialSlide: 1,
    breakpoints: {
        768: {
            spaceBetween: 50
        },
        1280: {
            spaceBetween: 55
        },
        1440: {
            spaceBetween: 60
        },
        1560: {
            spaceBetween: 116
        }
    }
});
const $030b0e797b9b5804$var$scalpingEffectivitySlider = document.querySelector(".scalping-effectivity-slider");
if ($030b0e797b9b5804$var$scalpingEffectivitySlider) new (0, $7b90f2d36df6fcf3$export$25ce5a424b770e84)($030b0e797b9b5804$var$scalpingEffectivitySlider, {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    navigation: {
        nextEl: ".scalping-effectivity-slider__btn.next",
        prevEl: ".scalping-effectivity-slider__btn.prev"
    },
    modules: [
        (0, $56d57b52593640f1$export$2e2bcd8739ae039)
    ],
    breakpoints: {
        768: {
            slidesPerView: 2
        },
        1280: {
            slidesPerView: 3
        }
    }
});
const $030b0e797b9b5804$var$participantsDeals = document.querySelector(".participants-deals-slider");
if ($030b0e797b9b5804$var$participantsDeals) new (0, $7b90f2d36df6fcf3$export$25ce5a424b770e84)($030b0e797b9b5804$var$participantsDeals, {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    loopAdditionalSlides: 1,
    initialSlide: 2,
    navigation: {
        nextEl: ".participants-deals-slider__nav-btn.next",
        prevEl: ".participants-deals-slider__nav-btn.prev"
    },
    effect: "creative",
    creativeEffect: {
        prev: {
            shadow: true,
            translate: [
                "-70%",
                0,
                -800
            ]
        },
        next: {
            shadow: true,
            translate: [
                "70%",
                0,
                -800
            ]
        }
    },
    modules: [
        (0, $56d57b52593640f1$export$2e2bcd8739ae039),
        (0, $9df61b3466b3b499$export$2e2bcd8739ae039)
    ]
});



var $5d06d6416fb3ab3b$require$pauseAllPlayers = $0890d11936b843d8$export$b5a871295b086ce9;
const $5d06d6416fb3ab3b$var$body = document.querySelector("body");
const $5d06d6416fb3ab3b$var$popupOpenBtns = document.querySelectorAll("[data-popup-open]");
const $5d06d6416fb3ab3b$export$10d7d627988df375 = (id)=>{
    const popup = document.querySelector(`#${id}`);
    if (popup) popup.classList.add("is-open");
    else throw new Error("Popup not found");
};
$5d06d6416fb3ab3b$var$popupOpenBtns.forEach((btn)=>{
    btn.addEventListener("click", ()=>{
        const popupId = btn.getAttribute("data-popup-open");
        $5d06d6416fb3ab3b$export$10d7d627988df375(popupId);
        $5d06d6416fb3ab3b$var$body.style.overflow = "hidden";
    });
});
const $5d06d6416fb3ab3b$var$popupCloseBtns = document.querySelectorAll("[data-popup-close]");
$5d06d6416fb3ab3b$var$popupCloseBtns.forEach((btn)=>{
    btn.addEventListener("click", ()=>{
        const popupId = btn.getAttribute("data-popup-close");
        const popup = document.querySelector(`#${popupId}`);
        if (popup) {
            popup.classList.remove("is-open");
            $5d06d6416fb3ab3b$require$pauseAllPlayers();
            $5d06d6416fb3ab3b$var$body.style.overflow = "";
        } else throw new Error("Popup not found");
    });
});


const $08401bf2c0b2bd23$var$header = document.querySelector(".header");
const $08401bf2c0b2bd23$var$dropMenu = document.querySelector(".header__drop-menu");
const $08401bf2c0b2bd23$var$deskBurger = document.querySelector("#desk-burger");
const $08401bf2c0b2bd23$var$mobBurger = document.querySelector("#mob-burger");
const $08401bf2c0b2bd23$var$mobMenu = document.querySelector(".header__mob-menu");
const $08401bf2c0b2bd23$var$body = document.querySelector("body");
if ($08401bf2c0b2bd23$var$header) {
    let headerHeight1 = $08401bf2c0b2bd23$var$header.offsetHeight;
    $08401bf2c0b2bd23$var$header.style.setProperty("--header-height", `${headerHeight1}px`);
}
if ($08401bf2c0b2bd23$var$deskBurger && $08401bf2c0b2bd23$var$dropMenu) {
    const dropMenuLinks = $08401bf2c0b2bd23$var$dropMenu.querySelectorAll(".header__drop-menu-link");
    $08401bf2c0b2bd23$var$deskBurger.addEventListener("click", ()=>{
        $08401bf2c0b2bd23$var$dropMenu.classList.toggle("active");
        $08401bf2c0b2bd23$var$deskBurger.classList.toggle("active");
    });
    dropMenuLinks.forEach((link)=>{
        link.addEventListener("click", ()=>{
            $08401bf2c0b2bd23$var$dropMenu.classList.remove("active");
            $08401bf2c0b2bd23$var$deskBurger.classList.remove("active");
        });
    });
}
if ($08401bf2c0b2bd23$var$mobBurger && $08401bf2c0b2bd23$var$mobMenu) {
    const mobMenuLinks = $08401bf2c0b2bd23$var$mobMenu.querySelectorAll(".header__mob-menu-link");
    $08401bf2c0b2bd23$var$mobBurger.addEventListener("click", ()=>{
        $08401bf2c0b2bd23$var$mobMenu.classList.toggle("active");
        $08401bf2c0b2bd23$var$mobBurger.classList.toggle("active");
        $08401bf2c0b2bd23$var$body.classList.toggle("no-scroll");
    });
    mobMenuLinks.forEach((link)=>{
        link.addEventListener("click", ()=>{
            $08401bf2c0b2bd23$var$mobMenu.classList.remove("active");
            $08401bf2c0b2bd23$var$mobBurger.classList.remove("active");
            $08401bf2c0b2bd23$var$body.classList.toggle("no-scroll");
        });
    });
}
window.addEventListener("scroll", ()=>{
    if (window.scrollY > 0) document.querySelector(".header").classList.add("scroll");
    else document.querySelector(".header").classList.remove("scroll");
});
window.addEventListener("click", (event)=>{
    if (!event.target.closest(".header__burger") && !event.target.closest(".header__drop-menu")) {
        $08401bf2c0b2bd23$var$dropMenu.classList.remove("active");
        $08401bf2c0b2bd23$var$deskBurger.classList.remove("active");
    }
});
window.addEventListener("resize", ()=>{
    headerHeight = $08401bf2c0b2bd23$var$header.offsetHeight;
    $08401bf2c0b2bd23$var$header.style.setProperty("--header-height", `${headerHeight}px`);
});
const $08401bf2c0b2bd23$var$langSelectors = document.querySelectorAll(".lang-selector");
$08401bf2c0b2bd23$var$langSelectors.forEach((langSelector)=>{
    langSelector.addEventListener("click", ()=>{
        langSelector.classList.toggle("active");
    });
    window.addEventListener("click", (event)=>{
        if (!event.target.closest(".lang-selector")) langSelector.classList.remove("active");
    });
});


const $f2a345bff0343e62$var$heroSection = document.querySelector(".hero-section");
if ($f2a345bff0343e62$var$heroSection) {
    const hero = document.querySelector(".hero");
    const setPaddingByAspectRation = ()=>{
        const heroSectionHeight = $f2a345bff0343e62$var$heroSection.offsetHeight;
        const heroSectionWidth = $f2a345bff0343e62$var$heroSection.offsetWidth;
        const aspectRatio = heroSectionWidth / heroSectionHeight;
        hero.setAttribute("style", `--padding-top: ${heroSectionHeight * 0.2 / aspectRatio}px`);
    };
    setPaddingByAspectRation();
    window.addEventListener("resize", setPaddingByAspectRation);
}


const $0fa4e7d490acc23e$var$blogSection = document.querySelector(".blog-section");
if ($0fa4e7d490acc23e$var$blogSection) {
    const showMoreBtn = $0fa4e7d490acc23e$var$blogSection.querySelector(".blog-section__btn");
    const pageSize = window.innerWidth > 768 ? 6 : 3;
    const initPagination = ()=>{
        const blogCards = $0fa4e7d490acc23e$var$blogSection.querySelectorAll(".blog-card");
        blogCards.forEach((card, index)=>{
            if (index >= pageSize) card.classList.add("hidden");
        });
        if (blogCards.length <= pageSize) showMoreBtn.classList.add("hidden");
    };
    initPagination();
    const nextPage = ()=>{
        const blogCards = $0fa4e7d490acc23e$var$blogSection.querySelectorAll(".blog-card.hidden");
        [
            ...blogCards
        ].slice(0, pageSize).forEach((card)=>{
            card.classList.remove("hidden");
        });
        if (blogCards.length <= pageSize) showMoreBtn.classList.add("hidden");
    };
    showMoreBtn.addEventListener("click", nextPage);
}


const $fbc02ca866c545a1$var$thankYouSection = document.querySelector(".thank-you");
if ($fbc02ca866c545a1$var$thankYouSection) {
    // const urlParams = new URLSearchParams(window.location.search);
    // const formParam = urlParams.get('form');
    // window.gtag('event', formParam ?? 'unknown');
    window.fbq("track", "Lead");
    window.open("https://t.me/peterson_trade_bot", "_self");
}



"use strict";
function $4cfbf69ecbb0da0d$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


var $c4060b902da94640$exports = {};
// shim for using process in browser
var $c4060b902da94640$var$process = $c4060b902da94640$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $c4060b902da94640$var$cachedSetTimeout;
var $c4060b902da94640$var$cachedClearTimeout;
function $c4060b902da94640$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $c4060b902da94640$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $c4060b902da94640$var$cachedSetTimeout = setTimeout;
        else $c4060b902da94640$var$cachedSetTimeout = $c4060b902da94640$var$defaultSetTimout;
    } catch (e) {
        $c4060b902da94640$var$cachedSetTimeout = $c4060b902da94640$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $c4060b902da94640$var$cachedClearTimeout = clearTimeout;
        else $c4060b902da94640$var$cachedClearTimeout = $c4060b902da94640$var$defaultClearTimeout;
    } catch (e) {
        $c4060b902da94640$var$cachedClearTimeout = $c4060b902da94640$var$defaultClearTimeout;
    }
})();
function $c4060b902da94640$var$runTimeout(fun) {
    if ($c4060b902da94640$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($c4060b902da94640$var$cachedSetTimeout === $c4060b902da94640$var$defaultSetTimout || !$c4060b902da94640$var$cachedSetTimeout) && setTimeout) {
        $c4060b902da94640$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $c4060b902da94640$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $c4060b902da94640$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $c4060b902da94640$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $c4060b902da94640$var$runClearTimeout(marker) {
    if ($c4060b902da94640$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($c4060b902da94640$var$cachedClearTimeout === $c4060b902da94640$var$defaultClearTimeout || !$c4060b902da94640$var$cachedClearTimeout) && clearTimeout) {
        $c4060b902da94640$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $c4060b902da94640$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $c4060b902da94640$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $c4060b902da94640$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $c4060b902da94640$var$queue = [];
var $c4060b902da94640$var$draining = false;
var $c4060b902da94640$var$currentQueue;
var $c4060b902da94640$var$queueIndex = -1;
function $c4060b902da94640$var$cleanUpNextTick() {
    if (!$c4060b902da94640$var$draining || !$c4060b902da94640$var$currentQueue) return;
    $c4060b902da94640$var$draining = false;
    if ($c4060b902da94640$var$currentQueue.length) $c4060b902da94640$var$queue = $c4060b902da94640$var$currentQueue.concat($c4060b902da94640$var$queue);
    else $c4060b902da94640$var$queueIndex = -1;
    if ($c4060b902da94640$var$queue.length) $c4060b902da94640$var$drainQueue();
}
function $c4060b902da94640$var$drainQueue() {
    if ($c4060b902da94640$var$draining) return;
    var timeout = $c4060b902da94640$var$runTimeout($c4060b902da94640$var$cleanUpNextTick);
    $c4060b902da94640$var$draining = true;
    var len = $c4060b902da94640$var$queue.length;
    while(len){
        $c4060b902da94640$var$currentQueue = $c4060b902da94640$var$queue;
        $c4060b902da94640$var$queue = [];
        while(++$c4060b902da94640$var$queueIndex < len)if ($c4060b902da94640$var$currentQueue) $c4060b902da94640$var$currentQueue[$c4060b902da94640$var$queueIndex].run();
        $c4060b902da94640$var$queueIndex = -1;
        len = $c4060b902da94640$var$queue.length;
    }
    $c4060b902da94640$var$currentQueue = null;
    $c4060b902da94640$var$draining = false;
    $c4060b902da94640$var$runClearTimeout(timeout);
}
$c4060b902da94640$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $c4060b902da94640$var$queue.push(new $c4060b902da94640$var$Item(fun, args));
    if ($c4060b902da94640$var$queue.length === 1 && !$c4060b902da94640$var$draining) $c4060b902da94640$var$runTimeout($c4060b902da94640$var$drainQueue);
};
// v8 likes predictible objects
function $c4060b902da94640$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$c4060b902da94640$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$c4060b902da94640$var$process.title = "browser";
$c4060b902da94640$var$process.browser = true;
$c4060b902da94640$var$process.env = {};
$c4060b902da94640$var$process.argv = [];
$c4060b902da94640$var$process.version = ""; // empty string to avoid regexp issues
$c4060b902da94640$var$process.versions = {};
function $c4060b902da94640$var$noop() {}
$c4060b902da94640$var$process.on = $c4060b902da94640$var$noop;
$c4060b902da94640$var$process.addListener = $c4060b902da94640$var$noop;
$c4060b902da94640$var$process.once = $c4060b902da94640$var$noop;
$c4060b902da94640$var$process.off = $c4060b902da94640$var$noop;
$c4060b902da94640$var$process.removeListener = $c4060b902da94640$var$noop;
$c4060b902da94640$var$process.removeAllListeners = $c4060b902da94640$var$noop;
$c4060b902da94640$var$process.emit = $c4060b902da94640$var$noop;
$c4060b902da94640$var$process.prependListener = $c4060b902da94640$var$noop;
$c4060b902da94640$var$process.prependOnceListener = $c4060b902da94640$var$noop;
$c4060b902da94640$var$process.listeners = function(name) {
    return [];
};
$c4060b902da94640$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$c4060b902da94640$var$process.cwd = function() {
    return "/";
};
$c4060b902da94640$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$c4060b902da94640$var$process.umask = function() {
    return 0;
};


"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $1defda52afdec17e$var$toString } = Object.prototype;
const { getPrototypeOf: $1defda52afdec17e$var$getPrototypeOf } = Object;
const $1defda52afdec17e$var$kindOf = ((cache)=>(thing)=>{
        const str = $1defda52afdec17e$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $1defda52afdec17e$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$1defda52afdec17e$var$kindOf(thing) === type;
};
const $1defda52afdec17e$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $1defda52afdec17e$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $1defda52afdec17e$var$isUndefined = $1defda52afdec17e$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $1defda52afdec17e$var$isBuffer(val) {
    return val !== null && !$1defda52afdec17e$var$isUndefined(val) && val.constructor !== null && !$1defda52afdec17e$var$isUndefined(val.constructor) && $1defda52afdec17e$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $1defda52afdec17e$var$isArrayBuffer = $1defda52afdec17e$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $1defda52afdec17e$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $1defda52afdec17e$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $1defda52afdec17e$var$isString = $1defda52afdec17e$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $1defda52afdec17e$var$isFunction = $1defda52afdec17e$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $1defda52afdec17e$var$isNumber = $1defda52afdec17e$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $1defda52afdec17e$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $1defda52afdec17e$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $1defda52afdec17e$var$isPlainObject = (val)=>{
    if ($1defda52afdec17e$var$kindOf(val) !== "object") return false;
    const prototype = $1defda52afdec17e$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $1defda52afdec17e$var$isDate = $1defda52afdec17e$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $1defda52afdec17e$var$isFile = $1defda52afdec17e$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $1defda52afdec17e$var$isBlob = $1defda52afdec17e$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $1defda52afdec17e$var$isFileList = $1defda52afdec17e$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $1defda52afdec17e$var$isStream = (val)=>$1defda52afdec17e$var$isObject(val) && $1defda52afdec17e$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $1defda52afdec17e$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $1defda52afdec17e$var$isFunction(thing.append) && ((kind = $1defda52afdec17e$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $1defda52afdec17e$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $1defda52afdec17e$var$isURLSearchParams = $1defda52afdec17e$var$kindOfTest("URLSearchParams");
const [$1defda52afdec17e$var$isReadableStream, $1defda52afdec17e$var$isRequest, $1defda52afdec17e$var$isResponse, $1defda52afdec17e$var$isHeaders] = [
    "ReadableStream",
    "Request",
    "Response",
    "Headers"
].map($1defda52afdec17e$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $1defda52afdec17e$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $1defda52afdec17e$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($1defda52afdec17e$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $1defda52afdec17e$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $1defda52afdec17e$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $1defda52afdec17e$var$isContextDefined = (context)=>!$1defda52afdec17e$var$isUndefined(context) && context !== $1defda52afdec17e$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $1defda52afdec17e$var$merge() {
    const { caseless: caseless } = $1defda52afdec17e$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $1defda52afdec17e$var$findKey(result, key) || key;
        if ($1defda52afdec17e$var$isPlainObject(result[targetKey]) && $1defda52afdec17e$var$isPlainObject(val)) result[targetKey] = $1defda52afdec17e$var$merge(result[targetKey], val);
        else if ($1defda52afdec17e$var$isPlainObject(val)) result[targetKey] = $1defda52afdec17e$var$merge({}, val);
        else if ($1defda52afdec17e$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $1defda52afdec17e$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $1defda52afdec17e$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $1defda52afdec17e$var$forEach(b, (val, key)=>{
        if (thisArg && $1defda52afdec17e$var$isFunction(val)) a[key] = (0, $4cfbf69ecbb0da0d$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $1defda52afdec17e$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $1defda52afdec17e$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $1defda52afdec17e$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $1defda52afdec17e$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $1defda52afdec17e$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $1defda52afdec17e$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($1defda52afdec17e$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$1defda52afdec17e$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $1defda52afdec17e$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $1defda52afdec17e$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $1defda52afdec17e$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $1defda52afdec17e$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $1defda52afdec17e$var$isHTMLForm = $1defda52afdec17e$var$kindOfTest("HTMLFormElement");
const $1defda52afdec17e$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $1defda52afdec17e$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $1defda52afdec17e$var$isRegExp = $1defda52afdec17e$var$kindOfTest("RegExp");
const $1defda52afdec17e$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $1defda52afdec17e$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $1defda52afdec17e$var$freezeMethods = (obj)=>{
    $1defda52afdec17e$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($1defda52afdec17e$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$1defda52afdec17e$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $1defda52afdec17e$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $1defda52afdec17e$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $1defda52afdec17e$var$noop = ()=>{};
const $1defda52afdec17e$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
const $1defda52afdec17e$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $1defda52afdec17e$var$DIGIT = "0123456789";
const $1defda52afdec17e$var$ALPHABET = {
    DIGIT: $1defda52afdec17e$var$DIGIT,
    ALPHA: $1defda52afdec17e$var$ALPHA,
    ALPHA_DIGIT: $1defda52afdec17e$var$ALPHA + $1defda52afdec17e$var$ALPHA.toUpperCase() + $1defda52afdec17e$var$DIGIT
};
const $1defda52afdec17e$var$generateString = (size = 16, alphabet = $1defda52afdec17e$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $1defda52afdec17e$var$isSpecCompliantForm(thing) {
    return !!(thing && $1defda52afdec17e$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $1defda52afdec17e$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($1defda52afdec17e$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $1defda52afdec17e$var$isArray(source) ? [] : {};
                $1defda52afdec17e$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$1defda52afdec17e$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $1defda52afdec17e$var$isAsyncFn = $1defda52afdec17e$var$kindOfTest("AsyncFunction");
const $1defda52afdec17e$var$isThenable = (thing)=>thing && ($1defda52afdec17e$var$isObject(thing) || $1defda52afdec17e$var$isFunction(thing)) && $1defda52afdec17e$var$isFunction(thing.then) && $1defda52afdec17e$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $1defda52afdec17e$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $1defda52afdec17e$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $1defda52afdec17e$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $1defda52afdec17e$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === "function", $1defda52afdec17e$var$isFunction($1defda52afdec17e$var$_global.postMessage));
const $1defda52afdec17e$var$asap = typeof queueMicrotask !== "undefined" ? queueMicrotask.bind($1defda52afdec17e$var$_global) : typeof $c4060b902da94640$exports !== "undefined" && $c4060b902da94640$exports.nextTick || $1defda52afdec17e$var$_setImmediate;
var // *********************
$1defda52afdec17e$export$2e2bcd8739ae039 = {
    isArray: $1defda52afdec17e$var$isArray,
    isArrayBuffer: $1defda52afdec17e$var$isArrayBuffer,
    isBuffer: $1defda52afdec17e$var$isBuffer,
    isFormData: $1defda52afdec17e$var$isFormData,
    isArrayBufferView: $1defda52afdec17e$var$isArrayBufferView,
    isString: $1defda52afdec17e$var$isString,
    isNumber: $1defda52afdec17e$var$isNumber,
    isBoolean: $1defda52afdec17e$var$isBoolean,
    isObject: $1defda52afdec17e$var$isObject,
    isPlainObject: $1defda52afdec17e$var$isPlainObject,
    isReadableStream: $1defda52afdec17e$var$isReadableStream,
    isRequest: $1defda52afdec17e$var$isRequest,
    isResponse: $1defda52afdec17e$var$isResponse,
    isHeaders: $1defda52afdec17e$var$isHeaders,
    isUndefined: $1defda52afdec17e$var$isUndefined,
    isDate: $1defda52afdec17e$var$isDate,
    isFile: $1defda52afdec17e$var$isFile,
    isBlob: $1defda52afdec17e$var$isBlob,
    isRegExp: $1defda52afdec17e$var$isRegExp,
    isFunction: $1defda52afdec17e$var$isFunction,
    isStream: $1defda52afdec17e$var$isStream,
    isURLSearchParams: $1defda52afdec17e$var$isURLSearchParams,
    isTypedArray: $1defda52afdec17e$var$isTypedArray,
    isFileList: $1defda52afdec17e$var$isFileList,
    forEach: $1defda52afdec17e$var$forEach,
    merge: $1defda52afdec17e$var$merge,
    extend: $1defda52afdec17e$var$extend,
    trim: $1defda52afdec17e$var$trim,
    stripBOM: $1defda52afdec17e$var$stripBOM,
    inherits: $1defda52afdec17e$var$inherits,
    toFlatObject: $1defda52afdec17e$var$toFlatObject,
    kindOf: $1defda52afdec17e$var$kindOf,
    kindOfTest: $1defda52afdec17e$var$kindOfTest,
    endsWith: $1defda52afdec17e$var$endsWith,
    toArray: $1defda52afdec17e$var$toArray,
    forEachEntry: $1defda52afdec17e$var$forEachEntry,
    matchAll: $1defda52afdec17e$var$matchAll,
    isHTMLForm: $1defda52afdec17e$var$isHTMLForm,
    hasOwnProperty: $1defda52afdec17e$var$hasOwnProperty,
    hasOwnProp: $1defda52afdec17e$var$hasOwnProperty,
    reduceDescriptors: $1defda52afdec17e$var$reduceDescriptors,
    freezeMethods: $1defda52afdec17e$var$freezeMethods,
    toObjectSet: $1defda52afdec17e$var$toObjectSet,
    toCamelCase: $1defda52afdec17e$var$toCamelCase,
    noop: $1defda52afdec17e$var$noop,
    toFiniteNumber: $1defda52afdec17e$var$toFiniteNumber,
    findKey: $1defda52afdec17e$var$findKey,
    global: $1defda52afdec17e$var$_global,
    isContextDefined: $1defda52afdec17e$var$isContextDefined,
    ALPHABET: $1defda52afdec17e$var$ALPHABET,
    generateString: $1defda52afdec17e$var$generateString,
    isSpecCompliantForm: $1defda52afdec17e$var$isSpecCompliantForm,
    toJSONObject: $1defda52afdec17e$var$toJSONObject,
    isAsyncFn: $1defda52afdec17e$var$isAsyncFn,
    isThenable: $1defda52afdec17e$var$isThenable,
    setImmediate: $1defda52afdec17e$var$_setImmediate,
    asap: $1defda52afdec17e$var$asap
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $0d41b511ca99bcf2$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, $1defda52afdec17e$export$2e2bcd8739ae039).inherits($0d41b511ca99bcf2$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $1defda52afdec17e$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $0d41b511ca99bcf2$var$prototype = $0d41b511ca99bcf2$var$AxiosError.prototype;
const $0d41b511ca99bcf2$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $0d41b511ca99bcf2$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($0d41b511ca99bcf2$var$AxiosError, $0d41b511ca99bcf2$var$descriptors);
Object.defineProperty($0d41b511ca99bcf2$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$0d41b511ca99bcf2$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($0d41b511ca99bcf2$var$prototype);
    (0, $1defda52afdec17e$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $0d41b511ca99bcf2$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $0d41b511ca99bcf2$export$2e2bcd8739ae039 = $0d41b511ca99bcf2$var$AxiosError;


// eslint-disable-next-line strict
var $8a14ce9a27cf61d8$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $b8ec8e7517d22bf6$export$a143d493d941bafc;
var $b8ec8e7517d22bf6$export$e4cf37d7f6fb9e0a;
var $b8ec8e7517d22bf6$export$f99ded8fe4b79145;
var $b8ec8e7517d22bf6$export$599f31c3813fae4d;
"use strict";
var $526c1158ea453612$export$a48f0734ac7c2329;
var $526c1158ea453612$export$d622b2ad8d90c771;
var $526c1158ea453612$export$6100ba28696e12de;
"use strict";
$526c1158ea453612$export$a48f0734ac7c2329 = $526c1158ea453612$var$byteLength;
$526c1158ea453612$export$d622b2ad8d90c771 = $526c1158ea453612$var$toByteArray;
$526c1158ea453612$export$6100ba28696e12de = $526c1158ea453612$var$fromByteArray;
var $526c1158ea453612$var$lookup = [];
var $526c1158ea453612$var$revLookup = [];
var $526c1158ea453612$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $526c1158ea453612$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $526c1158ea453612$var$i = 0, $526c1158ea453612$var$len = $526c1158ea453612$var$code.length; $526c1158ea453612$var$i < $526c1158ea453612$var$len; ++$526c1158ea453612$var$i){
    $526c1158ea453612$var$lookup[$526c1158ea453612$var$i] = $526c1158ea453612$var$code[$526c1158ea453612$var$i];
    $526c1158ea453612$var$revLookup[$526c1158ea453612$var$code.charCodeAt($526c1158ea453612$var$i)] = $526c1158ea453612$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$526c1158ea453612$var$revLookup["-".charCodeAt(0)] = 62;
$526c1158ea453612$var$revLookup["_".charCodeAt(0)] = 63;
function $526c1158ea453612$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $526c1158ea453612$var$byteLength(b64) {
    var lens = $526c1158ea453612$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $526c1158ea453612$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $526c1158ea453612$var$toByteArray(b64) {
    var tmp;
    var lens = $526c1158ea453612$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $526c1158ea453612$var$Arr($526c1158ea453612$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $526c1158ea453612$var$revLookup[b64.charCodeAt(i)] << 18 | $526c1158ea453612$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $526c1158ea453612$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $526c1158ea453612$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $526c1158ea453612$var$revLookup[b64.charCodeAt(i)] << 2 | $526c1158ea453612$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $526c1158ea453612$var$revLookup[b64.charCodeAt(i)] << 10 | $526c1158ea453612$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $526c1158ea453612$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $526c1158ea453612$var$tripletToBase64(num) {
    return $526c1158ea453612$var$lookup[num >> 18 & 0x3F] + $526c1158ea453612$var$lookup[num >> 12 & 0x3F] + $526c1158ea453612$var$lookup[num >> 6 & 0x3F] + $526c1158ea453612$var$lookup[num & 0x3F];
}
function $526c1158ea453612$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($526c1158ea453612$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $526c1158ea453612$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($526c1158ea453612$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($526c1158ea453612$var$lookup[tmp >> 2] + $526c1158ea453612$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($526c1158ea453612$var$lookup[tmp >> 10] + $526c1158ea453612$var$lookup[tmp >> 4 & 0x3F] + $526c1158ea453612$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $3227375bce6b652e$export$aafa59e2e03f2942;
var $3227375bce6b652e$export$68d8715fc104d294;
$3227375bce6b652e$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$3227375bce6b652e$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $b8ec8e7517d22bf6$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$b8ec8e7517d22bf6$export$a143d493d941bafc = $b8ec8e7517d22bf6$var$Buffer;
$b8ec8e7517d22bf6$export$e4cf37d7f6fb9e0a = $b8ec8e7517d22bf6$var$SlowBuffer;
$b8ec8e7517d22bf6$export$f99ded8fe4b79145 = 50;
const $b8ec8e7517d22bf6$var$K_MAX_LENGTH = 0x7fffffff;
$b8ec8e7517d22bf6$export$599f31c3813fae4d = $b8ec8e7517d22bf6$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $b8ec8e7517d22bf6$var$Buffer.TYPED_ARRAY_SUPPORT = $b8ec8e7517d22bf6$var$typedArraySupport();
if (!$b8ec8e7517d22bf6$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $b8ec8e7517d22bf6$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($b8ec8e7517d22bf6$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$b8ec8e7517d22bf6$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($b8ec8e7517d22bf6$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$b8ec8e7517d22bf6$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $b8ec8e7517d22bf6$var$createBuffer(length) {
    if (length > $b8ec8e7517d22bf6$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $b8ec8e7517d22bf6$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $b8ec8e7517d22bf6$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $b8ec8e7517d22bf6$var$allocUnsafe(arg);
    }
    return $b8ec8e7517d22bf6$var$from(arg, encodingOrOffset, length);
}
$b8ec8e7517d22bf6$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $b8ec8e7517d22bf6$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $b8ec8e7517d22bf6$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $b8ec8e7517d22bf6$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($b8ec8e7517d22bf6$var$isInstance(value, ArrayBuffer) || value && $b8ec8e7517d22bf6$var$isInstance(value.buffer, ArrayBuffer)) return $b8ec8e7517d22bf6$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($b8ec8e7517d22bf6$var$isInstance(value, SharedArrayBuffer) || value && $b8ec8e7517d22bf6$var$isInstance(value.buffer, SharedArrayBuffer))) return $b8ec8e7517d22bf6$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $b8ec8e7517d22bf6$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $b8ec8e7517d22bf6$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $b8ec8e7517d22bf6$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $b8ec8e7517d22bf6$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $b8ec8e7517d22bf6$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($b8ec8e7517d22bf6$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($b8ec8e7517d22bf6$var$Buffer, Uint8Array);
function $b8ec8e7517d22bf6$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $b8ec8e7517d22bf6$var$alloc(size, fill, encoding) {
    $b8ec8e7517d22bf6$var$assertSize(size);
    if (size <= 0) return $b8ec8e7517d22bf6$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $b8ec8e7517d22bf6$var$createBuffer(size).fill(fill, encoding) : $b8ec8e7517d22bf6$var$createBuffer(size).fill(fill);
    return $b8ec8e7517d22bf6$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $b8ec8e7517d22bf6$var$Buffer.alloc = function(size, fill, encoding) {
    return $b8ec8e7517d22bf6$var$alloc(size, fill, encoding);
};
function $b8ec8e7517d22bf6$var$allocUnsafe(size) {
    $b8ec8e7517d22bf6$var$assertSize(size);
    return $b8ec8e7517d22bf6$var$createBuffer(size < 0 ? 0 : $b8ec8e7517d22bf6$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $b8ec8e7517d22bf6$var$Buffer.allocUnsafe = function(size) {
    return $b8ec8e7517d22bf6$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $b8ec8e7517d22bf6$var$Buffer.allocUnsafeSlow = function(size) {
    return $b8ec8e7517d22bf6$var$allocUnsafe(size);
};
function $b8ec8e7517d22bf6$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$b8ec8e7517d22bf6$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $b8ec8e7517d22bf6$var$byteLength(string, encoding) | 0;
    let buf = $b8ec8e7517d22bf6$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $b8ec8e7517d22bf6$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $b8ec8e7517d22bf6$var$checked(array.length) | 0;
    const buf = $b8ec8e7517d22bf6$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $b8ec8e7517d22bf6$var$fromArrayView(arrayView) {
    if ($b8ec8e7517d22bf6$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $b8ec8e7517d22bf6$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $b8ec8e7517d22bf6$var$fromArrayLike(arrayView);
}
function $b8ec8e7517d22bf6$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $b8ec8e7517d22bf6$var$Buffer.prototype);
    return buf;
}
function $b8ec8e7517d22bf6$var$fromObject(obj) {
    if ($b8ec8e7517d22bf6$var$Buffer.isBuffer(obj)) {
        const len = $b8ec8e7517d22bf6$var$checked(obj.length) | 0;
        const buf = $b8ec8e7517d22bf6$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $b8ec8e7517d22bf6$var$numberIsNaN(obj.length)) return $b8ec8e7517d22bf6$var$createBuffer(0);
        return $b8ec8e7517d22bf6$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $b8ec8e7517d22bf6$var$fromArrayLike(obj.data);
}
function $b8ec8e7517d22bf6$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $b8ec8e7517d22bf6$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $b8ec8e7517d22bf6$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $b8ec8e7517d22bf6$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $b8ec8e7517d22bf6$var$Buffer.alloc(+length);
}
$b8ec8e7517d22bf6$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $b8ec8e7517d22bf6$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$b8ec8e7517d22bf6$var$Buffer.compare = function compare(a, b) {
    if ($b8ec8e7517d22bf6$var$isInstance(a, Uint8Array)) a = $b8ec8e7517d22bf6$var$Buffer.from(a, a.offset, a.byteLength);
    if ($b8ec8e7517d22bf6$var$isInstance(b, Uint8Array)) b = $b8ec8e7517d22bf6$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$b8ec8e7517d22bf6$var$Buffer.isBuffer(a) || !$b8ec8e7517d22bf6$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$b8ec8e7517d22bf6$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$b8ec8e7517d22bf6$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $b8ec8e7517d22bf6$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $b8ec8e7517d22bf6$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($b8ec8e7517d22bf6$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$b8ec8e7517d22bf6$var$Buffer.isBuffer(buf)) buf = $b8ec8e7517d22bf6$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$b8ec8e7517d22bf6$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $b8ec8e7517d22bf6$var$byteLength(string, encoding) {
    if ($b8ec8e7517d22bf6$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $b8ec8e7517d22bf6$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $b8ec8e7517d22bf6$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $b8ec8e7517d22bf6$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $b8ec8e7517d22bf6$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$b8ec8e7517d22bf6$var$Buffer.byteLength = $b8ec8e7517d22bf6$var$byteLength;
function $b8ec8e7517d22bf6$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $b8ec8e7517d22bf6$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $b8ec8e7517d22bf6$var$utf8Slice(this, start, end);
        case "ascii":
            return $b8ec8e7517d22bf6$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $b8ec8e7517d22bf6$var$latin1Slice(this, start, end);
        case "base64":
            return $b8ec8e7517d22bf6$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $b8ec8e7517d22bf6$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$b8ec8e7517d22bf6$var$Buffer.prototype._isBuffer = true;
function $b8ec8e7517d22bf6$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$b8ec8e7517d22bf6$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$b8ec8e7517d22bf6$var$swap(this, i, i + 1);
    return this;
};
$b8ec8e7517d22bf6$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $b8ec8e7517d22bf6$var$swap(this, i, i + 3);
        $b8ec8e7517d22bf6$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$b8ec8e7517d22bf6$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $b8ec8e7517d22bf6$var$swap(this, i, i + 7);
        $b8ec8e7517d22bf6$var$swap(this, i + 1, i + 6);
        $b8ec8e7517d22bf6$var$swap(this, i + 2, i + 5);
        $b8ec8e7517d22bf6$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$b8ec8e7517d22bf6$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $b8ec8e7517d22bf6$var$utf8Slice(this, 0, length);
    return $b8ec8e7517d22bf6$var$slowToString.apply(this, arguments);
};
$b8ec8e7517d22bf6$var$Buffer.prototype.toLocaleString = $b8ec8e7517d22bf6$var$Buffer.prototype.toString;
$b8ec8e7517d22bf6$var$Buffer.prototype.equals = function equals(b) {
    if (!$b8ec8e7517d22bf6$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $b8ec8e7517d22bf6$var$Buffer.compare(this, b) === 0;
};
$b8ec8e7517d22bf6$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $b8ec8e7517d22bf6$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($b8ec8e7517d22bf6$var$customInspectSymbol) $b8ec8e7517d22bf6$var$Buffer.prototype[$b8ec8e7517d22bf6$var$customInspectSymbol] = $b8ec8e7517d22bf6$var$Buffer.prototype.inspect;
$b8ec8e7517d22bf6$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($b8ec8e7517d22bf6$var$isInstance(target, Uint8Array)) target = $b8ec8e7517d22bf6$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$b8ec8e7517d22bf6$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $b8ec8e7517d22bf6$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($b8ec8e7517d22bf6$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $b8ec8e7517d22bf6$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($b8ec8e7517d22bf6$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $b8ec8e7517d22bf6$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $b8ec8e7517d22bf6$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $b8ec8e7517d22bf6$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$b8ec8e7517d22bf6$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$b8ec8e7517d22bf6$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $b8ec8e7517d22bf6$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$b8ec8e7517d22bf6$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $b8ec8e7517d22bf6$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $b8ec8e7517d22bf6$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($b8ec8e7517d22bf6$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $b8ec8e7517d22bf6$var$utf8Write(buf, string, offset, length) {
    return $b8ec8e7517d22bf6$var$blitBuffer($b8ec8e7517d22bf6$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $b8ec8e7517d22bf6$var$asciiWrite(buf, string, offset, length) {
    return $b8ec8e7517d22bf6$var$blitBuffer($b8ec8e7517d22bf6$var$asciiToBytes(string), buf, offset, length);
}
function $b8ec8e7517d22bf6$var$base64Write(buf, string, offset, length) {
    return $b8ec8e7517d22bf6$var$blitBuffer($b8ec8e7517d22bf6$var$base64ToBytes(string), buf, offset, length);
}
function $b8ec8e7517d22bf6$var$ucs2Write(buf, string, offset, length) {
    return $b8ec8e7517d22bf6$var$blitBuffer($b8ec8e7517d22bf6$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$b8ec8e7517d22bf6$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $b8ec8e7517d22bf6$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $b8ec8e7517d22bf6$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $b8ec8e7517d22bf6$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $b8ec8e7517d22bf6$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $b8ec8e7517d22bf6$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$b8ec8e7517d22bf6$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $b8ec8e7517d22bf6$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $526c1158ea453612$export$6100ba28696e12de(buf);
    else return $526c1158ea453612$export$6100ba28696e12de(buf.slice(start, end));
}
function $b8ec8e7517d22bf6$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $b8ec8e7517d22bf6$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $b8ec8e7517d22bf6$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $b8ec8e7517d22bf6$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $b8ec8e7517d22bf6$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $b8ec8e7517d22bf6$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $b8ec8e7517d22bf6$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $b8ec8e7517d22bf6$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $b8ec8e7517d22bf6$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $b8ec8e7517d22bf6$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $b8ec8e7517d22bf6$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$b8ec8e7517d22bf6$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $b8ec8e7517d22bf6$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $b8ec8e7517d22bf6$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$b8ec8e7517d22bf6$var$Buffer.prototype.readUintLE = $b8ec8e7517d22bf6$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $b8ec8e7517d22bf6$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$b8ec8e7517d22bf6$var$Buffer.prototype.readUintBE = $b8ec8e7517d22bf6$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $b8ec8e7517d22bf6$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$b8ec8e7517d22bf6$var$Buffer.prototype.readUint8 = $b8ec8e7517d22bf6$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b8ec8e7517d22bf6$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$b8ec8e7517d22bf6$var$Buffer.prototype.readUint16LE = $b8ec8e7517d22bf6$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b8ec8e7517d22bf6$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$b8ec8e7517d22bf6$var$Buffer.prototype.readUint16BE = $b8ec8e7517d22bf6$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b8ec8e7517d22bf6$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$b8ec8e7517d22bf6$var$Buffer.prototype.readUint32LE = $b8ec8e7517d22bf6$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b8ec8e7517d22bf6$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$b8ec8e7517d22bf6$var$Buffer.prototype.readUint32BE = $b8ec8e7517d22bf6$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b8ec8e7517d22bf6$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$b8ec8e7517d22bf6$var$Buffer.prototype.readBigUInt64LE = $b8ec8e7517d22bf6$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $b8ec8e7517d22bf6$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $b8ec8e7517d22bf6$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$b8ec8e7517d22bf6$var$Buffer.prototype.readBigUInt64BE = $b8ec8e7517d22bf6$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $b8ec8e7517d22bf6$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $b8ec8e7517d22bf6$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$b8ec8e7517d22bf6$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $b8ec8e7517d22bf6$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$b8ec8e7517d22bf6$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $b8ec8e7517d22bf6$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$b8ec8e7517d22bf6$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b8ec8e7517d22bf6$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$b8ec8e7517d22bf6$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b8ec8e7517d22bf6$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$b8ec8e7517d22bf6$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b8ec8e7517d22bf6$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$b8ec8e7517d22bf6$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b8ec8e7517d22bf6$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$b8ec8e7517d22bf6$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b8ec8e7517d22bf6$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$b8ec8e7517d22bf6$var$Buffer.prototype.readBigInt64LE = $b8ec8e7517d22bf6$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $b8ec8e7517d22bf6$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $b8ec8e7517d22bf6$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$b8ec8e7517d22bf6$var$Buffer.prototype.readBigInt64BE = $b8ec8e7517d22bf6$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $b8ec8e7517d22bf6$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $b8ec8e7517d22bf6$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$b8ec8e7517d22bf6$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b8ec8e7517d22bf6$var$checkOffset(offset, 4, this.length);
    return $3227375bce6b652e$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$b8ec8e7517d22bf6$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b8ec8e7517d22bf6$var$checkOffset(offset, 4, this.length);
    return $3227375bce6b652e$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$b8ec8e7517d22bf6$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b8ec8e7517d22bf6$var$checkOffset(offset, 8, this.length);
    return $3227375bce6b652e$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$b8ec8e7517d22bf6$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b8ec8e7517d22bf6$var$checkOffset(offset, 8, this.length);
    return $3227375bce6b652e$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $b8ec8e7517d22bf6$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$b8ec8e7517d22bf6$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$b8ec8e7517d22bf6$var$Buffer.prototype.writeUintLE = $b8ec8e7517d22bf6$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $b8ec8e7517d22bf6$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$b8ec8e7517d22bf6$var$Buffer.prototype.writeUintBE = $b8ec8e7517d22bf6$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $b8ec8e7517d22bf6$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$b8ec8e7517d22bf6$var$Buffer.prototype.writeUint8 = $b8ec8e7517d22bf6$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b8ec8e7517d22bf6$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$b8ec8e7517d22bf6$var$Buffer.prototype.writeUint16LE = $b8ec8e7517d22bf6$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b8ec8e7517d22bf6$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$b8ec8e7517d22bf6$var$Buffer.prototype.writeUint16BE = $b8ec8e7517d22bf6$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b8ec8e7517d22bf6$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$b8ec8e7517d22bf6$var$Buffer.prototype.writeUint32LE = $b8ec8e7517d22bf6$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b8ec8e7517d22bf6$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$b8ec8e7517d22bf6$var$Buffer.prototype.writeUint32BE = $b8ec8e7517d22bf6$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b8ec8e7517d22bf6$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $b8ec8e7517d22bf6$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $b8ec8e7517d22bf6$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $b8ec8e7517d22bf6$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $b8ec8e7517d22bf6$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$b8ec8e7517d22bf6$var$Buffer.prototype.writeBigUInt64LE = $b8ec8e7517d22bf6$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $b8ec8e7517d22bf6$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$b8ec8e7517d22bf6$var$Buffer.prototype.writeBigUInt64BE = $b8ec8e7517d22bf6$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $b8ec8e7517d22bf6$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$b8ec8e7517d22bf6$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $b8ec8e7517d22bf6$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$b8ec8e7517d22bf6$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $b8ec8e7517d22bf6$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$b8ec8e7517d22bf6$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b8ec8e7517d22bf6$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$b8ec8e7517d22bf6$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b8ec8e7517d22bf6$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$b8ec8e7517d22bf6$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b8ec8e7517d22bf6$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$b8ec8e7517d22bf6$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b8ec8e7517d22bf6$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$b8ec8e7517d22bf6$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b8ec8e7517d22bf6$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$b8ec8e7517d22bf6$var$Buffer.prototype.writeBigInt64LE = $b8ec8e7517d22bf6$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $b8ec8e7517d22bf6$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$b8ec8e7517d22bf6$var$Buffer.prototype.writeBigInt64BE = $b8ec8e7517d22bf6$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $b8ec8e7517d22bf6$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $b8ec8e7517d22bf6$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $b8ec8e7517d22bf6$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b8ec8e7517d22bf6$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $3227375bce6b652e$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$b8ec8e7517d22bf6$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $b8ec8e7517d22bf6$var$writeFloat(this, value, offset, true, noAssert);
};
$b8ec8e7517d22bf6$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $b8ec8e7517d22bf6$var$writeFloat(this, value, offset, false, noAssert);
};
function $b8ec8e7517d22bf6$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b8ec8e7517d22bf6$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $3227375bce6b652e$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$b8ec8e7517d22bf6$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $b8ec8e7517d22bf6$var$writeDouble(this, value, offset, true, noAssert);
};
$b8ec8e7517d22bf6$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $b8ec8e7517d22bf6$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$b8ec8e7517d22bf6$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$b8ec8e7517d22bf6$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$b8ec8e7517d22bf6$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$b8ec8e7517d22bf6$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $b8ec8e7517d22bf6$var$Buffer.isBuffer(val) ? val : $b8ec8e7517d22bf6$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $b8ec8e7517d22bf6$var$errors = {};
function $b8ec8e7517d22bf6$var$E(sym, getMessage, Base) {
    $b8ec8e7517d22bf6$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$b8ec8e7517d22bf6$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$b8ec8e7517d22bf6$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$b8ec8e7517d22bf6$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $b8ec8e7517d22bf6$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $b8ec8e7517d22bf6$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $b8ec8e7517d22bf6$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $b8ec8e7517d22bf6$var$checkBounds(buf, offset, byteLength) {
    $b8ec8e7517d22bf6$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $b8ec8e7517d22bf6$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $b8ec8e7517d22bf6$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $b8ec8e7517d22bf6$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $b8ec8e7517d22bf6$var$checkBounds(buf, offset, byteLength);
}
function $b8ec8e7517d22bf6$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $b8ec8e7517d22bf6$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $b8ec8e7517d22bf6$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $b8ec8e7517d22bf6$var$validateNumber(value, type);
        throw new $b8ec8e7517d22bf6$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $b8ec8e7517d22bf6$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $b8ec8e7517d22bf6$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $b8ec8e7517d22bf6$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $b8ec8e7517d22bf6$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($b8ec8e7517d22bf6$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $b8ec8e7517d22bf6$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $b8ec8e7517d22bf6$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $b8ec8e7517d22bf6$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $b8ec8e7517d22bf6$var$base64ToBytes(str) {
    return $526c1158ea453612$export$d622b2ad8d90c771($b8ec8e7517d22bf6$var$base64clean(str));
}
function $b8ec8e7517d22bf6$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $b8ec8e7517d22bf6$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $b8ec8e7517d22bf6$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $b8ec8e7517d22bf6$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $b8ec8e7517d22bf6$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $b8ec8e7517d22bf6$var$BufferBigIntNotDefined : fn;
}
function $b8ec8e7517d22bf6$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $a82e0e02302d0eb8$require$Buffer = $b8ec8e7517d22bf6$export$a143d493d941bafc;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $a82e0e02302d0eb8$var$isVisitable(thing) {
    return (0, $1defda52afdec17e$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $1defda52afdec17e$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $a82e0e02302d0eb8$var$removeBrackets(key) {
    return (0, $1defda52afdec17e$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $a82e0e02302d0eb8$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $a82e0e02302d0eb8$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $a82e0e02302d0eb8$var$isFlatArray(arr) {
    return (0, $1defda52afdec17e$export$2e2bcd8739ae039).isArray(arr) && !arr.some($a82e0e02302d0eb8$var$isVisitable);
}
const $a82e0e02302d0eb8$var$predicates = (0, $1defda52afdec17e$export$2e2bcd8739ae039).toFlatObject((0, $1defda52afdec17e$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $a82e0e02302d0eb8$var$toFormData(obj, formData, options) {
    if (!(0, $1defda52afdec17e$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $8a14ce9a27cf61d8$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $1defda52afdec17e$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $1defda52afdec17e$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $1defda52afdec17e$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $1defda52afdec17e$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $1defda52afdec17e$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $1defda52afdec17e$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $0d41b511ca99bcf2$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $1defda52afdec17e$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $1defda52afdec17e$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $a82e0e02302d0eb8$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $1defda52afdec17e$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $1defda52afdec17e$export$2e2bcd8739ae039).isArray(value) && $a82e0e02302d0eb8$var$isFlatArray(value) || ((0, $1defda52afdec17e$export$2e2bcd8739ae039).isFileList(value) || (0, $1defda52afdec17e$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $1defda52afdec17e$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $a82e0e02302d0eb8$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $1defda52afdec17e$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $a82e0e02302d0eb8$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($a82e0e02302d0eb8$var$isVisitable(value)) return true;
        formData.append($a82e0e02302d0eb8$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($a82e0e02302d0eb8$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $a82e0e02302d0eb8$var$isVisitable
    });
    function build(value, path) {
        if ((0, $1defda52afdec17e$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $1defda52afdec17e$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $1defda52afdec17e$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $1defda52afdec17e$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $1defda52afdec17e$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $a82e0e02302d0eb8$export$2e2bcd8739ae039 = $a82e0e02302d0eb8$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $840cb0979c2298ab$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $840cb0979c2298ab$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $a82e0e02302d0eb8$export$2e2bcd8739ae039)(params, this, options);
}
const $840cb0979c2298ab$var$prototype = $840cb0979c2298ab$var$AxiosURLSearchParams.prototype;
$840cb0979c2298ab$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$840cb0979c2298ab$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $840cb0979c2298ab$var$encode);
    } : $840cb0979c2298ab$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $840cb0979c2298ab$export$2e2bcd8739ae039 = $840cb0979c2298ab$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $a7f4152c7658fa48$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $a7f4152c7658fa48$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $a7f4152c7658fa48$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $1defda52afdec17e$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $840cb0979c2298ab$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $438b187b23f9b8dc$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $1defda52afdec17e$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $438b187b23f9b8dc$export$2e2bcd8739ae039 = $438b187b23f9b8dc$var$InterceptorManager;





"use strict";
var $7ff9de4a12dfd585$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






"use strict";
var $d3b7047993d3bd5a$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $840cb0979c2298ab$export$2e2bcd8739ae039);


"use strict";
var $7b8b26bc222e4f9f$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $9b00b363509257f4$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


var $43ebfe995240de7f$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $d3b7047993d3bd5a$export$2e2bcd8739ae039,
        FormData: $7b8b26bc222e4f9f$export$2e2bcd8739ae039,
        Blob: $9b00b363509257f4$export$2e2bcd8739ae039
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


var $44c15eeacef04c25$exports = {};

$parcel$export($44c15eeacef04c25$exports, "hasBrowserEnv", function () { return $44c15eeacef04c25$export$c4996c4b7b93b0bf; });
$parcel$export($44c15eeacef04c25$exports, "hasStandardBrowserEnv", function () { return $44c15eeacef04c25$export$c0bcc9250309d66; });
$parcel$export($44c15eeacef04c25$exports, "hasStandardBrowserWebWorkerEnv", function () { return $44c15eeacef04c25$export$c81692cf5af97dac; });
$parcel$export($44c15eeacef04c25$exports, "origin", function () { return $44c15eeacef04c25$export$f710a83a91838a36; });
const $44c15eeacef04c25$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $44c15eeacef04c25$export$c0bcc9250309d66 = ((product)=>{
    return $44c15eeacef04c25$export$c4996c4b7b93b0bf && [
        "ReactNative",
        "NativeScript",
        "NS"
    ].indexOf(product) < 0;
})(typeof navigator !== "undefined" && navigator.product);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $44c15eeacef04c25$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const $44c15eeacef04c25$export$f710a83a91838a36 = $44c15eeacef04c25$export$c4996c4b7b93b0bf && window.location.href || "http://localhost";


var $4e21fd6f042cb747$export$2e2bcd8739ae039 = {
    ...$44c15eeacef04c25$exports,
    ...(0, $43ebfe995240de7f$export$2e2bcd8739ae039)
};


"use strict";
function $f81c6b22e1e31535$export$2e2bcd8739ae039(data, options) {
    return (0, $a82e0e02302d0eb8$export$2e2bcd8739ae039)(data, new (0, $4e21fd6f042cb747$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $4e21fd6f042cb747$export$2e2bcd8739ae039).isNode && (0, $1defda52afdec17e$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $ea02a8c3b6a3948a$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $1defda52afdec17e$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $ea02a8c3b6a3948a$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $ea02a8c3b6a3948a$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $1defda52afdec17e$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $1defda52afdec17e$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $1defda52afdec17e$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $1defda52afdec17e$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $ea02a8c3b6a3948a$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $1defda52afdec17e$export$2e2bcd8739ae039).isFormData(formData) && (0, $1defda52afdec17e$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $1defda52afdec17e$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($ea02a8c3b6a3948a$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $ea02a8c3b6a3948a$export$2e2bcd8739ae039 = $ea02a8c3b6a3948a$var$formDataToJSON;


"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $2def394ec14ad65d$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $1defda52afdec17e$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $1defda52afdec17e$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $2def394ec14ad65d$var$defaults = {
    transitional: (0, $7ff9de4a12dfd585$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http",
        "fetch"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $1defda52afdec17e$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $1defda52afdec17e$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $1defda52afdec17e$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $ea02a8c3b6a3948a$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $1defda52afdec17e$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $1defda52afdec17e$export$2e2bcd8739ae039).isBuffer(data) || (0, $1defda52afdec17e$export$2e2bcd8739ae039).isStream(data) || (0, $1defda52afdec17e$export$2e2bcd8739ae039).isFile(data) || (0, $1defda52afdec17e$export$2e2bcd8739ae039).isBlob(data) || (0, $1defda52afdec17e$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $1defda52afdec17e$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $1defda52afdec17e$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $f81c6b22e1e31535$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $1defda52afdec17e$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $a82e0e02302d0eb8$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $2def394ec14ad65d$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $2def394ec14ad65d$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if ((0, $1defda52afdec17e$export$2e2bcd8739ae039).isResponse(data) || (0, $1defda52afdec17e$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $1defda52afdec17e$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $0d41b511ca99bcf2$export$2e2bcd8739ae039).from(e, (0, $0d41b511ca99bcf2$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $4e21fd6f042cb747$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $4e21fd6f042cb747$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $1defda52afdec17e$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $2def394ec14ad65d$var$defaults.headers[method] = {};
});
var $2def394ec14ad65d$export$2e2bcd8739ae039 = $2def394ec14ad65d$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $51a147a12a7d25e2$var$ignoreDuplicateOf = (0, $1defda52afdec17e$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $51a147a12a7d25e2$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $51a147a12a7d25e2$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $ce5051052461eee5$var$$internals = Symbol("internals");
function $ce5051052461eee5$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $ce5051052461eee5$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $1defda52afdec17e$export$2e2bcd8739ae039).isArray(value) ? value.map($ce5051052461eee5$var$normalizeValue) : String(value);
}
function $ce5051052461eee5$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $ce5051052461eee5$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $ce5051052461eee5$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $1defda52afdec17e$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $1defda52afdec17e$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $1defda52afdec17e$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $1defda52afdec17e$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $ce5051052461eee5$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $ce5051052461eee5$var$buildAccessors(obj, header) {
    const accessorName = (0, $1defda52afdec17e$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $ce5051052461eee5$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $ce5051052461eee5$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $1defda52afdec17e$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $ce5051052461eee5$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $1defda52afdec17e$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $1defda52afdec17e$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $1defda52afdec17e$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$ce5051052461eee5$var$isValidHeaderName(header)) setHeaders((0, $51a147a12a7d25e2$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $1defda52afdec17e$export$2e2bcd8739ae039).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $ce5051052461eee5$var$normalizeHeader(header);
        if (header) {
            const key = (0, $1defda52afdec17e$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $ce5051052461eee5$var$parseTokens(value);
                if ((0, $1defda52afdec17e$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $1defda52afdec17e$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $ce5051052461eee5$var$normalizeHeader(header);
        if (header) {
            const key = (0, $1defda52afdec17e$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $ce5051052461eee5$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $ce5051052461eee5$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $1defda52afdec17e$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $ce5051052461eee5$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $1defda52afdec17e$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $ce5051052461eee5$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $1defda52afdec17e$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $1defda52afdec17e$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $ce5051052461eee5$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $ce5051052461eee5$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $ce5051052461eee5$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $1defda52afdec17e$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $1defda52afdec17e$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$ce5051052461eee5$var$$internals] = this[$ce5051052461eee5$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $ce5051052461eee5$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $ce5051052461eee5$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $1defda52afdec17e$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$ce5051052461eee5$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $1defda52afdec17e$export$2e2bcd8739ae039).reduceDescriptors($ce5051052461eee5$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $1defda52afdec17e$export$2e2bcd8739ae039).freezeMethods($ce5051052461eee5$var$AxiosHeaders);
var $ce5051052461eee5$export$2e2bcd8739ae039 = $ce5051052461eee5$var$AxiosHeaders;


"use strict";
function $e0b3b2f6eab104fa$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $2def394ec14ad65d$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $ce5051052461eee5$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $1defda52afdec17e$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $97152c84e0e1d277$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $b757488873f0d680$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $0d41b511ca99bcf2$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $0d41b511ca99bcf2$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $1defda52afdec17e$export$2e2bcd8739ae039).inherits($b757488873f0d680$var$CanceledError, (0, $0d41b511ca99bcf2$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $b757488873f0d680$export$2e2bcd8739ae039 = $b757488873f0d680$var$CanceledError;







"use strict";
function $bc273eb79714fb23$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $0d41b511ca99bcf2$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $0d41b511ca99bcf2$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $0d41b511ca99bcf2$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





"use strict";
function $a2844c1873eb8588$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $97cc3cd9fdc1bf5d$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $97cc3cd9fdc1bf5d$export$2e2bcd8739ae039 = $97cc3cd9fdc1bf5d$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $01094b4dc3f3eb59$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $01094b4dc3f3eb59$export$2e2bcd8739ae039 = $01094b4dc3f3eb59$var$throttle;



const $14ce9bbcb400ffef$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $97cc3cd9fdc1bf5d$export$2e2bcd8739ae039)(50, 250);
    return (0, $01094b4dc3f3eb59$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? "download" : "upload"]: true
        };
        listener(data);
    }, freq);
};
const $14ce9bbcb400ffef$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $14ce9bbcb400ffef$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $1defda52afdec17e$export$2e2bcd8739ae039).asap(()=>fn(...args));






"use strict";
var $85a715e04d9ec7dc$export$2e2bcd8739ae039 = (0, $4e21fd6f042cb747$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $1defda52afdec17e$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();




var $62417cfb05e701d3$export$2e2bcd8739ae039 = (0, $4e21fd6f042cb747$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $1defda52afdec17e$export$2e2bcd8739ae039).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $1defda52afdec17e$export$2e2bcd8739ae039).isString(path) && cookie.push("path=" + path);
        (0, $1defda52afdec17e$export$2e2bcd8739ae039).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


"use strict";
function $c6747a83669972fe$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $c4341d59648ecc93$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $aa44f6b334b02753$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $c6747a83669972fe$export$2e2bcd8739ae039)(requestedURL)) return (0, $c4341d59648ecc93$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
const $b55eb23ce7af16c1$var$headersToObject = (thing)=>thing instanceof (0, $ce5051052461eee5$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $b55eb23ce7af16c1$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $1defda52afdec17e$export$2e2bcd8739ae039).isPlainObject(target) && (0, $1defda52afdec17e$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $1defda52afdec17e$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $1defda52afdec17e$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $1defda52afdec17e$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $1defda52afdec17e$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $1defda52afdec17e$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $1defda52afdec17e$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $1defda52afdec17e$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $1defda52afdec17e$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $1defda52afdec17e$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($b55eb23ce7af16c1$var$headersToObject(a), $b55eb23ce7af16c1$var$headersToObject(b), true)
    };
    (0, $1defda52afdec17e$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $1defda52afdec17e$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $f0c9e01afe28d355$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $b55eb23ce7af16c1$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $ce5051052461eee5$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $a7f4152c7658fa48$export$2e2bcd8739ae039)((0, $aa44f6b334b02753$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set("Authorization", "Basic " + btoa((auth.username || "") + ":" + (auth.password ? unescape(encodeURIComponent(auth.password)) : "")));
    let contentType;
    if ((0, $1defda52afdec17e$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $4e21fd6f042cb747$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $4e21fd6f042cb747$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || "multipart/form-data",
                ...tokens
            ].join("; "));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $4e21fd6f042cb747$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $1defda52afdec17e$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $85a715e04d9ec7dc$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $62417cfb05e701d3$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $5008f76868d2c2b2$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $5008f76868d2c2b2$export$2e2bcd8739ae039 = $5008f76868d2c2b2$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $f0c9e01afe28d355$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $ce5051052461eee5$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener("abort", onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $ce5051052461eee5$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $bc273eb79714fb23$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $0d41b511ca99bcf2$export$2e2bcd8739ae039)("Request aborted", (0, $0d41b511ca99bcf2$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $0d41b511ca99bcf2$export$2e2bcd8739ae039)("Network Error", (0, $0d41b511ca99bcf2$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = _config.transitional || (0, $7ff9de4a12dfd585$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $0d41b511ca99bcf2$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $0d41b511ca99bcf2$export$2e2bcd8739ae039).ETIMEDOUT : (0, $0d41b511ca99bcf2$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $1defda52afdec17e$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $1defda52afdec17e$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $14ce9bbcb400ffef$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener("progress", downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $14ce9bbcb400ffef$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener("progress", uploadThrottled);
            request.upload.addEventListener("loadend", flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $b757488873f0d680$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $a2844c1873eb8588$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $4e21fd6f042cb747$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $0d41b511ca99bcf2$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $0d41b511ca99bcf2$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};







const $3dbac09553507e23$var$composeSignals = (signals, timeout)=>{
    let controller = new AbortController();
    let aborted;
    const onabort = function(cancel) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = cancel instanceof Error ? cancel : this.reason;
            controller.abort(err instanceof (0, $0d41b511ca99bcf2$export$2e2bcd8739ae039) ? err : new (0, $b757488873f0d680$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        onabort(new (0, $0d41b511ca99bcf2$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $0d41b511ca99bcf2$export$2e2bcd8739ae039).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (signals) {
            timer && clearTimeout(timer);
            timer = null;
            signals.forEach((signal)=>{
                signal && (signal.removeEventListener ? signal.removeEventListener("abort", onabort) : signal.unsubscribe(onabort));
            });
            signals = null;
        }
    };
    signals.forEach((signal)=>signal && signal.addEventListener && signal.addEventListener("abort", onabort));
    const { signal: signal } = controller;
    signal.unsubscribe = unsubscribe;
    return [
        signal,
        ()=>{
            timer && clearTimeout(timer);
            timer = null;
        }
    ];
};
var $3dbac09553507e23$export$2e2bcd8739ae039 = $3dbac09553507e23$var$composeSignals;


const $63dd2a57fc22af2a$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $63dd2a57fc22af2a$export$f9f241124ee3198e = async function*(iterable, chunkSize, encode) {
    for await (const chunk of iterable)yield* $63dd2a57fc22af2a$export$71b051935044bd5d(ArrayBuffer.isView(chunk) ? chunk : await encode(String(chunk)), chunkSize);
};
const $63dd2a57fc22af2a$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish, encode)=>{
    const iterator = $63dd2a57fc22af2a$export$f9f241124ee3198e(stream, chunkSize, encode);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $4aad3d58dbf921d2$var$isFetchSupported = typeof fetch === "function" && typeof Request === "function" && typeof Response === "function";
const $4aad3d58dbf921d2$var$isReadableStreamSupported = $4aad3d58dbf921d2$var$isFetchSupported && typeof ReadableStream === "function";
// used only inside the fetch adapter
const $4aad3d58dbf921d2$var$encodeText = $4aad3d58dbf921d2$var$isFetchSupported && (typeof TextEncoder === "function" ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $4aad3d58dbf921d2$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $4aad3d58dbf921d2$var$supportsRequestStream = $4aad3d58dbf921d2$var$isReadableStreamSupported && $4aad3d58dbf921d2$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $4e21fd6f042cb747$export$2e2bcd8739ae039).origin, {
        body: new ReadableStream(),
        method: "POST",
        get duplex () {
            duplexAccessed = true;
            return "half";
        }
    }).headers.has("Content-Type");
    return duplexAccessed && !hasContentType;
});
const $4aad3d58dbf921d2$var$DEFAULT_CHUNK_SIZE = 65536;
const $4aad3d58dbf921d2$var$supportsResponseStream = $4aad3d58dbf921d2$var$isReadableStreamSupported && $4aad3d58dbf921d2$var$test(()=>(0, $1defda52afdec17e$export$2e2bcd8739ae039).isReadableStream(new Response("").body));
const $4aad3d58dbf921d2$var$resolvers = {
    stream: $4aad3d58dbf921d2$var$supportsResponseStream && ((res)=>res.body)
};
$4aad3d58dbf921d2$var$isFetchSupported && ((res)=>{
    [
        "text",
        "arrayBuffer",
        "blob",
        "formData",
        "stream"
    ].forEach((type)=>{
        !$4aad3d58dbf921d2$var$resolvers[type] && ($4aad3d58dbf921d2$var$resolvers[type] = (0, $1defda52afdec17e$export$2e2bcd8739ae039).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $0d41b511ca99bcf2$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $0d41b511ca99bcf2$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $4aad3d58dbf921d2$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $1defda52afdec17e$export$2e2bcd8739ae039).isBlob(body)) return body.size;
    if ((0, $1defda52afdec17e$export$2e2bcd8739ae039).isSpecCompliantForm(body)) return (await new Request(body).arrayBuffer()).byteLength;
    if ((0, $1defda52afdec17e$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $1defda52afdec17e$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
    if ((0, $1defda52afdec17e$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + "";
    if ((0, $1defda52afdec17e$export$2e2bcd8739ae039).isString(body)) return (await $4aad3d58dbf921d2$var$encodeText(body)).byteLength;
};
const $4aad3d58dbf921d2$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $1defda52afdec17e$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
    return length == null ? $4aad3d58dbf921d2$var$getBodyLength(body) : length;
};
var $4aad3d58dbf921d2$export$2e2bcd8739ae039 = $4aad3d58dbf921d2$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = "same-origin", fetchOptions: fetchOptions } = (0, $f0c9e01afe28d355$export$2e2bcd8739ae039)(config);
    responseType = responseType ? (responseType + "").toLowerCase() : "text";
    let [composedSignal, stopTimeout] = signal || cancelToken || timeout ? (0, $3dbac09553507e23$export$2e2bcd8739ae039)([
        signal,
        cancelToken
    ], timeout) : [];
    let finished, request;
    const onFinish = ()=>{
        !finished && setTimeout(()=>{
            composedSignal && composedSignal.unsubscribe();
        });
        finished = true;
    };
    let requestContentLength;
    try {
        if (onUploadProgress && $4aad3d58dbf921d2$var$supportsRequestStream && method !== "get" && method !== "head" && (requestContentLength = await $4aad3d58dbf921d2$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: "POST",
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $1defda52afdec17e$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $14ce9bbcb400ffef$export$d9fadd12586c18d6)(requestContentLength, (0, $14ce9bbcb400ffef$export$c1b28109d46c3592)((0, $14ce9bbcb400ffef$export$5d35863c355a22a9)(onUploadProgress)));
                data = (0, $63dd2a57fc22af2a$export$b0119225647bd83)(_request.body, $4aad3d58dbf921d2$var$DEFAULT_CHUNK_SIZE, onProgress, flush, $4aad3d58dbf921d2$var$encodeText);
            }
        }
        if (!(0, $1defda52afdec17e$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? "include" : "omit";
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: withCredentials
        });
        let response = await fetch(request);
        const isStreamResponse = $4aad3d58dbf921d2$var$supportsResponseStream && (responseType === "stream" || responseType === "response");
        if ($4aad3d58dbf921d2$var$supportsResponseStream && (onDownloadProgress || isStreamResponse)) {
            const options = {};
            [
                "status",
                "statusText",
                "headers"
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $1defda52afdec17e$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get("content-length"));
            const [onProgress, flush] = onDownloadProgress && (0, $14ce9bbcb400ffef$export$d9fadd12586c18d6)(responseContentLength, (0, $14ce9bbcb400ffef$export$c1b28109d46c3592)((0, $14ce9bbcb400ffef$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
            response = new Response((0, $63dd2a57fc22af2a$export$b0119225647bd83)(response.body, $4aad3d58dbf921d2$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                isStreamResponse && onFinish();
            }, $4aad3d58dbf921d2$var$encodeText), options);
        }
        responseType = responseType || "text";
        let responseData = await $4aad3d58dbf921d2$var$resolvers[(0, $1defda52afdec17e$export$2e2bcd8739ae039).findKey($4aad3d58dbf921d2$var$resolvers, responseType) || "text"](response, config);
        !isStreamResponse && onFinish();
        stopTimeout && stopTimeout();
        return await new Promise((resolve, reject)=>{
            (0, $bc273eb79714fb23$export$2e2bcd8739ae039)(resolve, reject, {
                data: responseData,
                headers: (0, $ce5051052461eee5$export$2e2bcd8739ae039).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        onFinish();
        if (err && err.name === "TypeError" && /fetch/i.test(err.message)) throw Object.assign(new (0, $0d41b511ca99bcf2$export$2e2bcd8739ae039)("Network Error", (0, $0d41b511ca99bcf2$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $0d41b511ca99bcf2$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
    }
});



const $cb6b42e5897c9682$var$knownAdapters = {
    http: (0, $8a14ce9a27cf61d8$export$2e2bcd8739ae039),
    xhr: (0, $5008f76868d2c2b2$export$2e2bcd8739ae039),
    fetch: (0, $4aad3d58dbf921d2$export$2e2bcd8739ae039)
};
(0, $1defda52afdec17e$export$2e2bcd8739ae039).forEach($cb6b42e5897c9682$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $cb6b42e5897c9682$var$renderReason = (reason)=>`- ${reason}`;
const $cb6b42e5897c9682$var$isResolvedHandle = (adapter)=>(0, $1defda52afdec17e$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $cb6b42e5897c9682$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $1defda52afdec17e$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$cb6b42e5897c9682$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $cb6b42e5897c9682$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $0d41b511ca99bcf2$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($cb6b42e5897c9682$var$renderReason).join("\n") : " " + $cb6b42e5897c9682$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $0d41b511ca99bcf2$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $cb6b42e5897c9682$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $d6541ec0f8684ff5$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $b757488873f0d680$export$2e2bcd8739ae039)(null, config);
}
function $d6541ec0f8684ff5$export$2e2bcd8739ae039(config) {
    $d6541ec0f8684ff5$var$throwIfCancellationRequested(config);
    config.headers = (0, $ce5051052461eee5$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $e0b3b2f6eab104fa$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $cb6b42e5897c9682$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $2def394ec14ad65d$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $d6541ec0f8684ff5$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $e0b3b2f6eab104fa$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $ce5051052461eee5$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $97152c84e0e1d277$export$2e2bcd8739ae039)(reason)) {
            $d6541ec0f8684ff5$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $e0b3b2f6eab104fa$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $ce5051052461eee5$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $af9a51c17952b10c$export$a4ad2735b021c132 = "1.7.3";



"use strict";
const $fa132bfc29b8b185$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $fa132bfc29b8b185$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $fa132bfc29b8b185$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $fa132bfc29b8b185$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $af9a51c17952b10c$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $0d41b511ca99bcf2$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $0d41b511ca99bcf2$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$fa132bfc29b8b185$var$deprecatedWarnings[opt]) {
            $fa132bfc29b8b185$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $fa132bfc29b8b185$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $0d41b511ca99bcf2$export$2e2bcd8739ae039)("options must be an object", (0, $0d41b511ca99bcf2$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $0d41b511ca99bcf2$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $0d41b511ca99bcf2$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $0d41b511ca99bcf2$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $0d41b511ca99bcf2$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $fa132bfc29b8b185$export$2e2bcd8739ae039 = {
    assertOptions: $fa132bfc29b8b185$var$assertOptions,
    validators: $fa132bfc29b8b185$var$validators
};



"use strict";
const $5df47c5fe7a86f59$var$validators = (0, $fa132bfc29b8b185$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $5df47c5fe7a86f59$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $438b187b23f9b8dc$export$2e2bcd8739ae039)(),
            response: new (0, $438b187b23f9b8dc$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy;
                Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $b55eb23ce7af16c1$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $fa132bfc29b8b185$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $5df47c5fe7a86f59$var$validators.transitional($5df47c5fe7a86f59$var$validators.boolean),
            forcedJSONParsing: $5df47c5fe7a86f59$var$validators.transitional($5df47c5fe7a86f59$var$validators.boolean),
            clarifyTimeoutError: $5df47c5fe7a86f59$var$validators.transitional($5df47c5fe7a86f59$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $1defda52afdec17e$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $fa132bfc29b8b185$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $5df47c5fe7a86f59$var$validators.function,
                serialize: $5df47c5fe7a86f59$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $1defda52afdec17e$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $1defda52afdec17e$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $ce5051052461eee5$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $d6541ec0f8684ff5$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $d6541ec0f8684ff5$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $b55eb23ce7af16c1$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $aa44f6b334b02753$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $a7f4152c7658fa48$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $1defda52afdec17e$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $5df47c5fe7a86f59$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $b55eb23ce7af16c1$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $1defda52afdec17e$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $b55eb23ce7af16c1$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $5df47c5fe7a86f59$var$Axios.prototype[method] = generateHTTPMethod();
    $5df47c5fe7a86f59$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $5df47c5fe7a86f59$export$2e2bcd8739ae039 = $5df47c5fe7a86f59$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $37d75a0965e3c4e1$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $b757488873f0d680$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $37d75a0965e3c4e1$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $37d75a0965e3c4e1$export$2e2bcd8739ae039 = $37d75a0965e3c4e1$var$CancelToken;






"use strict";
function $f2bf0010ab12105c$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $7b5d8c9cd56bf50b$export$2e2bcd8739ae039(payload) {
    return (0, $1defda52afdec17e$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $5a0d9226a61ccdfa$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($5a0d9226a61ccdfa$var$HttpStatusCode).forEach(([key, value])=>{
    $5a0d9226a61ccdfa$var$HttpStatusCode[value] = key;
});
var $5a0d9226a61ccdfa$export$2e2bcd8739ae039 = $5a0d9226a61ccdfa$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $d84d31659ada1a57$var$createInstance(defaultConfig) {
    const context = new (0, $5df47c5fe7a86f59$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $4cfbf69ecbb0da0d$export$2e2bcd8739ae039)((0, $5df47c5fe7a86f59$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $1defda52afdec17e$export$2e2bcd8739ae039).extend(instance, (0, $5df47c5fe7a86f59$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $1defda52afdec17e$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $d84d31659ada1a57$var$createInstance((0, $b55eb23ce7af16c1$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $d84d31659ada1a57$var$axios = $d84d31659ada1a57$var$createInstance((0, $2def394ec14ad65d$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$d84d31659ada1a57$var$axios.Axios = (0, $5df47c5fe7a86f59$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$d84d31659ada1a57$var$axios.CanceledError = (0, $b757488873f0d680$export$2e2bcd8739ae039);
$d84d31659ada1a57$var$axios.CancelToken = (0, $37d75a0965e3c4e1$export$2e2bcd8739ae039);
$d84d31659ada1a57$var$axios.isCancel = (0, $97152c84e0e1d277$export$2e2bcd8739ae039);
$d84d31659ada1a57$var$axios.VERSION = (0, $af9a51c17952b10c$export$a4ad2735b021c132);
$d84d31659ada1a57$var$axios.toFormData = (0, $a82e0e02302d0eb8$export$2e2bcd8739ae039);
// Expose AxiosError class
$d84d31659ada1a57$var$axios.AxiosError = (0, $0d41b511ca99bcf2$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$d84d31659ada1a57$var$axios.Cancel = $d84d31659ada1a57$var$axios.CanceledError;
// Expose all/spread
$d84d31659ada1a57$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$d84d31659ada1a57$var$axios.spread = (0, $f2bf0010ab12105c$export$2e2bcd8739ae039);
// Expose isAxiosError
$d84d31659ada1a57$var$axios.isAxiosError = (0, $7b5d8c9cd56bf50b$export$2e2bcd8739ae039);
// Expose mergeConfig
$d84d31659ada1a57$var$axios.mergeConfig = (0, $b55eb23ce7af16c1$export$2e2bcd8739ae039);
$d84d31659ada1a57$var$axios.AxiosHeaders = (0, $ce5051052461eee5$export$2e2bcd8739ae039);
$d84d31659ada1a57$var$axios.formToJSON = (thing)=>(0, $ea02a8c3b6a3948a$export$2e2bcd8739ae039)((0, $1defda52afdec17e$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$d84d31659ada1a57$var$axios.getAdapter = (0, $cb6b42e5897c9682$export$2e2bcd8739ae039).getAdapter;
$d84d31659ada1a57$var$axios.HttpStatusCode = (0, $5a0d9226a61ccdfa$export$2e2bcd8739ae039);
$d84d31659ada1a57$var$axios.default = $d84d31659ada1a57$var$axios;
var // this module should only have a default export
$d84d31659ada1a57$export$2e2bcd8739ae039 = $d84d31659ada1a57$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $fc0a44ef98d6d858$export$1c00760e9e5a4e95, AxiosError: $fc0a44ef98d6d858$export$c1fbed17c2f6a328, CanceledError: $fc0a44ef98d6d858$export$1ab0c6b20d94fa14, isCancel: $fc0a44ef98d6d858$export$3b22524397b493c6, CancelToken: $fc0a44ef98d6d858$export$fd08e3cb425f0d61, VERSION: $fc0a44ef98d6d858$export$a4ad2735b021c132, all: $fc0a44ef98d6d858$export$84bf76cd7afc7469, Cancel: $fc0a44ef98d6d858$export$848c9b7ead0df967, isAxiosError: $fc0a44ef98d6d858$export$fbafdbe06a5b5a9a, spread: $fc0a44ef98d6d858$export$3ae0fd4797ed47c8, toFormData: $fc0a44ef98d6d858$export$10ae0d317ea97f8b, AxiosHeaders: $fc0a44ef98d6d858$export$4e7d6ff0f3e6520, HttpStatusCode: $fc0a44ef98d6d858$export$a972f69c851492b3, formToJSON: $fc0a44ef98d6d858$export$86d7c59254d6a2c9, getAdapter: $fc0a44ef98d6d858$export$17ddc20a97d669e2, mergeConfig: $fc0a44ef98d6d858$export$7ec1ebcfa9d8bd6a } = (0, $d84d31659ada1a57$export$2e2bcd8739ae039);


const $abced26eb1aa148c$export$644d8ea042df96a6 = (0, $d84d31659ada1a57$export$2e2bcd8739ae039).create({
    baseURL: "https://petersontrade.com/",
    headers: {
        "Content-Type": "application/json"
    }
});


const $c5d5259bbc3a9a51$var$notifyRef = document.querySelector(".notify");
const $c5d5259bbc3a9a51$export$5e14cdade93d6f7b = (message, type = "info")=>{
    $c5d5259bbc3a9a51$var$notifyRef.innerHTML = message;
    $c5d5259bbc3a9a51$var$notifyRef.classList.add(type);
    $c5d5259bbc3a9a51$var$notifyRef.classList.add("active");
    setTimeout(()=>{
        $c5d5259bbc3a9a51$var$notifyRef.innerHTML = "";
        $c5d5259bbc3a9a51$var$notifyRef.classList.remove(type);
        $c5d5259bbc3a9a51$var$notifyRef.classList.remove("active");
    }, 3000);
};


var $2338751fefe03e79$exports = {};
/*
 * International Telephone Input v23.8.1
 * https://github.com/jackocnr/intl-tel-input.git
 * Licensed under the MIT license
 */ // UMD
(function(factory) {
    if (0, $2338751fefe03e79$exports) $2338751fefe03e79$exports = factory();
    else window.intlTelInput = factory();
})(()=>{
    var factoryOutput = (()=>{
        var __defProp = Object.defineProperty;
        var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
        var __getOwnPropNames = Object.getOwnPropertyNames;
        var __hasOwnProp = Object.prototype.hasOwnProperty;
        var __export = (target, all)=>{
            for(var name in all)__defProp(target, name, {
                get: all[name],
                enumerable: true
            });
        };
        var __copyProps = (to, from, except, desc)=>{
            if (from && typeof from === "object" || typeof from === "function") {
                for (let key of __getOwnPropNames(from))if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: ()=>from[key],
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            }
            return to;
        };
        var __toCommonJS = (mod)=>__copyProps(__defProp({}, "__esModule", {
                value: true
            }), mod);
        // src/js/intl-tel-input/intlTelInputWithUtils.ts
        var intlTelInputWithUtils_exports = {};
        __export(intlTelInputWithUtils_exports, {
            default: ()=>intlTelInputWithUtils_default
        });
        // src/js/intl-tel-input/data.ts
        var rawCountryData = [
            [
                "af",
                "93"
            ],
            [
                "al",
                "355"
            ],
            [
                "dz",
                "213"
            ],
            [
                "as",
                "1",
                5,
                [
                    "684"
                ]
            ],
            [
                "ad",
                "376"
            ],
            [
                "ao",
                "244"
            ],
            [
                "ai",
                "1",
                6,
                [
                    "264"
                ]
            ],
            [
                "ag",
                "1",
                7,
                [
                    "268"
                ]
            ],
            [
                "ar",
                "54"
            ],
            [
                "am",
                "374"
            ],
            [
                "aw",
                "297"
            ],
            [
                "ac",
                "247"
            ],
            [
                "au",
                "61",
                0
            ],
            [
                "at",
                "43"
            ],
            [
                "az",
                "994"
            ],
            [
                "bs",
                "1",
                8,
                [
                    "242"
                ]
            ],
            [
                "bh",
                "973"
            ],
            [
                "bd",
                "880"
            ],
            [
                "bb",
                "1",
                9,
                [
                    "246"
                ]
            ],
            [
                "by",
                "375"
            ],
            [
                "be",
                "32"
            ],
            [
                "bz",
                "501"
            ],
            [
                "bj",
                "229"
            ],
            [
                "bm",
                "1",
                10,
                [
                    "441"
                ]
            ],
            [
                "bt",
                "975"
            ],
            [
                "bo",
                "591"
            ],
            [
                "ba",
                "387"
            ],
            [
                "bw",
                "267"
            ],
            [
                "br",
                "55"
            ],
            [
                "io",
                "246"
            ],
            [
                "vg",
                "1",
                11,
                [
                    "284"
                ]
            ],
            [
                "bn",
                "673"
            ],
            [
                "bg",
                "359"
            ],
            [
                "bf",
                "226"
            ],
            [
                "bi",
                "257"
            ],
            [
                "kh",
                "855"
            ],
            [
                "cm",
                "237"
            ],
            [
                "ca",
                "1",
                1,
                [
                    "204",
                    "226",
                    "236",
                    "249",
                    "250",
                    "263",
                    "289",
                    "306",
                    "343",
                    "354",
                    "365",
                    "367",
                    "368",
                    "382",
                    "387",
                    "403",
                    "416",
                    "418",
                    "428",
                    "431",
                    "437",
                    "438",
                    "450",
                    "584",
                    "468",
                    "474",
                    "506",
                    "514",
                    "519",
                    "548",
                    "579",
                    "581",
                    "584",
                    "587",
                    "604",
                    "613",
                    "639",
                    "647",
                    "672",
                    "683",
                    "705",
                    "709",
                    "742",
                    "753",
                    "778",
                    "780",
                    "782",
                    "807",
                    "819",
                    "825",
                    "867",
                    "873",
                    "879",
                    "902",
                    "905"
                ]
            ],
            [
                "cv",
                "238"
            ],
            [
                "bq",
                "599",
                1,
                [
                    "3",
                    "4",
                    "7"
                ]
            ],
            [
                "ky",
                "1",
                12,
                [
                    "345"
                ]
            ],
            [
                "cf",
                "236"
            ],
            [
                "td",
                "235"
            ],
            [
                "cl",
                "56"
            ],
            [
                "cn",
                "86"
            ],
            [
                "cx",
                "61",
                2,
                [
                    "89164"
                ]
            ],
            [
                "cc",
                "61",
                1,
                [
                    "89162"
                ]
            ],
            [
                "co",
                "57"
            ],
            [
                "km",
                "269"
            ],
            [
                "cg",
                "242"
            ],
            [
                "cd",
                "243"
            ],
            [
                "ck",
                "682"
            ],
            [
                "cr",
                "506"
            ],
            [
                "ci",
                "225"
            ],
            [
                "hr",
                "385"
            ],
            [
                "cu",
                "53"
            ],
            [
                "cw",
                "599",
                0
            ],
            [
                "cy",
                "357"
            ],
            [
                "cz",
                "420"
            ],
            [
                "dk",
                "45"
            ],
            [
                "dj",
                "253"
            ],
            [
                "dm",
                "1",
                13,
                [
                    "767"
                ]
            ],
            [
                "do",
                "1",
                2,
                [
                    "809",
                    "829",
                    "849"
                ]
            ],
            [
                "ec",
                "593"
            ],
            [
                "eg",
                "20"
            ],
            [
                "sv",
                "503"
            ],
            [
                "gq",
                "240"
            ],
            [
                "er",
                "291"
            ],
            [
                "ee",
                "372"
            ],
            [
                "sz",
                "268"
            ],
            [
                "et",
                "251"
            ],
            [
                "fk",
                "500"
            ],
            [
                "fo",
                "298"
            ],
            [
                "fj",
                "679"
            ],
            [
                "fi",
                "358",
                0
            ],
            [
                "fr",
                "33"
            ],
            [
                "gf",
                "594"
            ],
            [
                "pf",
                "689"
            ],
            [
                "ga",
                "241"
            ],
            [
                "gm",
                "220"
            ],
            [
                "ge",
                "995"
            ],
            [
                "de",
                "49"
            ],
            [
                "gh",
                "233"
            ],
            [
                "gi",
                "350"
            ],
            [
                "gr",
                "30"
            ],
            [
                "gl",
                "299"
            ],
            [
                "gd",
                "1",
                14,
                [
                    "473"
                ]
            ],
            [
                "gp",
                "590",
                0
            ],
            [
                "gu",
                "1",
                15,
                [
                    "671"
                ]
            ],
            [
                "gt",
                "502"
            ],
            [
                "gg",
                "44",
                1,
                [
                    "1481",
                    "7781",
                    "7839",
                    "7911"
                ]
            ],
            [
                "gn",
                "224"
            ],
            [
                "gw",
                "245"
            ],
            [
                "gy",
                "592"
            ],
            [
                "ht",
                "509"
            ],
            [
                "hn",
                "504"
            ],
            [
                "hk",
                "852"
            ],
            [
                "hu",
                "36"
            ],
            [
                "is",
                "354"
            ],
            [
                "in",
                "91"
            ],
            [
                "id",
                "62"
            ],
            [
                "ir",
                "98"
            ],
            [
                "iq",
                "964"
            ],
            [
                "ie",
                "353"
            ],
            [
                "im",
                "44",
                2,
                [
                    "1624",
                    "74576",
                    "7524",
                    "7924",
                    "7624"
                ]
            ],
            [
                "il",
                "972"
            ],
            [
                "it",
                "39",
                0
            ],
            [
                "jm",
                "1",
                4,
                [
                    "876",
                    "658"
                ]
            ],
            [
                "jp",
                "81"
            ],
            [
                "je",
                "44",
                3,
                [
                    "1534",
                    "7509",
                    "7700",
                    "7797",
                    "7829",
                    "7937"
                ]
            ],
            [
                "jo",
                "962"
            ],
            [
                "kz",
                "7",
                1,
                [
                    "33",
                    "7"
                ]
            ],
            [
                "ke",
                "254"
            ],
            [
                "ki",
                "686"
            ],
            [
                "xk",
                "383"
            ],
            [
                "kw",
                "965"
            ],
            [
                "kg",
                "996"
            ],
            [
                "la",
                "856"
            ],
            [
                "lv",
                "371"
            ],
            [
                "lb",
                "961"
            ],
            [
                "ls",
                "266"
            ],
            [
                "lr",
                "231"
            ],
            [
                "ly",
                "218"
            ],
            [
                "li",
                "423"
            ],
            [
                "lt",
                "370"
            ],
            [
                "lu",
                "352"
            ],
            [
                "mo",
                "853"
            ],
            [
                "mg",
                "261"
            ],
            [
                "mw",
                "265"
            ],
            [
                "my",
                "60"
            ],
            [
                "mv",
                "960"
            ],
            [
                "ml",
                "223"
            ],
            [
                "mt",
                "356"
            ],
            [
                "mh",
                "692"
            ],
            [
                "mq",
                "596"
            ],
            [
                "mr",
                "222"
            ],
            [
                "mu",
                "230"
            ],
            [
                "yt",
                "262",
                1,
                [
                    "269",
                    "639"
                ]
            ],
            [
                "mx",
                "52"
            ],
            [
                "fm",
                "691"
            ],
            [
                "md",
                "373"
            ],
            [
                "mc",
                "377"
            ],
            [
                "mn",
                "976"
            ],
            [
                "me",
                "382"
            ],
            [
                "ms",
                "1",
                16,
                [
                    "664"
                ]
            ],
            [
                "ma",
                "212",
                0
            ],
            [
                "mz",
                "258"
            ],
            [
                "mm",
                "95"
            ],
            [
                "na",
                "264"
            ],
            [
                "nr",
                "674"
            ],
            [
                "np",
                "977"
            ],
            [
                "nl",
                "31"
            ],
            [
                "nc",
                "687"
            ],
            [
                "nz",
                "64"
            ],
            [
                "ni",
                "505"
            ],
            [
                "ne",
                "227"
            ],
            [
                "ng",
                "234"
            ],
            [
                "nu",
                "683"
            ],
            [
                "nf",
                "672"
            ],
            [
                "kp",
                "850"
            ],
            [
                "mk",
                "389"
            ],
            [
                "mp",
                "1",
                17,
                [
                    "670"
                ]
            ],
            [
                "no",
                "47",
                0
            ],
            [
                "om",
                "968"
            ],
            [
                "pk",
                "92"
            ],
            [
                "pw",
                "680"
            ],
            [
                "ps",
                "970"
            ],
            [
                "pa",
                "507"
            ],
            [
                "pg",
                "675"
            ],
            [
                "py",
                "595"
            ],
            [
                "pe",
                "51"
            ],
            [
                "ph",
                "63"
            ],
            [
                "pl",
                "48"
            ],
            [
                "pt",
                "351"
            ],
            [
                "pr",
                "1",
                3,
                [
                    "787",
                    "939"
                ]
            ],
            [
                "qa",
                "974"
            ],
            [
                "re",
                "262",
                0
            ],
            [
                "ro",
                "40"
            ],
            [
                "ru",
                "7",
                0
            ],
            [
                "rw",
                "250"
            ],
            [
                "ws",
                "685"
            ],
            [
                "sm",
                "378"
            ],
            [
                "st",
                "239"
            ],
            [
                "sa",
                "966"
            ],
            [
                "sn",
                "221"
            ],
            [
                "rs",
                "381"
            ],
            [
                "sc",
                "248"
            ],
            [
                "sl",
                "232"
            ],
            [
                "sg",
                "65"
            ],
            [
                "sx",
                "1",
                21,
                [
                    "721"
                ]
            ],
            [
                "sk",
                "421"
            ],
            [
                "si",
                "386"
            ],
            [
                "sb",
                "677"
            ],
            [
                "so",
                "252"
            ],
            [
                "za",
                "27"
            ],
            [
                "kr",
                "82"
            ],
            [
                "ss",
                "211"
            ],
            [
                "es",
                "34"
            ],
            [
                "lk",
                "94"
            ],
            [
                "bl",
                "590",
                1
            ],
            [
                "sh",
                "290"
            ],
            [
                "kn",
                "1",
                18,
                [
                    "869"
                ]
            ],
            [
                "lc",
                "1",
                19,
                [
                    "758"
                ]
            ],
            [
                "mf",
                "590",
                2
            ],
            [
                "pm",
                "508"
            ],
            [
                "vc",
                "1",
                20,
                [
                    "784"
                ]
            ],
            [
                "sd",
                "249"
            ],
            [
                "sr",
                "597"
            ],
            [
                "sj",
                "47",
                1,
                [
                    "79"
                ]
            ],
            [
                "se",
                "46"
            ],
            [
                "ch",
                "41"
            ],
            [
                "sy",
                "963"
            ],
            [
                "tw",
                "886"
            ],
            [
                "tj",
                "992"
            ],
            [
                "tz",
                "255"
            ],
            [
                "th",
                "66"
            ],
            [
                "tl",
                "670"
            ],
            [
                "tg",
                "228"
            ],
            [
                "tk",
                "690"
            ],
            [
                "to",
                "676"
            ],
            [
                "tt",
                "1",
                22,
                [
                    "868"
                ]
            ],
            [
                "tn",
                "216"
            ],
            [
                "tr",
                "90"
            ],
            [
                "tm",
                "993"
            ],
            [
                "tc",
                "1",
                23,
                [
                    "649"
                ]
            ],
            [
                "tv",
                "688"
            ],
            [
                "ug",
                "256"
            ],
            [
                "ua",
                "380"
            ],
            [
                "ae",
                "971"
            ],
            [
                "gb",
                "44",
                0
            ],
            [
                "us",
                "1",
                0
            ],
            [
                "uy",
                "598"
            ],
            [
                "vi",
                "1",
                24,
                [
                    "340"
                ]
            ],
            [
                "uz",
                "998"
            ],
            [
                "vu",
                "678"
            ],
            [
                "va",
                "39",
                1,
                [
                    "06698"
                ]
            ],
            [
                "ve",
                "58"
            ],
            [
                "vn",
                "84"
            ],
            [
                "wf",
                "681"
            ],
            [
                "eh",
                "212",
                1,
                [
                    "5288",
                    "5289"
                ]
            ],
            [
                "ye",
                "967"
            ],
            [
                "zm",
                "260"
            ],
            [
                "zw",
                "263"
            ],
            [
                "ax",
                "358",
                1,
                [
                    "18"
                ]
            ]
        ];
        var allCountries = [];
        for(let i = 0; i < rawCountryData.length; i++){
            const c = rawCountryData[i];
            allCountries[i] = {
                name: "",
                // this is now populated in the plugin
                iso2: c[0],
                dialCode: c[1],
                priority: c[2] || 0,
                areaCodes: c[3] || null,
                nodeById: {}
            };
        }
        var data_default = allCountries;
        // src/js/i18n/en/countries.ts
        var countries_default = {
            ad: "Andorra",
            ae: "United Arab Emirates",
            af: "Afghanistan",
            ag: "Antigua & Barbuda",
            ai: "Anguilla",
            al: "Albania",
            am: "Armenia",
            ao: "Angola",
            aq: "Antarctica",
            ar: "Argentina",
            as: "American Samoa",
            at: "Austria",
            au: "Australia",
            aw: "Aruba",
            ax: "\xc5land Islands",
            az: "Azerbaijan",
            ba: "Bosnia & Herzegovina",
            bb: "Barbados",
            bd: "Bangladesh",
            be: "Belgium",
            bf: "Burkina Faso",
            bg: "Bulgaria",
            bh: "Bahrain",
            bi: "Burundi",
            bj: "Benin",
            bl: "St. Barth\xe9lemy",
            bm: "Bermuda",
            bn: "Brunei",
            bo: "Bolivia",
            bq: "Caribbean Netherlands",
            br: "Brazil",
            bs: "Bahamas",
            bt: "Bhutan",
            bv: "Bouvet Island",
            bw: "Botswana",
            by: "Belarus",
            bz: "Belize",
            ca: "Canada",
            cc: "Cocos (Keeling) Islands",
            cd: "Congo - Kinshasa",
            cf: "Central African Republic",
            cg: "Congo - Brazzaville",
            ch: "Switzerland",
            ci: "C\xf4te d\u2019Ivoire",
            ck: "Cook Islands",
            cl: "Chile",
            cm: "Cameroon",
            cn: "China",
            co: "Colombia",
            cr: "Costa Rica",
            cu: "Cuba",
            cv: "Cape Verde",
            cw: "Cura\xe7ao",
            cx: "Christmas Island",
            cy: "Cyprus",
            cz: "Czechia",
            de: "Germany",
            dj: "Djibouti",
            dk: "Denmark",
            dm: "Dominica",
            do: "Dominican Republic",
            dz: "Algeria",
            ec: "Ecuador",
            ee: "Estonia",
            eg: "Egypt",
            eh: "Western Sahara",
            er: "Eritrea",
            es: "Spain",
            et: "Ethiopia",
            fi: "Finland",
            fj: "Fiji",
            fk: "Falkland Islands",
            fm: "Micronesia",
            fo: "Faroe Islands",
            fr: "France",
            ga: "Gabon",
            gb: "United Kingdom",
            gd: "Grenada",
            ge: "Georgia",
            gf: "French Guiana",
            gg: "Guernsey",
            gh: "Ghana",
            gi: "Gibraltar",
            gl: "Greenland",
            gm: "Gambia",
            gn: "Guinea",
            gp: "Guadeloupe",
            gq: "Equatorial Guinea",
            gr: "Greece",
            gs: "South Georgia & South Sandwich Islands",
            gt: "Guatemala",
            gu: "Guam",
            gw: "Guinea-Bissau",
            gy: "Guyana",
            hk: "Hong Kong SAR China",
            hm: "Heard & McDonald Islands",
            hn: "Honduras",
            hr: "Croatia",
            ht: "Haiti",
            hu: "Hungary",
            id: "Indonesia",
            ie: "Ireland",
            il: "Israel",
            im: "Isle of Man",
            in: "India",
            io: "British Indian Ocean Territory",
            iq: "Iraq",
            ir: "Iran",
            is: "Iceland",
            it: "Italy",
            je: "Jersey",
            jm: "Jamaica",
            jo: "Jordan",
            jp: "Japan",
            ke: "Kenya",
            kg: "Kyrgyzstan",
            kh: "Cambodia",
            ki: "Kiribati",
            km: "Comoros",
            kn: "St. Kitts & Nevis",
            kp: "North Korea",
            kr: "South Korea",
            kw: "Kuwait",
            ky: "Cayman Islands",
            kz: "Kazakhstan",
            la: "Laos",
            lb: "Lebanon",
            lc: "St. Lucia",
            li: "Liechtenstein",
            lk: "Sri Lanka",
            lr: "Liberia",
            ls: "Lesotho",
            lt: "Lithuania",
            lu: "Luxembourg",
            lv: "Latvia",
            ly: "Libya",
            ma: "Morocco",
            mc: "Monaco",
            md: "Moldova",
            me: "Montenegro",
            mf: "St. Martin",
            mg: "Madagascar",
            mh: "Marshall Islands",
            mk: "North Macedonia",
            ml: "Mali",
            mm: "Myanmar (Burma)",
            mn: "Mongolia",
            mo: "Macao SAR China",
            mp: "Northern Mariana Islands",
            mq: "Martinique",
            mr: "Mauritania",
            ms: "Montserrat",
            mt: "Malta",
            mu: "Mauritius",
            mv: "Maldives",
            mw: "Malawi",
            mx: "Mexico",
            my: "Malaysia",
            mz: "Mozambique",
            na: "Namibia",
            nc: "New Caledonia",
            ne: "Niger",
            nf: "Norfolk Island",
            ng: "Nigeria",
            ni: "Nicaragua",
            nl: "Netherlands",
            no: "Norway",
            np: "Nepal",
            nr: "Nauru",
            nu: "Niue",
            nz: "New Zealand",
            om: "Oman",
            pa: "Panama",
            pe: "Peru",
            pf: "French Polynesia",
            pg: "Papua New Guinea",
            ph: "Philippines",
            pk: "Pakistan",
            pl: "Poland",
            pm: "St. Pierre & Miquelon",
            pn: "Pitcairn Islands",
            pr: "Puerto Rico",
            ps: "Palestinian Territories",
            pt: "Portugal",
            pw: "Palau",
            py: "Paraguay",
            qa: "Qatar",
            re: "R\xe9union",
            ro: "Romania",
            rs: "Serbia",
            ru: "Russia",
            rw: "Rwanda",
            sa: "Saudi Arabia",
            sb: "Solomon Islands",
            sc: "Seychelles",
            sd: "Sudan",
            se: "Sweden",
            sg: "Singapore",
            sh: "St. Helena",
            si: "Slovenia",
            sj: "Svalbard & Jan Mayen",
            sk: "Slovakia",
            sl: "Sierra Leone",
            sm: "San Marino",
            sn: "Senegal",
            so: "Somalia",
            sr: "Suriname",
            ss: "South Sudan",
            st: "S\xe3o Tom\xe9 & Pr\xedncipe",
            sv: "El Salvador",
            sx: "Sint Maarten",
            sy: "Syria",
            sz: "Eswatini",
            tc: "Turks & Caicos Islands",
            td: "Chad",
            tf: "French Southern Territories",
            tg: "Togo",
            th: "Thailand",
            tj: "Tajikistan",
            tk: "Tokelau",
            tl: "Timor-Leste",
            tm: "Turkmenistan",
            tn: "Tunisia",
            to: "Tonga",
            tr: "Turkey",
            tt: "Trinidad & Tobago",
            tv: "Tuvalu",
            tw: "Taiwan",
            tz: "Tanzania",
            ua: "Ukraine",
            ug: "Uganda",
            um: "U.S. Outlying Islands",
            us: "United States",
            uy: "Uruguay",
            uz: "Uzbekistan",
            va: "Vatican City",
            vc: "St. Vincent & Grenadines",
            ve: "Venezuela",
            vg: "British Virgin Islands",
            vi: "U.S. Virgin Islands",
            vn: "Vietnam",
            vu: "Vanuatu",
            wf: "Wallis & Futuna",
            ws: "Samoa",
            ye: "Yemen",
            yt: "Mayotte",
            za: "South Africa",
            zm: "Zambia",
            zw: "Zimbabwe"
        };
        // src/js/i18n/en/interface.ts
        var interface_default = {
            selectedCountryAriaLabel: "Selected country",
            noCountrySelected: "No country selected",
            countryListAriaLabel: "List of countries",
            searchPlaceholder: "Search",
            zeroSearchResults: "No results found",
            oneSearchResult: "1 result found",
            multipleSearchResults: "${count} results found",
            // additional countries (not supported by country-list library)
            ac: "Ascension Island",
            xk: "Kosovo"
        };
        // src/js/i18n/en/index.ts
        var en_default = {
            ...countries_default,
            ...interface_default
        };
        // src/js/intl-tel-input.ts
        for(let i = 0; i < data_default.length; i++)data_default[i].name = en_default[data_default[i].iso2];
        var id = 0;
        var defaults = {
            //* Whether or not to allow the dropdown.
            allowDropdown: true,
            //* Add a placeholder in the input with an example number for the selected country.
            autoPlaceholder: "polite",
            //* Modify the parentClass.
            containerClass: "",
            //* The order of the countries in the dropdown. Defaults to alphabetical.
            countryOrder: null,
            //* Add a country search input at the top of the dropdown.
            countrySearch: true,
            //* Modify the auto placeholder.
            customPlaceholder: null,
            //* Append menu to specified element.
            dropdownContainer: null,
            //* Don't display these countries.
            excludeCountries: [],
            //* Fix the dropdown width to the input width (rather than being as wide as the longest country name).
            fixDropdownWidth: true,
            //* Format the number as the user types
            formatAsYouType: true,
            //* Format the input value during initialisation and on setNumber.
            formatOnDisplay: true,
            //* geoIp lookup function.
            geoIpLookup: null,
            //* Inject a hidden input with the name returned from this function, and on submit, populate it with the result of getNumber.
            hiddenInput: null,
            //* Internationalise the plugin text e.g. search input placeholder, country names.
            i18n: {},
            //* Initial country.
            initialCountry: "",
            //* National vs international formatting for numbers e.g. placeholders and displaying existing numbers.
            nationalMode: true,
            //* Display only these countries.
            onlyCountries: [],
            //* Number type to use for placeholders.
            placeholderNumberType: "MOBILE",
            //* Show flags - for both the selected country, and in the country dropdown
            showFlags: true,
            //* Display the international dial code next to the selected flag.
            separateDialCode: false,
            //* Only allow certain chars e.g. a plus followed by numeric digits, and cap at max valid length.
            strictMode: false,
            //* Use full screen popup instead of dropdown for country list.
            useFullscreenPopup: typeof navigator !== "undefined" && typeof window !== "undefined" ? //* We cannot just test screen size as some smartphones/website meta tags will report desktop resolutions.
            //* Note: to target Android Mobiles (and not Tablets), we must find 'Android' and 'Mobile'
            /Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 500 : false,
            //* Specify the path to the libphonenumber script to enable validation/formatting.
            utilsScript: "",
            //* The number type to enforce during validation.
            validationNumberType: "MOBILE"
        };
        var regionlessNanpNumbers = [
            "800",
            "822",
            "833",
            "844",
            "855",
            "866",
            "877",
            "880",
            "881",
            "882",
            "883",
            "884",
            "885",
            "886",
            "887",
            "888",
            "889"
        ];
        var getNumeric = (s)=>s.replace(/\D/g, "");
        var normaliseString = (s = "")=>s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
        var isRegionlessNanp = (number)=>{
            const numeric = getNumeric(number);
            if (numeric.charAt(0) === "1") {
                const areaCode = numeric.substr(1, 3);
                return regionlessNanpNumbers.indexOf(areaCode) !== -1;
            }
            return false;
        };
        var translateCursorPosition = (relevantChars, formattedValue, prevCaretPos, isDeleteForwards)=>{
            if (prevCaretPos === 0 && !isDeleteForwards) return 0;
            let count = 0;
            for(let i = 0; i < formattedValue.length; i++){
                if (/[+0-9]/.test(formattedValue[i])) count++;
                if (count === relevantChars && !isDeleteForwards) return i + 1;
                if (isDeleteForwards && count === relevantChars + 1) return i;
            }
            return formattedValue.length;
        };
        var createEl = (name, attrs, container)=>{
            const el = document.createElement(name);
            if (attrs) Object.entries(attrs).forEach(([key, value])=>el.setAttribute(key, value));
            if (container) container.appendChild(el);
            return el;
        };
        var forEachInstance = (method)=>{
            const { instances: instances } = intlTelInput;
            Object.values(instances).forEach((instance)=>instance[method]());
        };
        var Iti = class {
            constructor(input, customOptions = {}){
                this.id = id++;
                this.telInput = input;
                this.highlightedItem = null;
                this.options = Object.assign({}, defaults, customOptions);
                this.hadInitialPlaceholder = Boolean(input.getAttribute("placeholder"));
            }
            //* Can't be private as it's called from intlTelInput convenience wrapper.
            _init() {
                if (this.options.useFullscreenPopup) this.options.fixDropdownWidth = false;
                if (this.options.separateDialCode) {
                    this.options.allowDropdown = true;
                    this.options.nationalMode = false;
                    this.options.countrySearch = true;
                }
                if (!this.options.showFlags && !this.options.separateDialCode) this.options.nationalMode = false;
                if (this.options.useFullscreenPopup && !this.options.dropdownContainer) this.options.dropdownContainer = document.body;
                this.isAndroid = typeof navigator !== "undefined" ? /Android/i.test(navigator.userAgent) : false;
                this.isRTL = !!this.telInput.closest("[dir=rtl]");
                if (this.options.separateDialCode) {
                    if (this.isRTL) this.originalPaddingRight = this.telInput.style.paddingRight;
                    else this.originalPaddingLeft = this.telInput.style.paddingLeft;
                }
                this.options.i18n = {
                    ...en_default,
                    ...this.options.i18n
                };
                const autoCountryPromise = new Promise((resolve, reject)=>{
                    this.resolveAutoCountryPromise = resolve;
                    this.rejectAutoCountryPromise = reject;
                });
                const utilsScriptPromise = new Promise((resolve, reject)=>{
                    this.resolveUtilsScriptPromise = resolve;
                    this.rejectUtilsScriptPromise = reject;
                });
                this.promise = Promise.all([
                    autoCountryPromise,
                    utilsScriptPromise
                ]);
                this.selectedCountryData = {};
                this._processCountryData();
                this._generateMarkup();
                this._setInitialState();
                this._initListeners();
                this._initRequests();
            }
            //********************
            //*  PRIVATE METHODS
            //********************
            //* Prepare all of the country data, including onlyCountries, excludeCountries, countryOrder options.
            _processCountryData() {
                this._processAllCountries();
                this._processDialCodes();
                this._translateCountryNames();
                this._sortCountries();
            }
            //* Sort countries by countryOrder option (if present), then name.
            _sortCountries() {
                if (this.options.countryOrder) this.options.countryOrder = this.options.countryOrder.map((country)=>country.toLowerCase());
                this.countries.sort((a, b)=>{
                    const { countryOrder: countryOrder } = this.options;
                    if (countryOrder) {
                        const aIndex = countryOrder.indexOf(a.iso2);
                        const bIndex = countryOrder.indexOf(b.iso2);
                        const aIndexExists = aIndex > -1;
                        const bIndexExists = bIndex > -1;
                        if (aIndexExists || bIndexExists) {
                            if (aIndexExists && bIndexExists) return aIndex - bIndex;
                            return aIndexExists ? -1 : 1;
                        }
                    }
                    return a.name.localeCompare(b.name);
                });
            }
            //* Add a dial code to this.dialCodeToIso2Map.
            _addToDialCodeMap(iso2, dialCode, priority) {
                if (dialCode.length > this.dialCodeMaxLen) this.dialCodeMaxLen = dialCode.length;
                if (!this.dialCodeToIso2Map.hasOwnProperty(dialCode)) this.dialCodeToIso2Map[dialCode] = [];
                for(let i = 0; i < this.dialCodeToIso2Map[dialCode].length; i++){
                    if (this.dialCodeToIso2Map[dialCode][i] === iso2) return;
                }
                const index = priority !== void 0 ? priority : this.dialCodeToIso2Map[dialCode].length;
                this.dialCodeToIso2Map[dialCode][index] = iso2;
            }
            //* Process onlyCountries or excludeCountries array if present.
            _processAllCountries() {
                const { onlyCountries: onlyCountries, excludeCountries: excludeCountries } = this.options;
                if (onlyCountries.length) {
                    const lowerCaseOnlyCountries = onlyCountries.map((country)=>country.toLowerCase());
                    this.countries = data_default.filter((country)=>lowerCaseOnlyCountries.indexOf(country.iso2) > -1);
                } else if (excludeCountries.length) {
                    const lowerCaseExcludeCountries = excludeCountries.map((country)=>country.toLowerCase());
                    this.countries = data_default.filter((country)=>lowerCaseExcludeCountries.indexOf(country.iso2) === -1);
                } else this.countries = data_default;
            }
            //* Translate Countries by object literal provided on config.
            _translateCountryNames() {
                for(let i = 0; i < this.countries.length; i++){
                    const iso2 = this.countries[i].iso2.toLowerCase();
                    if (this.options.i18n.hasOwnProperty(iso2)) this.countries[i].name = this.options.i18n[iso2];
                }
            }
            //* Generate this.dialCodes and this.dialCodeToIso2Map.
            _processDialCodes() {
                this.dialCodes = {};
                this.dialCodeMaxLen = 0;
                this.dialCodeToIso2Map = {};
                for(let i = 0; i < this.countries.length; i++){
                    const c = this.countries[i];
                    if (!this.dialCodes[c.dialCode]) this.dialCodes[c.dialCode] = true;
                    this._addToDialCodeMap(c.iso2, c.dialCode, c.priority);
                }
                for(let i = 0; i < this.countries.length; i++){
                    const c = this.countries[i];
                    if (c.areaCodes) {
                        const rootIso2Code = this.dialCodeToIso2Map[c.dialCode][0];
                        for(let j = 0; j < c.areaCodes.length; j++){
                            const areaCode = c.areaCodes[j];
                            for(let k = 1; k < areaCode.length; k++){
                                const partialDialCode = c.dialCode + areaCode.substr(0, k);
                                this._addToDialCodeMap(rootIso2Code, partialDialCode);
                                this._addToDialCodeMap(c.iso2, partialDialCode);
                            }
                            this._addToDialCodeMap(c.iso2, c.dialCode + areaCode);
                        }
                    }
                }
            }
            //* Generate all of the markup for the plugin: the selected country overlay, and the dropdown.
            _generateMarkup() {
                this.telInput.classList.add("iti__tel-input");
                if (!this.telInput.hasAttribute("autocomplete") && !(this.telInput.form && this.telInput.form.hasAttribute("autocomplete"))) this.telInput.setAttribute("autocomplete", "off");
                const { allowDropdown: allowDropdown, separateDialCode: separateDialCode, showFlags: showFlags, containerClass: containerClass, hiddenInput: hiddenInput, dropdownContainer: dropdownContainer, fixDropdownWidth: fixDropdownWidth, useFullscreenPopup: useFullscreenPopup, countrySearch: countrySearch, i18n: i18n } = this.options;
                let parentClass = "iti";
                if (allowDropdown) parentClass += " iti--allow-dropdown";
                if (showFlags) parentClass += " iti--show-flags";
                if (containerClass) parentClass += ` ${containerClass}`;
                if (!useFullscreenPopup) parentClass += " iti--inline-dropdown";
                const wrapper = createEl("div", {
                    class: parentClass
                });
                this.telInput.parentNode?.insertBefore(wrapper, this.telInput);
                if (allowDropdown || showFlags) {
                    this.countryContainer = createEl("div", {
                        class: "iti__country-container"
                    }, wrapper);
                    if (allowDropdown) {
                        this.selectedCountry = createEl("button", {
                            type: "button",
                            class: "iti__selected-country",
                            "aria-expanded": "false",
                            "aria-label": this.options.i18n.selectedCountryAriaLabel,
                            "aria-haspopup": "true",
                            "aria-controls": `iti-${this.id}__dropdown-content`,
                            "role": "combobox"
                        }, this.countryContainer);
                        if (this.telInput.disabled) this.selectedCountry.setAttribute("disabled", "true");
                    } else this.selectedCountry = createEl("div", {
                        class: "iti__selected-country"
                    }, this.countryContainer);
                    const selectedCountryPrimary = createEl("div", {
                        class: "iti__selected-country-primary"
                    }, this.selectedCountry);
                    this.selectedCountryInner = createEl("div", null, selectedCountryPrimary);
                    this.selectedCountryA11yText = createEl("span", {
                        class: "iti__a11y-text"
                    }, this.selectedCountryInner);
                    if (allowDropdown) this.dropdownArrow = createEl("div", {
                        class: "iti__arrow",
                        "aria-hidden": "true"
                    }, selectedCountryPrimary);
                    if (separateDialCode) this.selectedDialCode = createEl("div", {
                        class: "iti__selected-dial-code"
                    }, this.selectedCountry);
                    if (allowDropdown) {
                        const extraClasses = fixDropdownWidth ? "" : "iti--flexible-dropdown-width";
                        this.dropdownContent = createEl("div", {
                            id: `iti-${this.id}__dropdown-content`,
                            class: `iti__dropdown-content iti__hide ${extraClasses}`
                        });
                        if (countrySearch) {
                            this.searchInput = createEl("input", {
                                type: "text",
                                class: "iti__search-input",
                                placeholder: i18n.searchPlaceholder,
                                role: "combobox",
                                "aria-expanded": "true",
                                "aria-label": i18n.searchPlaceholder,
                                "aria-controls": `iti-${this.id}__country-listbox`,
                                "aria-autocomplete": "list",
                                "autocomplete": "off"
                            }, this.dropdownContent);
                            this.searchResultsA11yText = createEl("span", {
                                class: "iti__a11y-text"
                            }, this.dropdownContent);
                        }
                        this.countryList = createEl("ul", {
                            class: "iti__country-list",
                            id: `iti-${this.id}__country-listbox`,
                            role: "listbox",
                            "aria-label": i18n.countryListAriaLabel
                        }, this.dropdownContent);
                        this._appendListItems();
                        if (countrySearch) this._updateSearchResultsText();
                        if (dropdownContainer) {
                            let dropdownClasses = "iti iti--container";
                            if (useFullscreenPopup) dropdownClasses += " iti--fullscreen-popup";
                            else dropdownClasses += " iti--inline-dropdown";
                            this.dropdown = createEl("div", {
                                class: dropdownClasses
                            });
                            this.dropdown.appendChild(this.dropdownContent);
                        } else this.countryContainer.appendChild(this.dropdownContent);
                    }
                }
                wrapper.appendChild(this.telInput);
                if (hiddenInput) {
                    const telInputName = this.telInput.getAttribute("name") || "";
                    const names = hiddenInput(telInputName);
                    if (names.phone) {
                        this.hiddenInput = createEl("input", {
                            type: "hidden",
                            name: names.phone
                        });
                        wrapper.appendChild(this.hiddenInput);
                    }
                    if (names.country) {
                        this.hiddenInputCountry = createEl("input", {
                            type: "hidden",
                            name: names.country
                        });
                        wrapper.appendChild(this.hiddenInputCountry);
                    }
                }
            }
            //* For each country: add a country list item <li> to the countryList <ul> container.
            _appendListItems() {
                for(let i = 0; i < this.countries.length; i++){
                    const c = this.countries[i];
                    const extraClass = i === 0 ? "iti__highlight" : "";
                    const listItem = createEl("li", {
                        id: `iti-${this.id}__item-${c.iso2}`,
                        class: `iti__country ${extraClass}`,
                        tabindex: "-1",
                        role: "option",
                        "data-dial-code": c.dialCode,
                        "data-country-code": c.iso2,
                        "aria-selected": "false"
                    }, this.countryList);
                    c.nodeById[this.id] = listItem;
                    let content = "";
                    if (this.options.showFlags) content += `<div class='iti__flag-box'><div class='iti__flag iti__${c.iso2}'></div></div>`;
                    content += `<span class='iti__country-name'>${c.name}</span>`;
                    content += `<span class='iti__dial-code'>+${c.dialCode}</span>`;
                    listItem.insertAdjacentHTML("beforeend", content);
                }
            }
            //* Set the initial state of the input value and the selected country by:
            //* 1. Extracting a dial code from the given number
            //* 2. Using explicit initialCountry
            _setInitialState(overrideAutoCountry = false) {
                const attributeValue = this.telInput.getAttribute("value");
                const inputValue = this.telInput.value;
                const useAttribute = attributeValue && attributeValue.charAt(0) === "+" && (!inputValue || inputValue.charAt(0) !== "+");
                const val = useAttribute ? attributeValue : inputValue;
                const dialCode = this._getDialCode(val);
                const isRegionlessNanpNumber = isRegionlessNanp(val);
                const { initialCountry: initialCountry, geoIpLookup: geoIpLookup } = this.options;
                const isAutoCountry = initialCountry === "auto" && geoIpLookup;
                if (dialCode && !isRegionlessNanpNumber) this._updateCountryFromNumber(val);
                else if (!isAutoCountry || overrideAutoCountry) {
                    const lowerInitialCountry = initialCountry ? initialCountry.toLowerCase() : "";
                    const isValidInitialCountry = lowerInitialCountry && this._getCountryData(lowerInitialCountry, true);
                    if (isValidInitialCountry) this._setCountry(lowerInitialCountry);
                    else if (dialCode && isRegionlessNanpNumber) this._setCountry("us");
                    else this._setCountry();
                }
                if (val) this._updateValFromNumber(val);
            }
            //* Initialise the main event listeners: input keyup, and click selected country.
            _initListeners() {
                this._initTelInputListeners();
                if (this.options.allowDropdown) this._initDropdownListeners();
                if ((this.hiddenInput || this.hiddenInputCountry) && this.telInput.form) this._initHiddenInputListener();
            }
            //* Update hidden input on form submit.
            _initHiddenInputListener() {
                this._handleHiddenInputSubmit = ()=>{
                    if (this.hiddenInput) this.hiddenInput.value = this.getNumber();
                    if (this.hiddenInputCountry) this.hiddenInputCountry.value = this.getSelectedCountryData().iso2 || "";
                };
                this.telInput.form?.addEventListener("submit", this._handleHiddenInputSubmit);
            }
            //* initialise the dropdown listeners.
            _initDropdownListeners() {
                this._handleLabelClick = (e)=>{
                    if (this.dropdownContent.classList.contains("iti__hide")) this.telInput.focus();
                    else e.preventDefault();
                };
                const label = this.telInput.closest("label");
                if (label) label.addEventListener("click", this._handleLabelClick);
                this._handleClickSelectedCountry = ()=>{
                    if (this.dropdownContent.classList.contains("iti__hide") && !this.telInput.disabled && !this.telInput.readOnly) this._openDropdown();
                };
                this.selectedCountry.addEventListener("click", this._handleClickSelectedCountry);
                this._handleCountryContainerKeydown = (e)=>{
                    const isDropdownHidden = this.dropdownContent.classList.contains("iti__hide");
                    if (isDropdownHidden && [
                        "ArrowUp",
                        "ArrowDown",
                        " ",
                        "Enter"
                    ].includes(e.key)) {
                        e.preventDefault();
                        e.stopPropagation();
                        this._openDropdown();
                    }
                    if (e.key === "Tab") this._closeDropdown();
                };
                this.countryContainer.addEventListener("keydown", this._handleCountryContainerKeydown);
            }
            //* Init many requests: utils script / geo ip lookup.
            _initRequests() {
                const { utilsScript: utilsScript, initialCountry: initialCountry, geoIpLookup: geoIpLookup } = this.options;
                if (utilsScript && !intlTelInput.utils) {
                    if (intlTelInput.documentReady()) intlTelInput.loadUtils(utilsScript);
                    else window.addEventListener("load", ()=>{
                        intlTelInput.loadUtils(utilsScript);
                    });
                } else this.resolveUtilsScriptPromise();
                const isAutoCountry = initialCountry === "auto" && geoIpLookup;
                if (isAutoCountry && !this.selectedCountryData.iso2) this._loadAutoCountry();
                else this.resolveAutoCountryPromise();
            }
            //* Perform the geo ip lookup.
            _loadAutoCountry() {
                if (intlTelInput.autoCountry) this.handleAutoCountry();
                else if (!intlTelInput.startedLoadingAutoCountry) {
                    intlTelInput.startedLoadingAutoCountry = true;
                    if (typeof this.options.geoIpLookup === "function") this.options.geoIpLookup((iso2 = "")=>{
                        const iso2Lower = iso2.toLowerCase();
                        const isValidIso2 = iso2Lower && this._getCountryData(iso2Lower, true);
                        if (isValidIso2) {
                            intlTelInput.autoCountry = iso2Lower;
                            setTimeout(()=>forEachInstance("handleAutoCountry"));
                        } else {
                            this._setInitialState(true);
                            forEachInstance("rejectAutoCountryPromise");
                        }
                    }, ()=>{
                        this._setInitialState(true);
                        forEachInstance("rejectAutoCountryPromise");
                    });
                }
            }
            //* Initialize the tel input listeners.
            _initTelInputListeners() {
                const { strictMode: strictMode, formatAsYouType: formatAsYouType, separateDialCode: separateDialCode, formatOnDisplay: formatOnDisplay } = this.options;
                let userOverrideFormatting = false;
                if (/\p{L}/u.test(this.telInput.value)) userOverrideFormatting = true;
                const openDropdownWithPlus = ()=>{
                    this._openDropdown();
                    this.searchInput.value = "+";
                    this._filterCountries("", true);
                };
                this._handleInputEvent = (e)=>{
                    if (this.isAndroid && e?.data === "+" && separateDialCode) {
                        const currentCaretPos = this.telInput.selectionStart || 0;
                        const valueBeforeCaret = this.telInput.value.substring(0, currentCaretPos - 1);
                        const valueAfterCaret = this.telInput.value.substring(currentCaretPos);
                        this.telInput.value = valueBeforeCaret + valueAfterCaret;
                        openDropdownWithPlus();
                        return;
                    }
                    if (this._updateCountryFromNumber(this.telInput.value)) this._triggerCountryChange();
                    const isFormattingChar = e?.data && /[^+0-9]/.test(e.data);
                    const isPaste = e?.inputType === "insertFromPaste" && this.telInput.value;
                    if (isFormattingChar || isPaste && !strictMode) userOverrideFormatting = true;
                    else if (!/[^+0-9]/.test(this.telInput.value)) userOverrideFormatting = false;
                    const disableFormatOnSetNumber = e?.detail && e.detail["isSetNumber"] && !formatOnDisplay;
                    if (formatAsYouType && !userOverrideFormatting && !disableFormatOnSetNumber) {
                        const currentCaretPos = this.telInput.selectionStart || 0;
                        const valueBeforeCaret = this.telInput.value.substring(0, currentCaretPos);
                        const relevantCharsBeforeCaret = valueBeforeCaret.replace(/[^+0-9]/g, "").length;
                        const isDeleteForwards = e?.inputType === "deleteContentForward";
                        const formattedValue = this._formatNumberAsYouType();
                        const newCaretPos = translateCursorPosition(relevantCharsBeforeCaret, formattedValue, currentCaretPos, isDeleteForwards);
                        this.telInput.value = formattedValue;
                        this.telInput.setSelectionRange(newCaretPos, newCaretPos);
                    }
                };
                this.telInput.addEventListener("input", this._handleInputEvent);
                if (strictMode || separateDialCode) {
                    this._handleKeydownEvent = (e)=>{
                        if (e.key && e.key.length === 1 && !e.altKey && !e.ctrlKey && !e.metaKey) {
                            if (separateDialCode && e.key === "+") {
                                e.preventDefault();
                                openDropdownWithPlus();
                                return;
                            }
                            if (strictMode) {
                                const isInitialPlus = this.telInput.selectionStart === 0 && e.key === "+";
                                const isNumeric = /^[0-9]$/.test(e.key);
                                const isAllowedChar = isInitialPlus || isNumeric;
                                const fullNumber = this._getFullNumber();
                                const coreNumber = intlTelInput.utils.getCoreNumber(fullNumber, this.selectedCountryData.iso2);
                                const hasReachedMaxLength = this.maxCoreNumberLength && coreNumber.length >= this.maxCoreNumberLength;
                                const selectedText = this.telInput.value.substring(this.telInput.selectionStart, this.telInput.selectionEnd);
                                const hasSelectedDigit = /\d/.test(selectedText);
                                if (!isAllowedChar || hasReachedMaxLength && !hasSelectedDigit) e.preventDefault();
                            }
                        }
                    };
                    this.telInput.addEventListener("keydown", this._handleKeydownEvent);
                }
            }
            //* Adhere to the input's maxlength attr.
            _cap(number) {
                const max = parseInt(this.telInput.getAttribute("maxlength") || "", 10);
                return max && number.length > max ? number.substr(0, max) : number;
            }
            //* Trigger a custom event on the input.
            _trigger(name, detailProps = {}) {
                const e = new CustomEvent(name, {
                    bubbles: true,
                    cancelable: true,
                    detail: detailProps
                });
                this.telInput.dispatchEvent(e);
            }
            //* Open the dropdown.
            _openDropdown() {
                const { fixDropdownWidth: fixDropdownWidth, countrySearch: countrySearch } = this.options;
                if (fixDropdownWidth) this.dropdownContent.style.width = `${this.telInput.offsetWidth}px`;
                this.dropdownContent.classList.remove("iti__hide");
                this.selectedCountry.setAttribute("aria-expanded", "true");
                this._setDropdownPosition();
                if (countrySearch) {
                    const firstCountryItem = this.countryList.firstElementChild;
                    if (firstCountryItem) {
                        this._highlightListItem(firstCountryItem, false);
                        this.countryList.scrollTop = 0;
                    }
                    this.searchInput.focus();
                }
                this._bindDropdownListeners();
                this.dropdownArrow.classList.add("iti__arrow--up");
                this._trigger("open:countrydropdown");
            }
            //* Set the dropdown position
            _setDropdownPosition() {
                if (this.options.dropdownContainer) this.options.dropdownContainer.appendChild(this.dropdown);
                if (!this.options.useFullscreenPopup) {
                    const inputPosRelativeToVP = this.telInput.getBoundingClientRect();
                    const inputHeight = this.telInput.offsetHeight;
                    if (this.options.dropdownContainer) {
                        this.dropdown.style.top = `${inputPosRelativeToVP.top + inputHeight}px`;
                        this.dropdown.style.left = `${inputPosRelativeToVP.left}px`;
                        this._handleWindowScroll = ()=>this._closeDropdown();
                        window.addEventListener("scroll", this._handleWindowScroll);
                    }
                }
            }
            //* We only bind dropdown listeners when the dropdown is open.
            _bindDropdownListeners() {
                this._handleMouseoverCountryList = (e)=>{
                    const listItem = e.target?.closest(".iti__country");
                    if (listItem) this._highlightListItem(listItem, false);
                };
                this.countryList.addEventListener("mouseover", this._handleMouseoverCountryList);
                this._handleClickCountryList = (e)=>{
                    const listItem = e.target?.closest(".iti__country");
                    if (listItem) this._selectListItem(listItem);
                };
                this.countryList.addEventListener("click", this._handleClickCountryList);
                let isOpening = true;
                this._handleClickOffToClose = ()=>{
                    if (!isOpening) this._closeDropdown();
                    isOpening = false;
                };
                document.documentElement.addEventListener("click", this._handleClickOffToClose);
                let query = "";
                let queryTimer = null;
                this._handleKeydownOnDropdown = (e)=>{
                    if ([
                        "ArrowUp",
                        "ArrowDown",
                        "Enter",
                        "Escape"
                    ].includes(e.key)) {
                        e.preventDefault();
                        e.stopPropagation();
                        if (e.key === "ArrowUp" || e.key === "ArrowDown") this._handleUpDownKey(e.key);
                        else if (e.key === "Enter") this._handleEnterKey();
                        else if (e.key === "Escape") this._closeDropdown();
                    }
                    if (!this.options.countrySearch && /^[a-zA-ZÀ-ÿа-яА-Я ]$/.test(e.key)) {
                        e.stopPropagation();
                        if (queryTimer) clearTimeout(queryTimer);
                        query += e.key.toLowerCase();
                        this._searchForCountry(query);
                        queryTimer = setTimeout(()=>{
                            query = "";
                        }, 1e3);
                    }
                };
                document.addEventListener("keydown", this._handleKeydownOnDropdown);
                if (this.options.countrySearch) {
                    const doFilter = ()=>{
                        const inputQuery = this.searchInput.value.trim();
                        if (inputQuery) this._filterCountries(inputQuery);
                        else this._filterCountries("", true);
                    };
                    let keyupTimer = null;
                    this._handleSearchChange = ()=>{
                        if (keyupTimer) clearTimeout(keyupTimer);
                        keyupTimer = setTimeout(()=>{
                            doFilter();
                            keyupTimer = null;
                        }, 100);
                    };
                    this.searchInput.addEventListener("input", this._handleSearchChange);
                    this.searchInput.addEventListener("click", (e)=>e.stopPropagation());
                }
            }
            //* Hidden search (countrySearch disabled): Find the first list item whose name starts with the query string.
            _searchForCountry(query) {
                for(let i = 0; i < this.countries.length; i++){
                    const c = this.countries[i];
                    const startsWith = c.name.substr(0, query.length).toLowerCase() === query;
                    if (startsWith) {
                        const listItem = c.nodeById[this.id];
                        this._highlightListItem(listItem, false);
                        this._scrollTo(listItem);
                        break;
                    }
                }
            }
            //* Country search enabled: Filter the countries according to the search query.
            _filterCountries(query, isReset = false) {
                let noCountriesAddedYet = true;
                this.countryList.innerHTML = "";
                const normalisedQuery = normaliseString(query);
                for(let i = 0; i < this.countries.length; i++){
                    const c = this.countries[i];
                    const normalisedCountryName = normaliseString(c.name);
                    const fullDialCode = `+${c.dialCode}`;
                    if (isReset || normalisedCountryName.includes(normalisedQuery) || fullDialCode.includes(normalisedQuery) || c.iso2.includes(normalisedQuery)) {
                        const listItem = c.nodeById[this.id];
                        if (listItem) this.countryList.appendChild(listItem);
                        if (noCountriesAddedYet) {
                            this._highlightListItem(listItem, false);
                            noCountriesAddedYet = false;
                        }
                    }
                }
                if (noCountriesAddedYet) this._highlightListItem(null, false);
                this.countryList.scrollTop = 0;
                this._updateSearchResultsText();
            }
            //* Update search results text (for a11y).
            _updateSearchResultsText() {
                const { i18n: i18n } = this.options;
                const count = this.countryList.childElementCount;
                let searchText;
                if (count === 0) searchText = i18n.zeroSearchResults;
                else if (count === 1) searchText = i18n.oneSearchResult;
                else searchText = i18n.multipleSearchResults.replace("${count}", count.toString());
                this.searchResultsA11yText.textContent = searchText;
            }
            //* Highlight the next/prev item in the list (and ensure it is visible).
            _handleUpDownKey(key) {
                let next = key === "ArrowUp" ? this.highlightedItem?.previousElementSibling : this.highlightedItem?.nextElementSibling;
                if (!next && this.countryList.childElementCount > 1) next = key === "ArrowUp" ? this.countryList.lastElementChild : this.countryList.firstElementChild;
                if (next) {
                    this._scrollTo(next);
                    this._highlightListItem(next, false);
                }
            }
            //* Select the currently highlighted item.
            _handleEnterKey() {
                if (this.highlightedItem) this._selectListItem(this.highlightedItem);
            }
            //* Update the input's value to the given val (format first if possible)
            //* NOTE: this is called from _setInitialState, handleUtils and setNumber.
            _updateValFromNumber(fullNumber) {
                let number = fullNumber;
                if (this.options.formatOnDisplay && intlTelInput.utils && this.selectedCountryData) {
                    const useNational = this.options.nationalMode || number.charAt(0) !== "+" && !this.options.separateDialCode;
                    const { NATIONAL: NATIONAL, INTERNATIONAL: INTERNATIONAL } = intlTelInput.utils.numberFormat;
                    const format = useNational ? NATIONAL : INTERNATIONAL;
                    number = intlTelInput.utils.formatNumber(number, this.selectedCountryData.iso2, format);
                }
                number = this._beforeSetNumber(number);
                this.telInput.value = number;
            }
            //* Check if need to select a new country based on the given number
            //* Note: called from _setInitialState, keyup handler, setNumber.
            _updateCountryFromNumber(fullNumber) {
                const plusIndex = fullNumber.indexOf("+");
                let number = plusIndex ? fullNumber.substring(plusIndex) : fullNumber;
                const selectedDialCode = this.selectedCountryData.dialCode;
                const isNanp = selectedDialCode === "1";
                if (number && isNanp && number.charAt(0) !== "+") {
                    if (number.charAt(0) !== "1") number = `1${number}`;
                    number = `+${number}`;
                }
                if (this.options.separateDialCode && selectedDialCode && number.charAt(0) !== "+") number = `+${selectedDialCode}${number}`;
                const dialCode = this._getDialCode(number, true);
                const numeric = getNumeric(number);
                let iso2 = null;
                if (dialCode) {
                    const iso2Codes = this.dialCodeToIso2Map[getNumeric(dialCode)];
                    const alreadySelected = iso2Codes.indexOf(this.selectedCountryData.iso2) !== -1 && numeric.length <= dialCode.length - 1;
                    const isRegionlessNanpNumber = selectedDialCode === "1" && isRegionlessNanp(numeric);
                    if (!isRegionlessNanpNumber && !alreadySelected) {
                        for(let j = 0; j < iso2Codes.length; j++)if (iso2Codes[j]) {
                            iso2 = iso2Codes[j];
                            break;
                        }
                    }
                } else if (number.charAt(0) === "+" && numeric.length) iso2 = "";
                else if ((!number || number === "+") && !this.selectedCountryData.iso2) iso2 = this.defaultCountry;
                if (iso2 !== null) return this._setCountry(iso2);
                return false;
            }
            //* Remove highlighting from other list items and highlight the given item.
            _highlightListItem(listItem, shouldFocus) {
                const prevItem = this.highlightedItem;
                if (prevItem) {
                    prevItem.classList.remove("iti__highlight");
                    prevItem.setAttribute("aria-selected", "false");
                }
                this.highlightedItem = listItem;
                if (this.highlightedItem) {
                    this.highlightedItem.classList.add("iti__highlight");
                    this.highlightedItem.setAttribute("aria-selected", "true");
                    const activeDescendant = this.highlightedItem.getAttribute("id") || "";
                    this.selectedCountry.setAttribute("aria-activedescendant", activeDescendant);
                    if (this.options.countrySearch) this.searchInput.setAttribute("aria-activedescendant", activeDescendant);
                }
                if (shouldFocus) this.highlightedItem.focus();
            }
            //* Find the country data for the given iso2 code
            //* the ignoreOnlyCountriesOption is only used during init() while parsing the onlyCountries array
            _getCountryData(iso2, allowFail) {
                for(let i = 0; i < this.countries.length; i++){
                    if (this.countries[i].iso2 === iso2) return this.countries[i];
                }
                if (allowFail) return null;
                throw new Error(`No country data for '${iso2}'`);
            }
            //* Update the selected country, dial code (if separateDialCode), placeholder, title, and active list item.
            //* Note: called from _setInitialState, _updateCountryFromNumber, _selectListItem, setCountry.
            _setCountry(iso2) {
                const { separateDialCode: separateDialCode, showFlags: showFlags, i18n: i18n } = this.options;
                const prevCountry = this.selectedCountryData.iso2 ? this.selectedCountryData : {};
                this.selectedCountryData = iso2 ? this._getCountryData(iso2, false) || {} : {};
                if (this.selectedCountryData.iso2) this.defaultCountry = this.selectedCountryData.iso2;
                if (this.selectedCountryInner) {
                    let flagClass = "";
                    let a11yText = "";
                    if (iso2 && showFlags) {
                        flagClass = `iti__flag iti__${iso2}`;
                        a11yText = `${this.selectedCountryData.name} +${this.selectedCountryData.dialCode}`;
                    } else {
                        flagClass = "iti__flag iti__globe";
                        a11yText = i18n.noCountrySelected;
                    }
                    this.selectedCountryInner.className = flagClass;
                    this.selectedCountryA11yText.textContent = a11yText;
                }
                this._setSelectedCountryTitleAttribute(iso2, separateDialCode);
                if (separateDialCode) {
                    const dialCode = this.selectedCountryData.dialCode ? `+${this.selectedCountryData.dialCode}` : "";
                    this.selectedDialCode.innerHTML = dialCode;
                    const selectedCountryWidth = this.selectedCountry.offsetWidth || this._getHiddenSelectedCountryWidth();
                    const inputPadding = selectedCountryWidth + 8;
                    if (this.isRTL) this.telInput.style.paddingRight = `${inputPadding}px`;
                    else this.telInput.style.paddingLeft = `${inputPadding}px`;
                }
                this._updatePlaceholder();
                this._updateMaxLength();
                return prevCountry.iso2 !== iso2;
            }
            //* Update the maximum valid number length for the currently selected country.
            _updateMaxLength() {
                const { strictMode: strictMode, placeholderNumberType: placeholderNumberType, validationNumberType: validationNumberType } = this.options;
                if (strictMode && intlTelInput.utils) {
                    if (this.selectedCountryData.iso2) {
                        const numberType = intlTelInput.utils.numberType[placeholderNumberType];
                        let exampleNumber = intlTelInput.utils.getExampleNumber(this.selectedCountryData.iso2, false, numberType, true);
                        let validNumber = exampleNumber;
                        while(intlTelInput.utils.isPossibleNumber(exampleNumber, this.selectedCountryData.iso2, validationNumberType)){
                            validNumber = exampleNumber;
                            exampleNumber += "0";
                        }
                        const coreNumber = intlTelInput.utils.getCoreNumber(validNumber, this.selectedCountryData.iso2);
                        this.maxCoreNumberLength = coreNumber.length;
                    } else this.maxCoreNumberLength = null;
                }
            }
            _setSelectedCountryTitleAttribute(iso2 = null, separateDialCode) {
                if (!this.selectedCountry) return;
                let title;
                if (iso2 && !separateDialCode) title = `${this.selectedCountryData.name}: +${this.selectedCountryData.dialCode}`;
                else if (iso2) title = this.selectedCountryData.name;
                else title = "Unknown";
                this.selectedCountry.setAttribute("title", title);
            }
            //* When the input is in a hidden container during initialisation, we must inject some markup
            //* into the end of the DOM to calculate the correct offsetWidth.
            //* NOTE: this is only used when separateDialCode is enabled, so countryContainer and selectedCountry
            //* will definitely exist.
            _getHiddenSelectedCountryWidth() {
                if (this.telInput.parentNode) {
                    const containerClone = this.telInput.parentNode.cloneNode(false);
                    containerClone.style.visibility = "hidden";
                    document.body.appendChild(containerClone);
                    const countryContainerClone = this.countryContainer.cloneNode();
                    containerClone.appendChild(countryContainerClone);
                    const selectedCountryClone = this.selectedCountry.cloneNode(true);
                    countryContainerClone.appendChild(selectedCountryClone);
                    const width = selectedCountryClone.offsetWidth;
                    document.body.removeChild(containerClone);
                    return width;
                }
                return 0;
            }
            //* Update the input placeholder to an example number from the currently selected country.
            _updatePlaceholder() {
                const { autoPlaceholder: autoPlaceholder, placeholderNumberType: placeholderNumberType, nationalMode: nationalMode, customPlaceholder: customPlaceholder } = this.options;
                const shouldSetPlaceholder = autoPlaceholder === "aggressive" || !this.hadInitialPlaceholder && autoPlaceholder === "polite";
                if (intlTelInput.utils && shouldSetPlaceholder) {
                    const numberType = intlTelInput.utils.numberType[placeholderNumberType];
                    let placeholder = this.selectedCountryData.iso2 ? intlTelInput.utils.getExampleNumber(this.selectedCountryData.iso2, nationalMode, numberType) : "";
                    placeholder = this._beforeSetNumber(placeholder);
                    if (typeof customPlaceholder === "function") placeholder = customPlaceholder(placeholder, this.selectedCountryData);
                    this.telInput.setAttribute("placeholder", placeholder);
                }
            }
            //* Called when the user selects a list item from the dropdown.
            _selectListItem(listItem) {
                const countryChanged = this._setCountry(listItem.getAttribute("data-country-code"));
                this._closeDropdown();
                this._updateDialCode(listItem.getAttribute("data-dial-code"));
                this.telInput.focus();
                if (countryChanged) this._triggerCountryChange();
            }
            //* Close the dropdown and unbind any listeners.
            _closeDropdown() {
                this.dropdownContent.classList.add("iti__hide");
                this.selectedCountry.setAttribute("aria-expanded", "false");
                this.selectedCountry.removeAttribute("aria-activedescendant");
                if (this.highlightedItem) this.highlightedItem.setAttribute("aria-selected", "false");
                if (this.options.countrySearch) this.searchInput.removeAttribute("aria-activedescendant");
                this.dropdownArrow.classList.remove("iti__arrow--up");
                document.removeEventListener("keydown", this._handleKeydownOnDropdown);
                if (this.options.countrySearch) this.searchInput.removeEventListener("input", this._handleSearchChange);
                document.documentElement.removeEventListener("click", this._handleClickOffToClose);
                this.countryList.removeEventListener("mouseover", this._handleMouseoverCountryList);
                this.countryList.removeEventListener("click", this._handleClickCountryList);
                if (this.options.dropdownContainer) {
                    if (!this.options.useFullscreenPopup) window.removeEventListener("scroll", this._handleWindowScroll);
                    if (this.dropdown.parentNode) this.dropdown.parentNode.removeChild(this.dropdown);
                }
                this._trigger("close:countrydropdown");
            }
            //* Check if an element is visible within it's container, else scroll until it is.
            _scrollTo(element) {
                const container = this.countryList;
                const scrollTop = document.documentElement.scrollTop;
                const containerHeight = container.offsetHeight;
                const containerTop = container.getBoundingClientRect().top + scrollTop;
                const containerBottom = containerTop + containerHeight;
                const elementHeight = element.offsetHeight;
                const elementTop = element.getBoundingClientRect().top + scrollTop;
                const elementBottom = elementTop + elementHeight;
                const newScrollTop = elementTop - containerTop + container.scrollTop;
                if (elementTop < containerTop) container.scrollTop = newScrollTop;
                else if (elementBottom > containerBottom) {
                    const heightDifference = containerHeight - elementHeight;
                    container.scrollTop = newScrollTop - heightDifference;
                }
            }
            //* Replace any existing dial code with the new one
            //* Note: called from _selectListItem and setCountry
            _updateDialCode(newDialCodeBare) {
                const inputVal = this.telInput.value;
                const newDialCode = `+${newDialCodeBare}`;
                let newNumber;
                if (inputVal.charAt(0) === "+") {
                    const prevDialCode = this._getDialCode(inputVal);
                    if (prevDialCode) newNumber = inputVal.replace(prevDialCode, newDialCode);
                    else newNumber = newDialCode;
                    this.telInput.value = newNumber;
                }
            }
            //* Try and extract a valid international dial code from a full telephone number.
            //* Note: returns the raw string inc plus character and any whitespace/dots etc.
            _getDialCode(number, includeAreaCode) {
                let dialCode = "";
                if (number.charAt(0) === "+") {
                    let numericChars = "";
                    for(let i = 0; i < number.length; i++){
                        const c = number.charAt(i);
                        if (!isNaN(parseInt(c, 10))) {
                            numericChars += c;
                            if (includeAreaCode) {
                                if (this.dialCodeToIso2Map[numericChars]) dialCode = number.substr(0, i + 1);
                            } else if (this.dialCodes[numericChars]) {
                                dialCode = number.substr(0, i + 1);
                                break;
                            }
                            if (numericChars.length === this.dialCodeMaxLen) break;
                        }
                    }
                }
                return dialCode;
            }
            //* Get the input val, adding the dial code if separateDialCode is enabled.
            _getFullNumber() {
                const val = this.telInput.value.trim();
                const { dialCode: dialCode } = this.selectedCountryData;
                let prefix;
                const numericVal = getNumeric(val);
                if (this.options.separateDialCode && val.charAt(0) !== "+" && dialCode && numericVal) prefix = `+${dialCode}`;
                else prefix = "";
                return prefix + val;
            }
            //* Remove the dial code if separateDialCode is enabled also cap the length if the input has a maxlength attribute
            _beforeSetNumber(fullNumber) {
                let number = fullNumber;
                if (this.options.separateDialCode) {
                    let dialCode = this._getDialCode(number);
                    if (dialCode) {
                        dialCode = `+${this.selectedCountryData.dialCode}`;
                        const start = number[dialCode.length] === " " || number[dialCode.length] === "-" ? dialCode.length + 1 : dialCode.length;
                        number = number.substr(start);
                    }
                }
                return this._cap(number);
            }
            //* Trigger the 'countrychange' event.
            _triggerCountryChange() {
                this._trigger("countrychange");
            }
            //* Format the number as the user types.
            _formatNumberAsYouType() {
                const val = this._getFullNumber();
                const result = intlTelInput.utils ? intlTelInput.utils.formatNumberAsYouType(val, this.selectedCountryData.iso2) : val;
                const { dialCode: dialCode } = this.selectedCountryData;
                if (this.options.separateDialCode && this.telInput.value.charAt(0) !== "+" && result.includes(`+${dialCode}`)) {
                    const afterDialCode = result.split(`+${dialCode}`)[1] || "";
                    return afterDialCode.trim();
                }
                return result;
            }
            //**************************
            //*  SECRET PUBLIC METHODS
            //**************************
            //* This is called when the geoip call returns.
            handleAutoCountry() {
                if (this.options.initialCountry === "auto" && intlTelInput.autoCountry) {
                    this.defaultCountry = intlTelInput.autoCountry;
                    const hasSelectedCountryOrGlobe = this.selectedCountryData.iso2 || this.selectedCountryInner.classList.contains("iti__globe");
                    if (!hasSelectedCountryOrGlobe) this.setCountry(this.defaultCountry);
                    this.resolveAutoCountryPromise();
                }
            }
            //* This is called when the utils request completes.
            handleUtils() {
                if (intlTelInput.utils) {
                    if (this.telInput.value) this._updateValFromNumber(this.telInput.value);
                    if (this.selectedCountryData.iso2) {
                        this._updatePlaceholder();
                        this._updateMaxLength();
                    }
                }
                this.resolveUtilsScriptPromise();
            }
            //********************
            //*  PUBLIC METHODS
            //********************
            //* Remove plugin.
            destroy() {
                const { allowDropdown: allowDropdown, separateDialCode: separateDialCode } = this.options;
                if (allowDropdown) {
                    this._closeDropdown();
                    this.selectedCountry.removeEventListener("click", this._handleClickSelectedCountry);
                    this.countryContainer.removeEventListener("keydown", this._handleCountryContainerKeydown);
                    const label = this.telInput.closest("label");
                    if (label) label.removeEventListener("click", this._handleLabelClick);
                }
                const { form: form } = this.telInput;
                if (this._handleHiddenInputSubmit && form) form.removeEventListener("submit", this._handleHiddenInputSubmit);
                this.telInput.removeEventListener("input", this._handleInputEvent);
                if (this._handleKeydownEvent) this.telInput.removeEventListener("keydown", this._handleKeydownEvent);
                this.telInput.removeAttribute("data-intl-tel-input-id");
                if (separateDialCode) {
                    if (this.isRTL) this.telInput.style.paddingRight = this.originalPaddingRight;
                    else this.telInput.style.paddingLeft = this.originalPaddingLeft;
                }
                const wrapper = this.telInput.parentNode;
                wrapper?.parentNode?.insertBefore(this.telInput, wrapper);
                wrapper?.parentNode?.removeChild(wrapper);
                delete intlTelInput.instances[this.id];
            }
            //* Get the extension from the current number.
            getExtension() {
                if (intlTelInput.utils) return intlTelInput.utils.getExtension(this._getFullNumber(), this.selectedCountryData.iso2);
                return "";
            }
            //* Format the number to the given format.
            getNumber(format) {
                if (intlTelInput.utils) {
                    const { iso2: iso2 } = this.selectedCountryData;
                    return intlTelInput.utils.formatNumber(this._getFullNumber(), iso2, format);
                }
                return "";
            }
            //* Get the type of the entered number e.g. landline/mobile.
            getNumberType() {
                if (intlTelInput.utils) return intlTelInput.utils.getNumberType(this._getFullNumber(), this.selectedCountryData.iso2);
                return -99;
            }
            //* Get the country data for the currently selected country.
            getSelectedCountryData() {
                return this.selectedCountryData;
            }
            //* Get the validation error.
            getValidationError() {
                if (intlTelInput.utils) {
                    const { iso2: iso2 } = this.selectedCountryData;
                    return intlTelInput.utils.getValidationError(this._getFullNumber(), iso2);
                }
                return -99;
            }
            //* Validate the input val
            isValidNumber() {
                const val = this._getFullNumber();
                const alphaCharPosition = val.search(/\p{L}/u);
                if (alphaCharPosition > -1) {
                    const beforeAlphaChar = val.substring(0, alphaCharPosition);
                    const beforeAlphaIsValid = this._utilsIsPossibleNumber(beforeAlphaChar);
                    const isValid = this._utilsIsPossibleNumber(val);
                    return beforeAlphaIsValid && isValid;
                }
                return this._utilsIsPossibleNumber(val);
            }
            _utilsIsPossibleNumber(val) {
                return intlTelInput.utils ? intlTelInput.utils.isPossibleNumber(val, this.selectedCountryData.iso2, this.options.validationNumberType) : null;
            }
            //* Validate the input val (precise)
            isValidNumberPrecise() {
                const val = this._getFullNumber();
                const alphaCharPosition = val.search(/\p{L}/u);
                if (alphaCharPosition > -1) {
                    const beforeAlphaChar = val.substring(0, alphaCharPosition);
                    const beforeAlphaIsValid = this._utilsIsValidNumber(beforeAlphaChar);
                    const isValid = this._utilsIsValidNumber(val);
                    return beforeAlphaIsValid && isValid;
                }
                return this._utilsIsValidNumber(val);
            }
            _utilsIsValidNumber(val) {
                return intlTelInput.utils ? intlTelInput.utils.isValidNumber(val, this.selectedCountryData.iso2) : null;
            }
            //* Update the selected country, and update the input val accordingly.
            setCountry(iso2) {
                const iso2Lower = iso2?.toLowerCase();
                const currentCountry = this.selectedCountryData.iso2;
                const isCountryChange = iso2 && iso2Lower !== currentCountry || !iso2 && currentCountry;
                if (isCountryChange) {
                    this._setCountry(iso2Lower);
                    this._updateDialCode(this.selectedCountryData.dialCode);
                    this._triggerCountryChange();
                }
            }
            //* Set the input value and update the country.
            setNumber(number) {
                const countryChanged = this._updateCountryFromNumber(number);
                this._updateValFromNumber(number);
                if (countryChanged) this._triggerCountryChange();
                this._trigger("input", {
                    isSetNumber: true
                });
            }
            //* Set the placeholder number typ
            setPlaceholderNumberType(type) {
                this.options.placeholderNumberType = type;
                this._updatePlaceholder();
            }
            setDisabled(disabled) {
                this.telInput.disabled = disabled;
                if (disabled) this.selectedCountry.setAttribute("disabled", "true");
                else this.selectedCountry.removeAttribute("disabled");
            }
        };
        var loadUtils = (path)=>{
            if (!intlTelInput.utils && !intlTelInput.startedLoadingUtilsScript) {
                intlTelInput.startedLoadingUtilsScript = true;
                return new Promise((resolve, reject)=>{
                    import_INTENTIONALLY_BROKEN(/* webpackIgnore: true */ /* @vite-ignore */ path).then(({ default: utils2 })=>{
                        intlTelInput.utils = utils2;
                        forEachInstance("handleUtils");
                        resolve(true);
                    }).catch(()=>{
                        forEachInstance("rejectUtilsScriptPromise");
                        reject();
                    });
                });
            }
            return null;
        };
        var intlTelInput = Object.assign((input, options)=>{
            const iti = new Iti(input, options);
            iti._init();
            input.setAttribute("data-intl-tel-input-id", iti.id.toString());
            intlTelInput.instances[iti.id] = iti;
            return iti;
        }, {
            defaults: defaults,
            //* Using a static var like this allows us to mock it in the tests.
            documentReady: ()=>document.readyState === "complete",
            //* Get the country data object.
            getCountryData: ()=>data_default,
            //* A getter for the plugin instance.
            getInstance: (input)=>{
                const id2 = input.getAttribute("data-intl-tel-input-id");
                return id2 ? intlTelInput.instances[id2] : null;
            },
            //* A map from instance ID to instance object.
            instances: {},
            loadUtils: loadUtils,
            version: "23.8.1"
        });
        var intl_tel_input_default = intlTelInput;
        // build/js/utils.js
        (function() {
            var k = this || self;
            function m(a, b) {
                a = a.split(".");
                var c = k;
                a[0] in c || "undefined" == typeof c.execScript || c.execScript("var " + a[0]);
                for(var d; a.length && (d = a.shift());)a.length || void 0 === b ? c[d] && c[d] !== Object.prototype[d] ? c = c[d] : c = c[d] = {} : c[d] = b;
            }
            function n(a, b) {
                function c() {}
                c.prototype = b.prototype;
                a.ma = b.prototype;
                a.prototype = new c();
                a.prototype.constructor = a;
                a.sa = function(d, e, f) {
                    for(var g = Array(arguments.length - 2), h = 2; h < arguments.length; h++)g[h - 2] = arguments[h];
                    return b.prototype[e].apply(d, g);
                };
            }
            function aa(a) {
                const b = [];
                let c = 0;
                for(const d in a)b[c++] = a[d];
                return b;
            }
            var ca = class {
                constructor(a){
                    if (ba !== ba) throw Error("SafeUrl is not meant to be built directly");
                    this.g = a;
                }
                toString() {
                    return this.g.toString();
                }
            }, ba = {};
            new ca("about:invalid#zClosurez");
            new ca("about:blank");
            const ea = {};
            class fa {
                constructor(){
                    if (ea !== ea) throw Error("SafeStyle is not meant to be built directly");
                }
                toString() {
                    return "".toString();
                }
            }
            new fa();
            const ha = {};
            class ia {
                constructor(){
                    if (ha !== ha) throw Error("SafeStyleSheet is not meant to be built directly");
                }
                toString() {
                    return "".toString();
                }
            }
            new ia();
            const ja = {};
            class ka {
                constructor(){
                    var a = k.trustedTypes && k.trustedTypes.emptyHTML || "";
                    if (ja !== ja) throw Error("SafeHtml is not meant to be built directly");
                    this.g = a;
                }
                toString() {
                    return this.g.toString();
                }
            }
            new ka();
            function la(a, b) {
                this.g = a;
                this.l = !!b.aa;
                this.h = b.i;
                this.s = b.type;
                this.o = false;
                switch(this.h){
                    case ma:
                    case na:
                    case oa:
                    case pa:
                    case qa:
                    case ra:
                    case sa:
                        this.o = true;
                }
                this.j = b.defaultValue;
            }
            var sa = 1, ra = 2, ma = 3, na = 4, oa = 6, pa = 16, qa = 18;
            function ta(a, b) {
                this.h = a;
                this.g = {};
                for(a = 0; a < b.length; a++){
                    var c = b[a];
                    this.g[c.g] = c;
                }
            }
            function ua(a) {
                a = aa(a.g);
                a.sort(function(b, c) {
                    return b.g - c.g;
                });
                return a;
            }
            function p() {
                this.h = {};
                this.j = this.m().g;
                this.g = this.l = null;
            }
            p.prototype.has = function(a) {
                return q(this, a.g);
            };
            p.prototype.get = function(a, b) {
                return r(this, a.g, b);
            };
            p.prototype.set = function(a, b) {
                t(this, a.g, b);
            };
            p.prototype.add = function(a, b) {
                va(this, a.g, b);
            };
            function wa(a, b) {
                for(var c = ua(a.m()), d = 0; d < c.length; d++){
                    var e = c[d], f = e.g;
                    if (q(b, f)) {
                        a.g && delete a.g[e.g];
                        var g = 11 == e.h || 10 == e.h;
                        if (e.l) {
                            e = u(b, f);
                            for(var h = 0; h < e.length; h++)va(a, f, g ? e[h].clone() : e[h]);
                        } else e = v(b, f), g ? (g = v(a, f)) ? wa(g, e) : t(a, f, e.clone()) : t(a, f, e);
                    }
                }
            }
            p.prototype.clone = function() {
                var a = new this.constructor();
                a != this && (a.h = {}, a.g && (a.g = {}), wa(a, this));
                return a;
            };
            function q(a, b) {
                return null != a.h[b];
            }
            function v(a, b) {
                var c = a.h[b];
                if (null == c) return null;
                if (a.l) {
                    if (!(b in a.g)) {
                        var d = a.l, e = a.j[b];
                        if (null != c) {
                            if (e.l) {
                                for(var f = [], g = 0; g < c.length; g++)f[g] = d.h(e, c[g]);
                                c = f;
                            } else c = d.h(e, c);
                        }
                        return a.g[b] = c;
                    }
                    return a.g[b];
                }
                return c;
            }
            function r(a, b, c) {
                var d = v(a, b);
                return a.j[b].l ? d[c || 0] : d;
            }
            function w(a, b) {
                if (q(a, b)) a = r(a, b);
                else a: {
                    a = a.j[b];
                    if (void 0 === a.j) {
                        if (b = a.s, b === Boolean) a.j = false;
                        else if (b === Number) a.j = 0;
                        else if (b === String) a.j = a.o ? "0" : "";
                        else {
                            a = new b();
                            break a;
                        }
                    }
                    a = a.j;
                }
                return a;
            }
            function u(a, b) {
                return v(a, b) || [];
            }
            function x(a, b) {
                return a.j[b].l ? q(a, b) ? a.h[b].length : 0 : q(a, b) ? 1 : 0;
            }
            function t(a, b, c) {
                a.h[b] = c;
                a.g && (a.g[b] = c);
            }
            function va(a, b, c) {
                a.h[b] || (a.h[b] = []);
                a.h[b].push(c);
                a.g && delete a.g[b];
            }
            function y(a, b) {
                var c = [], d;
                for(d in b)0 != d && c.push(new la(d, b[d]));
                return new ta(a, c);
            }
            function z() {}
            z.prototype.g = function(a) {
                new a.h();
                throw Error("Unimplemented");
            };
            z.prototype.h = function(a, b) {
                if (11 == a.h || 10 == a.h) return b instanceof p ? b : this.g(a.s.prototype.m(), b);
                if (14 == a.h) return "string" === typeof b && xa.test(b) && (a = Number(b), 0 < a) ? a : b;
                if (!a.o) return b;
                a = a.s;
                if (a === String) {
                    if ("number" === typeof b) return String(b);
                } else if (a === Number && "string" === typeof b && ("Infinity" === b || "-Infinity" === b || "NaN" === b || xa.test(b))) return Number(b);
                return b;
            };
            var xa = /^-?[0-9]+$/;
            function ya() {}
            n(ya, z);
            ya.prototype.g = function(a, b) {
                a = new a.h();
                a.l = this;
                a.h = b;
                a.g = {};
                return a;
            };
            function B() {}
            n(B, ya);
            B.prototype.h = function(a, b) {
                return 8 == a.h ? !!b : z.prototype.h.apply(this, arguments);
            };
            B.prototype.g = function(a, b) {
                return B.ma.g.call(this, a, b);
            };
            function C(a, b) {
                null != a && this.g.apply(this, arguments);
            }
            C.prototype.h = "";
            C.prototype.set = function(a) {
                this.h = "" + a;
            };
            C.prototype.g = function(a, b, c) {
                this.h += String(a);
                if (null != b) for(let d = 1; d < arguments.length; d++)this.h += arguments[d];
                return this;
            };
            function D(a) {
                a.h = "";
            }
            C.prototype.toString = function() {
                return this.h;
            };
            function E() {
                p.call(this);
            }
            n(E, p);
            var za = null;
            function F() {
                p.call(this);
            }
            n(F, p);
            var Aa = null;
            function G() {
                p.call(this);
            }
            n(G, p);
            var Ba = null;
            E.prototype.m = function() {
                var a = za;
                a || (za = a = y(E, {
                    0: {
                        name: "NumberFormat",
                        ia: "i18n.phonenumbers.NumberFormat"
                    },
                    1: {
                        name: "pattern",
                        required: true,
                        i: 9,
                        type: String
                    },
                    2: {
                        name: "format",
                        required: true,
                        i: 9,
                        type: String
                    },
                    3: {
                        name: "leading_digits_pattern",
                        aa: true,
                        i: 9,
                        type: String
                    },
                    4: {
                        name: "national_prefix_formatting_rule",
                        i: 9,
                        type: String
                    },
                    6: {
                        name: "national_prefix_optional_when_formatting",
                        i: 8,
                        defaultValue: false,
                        type: Boolean
                    },
                    5: {
                        name: "domestic_carrier_code_formatting_rule",
                        i: 9,
                        type: String
                    }
                }));
                return a;
            };
            E.m = E.prototype.m;
            F.prototype.m = function() {
                var a = Aa;
                a || (Aa = a = y(F, {
                    0: {
                        name: "PhoneNumberDesc",
                        ia: "i18n.phonenumbers.PhoneNumberDesc"
                    },
                    2: {
                        name: "national_number_pattern",
                        i: 9,
                        type: String
                    },
                    9: {
                        name: "possible_length",
                        aa: true,
                        i: 5,
                        type: Number
                    },
                    10: {
                        name: "possible_length_local_only",
                        aa: true,
                        i: 5,
                        type: Number
                    },
                    6: {
                        name: "example_number",
                        i: 9,
                        type: String
                    }
                }));
                return a;
            };
            F.m = F.prototype.m;
            G.prototype.m = function() {
                var a = Ba;
                a || (Ba = a = y(G, {
                    0: {
                        name: "PhoneMetadata",
                        ia: "i18n.phonenumbers.PhoneMetadata"
                    },
                    1: {
                        name: "general_desc",
                        i: 11,
                        type: F
                    },
                    2: {
                        name: "fixed_line",
                        i: 11,
                        type: F
                    },
                    3: {
                        name: "mobile",
                        i: 11,
                        type: F
                    },
                    4: {
                        name: "toll_free",
                        i: 11,
                        type: F
                    },
                    5: {
                        name: "premium_rate",
                        i: 11,
                        type: F
                    },
                    6: {
                        name: "shared_cost",
                        i: 11,
                        type: F
                    },
                    7: {
                        name: "personal_number",
                        i: 11,
                        type: F
                    },
                    8: {
                        name: "voip",
                        i: 11,
                        type: F
                    },
                    21: {
                        name: "pager",
                        i: 11,
                        type: F
                    },
                    25: {
                        name: "uan",
                        i: 11,
                        type: F
                    },
                    27: {
                        name: "emergency",
                        i: 11,
                        type: F
                    },
                    28: {
                        name: "voicemail",
                        i: 11,
                        type: F
                    },
                    29: {
                        name: "short_code",
                        i: 11,
                        type: F
                    },
                    30: {
                        name: "standard_rate",
                        i: 11,
                        type: F
                    },
                    31: {
                        name: "carrier_specific",
                        i: 11,
                        type: F
                    },
                    33: {
                        name: "sms_services",
                        i: 11,
                        type: F
                    },
                    24: {
                        name: "no_international_dialling",
                        i: 11,
                        type: F
                    },
                    9: {
                        name: "id",
                        required: true,
                        i: 9,
                        type: String
                    },
                    10: {
                        name: "country_code",
                        i: 5,
                        type: Number
                    },
                    11: {
                        name: "international_prefix",
                        i: 9,
                        type: String
                    },
                    17: {
                        name: "preferred_international_prefix",
                        i: 9,
                        type: String
                    },
                    12: {
                        name: "national_prefix",
                        i: 9,
                        type: String
                    },
                    13: {
                        name: "preferred_extn_prefix",
                        i: 9,
                        type: String
                    },
                    15: {
                        name: "national_prefix_for_parsing",
                        i: 9,
                        type: String
                    },
                    16: {
                        name: "national_prefix_transform_rule",
                        i: 9,
                        type: String
                    },
                    18: {
                        name: "same_mobile_and_fixed_line_pattern",
                        i: 8,
                        defaultValue: false,
                        type: Boolean
                    },
                    19: {
                        name: "number_format",
                        aa: true,
                        i: 11,
                        type: E
                    },
                    20: {
                        name: "intl_number_format",
                        aa: true,
                        i: 11,
                        type: E
                    },
                    22: {
                        name: "main_country_for_code",
                        i: 8,
                        defaultValue: false,
                        type: Boolean
                    },
                    23: {
                        name: "leading_digits",
                        i: 9,
                        type: String
                    }
                }));
                return a;
            };
            G.m = G.prototype.m;
            function H() {
                p.call(this);
            }
            n(H, p);
            var Ca = null, Da = {
                ra: 0,
                qa: 1,
                pa: 5,
                oa: 10,
                na: 20
            };
            H.prototype.m = function() {
                var a = Ca;
                a || (Ca = a = y(H, {
                    0: {
                        name: "PhoneNumber",
                        ia: "i18n.phonenumbers.PhoneNumber"
                    },
                    1: {
                        name: "country_code",
                        required: true,
                        i: 5,
                        type: Number
                    },
                    2: {
                        name: "national_number",
                        required: true,
                        i: 4,
                        type: Number
                    },
                    3: {
                        name: "extension",
                        i: 9,
                        type: String
                    },
                    4: {
                        name: "italian_leading_zero",
                        i: 8,
                        type: Boolean
                    },
                    8: {
                        name: "number_of_leading_zeros",
                        i: 5,
                        defaultValue: 1,
                        type: Number
                    },
                    5: {
                        name: "raw_input",
                        i: 9,
                        type: String
                    },
                    6: {
                        name: "country_code_source",
                        i: 14,
                        defaultValue: 0,
                        type: Da
                    },
                    7: {
                        name: "preferred_domestic_carrier_code",
                        i: 9,
                        type: String
                    }
                }));
                return a;
            };
            H.ctor = H;
            H.ctor.m = H.prototype.m;
            var I = {
                1: "US AG AI AS BB BM BS CA DM DO GD GU JM KN KY LC MP MS PR SX TC TT VC VG VI".split(" "),
                7: [
                    "RU",
                    "KZ"
                ],
                20: [
                    "EG"
                ],
                27: [
                    "ZA"
                ],
                30: [
                    "GR"
                ],
                31: [
                    "NL"
                ],
                32: [
                    "BE"
                ],
                33: [
                    "FR"
                ],
                34: [
                    "ES"
                ],
                36: [
                    "HU"
                ],
                39: [
                    "IT",
                    "VA"
                ],
                40: [
                    "RO"
                ],
                41: [
                    "CH"
                ],
                43: [
                    "AT"
                ],
                44: [
                    "GB",
                    "GG",
                    "IM",
                    "JE"
                ],
                45: [
                    "DK"
                ],
                46: [
                    "SE"
                ],
                47: [
                    "NO",
                    "SJ"
                ],
                48: [
                    "PL"
                ],
                49: [
                    "DE"
                ],
                51: [
                    "PE"
                ],
                52: [
                    "MX"
                ],
                53: [
                    "CU"
                ],
                54: [
                    "AR"
                ],
                55: [
                    "BR"
                ],
                56: [
                    "CL"
                ],
                57: [
                    "CO"
                ],
                58: [
                    "VE"
                ],
                60: [
                    "MY"
                ],
                61: [
                    "AU",
                    "CC",
                    "CX"
                ],
                62: [
                    "ID"
                ],
                63: [
                    "PH"
                ],
                64: [
                    "NZ"
                ],
                65: [
                    "SG"
                ],
                66: [
                    "TH"
                ],
                81: [
                    "JP"
                ],
                82: [
                    "KR"
                ],
                84: [
                    "VN"
                ],
                86: [
                    "CN"
                ],
                90: [
                    "TR"
                ],
                91: [
                    "IN"
                ],
                92: [
                    "PK"
                ],
                93: [
                    "AF"
                ],
                94: [
                    "LK"
                ],
                95: [
                    "MM"
                ],
                98: [
                    "IR"
                ],
                211: [
                    "SS"
                ],
                212: [
                    "MA",
                    "EH"
                ],
                213: [
                    "DZ"
                ],
                216: [
                    "TN"
                ],
                218: [
                    "LY"
                ],
                220: [
                    "GM"
                ],
                221: [
                    "SN"
                ],
                222: [
                    "MR"
                ],
                223: [
                    "ML"
                ],
                224: [
                    "GN"
                ],
                225: [
                    "CI"
                ],
                226: [
                    "BF"
                ],
                227: [
                    "NE"
                ],
                228: [
                    "TG"
                ],
                229: [
                    "BJ"
                ],
                230: [
                    "MU"
                ],
                231: [
                    "LR"
                ],
                232: [
                    "SL"
                ],
                233: [
                    "GH"
                ],
                234: [
                    "NG"
                ],
                235: [
                    "TD"
                ],
                236: [
                    "CF"
                ],
                237: [
                    "CM"
                ],
                238: [
                    "CV"
                ],
                239: [
                    "ST"
                ],
                240: [
                    "GQ"
                ],
                241: [
                    "GA"
                ],
                242: [
                    "CG"
                ],
                243: [
                    "CD"
                ],
                244: [
                    "AO"
                ],
                245: [
                    "GW"
                ],
                246: [
                    "IO"
                ],
                247: [
                    "AC"
                ],
                248: [
                    "SC"
                ],
                249: [
                    "SD"
                ],
                250: [
                    "RW"
                ],
                251: [
                    "ET"
                ],
                252: [
                    "SO"
                ],
                253: [
                    "DJ"
                ],
                254: [
                    "KE"
                ],
                255: [
                    "TZ"
                ],
                256: [
                    "UG"
                ],
                257: [
                    "BI"
                ],
                258: [
                    "MZ"
                ],
                260: [
                    "ZM"
                ],
                261: [
                    "MG"
                ],
                262: [
                    "RE",
                    "YT"
                ],
                263: [
                    "ZW"
                ],
                264: [
                    "NA"
                ],
                265: [
                    "MW"
                ],
                266: [
                    "LS"
                ],
                267: [
                    "BW"
                ],
                268: [
                    "SZ"
                ],
                269: [
                    "KM"
                ],
                290: [
                    "SH",
                    "TA"
                ],
                291: [
                    "ER"
                ],
                297: [
                    "AW"
                ],
                298: [
                    "FO"
                ],
                299: [
                    "GL"
                ],
                350: [
                    "GI"
                ],
                351: [
                    "PT"
                ],
                352: [
                    "LU"
                ],
                353: [
                    "IE"
                ],
                354: [
                    "IS"
                ],
                355: [
                    "AL"
                ],
                356: [
                    "MT"
                ],
                357: [
                    "CY"
                ],
                358: [
                    "FI",
                    "AX"
                ],
                359: [
                    "BG"
                ],
                370: [
                    "LT"
                ],
                371: [
                    "LV"
                ],
                372: [
                    "EE"
                ],
                373: [
                    "MD"
                ],
                374: [
                    "AM"
                ],
                375: [
                    "BY"
                ],
                376: [
                    "AD"
                ],
                377: [
                    "MC"
                ],
                378: [
                    "SM"
                ],
                380: [
                    "UA"
                ],
                381: [
                    "RS"
                ],
                382: [
                    "ME"
                ],
                383: [
                    "XK"
                ],
                385: [
                    "HR"
                ],
                386: [
                    "SI"
                ],
                387: [
                    "BA"
                ],
                389: [
                    "MK"
                ],
                420: [
                    "CZ"
                ],
                421: [
                    "SK"
                ],
                423: [
                    "LI"
                ],
                500: [
                    "FK"
                ],
                501: [
                    "BZ"
                ],
                502: [
                    "GT"
                ],
                503: [
                    "SV"
                ],
                504: [
                    "HN"
                ],
                505: [
                    "NI"
                ],
                506: [
                    "CR"
                ],
                507: [
                    "PA"
                ],
                508: [
                    "PM"
                ],
                509: [
                    "HT"
                ],
                590: [
                    "GP",
                    "BL",
                    "MF"
                ],
                591: [
                    "BO"
                ],
                592: [
                    "GY"
                ],
                593: [
                    "EC"
                ],
                594: [
                    "GF"
                ],
                595: [
                    "PY"
                ],
                596: [
                    "MQ"
                ],
                597: [
                    "SR"
                ],
                598: [
                    "UY"
                ],
                599: [
                    "CW",
                    "BQ"
                ],
                670: [
                    "TL"
                ],
                672: [
                    "NF"
                ],
                673: [
                    "BN"
                ],
                674: [
                    "NR"
                ],
                675: [
                    "PG"
                ],
                676: [
                    "TO"
                ],
                677: [
                    "SB"
                ],
                678: [
                    "VU"
                ],
                679: [
                    "FJ"
                ],
                680: [
                    "PW"
                ],
                681: [
                    "WF"
                ],
                682: [
                    "CK"
                ],
                683: [
                    "NU"
                ],
                685: [
                    "WS"
                ],
                686: [
                    "KI"
                ],
                687: [
                    "NC"
                ],
                688: [
                    "TV"
                ],
                689: [
                    "PF"
                ],
                690: [
                    "TK"
                ],
                691: [
                    "FM"
                ],
                692: [
                    "MH"
                ],
                800: [
                    "001"
                ],
                808: [
                    "001"
                ],
                850: [
                    "KP"
                ],
                852: [
                    "HK"
                ],
                853: [
                    "MO"
                ],
                855: [
                    "KH"
                ],
                856: [
                    "LA"
                ],
                870: [
                    "001"
                ],
                878: [
                    "001"
                ],
                880: [
                    "BD"
                ],
                881: [
                    "001"
                ],
                882: [
                    "001"
                ],
                883: [
                    "001"
                ],
                886: [
                    "TW"
                ],
                888: [
                    "001"
                ],
                960: [
                    "MV"
                ],
                961: [
                    "LB"
                ],
                962: [
                    "JO"
                ],
                963: [
                    "SY"
                ],
                964: [
                    "IQ"
                ],
                965: [
                    "KW"
                ],
                966: [
                    "SA"
                ],
                967: [
                    "YE"
                ],
                968: [
                    "OM"
                ],
                970: [
                    "PS"
                ],
                971: [
                    "AE"
                ],
                972: [
                    "IL"
                ],
                973: [
                    "BH"
                ],
                974: [
                    "QA"
                ],
                975: [
                    "BT"
                ],
                976: [
                    "MN"
                ],
                977: [
                    "NP"
                ],
                979: [
                    "001"
                ],
                992: [
                    "TJ"
                ],
                993: [
                    "TM"
                ],
                994: [
                    "AZ"
                ],
                995: [
                    "GE"
                ],
                996: [
                    "KG"
                ],
                998: [
                    "UZ"
                ]
            }, Ea = {
                AC: [
                    ,
                    [
                        ,
                        ,
                        "(?:[01589]\\d|[46])\\d{4}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            5,
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "6[2-467]\\d{3}",
                        ,
                        ,
                        ,
                        "62889",
                        ,
                        ,
                        [
                            5
                        ]
                    ],
                    [
                        ,
                        ,
                        "4\\d{4}",
                        ,
                        ,
                        ,
                        "40123",
                        ,
                        ,
                        [
                            5
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "AC",
                    247,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:0[1-9]|[1589]\\d)\\d{4}",
                        ,
                        ,
                        ,
                        "542011",
                        ,
                        ,
                        [
                            6
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                AD: [
                    ,
                    [
                        ,
                        ,
                        "(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            6,
                            8,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "[78]\\d{5}",
                        ,
                        ,
                        ,
                        "712345",
                        ,
                        ,
                        [
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "690\\d{6}|[356]\\d{5}",
                        ,
                        ,
                        ,
                        "312345",
                        ,
                        ,
                        [
                            6,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "180[02]\\d{4}",
                        ,
                        ,
                        ,
                        "18001234",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "[19]\\d{5}",
                        ,
                        ,
                        ,
                        "912345",
                        ,
                        ,
                        [
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "AD",
                    376,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{3})",
                            "$1 $2",
                            [
                                "[135-9]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{4})",
                            "$1 $2",
                            [
                                "1"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "6"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "1800\\d{4}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                AE: [
                    ,
                    [
                        ,
                        ,
                        "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            5,
                            6,
                            7,
                            8,
                            9,
                            10,
                            11,
                            12
                        ]
                    ],
                    [
                        ,
                        ,
                        "[2-4679][2-8]\\d{6}",
                        ,
                        ,
                        ,
                        "22345678",
                        ,
                        ,
                        [
                            8
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "5[024-68]\\d{7}",
                        ,
                        ,
                        ,
                        "501234567",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "400\\d{6}|800\\d{2,9}",
                        ,
                        ,
                        ,
                        "800123456"
                    ],
                    [
                        ,
                        ,
                        "900[02]\\d{5}",
                        ,
                        ,
                        ,
                        "900234567",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "700[05]\\d{5}",
                        ,
                        ,
                        ,
                        "700012345",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "AE",
                    971,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{2,9})",
                            "$1 $2",
                            [
                                "60|8"
                            ]
                        ],
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[236]|[479][2-8]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d)(\\d{5})",
                            "$1 $2 $3",
                            [
                                "[479]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "5"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "600[25]\\d{5}",
                        ,
                        ,
                        ,
                        "600212345",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                AF: [
                    ,
                    [
                        ,
                        ,
                        "[2-7]\\d{8}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "234567890",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "7\\d{8}",
                        ,
                        ,
                        ,
                        "701234567",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "AF",
                    93,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1 $2",
                            [
                                "[1-9]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[2-7]"
                            ],
                            "0$1"
                        ]
                    ],
                    [
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[2-7]"
                            ],
                            "0$1"
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                AG: [
                    ,
                    [
                        ,
                        ,
                        "(?:268|[58]\\d\\d|900)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}",
                        ,
                        ,
                        ,
                        "2684601234",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}",
                        ,
                        ,
                        ,
                        "2684641234",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "8002123456"
                    ],
                    [
                        ,
                        ,
                        "900[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "9002123456"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "5002345678"
                    ],
                    [
                        ,
                        ,
                        "26848[01]\\d{4}",
                        ,
                        ,
                        ,
                        "2684801234",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    "AG",
                    1,
                    "011",
                    "1",
                    ,
                    ,
                    "([457]\\d{6})$|1",
                    "268$1",
                    ,
                    ,
                    ,
                    ,
                    [
                        ,
                        ,
                        "26840[69]\\d{4}",
                        ,
                        ,
                        ,
                        "2684061234",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    ,
                    "268",
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                AI: [
                    ,
                    [
                        ,
                        ,
                        "(?:264|[58]\\d\\d|900)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "264(?:292|4(?:6[12]|9[78]))\\d{4}",
                        ,
                        ,
                        ,
                        "2644612345",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}",
                        ,
                        ,
                        ,
                        "2642351234",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "8002123456"
                    ],
                    [
                        ,
                        ,
                        "900[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "9002123456"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "5002345678"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "AI",
                    1,
                    "011",
                    "1",
                    ,
                    ,
                    "([2457]\\d{6})$|1",
                    "264$1",
                    ,
                    ,
                    ,
                    ,
                    [
                        ,
                        ,
                        "264724\\d{4}",
                        ,
                        ,
                        ,
                        "2647241234",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    ,
                    "264",
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                AL: [
                    ,
                    [
                        ,
                        ,
                        "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            6,
                            7,
                            8,
                            9
                        ],
                        [
                            5
                        ]
                    ],
                    [
                        ,
                        ,
                        "4505[0-2]\\d{3}|(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}",
                        ,
                        ,
                        ,
                        "22345678",
                        ,
                        ,
                        [
                            8
                        ],
                        [
                            5,
                            6,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "6(?:[78][2-9]|9\\d)\\d{6}",
                        ,
                        ,
                        ,
                        "672123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "800\\d{4}",
                        ,
                        ,
                        ,
                        "8001234",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "900[1-9]\\d\\d",
                        ,
                        ,
                        ,
                        "900123",
                        ,
                        ,
                        [
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "808[1-9]\\d\\d",
                        ,
                        ,
                        ,
                        "808123",
                        ,
                        ,
                        [
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "700[2-9]\\d{4}",
                        ,
                        ,
                        ,
                        "70021234",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "AL",
                    355,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{3,4})",
                            "$1 $2",
                            [
                                "80|9"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "4[2-6]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[2358][2-5]|4"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{5})",
                            "$1 $2",
                            [
                                "[23578]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "6"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                AM: [
                    ,
                    [
                        ,
                        ,
                        "(?:[1-489]\\d|55|60|77)\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8
                        ],
                        [
                            5,
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}",
                        ,
                        ,
                        ,
                        "10123456",
                        ,
                        ,
                        ,
                        [
                            5,
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:33|4[1349]|55|77|88|9[13-9])\\d{6}",
                        ,
                        ,
                        ,
                        "77123456"
                    ],
                    [
                        ,
                        ,
                        "800\\d{5}",
                        ,
                        ,
                        ,
                        "80012345"
                    ],
                    [
                        ,
                        ,
                        "90[016]\\d{5}",
                        ,
                        ,
                        ,
                        "90012345"
                    ],
                    [
                        ,
                        ,
                        "80[1-4]\\d{5}",
                        ,
                        ,
                        ,
                        "80112345"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|9[0-2])\\d{4}",
                        ,
                        ,
                        ,
                        "60271234"
                    ],
                    "AM",
                    374,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[89]0"
                            ],
                            "0 $1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{5})",
                            "$1 $2",
                            [
                                "2|3[12]"
                            ],
                            "(0$1)"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{6})",
                            "$1 $2",
                            [
                                "1|47"
                            ],
                            "(0$1)"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{6})",
                            "$1 $2",
                            [
                                "[3-9]"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                AO: [
                    ,
                    [
                        ,
                        ,
                        "[29]\\d{8}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}",
                        ,
                        ,
                        ,
                        "222123456"
                    ],
                    [
                        ,
                        ,
                        "9[1-579]\\d{7}",
                        ,
                        ,
                        ,
                        "923123456"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "AO",
                    244,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[29]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                AR: [
                    ,
                    [
                        ,
                        ,
                        "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10,
                            11
                        ],
                        [
                            6,
                            7,
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:2(?:657|9(?:54|66))|3(?:7(?:55|77)|865))[2-8]\\d{5}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:284|3(?:02|23)|920)|3(?:4(?:46|8[27]|92)|541|878))[2-7]\\d{5}|(?:2(?:(?:26|62)2|320|477|9(?:42|83))|3(?:329|4(?:62|76|89)|564))[2-6]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[235][4-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|[17][2-6]|3[4-6]|5[3-6]|8[3-68])))\\d{6}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
                        ,
                        ,
                        ,
                        "1123456789",
                        ,
                        ,
                        [
                            10
                        ],
                        [
                            6,
                            7,
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "93(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|9(?:2(?:657|9(?:54|66))|3(?:7(?:55|77)|865))[2-8]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:284|3(?:02|23)|920)|3(?:4(?:46|8[27]|92)|541|878))[2-7]\\d{5}|9(?:2(?:(?:26|62)2|320|477|9(?:42|83))|3(?:329|4(?:62|76|89)|564))[2-6]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[235][4-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|[17][2-6]|3[4-6]|5[3-6]|8[3-68]))))\\d{6}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
                        ,
                        ,
                        ,
                        "91123456789",
                        ,
                        ,
                        ,
                        [
                            6,
                            7,
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "800\\d{7,8}",
                        ,
                        ,
                        ,
                        "8001234567"
                    ],
                    [
                        ,
                        ,
                        "60[04579]\\d{7}",
                        ,
                        ,
                        ,
                        "6001234567",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "AR",
                    54,
                    "00",
                    "0",
                    ,
                    ,
                    "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
                    "9$1",
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})",
                            "$1",
                            [
                                "0|1(?:0[0-35-7]|1[02-5]|2[015]|3[47]|4[478])|911"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{4})",
                            "$1-$2",
                            [
                                "[1-9]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1-$2",
                            [
                                "[2-9]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{4})",
                            "$1-$2",
                            [
                                "[1-8]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{2})(\\d{4})",
                            "$1 $2-$3",
                            [
                                "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                                "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                                "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                                "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                            ],
                            "0$1",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{4})(\\d{4})",
                            "$1 $2-$3",
                            [
                                "1"
                            ],
                            "0$1",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "$1-$2-$3",
                            [
                                "[68]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "$1 $2-$3",
                            [
                                "[23]"
                            ],
                            "0$1",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                            "$2 15-$3-$4",
                            [
                                "9(?:2[2-469]|3[3-578])",
                                "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                                "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                                "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                                "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                            "$2 15-$3-$4",
                            [
                                "91"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{5})",
                            "$1-$2-$3",
                            [
                                "8"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                            "$2 15-$3-$4",
                            [
                                "9"
                            ],
                            "0$1"
                        ]
                    ],
                    [
                        [
                            ,
                            "(\\d{4})(\\d{2})(\\d{4})",
                            "$1 $2-$3",
                            [
                                "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                                "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                                "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                                "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                            ],
                            "0$1",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{4})(\\d{4})",
                            "$1 $2-$3",
                            [
                                "1"
                            ],
                            "0$1",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "$1-$2-$3",
                            [
                                "[68]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "$1 $2-$3",
                            [
                                "[23]"
                            ],
                            "0$1",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                            "$1 $2 $3-$4",
                            [
                                "9(?:2[2-469]|3[3-578])",
                                "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                                "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                                "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                                "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                            ]
                        ],
                        [
                            ,
                            "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                            "$1 $2 $3-$4",
                            [
                                "91"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{5})",
                            "$1-$2-$3",
                            [
                                "8"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                            "$1 $2 $3-$4",
                            [
                                "9"
                            ]
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "810\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "810\\d{7}",
                        ,
                        ,
                        ,
                        "8101234567",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                AS: [
                    ,
                    [
                        ,
                        ,
                        "(?:[58]\\d\\d|684|900)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "6846(?:22|33|44|55|77|88|9[19])\\d{4}",
                        ,
                        ,
                        ,
                        "6846221234",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "684(?:2(?:48|5[2468]|7[26])|7(?:3[13]|70|82))\\d{4}",
                        ,
                        ,
                        ,
                        "6847331234",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "8002123456"
                    ],
                    [
                        ,
                        ,
                        "900[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "9002123456"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "5002345678"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "AS",
                    1,
                    "011",
                    "1",
                    ,
                    ,
                    "([267]\\d{6})$|1",
                    "684$1",
                    ,
                    ,
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    "684",
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                AT: [
                    ,
                    [
                        ,
                        ,
                        "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            4,
                            5,
                            6,
                            7,
                            8,
                            9,
                            10,
                            11,
                            12,
                            13
                        ],
                        [
                            3
                        ]
                    ],
                    [
                        ,
                        ,
                        "1(?:11\\d|[2-9]\\d{3,11})|(?:316|463|(?:51|66|73)2)\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-8]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}",
                        ,
                        ,
                        ,
                        "1234567890",
                        ,
                        ,
                        ,
                        [
                            3
                        ]
                    ],
                    [
                        ,
                        ,
                        "6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}",
                        ,
                        ,
                        ,
                        "664123456",
                        ,
                        ,
                        [
                            7,
                            8,
                            9,
                            10,
                            11,
                            12,
                            13
                        ]
                    ],
                    [
                        ,
                        ,
                        "800\\d{6,10}",
                        ,
                        ,
                        ,
                        "800123456",
                        ,
                        ,
                        [
                            9,
                            10,
                            11,
                            12,
                            13
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:8[69][2-68]|9(?:0[01]|3[019]))\\d{6,10}",
                        ,
                        ,
                        ,
                        "900123456",
                        ,
                        ,
                        [
                            9,
                            10,
                            11,
                            12,
                            13
                        ]
                    ],
                    [
                        ,
                        ,
                        "8(?:10|2[018])\\d{6,10}|828\\d{5}",
                        ,
                        ,
                        ,
                        "810123456",
                        ,
                        ,
                        [
                            8,
                            9,
                            10,
                            11,
                            12,
                            13
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}",
                        ,
                        ,
                        ,
                        "780123456",
                        ,
                        ,
                        [
                            5,
                            6,
                            7,
                            8,
                            9,
                            10,
                            11,
                            12,
                            13
                        ]
                    ],
                    "AT",
                    43,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{4})",
                            "$1",
                            [
                                "14"
                            ]
                        ],
                        [
                            ,
                            "(\\d)(\\d{3,12})",
                            "$1 $2",
                            [
                                "1(?:11|[2-9])"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})",
                            "$1 $2",
                            [
                                "517"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3,5})",
                            "$1 $2",
                            [
                                "5[079]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{6})",
                            "$1",
                            [
                                "[18]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3,10})",
                            "$1 $2",
                            [
                                "(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{3,9})",
                            "$1 $2",
                            [
                                "[2-467]|5[2-6]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "5"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{4})(\\d{4,7})",
                            "$1 $2 $3",
                            [
                                "5"
                            ],
                            "0$1"
                        ]
                    ],
                    [
                        [
                            ,
                            "(\\d)(\\d{3,12})",
                            "$1 $2",
                            [
                                "1(?:11|[2-9])"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})",
                            "$1 $2",
                            [
                                "517"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3,5})",
                            "$1 $2",
                            [
                                "5[079]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3,10})",
                            "$1 $2",
                            [
                                "(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{3,9})",
                            "$1 $2",
                            [
                                "[2-467]|5[2-6]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "5"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{4})(\\d{4,7})",
                            "$1 $2 $3",
                            [
                                "5"
                            ],
                            "0$1"
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                AU: [
                    ,
                    [
                        ,
                        ,
                        "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            5,
                            6,
                            7,
                            8,
                            9,
                            10,
                            12
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
                        ,
                        ,
                        ,
                        "212345678",
                        ,
                        ,
                        [
                            9
                        ],
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                        ,
                        ,
                        ,
                        "412345678",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "180(?:0\\d{3}|2)\\d{3}",
                        ,
                        ,
                        ,
                        "1800123456",
                        ,
                        ,
                        [
                            7,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "190[0-26]\\d{6}",
                        ,
                        ,
                        ,
                        "1900123456",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                        ,
                        ,
                        ,
                        "1300123456",
                        ,
                        ,
                        [
                            6,
                            8,
                            10,
                            12
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                        ,
                        ,
                        ,
                        "147101234",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    "AU",
                    61,
                    "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
                    "0",
                    ,
                    ,
                    "(183[12])|0",
                    ,
                    "0011",
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{3,4})",
                            "$1 $2",
                            [
                                "16"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3",
                            [
                                "13"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})",
                            "$1 $2",
                            [
                                "19"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1 $2",
                            [
                                "180",
                                "1802"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{3,4})",
                            "$1 $2",
                            [
                                "19"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{2,4})",
                            "$1 $2 $3",
                            [
                                "16"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "14|4"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d)(\\d{4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[2378]"
                            ],
                            "(0$1)",
                            "$CC ($1)"
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "1(?:30|[89])"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "130"
                            ]
                        ]
                    ],
                    [
                        [
                            ,
                            "(\\d{2})(\\d{3,4})",
                            "$1 $2",
                            [
                                "16"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{2,4})",
                            "$1 $2 $3",
                            [
                                "16"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "14|4"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d)(\\d{4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[2378]"
                            ],
                            "(0$1)",
                            "$CC ($1)"
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "1(?:30|[89])"
                            ]
                        ]
                    ],
                    [
                        ,
                        ,
                        "163\\d{2,6}",
                        ,
                        ,
                        ,
                        "1631234",
                        ,
                        ,
                        [
                            5,
                            6,
                            7,
                            8,
                            9
                        ]
                    ],
                    1,
                    ,
                    [
                        ,
                        ,
                        "1(?:3(?:00\\d{5}|45[0-4])|802)\\d{3}|1[38]00\\d{6}|13\\d{4}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            6,
                            7,
                            8,
                            10,
                            12
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                AW: [
                    ,
                    [
                        ,
                        ,
                        "(?:[25-79]\\d\\d|800)\\d{4}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "5(?:2\\d|8[1-9])\\d{4}",
                        ,
                        ,
                        ,
                        "5212345"
                    ],
                    [
                        ,
                        ,
                        "(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}",
                        ,
                        ,
                        ,
                        "5601234"
                    ],
                    [
                        ,
                        ,
                        "800\\d{4}",
                        ,
                        ,
                        ,
                        "8001234"
                    ],
                    [
                        ,
                        ,
                        "900\\d{4}",
                        ,
                        ,
                        ,
                        "9001234"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:28\\d|501)\\d{4}",
                        ,
                        ,
                        ,
                        "5011234"
                    ],
                    "AW",
                    297,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1 $2",
                            [
                                "[25-9]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                AX: [
                    ,
                    [
                        ,
                        ,
                        "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            5,
                            6,
                            7,
                            8,
                            9,
                            10,
                            11,
                            12
                        ]
                    ],
                    [
                        ,
                        ,
                        "18[1-8]\\d{3,6}",
                        ,
                        ,
                        ,
                        "181234567",
                        ,
                        ,
                        [
                            6,
                            7,
                            8,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}",
                        ,
                        ,
                        ,
                        "412345678",
                        ,
                        ,
                        [
                            6,
                            7,
                            8,
                            9,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "800\\d{4,6}",
                        ,
                        ,
                        ,
                        "800123456",
                        ,
                        ,
                        [
                            7,
                            8,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "[67]00\\d{5,6}",
                        ,
                        ,
                        ,
                        "600123456",
                        ,
                        ,
                        [
                            8,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "AX",
                    358,
                    "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    "00",
                    ,
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    "18",
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}",
                        ,
                        ,
                        ,
                        "10112345"
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                AZ: [
                    ,
                    [
                        ,
                        ,
                        "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:2[12]428|3655[02])\\d{4}|(?:2(?:22[0-79]|63[0-28])|3654)\\d{5}|(?:(?:1[28]|46)\\d|2(?:[014-6]2|[23]3))\\d{6}",
                        ,
                        ,
                        ,
                        "123123456",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}",
                        ,
                        ,
                        ,
                        "401234567"
                    ],
                    [
                        ,
                        ,
                        "88\\d{7}",
                        ,
                        ,
                        ,
                        "881234567"
                    ],
                    [
                        ,
                        ,
                        "900200\\d{3}",
                        ,
                        ,
                        ,
                        "900200123"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "AZ",
                    994,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{2})",
                            "$1 $2 $3",
                            [
                                "[1-9]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "90"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "1[28]|2|365|46",
                                "1[28]|2|365[45]|46",
                                "1[28]|2|365(?:4|5[02])|46"
                            ],
                            "(0$1)"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[13-9]"
                            ],
                            "0$1"
                        ]
                    ],
                    [
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "90"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "1[28]|2|365|46",
                                "1[28]|2|365[45]|46",
                                "1[28]|2|365(?:4|5[02])|46"
                            ],
                            "(0$1)"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[13-9]"
                            ],
                            "0$1"
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                BA: [
                    ,
                    [
                        ,
                        ,
                        "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8,
                            9
                        ],
                        [
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}",
                        ,
                        ,
                        ,
                        "30212345",
                        ,
                        ,
                        [
                            8
                        ],
                        [
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}",
                        ,
                        ,
                        ,
                        "61123456"
                    ],
                    [
                        ,
                        ,
                        "8[08]\\d{6}",
                        ,
                        ,
                        ,
                        "80123456",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "9[0246]\\d{6}",
                        ,
                        ,
                        ,
                        "90123456",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "8[12]\\d{6}",
                        ,
                        ,
                        ,
                        "82123456",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "BA",
                    387,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{3})",
                            "$1-$2",
                            [
                                "[2-9]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "6[1-3]|[7-9]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3})",
                            "$1 $2-$3",
                            [
                                "[3-5]|6[56]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                            "$1 $2 $3 $4",
                            [
                                "6"
                            ],
                            "0$1"
                        ]
                    ],
                    [
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "6[1-3]|[7-9]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3})",
                            "$1 $2-$3",
                            [
                                "[3-5]|6[56]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                            "$1 $2 $3 $4",
                            [
                                "6"
                            ],
                            "0$1"
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "703[235]0\\d{3}|70(?:2[0-5]|3[0146]|[56]0)\\d{4}",
                        ,
                        ,
                        ,
                        "70341234",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                BB: [
                    ,
                    [
                        ,
                        ,
                        "(?:246|[58]\\d\\d|900)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "246521[0369]\\d{3}|246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}",
                        ,
                        ,
                        ,
                        "2464123456",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "246(?:(?:2(?:[3568]\\d|4[0-57-9])|3(?:5[2-9]|6[0-6])|4(?:46|5\\d)|69[5-7]|8(?:[2-5]\\d|83))\\d|52(?:1[147]|20))\\d{3}",
                        ,
                        ,
                        ,
                        "2462501234",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "8002123456"
                    ],
                    [
                        ,
                        ,
                        "(?:246976|900[2-9]\\d\\d)\\d{4}",
                        ,
                        ,
                        ,
                        "9002123456",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "5002345678"
                    ],
                    [
                        ,
                        ,
                        "24631\\d{5}",
                        ,
                        ,
                        ,
                        "2463101234",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    "BB",
                    1,
                    "011",
                    "1",
                    ,
                    ,
                    "([2-9]\\d{6})$|1",
                    "246$1",
                    ,
                    ,
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    "246",
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "246(?:292|367|4(?:1[7-9]|3[01]|4[47-9]|67)|7(?:1[2-9]|2\\d|3[016]|53))\\d{4}",
                        ,
                        ,
                        ,
                        "2464301234",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                BD: [
                    ,
                    [
                        ,
                        ,
                        "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            6,
                            7,
                            8,
                            9,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:4(?:31\\d\\d|423)|5222)\\d{3}(?:\\d{2})?|8332[6-9]\\d\\d|(?:3(?:03[56]|224)|4(?:22[25]|653))\\d{3,4}|(?:3(?:42[47]|529|823)|4(?:027|525|65(?:28|8))|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|5[57])|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|6(?:27|54))|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2(?:2\\d|[45])\\d\\d|3(?:1(?:2[5-7]|[5-7])|425|822)|4(?:033|1\\d|[257]1|332|4(?:2[246]|5[25])|6(?:2[35]|56|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:217|3[12]|[5-7]1)|9[24]1)\\d{5}|(?:(?:3[2-8]|5[2-57-9]|6[03-589])1|4[4689][18])\\d{5}|[59]1\\d{5}",
                        ,
                        ,
                        ,
                        "27111234"
                    ],
                    [
                        ,
                        ,
                        "(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}",
                        ,
                        ,
                        ,
                        "1812345678",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "80[03]\\d{7}",
                        ,
                        ,
                        ,
                        "8001234567",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "96(?:0[469]|1[0-47]|3[389]|43|6[69]|7[78])\\d{6}",
                        ,
                        ,
                        ,
                        "9604123456",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    "BD",
                    880,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{4,6})",
                            "$1-$2",
                            [
                                "31[5-8]|[459]1"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3,7})",
                            "$1-$2",
                            [
                                "3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{3,6})",
                            "$1-$2",
                            [
                                "[13-9]|22"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d)(\\d{7,8})",
                            "$1-$2",
                            [
                                "2"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                BE: [
                    ,
                    [
                        ,
                        ,
                        "4\\d{8}|[1-9]\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}",
                        ,
                        ,
                        ,
                        "12345678",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "4[5-9]\\d{7}",
                        ,
                        ,
                        ,
                        "470123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "800[1-9]\\d{4}",
                        ,
                        ,
                        ,
                        "80012345",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:70(?:2[0-57]|3[04-7]|44|6[4-69]|7[0579])|90\\d\\d)\\d{4}",
                        ,
                        ,
                        ,
                        "90012345",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "7879\\d{4}",
                        ,
                        ,
                        ,
                        "78791234",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "BE",
                    32,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "(?:80|9)0"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[239]|4[23]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[15-8]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "4"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "78(?:0[57]|1[014-8]|2[25]|3[15-8]|48|[56]0|7[06-8]|9\\d)\\d{4}",
                        ,
                        ,
                        ,
                        "78102345",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                BF: [
                    ,
                    [
                        ,
                        ,
                        "[025-7]\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "2(?:0(?:49|5[23]|6[5-7]|9[016-9])|4(?:4[569]|5[4-6]|6[5-7]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}",
                        ,
                        ,
                        ,
                        "20491234"
                    ],
                    [
                        ,
                        ,
                        "(?:0[1-35-7]|5[0-8]|[67]\\d)\\d{6}",
                        ,
                        ,
                        ,
                        "70123456"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "BF",
                    226,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[025-7]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                BG: [
                    ,
                    [
                        ,
                        ,
                        "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            6,
                            7,
                            8,
                            9,
                            12
                        ],
                        [
                            4,
                            5
                        ]
                    ],
                    [
                        ,
                        ,
                        "2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}",
                        ,
                        ,
                        ,
                        "2123456",
                        ,
                        ,
                        [
                            6,
                            7,
                            8
                        ],
                        [
                            4,
                            5
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:43[07-9]|99[69]\\d)\\d{5}|(?:8[7-9]|98)\\d{7}",
                        ,
                        ,
                        ,
                        "43012345",
                        ,
                        ,
                        [
                            8,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:00800\\d\\d|800)\\d{5}",
                        ,
                        ,
                        ,
                        "80012345",
                        ,
                        ,
                        [
                            8,
                            12
                        ]
                    ],
                    [
                        ,
                        ,
                        "90\\d{6}",
                        ,
                        ,
                        ,
                        "90123456",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "700\\d{5}",
                        ,
                        ,
                        ,
                        "70012345",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "BG",
                    359,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{6})",
                            "$1",
                            [
                                "1"
                            ]
                        ],
                        [
                            ,
                            "(\\d)(\\d)(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "2"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1 $2",
                            [
                                "43[1-6]|70[1-9]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "2"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{2,3})",
                            "$1 $2 $3",
                            [
                                "[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "(?:70|8)0"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{2})",
                            "$1 $2 $3",
                            [
                                "43[1-7]|7"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "[48]|9[08]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "9"
                            ],
                            "0$1"
                        ]
                    ],
                    [
                        [
                            ,
                            "(\\d)(\\d)(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "2"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1 $2",
                            [
                                "43[1-6]|70[1-9]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "2"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{2,3})",
                            "$1 $2 $3",
                            [
                                "[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "(?:70|8)0"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{2})",
                            "$1 $2 $3",
                            [
                                "43[1-7]|7"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "[48]|9[08]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "9"
                            ],
                            "0$1"
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                BH: [
                    ,
                    [
                        ,
                        ,
                        "[136-9]\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|55|7[7-9]|88)|9[69][69])|7(?:[07]\\d\\d|1(?:11|78)))\\d{4}",
                        ,
                        ,
                        ,
                        "17001234"
                    ],
                    [
                        ,
                        ,
                        "(?:3(?:[0-79]\\d|8[0-57-9])\\d|6(?:3(?:00|33|6[16])|441|6(?:3[03-9]|[69]\\d|7[0-689])))\\d{4}",
                        ,
                        ,
                        ,
                        "36001234"
                    ],
                    [
                        ,
                        ,
                        "8[02369]\\d{6}",
                        ,
                        ,
                        ,
                        "80123456"
                    ],
                    [
                        ,
                        ,
                        "(?:87|9[0-8])\\d{6}",
                        ,
                        ,
                        ,
                        "90123456"
                    ],
                    [
                        ,
                        ,
                        "84\\d{6}",
                        ,
                        ,
                        ,
                        "84123456"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "BH",
                    973,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{4})(\\d{4})",
                            "$1 $2",
                            [
                                "[13679]|8[02-4679]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                BI: [
                    ,
                    [
                        ,
                        ,
                        "(?:[267]\\d|31)\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:22|31)\\d{6}",
                        ,
                        ,
                        ,
                        "22201234"
                    ],
                    [
                        ,
                        ,
                        "(?:29|[67][125-9])\\d{6}",
                        ,
                        ,
                        ,
                        "79561234"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "BI",
                    257,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[2367]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                BJ: [
                    ,
                    [
                        ,
                        ,
                        "[24-689]\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "2(?:02|1[037]|2[45]|3[68]|4\\d)\\d{5}",
                        ,
                        ,
                        ,
                        "20211234"
                    ],
                    [
                        ,
                        ,
                        "(?:4[0-7]|[56]\\d|9[013-9])\\d{6}",
                        ,
                        ,
                        ,
                        "90011234"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "857[58]\\d{4}",
                        ,
                        ,
                        ,
                        "85751234"
                    ],
                    "BJ",
                    229,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[24-689]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "81\\d{6}",
                        ,
                        ,
                        ,
                        "81123456"
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                BL: [
                    ,
                    [
                        ,
                        ,
                        "590\\d{6}|(?:69|80|9\\d)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}",
                        ,
                        ,
                        ,
                        "590271234"
                    ],
                    [
                        ,
                        ,
                        "69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}",
                        ,
                        ,
                        ,
                        "690001234"
                    ],
                    [
                        ,
                        ,
                        "80[0-5]\\d{6}",
                        ,
                        ,
                        ,
                        "800012345"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}",
                        ,
                        ,
                        ,
                        "976012345"
                    ],
                    "BL",
                    590,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                BM: [
                    ,
                    [
                        ,
                        ,
                        "(?:441|[58]\\d\\d|900)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}",
                        ,
                        ,
                        ,
                        "4414123456",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "441(?:[2378]\\d|5[0-39]|9[02])\\d{5}",
                        ,
                        ,
                        ,
                        "4413701234",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "8002123456"
                    ],
                    [
                        ,
                        ,
                        "900[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "9002123456"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "5002345678"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "BM",
                    1,
                    "011",
                    "1",
                    ,
                    ,
                    "([2-9]\\d{6})$|1",
                    "441$1",
                    ,
                    ,
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    "441",
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                BN: [
                    ,
                    [
                        ,
                        ,
                        "[2-578]\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}",
                        ,
                        ,
                        ,
                        "2345678"
                    ],
                    [
                        ,
                        ,
                        "(?:22[89]|[78]\\d\\d)\\d{4}",
                        ,
                        ,
                        ,
                        "7123456"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "5[34]\\d{5}",
                        ,
                        ,
                        ,
                        "5345678"
                    ],
                    "BN",
                    673,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1 $2",
                            [
                                "[2-578]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                BO: [
                    ,
                    [
                        ,
                        ,
                        "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8,
                            9
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}",
                        ,
                        ,
                        ,
                        "22123456",
                        ,
                        ,
                        [
                            8
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "[67]\\d{7}",
                        ,
                        ,
                        ,
                        "71234567",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "8001[07]\\d{4}",
                        ,
                        ,
                        ,
                        "800171234",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "50\\d{6}",
                        ,
                        ,
                        ,
                        "50123456",
                        ,
                        ,
                        [
                            8
                        ],
                        [
                            7
                        ]
                    ],
                    "BO",
                    591,
                    "00(?:1\\d)?",
                    "0",
                    ,
                    ,
                    "0(1\\d)?",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d)(\\d{7})",
                            "$1 $2",
                            [
                                "[235]|4[46]"
                            ],
                            ,
                            "0$CC $1"
                        ],
                        [
                            ,
                            "(\\d{8})",
                            "$1",
                            [
                                "[67]"
                            ],
                            ,
                            "0$CC $1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "8"
                            ],
                            ,
                            "0$CC $1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "8001[07]\\d{4}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                BQ: [
                    ,
                    [
                        ,
                        ,
                        "(?:[34]1|7\\d)\\d{5}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}",
                        ,
                        ,
                        ,
                        "7151234"
                    ],
                    [
                        ,
                        ,
                        "(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}",
                        ,
                        ,
                        ,
                        "3181234"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "BQ",
                    599,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    "[347]",
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                BR: [
                    ,
                    [
                        ,
                        ,
                        "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8,
                            9,
                            10,
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}",
                        ,
                        ,
                        ,
                        "1123456789",
                        ,
                        ,
                        [
                            10
                        ],
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}",
                        ,
                        ,
                        ,
                        "11961234567",
                        ,
                        ,
                        [
                            10,
                            11
                        ],
                        [
                            8,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "800\\d{6,7}",
                        ,
                        ,
                        ,
                        "800123456",
                        ,
                        ,
                        [
                            9,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "300\\d{6}|[59]00\\d{6,7}",
                        ,
                        ,
                        ,
                        "300123456",
                        ,
                        ,
                        [
                            9,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|370))\\d{4}|300\\d{5}",
                        ,
                        ,
                        ,
                        "40041234",
                        ,
                        ,
                        [
                            8,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "BR",
                    55,
                    "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
                    "0",
                    ,
                    ,
                    "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
                    "$2",
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3,6})",
                            "$1",
                            [
                                "1(?:1[25-8]|2[357-9]|3[02-68]|4[12568]|5|6[0-8]|8[015]|9[0-47-9])|321|610"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{4})",
                            "$1-$2",
                            [
                                "300|4(?:0[02]|37)",
                                "4(?:02|37)0|[34]00"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{4})",
                            "$1-$2",
                            [
                                "[2-57]",
                                "[2357]|4(?:[0-24-9]|3(?:[0-689]|7[1-9]))"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2,3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "(?:[358]|90)0"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{5})(\\d{4})",
                            "$1-$2",
                            [
                                "9"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{4})(\\d{4})",
                            "$1 $2-$3",
                            [
                                "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
                            ],
                            "($1)",
                            "0 $CC ($1)"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{5})(\\d{4})",
                            "$1 $2-$3",
                            [
                                "[16][1-9]|[2-57-9]"
                            ],
                            "($1)",
                            "0 $CC ($1)"
                        ]
                    ],
                    [
                        [
                            ,
                            "(\\d{4})(\\d{4})",
                            "$1-$2",
                            [
                                "300|4(?:0[02]|37)",
                                "4(?:02|37)0|[34]00"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2,3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "(?:[358]|90)0"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{4})(\\d{4})",
                            "$1 $2-$3",
                            [
                                "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
                            ],
                            "($1)",
                            "0 $CC ($1)"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{5})(\\d{4})",
                            "$1 $2-$3",
                            [
                                "[16][1-9]|[2-57-9]"
                            ],
                            "($1)",
                            "0 $CC ($1)"
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "30(?:0\\d{5,7}|3\\d{7})|40(?:0\\d|20)\\d{4}|800\\d{6,7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8,
                            9,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                BS: [
                    ,
                    [
                        ,
                        ,
                        "(?:242|[58]\\d\\d|900)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-5]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}",
                        ,
                        ,
                        ,
                        "2423456789",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|3[0-4]|[89]9))\\d{4}",
                        ,
                        ,
                        ,
                        "2423591234",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "8002123456",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "900[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "9002123456"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "5002345678"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "BS",
                    1,
                    "011",
                    "1",
                    ,
                    ,
                    "([3-8]\\d{6})$|1",
                    "242$1",
                    ,
                    ,
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    "242",
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "242225\\d{4}",
                        ,
                        ,
                        ,
                        "2422250123"
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                BT: [
                    ,
                    [
                        ,
                        ,
                        "[17]\\d{7}|[2-8]\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            8
                        ],
                        [
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}",
                        ,
                        ,
                        ,
                        "2345678",
                        ,
                        ,
                        [
                            7
                        ],
                        [
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:1[67]|77)\\d{6}",
                        ,
                        ,
                        ,
                        "17123456",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "BT",
                    975,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{3})",
                            "$1 $2",
                            [
                                "[2-7]"
                            ]
                        ],
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[2-68]|7[246]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "1[67]|7"
                            ]
                        ]
                    ],
                    [
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[2-68]|7[246]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "1[67]|7"
                            ]
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                BW: [
                    ,
                    [
                        ,
                        ,
                        "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            8,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013]|81)|4(?:6[03]|7[1267]|9[0-5])|5(?:3[03489]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[013467]))\\d{4}",
                        ,
                        ,
                        ,
                        "2401234",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:321|7[1-8]\\d)\\d{5}",
                        ,
                        ,
                        ,
                        "71123456",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:0800|800\\d)\\d{6}",
                        ,
                        ,
                        ,
                        "0800012345",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "90\\d{5}",
                        ,
                        ,
                        ,
                        "9012345",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "79(?:1(?:[0-2]\\d|3[0-3])|2[0-7]\\d)\\d{3}",
                        ,
                        ,
                        ,
                        "79101234",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    "BW",
                    267,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{5})",
                            "$1 $2",
                            [
                                "90"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1 $2",
                            [
                                "[24-6]|3[15-9]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[37]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "0"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{4})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "8"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                BY: [
                    ,
                    [
                        ,
                        ,
                        "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            6,
                            7,
                            8,
                            9,
                            10,
                            11
                        ],
                        [
                            5
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}",
                        ,
                        ,
                        ,
                        "152450911",
                        ,
                        ,
                        [
                            9
                        ],
                        [
                            5,
                            6,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}",
                        ,
                        ,
                        ,
                        "294911911",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}",
                        ,
                        ,
                        ,
                        "8011234567"
                    ],
                    [
                        ,
                        ,
                        "(?:810|902)\\d{7}",
                        ,
                        ,
                        ,
                        "9021234567",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "249\\d{6}",
                        ,
                        ,
                        ,
                        "249123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    "BY",
                    375,
                    "810",
                    "8",
                    ,
                    ,
                    "0|80?",
                    ,
                    "8~10",
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{3})",
                            "$1 $2",
                            [
                                "800"
                            ],
                            "8 $1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{2,4})",
                            "$1 $2 $3",
                            [
                                "800"
                            ],
                            "8 $1"
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{2})(\\d{3})",
                            "$1 $2-$3",
                            [
                                "1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
                                "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
                            ],
                            "8 0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2-$3-$4",
                            [
                                "1(?:[56]|7[467])|2[1-3]"
                            ],
                            "8 0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                            "$1 $2-$3-$4",
                            [
                                "[1-4]"
                            ],
                            "8 0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3,4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[89]"
                            ],
                            "8 $1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "800\\d{3,7}|(?:8(?:0[13]|10|20\\d)|902)\\d{7}"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                BZ: [
                    ,
                    [
                        ,
                        ,
                        "(?:0800\\d|[2-8])\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:2(?:[02]\\d|36|[68]0)|[3-58](?:[02]\\d|[68]0)|7(?:[02]\\d|32|[68]0))\\d{4}",
                        ,
                        ,
                        ,
                        "2221234",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "6[0-35-7]\\d{5}",
                        ,
                        ,
                        ,
                        "6221234",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "0800\\d{7}",
                        ,
                        ,
                        ,
                        "08001234123",
                        ,
                        ,
                        [
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "BZ",
                    501,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1-$2",
                            [
                                "[2-8]"
                            ]
                        ],
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{4})(\\d{3})",
                            "$1-$2-$3-$4",
                            [
                                "0"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                CA: [
                    ,
                    [
                        ,
                        ,
                        "(?:[2-8]\\d|90)\\d{8}|3\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|90[25])[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "5062345678",
                        ,
                        ,
                        [
                            10
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|90[25])[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "5062345678",
                        ,
                        ,
                        [
                            10
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "8002123456",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "900[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "9002123456",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "5002345678",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "600[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "6002012345",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    "CA",
                    1,
                    "011",
                    "1",
                    ,
                    ,
                    "1",
                    ,
                    ,
                    1,
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "310\\d{4}",
                        ,
                        ,
                        ,
                        "3101234",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                CC: [
                    ,
                    [
                        ,
                        ,
                        "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            6,
                            7,
                            8,
                            9,
                            10,
                            12
                        ]
                    ],
                    [
                        ,
                        ,
                        "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",
                        ,
                        ,
                        ,
                        "891621234",
                        ,
                        ,
                        [
                            9
                        ],
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                        ,
                        ,
                        ,
                        "412345678",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "180(?:0\\d{3}|2)\\d{3}",
                        ,
                        ,
                        ,
                        "1800123456",
                        ,
                        ,
                        [
                            7,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "190[0-26]\\d{6}",
                        ,
                        ,
                        ,
                        "1900123456",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                        ,
                        ,
                        ,
                        "1300123456",
                        ,
                        ,
                        [
                            6,
                            8,
                            10,
                            12
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                        ,
                        ,
                        ,
                        "147101234",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    "CC",
                    61,
                    "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
                    "0",
                    ,
                    ,
                    "([59]\\d{7})$|0",
                    "8$1",
                    "0011",
                    ,
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                CD: [
                    ,
                    [
                        ,
                        ,
                        "[189]\\d{8}|[1-68]\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "12\\d{7}|[1-6]\\d{6}",
                        ,
                        ,
                        ,
                        "1234567"
                    ],
                    [
                        ,
                        ,
                        "88\\d{5}|(?:8[0-69]|9[017-9])\\d{7}",
                        ,
                        ,
                        ,
                        "991234567"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "CD",
                    243,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "88"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{5})",
                            "$1 $2",
                            [
                                "[1-6]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "1"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[89]"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                CF: [
                    ,
                    [
                        ,
                        ,
                        "(?:[27]\\d{3}|8776)\\d{4}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "2[12]\\d{6}",
                        ,
                        ,
                        ,
                        "21612345"
                    ],
                    [
                        ,
                        ,
                        "7[024-7]\\d{6}",
                        ,
                        ,
                        ,
                        "70012345"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "8776\\d{4}",
                        ,
                        ,
                        ,
                        "87761234"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "CF",
                    236,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[278]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                CG: [
                    ,
                    [
                        ,
                        ,
                        "222\\d{6}|(?:0\\d|80)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "222[1-589]\\d{5}",
                        ,
                        ,
                        ,
                        "222123456"
                    ],
                    [
                        ,
                        ,
                        "026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}",
                        ,
                        ,
                        ,
                        "061234567"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "80[0-2]\\d{6}",
                        ,
                        ,
                        ,
                        "800123456"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "CG",
                    242,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d)(\\d{4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "8"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[02]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                CH: [
                    ,
                    [
                        ,
                        ,
                        "8\\d{11}|[2-9]\\d{8}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9,
                            12
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}",
                        ,
                        ,
                        ,
                        "212345678",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:6[89]|7[235-9])\\d{7}",
                        ,
                        ,
                        ,
                        "781234567",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "800\\d{6}",
                        ,
                        ,
                        ,
                        "800123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "90[016]\\d{6}",
                        ,
                        ,
                        ,
                        "900123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "84[0248]\\d{6}",
                        ,
                        ,
                        ,
                        "840123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "878\\d{6}",
                        ,
                        ,
                        ,
                        "878123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "CH",
                    41,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "8[047]|90"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[2-79]|81"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4 $5",
                            [
                                "8"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        "74[0248]\\d{6}",
                        ,
                        ,
                        ,
                        "740123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "5[18]\\d{7}",
                        ,
                        ,
                        ,
                        "581234567",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "860\\d{9}",
                        ,
                        ,
                        ,
                        "860123456789",
                        ,
                        ,
                        [
                            12
                        ]
                    ]
                ],
                CI: [
                    ,
                    [
                        ,
                        ,
                        "[02]\\d{9}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "2(?:[15]\\d{3}|7(?:2(?:0[23]|1[2357]|2[245]|3[45]|4[3-5])|3(?:06|1[69]|[2-6]7)))\\d{5}",
                        ,
                        ,
                        ,
                        "2123456789"
                    ],
                    [
                        ,
                        ,
                        "0[157]\\d{8}",
                        ,
                        ,
                        ,
                        "0123456789"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "CI",
                    225,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d)(\\d{5})",
                            "$1 $2 $3 $4",
                            [
                                "2"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})(\\d{4})",
                            "$1 $2 $3 $4",
                            [
                                "0"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                CK: [
                    ,
                    [
                        ,
                        ,
                        "[2-578]\\d{4}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            5
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:2\\d|3[13-7]|4[1-5])\\d{3}",
                        ,
                        ,
                        ,
                        "21234"
                    ],
                    [
                        ,
                        ,
                        "[578]\\d{4}",
                        ,
                        ,
                        ,
                        "71234"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "CK",
                    682,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{3})",
                            "$1 $2",
                            [
                                "[2-578]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                CL: [
                    ,
                    [
                        ,
                        ,
                        "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9,
                            10,
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        "2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}",
                        ,
                        ,
                        ,
                        "221234567",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}",
                        ,
                        ,
                        ,
                        "221234567",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:123|8)00\\d{6}",
                        ,
                        ,
                        ,
                        "800123456",
                        ,
                        ,
                        [
                            9,
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "600\\d{7,8}",
                        ,
                        ,
                        ,
                        "6001234567",
                        ,
                        ,
                        [
                            10,
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "44\\d{7}",
                        ,
                        ,
                        ,
                        "441234567",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    "CL",
                    56,
                    "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    [
                        [
                            ,
                            "(\\d{4})",
                            "$1",
                            [
                                "1(?:[03-589]|21)|[29]0|78"
                            ]
                        ],
                        [
                            ,
                            "(\\d{5})(\\d{4})",
                            "$1 $2",
                            [
                                "219",
                                "2196"
                            ],
                            "($1)"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "44"
                            ]
                        ],
                        [
                            ,
                            "(\\d)(\\d{4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "2[1-36]"
                            ],
                            "($1)"
                        ],
                        [
                            ,
                            "(\\d)(\\d{4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "9[2-9]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"
                            ],
                            "($1)"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "60|8"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "1"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                            "$1 $2 $3 $4",
                            [
                                "60"
                            ]
                        ]
                    ],
                    [
                        [
                            ,
                            "(\\d{5})(\\d{4})",
                            "$1 $2",
                            [
                                "219",
                                "2196"
                            ],
                            "($1)"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "44"
                            ]
                        ],
                        [
                            ,
                            "(\\d)(\\d{4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "2[1-36]"
                            ],
                            "($1)"
                        ],
                        [
                            ,
                            "(\\d)(\\d{4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "9[2-9]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"
                            ],
                            "($1)"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "60|8"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "1"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                            "$1 $2 $3 $4",
                            [
                                "60"
                            ]
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "600\\d{7,8}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10,
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                CM: [
                    ,
                    [
                        ,
                        ,
                        "[26]\\d{8}|88\\d{6,7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "2(?:22|33)\\d{6}",
                        ,
                        ,
                        ,
                        "222123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:24[23]|6[25-9]\\d)\\d{6}",
                        ,
                        ,
                        ,
                        "671234567",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "88\\d{6,7}",
                        ,
                        ,
                        ,
                        "88012345"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "CM",
                    237,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "88"
                            ]
                        ],
                        [
                            ,
                            "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4 $5",
                            [
                                "[26]|88"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                CN: [
                    ,
                    [
                        ,
                        ,
                        "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            8,
                            9,
                            10,
                            11,
                            12
                        ],
                        [
                            5,
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|21(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))\\d{5}|(?:43[35]|754)\\d{7,8}|8(?:078\\d{7}|51\\d{7,8})|(?:10|(?:2|85)1|43[35]|754)(?:100\\d\\d|95\\d{3,4})|(?:2[02-57-9]|3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[1-9]\\d{6})|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[1-9]\\d{5})|9(?:[0-46-9]\\d{5}|5\\d{3,5}))",
                        ,
                        ,
                        ,
                        "1012345678",
                        ,
                        ,
                        [
                            7,
                            8,
                            9,
                            10,
                            11
                        ],
                        [
                            5,
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|[59][0-35-9]|6[25-7]|7[0-35-8])\\d{8}",
                        ,
                        ,
                        ,
                        "13123456789",
                        ,
                        ,
                        [
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:(?:10|21)8|8)00\\d{7}",
                        ,
                        ,
                        ,
                        "8001234567",
                        ,
                        ,
                        [
                            10,
                            12
                        ]
                    ],
                    [
                        ,
                        ,
                        "16[08]\\d{5}",
                        ,
                        ,
                        ,
                        "16812345",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "10(?:10\\d{4}|96\\d{3,4})|400\\d{7}|950\\d{7,8}|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}",
                        ,
                        ,
                        ,
                        "4001234567",
                        ,
                        ,
                        [
                            7,
                            8,
                            9,
                            10,
                            11
                        ],
                        [
                            5,
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "CN",
                    86,
                    "00|1(?:[12]\\d|79)\\d\\d00",
                    "0",
                    ,
                    ,
                    "(1(?:[12]\\d|79)\\d\\d)|0",
                    ,
                    "00",
                    ,
                    [
                        [
                            ,
                            "(\\d{5,6})",
                            "$1",
                            [
                                "1(?:00|2[13])|9[56]",
                                "1(?:00|2(?:1|39))|9[56]",
                                "1(?:00|2(?:1|395))|9[56]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{5,6})",
                            "$1",
                            [
                                "10"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{5,6})",
                            "$1 $2",
                            [
                                "(?:10|2[0-57-9])[19]",
                                "(?:10|2[0-57-9])(?:10|9[56])",
                                "10(?:10|9[56])|2[0-57-9](?:100|9[56])"
                            ],
                            "0$1",
                            "$CC $1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1 $2",
                            [
                                "[1-9]",
                                "1[1-9]|26|[3-9]|(?:10|2[0-57-9])(?:[0-8]|9[0-47-9])",
                                "1(?:0(?:[0-8]|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[1-9])|9[0-47-9])|6)|[3-9]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{4})",
                            "$1 $2",
                            [
                                "16[08]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{5,6})",
                            "$1 $2",
                            [
                                "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                                "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                                "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                                "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                            ],
                            "0$1",
                            "$CC $1"
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{4})",
                            "$1 $2",
                            [
                                "[1-9]",
                                "1(?:0(?:[02-8]|1[1-9]|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[0-8]|9[0-47-9])|6)|[3-9]",
                                "1(?:0(?:[02-8]|1[1-9]|9[0-47-9])|[1-9])|26|3(?:[0268]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23][0-8])|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:33|85[23]9)[0-46-9]|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[0-8]|9[0-47-9])",
                                "1(?:0[02-8]|[1-9])|2(?:[0-57-9][0-8]|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23](?:[02-8]|1[1-9]|9[0-46-9]))|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:10|2[0-57-9])9[0-47-9]|(?:101|58|85[23]10)[1-9]|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]|1(?:0[1-9]|[1-9])|9[0-47-9])"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "(?:4|80)0"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "10|2(?:[02-57-9]|1[1-9])",
                                "10|2(?:[02-57-9]|1[1-9])",
                                "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                            ],
                            "0$1",
                            "$CC $1",
                            1
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
                            ],
                            "0$1",
                            "$CC $1",
                            1
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{7,8})",
                            "$1 $2",
                            [
                                "9"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "80"
                            ],
                            "0$1",
                            "$CC $1",
                            1
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[3-578]"
                            ],
                            "0$1",
                            "$CC $1",
                            1
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "1[3-9]"
                            ],
                            ,
                            "$CC $1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                            "$1 $2 $3 $4",
                            [
                                "[12]"
                            ],
                            "0$1",
                            ,
                            1
                        ]
                    ],
                    [
                        [
                            ,
                            "(\\d{2})(\\d{5,6})",
                            "$1 $2",
                            [
                                "(?:10|2[0-57-9])[19]",
                                "(?:10|2[0-57-9])(?:10|9[56])",
                                "10(?:10|9[56])|2[0-57-9](?:100|9[56])"
                            ],
                            "0$1",
                            "$CC $1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{5,6})",
                            "$1 $2",
                            [
                                "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                                "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                                "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                                "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                            ],
                            "0$1",
                            "$CC $1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "(?:4|80)0"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "10|2(?:[02-57-9]|1[1-9])",
                                "10|2(?:[02-57-9]|1[1-9])",
                                "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                            ],
                            "0$1",
                            "$CC $1",
                            1
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
                            ],
                            "0$1",
                            "$CC $1",
                            1
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{7,8})",
                            "$1 $2",
                            [
                                "9"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "80"
                            ],
                            "0$1",
                            "$CC $1",
                            1
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[3-578]"
                            ],
                            "0$1",
                            "$CC $1",
                            1
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "1[3-9]"
                            ],
                            ,
                            "$CC $1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                            "$1 $2 $3 $4",
                            [
                                "[12]"
                            ],
                            "0$1",
                            ,
                            1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "(?:(?:10|21)8|[48])00\\d{7}|950\\d{7,8}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10,
                            11,
                            12
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                CO: [
                    ,
                    [
                        ,
                        ,
                        "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10,
                            11
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "601055(?:[0-4]\\d|50)\\d\\d|6010(?:[0-4]\\d|5[0-4])\\d{4}|60(?:[124-7][2-9]|8[1-9])\\d{6}",
                        ,
                        ,
                        ,
                        "6012345678",
                        ,
                        ,
                        [
                            10
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "333301[0-5]\\d{3}|3333(?:00|2[5-9]|[3-9]\\d)\\d{4}|(?:3(?:24[1-9]|3(?:00|3[0-24-9]))|9101)\\d{6}|3(?:0[0-5]|1\\d|2[0-3]|5[01]|70)\\d{7}",
                        ,
                        ,
                        ,
                        "3211234567",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "1800\\d{7}",
                        ,
                        ,
                        ,
                        "18001234567",
                        ,
                        ,
                        [
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        "19(?:0[01]|4[78])\\d{7}",
                        ,
                        ,
                        ,
                        "19001234567",
                        ,
                        ,
                        [
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "CO",
                    57,
                    "00(?:4(?:[14]4|56)|[579])",
                    "0",
                    ,
                    ,
                    "0([3579]|4(?:[14]4|56))?",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{7})",
                            "$1 $2",
                            [
                                "6"
                            ],
                            "($1)",
                            "0$CC $1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{7})",
                            "$1 $2",
                            [
                                "3[0-357]|91"
                            ],
                            ,
                            "0$CC $1"
                        ],
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{7})",
                            "$1-$2-$3",
                            [
                                "1"
                            ],
                            "0$1"
                        ]
                    ],
                    [
                        [
                            ,
                            "(\\d{3})(\\d{7})",
                            "$1 $2",
                            [
                                "6"
                            ],
                            "($1)",
                            "0$CC $1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{7})",
                            "$1 $2",
                            [
                                "3[0-357]|91"
                            ],
                            ,
                            "0$CC $1"
                        ],
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{7})",
                            "$1 $2 $3",
                            [
                                "1"
                            ]
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                CR: [
                    ,
                    [
                        ,
                        ,
                        "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}",
                        ,
                        ,
                        ,
                        "22123456",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}",
                        ,
                        ,
                        ,
                        "83123456",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "800\\d{7}",
                        ,
                        ,
                        ,
                        "8001234567",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "90[059]\\d{7}",
                        ,
                        ,
                        ,
                        "9001234567",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:210[0-6]|4\\d{3}|5100)\\d{4}",
                        ,
                        ,
                        ,
                        "40001234",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    "CR",
                    506,
                    "00",
                    ,
                    ,
                    ,
                    "(19(?:0[0-2468]|1[09]|20|66|77|99))",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{4})(\\d{4})",
                            "$1 $2",
                            [
                                "[2-7]|8[3-9]"
                            ],
                            ,
                            "$CC $1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "$1-$2-$3",
                            [
                                "[89]"
                            ],
                            ,
                            "$CC $1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                CU: [
                    ,
                    [
                        ,
                        ,
                        "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            6,
                            7,
                            8,
                            10
                        ],
                        [
                            4,
                            5
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:3[23]|4[89])\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}",
                        ,
                        ,
                        ,
                        "71234567",
                        ,
                        ,
                        ,
                        [
                            4,
                            5
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:5\\d|6[2-4])\\d{6}",
                        ,
                        ,
                        ,
                        "51234567",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "800\\d{7}",
                        ,
                        ,
                        ,
                        "8001234567",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "807\\d{7}",
                        ,
                        ,
                        ,
                        "8071234567",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "CU",
                    53,
                    "119",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{4,6})",
                            "$1 $2",
                            [
                                "2[1-4]|[34]"
                            ],
                            "(0$1)"
                        ],
                        [
                            ,
                            "(\\d)(\\d{6,7})",
                            "$1 $2",
                            [
                                "7"
                            ],
                            "(0$1)"
                        ],
                        [
                            ,
                            "(\\d)(\\d{7})",
                            "$1 $2",
                            [
                                "[56]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{7})",
                            "$1 $2",
                            [
                                "8"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                CV: [
                    ,
                    [
                        ,
                        ,
                        "(?:[2-59]\\d\\d|800)\\d{4}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}",
                        ,
                        ,
                        ,
                        "2211234"
                    ],
                    [
                        ,
                        ,
                        "(?:36|5[1-389]|9\\d)\\d{5}",
                        ,
                        ,
                        ,
                        "9911234"
                    ],
                    [
                        ,
                        ,
                        "800\\d{4}",
                        ,
                        ,
                        ,
                        "8001234"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:3[3-5]|4[356])\\d{5}",
                        ,
                        ,
                        ,
                        "3401234"
                    ],
                    "CV",
                    238,
                    "0",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{2})",
                            "$1 $2 $3",
                            [
                                "[2-589]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                CW: [
                    ,
                    [
                        ,
                        ,
                        "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}",
                        ,
                        ,
                        ,
                        "94351234"
                    ],
                    [
                        ,
                        ,
                        "953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}",
                        ,
                        ,
                        ,
                        "95181234"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "60[0-2]\\d{4}",
                        ,
                        ,
                        ,
                        "6001234",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "CW",
                    599,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1 $2",
                            [
                                "[3467]"
                            ]
                        ],
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "9[4-8]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        "955\\d{5}",
                        ,
                        ,
                        ,
                        "95581234",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    1,
                    "[69]",
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                CX: [
                    ,
                    [
                        ,
                        ,
                        "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            6,
                            7,
                            8,
                            9,
                            10,
                            12
                        ]
                    ],
                    [
                        ,
                        ,
                        "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
                        ,
                        ,
                        ,
                        "891641234",
                        ,
                        ,
                        [
                            9
                        ],
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                        ,
                        ,
                        ,
                        "412345678",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "180(?:0\\d{3}|2)\\d{3}",
                        ,
                        ,
                        ,
                        "1800123456",
                        ,
                        ,
                        [
                            7,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "190[0-26]\\d{6}",
                        ,
                        ,
                        ,
                        "1900123456",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                        ,
                        ,
                        ,
                        "1300123456",
                        ,
                        ,
                        [
                            6,
                            8,
                            10,
                            12
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                        ,
                        ,
                        ,
                        "147101234",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    "CX",
                    61,
                    "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
                    "0",
                    ,
                    ,
                    "([59]\\d{7})$|0",
                    "8$1",
                    "0011",
                    ,
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                CY: [
                    ,
                    [
                        ,
                        ,
                        "(?:[279]\\d|[58]0)\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "2[2-6]\\d{6}",
                        ,
                        ,
                        ,
                        "22345678"
                    ],
                    [
                        ,
                        ,
                        "9(?:10|[4-79]\\d)\\d{5}",
                        ,
                        ,
                        ,
                        "96123456"
                    ],
                    [
                        ,
                        ,
                        "800\\d{5}",
                        ,
                        ,
                        ,
                        "80001234"
                    ],
                    [
                        ,
                        ,
                        "90[09]\\d{5}",
                        ,
                        ,
                        ,
                        "90012345"
                    ],
                    [
                        ,
                        ,
                        "80[1-9]\\d{5}",
                        ,
                        ,
                        ,
                        "80112345"
                    ],
                    [
                        ,
                        ,
                        "700\\d{5}",
                        ,
                        ,
                        ,
                        "70012345"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "CY",
                    357,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{6})",
                            "$1 $2",
                            [
                                "[257-9]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:50|77)\\d{6}",
                        ,
                        ,
                        ,
                        "77123456"
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                CZ: [
                    ,
                    [
                        ,
                        ,
                        "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9,
                            10,
                            11,
                            12
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}",
                        ,
                        ,
                        ,
                        "212345678",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:60[1-8]\\d|7(?:0(?:[2-5]\\d|60)|190|[2379]\\d\\d))\\d{5}",
                        ,
                        ,
                        ,
                        "601123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "800\\d{6}",
                        ,
                        ,
                        ,
                        "800123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "9(?:0[05689]|76)\\d{6}",
                        ,
                        ,
                        ,
                        "900123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "8[134]\\d{7}",
                        ,
                        ,
                        ,
                        "811234567",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "70[01]\\d{6}",
                        ,
                        ,
                        ,
                        "700123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "9[17]0\\d{6}",
                        ,
                        ,
                        ,
                        "910123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    "CZ",
                    420,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[2-8]|9[015-7]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "96"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3 $4",
                            [
                                "9"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3 $4",
                            [
                                "9"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "9(?:5\\d|7[2-4])\\d{6}",
                        ,
                        ,
                        ,
                        "972123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "9(?:3\\d{9}|6\\d{7,10})",
                        ,
                        ,
                        ,
                        "93123456789"
                    ]
                ],
                DE: [
                    ,
                    [
                        ,
                        ,
                        "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            4,
                            5,
                            6,
                            7,
                            8,
                            9,
                            10,
                            11,
                            12,
                            13,
                            14,
                            15
                        ],
                        [
                            2,
                            3
                        ]
                    ],
                    [
                        ,
                        ,
                        "32\\d{9,11}|49[1-6]\\d{10}|322\\d{6}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}",
                        ,
                        ,
                        ,
                        "30123456",
                        ,
                        ,
                        [
                            5,
                            6,
                            7,
                            8,
                            9,
                            10,
                            11,
                            12,
                            13,
                            14,
                            15
                        ],
                        [
                            2,
                            3,
                            4
                        ]
                    ],
                    [
                        ,
                        ,
                        "15(?:[0-25-9]\\d\\d|310)\\d{6}|1(?:6[023]|7\\d)\\d{7,8}",
                        ,
                        ,
                        ,
                        "15123456789",
                        ,
                        ,
                        [
                            10,
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        "800\\d{7,12}",
                        ,
                        ,
                        ,
                        "8001234567890",
                        ,
                        ,
                        [
                            10,
                            11,
                            12,
                            13,
                            14,
                            15
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:137[7-9]|900(?:[135]|9\\d))\\d{6}",
                        ,
                        ,
                        ,
                        "9001234567",
                        ,
                        ,
                        [
                            10,
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        "180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}",
                        ,
                        ,
                        ,
                        "18012345",
                        ,
                        ,
                        [
                            7,
                            8,
                            9,
                            10,
                            11,
                            12,
                            13,
                            14
                        ]
                    ],
                    [
                        ,
                        ,
                        "700\\d{8}",
                        ,
                        ,
                        ,
                        "70012345678",
                        ,
                        ,
                        [
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "DE",
                    49,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{3,13})",
                            "$1 $2",
                            [
                                "3[02]|40|[68]9"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3,12})",
                            "$1 $2",
                            [
                                "2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
                                "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{2,11})",
                            "$1 $2",
                            [
                                "[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
                                "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1 $2",
                            [
                                "138"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{5})(\\d{2,10})",
                            "$1 $2",
                            [
                                "3"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{5,11})",
                            "$1 $2",
                            [
                                "181"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d)(\\d{4,10})",
                            "$1 $2 $3",
                            [
                                "1(?:3|80)|9"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{7,8})",
                            "$1 $2",
                            [
                                "1[67]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{7,12})",
                            "$1 $2",
                            [
                                "8"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{5})(\\d{6})",
                            "$1 $2",
                            [
                                "185",
                                "1850",
                                "18500"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "7"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{7})",
                            "$1 $2",
                            [
                                "18[68]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{7})",
                            "$1 $2",
                            [
                                "15[1279]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{5})(\\d{6})",
                            "$1 $2",
                            [
                                "15[03568]",
                                "15(?:[0568]|31)"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{8})",
                            "$1 $2",
                            [
                                "18"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{7,8})",
                            "$1 $2 $3",
                            [
                                "1(?:6[023]|7)"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{2})(\\d{7})",
                            "$1 $2 $3",
                            [
                                "15[279]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{8})",
                            "$1 $2 $3",
                            [
                                "15"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        "16(?:4\\d{1,10}|[89]\\d{1,11})",
                        ,
                        ,
                        ,
                        "16412345",
                        ,
                        ,
                        [
                            4,
                            5,
                            6,
                            7,
                            8,
                            9,
                            10,
                            11,
                            12,
                            13,
                            14
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "18(?:1\\d{5,11}|[2-9]\\d{8})",
                        ,
                        ,
                        ,
                        "18500123456",
                        ,
                        ,
                        [
                            8,
                            9,
                            10,
                            11,
                            12,
                            13,
                            14
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "1(?:6(?:013|255|399)|7(?:(?:[015]1|[69]3)3|[2-4]55|[78]99))\\d{7,8}|15(?:(?:[03-68]00|113)\\d|2\\d55|7\\d99|9\\d33)\\d{7}",
                        ,
                        ,
                        ,
                        "177991234567",
                        ,
                        ,
                        [
                            12,
                            13
                        ]
                    ]
                ],
                DJ: [
                    ,
                    [
                        ,
                        ,
                        "(?:2\\d|77)\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "2(?:1[2-5]|7[45])\\d{5}",
                        ,
                        ,
                        ,
                        "21360003"
                    ],
                    [
                        ,
                        ,
                        "77\\d{6}",
                        ,
                        ,
                        ,
                        "77831001"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "DJ",
                    253,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[27]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                DK: [
                    ,
                    [
                        ,
                        ,
                        "[2-9]\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:(?:2\\d|9[1-46-9])\\d|3(?:[0-37]\\d|4[013]|5[0-58]|6[01347-9]|8[0-8]|9[0-79])|4(?:[0-25]\\d|[34][02-9]|6[013-579]|7[013579]|8[0-47]|9[0-27])|5(?:[0-36]\\d|4[0146-9]|5[03-57-9]|7[0568]|8[0-358]|9[0-69])|6(?:[013578]\\d|2[0-68]|4[02-8]|6[01689]|9[015689])|7(?:[0-69]\\d|7[03-9]|8[0147])|8(?:[16-9]\\d|2[0-58]))\\d{5}",
                        ,
                        ,
                        ,
                        "32123456"
                    ],
                    [
                        ,
                        ,
                        "(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}",
                        ,
                        ,
                        ,
                        "34412345"
                    ],
                    [
                        ,
                        ,
                        "80\\d{6}",
                        ,
                        ,
                        ,
                        "80123456"
                    ],
                    [
                        ,
                        ,
                        "90\\d{6}",
                        ,
                        ,
                        ,
                        "90123456"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "DK",
                    45,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[2-9]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                DM: [
                    ,
                    [
                        ,
                        ,
                        "(?:[58]\\d\\d|767|900)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}",
                        ,
                        ,
                        ,
                        "7674201234",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}",
                        ,
                        ,
                        ,
                        "7672251234",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "8002123456"
                    ],
                    [
                        ,
                        ,
                        "900[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "9002123456"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "5002345678"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "DM",
                    1,
                    "011",
                    "1",
                    ,
                    ,
                    "([2-7]\\d{6})$|1",
                    "767$1",
                    ,
                    ,
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    "767",
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                DO: [
                    ,
                    [
                        ,
                        ,
                        "(?:[58]\\d\\d|900)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}",
                        ,
                        ,
                        ,
                        "8092345678",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "8[024]9[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "8092345678",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "8(?:00(?:14|[2-9]\\d)|(?:33|44|55|66|77|88)[2-9]\\d)\\d{5}",
                        ,
                        ,
                        ,
                        "8002123456"
                    ],
                    [
                        ,
                        ,
                        "900[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "9002123456"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "5002345678"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "DO",
                    1,
                    "011",
                    "1",
                    ,
                    ,
                    "1",
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    "8001|8[024]9",
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                DZ: [
                    ,
                    [
                        ,
                        ,
                        "(?:[1-4]|[5-79]\\d|80)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[013-689])\\d{6}",
                        ,
                        ,
                        ,
                        "12345678"
                    ],
                    [
                        ,
                        ,
                        "(?:5(?:4[0-29]|5\\d|6[0-2])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}",
                        ,
                        ,
                        ,
                        "551234567",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "800\\d{6}",
                        ,
                        ,
                        ,
                        "800123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "80[3-689]1\\d{5}",
                        ,
                        ,
                        ,
                        "808123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "80[12]1\\d{5}",
                        ,
                        ,
                        ,
                        "801123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "98[23]\\d{6}",
                        ,
                        ,
                        ,
                        "983123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    "DZ",
                    213,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[1-4]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "9"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[5-8]"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                EC: [
                    ,
                    [
                        ,
                        ,
                        "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8,
                            9,
                            10,
                            11
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "[2-7][2-7]\\d{6}",
                        ,
                        ,
                        ,
                        "22123456",
                        ,
                        ,
                        [
                            8
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}",
                        ,
                        ,
                        ,
                        "991234567",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "1800\\d{7}|1[78]00\\d{6}",
                        ,
                        ,
                        ,
                        "18001234567",
                        ,
                        ,
                        [
                            10,
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "[2-7]890\\d{4}",
                        ,
                        ,
                        ,
                        "28901234",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    "EC",
                    593,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1-$2",
                            [
                                "[2-7]"
                            ]
                        ],
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{4})",
                            "$1 $2-$3",
                            [
                                "[2-7]"
                            ],
                            "(0$1)"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "9"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{3})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "1"
                            ]
                        ]
                    ],
                    [
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{4})",
                            "$1-$2-$3",
                            [
                                "[2-7]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "9"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{3})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "1"
                            ]
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                EE: [
                    ,
                    [
                        ,
                        ,
                        "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            8,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}",
                        ,
                        ,
                        ,
                        "3212345",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:5\\d{5}|8(?:1(?:0(?:0(?:00|[178]\\d)|[3-9]\\d\\d)|(?:1(?:0[236]|1\\d)|(?:2[0-59]|[3-79]\\d)\\d)\\d)|2(?:0(?:0(?:00|4\\d)|(?:19|[2-7]\\d)\\d)|(?:(?:[124-6]\\d|3[5-9])\\d|7(?:[0-79]\\d|8[13-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}",
                        ,
                        ,
                        ,
                        "51234567",
                        ,
                        ,
                        [
                            7,
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}",
                        ,
                        ,
                        ,
                        "80012345"
                    ],
                    [
                        ,
                        ,
                        "(?:40\\d\\d|900)\\d{4}",
                        ,
                        ,
                        ,
                        "9001234",
                        ,
                        ,
                        [
                            7,
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "70[0-2]\\d{5}",
                        ,
                        ,
                        ,
                        "70012345",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "EE",
                    372,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1 $2",
                            [
                                "[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88",
                                "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{3,4})",
                            "$1 $2",
                            [
                                "[45]|8(?:00|[1-49])",
                                "[45]|8(?:00[1-9]|[1-49])"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "7"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "8"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "800[2-9]\\d{3}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                EG: [
                    ,
                    [
                        ,
                        ,
                        "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8,
                            9,
                            10
                        ],
                        [
                            6,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2[2-4]|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}",
                        ,
                        ,
                        ,
                        "234567890",
                        ,
                        ,
                        [
                            8,
                            9
                        ],
                        [
                            6,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "1[0-25]\\d{8}",
                        ,
                        ,
                        ,
                        "1001234567",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "800\\d{7}",
                        ,
                        ,
                        ,
                        "8001234567",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "900\\d{7}",
                        ,
                        ,
                        ,
                        "9001234567",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "EG",
                    20,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d)(\\d{7,8})",
                            "$1 $2",
                            [
                                "[23]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{6,7})",
                            "$1 $2",
                            [
                                "1[35]|[4-6]|8[2468]|9[235-7]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[89]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{8})",
                            "$1 $2",
                            [
                                "1"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                EH: [
                    ,
                    [
                        ,
                        ,
                        "[5-8]\\d{8}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "528[89]\\d{5}",
                        ,
                        ,
                        ,
                        "528812345"
                    ],
                    [
                        ,
                        ,
                        "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-4]|5[01]|8[0-3]))\\d{6}",
                        ,
                        ,
                        ,
                        "650123456"
                    ],
                    [
                        ,
                        ,
                        "80[0-7]\\d{6}",
                        ,
                        ,
                        ,
                        "801234567"
                    ],
                    [
                        ,
                        ,
                        "89\\d{7}",
                        ,
                        ,
                        ,
                        "891234567"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}",
                        ,
                        ,
                        ,
                        "592401234"
                    ],
                    "EH",
                    212,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    "528[89]",
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                ER: [
                    ,
                    [
                        ,
                        ,
                        "[178]\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7
                        ],
                        [
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}",
                        ,
                        ,
                        ,
                        "8370362",
                        ,
                        ,
                        ,
                        [
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:17[1-3]|7\\d\\d)\\d{4}",
                        ,
                        ,
                        ,
                        "7123456"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "ER",
                    291,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[178]"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                ES: [
                    ,
                    [
                        ,
                        ,
                        "[5-9]\\d{8}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}",
                        ,
                        ,
                        ,
                        "810123456"
                    ],
                    [
                        ,
                        ,
                        "(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}",
                        ,
                        ,
                        ,
                        "612345678"
                    ],
                    [
                        ,
                        ,
                        "[89]00\\d{6}",
                        ,
                        ,
                        ,
                        "800123456"
                    ],
                    [
                        ,
                        ,
                        "80[367]\\d{6}",
                        ,
                        ,
                        ,
                        "803123456"
                    ],
                    [
                        ,
                        ,
                        "90[12]\\d{6}",
                        ,
                        ,
                        ,
                        "901123456"
                    ],
                    [
                        ,
                        ,
                        "70\\d{7}",
                        ,
                        ,
                        ,
                        "701234567"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "ES",
                    34,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{4})",
                            "$1",
                            [
                                "905"
                            ]
                        ],
                        [
                            ,
                            "(\\d{6})",
                            "$1",
                            [
                                "[79]9"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[89]00"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[5-9]"
                            ]
                        ]
                    ],
                    [
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[89]00"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[5-9]"
                            ]
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "51\\d{7}",
                        ,
                        ,
                        ,
                        "511234567"
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                ET: [
                    ,
                    [
                        ,
                        ,
                        "(?:11|[2-579]\\d)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "11667[01]\\d{3}|(?:11(?:1(?:1[124]|2[2-7]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8])|5(?:1[578]|44|5[0-4])|6(?:1[578]|2[69]|39|4[5-7]|5[0-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}",
                        ,
                        ,
                        ,
                        "111112345",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "700[1-9]\\d{5}|(?:7(?:0[1-9]|1[0-8]|22|77|86|99)|9\\d\\d)\\d{6}",
                        ,
                        ,
                        ,
                        "911234567"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "ET",
                    251,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[1-579]"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                FI: [
                    ,
                    [
                        ,
                        ,
                        "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            5,
                            6,
                            7,
                            8,
                            9,
                            10,
                            11,
                            12
                        ]
                    ],
                    [
                        ,
                        ,
                        "1[35-7][1-8]\\d{3,6}|(?:1[49][1-8]|[23568][1-8]\\d|9(?:00|[1-8]\\d))\\d{2,6}",
                        ,
                        ,
                        ,
                        "131234567",
                        ,
                        ,
                        [
                            5,
                            6,
                            7,
                            8,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}",
                        ,
                        ,
                        ,
                        "412345678",
                        ,
                        ,
                        [
                            6,
                            7,
                            8,
                            9,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "800\\d{4,6}",
                        ,
                        ,
                        ,
                        "800123456",
                        ,
                        ,
                        [
                            7,
                            8,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "[67]00\\d{5,6}",
                        ,
                        ,
                        ,
                        "600123456",
                        ,
                        ,
                        [
                            8,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "FI",
                    358,
                    "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    "00",
                    ,
                    [
                        [
                            ,
                            "(\\d{5})",
                            "$1",
                            [
                                "75[12]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{5})",
                            "$1",
                            [
                                "20[2-59]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{6})",
                            "$1",
                            [
                                "11"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3,7})",
                            "$1 $2",
                            [
                                "(?:[1-3]0|[68])0|70[07-9]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{4,8})",
                            "$1 $2",
                            [
                                "[14]|2[09]|50|7[135]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{6,10})",
                            "$1 $2",
                            [
                                "7"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d)(\\d{4,9})",
                            "$1 $2",
                            [
                                "(?:1[49]|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"
                            ],
                            "0$1"
                        ]
                    ],
                    [
                        [
                            ,
                            "(\\d{5})",
                            "$1",
                            [
                                "20[2-59]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3,7})",
                            "$1 $2",
                            [
                                "(?:[1-3]0|[68])0|70[07-9]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{4,8})",
                            "$1 $2",
                            [
                                "[14]|2[09]|50|7[135]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{6,10})",
                            "$1 $2",
                            [
                                "7"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d)(\\d{4,9})",
                            "$1 $2",
                            [
                                "(?:1[49]|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"
                            ],
                            "0$1"
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    1,
                    "1[03-79]|[2-9]",
                    [
                        ,
                        ,
                        "20(?:2[023]|9[89])\\d{1,6}|(?:60[12]\\d|7099)\\d{4,5}|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:[1-3]00|7(?:0[1-5]\\d\\d|5[03-9]))\\d{3,7}"
                    ],
                    [
                        ,
                        ,
                        "20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}",
                        ,
                        ,
                        ,
                        "10112345"
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                FJ: [
                    ,
                    [
                        ,
                        ,
                        "45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        "603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}",
                        ,
                        ,
                        ,
                        "3212345",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:[279]\\d|45|5[01568]|8[034679])\\d{5}",
                        ,
                        ,
                        ,
                        "7012345",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "0800\\d{7}",
                        ,
                        ,
                        ,
                        "08001234567",
                        ,
                        ,
                        [
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "FJ",
                    679,
                    "0(?:0|52)",
                    ,
                    ,
                    ,
                    ,
                    ,
                    "00",
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1 $2",
                            [
                                "[235-9]|45"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "0"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                FK: [
                    ,
                    [
                        ,
                        ,
                        "[2-7]\\d{4}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            5
                        ]
                    ],
                    [
                        ,
                        ,
                        "[2-47]\\d{4}",
                        ,
                        ,
                        ,
                        "31234"
                    ],
                    [
                        ,
                        ,
                        "[56]\\d{4}",
                        ,
                        ,
                        ,
                        "51234"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "FK",
                    500,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                FM: [
                    ,
                    [
                        ,
                        ,
                        "(?:[39]\\d\\d|820)\\d{4}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}",
                        ,
                        ,
                        ,
                        "3201234"
                    ],
                    [
                        ,
                        ,
                        "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}",
                        ,
                        ,
                        ,
                        "3501234"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "FM",
                    691,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1 $2",
                            [
                                "[389]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                FO: [
                    ,
                    [
                        ,
                        ,
                        "[2-9]\\d{5}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:20|[34]\\d|8[19])\\d{4}",
                        ,
                        ,
                        ,
                        "201234"
                    ],
                    [
                        ,
                        ,
                        "(?:[27][1-9]|5\\d|9[16])\\d{4}",
                        ,
                        ,
                        ,
                        "211234"
                    ],
                    [
                        ,
                        ,
                        "80[257-9]\\d{3}",
                        ,
                        ,
                        ,
                        "802123"
                    ],
                    [
                        ,
                        ,
                        "90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d",
                        ,
                        ,
                        ,
                        "901123"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:6[0-36]|88)\\d{4}",
                        ,
                        ,
                        ,
                        "601234"
                    ],
                    "FO",
                    298,
                    "00",
                    ,
                    ,
                    ,
                    "(10(?:01|[12]0|88))",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{6})",
                            "$1",
                            [
                                "[2-9]"
                            ],
                            ,
                            "$CC $1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                FR: [
                    ,
                    [
                        ,
                        ,
                        "[1-9]\\d{8}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:26[013-9]|59[1-35-9])\\d{6}|(?:[13]\\d|2[0-57-9]|4[1-9]|5[0-8])\\d{7}",
                        ,
                        ,
                        ,
                        "123456789"
                    ],
                    [
                        ,
                        ,
                        "(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}",
                        ,
                        ,
                        ,
                        "612345678"
                    ],
                    [
                        ,
                        ,
                        "80[0-5]\\d{6}",
                        ,
                        ,
                        ,
                        "801234567"
                    ],
                    [
                        ,
                        ,
                        "836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}",
                        ,
                        ,
                        ,
                        "891123456"
                    ],
                    [
                        ,
                        ,
                        "8(?:1[01]|2[0156]|4[02]|84)\\d{6}",
                        ,
                        ,
                        ,
                        "884012345"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "9\\d{8}",
                        ,
                        ,
                        ,
                        "912345678"
                    ],
                    "FR",
                    33,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{4})",
                            "$1",
                            [
                                "10"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})",
                            "$1 $2",
                            [
                                "1"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "8"
                            ],
                            "0 $1"
                        ],
                        [
                            ,
                            "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4 $5",
                            [
                                "[1-79]"
                            ],
                            "0$1"
                        ]
                    ],
                    [
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "8"
                            ],
                            "0 $1"
                        ],
                        [
                            ,
                            "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4 $5",
                            [
                                "[1-79]"
                            ],
                            "0$1"
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "80[6-9]\\d{6}",
                        ,
                        ,
                        ,
                        "806123456"
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                GA: [
                    ,
                    [
                        ,
                        ,
                        "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "[01]1\\d{6}",
                        ,
                        ,
                        ,
                        "01441234",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:(?:0[2-7]|7[467])\\d|6(?:0[0-4]|10|[256]\\d))\\d{5}|[2-7]\\d{6}",
                        ,
                        ,
                        ,
                        "06031234"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "GA",
                    241,
                    "00",
                    ,
                    ,
                    ,
                    "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})",
                    "$1",
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d)(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[2-7]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "0"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "11|[67]"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                GB: [
                    ,
                    [
                        ,
                        ,
                        "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            9,
                            10
                        ],
                        [
                            4,
                            5,
                            6,
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
                        ,
                        ,
                        ,
                        "1212345678",
                        ,
                        ,
                        [
                            9,
                            10
                        ],
                        [
                            4,
                            5,
                            6,
                            7,
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
                        ,
                        ,
                        ,
                        "7400123456",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "80[08]\\d{7}|800\\d{6}|8001111",
                        ,
                        ,
                        ,
                        "8001234567"
                    ],
                    [
                        ,
                        ,
                        "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",
                        ,
                        ,
                        ,
                        "9012345678",
                        ,
                        ,
                        [
                            7,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "70\\d{8}",
                        ,
                        ,
                        ,
                        "7012345678",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "56\\d{8}",
                        ,
                        ,
                        ,
                        "5612345678",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    "GB",
                    44,
                    "00",
                    "0",
                    " x",
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1 $2",
                            [
                                "800",
                                "8001",
                                "80011",
                                "800111",
                                "8001111"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{2})",
                            "$1 $2 $3",
                            [
                                "845",
                                "8454",
                                "84546",
                                "845464"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{6})",
                            "$1 $2",
                            [
                                "800"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{5})(\\d{4,5})",
                            "$1 $2",
                            [
                                "1(?:38|5[23]|69|76|94)",
                                "1(?:(?:38|69)7|5(?:24|39)|768|946)",
                                "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{5,6})",
                            "$1 $2",
                            [
                                "1(?:[2-69][02-9]|[78])"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[25]|7(?:0|6[02-9])",
                                "[25]|7(?:0|6(?:[03-9]|2[356]))"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{6})",
                            "$1 $2",
                            [
                                "7"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[1389]"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                        ,
                        ,
                        ,
                        "7640123456",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    1,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:3[0347]|55)\\d{8}",
                        ,
                        ,
                        ,
                        "5512345678",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                GD: [
                    ,
                    [
                        ,
                        ,
                        "(?:473|[58]\\d\\d|900)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-4]|5[579]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}",
                        ,
                        ,
                        ,
                        "4732691234",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "473(?:4(?:0[2-79]|1[04-9]|2[0-5]|49|5[68])|5(?:2[01]|3[3-8])|901)\\d{4}",
                        ,
                        ,
                        ,
                        "4734031234",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "8002123456"
                    ],
                    [
                        ,
                        ,
                        "900[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "9002123456"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "5002345678"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "GD",
                    1,
                    "011",
                    "1",
                    ,
                    ,
                    "([2-9]\\d{6})$|1",
                    "473$1",
                    ,
                    ,
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    "473",
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                GE: [
                    ,
                    [
                        ,
                        ,
                        "(?:[3-57]\\d\\d|800)\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9
                        ],
                        [
                            6,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}",
                        ,
                        ,
                        ,
                        "322123456",
                        ,
                        ,
                        ,
                        [
                            6,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "5(?:(?:(?:0555|1(?:[17]77|555))[5-9]|757(?:7[7-9]|8[01]))\\d|22252[0-4])\\d\\d|(?:5(?:0(?:0(?:0\\d|11|22|3[0-6]|44|5[05]|77|88|9[09])|111|22[02]|77\\d)|1(?:1(?:[03][01]|[124]\\d)|4\\d\\d)|[23]555|4(?:4\\d\\d|555)|5(?:[0157-9]\\d\\d|200)|6[89]\\d\\d|7(?:[0147-9]\\d\\d|5(?:00|[57]5))|8(?:0(?:[018]\\d|2[0-4])|5(?:55|8[89])|8(?:55|88))|9(?:090|[1-35-9]\\d\\d))|790\\d\\d)\\d{4}|5(?:0(?:0[17]0|505)|1(?:0[01]0|1(?:07|33|51))|2(?:0[02]0|2[25]2)|3(?:0[03]0|3[35]3)|(?:40[04]|900)0|5222)[0-4]\\d{3}",
                        ,
                        ,
                        ,
                        "555123456"
                    ],
                    [
                        ,
                        ,
                        "800\\d{6}",
                        ,
                        ,
                        ,
                        "800123456"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "70[67]\\d{6}",
                        ,
                        ,
                        ,
                        "706123456"
                    ],
                    "GE",
                    995,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "70"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "32"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[57]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[348]"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "70[67]\\d{6}"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                GF: [
                    ,
                    [
                        ,
                        ,
                        "[56]94\\d{6}|(?:80|9\\d)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "594(?:[02-49]\\d|1[0-5]|5[6-9]|6[0-3]|80)\\d{4}",
                        ,
                        ,
                        ,
                        "594101234"
                    ],
                    [
                        ,
                        ,
                        "694(?:[0-249]\\d|3[0-8])\\d{4}",
                        ,
                        ,
                        ,
                        "694201234"
                    ],
                    [
                        ,
                        ,
                        "80[0-5]\\d{6}",
                        ,
                        ,
                        ,
                        "800012345"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "9(?:(?:396|76\\d)\\d|476[0-5])\\d{4}",
                        ,
                        ,
                        ,
                        "976012345"
                    ],
                    "GF",
                    594,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[56]|9[47]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[89]"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                GG: [
                    ,
                    [
                        ,
                        ,
                        "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            9,
                            10
                        ],
                        [
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "1481[25-9]\\d{5}",
                        ,
                        ,
                        ,
                        "1481256789",
                        ,
                        ,
                        [
                            10
                        ],
                        [
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "7(?:(?:781|839)\\d|911[17])\\d{5}",
                        ,
                        ,
                        ,
                        "7781123456",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "80[08]\\d{7}|800\\d{6}|8001111",
                        ,
                        ,
                        ,
                        "8001234567"
                    ],
                    [
                        ,
                        ,
                        "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",
                        ,
                        ,
                        ,
                        "9012345678",
                        ,
                        ,
                        [
                            7,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "70\\d{8}",
                        ,
                        ,
                        ,
                        "7012345678",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "56\\d{8}",
                        ,
                        ,
                        ,
                        "5612345678",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    "GG",
                    44,
                    "00",
                    "0",
                    ,
                    ,
                    "([25-9]\\d{5})$|0",
                    "1481$1",
                    ,
                    ,
                    ,
                    ,
                    [
                        ,
                        ,
                        "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                        ,
                        ,
                        ,
                        "7640123456",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:3[0347]|55)\\d{8}",
                        ,
                        ,
                        ,
                        "5512345678",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                GH: [
                    ,
                    [
                        ,
                        ,
                        "(?:[235]\\d{3}|800)\\d{5}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8,
                            9
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}",
                        ,
                        ,
                        ,
                        "302345678",
                        ,
                        ,
                        [
                            9
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:2(?:[0346-9]\\d|5[67])|5(?:[03-7]\\d|9[1-9]))\\d{6}",
                        ,
                        ,
                        ,
                        "231234567",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "800\\d{5}",
                        ,
                        ,
                        ,
                        "80012345",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "GH",
                    233,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1 $2",
                            [
                                "[237]|8[0-2]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{5})",
                            "$1 $2",
                            [
                                "8"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[235]"
                            ],
                            "0$1"
                        ]
                    ],
                    [
                        [
                            ,
                            "(\\d{3})(\\d{5})",
                            "$1 $2",
                            [
                                "8"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[235]"
                            ],
                            "0$1"
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "800\\d{5}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                GI: [
                    ,
                    [
                        ,
                        ,
                        "(?:[25]\\d|60)\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "2190[0-2]\\d{3}|2(?:0(?:[02]\\d|3[01])|16[24-9]|2[2-5]\\d)\\d{4}",
                        ,
                        ,
                        ,
                        "20012345"
                    ],
                    [
                        ,
                        ,
                        "5251[0-4]\\d{3}|(?:5(?:[146-8]\\d\\d|250)|60(?:1[01]|6\\d))\\d{4}",
                        ,
                        ,
                        ,
                        "57123456"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "GI",
                    350,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{5})",
                            "$1 $2",
                            [
                                "2"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                GL: [
                    ,
                    [
                        ,
                        ,
                        "(?:19|[2-689]\\d|70)\\d{4}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:19|3[1-7]|[68][1-9]|70|9\\d)\\d{4}",
                        ,
                        ,
                        ,
                        "321000"
                    ],
                    [
                        ,
                        ,
                        "[245]\\d{5}",
                        ,
                        ,
                        ,
                        "221234"
                    ],
                    [
                        ,
                        ,
                        "80\\d{4}",
                        ,
                        ,
                        ,
                        "801234"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "3[89]\\d{4}",
                        ,
                        ,
                        ,
                        "381234"
                    ],
                    "GL",
                    299,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3",
                            [
                                "19|[2-9]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                GM: [
                    ,
                    [
                        ,
                        ,
                        "[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}",
                        ,
                        ,
                        ,
                        "5661234"
                    ],
                    [
                        ,
                        ,
                        "(?:[23679]\\d|5[0-489])\\d{5}",
                        ,
                        ,
                        ,
                        "3012345"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "GM",
                    220,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1 $2",
                            [
                                "[2-9]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                GN: [
                    ,
                    [
                        ,
                        ,
                        "722\\d{6}|(?:3|6\\d)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}",
                        ,
                        ,
                        ,
                        "30241234",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "6[0-356]\\d{7}",
                        ,
                        ,
                        ,
                        "601123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "722\\d{6}",
                        ,
                        ,
                        ,
                        "722123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    "GN",
                    224,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "3"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[67]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                GP: [
                    ,
                    [
                        ,
                        ,
                        "590\\d{6}|(?:69|80|9\\d)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}",
                        ,
                        ,
                        ,
                        "590201234"
                    ],
                    [
                        ,
                        ,
                        "69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}",
                        ,
                        ,
                        ,
                        "690001234"
                    ],
                    [
                        ,
                        ,
                        "80[0-5]\\d{6}",
                        ,
                        ,
                        ,
                        "800012345"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}",
                        ,
                        ,
                        ,
                        "976012345"
                    ],
                    "GP",
                    590,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[569]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "8"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    1,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                GQ: [
                    ,
                    [
                        ,
                        ,
                        "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}",
                        ,
                        ,
                        ,
                        "333091234"
                    ],
                    [
                        ,
                        ,
                        "(?:222|55\\d)\\d{6}",
                        ,
                        ,
                        ,
                        "222123456"
                    ],
                    [
                        ,
                        ,
                        "80\\d[1-9]\\d{5}",
                        ,
                        ,
                        ,
                        "800123456"
                    ],
                    [
                        ,
                        ,
                        "90\\d[1-9]\\d{5}",
                        ,
                        ,
                        ,
                        "900123456"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "GQ",
                    240,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[235]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{6})",
                            "$1 $2",
                            [
                                "[89]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                GR: [
                    ,
                    [
                        ,
                        ,
                        "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10,
                            11,
                            12
                        ]
                    ],
                    [
                        ,
                        ,
                        "2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}",
                        ,
                        ,
                        ,
                        "2123456789",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "68[57-9]\\d{7}|(?:69|94)\\d{8}",
                        ,
                        ,
                        ,
                        "6912345678",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "800\\d{7,9}",
                        ,
                        ,
                        ,
                        "8001234567"
                    ],
                    [
                        ,
                        ,
                        "90[19]\\d{7}",
                        ,
                        ,
                        ,
                        "9091234567",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "8(?:0[16]|12|[27]5|50)\\d{7}",
                        ,
                        ,
                        ,
                        "8011234567",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "70\\d{8}",
                        ,
                        ,
                        ,
                        "7012345678",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "GR",
                    30,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "21|7"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{6})",
                            "$1 $2",
                            [
                                "2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[2689]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3,4})(\\d{5})",
                            "$1 $2 $3",
                            [
                                "8"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "5005000\\d{3}",
                        ,
                        ,
                        ,
                        "5005000123",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                GT: [
                    ,
                    [
                        ,
                        ,
                        "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8,
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        "[267][2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "22456789",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:[3-5]\\d\\d|80[0-4])\\d{5}",
                        ,
                        ,
                        ,
                        "51234567",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "18[01]\\d{8}",
                        ,
                        ,
                        ,
                        "18001112222",
                        ,
                        ,
                        [
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        "19\\d{9}",
                        ,
                        ,
                        ,
                        "19001112222",
                        ,
                        ,
                        [
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "GT",
                    502,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{4})(\\d{4})",
                            "$1 $2",
                            [
                                "[2-8]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "1"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                GU: [
                    ,
                    [
                        ,
                        ,
                        "(?:[58]\\d\\d|671|900)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-46-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}",
                        ,
                        ,
                        ,
                        "6713001234",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-46-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}",
                        ,
                        ,
                        ,
                        "6713001234",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "8002123456"
                    ],
                    [
                        ,
                        ,
                        "900[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "9002123456"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "5002345678"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "GU",
                    1,
                    "011",
                    "1",
                    ,
                    ,
                    "([2-9]\\d{6})$|1",
                    "671$1",
                    ,
                    1,
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    "671",
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                GW: [
                    ,
                    [
                        ,
                        ,
                        "[49]\\d{8}|4\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "443\\d{6}",
                        ,
                        ,
                        ,
                        "443201234",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "9(?:5\\d|6[569]|77)\\d{6}",
                        ,
                        ,
                        ,
                        "955012345",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "40\\d{5}",
                        ,
                        ,
                        ,
                        "4012345",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    "GW",
                    245,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1 $2",
                            [
                                "40"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[49]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                GY: [
                    ,
                    [
                        ,
                        ,
                        "(?:[2-8]\\d{3}|9008)\\d{3}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|50[0-6]|77[1-57])\\d{4}",
                        ,
                        ,
                        ,
                        "2201234"
                    ],
                    [
                        ,
                        ,
                        "510\\d{4}|(?:6\\d|7[0-5])\\d{5}",
                        ,
                        ,
                        ,
                        "6091234"
                    ],
                    [
                        ,
                        ,
                        "(?:289|8(?:00|6[28]|88|99))\\d{4}",
                        ,
                        ,
                        ,
                        "2891234"
                    ],
                    [
                        ,
                        ,
                        "9008\\d{3}",
                        ,
                        ,
                        ,
                        "9008123"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "515\\d{4}",
                        ,
                        ,
                        ,
                        "5151234"
                    ],
                    "GY",
                    592,
                    "001",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1 $2",
                            [
                                "[2-9]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                HK: [
                    ,
                    [
                        ,
                        ,
                        "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            5,
                            6,
                            7,
                            8,
                            9,
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:2(?:[13-9]\\d|2[013-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:4[0-8]|[59]\\d|6[0-2]))|58(?:0[1-9]|1[2-9]))\\d{4}",
                        ,
                        ,
                        ,
                        "21234567",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:4(?:44[0-25-9]|6(?:1[0-7]|4[0-57-9]|6[0-4]))|5(?:73[0-6]|95[0-8])|6(?:26[013-8]|66[0-3])|70(?:7[1-8]|8[0-4])|848[0-35-9]|9(?:29[013-9]|39[01]|59[0-4]|899))\\d{4}|(?:4(?:4[0-35-8]|6[02357-9]|70)|5(?:[1-59][0-46-9]|6[0-4689]|7[0-246-9])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|70[1-39]|84[0-29]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}",
                        ,
                        ,
                        ,
                        "51234567",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "800\\d{6}",
                        ,
                        ,
                        ,
                        "800123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "900(?:[0-24-9]\\d{7}|3\\d{1,4})",
                        ,
                        ,
                        ,
                        "90012345678",
                        ,
                        ,
                        [
                            5,
                            6,
                            7,
                            8,
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}",
                        ,
                        ,
                        ,
                        "81123456",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "HK",
                    852,
                    "00(?:30|5[09]|[126-9]?)",
                    ,
                    ,
                    ,
                    ,
                    ,
                    "00",
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{2,5})",
                            "$1 $2",
                            [
                                "900",
                                "9003"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{4})",
                            "$1 $2",
                            [
                                "[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "8"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
                            "$1 $2 $3 $4",
                            [
                                "9"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        "7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}",
                        ,
                        ,
                        ,
                        "71123456",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}",
                        ,
                        ,
                        ,
                        "30161234",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                HN: [
                    ,
                    [
                        ,
                        ,
                        "8\\d{10}|[237-9]\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8,
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        "2(?:2(?:0[0-59]|1[1-9]|[23]\\d|4[02-6]|5[57]|6[245]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[578]|2[3-59]|3[13-9]|4[0-68]|5[1-3589])|5(?:0[2357-9]|1[1-356]|4[03-5]|5\\d|6[014-69]|7[04]|80)|6(?:[056]\\d|17|2[067]|3[047]|4[0-378]|[78][0-8]|9[01])|7(?:0[5-79]|6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}",
                        ,
                        ,
                        ,
                        "22123456",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "[37-9]\\d{7}",
                        ,
                        ,
                        ,
                        "91234567",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "8002\\d{7}",
                        ,
                        ,
                        ,
                        "80021234567",
                        ,
                        ,
                        [
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "HN",
                    504,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{4})(\\d{4})",
                            "$1-$2",
                            [
                                "[237-9]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "8"
                            ]
                        ]
                    ],
                    [
                        [
                            ,
                            "(\\d{4})(\\d{4})",
                            "$1-$2",
                            [
                                "[237-9]"
                            ]
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "8002\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                HR: [
                    ,
                    [
                        ,
                        ,
                        "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            6,
                            7,
                            8,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}",
                        ,
                        ,
                        ,
                        "12345678",
                        ,
                        ,
                        [
                            8,
                            9
                        ],
                        [
                            6,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "9(?:(?:0[1-9]|[12589]\\d)\\d\\d|7(?:[0679]\\d\\d|5(?:[01]\\d|44|55|77|9[5-7])))\\d{4}|98\\d{6}",
                        ,
                        ,
                        ,
                        "921234567",
                        ,
                        ,
                        [
                            8,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "80\\d{5,7}",
                        ,
                        ,
                        ,
                        "800123456",
                        ,
                        ,
                        [
                            7,
                            8,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "6[01459]\\d{6}|6[01]\\d{4,5}",
                        ,
                        ,
                        ,
                        "611234",
                        ,
                        ,
                        [
                            6,
                            7,
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "7[45]\\d{6}",
                        ,
                        ,
                        ,
                        "74123456",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "HR",
                    385,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2,3})",
                            "$1 $2 $3",
                            [
                                "6[01]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{2,3})",
                            "$1 $2 $3",
                            [
                                "8"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d)(\\d{4})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "1"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "6|7[245]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "9"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "[2-57]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "8"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "62\\d{6,7}|72\\d{6}",
                        ,
                        ,
                        ,
                        "62123456",
                        ,
                        ,
                        [
                            8,
                            9
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                HT: [
                    ,
                    [
                        ,
                        ,
                        "(?:[2-489]\\d|55)\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "2(?:2\\d|5[1-5]|81|9[149])\\d{5}",
                        ,
                        ,
                        ,
                        "22453300"
                    ],
                    [
                        ,
                        ,
                        "(?:[34]\\d|55)\\d{6}",
                        ,
                        ,
                        ,
                        "34101234"
                    ],
                    [
                        ,
                        ,
                        "8\\d{7}",
                        ,
                        ,
                        ,
                        "80012345"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}",
                        ,
                        ,
                        ,
                        "98901234"
                    ],
                    "HT",
                    509,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[2-589]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                HU: [
                    ,
                    [
                        ,
                        ,
                        "[235-7]\\d{8}|[1-9]\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8,
                            9
                        ],
                        [
                            6,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}",
                        ,
                        ,
                        ,
                        "12345678",
                        ,
                        ,
                        [
                            8
                        ],
                        [
                            6,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:[257]0|3[01])\\d{7}",
                        ,
                        ,
                        ,
                        "201234567",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:[48]0\\d|680[29])\\d{5}",
                        ,
                        ,
                        ,
                        "80123456"
                    ],
                    [
                        ,
                        ,
                        "9[01]\\d{6}",
                        ,
                        ,
                        ,
                        "90123456",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "21\\d{7}",
                        ,
                        ,
                        ,
                        "211234567",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    "HU",
                    36,
                    "00",
                    "06",
                    ,
                    ,
                    "06",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "1"
                            ],
                            "(06 $1)"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"
                            ],
                            "(06 $1)"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "[2-9]"
                            ],
                            "06 $1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "(?:[48]0\\d|680[29])\\d{5}"
                    ],
                    [
                        ,
                        ,
                        "38\\d{7}",
                        ,
                        ,
                        ,
                        "381234567",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                ID: [
                    ,
                    [
                        ,
                        ,
                        "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            8,
                            9,
                            10,
                            11,
                            12,
                            13
                        ],
                        [
                            5,
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}",
                        ,
                        ,
                        ,
                        "218350123",
                        ,
                        ,
                        [
                            7,
                            8,
                            9,
                            10,
                            11
                        ],
                        [
                            5,
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "8[1-35-9]\\d{7,10}",
                        ,
                        ,
                        ,
                        "812345678",
                        ,
                        ,
                        [
                            9,
                            10,
                            11,
                            12
                        ]
                    ],
                    [
                        ,
                        ,
                        "00[17]803\\d{7}|(?:177\\d|800)\\d{5,7}|001803\\d{6}",
                        ,
                        ,
                        ,
                        "8001234567",
                        ,
                        ,
                        [
                            8,
                            9,
                            10,
                            11,
                            12,
                            13
                        ]
                    ],
                    [
                        ,
                        ,
                        "809\\d{7}",
                        ,
                        ,
                        ,
                        "8091234567",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "804\\d{7}",
                        ,
                        ,
                        ,
                        "8041234567",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "ID",
                    62,
                    "00[89]",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "15"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{5,9})",
                            "$1 $2",
                            [
                                "2[124]|[36]1"
                            ],
                            "(0$1)"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{5,7})",
                            "$1 $2",
                            [
                                "800"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{5,8})",
                            "$1 $2",
                            [
                                "[2-79]"
                            ],
                            "(0$1)"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3,4})(\\d{3})",
                            "$1-$2-$3",
                            [
                                "8[1-35-9]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{6,8})",
                            "$1 $2",
                            [
                                "1"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "804"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                            "$1 $2 $3 $4",
                            [
                                "80"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{4})(\\d{4,5})",
                            "$1-$2-$3",
                            [
                                "8"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3 $4",
                            [
                                "001"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{4})(\\d{3})(\\d{4})",
                            "$1 $2 $3 $4",
                            [
                                "0"
                            ]
                        ]
                    ],
                    [
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "15"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{5,9})",
                            "$1 $2",
                            [
                                "2[124]|[36]1"
                            ],
                            "(0$1)"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{5,7})",
                            "$1 $2",
                            [
                                "800"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{5,8})",
                            "$1 $2",
                            [
                                "[2-79]"
                            ],
                            "(0$1)"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3,4})(\\d{3})",
                            "$1-$2-$3",
                            [
                                "8[1-35-9]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{6,8})",
                            "$1 $2",
                            [
                                "1"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "804"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                            "$1 $2 $3 $4",
                            [
                                "80"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{4})(\\d{4,5})",
                            "$1-$2-$3",
                            [
                                "8"
                            ],
                            "0$1"
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "001803\\d{6,7}|(?:007803\\d|8071)\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10,
                            12,
                            13
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:1500|8071\\d{3})\\d{3}",
                        ,
                        ,
                        ,
                        "8071123456",
                        ,
                        ,
                        [
                            7,
                            10
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                IE: [
                    ,
                    [
                        ,
                        ,
                        "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            8,
                            9,
                            10
                        ],
                        [
                            5,
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}",
                        ,
                        ,
                        ,
                        "2212345",
                        ,
                        ,
                        ,
                        [
                            5,
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "8(?:22|[35-9]\\d)\\d{6}",
                        ,
                        ,
                        ,
                        "850123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "1800\\d{6}",
                        ,
                        ,
                        ,
                        "1800123456",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "15(?:1[2-8]|[2-8]0|9[089])\\d{6}",
                        ,
                        ,
                        ,
                        "1520123456",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "18[59]0\\d{6}",
                        ,
                        ,
                        ,
                        "1850123456",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "700\\d{6}",
                        ,
                        ,
                        ,
                        "700123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "76\\d{7}",
                        ,
                        ,
                        ,
                        "761234567",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    "IE",
                    353,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{5})",
                            "$1 $2",
                            [
                                "2[24-9]|47|58|6[237-9]|9[35-9]"
                            ],
                            "(0$1)"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{5})",
                            "$1 $2",
                            [
                                "[45]0"
                            ],
                            "(0$1)"
                        ],
                        [
                            ,
                            "(\\d)(\\d{3,4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "1"
                            ],
                            "(0$1)"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "[2569]|4[1-69]|7[14]"
                            ],
                            "(0$1)"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "70"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "81"
                            ],
                            "(0$1)"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[78]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "1"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "4"
                            ],
                            "(0$1)"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d)(\\d{3})(\\d{4})",
                            "$1 $2 $3 $4",
                            [
                                "8"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "18[59]0\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "818\\d{6}",
                        ,
                        ,
                        ,
                        "818123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "88210[1-9]\\d{4}|8(?:[35-79]5\\d\\d|8(?:[013-9]\\d\\d|2(?:[01][1-9]|[2-9]\\d)))\\d{5}",
                        ,
                        ,
                        ,
                        "8551234567",
                        ,
                        ,
                        [
                            10
                        ]
                    ]
                ],
                IL: [
                    ,
                    [
                        ,
                        ,
                        "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            8,
                            9,
                            10,
                            11,
                            12
                        ]
                    ],
                    [
                        ,
                        ,
                        "153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}",
                        ,
                        ,
                        ,
                        "21234567",
                        ,
                        ,
                        [
                            8,
                            11,
                            12
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "55(?:410|57[0-289])\\d{4}|5(?:(?:[02][02-9]|[149][2-9]|[36]\\d|8[3-7])\\d|5(?:01|2\\d|3[0-3]|4[34]|5[0-25689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}",
                        ,
                        ,
                        ,
                        "502345678",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "1(?:255|80[019]\\d{3})\\d{3}",
                        ,
                        ,
                        ,
                        "1800123456",
                        ,
                        ,
                        [
                            7,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "1212\\d{4}|1(?:200|9(?:0[0-2]|19))\\d{6}",
                        ,
                        ,
                        ,
                        "1919123456",
                        ,
                        ,
                        [
                            8,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "1700\\d{6}",
                        ,
                        ,
                        ,
                        "1700123456",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "7(?:38(?:0\\d|5[0-259]|88)|8(?:33|55|77|81)\\d)\\d{4}|7(?:18|2[23]|3[237]|47|6[258]|7\\d|82|9[2-9])\\d{6}",
                        ,
                        ,
                        ,
                        "771234567",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    "IL",
                    972,
                    "0(?:0|1[2-9])",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{4})(\\d{3})",
                            "$1-$2",
                            [
                                "125"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{2})(\\d{2})",
                            "$1-$2-$3",
                            [
                                "121"
                            ]
                        ],
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{4})",
                            "$1-$2-$3",
                            [
                                "[2-489]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1-$2-$3",
                            [
                                "[57]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{3})(\\d{3})",
                            "$1-$2-$3",
                            [
                                "12"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{6})",
                            "$1-$2",
                            [
                                "159"
                            ]
                        ],
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                            "$1-$2-$3-$4",
                            [
                                "1[7-9]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})",
                            "$1-$2 $3-$4",
                            [
                                "15"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "1700\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "1599\\d{6}",
                        ,
                        ,
                        ,
                        "1599123456",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "151\\d{8,9}",
                        ,
                        ,
                        ,
                        "15112340000",
                        ,
                        ,
                        [
                            11,
                            12
                        ]
                    ]
                ],
                IM: [
                    ,
                    [
                        ,
                        ,
                        "1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10
                        ],
                        [
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "1624(?:230|[5-8]\\d\\d)\\d{3}",
                        ,
                        ,
                        ,
                        "1624756789",
                        ,
                        ,
                        ,
                        [
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}",
                        ,
                        ,
                        ,
                        "7924123456"
                    ],
                    [
                        ,
                        ,
                        "808162\\d{4}",
                        ,
                        ,
                        ,
                        "8081624567"
                    ],
                    [
                        ,
                        ,
                        "8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}",
                        ,
                        ,
                        ,
                        "9016247890"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "70\\d{8}",
                        ,
                        ,
                        ,
                        "7012345678"
                    ],
                    [
                        ,
                        ,
                        "56\\d{8}",
                        ,
                        ,
                        ,
                        "5612345678"
                    ],
                    "IM",
                    44,
                    "00",
                    "0",
                    ,
                    ,
                    "([25-8]\\d{5})$|0",
                    "1624$1",
                    ,
                    ,
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    "74576|(?:16|7[56])24",
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}",
                        ,
                        ,
                        ,
                        "5512345678"
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                IN: [
                    ,
                    [
                        ,
                        ,
                        "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8,
                            9,
                            10,
                            11,
                            12,
                            13
                        ],
                        [
                            6,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "2717(?:[2-7]\\d|95)\\d{4}|(?:271[0-689]|782[0-6])[2-7]\\d{5}|(?:170[24]|2(?:(?:[02][2-79]|90)\\d|80[13468])|(?:3(?:23|80)|683|79[1-7])\\d|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}",
                        ,
                        ,
                        ,
                        "7410410123",
                        ,
                        ,
                        [
                            10
                        ],
                        [
                            6,
                            7,
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}",
                        ,
                        ,
                        ,
                        "8123456789",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "000800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))",
                        ,
                        ,
                        ,
                        "1800123456"
                    ],
                    [
                        ,
                        ,
                        "186[12]\\d{9}",
                        ,
                        ,
                        ,
                        "1861123456789",
                        ,
                        ,
                        [
                            13
                        ]
                    ],
                    [
                        ,
                        ,
                        "1860\\d{7}",
                        ,
                        ,
                        ,
                        "18603451234",
                        ,
                        ,
                        [
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "IN",
                    91,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{7})",
                            "$1",
                            [
                                "575"
                            ]
                        ],
                        [
                            ,
                            "(\\d{8})",
                            "$1",
                            [
                                "5(?:0|2[23]|3[03]|[67]1|88)",
                                "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                                "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                            ],
                            ,
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{4,5})",
                            "$1 $2",
                            [
                                "180",
                                "1800"
                            ],
                            ,
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "140"
                            ],
                            ,
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                                "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                                "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                            ],
                            "0$1",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                                "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                                "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                            ],
                            "0$1",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                                "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                                "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                            ],
                            "0$1",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{5})(\\d{5})",
                            "$1 $2",
                            [
                                "[6-9]"
                            ],
                            "0$1",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{2,4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "1(?:6|8[06])",
                                "1(?:6|8[06]0)"
                            ],
                            ,
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})(\\d{4})",
                            "$1 $2 $3 $4",
                            [
                                "0"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3 $4",
                            [
                                "18"
                            ],
                            ,
                            ,
                            1
                        ]
                    ],
                    [
                        [
                            ,
                            "(\\d{8})",
                            "$1",
                            [
                                "5(?:0|2[23]|3[03]|[67]1|88)",
                                "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                                "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                            ],
                            ,
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{4,5})",
                            "$1 $2",
                            [
                                "180",
                                "1800"
                            ],
                            ,
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "140"
                            ],
                            ,
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                                "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                                "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                            ],
                            "0$1",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                                "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                                "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                            ],
                            "0$1",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                                "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                                "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                            ],
                            "0$1",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{5})(\\d{5})",
                            "$1 $2",
                            [
                                "[6-9]"
                            ],
                            "0$1",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{2,4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "1(?:6|8[06])",
                                "1(?:6|8[06]0)"
                            ],
                            ,
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3 $4",
                            [
                                "18"
                            ],
                            ,
                            ,
                            1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "1(?:600\\d{6}|800\\d{4,9})|(?:000800|18(?:03\\d\\d|6(?:0|[12]\\d\\d)))\\d{7}"
                    ],
                    [
                        ,
                        ,
                        "140\\d{7}",
                        ,
                        ,
                        ,
                        "1409305260",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                IO: [
                    ,
                    [
                        ,
                        ,
                        "3\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "37\\d{5}",
                        ,
                        ,
                        ,
                        "3709100"
                    ],
                    [
                        ,
                        ,
                        "38\\d{5}",
                        ,
                        ,
                        ,
                        "3801234"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "IO",
                    246,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1 $2",
                            [
                                "3"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                IQ: [
                    ,
                    [
                        ,
                        ,
                        "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8,
                            9,
                            10
                        ],
                        [
                            6,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}",
                        ,
                        ,
                        ,
                        "12345678",
                        ,
                        ,
                        [
                            8,
                            9
                        ],
                        [
                            6,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "7[3-9]\\d{8}",
                        ,
                        ,
                        ,
                        "7912345678",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "IQ",
                    964,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "1"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "[2-6]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "7"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                IR: [
                    ,
                    [
                        ,
                        ,
                        "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            4,
                            5,
                            6,
                            7,
                            10
                        ],
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|(?:12\\d|30[0-2])\\d|2(?:121|[2689]0\\d)|4(?:111|40\\d))\\d{4}",
                        ,
                        ,
                        ,
                        "2123456789",
                        ,
                        ,
                        [
                            6,
                            7,
                            10
                        ],
                        [
                            4,
                            5,
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "9(?:(?:0(?:[0-35]\\d|4[4-6])|(?:[13]\\d|2[0-3])\\d)\\d|9(?:[0-46]\\d\\d|5[15]0|8(?:[12]\\d|88)|9(?:0[0-3]|[19]\\d|21|69|77|8[7-9])))\\d{5}",
                        ,
                        ,
                        ,
                        "9123456789",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "IR",
                    98,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{4,5})",
                            "$1",
                            [
                                "96"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{4,5})",
                            "$1 $2",
                            [
                                "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "9"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[1-8]"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "9(?:4440\\d{5}|6(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19]))",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            4,
                            5,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])",
                        ,
                        ,
                        ,
                        "9601",
                        ,
                        ,
                        [
                            4,
                            5
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                IS: [
                    ,
                    [
                        ,
                        ,
                        "(?:38\\d|[4-9])\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-24589]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}",
                        ,
                        ,
                        ,
                        "4101234",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[026-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[238]))\\d{4}",
                        ,
                        ,
                        ,
                        "6111234"
                    ],
                    [
                        ,
                        ,
                        "80[0-8]\\d{4}",
                        ,
                        ,
                        ,
                        "8001234",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}",
                        ,
                        ,
                        ,
                        "9001234",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "49[0-24-79]\\d{4}",
                        ,
                        ,
                        ,
                        "4921234",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    "IS",
                    354,
                    "00|1(?:0(?:01|[12]0)|100)",
                    ,
                    ,
                    ,
                    ,
                    ,
                    "00",
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1 $2",
                            [
                                "[4-9]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "3"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "809\\d{4}",
                        ,
                        ,
                        ,
                        "8091234",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "(?:689|8(?:7[18]|80)|95[48])\\d{4}",
                        ,
                        ,
                        ,
                        "6891234",
                        ,
                        ,
                        [
                            7
                        ]
                    ]
                ],
                IT: [
                    ,
                    [
                        ,
                        ,
                        "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            6,
                            7,
                            8,
                            9,
                            10,
                            11,
                            12
                        ]
                    ],
                    [
                        ,
                        ,
                        "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}",
                        ,
                        ,
                        ,
                        "0212345678",
                        ,
                        ,
                        [
                            6,
                            7,
                            8,
                            9,
                            10,
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        "3[2-9]\\d{7,8}|(?:31|43)\\d{8}",
                        ,
                        ,
                        ,
                        "3123456789",
                        ,
                        ,
                        [
                            9,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "80(?:0\\d{3}|3)\\d{3}",
                        ,
                        ,
                        ,
                        "800123456",
                        ,
                        ,
                        [
                            6,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",
                        ,
                        ,
                        ,
                        "899123456",
                        ,
                        ,
                        [
                            6,
                            8,
                            9,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "84(?:[08]\\d{3}|[17])\\d{3}",
                        ,
                        ,
                        ,
                        "848123456",
                        ,
                        ,
                        [
                            6,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "1(?:78\\d|99)\\d{6}",
                        ,
                        ,
                        ,
                        "1781234567",
                        ,
                        ,
                        [
                            9,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "55\\d{8}",
                        ,
                        ,
                        ,
                        "5512345678",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    "IT",
                    39,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{4,5})",
                            "$1",
                            [
                                "1(?:0|9[246])",
                                "1(?:0|9(?:2[2-9]|[46]))"
                            ]
                        ],
                        [
                            ,
                            "(\\d{6})",
                            "$1",
                            [
                                "1(?:1|92)"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{4,6})",
                            "$1 $2",
                            [
                                "0[26]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3,6})",
                            "$1 $2",
                            [
                                "0[13-57-9][0159]|8(?:03|4[17]|9[2-5])",
                                "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{2,6})",
                            "$1 $2",
                            [
                                "0(?:[13-579][2-46-8]|8[236-8])"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{4})",
                            "$1 $2",
                            [
                                "894"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3,4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "0[26]|5"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "1(?:44|[679])|[378]|43"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3,4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "0[13-57-9][0159]|14"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{4})(\\d{5})",
                            "$1 $2 $3",
                            [
                                "0[26]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "0"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{4})(\\d{4,5})",
                            "$1 $2 $3",
                            [
                                "3"
                            ]
                        ]
                    ],
                    [
                        [
                            ,
                            "(\\d{2})(\\d{4,6})",
                            "$1 $2",
                            [
                                "0[26]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3,6})",
                            "$1 $2",
                            [
                                "0[13-57-9][0159]|8(?:03|4[17]|9[2-5])",
                                "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{2,6})",
                            "$1 $2",
                            [
                                "0(?:[13-579][2-46-8]|8[236-8])"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{4})",
                            "$1 $2",
                            [
                                "894"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3,4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "0[26]|5"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "1(?:44|[679])|[378]|43"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3,4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "0[13-57-9][0159]|14"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{4})(\\d{5})",
                            "$1 $2 $3",
                            [
                                "0[26]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "0"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{4})(\\d{4,5})",
                            "$1 $2 $3",
                            [
                                "3"
                            ]
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    1,
                    ,
                    [
                        ,
                        ,
                        "848\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "3[2-8]\\d{9,10}",
                        ,
                        ,
                        ,
                        "33101234501",
                        ,
                        ,
                        [
                            11,
                            12
                        ]
                    ]
                ],
                JE: [
                    ,
                    [
                        ,
                        ,
                        "1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10
                        ],
                        [
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "1534[0-24-8]\\d{5}",
                        ,
                        ,
                        ,
                        "1534456789",
                        ,
                        ,
                        ,
                        [
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}",
                        ,
                        ,
                        ,
                        "7797712345"
                    ],
                    [
                        ,
                        ,
                        "80(?:07(?:35|81)|8901)\\d{4}",
                        ,
                        ,
                        ,
                        "8007354567"
                    ],
                    [
                        ,
                        ,
                        "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}",
                        ,
                        ,
                        ,
                        "9018105678"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "701511\\d{4}",
                        ,
                        ,
                        ,
                        "7015115678"
                    ],
                    [
                        ,
                        ,
                        "56\\d{8}",
                        ,
                        ,
                        ,
                        "5612345678"
                    ],
                    "JE",
                    44,
                    "00",
                    "0",
                    ,
                    ,
                    "([0-24-8]\\d{5})$|0",
                    "1534$1",
                    ,
                    ,
                    ,
                    ,
                    [
                        ,
                        ,
                        "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                        ,
                        ,
                        ,
                        "7640123456"
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}",
                        ,
                        ,
                        ,
                        "5512345678"
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                JM: [
                    ,
                    [
                        ,
                        ,
                        "(?:[58]\\d\\d|658|900)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "8766060\\d{3}|(?:658(?:2(?:[0-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:52[35]|6(?:0[1-3579]|1[0235-9]|[23]\\d|40|5[06]|6[2-589]|7[0-25-9]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}",
                        ,
                        ,
                        ,
                        "8765230123",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:658295|876(?:2(?:0[1-9]|[13-9]\\d|2[013-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}",
                        ,
                        ,
                        ,
                        "8762101234",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "8002123456"
                    ],
                    [
                        ,
                        ,
                        "900[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "9002123456"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "5002345678"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "JM",
                    1,
                    "011",
                    "1",
                    ,
                    ,
                    "1",
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    "658|876",
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                JO: [
                    ,
                    [
                        ,
                        ,
                        "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}",
                        ,
                        ,
                        ,
                        "62001234",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "7(?:[78][0-25-9]|9\\d)\\d{6}",
                        ,
                        ,
                        ,
                        "790123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "80\\d{6}",
                        ,
                        ,
                        ,
                        "80012345",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "9\\d{7}",
                        ,
                        ,
                        ,
                        "90012345",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "85\\d{6}",
                        ,
                        ,
                        ,
                        "85012345",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "70\\d{7}",
                        ,
                        ,
                        ,
                        "700123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "JO",
                    962,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[2356]|87"
                            ],
                            "(0$1)"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{5,6})",
                            "$1 $2",
                            [
                                "[89]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{7})",
                            "$1 $2",
                            [
                                "70"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d)(\\d{4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "7"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        "74(?:66|77)\\d{5}",
                        ,
                        ,
                        ,
                        "746612345",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "8(?:10|8\\d)\\d{5}",
                        ,
                        ,
                        ,
                        "88101234",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                JP: [
                    ,
                    [
                        ,
                        ,
                        "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8,
                            9,
                            10,
                            11,
                            12,
                            13,
                            14,
                            15,
                            16,
                            17
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}",
                        ,
                        ,
                        ,
                        "312345678",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "[7-9]0[1-9]\\d{7}",
                        ,
                        ,
                        ,
                        "9012345678",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "00777(?:[01]|5\\d)\\d\\d|(?:00(?:7778|882[1245])|(?:120|800\\d)\\d\\d)\\d{4}|00(?:37|66|78)\\d{6,13}",
                        ,
                        ,
                        ,
                        "120123456"
                    ],
                    [
                        ,
                        ,
                        "990\\d{6}",
                        ,
                        ,
                        ,
                        "990123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "60\\d{7}",
                        ,
                        ,
                        ,
                        "601234567",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "50[1-9]\\d{7}",
                        ,
                        ,
                        ,
                        "5012345678",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    "JP",
                    81,
                    "010",
                    "0",
                    ,
                    ,
                    "(000[259]\\d{6})$|(?:(?:003768)0?)|0",
                    "$1",
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{4})(\\d{4})",
                            "$1-$2",
                            [
                                "007",
                                "0077",
                                "00777",
                                "00777[01]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1-$2-$3",
                            [
                                "(?:12|57|99)0"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{4})(\\d)(\\d{4})",
                            "$1-$2-$3",
                            [
                                "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])",
                                "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
                                "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1-$2-$3",
                            [
                                "60"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d)(\\d{4})(\\d{4})",
                            "$1-$2-$3",
                            [
                                "[36]|4(?:2[09]|7[01])",
                                "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1-$2-$3",
                            [
                                "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                                "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                                "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{4})",
                            "$1-$2-$3",
                            [
                                "[14]|[289][2-9]|5[3-9]|7[2-4679]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{2})(\\d{3,4})",
                            "$1-$2-$3",
                            [
                                "007",
                                "0077"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{2})(\\d{4})",
                            "$1-$2-$3",
                            [
                                "008"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "$1-$2-$3",
                            [
                                "800"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{4})(\\d{4})",
                            "$1-$2-$3",
                            [
                                "[257-9]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{3})(\\d{3,4})",
                            "$1-$2-$3",
                            [
                                "0"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{4})(\\d{4,5})",
                            "$1-$2-$3",
                            [
                                "0"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{5})(\\d{5,6})",
                            "$1-$2-$3",
                            [
                                "0"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{6})(\\d{6,7})",
                            "$1-$2-$3",
                            [
                                "0"
                            ]
                        ]
                    ],
                    [
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1-$2-$3",
                            [
                                "(?:12|57|99)0"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{4})(\\d)(\\d{4})",
                            "$1-$2-$3",
                            [
                                "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])",
                                "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
                                "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1-$2-$3",
                            [
                                "60"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d)(\\d{4})(\\d{4})",
                            "$1-$2-$3",
                            [
                                "[36]|4(?:2[09]|7[01])",
                                "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1-$2-$3",
                            [
                                "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                                "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                                "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{4})",
                            "$1-$2-$3",
                            [
                                "[14]|[289][2-9]|5[3-9]|7[2-4679]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "$1-$2-$3",
                            [
                                "800"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{4})(\\d{4})",
                            "$1-$2-$3",
                            [
                                "[257-9]"
                            ],
                            "0$1"
                        ]
                    ],
                    [
                        ,
                        ,
                        "20\\d{8}",
                        ,
                        ,
                        ,
                        "2012345678",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "00(?:777(?:[01]|(?:5|8\\d)\\d)|882[1245]\\d\\d)\\d\\d|00(?:37|66|78)\\d{6,13}"
                    ],
                    [
                        ,
                        ,
                        "570\\d{6}",
                        ,
                        ,
                        ,
                        "570123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                KE: [
                    ,
                    [
                        ,
                        ,
                        "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            8,
                            9,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}",
                        ,
                        ,
                        ,
                        "202012345",
                        ,
                        ,
                        [
                            7,
                            8,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:1(?:0[0-8]|1[0-7]|2[014]|30)|7\\d\\d)\\d{6}",
                        ,
                        ,
                        ,
                        "712123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "800[02-8]\\d{5,6}",
                        ,
                        ,
                        ,
                        "800223456",
                        ,
                        ,
                        [
                            9,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "900[02-9]\\d{5}",
                        ,
                        ,
                        ,
                        "900223456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "KE",
                    254,
                    "000",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{5,7})",
                            "$1 $2",
                            [
                                "[24-6]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{6})",
                            "$1 $2",
                            [
                                "[17]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "[89]"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                KG: [
                    ,
                    [
                        ,
                        ,
                        "8\\d{9}|[235-9]\\d{8}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9,
                            10
                        ],
                        [
                            5,
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}",
                        ,
                        ,
                        ,
                        "312123456",
                        ,
                        ,
                        [
                            9
                        ],
                        [
                            5,
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|600|7(?:[07]\\d|55)|88[08]|9(?:12|9[05-9]))\\d{6}",
                        ,
                        ,
                        ,
                        "700123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "800\\d{6,7}",
                        ,
                        ,
                        ,
                        "800123456"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "KG",
                    996,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{4})(\\d{5})",
                            "$1 $2",
                            [
                                "3(?:1[346]|[24-79])"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[235-79]|88"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d)(\\d{2,3})",
                            "$1 $2 $3 $4",
                            [
                                "8"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                KH: [
                    ,
                    [
                        ,
                        ,
                        "1\\d{9}|[1-9]\\d{7,8}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8,
                            9,
                            10
                        ],
                        [
                            6,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})",
                        ,
                        ,
                        ,
                        "23756789",
                        ,
                        ,
                        [
                            8,
                            9
                        ],
                        [
                            6,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}",
                        ,
                        ,
                        ,
                        "91234567",
                        ,
                        ,
                        [
                            8,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "1800(?:1\\d|2[019])\\d{4}",
                        ,
                        ,
                        ,
                        "1800123456",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "1900(?:1\\d|2[09])\\d{4}",
                        ,
                        ,
                        ,
                        "1900123456",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "KH",
                    855,
                    "00[14-9]",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "[1-9]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "1"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                KI: [
                    ,
                    [
                        ,
                        ,
                        "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            5,
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}",
                        ,
                        ,
                        ,
                        "31234"
                    ],
                    [
                        ,
                        ,
                        "(?:6200[01]|7(?:310[1-9]|5(?:02[03-9]|12[0-47-9]|22[0-7]|[34](?:0[1-9]|8[02-9])|50[1-9])))\\d{3}|(?:63\\d\\d|7(?:(?:[0146-9]\\d|2[0-689])\\d|3(?:[02-9]\\d|1[1-9])|5(?:[0-2][013-9]|[34][1-79]|5[1-9]|[6-9]\\d)))\\d{4}",
                        ,
                        ,
                        ,
                        "72001234",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "30(?:0[01]\\d\\d|12(?:11|20))\\d\\d",
                        ,
                        ,
                        ,
                        "30010000",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    "KI",
                    686,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                KM: [
                    ,
                    [
                        ,
                        ,
                        "[3478]\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7
                        ],
                        [
                            4
                        ]
                    ],
                    [
                        ,
                        ,
                        "7[4-7]\\d{5}",
                        ,
                        ,
                        ,
                        "7712345",
                        ,
                        ,
                        ,
                        [
                            4
                        ]
                    ],
                    [
                        ,
                        ,
                        "[34]\\d{6}",
                        ,
                        ,
                        ,
                        "3212345"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "8\\d{6}",
                        ,
                        ,
                        ,
                        "8001234"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "KM",
                    269,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{2})",
                            "$1 $2 $3",
                            [
                                "[3478]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                KN: [
                    ,
                    [
                        ,
                        ,
                        "(?:[58]\\d\\d|900)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "869(?:2(?:29|36)|302|4(?:6[015-9]|70)|56[5-7])\\d{4}",
                        ,
                        ,
                        ,
                        "8692361234",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}",
                        ,
                        ,
                        ,
                        "8697652917",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "8002123456"
                    ],
                    [
                        ,
                        ,
                        "900[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "9002123456"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "5002345678"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "KN",
                    1,
                    "011",
                    "1",
                    ,
                    ,
                    "([2-7]\\d{6})$|1",
                    "869$1",
                    ,
                    ,
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    "869",
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                KP: [
                    ,
                    [
                        ,
                        ,
                        "85\\d{6}|(?:19\\d|[2-7])\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8,
                            10
                        ],
                        [
                            6,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}",
                        ,
                        ,
                        ,
                        "21234567",
                        ,
                        ,
                        ,
                        [
                            6,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "19[1-3]\\d{7}",
                        ,
                        ,
                        ,
                        "1921234567",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "KP",
                    850,
                    "00|99",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "8"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[2-7]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "1"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "238[02-9]\\d{4}|2(?:[0-24-9]\\d|3[0-79])\\d{5}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                KR: [
                    ,
                    [
                        ,
                        ,
                        "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            5,
                            6,
                            8,
                            9,
                            10,
                            11,
                            12,
                            13,
                            14
                        ],
                        [
                            3,
                            4,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}",
                        ,
                        ,
                        ,
                        "22123456",
                        ,
                        ,
                        [
                            5,
                            6,
                            8,
                            9,
                            10
                        ],
                        [
                            3,
                            4,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[0-46-9]|[16-9]\\d|2[013-9])\\d{6,7}",
                        ,
                        ,
                        ,
                        "1020000000",
                        ,
                        ,
                        [
                            9,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|[38]0)\\d{7}",
                        ,
                        ,
                        ,
                        "801234567",
                        ,
                        ,
                        [
                            9,
                            11,
                            12,
                            13,
                            14
                        ]
                    ],
                    [
                        ,
                        ,
                        "60[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "602345678",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "50\\d{8,9}",
                        ,
                        ,
                        ,
                        "5012345678",
                        ,
                        ,
                        [
                            10,
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        "70\\d{8}",
                        ,
                        ,
                        ,
                        "7012345678",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    "KR",
                    82,
                    "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
                    "0",
                    ,
                    ,
                    "0(8(?:[1-46-8]|5\\d\\d))?",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{5})",
                            "$1",
                            [
                                "1[016-9]1",
                                "1[016-9]11",
                                "1[016-9]114"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3,4})",
                            "$1-$2",
                            [
                                "(?:3[1-3]|[46][1-4]|5[1-5])1"
                            ],
                            "0$1",
                            "0$CC-$1"
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{4})",
                            "$1-$2",
                            [
                                "1"
                            ]
                        ],
                        [
                            ,
                            "(\\d)(\\d{3,4})(\\d{4})",
                            "$1-$2-$3",
                            [
                                "2"
                            ],
                            "0$1",
                            "0$CC-$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1-$2-$3",
                            [
                                "[36]0|8"
                            ],
                            "0$1",
                            "0$CC-$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3,4})(\\d{4})",
                            "$1-$2-$3",
                            [
                                "[1346]|5[1-5]"
                            ],
                            "0$1",
                            "0$CC-$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{4})(\\d{4})",
                            "$1-$2-$3",
                            [
                                "[57]"
                            ],
                            "0$1",
                            "0$CC-$1"
                        ],
                        [
                            ,
                            "(\\d{5})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "003",
                                "0030"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{5})(\\d{4})",
                            "$1-$2-$3",
                            [
                                "5"
                            ],
                            "0$1",
                            "0$CC-$1"
                        ],
                        [
                            ,
                            "(\\d{5})(\\d{3,4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "0"
                            ]
                        ],
                        [
                            ,
                            "(\\d{5})(\\d{2})(\\d{3})(\\d{4})",
                            "$1 $2 $3 $4",
                            [
                                "0"
                            ]
                        ]
                    ],
                    [
                        [
                            ,
                            "(\\d{2})(\\d{3,4})",
                            "$1-$2",
                            [
                                "(?:3[1-3]|[46][1-4]|5[1-5])1"
                            ],
                            "0$1",
                            "0$CC-$1"
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{4})",
                            "$1-$2",
                            [
                                "1"
                            ]
                        ],
                        [
                            ,
                            "(\\d)(\\d{3,4})(\\d{4})",
                            "$1-$2-$3",
                            [
                                "2"
                            ],
                            "0$1",
                            "0$CC-$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1-$2-$3",
                            [
                                "[36]0|8"
                            ],
                            "0$1",
                            "0$CC-$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3,4})(\\d{4})",
                            "$1-$2-$3",
                            [
                                "[1346]|5[1-5]"
                            ],
                            "0$1",
                            "0$CC-$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{4})(\\d{4})",
                            "$1-$2-$3",
                            [
                                "[57]"
                            ],
                            "0$1",
                            "0$CC-$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{5})(\\d{4})",
                            "$1-$2-$3",
                            [
                                "5"
                            ],
                            "0$1",
                            "0$CC-$1"
                        ]
                    ],
                    [
                        ,
                        ,
                        "15\\d{7,8}",
                        ,
                        ,
                        ,
                        "1523456789",
                        ,
                        ,
                        [
                            9,
                            10
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "00(?:3(?:08\\d{6,7}|68\\d{7})|798\\d{7,9})",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            11,
                            12,
                            13,
                            14
                        ]
                    ],
                    [
                        ,
                        ,
                        "1(?:5(?:22|33|44|66|77|88|99)|6(?:[07]0|44|6[0168]|88)|8(?:00|33|55|77|99))\\d{4}",
                        ,
                        ,
                        ,
                        "15441234",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                KW: [
                    ,
                    [
                        ,
                        ,
                        "18\\d{5}|(?:[2569]\\d|41)\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}",
                        ,
                        ,
                        ,
                        "22345678",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|1(?:00|11|6[16])|2[26]2|3[36]3|4[46]4|7(?:0[013-9]|[67]\\d)|8[68]8|9(?:[069]\\d|3[039]))|9(?:(?:[04679]\\d|8[057-9])\\d|1(?:1[01]|99)|2(?:00|2\\d)|3(?:00|3[03])|5(?:00|5\\d)))\\d{4}",
                        ,
                        ,
                        ,
                        "50012345",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "18\\d{5}",
                        ,
                        ,
                        ,
                        "1801234",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "KW",
                    965,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{4})(\\d{3,4})",
                            "$1 $2",
                            [
                                "[169]|2(?:[235]|4[1-35-9])|52"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{5})",
                            "$1 $2",
                            [
                                "[245]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                KY: [
                    ,
                    [
                        ,
                        ,
                        "(?:345|[58]\\d\\d|900)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|[48]8)|9(?:14|4[035-9]))\\d{4}",
                        ,
                        ,
                        ,
                        "3452221234",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|82[56]|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}",
                        ,
                        ,
                        ,
                        "3453231234",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "8002345678"
                    ],
                    [
                        ,
                        ,
                        "(?:345976|900[2-9]\\d\\d)\\d{4}",
                        ,
                        ,
                        ,
                        "9002345678"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "5002345678"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "KY",
                    1,
                    "011",
                    "1",
                    ,
                    ,
                    "([2-9]\\d{6})$|1",
                    "345$1",
                    ,
                    ,
                    ,
                    ,
                    [
                        ,
                        ,
                        "345849\\d{4}",
                        ,
                        ,
                        ,
                        "3458491234"
                    ],
                    ,
                    "345",
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                KZ: [
                    ,
                    [
                        ,
                        ,
                        "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10,
                            14
                        ],
                        [
                            5,
                            6,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9]|97)|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]|59))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}",
                        ,
                        ,
                        ,
                        "7123456789",
                        ,
                        ,
                        [
                            10
                        ],
                        [
                            5,
                            6,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}",
                        ,
                        ,
                        ,
                        "7710009998",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "8(?:00|108\\d{3})\\d{7}",
                        ,
                        ,
                        ,
                        "8001234567"
                    ],
                    [
                        ,
                        ,
                        "809\\d{7}",
                        ,
                        ,
                        ,
                        "8091234567",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "808\\d{7}",
                        ,
                        ,
                        ,
                        "8081234567",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "751\\d{7}",
                        ,
                        ,
                        ,
                        "7511234567",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    "KZ",
                    7,
                    "810",
                    "8",
                    ,
                    ,
                    "8",
                    ,
                    "8~10",
                    ,
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    "33|7",
                    [
                        ,
                        ,
                        "751\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                LA: [
                    ,
                    [
                        ,
                        ,
                        "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8,
                            9,
                            10
                        ],
                        [
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:2[13]|[35-7][14]|41|8[1468])\\d{6}",
                        ,
                        ,
                        ,
                        "21212862",
                        ,
                        ,
                        [
                            8
                        ],
                        [
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "208[78]\\d{6}|(?:20[23579]|30[24])\\d{7}",
                        ,
                        ,
                        ,
                        "2023123456",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "LA",
                    856,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "2[13]|3[14]|[4-8]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                            "$1 $2 $3 $4",
                            [
                                "30[0135-9]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                            "$1 $2 $3 $4",
                            [
                                "[23]"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "30[0135-9]\\d{6}",
                        ,
                        ,
                        ,
                        "301234567",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                LB: [
                    ,
                    [
                        ,
                        ,
                        "[27-9]\\d{7}|[13-9]\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "7(?:62|8[0-7]|9[04-9])\\d{4}|(?:[14-69]\\d|2(?:[14-69]\\d|[78][1-9])|7[2-57]|8[02-9])\\d{5}",
                        ,
                        ,
                        ,
                        "1123456"
                    ],
                    [
                        ,
                        ,
                        "793(?:[01]\\d|2[0-4])\\d{3}|(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[12]))\\d{5}",
                        ,
                        ,
                        ,
                        "71123456"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "9[01]\\d{6}",
                        ,
                        ,
                        ,
                        "90123456",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "80\\d{6}",
                        ,
                        ,
                        ,
                        "80123456",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "LB",
                    961,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[27-9]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                LC: [
                    ,
                    [
                        ,
                        ,
                        "(?:[58]\\d\\d|758|900)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}",
                        ,
                        ,
                        ,
                        "7584305678",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}",
                        ,
                        ,
                        ,
                        "7582845678",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "8002123456"
                    ],
                    [
                        ,
                        ,
                        "900[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "9002123456"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "5002345678"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "LC",
                    1,
                    "011",
                    "1",
                    ,
                    ,
                    "([2-8]\\d{6})$|1",
                    "758$1",
                    ,
                    ,
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    "758",
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                LI: [
                    ,
                    [
                        ,
                        ,
                        "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:2(?:01|1[27]|2[02]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}",
                        ,
                        ,
                        ,
                        "2345678",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:6(?:(?:4[5-9]|5[0-469])\\d|6(?:[024-6]\\d|[17]0|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}",
                        ,
                        ,
                        ,
                        "660234567"
                    ],
                    [
                        ,
                        ,
                        "8002[28]\\d\\d|80(?:05\\d|9)\\d{4}",
                        ,
                        ,
                        ,
                        "8002222"
                    ],
                    [
                        ,
                        ,
                        "90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d",
                        ,
                        ,
                        ,
                        "9002222",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "LI",
                    423,
                    "00",
                    "0",
                    ,
                    ,
                    "(1001)|0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{2})",
                            "$1 $2 $3",
                            [
                                "[2379]|8(?:0[09]|7)",
                                "[2379]|8(?:0(?:02|9)|7)"
                            ],
                            ,
                            "$CC $1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "8"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "69"
                            ],
                            ,
                            "$CC $1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "6"
                            ],
                            ,
                            "$CC $1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "870(?:28|87)\\d\\d",
                        ,
                        ,
                        ,
                        "8702812",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "697(?:42|56|[78]\\d)\\d{4}",
                        ,
                        ,
                        ,
                        "697861234",
                        ,
                        ,
                        [
                            9
                        ]
                    ]
                ],
                LK: [
                    ,
                    [
                        ,
                        ,
                        "[1-9]\\d{8}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}",
                        ,
                        ,
                        ,
                        "112345678",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "7(?:[0-25-8]\\d|4[0-4])\\d{6}",
                        ,
                        ,
                        ,
                        "712345678"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "LK",
                    94,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "7"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[1-689]"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "1973\\d{5}",
                        ,
                        ,
                        ,
                        "197312345"
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                LR: [
                    ,
                    [
                        ,
                        ,
                        "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            8,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "2\\d{7}",
                        ,
                        ,
                        ,
                        "21234567",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:(?:(?:22|33)0|555|(?:77|88)\\d)\\d|4(?:240|[67]))\\d{5}|[56]\\d{6}",
                        ,
                        ,
                        ,
                        "770123456",
                        ,
                        ,
                        [
                            7,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "332(?:02|[34]\\d)\\d{4}",
                        ,
                        ,
                        ,
                        "332021234",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "LR",
                    231,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "4[67]|[56]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "2"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[2-578]"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                LS: [
                    ,
                    [
                        ,
                        ,
                        "(?:[256]\\d\\d|800)\\d{5}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "2\\d{7}",
                        ,
                        ,
                        ,
                        "22123456"
                    ],
                    [
                        ,
                        ,
                        "[56]\\d{7}",
                        ,
                        ,
                        ,
                        "50123456"
                    ],
                    [
                        ,
                        ,
                        "800[1256]\\d{4}",
                        ,
                        ,
                        ,
                        "80021234"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "LS",
                    266,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{4})(\\d{4})",
                            "$1 $2",
                            [
                                "[2568]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                LT: [
                    ,
                    [
                        ,
                        ,
                        "(?:[3469]\\d|52|[78]0)\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:3[1478]|4[124-6]|52)\\d{6}",
                        ,
                        ,
                        ,
                        "31234567"
                    ],
                    [
                        ,
                        ,
                        "6\\d{7}",
                        ,
                        ,
                        ,
                        "61234567"
                    ],
                    [
                        ,
                        ,
                        "80[02]\\d{5}",
                        ,
                        ,
                        ,
                        "80012345"
                    ],
                    [
                        ,
                        ,
                        "9(?:0[0239]|10)\\d{5}",
                        ,
                        ,
                        ,
                        "90012345"
                    ],
                    [
                        ,
                        ,
                        "808\\d{5}",
                        ,
                        ,
                        ,
                        "80812345"
                    ],
                    [
                        ,
                        ,
                        "70[05]\\d{5}",
                        ,
                        ,
                        ,
                        "70012345"
                    ],
                    [
                        ,
                        ,
                        "[89]01\\d{5}",
                        ,
                        ,
                        ,
                        "80123456"
                    ],
                    "LT",
                    370,
                    "00",
                    "0",
                    ,
                    ,
                    "[08]",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "52[0-7]"
                            ],
                            "(0-$1)",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[7-9]"
                            ],
                            "0 $1",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{6})",
                            "$1 $2",
                            [
                                "37|4(?:[15]|6[1-8])"
                            ],
                            "(0-$1)",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{5})",
                            "$1 $2",
                            [
                                "[3-6]"
                            ],
                            "(0-$1)",
                            ,
                            1
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "70[67]\\d{5}",
                        ,
                        ,
                        ,
                        "70712345"
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                LU: [
                    ,
                    [
                        ,
                        ,
                        "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            4,
                            5,
                            6,
                            7,
                            8,
                            9,
                            10,
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}",
                        ,
                        ,
                        ,
                        "27123456"
                    ],
                    [
                        ,
                        ,
                        "6(?:[269][18]|5[1568]|7[189]|81)\\d{6}",
                        ,
                        ,
                        ,
                        "628123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "800\\d{5}",
                        ,
                        ,
                        ,
                        "80012345",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "90[015]\\d{5}",
                        ,
                        ,
                        ,
                        "90012345",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "801\\d{5}",
                        ,
                        ,
                        ,
                        "80112345",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "20(?:1\\d{5}|[2-689]\\d{1,7})",
                        ,
                        ,
                        ,
                        "20201234",
                        ,
                        ,
                        [
                            4,
                            5,
                            6,
                            7,
                            8,
                            9,
                            10
                        ]
                    ],
                    "LU",
                    352,
                    "00",
                    ,
                    ,
                    ,
                    "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{3})",
                            "$1 $2",
                            [
                                "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                            ],
                            ,
                            "$CC $1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3",
                            [
                                "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                            ],
                            ,
                            "$CC $1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "20[2-689]"
                            ],
                            ,
                            "$CC $1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                            "$1 $2 $3 $4",
                            [
                                "2(?:[0367]|4[3-8])"
                            ],
                            ,
                            "$CC $1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "80[01]|90[015]"
                            ],
                            ,
                            "$CC $1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                            "$1 $2 $3 $4",
                            [
                                "20"
                            ],
                            ,
                            "$CC $1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "6"
                            ],
                            ,
                            "$CC $1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                            "$1 $2 $3 $4 $5",
                            [
                                "2(?:[0367]|4[3-8])"
                            ],
                            ,
                            "$CC $1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
                            "$1 $2 $3 $4",
                            [
                                "[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"
                            ],
                            ,
                            "$CC $1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                LV: [
                    ,
                    [
                        ,
                        ,
                        "(?:[268]\\d|90)\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "6\\d{7}",
                        ,
                        ,
                        ,
                        "63123456"
                    ],
                    [
                        ,
                        ,
                        "23(?:23[0-57-9]|33[0238])\\d{3}|2(?:[0-24-9]\\d\\d|3(?:0[07]|[14-9]\\d|2[024-9]|3[0-24-9]))\\d{4}",
                        ,
                        ,
                        ,
                        "21234567"
                    ],
                    [
                        ,
                        ,
                        "80\\d{6}",
                        ,
                        ,
                        ,
                        "80123456"
                    ],
                    [
                        ,
                        ,
                        "90\\d{6}",
                        ,
                        ,
                        ,
                        "90123456"
                    ],
                    [
                        ,
                        ,
                        "81\\d{6}",
                        ,
                        ,
                        ,
                        "81123456"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "LV",
                    371,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[269]|8[01]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                LY: [
                    ,
                    [
                        ,
                        ,
                        "[2-9]\\d{8}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}",
                        ,
                        ,
                        ,
                        "212345678",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "9[1-6]\\d{7}",
                        ,
                        ,
                        ,
                        "912345678"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "LY",
                    218,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{7})",
                            "$1-$2",
                            [
                                "[2-9]"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                MA: [
                    ,
                    [
                        ,
                        ,
                        "[5-8]\\d{8}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}",
                        ,
                        ,
                        ,
                        "520123456"
                    ],
                    [
                        ,
                        ,
                        "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-4]|5[01]|8[0-3]))\\d{6}",
                        ,
                        ,
                        ,
                        "650123456"
                    ],
                    [
                        ,
                        ,
                        "80[0-7]\\d{6}",
                        ,
                        ,
                        ,
                        "801234567"
                    ],
                    [
                        ,
                        ,
                        "89\\d{7}",
                        ,
                        ,
                        ,
                        "891234567"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}",
                        ,
                        ,
                        ,
                        "592401234"
                    ],
                    "MA",
                    212,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "5[45]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{5})",
                            "$1-$2",
                            [
                                "5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{7})",
                            "$1-$2",
                            [
                                "8"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{6})",
                            "$1-$2",
                            [
                                "[5-7]"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    1,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                MC: [
                    ,
                    [
                        ,
                        ,
                        "(?:[3489]|6\\d)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:870|9[2-47-9]\\d)\\d{5}",
                        ,
                        ,
                        ,
                        "99123456",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "4(?:[469]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}",
                        ,
                        ,
                        ,
                        "612345678"
                    ],
                    [
                        ,
                        ,
                        "(?:800|90\\d)\\d{5}",
                        ,
                        ,
                        ,
                        "90123456",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "MC",
                    377,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{2})",
                            "$1 $2 $3",
                            [
                                "87"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "4"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[389]"
                            ]
                        ],
                        [
                            ,
                            "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4 $5",
                            [
                                "6"
                            ],
                            "0$1"
                        ]
                    ],
                    [
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "4"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[389]"
                            ]
                        ],
                        [
                            ,
                            "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4 $5",
                            [
                                "6"
                            ],
                            "0$1"
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "8[07]0\\d{5}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                MD: [
                    ,
                    [
                        ,
                        ,
                        "(?:[235-7]\\d|[89]0)\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}",
                        ,
                        ,
                        ,
                        "22212345"
                    ],
                    [
                        ,
                        ,
                        "562\\d{5}|(?:6\\d|7[16-9])\\d{6}",
                        ,
                        ,
                        ,
                        "62112345"
                    ],
                    [
                        ,
                        ,
                        "800\\d{5}",
                        ,
                        ,
                        ,
                        "80012345"
                    ],
                    [
                        ,
                        ,
                        "90[056]\\d{5}",
                        ,
                        ,
                        ,
                        "90012345"
                    ],
                    [
                        ,
                        ,
                        "808\\d{5}",
                        ,
                        ,
                        ,
                        "80812345"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "3[08]\\d{6}",
                        ,
                        ,
                        ,
                        "30123456"
                    ],
                    "MD",
                    373,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{5})",
                            "$1 $2",
                            [
                                "[89]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "22|3"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[25-7]"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "803\\d{5}",
                        ,
                        ,
                        ,
                        "80312345"
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                ME: [
                    ,
                    [
                        ,
                        ,
                        "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8,
                            9
                        ],
                        [
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}",
                        ,
                        ,
                        ,
                        "30234567",
                        ,
                        ,
                        [
                            8
                        ],
                        [
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}",
                        ,
                        ,
                        ,
                        "67622901",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "80(?:[0-2578]|9\\d)\\d{5}",
                        ,
                        ,
                        ,
                        "80080002"
                    ],
                    [
                        ,
                        ,
                        "9(?:4[1568]|5[178])\\d{5}",
                        ,
                        ,
                        ,
                        "94515151",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "78[1-49]\\d{5}",
                        ,
                        ,
                        ,
                        "78108780",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    "ME",
                    382,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "[2-9]"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "77[1-9]\\d{5}",
                        ,
                        ,
                        ,
                        "77273012",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                MF: [
                    ,
                    [
                        ,
                        ,
                        "590\\d{6}|(?:69|80|9\\d)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}",
                        ,
                        ,
                        ,
                        "590271234"
                    ],
                    [
                        ,
                        ,
                        "69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}",
                        ,
                        ,
                        ,
                        "690001234"
                    ],
                    [
                        ,
                        ,
                        "80[0-5]\\d{6}",
                        ,
                        ,
                        ,
                        "800012345"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}",
                        ,
                        ,
                        ,
                        "976012345"
                    ],
                    "MF",
                    590,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                MG: [
                    ,
                    [
                        ,
                        ,
                        "[23]\\d{8}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[35]|8[268]|9[245])\\d{5}",
                        ,
                        ,
                        ,
                        "202123456",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "3[2-47-9]\\d{7}",
                        ,
                        ,
                        ,
                        "321234567"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "22\\d{7}",
                        ,
                        ,
                        ,
                        "221234567"
                    ],
                    "MG",
                    261,
                    "00",
                    "0",
                    ,
                    ,
                    "([24-9]\\d{6})$|0",
                    "20$1",
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[23]"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                MH: [
                    ,
                    [
                        ,
                        ,
                        "329\\d{4}|(?:[256]\\d|45)\\d{5}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:247|528|625)\\d{4}",
                        ,
                        ,
                        ,
                        "2471234"
                    ],
                    [
                        ,
                        ,
                        "(?:(?:23|54)5|329|45[35-8])\\d{4}",
                        ,
                        ,
                        ,
                        "2351234"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "635\\d{4}",
                        ,
                        ,
                        ,
                        "6351234"
                    ],
                    "MH",
                    692,
                    "011",
                    "1",
                    ,
                    ,
                    "1",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1-$2",
                            [
                                "[2-6]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                MK: [
                    ,
                    [
                        ,
                        ,
                        "[2-578]\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8
                        ],
                        [
                            6,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:(?:2(?:62|77)0|3444)\\d|4[56]440)\\d{3}|(?:34|4[357])700\\d{3}|(?:2(?:[0-3]\\d|5[0-578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}",
                        ,
                        ,
                        ,
                        "22012345",
                        ,
                        ,
                        ,
                        [
                            6,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "7(?:3555|(?:474|9[019]7)7)\\d{3}|7(?:[0-25-8]\\d\\d|3(?:[1-48]\\d|6[01]|7[01578])|4(?:2\\d|60|7[01578])|9(?:[2-4]\\d|5[01]|7[015]))\\d{4}",
                        ,
                        ,
                        ,
                        "72345678"
                    ],
                    [
                        ,
                        ,
                        "800\\d{5}",
                        ,
                        ,
                        ,
                        "80012345"
                    ],
                    [
                        ,
                        ,
                        "5\\d{7}",
                        ,
                        ,
                        ,
                        "50012345"
                    ],
                    [
                        ,
                        ,
                        "8(?:0[1-9]|[1-9]\\d)\\d{5}",
                        ,
                        ,
                        ,
                        "80123456"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "MK",
                    389,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "2|34[47]|4(?:[37]7|5[47]|64)"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[347]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[58]"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                ML: [
                    ,
                    [
                        ,
                        ,
                        "[24-9]\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-39]))\\d{5}",
                        ,
                        ,
                        ,
                        "20212345"
                    ],
                    [
                        ,
                        ,
                        "2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[01]|[679]\\d|8[2-49])\\d{6}",
                        ,
                        ,
                        ,
                        "65012345"
                    ],
                    [
                        ,
                        ,
                        "80\\d{6}",
                        ,
                        ,
                        ,
                        "80012345"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "ML",
                    223,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{4})",
                            "$1",
                            [
                                "67[057-9]|74[045]",
                                "67(?:0[09]|[59]9|77|8[89])|74(?:0[02]|44|55)"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[24-9]"
                            ]
                        ]
                    ],
                    [
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[24-9]"
                            ]
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "80\\d{6}"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                MM: [
                    ,
                    [
                        ,
                        ,
                        "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            6,
                            7,
                            8,
                            9,
                            10
                        ],
                        [
                            5
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:1(?:(?:2\\d|3[56]|[89][0-6])\\d|4(?:2[29]|62|7[0-2]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|[26]2|7[0-2]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[013])|3(?:20\\d|4(?:70|83)|56)|420\\d|5470)|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|2472|3(?:20\\d|470)|4(?:2[04]\\d|472)|7(?:(?:3\\d|8[01459])\\d|4[67]0)))\\d{4}|5(?:2(?:2\\d{5,6}|47[02]\\d{4})|(?:3472|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[01])|8(?:20\\d|47[02])|9(?:20\\d|470))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:(?:2\\d|51)\\d|4(?:[1-35-9]\\d|4[0-57-9]))|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|[35]2\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}",
                        ,
                        ,
                        ,
                        "1234567",
                        ,
                        ,
                        [
                            6,
                            7,
                            8,
                            9
                        ],
                        [
                            5
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}",
                        ,
                        ,
                        ,
                        "92123456",
                        ,
                        ,
                        [
                            7,
                            8,
                            9,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "80080(?:0[1-9]|2\\d)\\d{3}",
                        ,
                        ,
                        ,
                        "8008001234",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "1333\\d{4}|[12]468\\d{4}",
                        ,
                        ,
                        ,
                        "13331234",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    "MM",
                    95,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d)(\\d{2})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "16|2"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "[12]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "[4-7]|8[1-35]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{4,6})",
                            "$1 $2 $3",
                            [
                                "9(?:2[0-4]|[35-9]|4[137-9])"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d)(\\d{4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "2"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "8"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3 $4",
                            [
                                "92"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d)(\\d{5})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "9"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                MN: [
                    ,
                    [
                        ,
                        ,
                        "[12]\\d{7,9}|[5-9]\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8,
                            9,
                            10
                        ],
                        [
                            4,
                            5,
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "[12]2[1-3]\\d{5,6}|(?:(?:[12](?:1|27)|5[368])\\d\\d|7(?:0(?:[0-5]\\d|7[078]|80)|128))\\d{4}|[12](?:3[2-8]|4[2-68]|5[1-4689])\\d{6,7}",
                        ,
                        ,
                        ,
                        "53123456",
                        ,
                        ,
                        ,
                        [
                            4,
                            5,
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:83[01]|92[039])\\d{5}|(?:5[05]|6[069]|8[015689]|9[013-9])\\d{6}",
                        ,
                        ,
                        ,
                        "88123456",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "712[0-79]\\d{4}|7(?:1[013-9]|[25-9]\\d)\\d{5}",
                        ,
                        ,
                        ,
                        "75123456",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    "MN",
                    976,
                    "001",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[12]1"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{4})",
                            "$1 $2",
                            [
                                "[5-9]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{5,6})",
                            "$1 $2",
                            [
                                "[12]2[1-3]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{5,6})",
                            "$1 $2",
                            [
                                "[12](?:27|3[2-8]|4[2-68]|5[1-4689])",
                                "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{5})(\\d{4,5})",
                            "$1 $2",
                            [
                                "[12]"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                MO: [
                    ,
                    [
                        ,
                        ,
                        "0800\\d{3}|(?:28|[68]\\d)\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}",
                        ,
                        ,
                        ,
                        "28212345",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}",
                        ,
                        ,
                        ,
                        "66123456",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "0800\\d{3}",
                        ,
                        ,
                        ,
                        "0800501",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "MO",
                    853,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{4})(\\d{3})",
                            "$1 $2",
                            [
                                "0"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{4})",
                            "$1 $2",
                            [
                                "[268]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                MP: [
                    ,
                    [
                        ,
                        ,
                        "[58]\\d{9}|(?:67|90)0\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}",
                        ,
                        ,
                        ,
                        "6702345678",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}",
                        ,
                        ,
                        ,
                        "6702345678",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "8002123456"
                    ],
                    [
                        ,
                        ,
                        "900[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "9002123456"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "5002345678"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "MP",
                    1,
                    "011",
                    "1",
                    ,
                    ,
                    "([2-9]\\d{6})$|1",
                    "670$1",
                    ,
                    1,
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    "670",
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                MQ: [
                    ,
                    [
                        ,
                        ,
                        "596\\d{6}|(?:69|80|9\\d)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "596(?:[03-7]\\d|1[05]|2[7-9]|8[0-39]|9[04-9])\\d{4}",
                        ,
                        ,
                        ,
                        "596301234"
                    ],
                    [
                        ,
                        ,
                        "69(?:6(?:[0-46-9]\\d|5[0-6])|727)\\d{4}",
                        ,
                        ,
                        ,
                        "696201234"
                    ],
                    [
                        ,
                        ,
                        "80[0-5]\\d{6}",
                        ,
                        ,
                        ,
                        "800012345"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "9(?:397[0-3]|477[0-5]|76(?:6\\d|7[0-367]))\\d{4}",
                        ,
                        ,
                        ,
                        "976612345"
                    ],
                    "MQ",
                    596,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[569]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "8"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                MR: [
                    ,
                    [
                        ,
                        ,
                        "(?:[2-4]\\d\\d|800)\\d{5}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:25[08]|35\\d|45[1-7])\\d{5}",
                        ,
                        ,
                        ,
                        "35123456"
                    ],
                    [
                        ,
                        ,
                        "[2-4][0-46-9]\\d{6}",
                        ,
                        ,
                        ,
                        "22123456"
                    ],
                    [
                        ,
                        ,
                        "800\\d{5}",
                        ,
                        ,
                        ,
                        "80012345"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "MR",
                    222,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[2-48]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                MS: [
                    ,
                    [
                        ,
                        ,
                        "(?:[58]\\d\\d|664|900)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "6644(?:1[0-3]|91)\\d{4}",
                        ,
                        ,
                        ,
                        "6644912345",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "664(?:3(?:49|9[1-6])|49[2-6])\\d{4}",
                        ,
                        ,
                        ,
                        "6644923456",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "8002123456"
                    ],
                    [
                        ,
                        ,
                        "900[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "9002123456"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "5002345678"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "MS",
                    1,
                    "011",
                    "1",
                    ,
                    ,
                    "([34]\\d{6})$|1",
                    "664$1",
                    ,
                    ,
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    "664",
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                MT: [
                    ,
                    [
                        ,
                        ,
                        "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "20(?:3[1-4]|6[059])\\d{4}|2(?:0[19]|[1-357]\\d|60)\\d{5}",
                        ,
                        ,
                        ,
                        "21001234"
                    ],
                    [
                        ,
                        ,
                        "(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}",
                        ,
                        ,
                        ,
                        "96961234"
                    ],
                    [
                        ,
                        ,
                        "800(?:02|[3467]\\d)\\d{3}",
                        ,
                        ,
                        ,
                        "80071234"
                    ],
                    [
                        ,
                        ,
                        "5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}",
                        ,
                        ,
                        ,
                        "50037123"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "3550\\d{4}",
                        ,
                        ,
                        ,
                        "35501234"
                    ],
                    "MT",
                    356,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{4})(\\d{4})",
                            "$1 $2",
                            [
                                "[2357-9]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        "7117\\d{4}",
                        ,
                        ,
                        ,
                        "71171234"
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "501\\d{5}",
                        ,
                        ,
                        ,
                        "50112345"
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                MU: [
                    ,
                    [
                        ,
                        ,
                        "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            8,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:2(?:[0346-8]\\d|1[0-7])|4(?:[013568]\\d|2[4-8]|71)|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}",
                        ,
                        ,
                        ,
                        "54480123",
                        ,
                        ,
                        [
                            7,
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|(?:5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])|7(?:0[0-4]|3[013]))\\d{5}",
                        ,
                        ,
                        ,
                        "52512345",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "802\\d{7}|80[0-2]\\d{4}",
                        ,
                        ,
                        ,
                        "8001234",
                        ,
                        ,
                        [
                            7,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "30\\d{5}",
                        ,
                        ,
                        ,
                        "3012345",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "3(?:20|9\\d)\\d{4}",
                        ,
                        ,
                        ,
                        "3201234",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    "MU",
                    230,
                    "0(?:0|[24-7]0|3[03])",
                    ,
                    ,
                    ,
                    ,
                    ,
                    "020",
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1 $2",
                            [
                                "[2-46]|8[013]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{4})",
                            "$1 $2",
                            [
                                "[57]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{5})(\\d{5})",
                            "$1 $2",
                            [
                                "8"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                MV: [
                    ,
                    [
                        ,
                        ,
                        "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:3(?:0[0-3]|3[0-59])|6(?:[58][024689]|6[024-68]|7[02468]))\\d{4}",
                        ,
                        ,
                        ,
                        "6701234",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:46[46]|[79]\\d\\d)\\d{4}",
                        ,
                        ,
                        ,
                        "7712345",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "800\\d{7}",
                        ,
                        ,
                        ,
                        "8001234567",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "900\\d{7}",
                        ,
                        ,
                        ,
                        "9001234567",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "MV",
                    960,
                    "0(?:0|19)",
                    ,
                    ,
                    ,
                    ,
                    ,
                    "00",
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1-$2",
                            [
                                "[34679]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[89]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "4(?:0[01]|50)\\d{4}",
                        ,
                        ,
                        ,
                        "4001234",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                MW: [
                    ,
                    [
                        ,
                        ,
                        "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:1[2-9]|2[12]\\d\\d)\\d{5}",
                        ,
                        ,
                        ,
                        "1234567"
                    ],
                    [
                        ,
                        ,
                        "111\\d{6}|(?:31|77|[89][89])\\d{7}",
                        ,
                        ,
                        ,
                        "991234567",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "MW",
                    265,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "1[2-9]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "2"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[137-9]"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                MX: [
                    ,
                    [
                        ,
                        ,
                        "[2-9]\\d{9}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10
                        ],
                        [
                            7,
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "657[12]\\d{6}|(?:2(?:0[01]|2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[25-7][1-9]|3[1-8]|4\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}",
                        ,
                        ,
                        ,
                        "2001234567",
                        ,
                        ,
                        ,
                        [
                            7,
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "657[12]\\d{6}|(?:2(?:2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[25-7][1-9]|3[1-8]|4\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}",
                        ,
                        ,
                        ,
                        "2221234567",
                        ,
                        ,
                        ,
                        [
                            7,
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "8(?:00|88)\\d{7}",
                        ,
                        ,
                        ,
                        "8001234567"
                    ],
                    [
                        ,
                        ,
                        "900\\d{7}",
                        ,
                        ,
                        ,
                        "9001234567"
                    ],
                    [
                        ,
                        ,
                        "300\\d{7}",
                        ,
                        ,
                        ,
                        "3001234567"
                    ],
                    [
                        ,
                        ,
                        "500\\d{7}",
                        ,
                        ,
                        ,
                        "5001234567"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "MX",
                    52,
                    "0[09]",
                    ,
                    ,
                    ,
                    ,
                    ,
                    "00",
                    ,
                    [
                        [
                            ,
                            "(\\d{5})",
                            "$1",
                            [
                                "53"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "33|5[56]|81"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[2-9]"
                            ]
                        ]
                    ],
                    [
                        [
                            ,
                            "(\\d{2})(\\d{4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "33|5[56]|81"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[2-9]"
                            ]
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                MY: [
                    ,
                    [
                        ,
                        ,
                        "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8,
                            9,
                            10
                        ],
                        [
                            6,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "4270\\d{4}|(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}",
                        ,
                        ,
                        ,
                        "323856789",
                        ,
                        ,
                        [
                            8,
                            9
                        ],
                        [
                            6,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "1(?:1888[689]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0-4]\\d|5[0-7]))|(?:[269]\\d|[37][1-9]|4[235-9])\\d|5(?:31|9\\d\\d)|8(?:1[23]|[236]\\d|4[06]|5(?:46|[7-9])|7[016-9]|8[01]|9[0-8]))\\d{5}",
                        ,
                        ,
                        ,
                        "123456789",
                        ,
                        ,
                        [
                            9,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "1[378]00\\d{6}",
                        ,
                        ,
                        ,
                        "1300123456",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "1600\\d{6}",
                        ,
                        ,
                        ,
                        "1600123456",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}",
                        ,
                        ,
                        ,
                        "1546012345",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    "MY",
                    60,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{4})",
                            "$1-$2 $3",
                            [
                                "[4-79]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3,4})",
                            "$1-$2 $3",
                            [
                                "1(?:[02469]|[378][1-9]|53)|8",
                                "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d)(\\d{4})(\\d{4})",
                            "$1-$2 $3",
                            [
                                "3"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{2})(\\d{4})",
                            "$1-$2-$3-$4",
                            [
                                "1(?:[367]|80)"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "$1-$2 $3",
                            [
                                "15"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{4})(\\d{4})",
                            "$1-$2 $3",
                            [
                                "1"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                MZ: [
                    ,
                    [
                        ,
                        ,
                        "(?:2|8\\d)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}",
                        ,
                        ,
                        ,
                        "21123456",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "8[2-79]\\d{7}",
                        ,
                        ,
                        ,
                        "821234567",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "800\\d{6}",
                        ,
                        ,
                        ,
                        "800123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "MZ",
                    258,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "2|8[2-79]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "8"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                NA: [
                    ,
                    [
                        ,
                        ,
                        "[68]\\d{7,8}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}",
                        ,
                        ,
                        ,
                        "61221234"
                    ],
                    [
                        ,
                        ,
                        "(?:60|8[1245])\\d{7}",
                        ,
                        ,
                        ,
                        "811234567",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "80\\d{7}",
                        ,
                        ,
                        ,
                        "800123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "8701\\d{5}",
                        ,
                        ,
                        ,
                        "870123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "8(?:3\\d\\d|86)\\d{5}",
                        ,
                        ,
                        ,
                        "88612345"
                    ],
                    "NA",
                    264,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "88"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "6"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "87"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "8"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                NC: [
                    ,
                    [
                        ,
                        ,
                        "(?:050|[2-57-9]\\d\\d)\\d{3}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}",
                        ,
                        ,
                        ,
                        "201234"
                    ],
                    [
                        ,
                        ,
                        "(?:5[0-4]|[79]\\d|8[0-79])\\d{4}",
                        ,
                        ,
                        ,
                        "751234"
                    ],
                    [
                        ,
                        ,
                        "050\\d{3}",
                        ,
                        ,
                        ,
                        "050012"
                    ],
                    [
                        ,
                        ,
                        "36\\d{4}",
                        ,
                        ,
                        ,
                        "366711"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "NC",
                    687,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})",
                            "$1",
                            [
                                "5[6-8]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})",
                            "$1.$2.$3",
                            [
                                "[02-57-9]"
                            ]
                        ]
                    ],
                    [
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})",
                            "$1.$2.$3",
                            [
                                "[02-57-9]"
                            ]
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                NE: [
                    ,
                    [
                        ,
                        ,
                        "[027-9]\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}",
                        ,
                        ,
                        ,
                        "20201234"
                    ],
                    [
                        ,
                        ,
                        "(?:23|7[0467]|[89]\\d)\\d{6}",
                        ,
                        ,
                        ,
                        "93123456"
                    ],
                    [
                        ,
                        ,
                        "08\\d{6}",
                        ,
                        ,
                        ,
                        "08123456"
                    ],
                    [
                        ,
                        ,
                        "09\\d{6}",
                        ,
                        ,
                        ,
                        "09123456"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "NE",
                    227,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "08"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[089]|2[013]|7[0467]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                NF: [
                    ,
                    [
                        ,
                        ,
                        "[13]\\d{5}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            6
                        ],
                        [
                            5
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}",
                        ,
                        ,
                        ,
                        "106609",
                        ,
                        ,
                        ,
                        [
                            5
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:14|3[58])\\d{4}",
                        ,
                        ,
                        ,
                        "381234",
                        ,
                        ,
                        ,
                        [
                            5
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "NF",
                    672,
                    "00",
                    ,
                    ,
                    ,
                    "([0-258]\\d{4})$",
                    "3$1",
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{4})",
                            "$1 $2",
                            [
                                "1[0-3]"
                            ]
                        ],
                        [
                            ,
                            "(\\d)(\\d{5})",
                            "$1 $2",
                            [
                                "[13]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                NG: [
                    ,
                    [
                        ,
                        ,
                        "2[0-24-9]\\d{8}|[78]\\d{10,13}|[7-9]\\d{9}|[1-9]\\d{7}|[124-7]\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            8,
                            10,
                            11,
                            12,
                            13,
                            14
                        ],
                        [
                            5,
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "20(?:[1259]\\d|3[013-9]|4[1-8]|6[024-689]|7[1-79]|8[2-9])\\d{6}|(?:(?:[1-356]\\d|4[02-8]|8[2-9])\\d|9(?:0[3-9]|[1-9]\\d))\\d{5}|7(?:0(?:[013-689]\\d|2[0-24-9])\\d{3,4}|[1-79]\\d{6})|(?:[12]\\d|4[147]|5[14579]|6[1578]|7[1-3578])\\d{5}",
                        ,
                        ,
                        ,
                        "18040123",
                        ,
                        ,
                        [
                            7,
                            8,
                            10
                        ],
                        [
                            5,
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:702[0-24-9]|819[01])\\d{6}|(?:7(?:0[13-9]|[12]\\d)|8(?:0[1-9]|1[0-8])|9(?:0[1-9]|1[1-6]))\\d{7}",
                        ,
                        ,
                        ,
                        "8021234567",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "800\\d{7,11}",
                        ,
                        ,
                        ,
                        "80017591759",
                        ,
                        ,
                        [
                            10,
                            11,
                            12,
                            13,
                            14
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "NG",
                    234,
                    "009",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "78"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "[12]|9(?:0[3-9]|[1-9])"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{2,3})",
                            "$1 $2 $3",
                            [
                                "[3-6]|7(?:0[0-689]|[1-79])|8[2-9]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "[7-9]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "20[129]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{2})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "2"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{4})(\\d{4,5})",
                            "$1 $2 $3",
                            [
                                "[78]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{5})(\\d{5,6})",
                            "$1 $2 $3",
                            [
                                "[78]"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "700\\d{7,11}",
                        ,
                        ,
                        ,
                        "7001234567",
                        ,
                        ,
                        [
                            10,
                            11,
                            12,
                            13,
                            14
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                NI: [
                    ,
                    [
                        ,
                        ,
                        "(?:1800|[25-8]\\d{3})\\d{4}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "2\\d{7}",
                        ,
                        ,
                        ,
                        "21234567"
                    ],
                    [
                        ,
                        ,
                        "(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}",
                        ,
                        ,
                        ,
                        "81234567"
                    ],
                    [
                        ,
                        ,
                        "1800\\d{4}",
                        ,
                        ,
                        ,
                        "18001234"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "NI",
                    505,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{4})(\\d{4})",
                            "$1 $2",
                            [
                                "[125-8]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                NL: [
                    ,
                    [
                        ,
                        ,
                        "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            5,
                            6,
                            7,
                            8,
                            9,
                            10,
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}",
                        ,
                        ,
                        ,
                        "101234567",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:6[1-58]|970\\d)\\d{7}",
                        ,
                        ,
                        ,
                        "612345678",
                        ,
                        ,
                        [
                            9,
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        "800\\d{4,7}",
                        ,
                        ,
                        ,
                        "8001234",
                        ,
                        ,
                        [
                            7,
                            8,
                            9,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "90[069]\\d{4,7}",
                        ,
                        ,
                        ,
                        "9061234",
                        ,
                        ,
                        [
                            7,
                            8,
                            9,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:85|91)\\d{7}",
                        ,
                        ,
                        ,
                        "851234567",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    "NL",
                    31,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{4})",
                            "$1",
                            [
                                "1[238]|[34]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3,4})",
                            "$1 $2",
                            [
                                "14"
                            ]
                        ],
                        [
                            ,
                            "(\\d{6})",
                            "$1",
                            [
                                "1"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{4,7})",
                            "$1 $2",
                            [
                                "[89]0"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{7})",
                            "$1 $2",
                            [
                                "66"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d)(\\d{8})",
                            "$1 $2",
                            [
                                "6"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[1-578]|91"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{5})",
                            "$1 $2 $3",
                            [
                                "9"
                            ],
                            "0$1"
                        ]
                    ],
                    [
                        [
                            ,
                            "(\\d{3})(\\d{4,7})",
                            "$1 $2",
                            [
                                "[89]0"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{7})",
                            "$1 $2",
                            [
                                "66"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d)(\\d{8})",
                            "$1 $2",
                            [
                                "6"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[1-578]|91"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{5})",
                            "$1 $2 $3",
                            [
                                "9"
                            ],
                            "0$1"
                        ]
                    ],
                    [
                        ,
                        ,
                        "66\\d{7}",
                        ,
                        ,
                        ,
                        "662345678",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)\\d",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            5,
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d",
                        ,
                        ,
                        ,
                        "14020",
                        ,
                        ,
                        [
                            5,
                            6,
                            9
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                NO: [
                    ,
                    [
                        ,
                        ,
                        "(?:0|[2-9]\\d{3})\\d{4}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            5,
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}",
                        ,
                        ,
                        ,
                        "21234567",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:4[015-8]|9\\d)\\d{6}",
                        ,
                        ,
                        ,
                        "40612345",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "80[01]\\d{5}",
                        ,
                        ,
                        ,
                        "80012345",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "82[09]\\d{5}",
                        ,
                        ,
                        ,
                        "82012345",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "810(?:0[0-6]|[2-8]\\d)\\d{3}",
                        ,
                        ,
                        ,
                        "81021234",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "880\\d{5}",
                        ,
                        ,
                        ,
                        "88012345",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "85[0-5]\\d{5}",
                        ,
                        ,
                        ,
                        "85012345",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    "NO",
                    47,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "8"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[2-79]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    1,
                    "[02-689]|7[0-8]",
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}",
                        ,
                        ,
                        ,
                        "02000"
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "81[23]\\d{5}",
                        ,
                        ,
                        ,
                        "81212345",
                        ,
                        ,
                        [
                            8
                        ]
                    ]
                ],
                NP: [
                    ,
                    [
                        ,
                        ,
                        "(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8,
                            10,
                            11
                        ],
                        [
                            6,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}",
                        ,
                        ,
                        ,
                        "14567890",
                        ,
                        ,
                        [
                            8
                        ],
                        [
                            6,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "9(?:00|6[0-3]|7[024-6]|8[0-24-68])\\d{7}",
                        ,
                        ,
                        ,
                        "9841234567",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "1(?:66001|800\\d\\d)\\d{5}",
                        ,
                        ,
                        ,
                        "16600101234",
                        ,
                        ,
                        [
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "NP",
                    977,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d)(\\d{7})",
                            "$1-$2",
                            [
                                "1[2-6]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{6})",
                            "$1-$2",
                            [
                                "1[01]|[2-8]|9(?:[1-59]|[67][2-6])"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{7})",
                            "$1-$2",
                            [
                                "9"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{2})(\\d{5})",
                            "$1-$2-$3",
                            [
                                "1"
                            ]
                        ]
                    ],
                    [
                        [
                            ,
                            "(\\d)(\\d{7})",
                            "$1-$2",
                            [
                                "1[2-6]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{6})",
                            "$1-$2",
                            [
                                "1[01]|[2-8]|9(?:[1-59]|[67][2-6])"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{7})",
                            "$1-$2",
                            [
                                "9"
                            ]
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                NR: [
                    ,
                    [
                        ,
                        ,
                        "(?:444|(?:55|8\\d)\\d|666)\\d{4}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "444\\d{4}",
                        ,
                        ,
                        ,
                        "4441234"
                    ],
                    [
                        ,
                        ,
                        "(?:55[3-9]|666|8\\d\\d)\\d{4}",
                        ,
                        ,
                        ,
                        "5551234"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "NR",
                    674,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1 $2",
                            [
                                "[4-68]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                NU: [
                    ,
                    [
                        ,
                        ,
                        "(?:[4-7]|888\\d)\\d{3}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            4,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "[47]\\d{3}",
                        ,
                        ,
                        ,
                        "7012",
                        ,
                        ,
                        [
                            4
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:[56]|888[1-9])\\d{3}",
                        ,
                        ,
                        ,
                        "8884012"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "NU",
                    683,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1 $2",
                            [
                                "8"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                NZ: [
                    ,
                    [
                        ,
                        ,
                        "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            5,
                            6,
                            7,
                            8,
                            9,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "24099\\d{3}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}",
                        ,
                        ,
                        ,
                        "32345678",
                        ,
                        ,
                        [
                            8
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "2(?:[0-27-9]\\d|6)\\d{6,7}|2(?:1\\d|75)\\d{5}",
                        ,
                        ,
                        ,
                        "211234567",
                        ,
                        ,
                        [
                            8,
                            9,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "508\\d{6,7}|80\\d{6,8}",
                        ,
                        ,
                        ,
                        "800123456",
                        ,
                        ,
                        [
                            8,
                            9,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:1[13-57-9]\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}",
                        ,
                        ,
                        ,
                        "900123456",
                        ,
                        ,
                        [
                            7,
                            8,
                            9,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "70\\d{7}",
                        ,
                        ,
                        ,
                        "701234567",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "NZ",
                    64,
                    "0(?:0|161)",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    "00",
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{3,8})",
                            "$1 $2",
                            [
                                "8[1-79]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{2,3})",
                            "$1 $2 $3",
                            [
                                "50[036-8]|8|90",
                                "50(?:[0367]|88)|8|90"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "24|[346]|7[2-57-9]|9[2-9]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "2(?:10|74)|[589]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3,4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "1|2[028]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3,5})",
                            "$1 $2 $3",
                            [
                                "2(?:[169]|7[0-35-9])|7"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "8(?:1[16-9]|22|3\\d|4[045]|5[459]|6[235-9]|7[0-3579]|90)\\d{2,7}",
                        ,
                        ,
                        ,
                        "83012378"
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                OM: [
                    ,
                    [
                        ,
                        ,
                        "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            8,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "2[1-6]\\d{6}",
                        ,
                        ,
                        ,
                        "23123456",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:1505|90[1-9]\\d)\\d{4}|(?:7[126-9]|9[1-9])\\d{6}",
                        ,
                        ,
                        ,
                        "92123456",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "8007\\d{4,5}|(?:500|800[05])\\d{4}",
                        ,
                        ,
                        ,
                        "80071234"
                    ],
                    [
                        ,
                        ,
                        "900\\d{5}",
                        ,
                        ,
                        ,
                        "90012345",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "OM",
                    968,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{4,6})",
                            "$1 $2",
                            [
                                "[58]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{6})",
                            "$1 $2",
                            [
                                "2"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{4})",
                            "$1 $2",
                            [
                                "[179]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                PA: [
                    ,
                    [
                        ,
                        ,
                        "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            8,
                            10,
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:1(?:0\\d|1[479]|2[37]|3[0137]|4[17]|5[05]|6[058]|7[0167]|8[2358]|9[1389])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[02-9])|3(?:[089]\\d|1[0-7]|2[0-5]|33|4[0-79]|5[0-35]|6[068]|7[0-8])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[0156]|7[0-24-9]|8[5-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}",
                        ,
                        ,
                        ,
                        "2001234",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:1[16]1|21[89]|6\\d{3}|8(?:1[01]|7[23]))\\d{4}",
                        ,
                        ,
                        ,
                        "61234567",
                        ,
                        ,
                        [
                            7,
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "800\\d{4,5}|(?:00800|800\\d)\\d{6}",
                        ,
                        ,
                        ,
                        "8001234"
                    ],
                    [
                        ,
                        ,
                        "(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}",
                        ,
                        ,
                        ,
                        "8601234",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "PA",
                    507,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1-$2",
                            [
                                "[1-57-9]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{4})",
                            "$1-$2",
                            [
                                "[68]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "8"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                PE: [
                    ,
                    [
                        ,
                        ,
                        "(?:[14-8]|9\\d)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8,
                            9
                        ],
                        [
                            6,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:(?:4[34]|5[14])[0-8]\\d|7(?:173|3[0-8]\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}",
                        ,
                        ,
                        ,
                        "11234567",
                        ,
                        ,
                        [
                            8
                        ],
                        [
                            6,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "9\\d{8}",
                        ,
                        ,
                        ,
                        "912345678",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "800\\d{5}",
                        ,
                        ,
                        ,
                        "80012345",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "805\\d{5}",
                        ,
                        ,
                        ,
                        "80512345",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "801\\d{5}",
                        ,
                        ,
                        ,
                        "80112345",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "80[24]\\d{5}",
                        ,
                        ,
                        ,
                        "80212345",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "PE",
                    51,
                    "00|19(?:1[124]|77|90)00",
                    "0",
                    " Anexo ",
                    ,
                    "0",
                    ,
                    "00",
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{5})",
                            "$1 $2",
                            [
                                "80"
                            ],
                            "(0$1)"
                        ],
                        [
                            ,
                            "(\\d)(\\d{7})",
                            "$1 $2",
                            [
                                "1"
                            ],
                            "(0$1)"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{6})",
                            "$1 $2",
                            [
                                "[4-8]"
                            ],
                            "(0$1)"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "9"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                PF: [
                    ,
                    [
                        ,
                        ,
                        "4\\d{5}(?:\\d{2})?|8\\d{7,8}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            6,
                            8,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "4(?:0[4-689]|9[4-68])\\d{5}",
                        ,
                        ,
                        ,
                        "40412345",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "8[7-9]\\d{6}",
                        ,
                        ,
                        ,
                        "87123456",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "80[0-5]\\d{6}",
                        ,
                        ,
                        ,
                        "800012345",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "499\\d{5}",
                        ,
                        ,
                        ,
                        "49901234",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    "PF",
                    689,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3",
                            [
                                "44"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "4|8[7-9]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "8"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "44\\d{4}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "44\\d{4}",
                        ,
                        ,
                        ,
                        "440123",
                        ,
                        ,
                        [
                            6
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                PG: [
                    ,
                    [
                        ,
                        ,
                        "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:(?:3[0-2]|4[257]|5[34]|9[78])\\d|64[1-9]|85[02-46-9])\\d{4}",
                        ,
                        ,
                        ,
                        "3123456",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:7\\d|8[1-38])\\d{6}",
                        ,
                        ,
                        ,
                        "70123456",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "180\\d{4}",
                        ,
                        ,
                        ,
                        "1801234",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "2(?:0[0-57]|7[568])\\d{4}",
                        ,
                        ,
                        ,
                        "2751234",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    "PG",
                    675,
                    "00|140[1-3]",
                    ,
                    ,
                    ,
                    ,
                    ,
                    "00",
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1 $2",
                            [
                                "18|[2-69]|85"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{4})",
                            "$1 $2",
                            [
                                "[78]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        "27[01]\\d{4}",
                        ,
                        ,
                        ,
                        "2700123",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                PH: [
                    ,
                    [
                        ,
                        ,
                        "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            6,
                            8,
                            9,
                            10,
                            11,
                            12,
                            13
                        ],
                        [
                            4,
                            5,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|(?:2|8[2-8]\\d\\d)\\d{5}",
                        ,
                        ,
                        ,
                        "232345678",
                        ,
                        ,
                        [
                            6,
                            8,
                            9,
                            10
                        ],
                        [
                            4,
                            5,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}",
                        ,
                        ,
                        ,
                        "9051234567",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "1800\\d{7,9}",
                        ,
                        ,
                        ,
                        "180012345678",
                        ,
                        ,
                        [
                            11,
                            12,
                            13
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "PH",
                    63,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d)(\\d{5})",
                            "$1 $2",
                            [
                                "2"
                            ],
                            "(0$1)"
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{4,6})",
                            "$1 $2",
                            [
                                "3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2",
                                "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
                            ],
                            "(0$1)"
                        ],
                        [
                            ,
                            "(\\d{5})(\\d{4})",
                            "$1 $2",
                            [
                                "346|4(?:27|9[35])|883",
                                "3469|4(?:279|9(?:30|56))|8834"
                            ],
                            "(0$1)"
                        ],
                        [
                            ,
                            "(\\d)(\\d{4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "2"
                            ],
                            "(0$1)"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[3-7]|8[2-8]"
                            ],
                            "(0$1)"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[89]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "1"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})",
                            "$1 $2 $3 $4",
                            [
                                "1"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                PK: [
                    ,
                    [
                        ,
                        ,
                        "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8,
                            9,
                            10,
                            11,
                            12
                        ],
                        [
                            5,
                            6,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}",
                        ,
                        ,
                        ,
                        "2123456789",
                        ,
                        ,
                        [
                            9,
                            10
                        ],
                        [
                            5,
                            6,
                            7,
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "3(?:[0-247]\\d|3[0-79]|55|64)\\d{7}",
                        ,
                        ,
                        ,
                        "3012345678",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "800\\d{5}(?:\\d{3})?",
                        ,
                        ,
                        ,
                        "80012345",
                        ,
                        ,
                        [
                            8,
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        "900\\d{5}",
                        ,
                        ,
                        ,
                        "90012345",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "122\\d{6}",
                        ,
                        ,
                        ,
                        "122044444",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "PK",
                    92,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{2,7})",
                            "$1 $2 $3",
                            [
                                "[89]0"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{5})",
                            "$1 $2",
                            [
                                "1"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{6,7})",
                            "$1 $2",
                            [
                                "2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])",
                                "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"
                            ],
                            "(0$1)"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{7,8})",
                            "$1 $2",
                            [
                                "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"
                            ],
                            "(0$1)"
                        ],
                        [
                            ,
                            "(\\d{5})(\\d{5})",
                            "$1 $2",
                            [
                                "58"
                            ],
                            "(0$1)"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{7})",
                            "$1 $2",
                            [
                                "3"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3 $4",
                            [
                                "2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"
                            ],
                            "(0$1)"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3 $4",
                            [
                                "[24-9]"
                            ],
                            "(0$1)"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}",
                        ,
                        ,
                        ,
                        "21111825888",
                        ,
                        ,
                        [
                            11,
                            12
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                PL: [
                    ,
                    [
                        ,
                        ,
                        "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            6,
                            7,
                            8,
                            9,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))",
                        ,
                        ,
                        ,
                        "123456789",
                        ,
                        ,
                        [
                            7,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "21(?:1[013-5]|2\\d)\\d{5}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}",
                        ,
                        ,
                        ,
                        "512345678",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "800\\d{6,7}",
                        ,
                        ,
                        ,
                        "800123456",
                        ,
                        ,
                        [
                            9,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "70[01346-8]\\d{6}",
                        ,
                        ,
                        ,
                        "701234567",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "801\\d{6}",
                        ,
                        ,
                        ,
                        "801234567",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "39\\d{7}",
                        ,
                        ,
                        ,
                        "391234567",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    "PL",
                    48,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{5})",
                            "$1",
                            [
                                "19"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})",
                            "$1 $2",
                            [
                                "11|20|64"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1",
                                "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{2,3})",
                            "$1 $2 $3",
                            [
                                "64"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "1[2-8]|[2-7]|8[1-79]|9[145]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "8"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        "64\\d{4,7}",
                        ,
                        ,
                        ,
                        "641234567",
                        ,
                        ,
                        [
                            6,
                            7,
                            8,
                            9
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "804\\d{6}",
                        ,
                        ,
                        ,
                        "804123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                PM: [
                    ,
                    [
                        ,
                        ,
                        "[45]\\d{5}|(?:708|80\\d)\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            6,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:4[1-35-7]|5[01])\\d{4}",
                        ,
                        ,
                        ,
                        "430123",
                        ,
                        ,
                        [
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:4[02-4]|5[056]|708[45][0-5])\\d{4}",
                        ,
                        ,
                        ,
                        "551234"
                    ],
                    [
                        ,
                        ,
                        "80[0-5]\\d{6}",
                        ,
                        ,
                        ,
                        "800012345",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "PM",
                    508,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3",
                            [
                                "[45]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "7"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "8"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                PR: [
                    ,
                    [
                        ,
                        ,
                        "(?:[589]\\d\\d|787)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:787|939)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "7872345678",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:787|939)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "7872345678",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "8002345678"
                    ],
                    [
                        ,
                        ,
                        "900[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "9002345678"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "5002345678"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "PR",
                    1,
                    "011",
                    "1",
                    ,
                    ,
                    "1",
                    ,
                    ,
                    1,
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    "787|939",
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                PS: [
                    ,
                    [
                        ,
                        ,
                        "[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8,
                            9,
                            10
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}",
                        ,
                        ,
                        ,
                        "22234567",
                        ,
                        ,
                        [
                            8
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "5[69]\\d{7}",
                        ,
                        ,
                        ,
                        "599123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "1800\\d{6}",
                        ,
                        ,
                        ,
                        "1800123456",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "1700\\d{6}",
                        ,
                        ,
                        ,
                        "1700123456",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "PS",
                    970,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[2489]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "5"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "1"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                PT: [
                    ,
                    [
                        ,
                        ,
                        "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "2(?:[12]\\d|3[1-689]|4[1-59]|[57][1-9]|6[1-35689]|8[1-69]|9[1256])\\d{6}",
                        ,
                        ,
                        ,
                        "212345678"
                    ],
                    [
                        ,
                        ,
                        "6(?:[06]92(?:30|9\\d)|[35]92(?:[049]\\d|3[034]))\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}",
                        ,
                        ,
                        ,
                        "912345678"
                    ],
                    [
                        ,
                        ,
                        "80[02]\\d{6}",
                        ,
                        ,
                        ,
                        "800123456"
                    ],
                    [
                        ,
                        ,
                        "(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}",
                        ,
                        ,
                        ,
                        "760123456"
                    ],
                    [
                        ,
                        ,
                        "80(?:8\\d|9[1579])\\d{5}",
                        ,
                        ,
                        ,
                        "808123456"
                    ],
                    [
                        ,
                        ,
                        "884[0-4689]\\d{5}",
                        ,
                        ,
                        ,
                        "884123456"
                    ],
                    [
                        ,
                        ,
                        "30\\d{7}",
                        ,
                        ,
                        ,
                        "301234567"
                    ],
                    "PT",
                    351,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "2[12]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "16|[236-9]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        "6(?:222\\d|8988)\\d{4}",
                        ,
                        ,
                        ,
                        "622212345"
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "70(?:38[01]|596|(?:7\\d|8[17])\\d)\\d{4}",
                        ,
                        ,
                        ,
                        "707123456"
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "600\\d{6}|6[06]92(?:0\\d|3[349]|49)\\d{3}",
                        ,
                        ,
                        ,
                        "600110000"
                    ]
                ],
                PW: [
                    ,
                    [
                        ,
                        ,
                        "(?:[24-8]\\d\\d|345|900)\\d{4}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}",
                        ,
                        ,
                        ,
                        "2771234"
                    ],
                    [
                        ,
                        ,
                        "(?:(?:46|83)[0-5]|6[2-4689]0)\\d{4}|(?:45|77|88)\\d{5}",
                        ,
                        ,
                        ,
                        "6201234"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "PW",
                    680,
                    "01[12]",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1 $2",
                            [
                                "[2-9]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                PY: [
                    ,
                    [
                        ,
                        ,
                        "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            6,
                            7,
                            8,
                            9,
                            10,
                            11
                        ],
                        [
                            5
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:2[4-68]|[4-68]\\d|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}",
                        ,
                        ,
                        ,
                        "212345678",
                        ,
                        ,
                        [
                            7,
                            8,
                            9
                        ],
                        [
                            5,
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "9(?:51|6[129]|7[1-6]|8[1-7]|9[1-5])\\d{6}",
                        ,
                        ,
                        ,
                        "961456789",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "9800\\d{5,7}",
                        ,
                        ,
                        ,
                        "98000123456",
                        ,
                        ,
                        [
                            9,
                            10,
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "8700[0-4]\\d{4}",
                        ,
                        ,
                        ,
                        "870012345",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    "PY",
                    595,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{3,6})",
                            "$1 $2",
                            [
                                "[2-9]0"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{5})",
                            "$1 $2",
                            [
                                "[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"
                            ],
                            "(0$1)"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{4,5})",
                            "$1 $2",
                            [
                                "2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"
                            ],
                            "(0$1)"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"
                            ],
                            "(0$1)"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "87"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{6})",
                            "$1 $2",
                            [
                                "9(?:[5-79]|8[1-7])"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[2-8]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "9"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "[2-9]0\\d{4,7}",
                        ,
                        ,
                        ,
                        "201234567",
                        ,
                        ,
                        [
                            6,
                            7,
                            8,
                            9
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                QA: [
                    ,
                    [
                        ,
                        ,
                        "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            8,
                            9,
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        "4(?:1111|2022)\\d{3}|4(?:[04]\\d\\d|14[0-6]|999)\\d{4}",
                        ,
                        ,
                        ,
                        "44123456",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "[35-7]\\d{7}",
                        ,
                        ,
                        ,
                        "33123456",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "800\\d{4}|(?:0080[01]|800)\\d{6}",
                        ,
                        ,
                        ,
                        "8001234",
                        ,
                        ,
                        [
                            7,
                            9,
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "QA",
                    974,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1 $2",
                            [
                                "2[16]|8"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{4})",
                            "$1 $2",
                            [
                                "[3-7]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        "2[16]\\d{5}",
                        ,
                        ,
                        ,
                        "2123456",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                RE: [
                    ,
                    [
                        ,
                        ,
                        "(?:26|[689]\\d)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}",
                        ,
                        ,
                        ,
                        "262161234"
                    ],
                    [
                        ,
                        ,
                        "69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}",
                        ,
                        ,
                        ,
                        "692123456"
                    ],
                    [
                        ,
                        ,
                        "80\\d{7}",
                        ,
                        ,
                        ,
                        "801234567"
                    ],
                    [
                        ,
                        ,
                        "89[1-37-9]\\d{6}",
                        ,
                        ,
                        ,
                        "891123456"
                    ],
                    [
                        ,
                        ,
                        "8(?:1[019]|2[0156]|84|90)\\d{6}",
                        ,
                        ,
                        ,
                        "810123456"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "9(?:399[0-3]|479[0-5]|76(?:2[278]|3[0-37]))\\d{4}",
                        ,
                        ,
                        ,
                        "939901234"
                    ],
                    "RE",
                    262,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[2689]"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    1,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                RO: [
                    ,
                    [
                        ,
                        ,
                        "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            6,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d",
                        ,
                        ,
                        ,
                        "211234567"
                    ],
                    [
                        ,
                        ,
                        "(?:630|702)0\\d{5}|(?:6(?:[04]0|2\\d)|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[0-39]))\\d{6}",
                        ,
                        ,
                        ,
                        "712034567",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "800\\d{6}",
                        ,
                        ,
                        ,
                        "800123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "90[0136]\\d{6}",
                        ,
                        ,
                        ,
                        "900123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "801\\d{6}",
                        ,
                        ,
                        ,
                        "801123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "RO",
                    40,
                    "00",
                    "0",
                    " int ",
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{3})",
                            "$1 $2",
                            [
                                "2[3-6]",
                                "2[3-6]\\d9"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{4})",
                            "$1 $2",
                            [
                                "219|31"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[23]1"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[236-9]"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:37\\d|80[578])\\d{6}",
                        ,
                        ,
                        ,
                        "372123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                RS: [
                    ,
                    [
                        ,
                        ,
                        "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            6,
                            7,
                            8,
                            9,
                            10,
                            11,
                            12
                        ],
                        [
                            4,
                            5
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}",
                        ,
                        ,
                        ,
                        "10234567",
                        ,
                        ,
                        [
                            7,
                            8,
                            9,
                            10,
                            11,
                            12
                        ],
                        [
                            4,
                            5,
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "6(?:[0-689]|7\\d)\\d{6,7}",
                        ,
                        ,
                        ,
                        "601234567",
                        ,
                        ,
                        [
                            8,
                            9,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "800\\d{3,9}",
                        ,
                        ,
                        ,
                        "80012345"
                    ],
                    [
                        ,
                        ,
                        "(?:78\\d|90[0169])\\d{3,7}",
                        ,
                        ,
                        ,
                        "90012345",
                        ,
                        ,
                        [
                            6,
                            7,
                            8,
                            9,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "RS",
                    381,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{3,9})",
                            "$1 $2",
                            [
                                "(?:2[389]|39)0|[7-9]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{5,10})",
                            "$1 $2",
                            [
                                "[1-36]"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "7[06]\\d{4,10}",
                        ,
                        ,
                        ,
                        "700123456"
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                RU: [
                    ,
                    [
                        ,
                        ,
                        "8\\d{13}|[347-9]\\d{9}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10,
                            14
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}",
                        ,
                        ,
                        ,
                        "3011234567",
                        ,
                        ,
                        [
                            10
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "9\\d{9}",
                        ,
                        ,
                        ,
                        "9123456789",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "8(?:0[04]|108\\d{3})\\d{7}",
                        ,
                        ,
                        ,
                        "8001234567"
                    ],
                    [
                        ,
                        ,
                        "80[39]\\d{7}",
                        ,
                        ,
                        ,
                        "8091234567",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "808\\d{7}",
                        ,
                        ,
                        ,
                        "8081234567",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "RU",
                    7,
                    "810",
                    "8",
                    ,
                    ,
                    "8",
                    ,
                    "8~10",
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{2})",
                            "$1-$2-$3",
                            [
                                "[0-79]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "7(?:1[0-8]|2[1-9])",
                                "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))",
                                "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                            ],
                            "8 ($1)",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "7(?:1[0-68]|2[1-9])",
                                "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                                "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                            ],
                            "8 ($1)",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "7"
                            ],
                            "8 ($1)",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                            "$1 $2-$3-$4",
                            [
                                "[349]|8(?:[02-7]|1[1-8])"
                            ],
                            "8 ($1)",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                            "$1 $2 $3 $4",
                            [
                                "8"
                            ],
                            "8 ($1)"
                        ]
                    ],
                    [
                        [
                            ,
                            "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "7(?:1[0-8]|2[1-9])",
                                "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))",
                                "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                            ],
                            "8 ($1)",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "7(?:1[0-68]|2[1-9])",
                                "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                                "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                            ],
                            "8 ($1)",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "7"
                            ],
                            "8 ($1)",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                            "$1 $2-$3-$4",
                            [
                                "[349]|8(?:[02-7]|1[1-8])"
                            ],
                            "8 ($1)",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                            "$1 $2 $3 $4",
                            [
                                "8"
                            ],
                            "8 ($1)"
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    1,
                    "3[04-689]|[489]",
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                RW: [
                    ,
                    [
                        ,
                        ,
                        "(?:06|[27]\\d\\d|[89]00)\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:06|2[23568]\\d)\\d{6}",
                        ,
                        ,
                        ,
                        "250123456"
                    ],
                    [
                        ,
                        ,
                        "7[237-9]\\d{7}",
                        ,
                        ,
                        ,
                        "720123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "800\\d{6}",
                        ,
                        ,
                        ,
                        "800123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "900\\d{6}",
                        ,
                        ,
                        ,
                        "900123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "RW",
                    250,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "0"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "2"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[7-9]"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                SA: [
                    ,
                    [
                        ,
                        ,
                        "92\\d{7}|(?:[15]|8\\d)\\d{8}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9,
                            10
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}",
                        ,
                        ,
                        ,
                        "112345678",
                        ,
                        ,
                        [
                            9
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "579[01]\\d{5}|5(?:[013-689]\\d|7[0-8])\\d{6}",
                        ,
                        ,
                        ,
                        "512345678",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "800\\d{7}",
                        ,
                        ,
                        ,
                        "8001234567",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "925\\d{6}",
                        ,
                        ,
                        ,
                        "925012345",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "920\\d{6}",
                        ,
                        ,
                        ,
                        "920012345",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "SA",
                    966,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{4})(\\d{5})",
                            "$1 $2",
                            [
                                "9"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "1"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "5"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "81"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "8"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "811\\d{7}",
                        ,
                        ,
                        ,
                        "8110123456",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                SB: [
                    ,
                    [
                        ,
                        ,
                        "[6-9]\\d{6}|[1-6]\\d{4}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            5,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}",
                        ,
                        ,
                        ,
                        "40123",
                        ,
                        ,
                        [
                            5
                        ]
                    ],
                    [
                        ,
                        ,
                        "48\\d{3}|(?:(?:6[89]|7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}",
                        ,
                        ,
                        ,
                        "7421234"
                    ],
                    [
                        ,
                        ,
                        "1[38]\\d{3}",
                        ,
                        ,
                        ,
                        "18123",
                        ,
                        ,
                        [
                            5
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "5[12]\\d{3}",
                        ,
                        ,
                        ,
                        "51123",
                        ,
                        ,
                        [
                            5
                        ]
                    ],
                    "SB",
                    677,
                    "0[01]",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{5})",
                            "$1 $2",
                            [
                                "6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                SC: [
                    ,
                    [
                        ,
                        ,
                        "(?:[2489]\\d|64)\\d{5}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "4[2-46]\\d{5}",
                        ,
                        ,
                        ,
                        "4217123"
                    ],
                    [
                        ,
                        ,
                        "2[125-8]\\d{5}",
                        ,
                        ,
                        ,
                        "2510123"
                    ],
                    [
                        ,
                        ,
                        "800[08]\\d{3}",
                        ,
                        ,
                        ,
                        "8000000"
                    ],
                    [
                        ,
                        ,
                        "85\\d{5}",
                        ,
                        ,
                        ,
                        "8512345"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "971\\d{4}|(?:64|95)\\d{5}",
                        ,
                        ,
                        ,
                        "6412345"
                    ],
                    "SC",
                    248,
                    "010|0[0-2]",
                    ,
                    ,
                    ,
                    ,
                    ,
                    "00",
                    ,
                    [
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[246]|9[57]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                SD: [
                    ,
                    [
                        ,
                        ,
                        "[19]\\d{8}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "1(?:5\\d|8[35-7])\\d{6}",
                        ,
                        ,
                        ,
                        "153123456"
                    ],
                    [
                        ,
                        ,
                        "(?:1[0-2]|9[0-3569])\\d{7}",
                        ,
                        ,
                        ,
                        "911231234"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "SD",
                    249,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[19]"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                SE: [
                    ,
                    [
                        ,
                        ,
                        "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            6,
                            7,
                            8,
                            9,
                            10,
                            12
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}",
                        ,
                        ,
                        ,
                        "8123456",
                        ,
                        ,
                        [
                            7,
                            8,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "7[02369]\\d{7}",
                        ,
                        ,
                        ,
                        "701234567",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "20\\d{4,7}",
                        ,
                        ,
                        ,
                        "20123456",
                        ,
                        ,
                        [
                            6,
                            7,
                            8,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "649\\d{6}|99[1-59]\\d{4}(?:\\d{3})?|9(?:00|39|44)[1-8]\\d{3,6}",
                        ,
                        ,
                        ,
                        "9001234567",
                        ,
                        ,
                        [
                            7,
                            8,
                            9,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "77[0-7]\\d{6}",
                        ,
                        ,
                        ,
                        "771234567",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "75[1-8]\\d{6}",
                        ,
                        ,
                        ,
                        "751234567",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "SE",
                    46,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{2,3})(\\d{2})",
                            "$1-$2 $3",
                            [
                                "20"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1-$2",
                            [
                                "9(?:00|39|44|9)"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{2})",
                            "$1-$2 $3",
                            [
                                "[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                            "$1-$2 $3 $4",
                            [
                                "8"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2,3})(\\d{2})",
                            "$1-$2 $3",
                            [
                                "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2,3})(\\d{3})",
                            "$1-$2 $3",
                            [
                                "9(?:00|39|44)"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                            "$1-$2 $3 $4",
                            [
                                "1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                            "$1-$2 $3 $4",
                            [
                                "10|7"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                            "$1-$2 $3 $4",
                            [
                                "8"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                            "$1-$2 $3 $4",
                            [
                                "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                            "$1-$2 $3 $4",
                            [
                                "9"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                            "$1-$2 $3 $4 $5",
                            [
                                "[26]"
                            ],
                            "0$1"
                        ]
                    ],
                    [
                        [
                            ,
                            "(\\d{2})(\\d{2,3})(\\d{2})",
                            "$1 $2 $3",
                            [
                                "20"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1 $2",
                            [
                                "9(?:00|39|44|9)"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{2})",
                            "$1 $2 $3",
                            [
                                "[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
                            ]
                        ],
                        [
                            ,
                            "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "8"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2,3})(\\d{2})",
                            "$1 $2 $3",
                            [
                                "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2,3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "9(?:00|39|44)"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "10|7"
                            ]
                        ],
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "8"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                            "$1 $2 $3 $4",
                            [
                                "9"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4 $5",
                            [
                                "[26]"
                            ]
                        ]
                    ],
                    [
                        ,
                        ,
                        "74[02-9]\\d{6}",
                        ,
                        ,
                        ,
                        "740123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "10[1-8]\\d{6}",
                        ,
                        ,
                        ,
                        "102345678",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "(?:25[245]|67[3-68])\\d{9}",
                        ,
                        ,
                        ,
                        "254123456789",
                        ,
                        ,
                        [
                            12
                        ]
                    ]
                ],
                SG: [
                    ,
                    [
                        ,
                        ,
                        "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8,
                            10,
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        "662[0-24-9]\\d{4}|6(?:[0-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}",
                        ,
                        ,
                        ,
                        "61234567",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "8(?:09[0-68]|95[0-2])\\d{4}|(?:8(?:0[1-8]|[1-8]\\d|9[0-4])|9[0-8]\\d)\\d{5}",
                        ,
                        ,
                        ,
                        "81234567",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:18|8)00\\d{7}",
                        ,
                        ,
                        ,
                        "18001234567",
                        ,
                        ,
                        [
                            10,
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        "1900\\d{7}",
                        ,
                        ,
                        ,
                        "19001234567",
                        ,
                        ,
                        [
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:3[12]\\d|666)\\d{5}",
                        ,
                        ,
                        ,
                        "31234567",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    "SG",
                    65,
                    "0[0-3]\\d",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{4,5})",
                            "$1",
                            [
                                "1[013-9]|77",
                                "1(?:[013-8]|9(?:0[1-9]|[1-9]))|77"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{4})",
                            "$1 $2",
                            [
                                "[369]|8(?:0[1-9]|[1-9])"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "8"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{4})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "7"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "1"
                            ]
                        ]
                    ],
                    [
                        [
                            ,
                            "(\\d{4})(\\d{4})",
                            "$1 $2",
                            [
                                "[369]|8(?:0[1-9]|[1-9])"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "8"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{4})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "7"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "1"
                            ]
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "7000\\d{7}",
                        ,
                        ,
                        ,
                        "70001234567",
                        ,
                        ,
                        [
                            11
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                SH: [
                    ,
                    [
                        ,
                        ,
                        "(?:[256]\\d|8)\\d{3}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            4,
                            5
                        ]
                    ],
                    [
                        ,
                        ,
                        "2(?:[0-57-9]\\d|6[4-9])\\d\\d",
                        ,
                        ,
                        ,
                        "22158"
                    ],
                    [
                        ,
                        ,
                        "[56]\\d{4}",
                        ,
                        ,
                        ,
                        "51234",
                        ,
                        ,
                        [
                            5
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "262\\d\\d",
                        ,
                        ,
                        ,
                        "26212",
                        ,
                        ,
                        [
                            5
                        ]
                    ],
                    "SH",
                    290,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    1,
                    "[256]",
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                SI: [
                    ,
                    [
                        ,
                        ,
                        "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            5,
                            6,
                            7,
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:[1-357][2-8]|4[24-8])\\d{6}",
                        ,
                        ,
                        ,
                        "12345678",
                        ,
                        ,
                        [
                            8
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "65(?:[178]\\d|5[56]|6[01])\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}",
                        ,
                        ,
                        ,
                        "31234567",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "80\\d{4,6}",
                        ,
                        ,
                        ,
                        "80123456",
                        ,
                        ,
                        [
                            6,
                            7,
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "89[1-3]\\d{2,5}|90\\d{4,6}",
                        ,
                        ,
                        ,
                        "90123456"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-589])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}",
                        ,
                        ,
                        ,
                        "59012345",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    "SI",
                    386,
                    "00|10(?:22|66|88|99)",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    "00",
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{3,6})",
                            "$1 $2",
                            [
                                "8[09]|9"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{5})",
                            "$1 $2",
                            [
                                "59|8"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[37][01]|4[0139]|51|6"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[1-57]"
                            ],
                            "(0$1)"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                SJ: [
                    ,
                    [
                        ,
                        ,
                        "0\\d{4}|(?:[489]\\d|79)\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            5,
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "79\\d{6}",
                        ,
                        ,
                        ,
                        "79123456",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:4[015-8]|9\\d)\\d{6}",
                        ,
                        ,
                        ,
                        "41234567",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "80[01]\\d{5}",
                        ,
                        ,
                        ,
                        "80012345",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "82[09]\\d{5}",
                        ,
                        ,
                        ,
                        "82012345",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "810(?:0[0-6]|[2-8]\\d)\\d{3}",
                        ,
                        ,
                        ,
                        "81021234",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "880\\d{5}",
                        ,
                        ,
                        ,
                        "88012345",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "85[0-5]\\d{5}",
                        ,
                        ,
                        ,
                        "85012345",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    "SJ",
                    47,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    "79",
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}",
                        ,
                        ,
                        ,
                        "02000"
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "81[23]\\d{5}",
                        ,
                        ,
                        ,
                        "81212345",
                        ,
                        ,
                        [
                            8
                        ]
                    ]
                ],
                SK: [
                    ,
                    [
                        ,
                        ,
                        "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            6,
                            7,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d",
                        ,
                        ,
                        ,
                        "221234567"
                    ],
                    [
                        ,
                        ,
                        "909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}",
                        ,
                        ,
                        ,
                        "912123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "800\\d{6}",
                        ,
                        ,
                        ,
                        "800123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "9(?:00|[78]\\d)\\d{6}",
                        ,
                        ,
                        ,
                        "900123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "8[5-9]\\d{7}",
                        ,
                        ,
                        ,
                        "850123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "6(?:02|5[0-4]|9[0-6])\\d{6}",
                        ,
                        ,
                        ,
                        "690123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    "SK",
                    421,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d)(\\d{2})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "21"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2,3})",
                            "$1 $2 $3",
                            [
                                "[3-5][1-8]1",
                                "[3-5][1-8]1[67]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{3})",
                            "$1 $2",
                            [
                                "909",
                                "9090"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                            "$1/$2 $3 $4",
                            [
                                "2"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[689]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                            "$1/$2 $3 $4",
                            [
                                "[3-5]"
                            ],
                            "0$1"
                        ]
                    ],
                    [
                        [
                            ,
                            "(\\d)(\\d{2})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "21"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2,3})",
                            "$1 $2 $3",
                            [
                                "[3-5][1-8]1",
                                "[3-5][1-8]1[67]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                            "$1/$2 $3 $4",
                            [
                                "2"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[689]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                            "$1/$2 $3 $4",
                            [
                                "[3-5]"
                            ],
                            "0$1"
                        ]
                    ],
                    [
                        ,
                        ,
                        "9090\\d{3}",
                        ,
                        ,
                        ,
                        "9090123",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "9090\\d{3}|(?:602|8(?:00|[5-9]\\d)|9(?:00|[78]\\d))\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "96\\d{7}",
                        ,
                        ,
                        ,
                        "961234567",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                SL: [
                    ,
                    [
                        ,
                        ,
                        "(?:[237-9]\\d|66)\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8
                        ],
                        [
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "22[2-4][2-9]\\d{4}",
                        ,
                        ,
                        ,
                        "22221234",
                        ,
                        ,
                        ,
                        [
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:25|3[0-5]|66|7[2-9]|8[08]|9[09])\\d{6}",
                        ,
                        ,
                        ,
                        "25123456"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "SL",
                    232,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{6})",
                            "$1 $2",
                            [
                                "[236-9]"
                            ],
                            "(0$1)"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                SM: [
                    ,
                    [
                        ,
                        ,
                        "(?:0549|[5-7]\\d)\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8,
                            10
                        ],
                        [
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "0549(?:8[0157-9]|9\\d)\\d{4}",
                        ,
                        ,
                        ,
                        "0549886377",
                        ,
                        ,
                        [
                            10
                        ],
                        [
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "6[16]\\d{6}",
                        ,
                        ,
                        ,
                        "66661212",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "7[178]\\d{6}",
                        ,
                        ,
                        ,
                        "71123456",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "5[158]\\d{6}",
                        ,
                        ,
                        ,
                        "58001110",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    "SM",
                    378,
                    "00",
                    ,
                    ,
                    ,
                    "([89]\\d{5})$",
                    "0549$1",
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{6})",
                            "$1",
                            [
                                "[89]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[5-7]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{6})",
                            "$1 $2",
                            [
                                "0"
                            ]
                        ]
                    ],
                    [
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[5-7]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{6})",
                            "$1 $2",
                            [
                                "0"
                            ]
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                SN: [
                    ,
                    [
                        ,
                        ,
                        "(?:[378]\\d|93)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}",
                        ,
                        ,
                        ,
                        "301012345"
                    ],
                    [
                        ,
                        ,
                        "7(?:(?:[06-8]\\d|21|90)\\d|5(?:01|[19]0|25|[38]3|[4-7]\\d))\\d{5}",
                        ,
                        ,
                        ,
                        "701234567"
                    ],
                    [
                        ,
                        ,
                        "800\\d{6}",
                        ,
                        ,
                        ,
                        "800123456"
                    ],
                    [
                        ,
                        ,
                        "88[4689]\\d{6}",
                        ,
                        ,
                        ,
                        "884123456"
                    ],
                    [
                        ,
                        ,
                        "81[02468]\\d{6}",
                        ,
                        ,
                        ,
                        "810123456"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:3(?:392|9[01]\\d)\\d|93(?:3[13]0|929))\\d{4}",
                        ,
                        ,
                        ,
                        "933301234"
                    ],
                    "SN",
                    221,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "8"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[379]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                SO: [
                    ,
                    [
                        ,
                        ,
                        "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            6,
                            7,
                            8,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}",
                        ,
                        ,
                        ,
                        "4012345",
                        ,
                        ,
                        [
                            6,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:(?:15|(?:3[59]|4[89]|6\\d|7[79]|8[08])\\d|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:[67]\\d\\d|904)\\d{5}",
                        ,
                        ,
                        ,
                        "71123456",
                        ,
                        ,
                        [
                            7,
                            8,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "SO",
                    252,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{4})",
                            "$1 $2",
                            [
                                "8[125]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{6})",
                            "$1",
                            [
                                "[134]"
                            ]
                        ],
                        [
                            ,
                            "(\\d)(\\d{6})",
                            "$1 $2",
                            [
                                "[15]|2[0-79]|3[0-46-8]|4[0-7]"
                            ]
                        ],
                        [
                            ,
                            "(\\d)(\\d{7})",
                            "$1 $2",
                            [
                                "(?:2|90)4|[67]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[348]|64|79|90"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{5,7})",
                            "$1 $2",
                            [
                                "1|28|6[0-35-9]|77|9[2-9]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                SR: [
                    ,
                    [
                        ,
                        ,
                        "(?:[2-5]|68|[78]\\d)\\d{5}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            6,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:2[1-3]|3[0-7]|(?:4|68)\\d|5[2-58])\\d{4}",
                        ,
                        ,
                        ,
                        "211234"
                    ],
                    [
                        ,
                        ,
                        "(?:7[124-7]|8[124-9])\\d{5}",
                        ,
                        ,
                        ,
                        "7412345",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "56\\d{4}",
                        ,
                        ,
                        ,
                        "561234",
                        ,
                        ,
                        [
                            6
                        ]
                    ],
                    "SR",
                    597,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})",
                            "$1-$2-$3",
                            [
                                "56"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})",
                            "$1-$2",
                            [
                                "[2-5]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1-$2",
                            [
                                "[6-8]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                SS: [
                    ,
                    [
                        ,
                        ,
                        "[19]\\d{8}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "1[89]\\d{7}",
                        ,
                        ,
                        ,
                        "181234567"
                    ],
                    [
                        ,
                        ,
                        "(?:12|9[1257-9])\\d{7}",
                        ,
                        ,
                        ,
                        "977123456"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "SS",
                    211,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[19]"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                ST: [
                    ,
                    [
                        ,
                        ,
                        "(?:22|9\\d)\\d{5}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "22\\d{5}",
                        ,
                        ,
                        ,
                        "2221234"
                    ],
                    [
                        ,
                        ,
                        "900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}",
                        ,
                        ,
                        ,
                        "9812345"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "ST",
                    239,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1 $2",
                            [
                                "[29]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                SV: [
                    ,
                    [
                        ,
                        ,
                        "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            8,
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        "2(?:79(?:0[0347-9]|[1-9]\\d)|89(?:0[024589]|[1-9]\\d))\\d{3}|2(?:[1-69]\\d|[78][0-8])\\d{5}",
                        ,
                        ,
                        ,
                        "21234567",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "[67]\\d{7}",
                        ,
                        ,
                        ,
                        "70123456",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "800\\d{8}|80[01]\\d{4}",
                        ,
                        ,
                        ,
                        "8001234",
                        ,
                        ,
                        [
                            7,
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        "900\\d{4}(?:\\d{4})?",
                        ,
                        ,
                        ,
                        "9001234",
                        ,
                        ,
                        [
                            7,
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "SV",
                    503,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1 $2",
                            [
                                "[89]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{4})",
                            "$1 $2",
                            [
                                "[267]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[89]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                SX: [
                    ,
                    [
                        ,
                        ,
                        "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "7215(?:4[2-8]|8[239]|9[056])\\d{4}",
                        ,
                        ,
                        ,
                        "7215425678",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}",
                        ,
                        ,
                        ,
                        "7215205678",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "8002123456"
                    ],
                    [
                        ,
                        ,
                        "900[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "9002123456"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "5002345678"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "SX",
                    1,
                    "011",
                    "1",
                    ,
                    ,
                    "(5\\d{6})$|1",
                    "721$1",
                    ,
                    ,
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    "721",
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                SY: [
                    ,
                    [
                        ,
                        ,
                        "[1-39]\\d{8}|[1-5]\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8,
                            9
                        ],
                        [
                            6,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}",
                        ,
                        ,
                        ,
                        "112345678",
                        ,
                        ,
                        ,
                        [
                            6,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "9[1-689]\\d{7}",
                        ,
                        ,
                        ,
                        "944567890",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "SY",
                    963,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "[1-5]"
                            ],
                            "0$1",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "9"
                            ],
                            "0$1",
                            ,
                            1
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                SZ: [
                    ,
                    [
                        ,
                        ,
                        "0800\\d{4}|(?:[237]\\d|900)\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "[23][2-5]\\d{6}",
                        ,
                        ,
                        ,
                        "22171234",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "7[6-9]\\d{6}",
                        ,
                        ,
                        ,
                        "76123456",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "0800\\d{4}",
                        ,
                        ,
                        ,
                        "08001234",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "900\\d{6}",
                        ,
                        ,
                        ,
                        "900012345",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "70\\d{6}",
                        ,
                        ,
                        ,
                        "70012345",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    "SZ",
                    268,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{4})(\\d{4})",
                            "$1 $2",
                            [
                                "[0237]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{5})(\\d{4})",
                            "$1 $2",
                            [
                                "9"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "0800\\d{4}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                TA: [
                    ,
                    [
                        ,
                        ,
                        "8\\d{3}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            4
                        ]
                    ],
                    [
                        ,
                        ,
                        "8\\d{3}",
                        ,
                        ,
                        ,
                        "8999"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "TA",
                    290,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    "8",
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                TC: [
                    ,
                    [
                        ,
                        ,
                        "(?:[58]\\d\\d|649|900)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "649(?:266|712|9(?:4\\d|50))\\d{4}",
                        ,
                        ,
                        ,
                        "6497121234",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}",
                        ,
                        ,
                        ,
                        "6492311234",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "8002345678"
                    ],
                    [
                        ,
                        ,
                        "900[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "9002345678"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "5002345678"
                    ],
                    [
                        ,
                        ,
                        "649(?:71[01]|966)\\d{4}",
                        ,
                        ,
                        ,
                        "6497101234",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    "TC",
                    1,
                    "011",
                    "1",
                    ,
                    ,
                    "([2-479]\\d{6})$|1",
                    "649$1",
                    ,
                    ,
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    "649",
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                TD: [
                    ,
                    [
                        ,
                        ,
                        "(?:22|[689]\\d|77)\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "22(?:[37-9]0|5[0-5]|6[89])\\d{4}",
                        ,
                        ,
                        ,
                        "22501234"
                    ],
                    [
                        ,
                        ,
                        "(?:[69]\\d|77|8[56])\\d{6}",
                        ,
                        ,
                        ,
                        "63012345"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "TD",
                    235,
                    "00|16",
                    ,
                    ,
                    ,
                    ,
                    ,
                    "00",
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[26-9]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                TG: [
                    ,
                    [
                        ,
                        ,
                        "[279]\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}",
                        ,
                        ,
                        ,
                        "22212345"
                    ],
                    [
                        ,
                        ,
                        "(?:7[019]|9[0-36-9])\\d{6}",
                        ,
                        ,
                        ,
                        "90112345"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "TG",
                    228,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[279]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                TH: [
                    ,
                    [
                        ,
                        ,
                        "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8,
                            9,
                            10,
                            13
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}",
                        ,
                        ,
                        ,
                        "21234567",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "67(?:1[0-8]|2[4-7])\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}",
                        ,
                        ,
                        ,
                        "812345678",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:001800\\d|1800)\\d{6}",
                        ,
                        ,
                        ,
                        "1800123456",
                        ,
                        ,
                        [
                            10,
                            13
                        ]
                    ],
                    [
                        ,
                        ,
                        "1900\\d{6}",
                        ,
                        ,
                        ,
                        "1900123456",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "6[08]\\d{7}",
                        ,
                        ,
                        ,
                        "601234567",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    "TH",
                    66,
                    "00[1-9]",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "2"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "[13-9]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "1"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                TJ: [
                    ,
                    [
                        ,
                        ,
                        "[0-57-9]\\d{8}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9
                        ],
                        [
                            3,
                            5,
                            6,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}",
                        ,
                        ,
                        ,
                        "372123456",
                        ,
                        ,
                        ,
                        [
                            3,
                            5,
                            6,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:33[03-9]|4(?:1[18]|4[02-479])|81[1-9])\\d{6}|(?:0[0-57-9]|1[017]|2[02]|[34]0|5[05]|7[01578]|8[078]|9\\d)\\d{7}",
                        ,
                        ,
                        ,
                        "917123456"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "TJ",
                    992,
                    "810",
                    ,
                    ,
                    ,
                    ,
                    ,
                    "8~10",
                    ,
                    [
                        [
                            ,
                            "(\\d{6})(\\d)(\\d{2})",
                            "$1 $2 $3",
                            [
                                "331",
                                "3317"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "44[02-479]|[34]7"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d)(\\d{4})",
                            "$1 $2 $3",
                            [
                                "3(?:[1245]|3[12])"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[0-57-9]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                TK: [
                    ,
                    [
                        ,
                        ,
                        "[2-47]\\d{3,6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            4,
                            5,
                            6,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:2[2-4]|[34]\\d)\\d{2,5}",
                        ,
                        ,
                        ,
                        "3101"
                    ],
                    [
                        ,
                        ,
                        "7[2-4]\\d{2,5}",
                        ,
                        ,
                        ,
                        "7290"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "TK",
                    690,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                TL: [
                    ,
                    [
                        ,
                        ,
                        "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:2[1-5]|3[1-9]|4[1-4])\\d{5}",
                        ,
                        ,
                        ,
                        "2112345",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "7[2-8]\\d{6}",
                        ,
                        ,
                        ,
                        "77212345",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "80\\d{5}",
                        ,
                        ,
                        ,
                        "8012345",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "90\\d{5}",
                        ,
                        ,
                        ,
                        "9012345",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "70\\d{5}",
                        ,
                        ,
                        ,
                        "7012345",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "TL",
                    670,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1 $2",
                            [
                                "[2-489]|70"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{4})",
                            "$1 $2",
                            [
                                "7"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                TM: [
                    ,
                    [
                        ,
                        ,
                        "(?:[1-6]\\d|71)\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}",
                        ,
                        ,
                        ,
                        "12345678"
                    ],
                    [
                        ,
                        ,
                        "(?:6\\d|71)\\d{6}",
                        ,
                        ,
                        ,
                        "66123456"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "TM",
                    993,
                    "810",
                    "8",
                    ,
                    ,
                    "8",
                    ,
                    "8~10",
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2-$3-$4",
                            [
                                "12"
                            ],
                            "(8 $1)"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                            "$1 $2-$3-$4",
                            [
                                "[1-5]"
                            ],
                            "(8 $1)"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{6})",
                            "$1 $2",
                            [
                                "[67]"
                            ],
                            "8 $1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                TN: [
                    ,
                    [
                        ,
                        ,
                        "[2-57-9]\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}",
                        ,
                        ,
                        ,
                        "30010123"
                    ],
                    [
                        ,
                        ,
                        "3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-8])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}",
                        ,
                        ,
                        ,
                        "20123456"
                    ],
                    [
                        ,
                        ,
                        "8010\\d{4}",
                        ,
                        ,
                        ,
                        "80101234"
                    ],
                    [
                        ,
                        ,
                        "88\\d{6}",
                        ,
                        ,
                        ,
                        "88123456"
                    ],
                    [
                        ,
                        ,
                        "8[12]10\\d{4}",
                        ,
                        ,
                        ,
                        "81101234"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "TN",
                    216,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[2-57-9]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                TO: [
                    ,
                    [
                        ,
                        ,
                        "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            5,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}",
                        ,
                        ,
                        ,
                        "20123",
                        ,
                        ,
                        [
                            5
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:5(?:4[0-5]|5[4-6])|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}",
                        ,
                        ,
                        ,
                        "7715123",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "0800\\d{3}",
                        ,
                        ,
                        ,
                        "0800222",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "55[0-37-9]\\d{4}",
                        ,
                        ,
                        ,
                        "5510123",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    "TO",
                    676,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{3})",
                            "$1-$2",
                            [
                                "[2-4]|50|6[09]|7[0-24-69]|8[05]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{3})",
                            "$1 $2",
                            [
                                "0"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1 $2",
                            [
                                "[5-9]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                TR: [
                    ,
                    [
                        ,
                        ,
                        "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            10,
                            12,
                            13
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}",
                        ,
                        ,
                        ,
                        "2123456789",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "561(?:011|61\\d)\\d{4}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}",
                        ,
                        ,
                        ,
                        "5012345678",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "8(?:00\\d{7}(?:\\d{2,3})?|11\\d{7})",
                        ,
                        ,
                        ,
                        "8001234567",
                        ,
                        ,
                        [
                            10,
                            12,
                            13
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:8[89]8|900)\\d{7}",
                        ,
                        ,
                        ,
                        "9001234567",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "592(?:21[12]|461)\\d{4}",
                        ,
                        ,
                        ,
                        "5922121234",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "850\\d{7}",
                        ,
                        ,
                        ,
                        "8500123456",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    "TR",
                    90,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d)(\\d{3})",
                            "$1 $2 $3",
                            [
                                "444"
                            ],
                            ,
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "512|8[01589]|90"
                            ],
                            "0$1",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "5(?:[0-59]|61)",
                                "5(?:[0-59]|61[06])",
                                "5(?:[0-59]|61[06]1)"
                            ],
                            "0$1",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[24][1-8]|3[1-9]"
                            ],
                            "(0$1)",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{6,7})",
                            "$1 $2 $3",
                            [
                                "80"
                            ],
                            "0$1",
                            ,
                            1
                        ]
                    ],
                    [
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "512|8[01589]|90"
                            ],
                            "0$1",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "5(?:[0-59]|61)",
                                "5(?:[0-59]|61[06])",
                                "5(?:[0-59]|61[06]1)"
                            ],
                            "0$1",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[24][1-8]|3[1-9]"
                            ],
                            "(0$1)",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{6,7})",
                            "$1 $2 $3",
                            [
                                "80"
                            ],
                            "0$1",
                            ,
                            1
                        ]
                    ],
                    [
                        ,
                        ,
                        "512\\d{7}",
                        ,
                        ,
                        ,
                        "5123456789",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "(?:444|811\\d{3})\\d{4}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "444\\d{4}",
                        ,
                        ,
                        ,
                        "4441444",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                TT: [
                    ,
                    [
                        ,
                        ,
                        "(?:[58]\\d\\d|900)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "868(?:2(?:01|1[5-9]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}",
                        ,
                        ,
                        ,
                        "8682211234",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}",
                        ,
                        ,
                        ,
                        "8682911234",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "8002345678"
                    ],
                    [
                        ,
                        ,
                        "900[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "9002345678"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "5002345678"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "TT",
                    1,
                    "011",
                    "1",
                    ,
                    ,
                    "([2-46-8]\\d{6})$|1",
                    "868$1",
                    ,
                    ,
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    "868",
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "868619\\d{4}",
                        ,
                        ,
                        ,
                        "8686191234",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ]
                ],
                TV: [
                    ,
                    [
                        ,
                        ,
                        "(?:2|7\\d\\d|90)\\d{4}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            5,
                            6,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "2[02-9]\\d{3}",
                        ,
                        ,
                        ,
                        "20123",
                        ,
                        ,
                        [
                            5
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:7[01]\\d|90)\\d{4}",
                        ,
                        ,
                        ,
                        "901234",
                        ,
                        ,
                        [
                            6,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "TV",
                    688,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{3})",
                            "$1 $2",
                            [
                                "2"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{4})",
                            "$1 $2",
                            [
                                "90"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{5})",
                            "$1 $2",
                            [
                                "7"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                TW: [
                    ,
                    [
                        ,
                        ,
                        "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            8,
                            9,
                            10,
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}",
                        ,
                        ,
                        ,
                        "221234567",
                        ,
                        ,
                        [
                            8,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:40001[0-2]|9[0-8]\\d{4})\\d{3}",
                        ,
                        ,
                        ,
                        "912345678",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "80[0-79]\\d{6}|800\\d{5}",
                        ,
                        ,
                        ,
                        "800123456",
                        ,
                        ,
                        [
                            8,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "20(?:[013-9]\\d\\d|2)\\d{4}",
                        ,
                        ,
                        ,
                        "203123456",
                        ,
                        ,
                        [
                            7,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "99\\d{7}",
                        ,
                        ,
                        ,
                        "990123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}",
                        ,
                        ,
                        ,
                        "7012345678",
                        ,
                        ,
                        [
                            10,
                            11
                        ]
                    ],
                    "TW",
                    886,
                    "0(?:0[25-79]|19)",
                    "0",
                    "#",
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d)(\\d{4})",
                            "$1 $2 $3",
                            [
                                "202"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "[258]0"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d)(\\d{3,4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]",
                                "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[49]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{4})(\\d{4,5})",
                            "$1 $2 $3",
                            [
                                "7"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "50[0-46-9]\\d{6}",
                        ,
                        ,
                        ,
                        "500123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                TZ: [
                    ,
                    [
                        ,
                        ,
                        "(?:[25-8]\\d|41|90)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "2[2-8]\\d{7}",
                        ,
                        ,
                        ,
                        "222345678"
                    ],
                    [
                        ,
                        ,
                        "(?:6[125-9]|7[13-9])\\d{7}",
                        ,
                        ,
                        ,
                        "621234567"
                    ],
                    [
                        ,
                        ,
                        "80[08]\\d{6}",
                        ,
                        ,
                        ,
                        "800123456"
                    ],
                    [
                        ,
                        ,
                        "90\\d{7}",
                        ,
                        ,
                        ,
                        "900123456"
                    ],
                    [
                        ,
                        ,
                        "8(?:40|6[01])\\d{6}",
                        ,
                        ,
                        ,
                        "840123456"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "41\\d{7}",
                        ,
                        ,
                        ,
                        "412345678"
                    ],
                    "TZ",
                    255,
                    "00[056]",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[89]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[24]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{7})",
                            "$1 $2",
                            [
                                "5"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[67]"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "(?:8(?:[04]0|6[01])|90\\d)\\d{6}"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                UA: [
                    ,
                    [
                        ,
                        ,
                        "[89]\\d{9}|[3-9]\\d{8}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9,
                            10
                        ],
                        [
                            5,
                            6,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}",
                        ,
                        ,
                        ,
                        "311234567",
                        ,
                        ,
                        [
                            9
                        ],
                        [
                            5,
                            6,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:39|50|6[36-8]|7[1-357]|9[1-9])\\d{7}",
                        ,
                        ,
                        ,
                        "501234567",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "800[1-8]\\d{5,6}",
                        ,
                        ,
                        ,
                        "800123456"
                    ],
                    [
                        ,
                        ,
                        "900[239]\\d{5,6}",
                        ,
                        ,
                        ,
                        "900212345"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "89[1-579]\\d{6}",
                        ,
                        ,
                        ,
                        "891234567",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    "UA",
                    380,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    "0~0",
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]",
                                "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{5})",
                            "$1 $2",
                            [
                                "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])",
                                "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[3-7]|89|9[1-9]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "[89]"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                UG: [
                    ,
                    [
                        ,
                        ,
                        "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9
                        ],
                        [
                            5,
                            6,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "20(?:(?:240|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[017]\\d|2[5-9]|3[1-4]|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}",
                        ,
                        ,
                        ,
                        "312345678",
                        ,
                        ,
                        ,
                        [
                            5,
                            6,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "72(?:[48]0|6[01])\\d{5}|7(?:[015-8]\\d|20|36|4[0-5]|9[89])\\d{6}",
                        ,
                        ,
                        ,
                        "712345678"
                    ],
                    [
                        ,
                        ,
                        "800[1-3]\\d{5}",
                        ,
                        ,
                        ,
                        "800123456"
                    ],
                    [
                        ,
                        ,
                        "90[1-3]\\d{6}",
                        ,
                        ,
                        ,
                        "901123456"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "UG",
                    256,
                    "00[057]",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{4})(\\d{5})",
                            "$1 $2",
                            [
                                "202",
                                "2024"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{6})",
                            "$1 $2",
                            [
                                "[27-9]|4(?:6[45]|[7-9])"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{7})",
                            "$1 $2",
                            [
                                "[34]"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                US: [
                    ,
                    [
                        ,
                        ,
                        "[2-9]\\d{9}|3\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[468])|7302[0-4]\\d)\\d{4}|(?:305[3-9]|472[24]|505[2-57-9]|7306|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "2015550123",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[468])|7302[0-4]\\d)\\d{4}|(?:305[3-9]|472[24]|505[2-57-9]|7306|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "2015550123",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "8002345678"
                    ],
                    [
                        ,
                        ,
                        "900[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "9002345678"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "5002345678"
                    ],
                    [
                        ,
                        ,
                        "305209\\d{4}",
                        ,
                        ,
                        ,
                        "3052090123",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    "US",
                    1,
                    "011",
                    "1",
                    ,
                    ,
                    "1",
                    ,
                    ,
                    1,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1-$2",
                            [
                                "310"
                            ],
                            ,
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1-$2",
                            [
                                "[24-9]|3(?:[02-9]|1[1-9])"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "($1) $2-$3",
                            [
                                "[2-9]"
                            ],
                            ,
                            ,
                            1
                        ]
                    ],
                    [
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1-$2",
                            [
                                "310"
                            ],
                            ,
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "$1-$2-$3",
                            [
                                "[2-9]"
                            ]
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    1,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                UY: [
                    ,
                    [
                        ,
                        ,
                        "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            6,
                            7,
                            8,
                            9,
                            10,
                            11,
                            12,
                            13
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:1(?:770|9(?:20|87))|(?:2\\d|4[2-7])\\d\\d)\\d{4}",
                        ,
                        ,
                        ,
                        "21231234",
                        ,
                        ,
                        [
                            8
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "9[1-9]\\d{6}",
                        ,
                        ,
                        ,
                        "94231234",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "0004\\d{2,9}|(?:405|80[05])\\d{4}",
                        ,
                        ,
                        ,
                        "8001234"
                    ],
                    [
                        ,
                        ,
                        "90[0-8]\\d{4}",
                        ,
                        ,
                        ,
                        "9001234",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "UY",
                    598,
                    "0(?:0|1[3-9]\\d)",
                    "0",
                    " int. ",
                    ,
                    "0",
                    ,
                    "00",
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{3,4})",
                            "$1 $2",
                            [
                                "0"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1 $2",
                            [
                                "[49]0|8"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "9"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{4})",
                            "$1 $2",
                            [
                                "[124]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{2,4})",
                            "$1 $2 $3",
                            [
                                "0"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})",
                            "$1 $2 $3 $4",
                            [
                                "0"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                UZ: [
                    ,
                    [
                        ,
                        ,
                        "(?:20|33|[5-79]\\d|88)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:55\\d\\d|6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|6\\d\\d|7(?:[23]\\d|7[69])|9(?:22|4[1-8]|6[135]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|(?:1[12]|[68]\\d)\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|9(?:22|5[1-9])))\\d{5}",
                        ,
                        ,
                        ,
                        "669050123"
                    ],
                    [
                        ,
                        ,
                        "(?:(?:[25]0|33|88|9[0-57-9])\\d{3}|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079]))|9(?:2(?:1[1267]|3[01]|5\\d|7[0-4])|(?:5[67]|7\\d)\\d|6(?:2[0-26]|8\\d)))|7(?:[07]\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}",
                        ,
                        ,
                        ,
                        "912345678"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "UZ",
                    998,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "[235-9]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                VA: [
                    ,
                    [
                        ,
                        ,
                        "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            6,
                            7,
                            8,
                            9,
                            10,
                            11,
                            12
                        ]
                    ],
                    [
                        ,
                        ,
                        "06698\\d{1,6}",
                        ,
                        ,
                        ,
                        "0669812345",
                        ,
                        ,
                        [
                            6,
                            7,
                            8,
                            9,
                            10,
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        "3[1-9]\\d{8}|3[2-9]\\d{7}",
                        ,
                        ,
                        ,
                        "3123456789",
                        ,
                        ,
                        [
                            9,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "80(?:0\\d{3}|3)\\d{3}",
                        ,
                        ,
                        ,
                        "800123456",
                        ,
                        ,
                        [
                            6,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",
                        ,
                        ,
                        ,
                        "899123456",
                        ,
                        ,
                        [
                            6,
                            8,
                            9,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "84(?:[08]\\d{3}|[17])\\d{3}",
                        ,
                        ,
                        ,
                        "848123456",
                        ,
                        ,
                        [
                            6,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "1(?:78\\d|99)\\d{6}",
                        ,
                        ,
                        ,
                        "1781234567",
                        ,
                        ,
                        [
                            9,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "55\\d{8}",
                        ,
                        ,
                        ,
                        "5512345678",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    "VA",
                    39,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    "06698",
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "3[2-8]\\d{9,10}",
                        ,
                        ,
                        ,
                        "33101234501",
                        ,
                        ,
                        [
                            11,
                            12
                        ]
                    ]
                ],
                VC: [
                    ,
                    [
                        ,
                        ,
                        "(?:[58]\\d\\d|784|900)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}",
                        ,
                        ,
                        ,
                        "7842661234",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}",
                        ,
                        ,
                        ,
                        "7844301234",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "8002345678"
                    ],
                    [
                        ,
                        ,
                        "900[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "9002345678"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "5002345678"
                    ],
                    [
                        ,
                        ,
                        "78451[0-2]\\d{4}",
                        ,
                        ,
                        ,
                        "7845101234",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    "VC",
                    1,
                    "011",
                    "1",
                    ,
                    ,
                    "([2-7]\\d{6})$|1",
                    "784$1",
                    ,
                    ,
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    "784",
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                VE: [
                    ,
                    [
                        ,
                        ,
                        "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}",
                        ,
                        ,
                        ,
                        "2121234567",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "4(?:1[24-8]|2[46])\\d{7}",
                        ,
                        ,
                        ,
                        "4121234567"
                    ],
                    [
                        ,
                        ,
                        "800\\d{7}",
                        ,
                        ,
                        ,
                        "8001234567"
                    ],
                    [
                        ,
                        ,
                        "90[01]\\d{7}",
                        ,
                        ,
                        ,
                        "9001234567"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "VE",
                    58,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{7})",
                            "$1-$2",
                            [
                                "[24-689]"
                            ],
                            "0$1",
                            "$CC $1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "501\\d{7}",
                        ,
                        ,
                        ,
                        "5010123456",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                VG: [
                    ,
                    [
                        ,
                        ,
                        "(?:284|[58]\\d\\d|900)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}",
                        ,
                        ,
                        ,
                        "2842291234",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|9[69])|5(?:4[0-7]|68|9[69]))\\d{4}",
                        ,
                        ,
                        ,
                        "2843001234",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "8002345678"
                    ],
                    [
                        ,
                        ,
                        "900[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "9002345678"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "5002345678"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "VG",
                    1,
                    "011",
                    "1",
                    ,
                    ,
                    "([2-578]\\d{6})$|1",
                    "284$1",
                    ,
                    ,
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    "284",
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                VI: [
                    ,
                    [
                        ,
                        ,
                        "[58]\\d{9}|(?:34|90)0\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            10
                        ],
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "340(?:2(?:0\\d|10|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}",
                        ,
                        ,
                        ,
                        "3406421234",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "340(?:2(?:0\\d|10|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}",
                        ,
                        ,
                        ,
                        "3406421234",
                        ,
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "8002345678"
                    ],
                    [
                        ,
                        ,
                        "900[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "9002345678"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                        ,
                        ,
                        ,
                        "5002345678"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "VI",
                    1,
                    "011",
                    "1",
                    ,
                    ,
                    "([2-9]\\d{6})$|1",
                    "340$1",
                    ,
                    1,
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    "340",
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                VN: [
                    ,
                    [
                        ,
                        ,
                        "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            8,
                            9,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "2(?:0[3-9]|1[0-689]|2[0-25-9]|[38][2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|9[0-4679])\\d{7}",
                        ,
                        ,
                        ,
                        "2101234567",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:5(?:2[238]|59)|89[6-9]|99[013-9])\\d{6}|(?:3\\d|5[1689]|7[06-9]|8[1-8]|9[0-8])\\d{7}",
                        ,
                        ,
                        ,
                        "912345678",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "1800\\d{4,6}|12(?:0[13]|28)\\d{4}",
                        ,
                        ,
                        ,
                        "1800123456",
                        ,
                        ,
                        [
                            8,
                            9,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "1900\\d{4,6}",
                        ,
                        ,
                        ,
                        "1900123456",
                        ,
                        ,
                        [
                            8,
                            9,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "672\\d{6}",
                        ,
                        ,
                        ,
                        "672012345",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    "VN",
                    84,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1 $2",
                            [
                                "[17]99"
                            ],
                            "0$1",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{5})",
                            "$1 $2",
                            [
                                "80"
                            ],
                            "0$1",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{4,5})",
                            "$1 $2",
                            [
                                "69"
                            ],
                            "0$1",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{4,6})",
                            "$1 $2",
                            [
                                "1"
                            ],
                            ,
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "6"
                            ],
                            "0$1",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[357-9]"
                            ],
                            "0$1",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "2[48]"
                            ],
                            "0$1",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{4})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "2"
                            ],
                            "0$1",
                            ,
                            1
                        ]
                    ],
                    [
                        [
                            ,
                            "(\\d{2})(\\d{5})",
                            "$1 $2",
                            [
                                "80"
                            ],
                            "0$1",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{4,6})",
                            "$1 $2",
                            [
                                "1"
                            ],
                            ,
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "6"
                            ],
                            "0$1",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[357-9]"
                            ],
                            "0$1",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "2[48]"
                            ],
                            "0$1",
                            ,
                            1
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{4})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "2"
                            ],
                            "0$1",
                            ,
                            1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "[17]99\\d{4}|69\\d{5,6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:[17]99|80\\d)\\d{4}|69\\d{5,6}",
                        ,
                        ,
                        ,
                        "1992000",
                        ,
                        ,
                        [
                            7,
                            8
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                VU: [
                    ,
                    [
                        ,
                        ,
                        "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            5,
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}",
                        ,
                        ,
                        ,
                        "22123",
                        ,
                        ,
                        [
                            5
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:[58]\\d|7[013-7])\\d{5}",
                        ,
                        ,
                        ,
                        "5912345",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        "81[18]\\d\\d",
                        ,
                        ,
                        ,
                        "81123",
                        ,
                        ,
                        [
                            5
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "9(?:0[1-9]|1[01])\\d{4}",
                        ,
                        ,
                        ,
                        "9010123",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    "VU",
                    678,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1 $2",
                            [
                                "[57-9]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:3[03]|900\\d)\\d{3}",
                        ,
                        ,
                        ,
                        "30123"
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                WF: [
                    ,
                    [
                        ,
                        ,
                        "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            6,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "72\\d{4}",
                        ,
                        ,
                        ,
                        "721234",
                        ,
                        ,
                        [
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:72|8[23])\\d{4}",
                        ,
                        ,
                        ,
                        "821234",
                        ,
                        ,
                        [
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "80[0-5]\\d{6}",
                        ,
                        ,
                        ,
                        "800012345",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "WF",
                    681,
                    "00",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3",
                            [
                                "[478]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                            "$1 $2 $3 $4",
                            [
                                "8"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "[48]0\\d{4}",
                        ,
                        ,
                        ,
                        "401234",
                        ,
                        ,
                        [
                            6
                        ]
                    ]
                ],
                WS: [
                    ,
                    [
                        ,
                        ,
                        "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            5,
                            6,
                            7,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}",
                        ,
                        ,
                        ,
                        "22123",
                        ,
                        ,
                        [
                            5,
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:7[1-35-7]|8(?:[3-7]|9\\d{3}))\\d{5}",
                        ,
                        ,
                        ,
                        "7212345",
                        ,
                        ,
                        [
                            7,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "800\\d{3}",
                        ,
                        ,
                        ,
                        "800123",
                        ,
                        ,
                        [
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "WS",
                    685,
                    "0",
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{5})",
                            "$1",
                            [
                                "[2-5]|6[1-9]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3,7})",
                            "$1 $2",
                            [
                                "[68]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{5})",
                            "$1 $2",
                            [
                                "7"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                XK: [
                    ,
                    [
                        ,
                        ,
                        "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8,
                            9,
                            10,
                            11,
                            12
                        ]
                    ],
                    [
                        ,
                        ,
                        "38\\d{6,10}|(?:2[89]|39)(?:0\\d{5,6}|[1-9]\\d{5})",
                        ,
                        ,
                        ,
                        "28012345"
                    ],
                    [
                        ,
                        ,
                        "4[3-9]\\d{6}",
                        ,
                        ,
                        ,
                        "43201234",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "800\\d{5}",
                        ,
                        ,
                        ,
                        "80001234",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        "900\\d{5}",
                        ,
                        ,
                        ,
                        "90001234",
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "XK",
                    383,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{5})",
                            "$1 $2",
                            [
                                "[89]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[2-4]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "2|39"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{7,10})",
                            "$1 $2",
                            [
                                "3"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                YE: [
                    ,
                    [
                        ,
                        ,
                        "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            8,
                            9
                        ],
                        [
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}",
                        ,
                        ,
                        ,
                        "1234567",
                        ,
                        ,
                        [
                            7,
                            8
                        ],
                        [
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "7[01378]\\d{7}",
                        ,
                        ,
                        ,
                        "712345678",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "YE",
                    967,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "[1-6]|7(?:[24-6]|8[0-7])"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "7"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                YT: [
                    ,
                    [
                        ,
                        ,
                        "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}",
                        ,
                        ,
                        ,
                        "269601234"
                    ],
                    [
                        ,
                        ,
                        "639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}",
                        ,
                        ,
                        ,
                        "639012345"
                    ],
                    [
                        ,
                        ,
                        "80\\d{7}",
                        ,
                        ,
                        ,
                        "801234567"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "9(?:(?:39|47)8[01]|769\\d)\\d{4}",
                        ,
                        ,
                        ,
                        "939801234"
                    ],
                    "YT",
                    262,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                ZA: [
                    ,
                    [
                        ,
                        ,
                        "[1-79]\\d{8}|8\\d{4,9}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            5,
                            6,
                            7,
                            8,
                            9,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}",
                        ,
                        ,
                        ,
                        "101234567",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:6\\d|7[0-46-9])\\d{3}|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}",
                        ,
                        ,
                        ,
                        "711234567",
                        ,
                        ,
                        [
                            5,
                            6,
                            7,
                            8,
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "80\\d{7}",
                        ,
                        ,
                        ,
                        "801234567",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:86[2-9]|9[0-2]\\d)\\d{6}",
                        ,
                        ,
                        ,
                        "862345678",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "860\\d{6}",
                        ,
                        ,
                        ,
                        "860123456",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}",
                        ,
                        ,
                        ,
                        "871234567",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    "ZA",
                    27,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{3,4})",
                            "$1 $2",
                            [
                                "8[1-4]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{2,3})",
                            "$1 $2 $3",
                            [
                                "8[1-4]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "860"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[1-9]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "8"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "861\\d{6,7}",
                        ,
                        ,
                        ,
                        "861123456",
                        ,
                        ,
                        [
                            9,
                            10
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                ZM: [
                    ,
                    [
                        ,
                        ,
                        "800\\d{6}|(?:21|63|[79]\\d)\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9
                        ],
                        [
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "21[1-8]\\d{6}",
                        ,
                        ,
                        ,
                        "211234567",
                        ,
                        ,
                        ,
                        [
                            6
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:7[5-79]|9[5-8])\\d{7}",
                        ,
                        ,
                        ,
                        "955123456"
                    ],
                    [
                        ,
                        ,
                        "800\\d{6}",
                        ,
                        ,
                        ,
                        "800123456"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "63\\d{7}",
                        ,
                        ,
                        ,
                        "630123456"
                    ],
                    "ZM",
                    260,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{3})",
                            "$1 $2",
                            [
                                "[1-9]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[28]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{7})",
                            "$1 $2",
                            [
                                "[79]"
                            ],
                            "0$1"
                        ]
                    ],
                    [
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[28]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{7})",
                            "$1 $2",
                            [
                                "[79]"
                            ],
                            "0$1"
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                ZW: [
                    ,
                    [
                        ,
                        ,
                        "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            5,
                            6,
                            7,
                            8,
                            9,
                            10
                        ],
                        [
                            3,
                            4
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}",
                        ,
                        ,
                        ,
                        "1312345",
                        ,
                        ,
                        ,
                        [
                            3,
                            4
                        ]
                    ],
                    [
                        ,
                        ,
                        "7(?:[1278]\\d|3[1-9])\\d{6}",
                        ,
                        ,
                        ,
                        "712345678",
                        ,
                        ,
                        [
                            9
                        ]
                    ],
                    [
                        ,
                        ,
                        "80(?:[01]\\d|20|8[0-8])\\d{3}",
                        ,
                        ,
                        ,
                        "8001234",
                        ,
                        ,
                        [
                            7
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "86(?:1[12]|22|30|44|55|77|8[368])\\d{6}",
                        ,
                        ,
                        ,
                        "8686123456",
                        ,
                        ,
                        [
                            10
                        ]
                    ],
                    "ZW",
                    263,
                    "00",
                    "0",
                    ,
                    ,
                    "0",
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{3,5})",
                            "$1 $2",
                            [
                                "2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{2,4})",
                            "$1 $2 $3",
                            [
                                "[49]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{4})",
                            "$1 $2",
                            [
                                "80"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{7})",
                            "$1 $2",
                            [
                                "24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2",
                                "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"
                            ],
                            "(0$1)"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "7"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)",
                                "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{6})",
                            "$1 $2",
                            [
                                "8"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3,5})",
                            "$1 $2",
                            [
                                "1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3})(\\d{3,4})",
                            "$1 $2 $3",
                            [
                                "29[013-9]|39|54"
                            ],
                            "0$1"
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{3,5})",
                            "$1 $2",
                            [
                                "(?:25|54)8",
                                "258|5483"
                            ],
                            "0$1"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                800: [
                    ,
                    [
                        ,
                        ,
                        "(?:00|[1-9]\\d)\\d{6}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:00|[1-9]\\d)\\d{6}",
                        ,
                        ,
                        ,
                        "12345678"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "001",
                    800,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    [
                        [
                            ,
                            "(\\d{4})(\\d{4})",
                            "$1 $2",
                            [
                                "\\d"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                808: [
                    ,
                    [
                        ,
                        ,
                        "[1-9]\\d{7}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "[1-9]\\d{7}",
                        ,
                        ,
                        ,
                        "12345678"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "001",
                    808,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    [
                        [
                            ,
                            "(\\d{4})(\\d{4})",
                            "$1 $2",
                            [
                                "[1-9]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                870: [
                    ,
                    [
                        ,
                        ,
                        "7\\d{11}|[35-7]\\d{8}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9,
                            12
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}",
                        ,
                        ,
                        ,
                        "301234567"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "001",
                    870,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "[35-7]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                878: [
                    ,
                    [
                        ,
                        ,
                        "10\\d{10}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            12
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "10\\d{10}",
                        ,
                        ,
                        ,
                        "101234567890"
                    ],
                    "001",
                    878,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{5})(\\d{5})",
                            "$1 $2 $3",
                            [
                                "1"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                881: [
                    ,
                    [
                        ,
                        ,
                        "6\\d{9}|[0-36-9]\\d{8}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9,
                            10
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "6\\d{9}|[0-36-9]\\d{8}",
                        ,
                        ,
                        ,
                        "612345678"
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "001",
                    881,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{5})",
                            "$1 $2 $3",
                            [
                                "[0-37-9]"
                            ]
                        ],
                        [
                            ,
                            "(\\d)(\\d{3})(\\d{5,6})",
                            "$1 $2 $3",
                            [
                                "6"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                882: [
                    ,
                    [
                        ,
                        ,
                        "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            7,
                            8,
                            9,
                            10,
                            11,
                            12
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",
                        ,
                        ,
                        ,
                        "3421234",
                        ,
                        ,
                        [
                            7,
                            8,
                            9,
                            10,
                            12
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}",
                        ,
                        ,
                        ,
                        "390123456789"
                    ],
                    "001",
                    882,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    [
                        [
                            ,
                            "(\\d{2})(\\d{5})",
                            "$1 $2",
                            [
                                "16|342"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{6})",
                            "$1 $2",
                            [
                                "49"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{2})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "1[36]|9"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{4})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "3[23]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{3,4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "16"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "10|23|3(?:[15]|4[57])|4|51"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "34"
                            ]
                        ],
                        [
                            ,
                            "(\\d{2})(\\d{4,5})(\\d{5})",
                            "$1 $2 $3",
                            [
                                "[1-35]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        "348[57]\\d{7}",
                        ,
                        ,
                        ,
                        "34851234567",
                        ,
                        ,
                        [
                            11
                        ]
                    ]
                ],
                883: [
                    ,
                    [
                        ,
                        ,
                        "(?:[1-4]\\d|51)\\d{6,10}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            8,
                            9,
                            10,
                            11,
                            12
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}",
                        ,
                        ,
                        ,
                        "510012345"
                    ],
                    "001",
                    883,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{2,8})",
                            "$1 $2 $3",
                            [
                                "[14]|2[24-689]|3[02-689]|51[24-9]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3",
                            [
                                "510"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "21"
                            ]
                        ],
                        [
                            ,
                            "(\\d{4})(\\d{4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "51[13]"
                            ]
                        ],
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                            "$1 $2 $3 $4",
                            [
                                "[235]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                888: [
                    ,
                    [
                        ,
                        ,
                        "\\d{11}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            11
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "001",
                    888,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    [
                        [
                            ,
                            "(\\d{3})(\\d{3})(\\d{5})",
                            "$1 $2 $3"
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "\\d{11}",
                        ,
                        ,
                        ,
                        "12345678901"
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ],
                979: [
                    ,
                    [
                        ,
                        ,
                        "[1359]\\d{8}",
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            9
                        ],
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        "[1359]\\d{8}",
                        ,
                        ,
                        ,
                        "123456789",
                        ,
                        ,
                        ,
                        [
                            8
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    "001",
                    979,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    [
                        [
                            ,
                            "(\\d)(\\d{4})(\\d{4})",
                            "$1 $2 $3",
                            [
                                "[1359]"
                            ]
                        ]
                    ],
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ],
                    ,
                    ,
                    [
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        ,
                        [
                            -1
                        ]
                    ]
                ]
            };
            function J() {
                this.g = {};
            }
            J.h = void 0;
            J.g = function() {
                return J.h ? J.h : J.h = new J();
            };
            var Fa = {
                0: "0",
                1: "1",
                2: "2",
                3: "3",
                4: "4",
                5: "5",
                6: "6",
                7: "7",
                8: "8",
                9: "9",
                "\uFF10": "0",
                "\uFF11": "1",
                "\uFF12": "2",
                "\uFF13": "3",
                "\uFF14": "4",
                "\uFF15": "5",
                "\uFF16": "6",
                "\uFF17": "7",
                "\uFF18": "8",
                "\uFF19": "9",
                "\u0660": "0",
                "\u0661": "1",
                "\u0662": "2",
                "\u0663": "3",
                "\u0664": "4",
                "\u0665": "5",
                "\u0666": "6",
                "\u0667": "7",
                "\u0668": "8",
                "\u0669": "9",
                "\u06F0": "0",
                "\u06F1": "1",
                "\u06F2": "2",
                "\u06F3": "3",
                "\u06F4": "4",
                "\u06F5": "5",
                "\u06F6": "6",
                "\u06F7": "7",
                "\u06F8": "8",
                "\u06F9": "9"
            }, Ga = {
                0: "0",
                1: "1",
                2: "2",
                3: "3",
                4: "4",
                5: "5",
                6: "6",
                7: "7",
                8: "8",
                9: "9",
                "+": "+",
                "*": "*",
                "#": "#"
            }, Ha = {
                0: "0",
                1: "1",
                2: "2",
                3: "3",
                4: "4",
                5: "5",
                6: "6",
                7: "7",
                8: "8",
                9: "9",
                "\uFF10": "0",
                "\uFF11": "1",
                "\uFF12": "2",
                "\uFF13": "3",
                "\uFF14": "4",
                "\uFF15": "5",
                "\uFF16": "6",
                "\uFF17": "7",
                "\uFF18": "8",
                "\uFF19": "9",
                "\u0660": "0",
                "\u0661": "1",
                "\u0662": "2",
                "\u0663": "3",
                "\u0664": "4",
                "\u0665": "5",
                "\u0666": "6",
                "\u0667": "7",
                "\u0668": "8",
                "\u0669": "9",
                "\u06F0": "0",
                "\u06F1": "1",
                "\u06F2": "2",
                "\u06F3": "3",
                "\u06F4": "4",
                "\u06F5": "5",
                "\u06F6": "6",
                "\u06F7": "7",
                "\u06F8": "8",
                "\u06F9": "9",
                A: "2",
                B: "2",
                C: "2",
                D: "3",
                E: "3",
                F: "3",
                G: "4",
                H: "4",
                I: "4",
                J: "5",
                K: "5",
                L: "5",
                M: "6",
                N: "6",
                O: "6",
                P: "7",
                Q: "7",
                R: "7",
                S: "7",
                T: "8",
                U: "8",
                V: "8",
                W: "9",
                X: "9",
                Y: "9",
                Z: "9"
            }, Ia = RegExp("[+\uFF0B]+"), K = RegExp("^[+\uFF0B]+"), Ja = RegExp("([0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9])"), Ka = RegExp("[+\uFF0B0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9]"), La = /[\\\/] *x/, Ma = RegExp("[^0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9A-Za-z#]+$"), Na = /(?:.*?[A-Za-z]){3}.*/, Oa = RegExp("^\\+([0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9]|[\\-\\.\\(\\)]?)*[0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9]([0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9]|[\\-\\.\\(\\)]?)*$"), Pa = RegExp("^([A-Za-z0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9]+((\\-)*[A-Za-z0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9])*\\.)*[A-Za-z]+((\\-)*[A-Za-z0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9])*\\.?$");
            function L(a) {
                return "([0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9]{1," + a + "})";
            }
            function Qa() {
                return ";ext=" + L("20") + "|[ \xa0\\t,]*(?:e?xt(?:ensi(?:o\u0301?|\xf3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)[:\\.\uFF0E]?[ \xa0\\t,-]*" + (L("20") + "#?|[ \xa0\\t,]*(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)[:\\.\uFF0E]?[ \xa0\\t,-]*") + (L("9") + "#?|[- ]+") + (L("6") + "#|[ \xa0\\t]*(?:,{2}|;)[:\\.\uFF0E]?[ \xa0\\t,-]*") + (L("15") + "#?|[ \xa0\\t]*(?:,)+[:\\.\uFF0E]?[ \xa0\\t,-]*") + (L("9") + "#?");
            }
            var Ra = new RegExp("(?:" + Qa() + ")$", "i"), Sa = new RegExp("^[0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9]{2}$|^[+\uFF0B]*(?:[-x\u2010-\u2015\u2212\u30FC\uFF0D-\uFF0F \xa0\xad\u200B\u2060\u3000()\uFF08\uFF09\uFF3B\uFF3D.\\[\\]/~\u2053\u223C\uFF5E*]*[0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9]){3,}[-x\u2010-\u2015\u2212\u30FC\uFF0D-\uFF0F \xa0\xad\u200B\u2060\u3000()\uFF08\uFF09\uFF3B\uFF3D.\\[\\]/~\u2053\u223C\uFF5E*A-Za-z0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9]*(?:" + Qa() + ")?$", "i"), Ta = /(\$\d)/, Ua = /^\(?\$1\)?$/;
            function Va(a) {
                return 2 > a.length ? false : M(Sa, a);
            }
            function Wa(a) {
                return M(Na, a) ? N(a, Ha) : N(a, Fa);
            }
            function Xa(a) {
                var b = Wa(a.toString());
                D(a);
                a.g(b);
            }
            function Ya(a) {
                return null != a && (1 != x(a, 9) || -1 != u(a, 9)[0]);
            }
            function N(a, b) {
                for(var c = new C(), d, e = a.length, f = 0; f < e; ++f)d = a.charAt(f), d = b[d.toUpperCase()], null != d && c.g(d);
                return c.toString();
            }
            function Za(a) {
                return 0 == a.length || Ua.test(a);
            }
            function O(a) {
                return null != a && isNaN(a) && a.toUpperCase() in Ea;
            }
            J.prototype.format = function(a, b) {
                if (0 == r(a, 2) && q(a, 5)) {
                    var c = w(a, 5);
                    if (0 < c.length) return c;
                }
                c = w(a, 1);
                var d = P(a);
                if (0 == b) return $a(c, 0, d, "");
                if (!(c in I)) return d;
                var e = Q(this, c, R(c));
                a = q(a, 3) && 0 != r(a, 3).length ? 3 == b ? ";ext=" + r(a, 3) : q(e, 13) ? r(e, 13) + w(a, 3) : " ext. " + w(a, 3) : "";
                a: {
                    e = 0 == u(e, 20).length || 2 == b ? u(e, 19) : u(e, 20);
                    for(var f, g = e.length, h = 0; h < g; ++h){
                        f = e[h];
                        var l = x(f, 3);
                        if (0 == l || 0 == d.search(r(f, 3, l - 1))) {
                            if (l = new RegExp(r(f, 1)), M(l, d)) {
                                e = f;
                                break a;
                            }
                        }
                    }
                    e = null;
                }
                null != e && (g = e, e = w(g, 2), f = new RegExp(r(g, 1)), w(g, 5), g = w(g, 4), d = 2 == b && null != g && 0 < g.length ? d.replace(f, e.replace(Ta, g)) : d.replace(f, e), 3 == b && (d = d.replace(RegExp("^[-x\u2010-\u2015\u2212\u30FC\uFF0D-\uFF0F \xa0\xad\u200B\u2060\u3000()\uFF08\uFF09\uFF3B\uFF3D.\\[\\]/~\u2053\u223C\uFF5E]+"), ""), d = d.replace(RegExp("[-x\u2010-\u2015\u2212\u30FC\uFF0D-\uFF0F \xa0\xad\u200B\u2060\u3000()\uFF08\uFF09\uFF3B\uFF3D.\\[\\]/~\u2053\u223C\uFF5E]+", "g"), "-")));
                return $a(c, b, d, a);
            };
            function Q(a, b, c) {
                return "001" == c ? S(a, "" + b) : S(a, c);
            }
            function P(a) {
                if (!q(a, 2)) return "";
                var b = "" + r(a, 2);
                return q(a, 4) && r(a, 4) && 0 < w(a, 8) ? Array(w(a, 8) + 1).join("0") + b : b;
            }
            function $a(a, b, c, d) {
                switch(b){
                    case 0:
                        return "+" + a + c + d;
                    case 1:
                        return "+" + a + " " + c + d;
                    case 3:
                        return "tel:+" + a + "-" + c + d;
                    default:
                        return c + d;
                }
            }
            function T(a, b) {
                switch(b){
                    case 4:
                        return r(a, 5);
                    case 3:
                        return r(a, 4);
                    case 1:
                        return r(a, 3);
                    case 0:
                    case 2:
                        return r(a, 2);
                    case 5:
                        return r(a, 6);
                    case 6:
                        return r(a, 8);
                    case 7:
                        return r(a, 7);
                    case 8:
                        return r(a, 21);
                    case 9:
                        return r(a, 25);
                    case 10:
                        return r(a, 28);
                    default:
                        return r(a, 1);
                }
            }
            function ab(a, b) {
                return U(a, r(b, 1)) ? U(a, r(b, 5)) ? 4 : U(a, r(b, 4)) ? 3 : U(a, r(b, 6)) ? 5 : U(a, r(b, 8)) ? 6 : U(a, r(b, 7)) ? 7 : U(a, r(b, 21)) ? 8 : U(a, r(b, 25)) ? 9 : U(a, r(b, 28)) ? 10 : U(a, r(b, 2)) ? r(b, 18) || U(a, r(b, 3)) ? 2 : 0 : !r(b, 18) && U(a, r(b, 3)) ? 1 : -1 : -1;
            }
            function S(a, b) {
                if (null == b) return null;
                b = b.toUpperCase();
                var c = a.g[b];
                if (null == c) {
                    c = Ea[b];
                    if (null == c) return null;
                    c = new B().g(G.m(), c);
                    a.g[b] = c;
                }
                return c;
            }
            function U(a, b) {
                var c = a.length;
                return 0 < x(b, 9) && -1 == u(b, 9).indexOf(c) ? false : M(w(b, 2), a);
            }
            function bb(a, b) {
                if (null == b) return null;
                var c = w(b, 1);
                c = I[c];
                if (null == c) a = null;
                else if (1 == c.length) a = c[0];
                else a: {
                    b = P(b);
                    for(var d, e = c.length, f = 0; f < e; f++){
                        d = c[f];
                        var g = S(a, d);
                        if (q(g, 23)) {
                            if (0 == b.search(r(g, 23))) {
                                a = d;
                                break a;
                            }
                        } else if (-1 != ab(b, g)) {
                            a = d;
                            break a;
                        }
                    }
                    a = null;
                }
                return a;
            }
            function R(a) {
                a = I[a];
                return null == a ? "ZZ" : a[0];
            }
            function cb(a, b) {
                a = S(a, b);
                if (null == a) throw Error("Invalid region code: " + b);
                return w(a, 10);
            }
            function V(a, b, c, d) {
                var e = T(c, d), f = 0 == x(e, 9) ? u(r(c, 1), 9) : u(e, 9);
                e = u(e, 10);
                if (2 == d) {
                    if (Ya(T(c, 0))) a = T(c, 1), Ya(a) && (f = f.concat(0 == x(a, 9) ? u(r(c, 1), 9) : u(a, 9)), f.sort(), 0 == e.length ? e = u(a, 10) : (e = e.concat(u(a, 10)), e.sort()));
                    else return V(a, b, c, 1);
                }
                if (-1 == f[0]) return 5;
                b = b.length;
                if (-1 < e.indexOf(b)) return 4;
                c = f[0];
                return c == b ? 0 : c > b ? 2 : f[f.length - 1] < b ? 3 : -1 < f.indexOf(b, 1) ? 0 : 5;
            }
            function W(a, b, c) {
                var d = P(b);
                b = w(b, 1);
                if (!(b in I)) return 1;
                b = Q(a, b, R(b));
                return V(a, d, b, c);
            }
            function db(a, b) {
                a = a.toString();
                if (0 == a.length || "0" == a.charAt(0)) return 0;
                for(var c, d = a.length, e = 1; 3 >= e && e <= d; ++e)if (c = parseInt(a.substring(0, e), 10), c in I) return b.g(a.substring(e)), c;
                return 0;
            }
            function eb(a, b, c, d, e, f) {
                if (0 == b.length) return 0;
                b = new C(b);
                var g;
                null != c && (g = r(c, 11));
                null == g && (g = "NonMatch");
                var h = b.toString();
                if (0 == h.length) g = 20;
                else if (K.test(h)) h = h.replace(K, ""), D(b), b.g(Wa(h)), g = 1;
                else {
                    h = new RegExp(g);
                    Xa(b);
                    g = b.toString();
                    if (0 == g.search(h)) {
                        h = g.match(h)[0].length;
                        var l = g.substring(h).match(Ja);
                        l && null != l[1] && 0 < l[1].length && "0" == N(l[1], Fa) ? g = false : (D(b), b.g(g.substring(h)), g = true);
                    } else g = false;
                    g = g ? 5 : 20;
                }
                e && t(f, 6, g);
                if (20 != g) {
                    if (2 >= b.h.length) throw Error("Phone number too short after IDD");
                    a = db(b, d);
                    if (0 != a) return t(f, 1, a), a;
                    throw Error("Invalid country calling code");
                }
                if (null != c && (g = w(c, 10), h = "" + g, l = b.toString(), 0 == l.lastIndexOf(h, 0) && (h = new C(l.substring(h.length)), l = r(c, 1), l = new RegExp(w(l, 2)), fb(h, c, null), h = h.toString(), !M(l, b.toString()) && M(l, h) || 3 == V(a, b.toString(), c, -1)))) return d.g(h), e && t(f, 6, 10), t(f, 1, g), g;
                t(f, 1, 0);
                return 0;
            }
            function fb(a, b, c) {
                var d = a.toString(), e = d.length, f = r(b, 15);
                if (0 != e && null != f && 0 != f.length) {
                    var g = new RegExp("^(?:" + f + ")");
                    if (e = g.exec(d)) {
                        f = new RegExp(w(r(b, 1), 2));
                        var h = M(f, d), l = e.length - 1;
                        b = r(b, 16);
                        if (null == b || 0 == b.length || null == e[l] || 0 == e[l].length) {
                            if (!h || M(f, d.substring(e[0].length))) null != c && 0 < l && null != e[l] && c.g(e[1]), a.set(d.substring(e[0].length));
                        } else if (d = d.replace(g, b), !h || M(f, d)) null != c && 0 < l && c.g(e[1]), a.set(d);
                    }
                }
            }
            function X(a, b, c) {
                if (!O(c) && 0 < b.length && "+" != b.charAt(0)) throw Error("Invalid country calling code");
                return gb(a, b, c, true);
            }
            function gb(a, b, c, d) {
                if (null == b) throw Error("The string supplied did not seem to be a phone number");
                if (250 < b.length) throw Error("The string supplied is too long to be a phone number");
                var e = new C();
                var f = b.indexOf(";phone-context=");
                if (-1 === f) f = null;
                else if (f += 15, f >= b.length) f = "";
                else {
                    var g = b.indexOf(";", f);
                    f = -1 !== g ? b.substring(f, g) : b.substring(f);
                }
                var h = f;
                null == h ? g = true : 0 === h.length ? g = false : (g = Oa.exec(h), h = Pa.exec(h), g = null !== g || null !== h);
                if (!g) throw Error("The string supplied did not seem to be a phone number");
                null != f ? ("+" === f.charAt(0) && e.g(f), f = b.indexOf("tel:"), e.g(b.substring(0 <= f ? f + 4 : 0, b.indexOf(";phone-context=")))) : (f = e.g, g = b ?? "", h = g.search(Ka), 0 <= h ? (g = g.substring(h), g = g.replace(Ma, ""), h = g.search(La), 0 <= h && (g = g.substring(0, h))) : g = "", f.call(e, g));
                f = e.toString();
                g = f.indexOf(";isub=");
                0 < g && (D(e), e.g(f.substring(0, g)));
                if (!Va(e.toString())) throw Error("The string supplied did not seem to be a phone number");
                f = e.toString();
                if (!(O(c) || null != f && 0 < f.length && K.test(f))) throw Error("Invalid country calling code");
                f = new H();
                d && t(f, 5, b);
                a: {
                    b = e.toString();
                    g = b.search(Ra);
                    if (0 <= g && Va(b.substring(0, g))) {
                        h = b.match(Ra);
                        for(var l = h.length, A = 1; A < l; ++A)if (null != h[A] && 0 < h[A].length) {
                            D(e);
                            e.g(b.substring(0, g));
                            b = h[A];
                            break a;
                        }
                    }
                    b = "";
                }
                0 < b.length && t(f, 3, b);
                g = S(a, c);
                b = new C();
                h = 0;
                l = e.toString();
                try {
                    h = eb(a, l, g, b, d, f);
                } catch (da) {
                    if ("Invalid country calling code" == da.message && K.test(l)) {
                        if (l = l.replace(K, ""), h = eb(a, l, g, b, d, f), 0 == h) throw da;
                    } else throw da;
                }
                0 != h ? (e = R(h), e != c && (g = Q(a, h, e))) : (Xa(e), b.g(e.toString()), null != c ? (h = w(g, 10), t(f, 1, h)) : d && (delete f.h[6], f.g && delete f.g[6]));
                if (2 > b.h.length) throw Error("The string supplied is too short to be a phone number");
                null != g && (c = new C(), e = new C(b.toString()), fb(e, g, c), a = V(a, e.toString(), g, -1), 2 != a && 4 != a && 5 != a && (b = e, d && 0 < c.toString().length && t(f, 7, c.toString())));
                d = b.toString();
                a = d.length;
                if (2 > a) throw Error("The string supplied is too short to be a phone number");
                if (17 < a) throw Error("The string supplied is too long to be a phone number");
                if (1 < d.length && "0" == d.charAt(0)) {
                    t(f, 4, true);
                    for(a = 1; a < d.length - 1 && "0" == d.charAt(a);)a++;
                    1 != a && t(f, 8, a);
                }
                t(f, 2, parseInt(d, 10));
                return f;
            }
            function M(a, b) {
                return (a = "string" == typeof a ? b.match("^(?:" + a + ")$") : b.match(a)) && a[0].length == b.length ? true : false;
            }
            function hb(a) {
                this.fa = RegExp("\u2008");
                this.ja = "";
                this.v = new C();
                this.da = "";
                this.s = new C();
                this.ba = new C();
                this.u = true;
                this.ea = this.ca = this.la = false;
                this.ga = J.g();
                this.$ = 0;
                this.h = new C();
                this.ha = false;
                this.o = "";
                this.g = new C();
                this.j = [];
                this.ka = a;
                this.l = ib(this, this.ka);
            }
            var jb = new G();
            t(jb, 11, "NA");
            var kb = RegExp("^[-x\u2010-\u2015\u2212\u30FC\uFF0D-\uFF0F \xa0\xad\u200B\u2060\u3000()\uFF08\uFF09\uFF3B\uFF3D.\\[\\]/~\u2053\u223C\uFF5E]*\\$1[-x\u2010-\u2015\u2212\u30FC\uFF0D-\uFF0F \xa0\xad\u200B\u2060\u3000()\uFF08\uFF09\uFF3B\uFF3D.\\[\\]/~\u2053\u223C\uFF5E]*(\\$\\d[-x\u2010-\u2015\u2212\u30FC\uFF0D-\uFF0F \xa0\xad\u200B\u2060\u3000()\uFF08\uFF09\uFF3B\uFF3D.\\[\\]/~\u2053\u223C\uFF5E]*)*$"), lb = /[- ]/;
            function ib(a, b) {
                var c = a.ga;
                b = O(b) ? cb(c, b) : 0;
                a = S(a.ga, R(b));
                return null != a ? a : jb;
            }
            function mb(a) {
                for(var b = a.j.length, c = 0; c < b; ++c){
                    var d = a.j[c], e = w(d, 1);
                    if (a.da == e) return false;
                    var f = a;
                    var g = d, h = w(g, 1);
                    D(f.v);
                    var l = f;
                    g = w(g, 2);
                    var A = "999999999999999".match(h)[0];
                    A.length < l.g.h.length ? l = "" : (l = A.replace(new RegExp(h, "g"), g), l = l.replace(RegExp("9", "g"), "\u2008"));
                    0 < l.length ? (f.v.g(l), f = true) : f = false;
                    if (f) return a.da = e, a.ha = lb.test(r(d, 4)), a.$ = 0, true;
                }
                return a.u = false;
            }
            function nb(a, b) {
                for(var c = [], d = b.length - 3, e = a.j.length, f = 0; f < e; ++f){
                    var g = a.j[f];
                    0 == x(g, 3) ? c.push(a.j[f]) : (g = r(g, 3, Math.min(d, x(g, 3) - 1)), 0 == b.search(g) && c.push(a.j[f]));
                }
                a.j = c;
            }
            function ob(a, b) {
                a.s.g(b);
                var c = b;
                Ja.test(c) || 1 == a.s.h.length && Ia.test(c) ? ("+" == b ? (c = b, a.ba.g(b)) : (c = Fa[b], a.ba.g(c), a.g.g(c)), b = c) : (a.u = false, a.la = true);
                if (!a.u) {
                    if (!a.la) {
                        if (pb(a)) {
                            if (qb(a)) return rb(a);
                        } else if (0 < a.o.length && (b = a.g.toString(), D(a.g), a.g.g(a.o), a.g.g(b), b = a.h.toString(), c = b.lastIndexOf(a.o), D(a.h), a.h.g(b.substring(0, c))), a.o != sb(a)) return a.h.g(" "), rb(a);
                    }
                    return a.s.toString();
                }
                switch(a.ba.h.length){
                    case 0:
                    case 1:
                    case 2:
                        return a.s.toString();
                    case 3:
                        if (pb(a)) a.ea = true;
                        else return a.o = sb(a), tb(a);
                    default:
                        if (a.ea) return qb(a) && (a.ea = false), a.h.toString() + a.g.toString();
                        if (0 < a.j.length) {
                            b = ub(a, b);
                            c = vb(a);
                            if (0 < c.length) return c;
                            nb(a, a.g.toString());
                            return mb(a) ? wb(a) : a.u ? Y(a, b) : a.s.toString();
                        }
                        return tb(a);
                }
            }
            function rb(a) {
                a.u = true;
                a.ea = false;
                a.j = [];
                a.$ = 0;
                D(a.v);
                a.da = "";
                return tb(a);
            }
            function vb(a) {
                for(var b = a.g.toString(), c = a.j.length, d = 0; d < c; ++d){
                    var e = a.j[d], f = w(e, 1);
                    if (new RegExp("^(?:" + f + ")$").test(b) && (a.ha = lb.test(r(e, 4)), e = b.replace(new RegExp(f, "g"), r(e, 2)), e = Y(a, e), N(e, Ga) == a.ba)) return e;
                }
                return "";
            }
            function Y(a, b) {
                var c = a.h.h.length;
                return a.ha && 0 < c && " " != a.h.toString().charAt(c - 1) ? a.h + " " + b : a.h + b;
            }
            function tb(a) {
                var b = a.g.toString();
                if (3 <= b.length) {
                    for(var c = a.ca && 0 == a.o.length && 0 < x(a.l, 20) ? u(a.l, 20) : u(a.l, 19), d = c.length, e = 0; e < d; ++e){
                        var f = c[e];
                        0 < a.o.length && Za(w(f, 4)) && !r(f, 6) && !q(f, 5) || (0 != a.o.length || a.ca || Za(w(f, 4)) || r(f, 6)) && kb.test(w(f, 2)) && a.j.push(f);
                    }
                    nb(a, b);
                    b = vb(a);
                    return 0 < b.length ? b : mb(a) ? wb(a) : a.s.toString();
                }
                return Y(a, b);
            }
            function wb(a) {
                var b = a.g.toString(), c = b.length;
                if (0 < c) {
                    for(var d = "", e = 0; e < c; e++)d = ub(a, b.charAt(e));
                    return a.u ? Y(a, d) : a.s.toString();
                }
                return a.h.toString();
            }
            function sb(a) {
                var b = a.g.toString(), c = 0;
                if (1 != r(a.l, 10)) var d = false;
                else d = a.g.toString(), d = "1" == d.charAt(0) && "0" != d.charAt(1) && "1" != d.charAt(1);
                d ? (c = 1, a.h.g("1").g(" "), a.ca = true) : q(a.l, 15) && (d = new RegExp("^(?:" + r(a.l, 15) + ")"), d = b.match(d), null != d && null != d[0] && 0 < d[0].length && (a.ca = true, c = d[0].length, a.h.g(b.substring(0, c))));
                D(a.g);
                a.g.g(b.substring(c));
                return b.substring(0, c);
            }
            function pb(a) {
                var b = a.ba.toString(), c = new RegExp("^(?:\\+|" + r(a.l, 11) + ")");
                c = b.match(c);
                return null != c && null != c[0] && 0 < c[0].length ? (a.ca = true, c = c[0].length, D(a.g), a.g.g(b.substring(c)), D(a.h), a.h.g(b.substring(0, c)), "+" != b.charAt(0) && a.h.g(" "), true) : false;
            }
            function qb(a) {
                if (0 == a.g.h.length) return false;
                var b = new C(), c = db(a.g, b);
                if (0 == c) return false;
                D(a.g);
                a.g.g(b.toString());
                b = R(c);
                "001" == b ? a.l = S(a.ga, "" + c) : b != a.ka && (a.l = ib(a, b));
                a.h.g("" + c).g(" ");
                a.o = "";
                return true;
            }
            function ub(a, b) {
                var c = a.v.toString();
                if (0 <= c.substring(a.$).search(a.fa)) {
                    var d = c.search(a.fa);
                    b = c.replace(a.fa, b);
                    D(a.v);
                    a.v.g(b);
                    a.$ = d;
                    return b.substring(0, a.$ + 1);
                }
                1 == a.j.length && (a.u = false);
                a.da = "";
                return a.s.toString();
            }
            const Z = {
                FIXED_LINE: 0,
                MOBILE: 1,
                FIXED_LINE_OR_MOBILE: 2,
                TOLL_FREE: 3,
                PREMIUM_RATE: 4,
                SHARED_COST: 5,
                VOIP: 6,
                PERSONAL_NUMBER: 7,
                PAGER: 8,
                UAN: 9,
                VOICEMAIL: 10,
                UNKNOWN: -1
            };
            m("intlTelInputUtilsTemp", {});
            m("intlTelInputUtilsTemp.formatNumberAsYouType", (a, b)=>{
                try {
                    const c = a.replace(/[^+0-9]/g, ""), d = new hb(b);
                    b = "";
                    for(let e = 0; e < c.length; e++)d.ja = ob(d, c.charAt(e)), b = d.ja;
                    return b;
                } catch (c) {
                    return a;
                }
            });
            m("intlTelInputUtilsTemp.formatNumber", (a, b, c)=>{
                try {
                    const e = J.g(), f = X(e, a, b);
                    var d = W(e, f, -1);
                    return 0 == d || 4 == d ? e.format(f, "undefined" === typeof c ? 0 : c) : a;
                } catch (e) {
                    return a;
                }
            });
            m("intlTelInputUtilsTemp.getExampleNumber", (a, b, c, d)=>{
                try {
                    const l = J.g();
                    a: {
                        var e = l;
                        if (O(a)) {
                            var f = T(S(e, a), c);
                            try {
                                if (q(f, 6)) {
                                    var g = r(f, 6);
                                    var h = gb(e, g, a, false);
                                    break a;
                                }
                            } catch (A) {}
                        }
                        h = null;
                    }
                    return l.format(h, d ? 0 : b ? 2 : 1);
                } catch (l) {
                    return "";
                }
            });
            m("intlTelInputUtilsTemp.getExtension", (a, b)=>{
                try {
                    return r(X(J.g(), a, b), 3);
                } catch (c) {
                    return "";
                }
            });
            m("intlTelInputUtilsTemp.getNumberType", (a, b)=>{
                try {
                    const g = J.g(), h = X(g, a, b);
                    var c = bb(g, h), d = Q(g, w(h, 1), c);
                    if (null == d) var e = -1;
                    else {
                        var f = P(h);
                        e = ab(f, d);
                    }
                    return e;
                } catch (g) {
                    return -99;
                }
            });
            m("intlTelInputUtilsTemp.getValidationError", (a, b)=>{
                try {
                    const c = J.g(), d = X(c, a, b);
                    return W(c, d, -1);
                } catch (c) {
                    return "Invalid country calling code" === c.message ? 1 : 3 >= a.length || "Phone number too short after IDD" === c.message || "The string supplied is too short to be a phone number" === c.message ? 2 : "The string supplied is too long to be a phone number" === c.message ? 3 : -99;
                }
            });
            m("intlTelInputUtilsTemp.isValidNumber", (a, b)=>{
                try {
                    const l = J.g();
                    var c = X(l, a, b), d = bb(l, c);
                    a = l;
                    var e = w(c, 1), f = Q(a, e, d);
                    if (null == f || "001" != d && e != cb(a, d)) var g = false;
                    else {
                        var h = P(c);
                        g = -1 != ab(h, f);
                    }
                    return g;
                } catch (l) {
                    return false;
                }
            });
            m("intlTelInputUtilsTemp.isPossibleNumber", (a, b, c)=>{
                try {
                    const d = J.g(), e = X(d, a, b);
                    if (c) {
                        const f = 0 === W(d, e, Z[c]);
                        if ("FIXED_LINE_OR_MOBILE" === c) {
                            const g = 0 === W(d, e, Z.MOBILE), h = 0 === W(d, e, Z.FIXED_LINE);
                            return g || h || f;
                        }
                        return f;
                    }
                    return 0 === W(d, e, -1);
                } catch (d) {
                    return false;
                }
            });
            m("intlTelInputUtilsTemp.getCoreNumber", (a, b)=>{
                try {
                    return r(X(J.g(), a, b), 2).toString();
                } catch (c) {
                    return "";
                }
            });
            m("intlTelInputUtilsTemp.numberFormat", {
                E164: 0,
                INTERNATIONAL: 1,
                NATIONAL: 2,
                RFC3966: 3
            });
            m("intlTelInputUtilsTemp.numberType", Z);
            m("intlTelInputUtilsTemp.validationError", {
                IS_POSSIBLE: 0,
                INVALID_COUNTRY_CODE: 1,
                TOO_SHORT: 2,
                TOO_LONG: 3,
                IS_POSSIBLE_LOCAL_ONLY: 4,
                INVALID_LENGTH: 5
            });
        })();
        var utils = window.intlTelInputUtilsTemp;
        delete window.intlTelInputUtilsTemp;
        var utils_default = utils;
        // src/js/intl-tel-input/intlTelInputWithUtils.ts
        intl_tel_input_default.utils = utils_default;
        var intlTelInputWithUtils_default = intl_tel_input_default;
        return __toCommonJS(intlTelInputWithUtils_exports);
    })();
    // UMD
    return factoryOutput.default;
});


const $22d8fe6381852ff1$var$contactForm = document.querySelector(".contact-form");
let $22d8fe6381852ff1$var$b1 = "linear-gradient(216deg, #ffffff 25.97%, rgba(255, 255, 255, 0) 36.63%, rgba(255, 255, 255, 0) 67.82%, #ffffff 78.13%)";
let $22d8fe6381852ff1$var$b2 = "linear-gradient(144deg, #ffffff 25.97%, rgba(255, 255, 255, 0) 36.63%, rgba(255, 255, 255, 0) 67.82%, #ffffff 78.13%)";
if ($22d8fe6381852ff1$var$contactForm) {
    (0, $b57bb984cb8a78c2$export$99ee26438460406a).timeline({
        repeat: -1,
        yoyo: "true",
        repeatDelay: 3
    }).add((0, $b57bb984cb8a78c2$export$99ee26438460406a).set($22d8fe6381852ff1$var$contactForm, {
        background: $22d8fe6381852ff1$var$b1
    })).add((0, $b57bb984cb8a78c2$export$99ee26438460406a).to($22d8fe6381852ff1$var$contactForm, {
        ease: "none",
        duration: 6,
        background: $22d8fe6381852ff1$var$b2
    })).play(0);
    // Form
    const submitBtn = $22d8fe6381852ff1$var$contactForm.querySelector("#submit-contact-us");
    const nameInput = $22d8fe6381852ff1$var$contactForm.querySelector("#name");
    const phoneInput = $22d8fe6381852ff1$var$contactForm.querySelector("#phone");
    const agreeCheckbox = $22d8fe6381852ff1$var$contactForm.querySelector("#agree-checkbox");
    const tariffBtns = document.querySelectorAll(".tariff .btn");
    const iti = (0, (/*@__PURE__*/$parcel$interopDefault($2338751fefe03e79$exports)))(phoneInput, {
        initialCountry: "auto",
        strictMode: true,
        separateDialCode: true,
        excludeCountries: [
            "ru",
            "by"
        ],
        geoIpLookup: (callback)=>{
            fetch("https://ipapi.co/json").then((res)=>res.json()).then((data)=>callback(data.country_code)).catch(()=>callback("ua"));
        }
    });
    let selectedTariff = null;
    tariffBtns.forEach((btn)=>{
        btn.addEventListener("click", ()=>{
            const url = new URL(window.location.href);
            url.searchParams.set("tariff", btn.dataset.tariff);
            window.history.pushState(null, "", url.toString());
        });
    });
    agreeCheckbox.addEventListener("change", ()=>{
        if (agreeCheckbox.checked) submitBtn.disabled = false;
        else submitBtn.disabled = true;
    });
    submitBtn.addEventListener("click", async (e)=>{
        e.preventDefault();
        try {
            submitBtn.classList.add("is-loading");
            if (!iti.isValidNumber()) throw new Error("Invalid phone number");
            const name = nameInput.value;
            const phone = iti.getNumber();
            // const foundContacts = await api.get(`/contact?query=${phone}`);
            // if (foundContacts?.data) {
            //   console.log('Contact allready exists!');
            //   notify('Contact allready exists!', 'error');
            //   throw new Error('Contact allready exists!');
            // }
            const newContact = await (0, $abced26eb1aa148c$export$644d8ea042df96a6).post("/contact", {
                name: name,
                phone: phone
            });
            const newLead = await (0, $abced26eb1aa148c$export$644d8ea042df96a6).post("/lead", {
                name: "Contact us",
                phone: phone,
                pipeline_id: 8243187,
                link: window.location.href
            });
            await (0, $abced26eb1aa148c$export$644d8ea042df96a6).post("/lead-contact-link", {
                lead_id: newLead.data._embedded.leads[0].id,
                contact_id: newContact.data._embedded.contacts[0].id
            });
            await (0, $abced26eb1aa148c$export$644d8ea042df96a6).post("/lead/user-data", {
                lead_id: newLead.data._embedded.leads[0].id,
                link: window.location.href,
                name: name,
                phone: phone,
                tariff: selectedTariff ?? "-"
            });
            nameInput.value = "";
            phoneInput.value = "";
            // window.gtag('event', 'contact-us', { phone, name });
            (0, $c5d5259bbc3a9a51$export$5e14cdade93d6f7b)("Feedback sent successfully!", "info");
            window.open("/thank-you?form=contact_us", "_self");
        } catch (error) {
            console.dir(error);
            (0, $c5d5259bbc3a9a51$export$5e14cdade93d6f7b)(`Error! \n ${error.message}`, "error");
        } finally{
            submitBtn.classList.remove("is-loading");
        }
    });
}




var $5be514799d345ef8$require$api = $abced26eb1aa148c$export$644d8ea042df96a6;

var $5be514799d345ef8$require$notify = $c5d5259bbc3a9a51$export$5e14cdade93d6f7b;
const $5be514799d345ef8$var$startEducationForm = document.querySelector(".start-education-form");
if ($5be514799d345ef8$var$startEducationForm) {
    const startEducationFormBtn = $5be514799d345ef8$var$startEducationForm.querySelector("#submit-start-education");
    const nameInput = $5be514799d345ef8$var$startEducationForm.querySelector("#education-name");
    const phoneInput = $5be514799d345ef8$var$startEducationForm.querySelector("#education-phone");
    startEducationFormBtn.addEventListener("click", async (e)=>{
        e.preventDefault();
        try {
            const iti = (0, (/*@__PURE__*/$parcel$interopDefault($2338751fefe03e79$exports))).getInstance(phoneInput);
            startEducationFormBtn.classList.add("is-loading");
            const name = nameInput.value;
            const phone = iti.getNumber();
            // const foundContacts = await api.get(`/contact?query=${phone}`);
            // if (foundContacts?.data) {
            //   console.log('Contact allready exists!');
            //   notify('Contact allready exists!', 'error');
            //   throw new Error('Contact allready exists!');
            // }
            const newContact = await $5be514799d345ef8$require$api.post("/contact", {
                name: name,
                phone: phone
            });
            const newLead = await $5be514799d345ef8$require$api.post("/lead", {
                name: "Free education",
                phone: phone,
                pipeline_id: 8243187,
                link: window.location.href
            });
            await $5be514799d345ef8$require$api.post("/lead-contact-link", {
                lead_id: newLead.data._embedded.leads[0].id,
                contact_id: newContact.data._embedded.contacts[0].id
            });
            await $5be514799d345ef8$require$api.post("/lead/user-data", {
                lead_id: newLead.data._embedded.leads[0].id,
                link: window.location.href,
                name: name,
                phone: phone,
                tariff: "-"
            });
            nameInput.value = "";
            phoneInput.value = "";
            // window.gtag('event', 'free-education', {
            //   phone,
            //   name,
            // });
            $5be514799d345ef8$require$notify("Request sent successfully!", "info");
            window.open("/thank-you?form=free_education", "_self");
        } catch (error) {
            console.log(error);
            $5be514799d345ef8$require$notify("Error!", JSON.stringify(error));
        } finally{
            startEducationFormBtn.classList.remove("is-loading");
        }
    });
}




var $1cf303795441c9cf$require$api = $abced26eb1aa148c$export$644d8ea042df96a6;

var $1cf303795441c9cf$require$notify = $c5d5259bbc3a9a51$export$5e14cdade93d6f7b;
const $1cf303795441c9cf$var$form = document.querySelector(".learning-request-form");
if ($1cf303795441c9cf$var$form) {
    const submit = $1cf303795441c9cf$var$form.querySelector("#submit-learning-request");
    const nameInput = $1cf303795441c9cf$var$form.querySelector("#learning-request-name");
    const phoneInput = $1cf303795441c9cf$var$form.querySelector("#learning-request-phone");
    submit.addEventListener("click", async (e)=>{
        e.preventDefault();
        try {
            const params = new URL(window.location.href).searchParams;
            console.log("params", params);
            const tariff = params.get("tariff");
            const tariffName = tariff ? ` (${tariff})` : "";
            console.log(tariff);
            const iti = (0, (/*@__PURE__*/$parcel$interopDefault($2338751fefe03e79$exports))).getInstance(phoneInput);
            submit.classList.add("is-loading");
            const name = nameInput.value;
            const phone = iti.getNumber();
            // const foundContacts = await api.get(`/contact?query=${phone}`);
            // if (foundContacts?.data) {
            //   console.log('Contact allready exists!');
            //   notify('Contact allready exists!', 'error');
            //   throw new Error('Contact allready exists!');
            // }
            const newContact = await $1cf303795441c9cf$require$api.post("/contact", {
                name: name,
                phone: phone
            });
            const newLead = await $1cf303795441c9cf$require$api.post("/lead", {
                name: `Education request ${tariffName}`,
                phone: phone,
                pipeline_id: 8243187,
                link: window.location.href
            });
            await $1cf303795441c9cf$require$api.post("/lead-contact-link", {
                lead_id: newLead.data._embedded.leads[0].id,
                contact_id: newContact.data._embedded.contacts[0].id
            });
            await $1cf303795441c9cf$require$api.post("/lead/user-data", {
                lead_id: newLead.data._embedded.leads[0].id,
                link: window.location.href,
                name: name,
                phone: phone,
                tariff: tariff ?? "-"
            });
            nameInput.value = "";
            phoneInput.value = "";
            // window.gtag('event', 'learning-request', {
            //   phone,
            //   name,
            //   tariff: tariff ?? '-',
            // });
            $1cf303795441c9cf$require$notify("Request sent successfully!", "info");
            window.open("/thank-you?form=learning_request", "_self");
        } catch (error) {
            console.log(error);
            $1cf303795441c9cf$require$notify("Error!", JSON.stringify(error));
        } finally{
            submit.classList.remove("is-loading");
        }
    });
}




var $2c0733dafc84381c$require$api = $abced26eb1aa148c$export$644d8ea042df96a6;

var $2c0733dafc84381c$require$notify = $c5d5259bbc3a9a51$export$5e14cdade93d6f7b;
const $2c0733dafc84381c$var$form = document.querySelector(".scalping-info-form");
if ($2c0733dafc84381c$var$form) {
    const formBtn = $2c0733dafc84381c$var$form.querySelector("#submit-scalping-info");
    const nameInput = $2c0733dafc84381c$var$form.querySelector("#scalping-info-name");
    const phoneInput = $2c0733dafc84381c$var$form.querySelector("#scalping-info-phone");
    formBtn.addEventListener("click", async (e)=>{
        e.preventDefault();
        try {
            const iti = (0, (/*@__PURE__*/$parcel$interopDefault($2338751fefe03e79$exports))).getInstance(phoneInput);
            formBtn.classList.add("is-loading");
            const name = nameInput.value;
            const phone = iti.getNumber();
            const newContact = await $2c0733dafc84381c$require$api.post("/contact", {
                name: name,
                phone: phone
            });
            const newLead = await $2c0733dafc84381c$require$api.post("/lead", {
                name: "Scalping info",
                phone: phone,
                pipeline_id: 8243187,
                link: window.location.href
            });
            await $2c0733dafc84381c$require$api.post("/lead-contact-link", {
                lead_id: newLead.data._embedded.leads[0].id,
                contact_id: newContact.data._embedded.contacts[0].id
            });
            await $2c0733dafc84381c$require$api.post("/lead/user-data", {
                lead_id: newLead.data._embedded.leads[0].id,
                link: window.location.href,
                name: name,
                phone: phone,
                tariff: "-"
            });
            nameInput.value = "";
            phoneInput.value = "";
            // window.gtag('event', 'scalping-info', {
            //   phone,
            //   name,
            // });
            $2c0733dafc84381c$require$notify("Request sent successfully!", "info");
            window.open("/thank-you?form=scalping_info", "_self");
        } catch (error) {
            console.log(error);
            $2c0733dafc84381c$require$notify("Error!", JSON.stringify(error));
        } finally{
            formBtn.classList.remove("is-loading");
        }
    });
}






const $80d2a33f50221227$var$callMe = document.querySelector(".call-me");
if ($80d2a33f50221227$var$callMe) {
    const callMeInputName = $80d2a33f50221227$var$callMe.querySelector("#call-me-name");
    const callMeInputPhone = $80d2a33f50221227$var$callMe.querySelector("#call-me-phone");
    const callMeSubmit = $80d2a33f50221227$var$callMe.querySelector(".call-me__submit-btn");
    const callMeBtn = $80d2a33f50221227$var$callMe.querySelector(".call-me__btn");
    callMeBtn.addEventListener("click", ()=>{
        if (window.innerWidth < 768) (0, $5d06d6416fb3ab3b$export$10d7d627988df375)("call-me-popup");
        else $80d2a33f50221227$var$callMe.classList.toggle("active");
    });
    callMeSubmit.addEventListener("click", async (e)=>{
        e.preventDefault();
        try {
            callMeSubmit.classList.add("is-loading");
            const iti = (0, (/*@__PURE__*/$parcel$interopDefault($2338751fefe03e79$exports))).getInstance(callMeInputPhone);
            const name = callMeInputName.value;
            const phone = iti.getNumber();
            const newContact = await (0, $abced26eb1aa148c$export$644d8ea042df96a6).post("/contact", {
                phone: phone,
                name: name
            });
            const newLead = await (0, $abced26eb1aa148c$export$644d8ea042df96a6).post("/lead", {
                name: "Call me",
                phone: phone,
                pipeline_id: 8243187,
                link: window.location.href
            });
            await (0, $abced26eb1aa148c$export$644d8ea042df96a6).post("/lead-contact-link", {
                lead_id: newLead.data._embedded.leads[0].id,
                contact_id: newContact.data._embedded.contacts[0].id
            });
            $80d2a33f50221227$var$callMe.classList.remove("active");
            callMeInputPhone.value = "";
            callMeInputName.value = "";
            // window.gtag('event', 'call-me', { phone, name });
            (0, $c5d5259bbc3a9a51$export$5e14cdade93d6f7b)("\u0412\u0430\u0448\u0430 \u0437\u0430\u044F\u0432\u043A\u0430 \u043F\u0440\u0438\u0439\u043D\u044F\u0442\u0430!");
            window.open("/thank-you?form=call_me", "_self");
        } catch (error) {
            console.error(error);
            (0, $c5d5259bbc3a9a51$export$5e14cdade93d6f7b)("\u041F\u043E\u043C\u0438\u043B\u043A\u0430", "error");
        } finally{
            callMeSubmit.classList.remove("is-loading");
        }
    });
}
const $80d2a33f50221227$var$callMePopup = document.querySelector("#call-me-popup");
if ($80d2a33f50221227$var$callMePopup) {
    const callMePopupInputName = $80d2a33f50221227$var$callMePopup.querySelector("#call-me-popup-name");
    const callMePopupInputPhone = $80d2a33f50221227$var$callMePopup.querySelector("#call-me-popup-phone");
    const callMePopupSubmit = $80d2a33f50221227$var$callMePopup.querySelector("#submit-call-me-popup");
    callMePopupSubmit.addEventListener("click", async (e)=>{
        e.preventDefault();
        try {
            callMePopupSubmit.classList.add("is-loading");
            const name = callMePopupInputName.value;
            const phone = callMePopupInputPhone.value;
            const newContact = await (0, $abced26eb1aa148c$export$644d8ea042df96a6).post("/contact", {
                name: name,
                phone: phone
            });
            const newLead = await (0, $abced26eb1aa148c$export$644d8ea042df96a6).post("/lead", {
                name: "Call me form",
                phone: phone,
                pipeline_id: 8243187,
                link: window.location.href
            });
            await (0, $abced26eb1aa148c$export$644d8ea042df96a6).post("/lead-contact-link", {
                lead_id: newLead.data._embedded.leads[0].id,
                contact_id: newContact.data._embedded.contacts[0].id
            });
            $80d2a33f50221227$var$callMePopup.classList.remove("is-open");
            callMePopupInputName.value = "";
            callMePopupInputPhone.value = "";
            (0, $c5d5259bbc3a9a51$export$5e14cdade93d6f7b)("\u0412\u0430\u0448\u0430 \u0437\u0430\u044F\u0432\u043A\u0430 \u043F\u0440\u0438\u043D\u044F\u0442\u0430!");
        } catch (error) {
            console.error(error);
            (0, $c5d5259bbc3a9a51$export$5e14cdade93d6f7b)("\u041F\u043E\u043C\u0438\u043B\u043A\u0430", "error");
        } finally{
            callMePopupSubmit.classList.remove("is-loading");
        }
    });
}



const $e1a63532f9713047$var$forms = document.querySelectorAll("[data-form]");
$e1a63532f9713047$var$forms.forEach((form)=>{
    const submitBtn = form.querySelector('[data-form="submit"]');
    const inputs = form.querySelectorAll('[data-form="input"]');
    const checkboxes = form.querySelectorAll('[data-form="checkbox"]');
    const phoneInputs = form.querySelectorAll('[data-form="phone"]');
    phoneInputs.forEach((input)=>{
        const iti = (0, (/*@__PURE__*/$parcel$interopDefault($2338751fefe03e79$exports)))(input, {
            initialCountry: "auto",
            strictMode: true,
            separateDialCode: true,
            geoIpLookup: (callback)=>{
                fetch("https://ipapi.co/json").then((res)=>res.json()).then((data)=>callback(data.country_code)).catch(()=>callback("ua"));
            }
        });
        input.addEventListener("open:countrydropdown", ()=>{
            const dropdownRect = iti.dropdownContent.getBoundingClientRect();
            const { innerHeight: innerHeight } = window;
            if (dropdownRect.bottom > innerHeight) {
                iti.dropdownContent.style.bottom = "100%";
                iti.dropdownContent.style.marginBottom = "3px";
            }
        });
        input.addEventListener("close:countrydropdown", ()=>{
            iti.dropdownContent.style.bottom = null;
            iti.dropdownContent.style.marginBottom = null;
        });
    });
    const requiredInputs = [
        ...inputs
    ].filter((input)=>input.required);
    const requiredCheckboxes = [
        ...checkboxes
    ].filter((checkbox)=>checkbox.required);
    const isInputsFilled = (inputs)=>{
        return inputs.every((input)=>input.value !== "");
    };
    const isCheckboxesTrue = (checkboxes)=>{
        return checkboxes.every((checkbox)=>checkbox.checked);
    };
    const isPhoneInputsValid = (inputs)=>{
        return [
            ...inputs
        ].every((input)=>{
            const iti = (0, (/*@__PURE__*/$parcel$interopDefault($2338751fefe03e79$exports))).getInstance(input);
            console.dir(iti.dropdownContent);
            return iti.isValidNumber();
        });
    };
    const isValidFormData = ()=>{
        return isInputsFilled(requiredInputs) && isPhoneInputsValid(phoneInputs) && isCheckboxesTrue(requiredCheckboxes);
    };
    if (!isValidFormData()) submitBtn.disabled = true;
    [
        ...requiredInputs,
        ...phoneInputs
    ].forEach((input)=>{
        input.addEventListener("input", ()=>{
            if (!isValidFormData()) submitBtn.disabled = true;
            else submitBtn.disabled = false;
        });
    });
    checkboxes.forEach((checkbox)=>{
        checkbox.addEventListener("change", ()=>{
            if (!isValidFormData()) submitBtn.disabled = true;
            else submitBtn.disabled = false;
        });
    });
    submitBtn?.addEventListener("click", (e)=>{
        e.preventDefault();
        const formData = new FormData(form);
        const data = Object.fromEntries(formData);
        console.log(data);
    });
});


const $6dfb3f3b49e981bb$var$imgs = document.querySelectorAll("img");
$6dfb3f3b49e981bb$var$imgs.forEach((img)=>{
    img.addEventListener("error", ()=>{
        img.src = `/${img.src}`;
    });
});


/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $ef9ff4a900b8c936$export$dfd9b671c89acc8e = 7;
const $ef9ff4a900b8c936$export$3913210603d8e9ae = 365.2425;
const $ef9ff4a900b8c936$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
const $ef9ff4a900b8c936$export$4dec998e48f9c246 = -$ef9ff4a900b8c936$export$81caae6e1cc7a622;
const $ef9ff4a900b8c936$export$4fad13613e88edc8 = 604800000;
const $ef9ff4a900b8c936$export$b76b1809a2898f9a = 86400000;
const $ef9ff4a900b8c936$export$91246f0b9bd9beff = 60000;
const $ef9ff4a900b8c936$export$7f72910d6dfd237a = 3600000;
const $ef9ff4a900b8c936$export$397c2d5776aa9055 = 1000;
const $ef9ff4a900b8c936$export$3633035e63cee86a = 525600;
const $ef9ff4a900b8c936$export$ab7da2ccd1075c38 = 43200;
const $ef9ff4a900b8c936$export$2423174df8cd3cd2 = 1440;
const $ef9ff4a900b8c936$export$f2f5ae5a8e2d8f9f = 60;
const $ef9ff4a900b8c936$export$3c58128db900d44e = 3;
const $ef9ff4a900b8c936$export$80d7e435f744f319 = 12;
const $ef9ff4a900b8c936$export$4db7641526e3241f = 4;
const $ef9ff4a900b8c936$export$698aec755e92c695 = 3600;
const $ef9ff4a900b8c936$export$a77c1a7ebebe2a5a = 60;
const $ef9ff4a900b8c936$export$815a9362476d2fe3 = $ef9ff4a900b8c936$export$698aec755e92c695 * 24;
const $ef9ff4a900b8c936$export$34804a017b31e2fe = $ef9ff4a900b8c936$export$815a9362476d2fe3 * 7;
const $ef9ff4a900b8c936$export$7271e9e3478110d1 = $ef9ff4a900b8c936$export$815a9362476d2fe3 * $ef9ff4a900b8c936$export$3913210603d8e9ae;
const $ef9ff4a900b8c936$export$8e6600bbdee7dabb = $ef9ff4a900b8c936$export$7271e9e3478110d1 / 12;
const $ef9ff4a900b8c936$export$be1dccf2de902d31 = $ef9ff4a900b8c936$export$8e6600bbdee7dabb * 3;
const $ef9ff4a900b8c936$export$2a7b97929c48d47d = Symbol.for("constructDateFrom");


function $1629ce087a739a52$export$ead8a1812b171991(date, value) {
    if (typeof date === "function") return date(value);
    if (date && typeof date === "object" && (0, $ef9ff4a900b8c936$export$2a7b97929c48d47d) in date) return date[0, $ef9ff4a900b8c936$export$2a7b97929c48d47d](value);
    if (date instanceof Date) return new date.constructor(value);
    return new Date(value);
}
var // Fallback for modularized imports:
$1629ce087a739a52$export$2e2bcd8739ae039 = $1629ce087a739a52$export$ead8a1812b171991;



function $5184de0208a988ce$export$e67a095c620b86fe(argument, context) {
    // [TODO] Get rid of `toDate` or `constructFrom`?
    return (0, $1629ce087a739a52$export$ead8a1812b171991)(context || argument, argument);
}
var // Fallback for modularized imports:
$5184de0208a988ce$export$2e2bcd8739ae039 = $5184de0208a988ce$export$e67a095c620b86fe;


function $cda1c4900960825f$export$dd412b56f1e4d8aa(date, amount, options) {
    const _date = (0, $5184de0208a988ce$export$e67a095c620b86fe)(date, options?.in);
    if (isNaN(amount)) return (0, $1629ce087a739a52$export$ead8a1812b171991)(options?.in || date, NaN);
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    if (!amount) return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}
var // Fallback for modularized imports:
$cda1c4900960825f$export$2e2bcd8739ae039 = $cda1c4900960825f$export$dd412b56f1e4d8aa;



function $210030cc33170b45$export$17c93e242b2d3a22(date, amount, options) {
    const _date = (0, $5184de0208a988ce$export$e67a095c620b86fe)(date, options?.in);
    if (isNaN(amount)) return (0, $1629ce087a739a52$export$ead8a1812b171991)(options?.in || date, NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
    const dayOfMonth = _date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    const endOfDesiredMonth = (0, $1629ce087a739a52$export$ead8a1812b171991)(options?.in || date, _date.getTime());
    endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
    const daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        _date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return _date;
    }
}
var // Fallback for modularized imports:
$210030cc33170b45$export$2e2bcd8739ae039 = $210030cc33170b45$export$17c93e242b2d3a22;


function $d9c11d33d9ba8849$export$9f53b88e82f64d8d(context, ...dates) {
    const normalize = (0, $1629ce087a739a52$export$ead8a1812b171991).bind(null, context || dates.find((date)=>typeof date === "object"));
    return dates.map(normalize);
}



function $8dd8e3c4ab2913f3$export$113002b5eff6e430(date) {
    const _date = (0, $5184de0208a988ce$export$e67a095c620b86fe)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}





function $ece08dc474bc3c84$export$63fa379ae8a9ba2(date, options) {
    const _date = (0, $5184de0208a988ce$export$e67a095c620b86fe)(date, options?.in);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$ece08dc474bc3c84$export$2e2bcd8739ae039 = $ece08dc474bc3c84$export$63fa379ae8a9ba2;


function $d4d87cb9932e3018$export$4a02e9c37dab4871(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $d9c11d33d9ba8849$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    const laterStartOfDay = (0, $ece08dc474bc3c84$export$63fa379ae8a9ba2)(laterDate_);
    const earlierStartOfDay = (0, $ece08dc474bc3c84$export$63fa379ae8a9ba2)(earlierDate_);
    const laterTimestamp = +laterStartOfDay - (0, $8dd8e3c4ab2913f3$export$113002b5eff6e430)(laterStartOfDay);
    const earlierTimestamp = +earlierStartOfDay - (0, $8dd8e3c4ab2913f3$export$113002b5eff6e430)(earlierStartOfDay);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((laterTimestamp - earlierTimestamp) / (0, $ef9ff4a900b8c936$export$b76b1809a2898f9a));
}
var // Fallback for modularized imports:
$d4d87cb9932e3018$export$2e2bcd8739ae039 = $d4d87cb9932e3018$export$4a02e9c37dab4871;


function $03e8b21b6e454d65$export$86415ebf4eb36b8c(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $d9c11d33d9ba8849$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    const sign = $03e8b21b6e454d65$var$compareLocalAsc(laterDate_, earlierDate_);
    const difference = Math.abs((0, $d4d87cb9932e3018$export$4a02e9c37dab4871)(laterDate_, earlierDate_));
    laterDate_.setDate(laterDate_.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastDayNotFull = Number($03e8b21b6e454d65$var$compareLocalAsc(laterDate_, earlierDate_) === -sign);
    const result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
// Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $03e8b21b6e454d65$var$compareLocalAsc(laterDate, earlierDate) {
    const diff = laterDate.getFullYear() - earlierDate.getFullYear() || laterDate.getMonth() - earlierDate.getMonth() || laterDate.getDate() - earlierDate.getDate() || laterDate.getHours() - earlierDate.getHours() || laterDate.getMinutes() - earlierDate.getMinutes() || laterDate.getSeconds() - earlierDate.getSeconds() || laterDate.getMilliseconds() - earlierDate.getMilliseconds();
    if (diff < 0) return -1;
    if (diff > 0) return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
    return diff;
}
var // Fallback for modularized imports:
$03e8b21b6e454d65$export$2e2bcd8739ae039 = $03e8b21b6e454d65$export$86415ebf4eb36b8c;


function $d02275fe1902632f$export$a2258d9c4118825c(date, options) {
    const _date = (0, $5184de0208a988ce$export$e67a095c620b86fe)(date, options?.in);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$d02275fe1902632f$export$2e2bcd8739ae039 = $d02275fe1902632f$export$a2258d9c4118825c;


function $935b475bc5a55be1$export$618d60ea299da42(date, options) {
    const day = (0, $5184de0208a988ce$export$e67a095c620b86fe)(date, options?.in).getDay();
    return day === 0 || day === 6;
}
var // Fallback for modularized imports:
$935b475bc5a55be1$export$2e2bcd8739ae039 = $935b475bc5a55be1$export$618d60ea299da42;


function $c40780409d14ce8c$export$a5a3b454ada2268e(date, options) {
    const _date = (0, $5184de0208a988ce$export$e67a095c620b86fe)(date, options?.in);
    _date.setDate(1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$c40780409d14ce8c$export$2e2bcd8739ae039 = $c40780409d14ce8c$export$a5a3b454ada2268e;


const $7a67268d471a525d$var$tariffsSection = document.querySelector(".tariffs-section");
if ($7a67268d471a525d$var$tariffsSection) {
    const tariffIndividual = $7a67268d471a525d$var$tariffsSection.querySelector("#tariff-individual");
    const tariffTeam = $7a67268d471a525d$var$tariffsSection.querySelector("#tariff-team");
    if (tariffTeam) {
        const MAX_PLACES = 20;
        const placesRef = tariffTeam.querySelector("[data-tariff-places]");
        const dateRef = tariffTeam.querySelector("[data-tariff-date]");
        const nextCourseDateStart = $7a67268d471a525d$var$getFirstWorkingDayNextMonth();
        dateRef.textContent = nextCourseDateStart.toLocaleDateString("uk-UA", {
            day: "numeric",
            month: "numeric",
            year: "numeric"
        });
        const dates = $7a67268d471a525d$var$splitMonthInto7Parts();
        const placesByIdx = {
            0: 2,
            1: 5,
            2: 7,
            3: 12,
            4: 14,
            5: 16,
            6: 19
        };
        const currentPlaceIndex = dates.findLastIndex((date)=>{
            return Date.now() > date.getTime();
        });
        placesRef.textContent = placesByIdx[currentPlaceIndex] ?? MAX_PLACES - 1;
    }
    if (tariffIndividual) {
        const MAX_PLACES = 10;
        const placesRef = tariffIndividual.querySelector("[data-tariff-places]");
        const dates = $7a67268d471a525d$var$splitMonthInto7Parts();
        const placesByIdx = {
            0: 1,
            1: 2,
            2: 4,
            3: 6,
            4: 7,
            5: 8,
            6: 9
        };
        const currentPlaceIndex = dates.findLastIndex((date)=>{
            return Date.now() > date.getTime();
        });
        placesRef.textContent = placesByIdx[currentPlaceIndex] ?? MAX_PLACES - 1;
    }
}
function $7a67268d471a525d$var$getFirstWorkingDayNextMonth() {
    let nextMonth = (0, $210030cc33170b45$export$17c93e242b2d3a22)(new Date(), 1);
    let firstDayNextMonth = (0, $c40780409d14ce8c$export$a5a3b454ada2268e)(nextMonth);
    while((0, $935b475bc5a55be1$export$618d60ea299da42)(firstDayNextMonth))firstDayNextMonth = (0, $cda1c4900960825f$export$dd412b56f1e4d8aa)(firstDayNextMonth, 1);
    return firstDayNextMonth;
}
function $7a67268d471a525d$var$splitMonthInto7Parts() {
    const start = (0, $c40780409d14ce8c$export$a5a3b454ada2268e)(new Date());
    const end = (0, $d02275fe1902632f$export$a2258d9c4118825c)(new Date());
    const totalDaysInMonth = (0, $03e8b21b6e454d65$export$86415ebf4eb36b8c)(end, start) + 1;
    const daysPerSegment = Math.floor(totalDaysInMonth / 7);
    const dates = [];
    for(let i = 0; i < 6; i++){
        const currentDate = (0, $cda1c4900960825f$export$dd412b56f1e4d8aa)(start, i * daysPerSegment);
        dates.push(currentDate);
    }
    dates.push(end);
    return dates;
}


// Light animation by scroll
const $3d18640b262d33cb$var$aiv = ({ once: once, selector: selector } = {
    once: false,
    selector: null
})=>{
    const animateInViewElements = document.querySelectorAll("[data-aiv]");
    const animateInViewElementsBySelector = document.querySelectorAll(selector);
    const observer = new IntersectionObserver((entries, observer)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                entry.target.classList.add("in-view");
                if (once) observer.unobserve(entry.target);
            } else if (!once) entry.target.classList.remove("in-view");
        });
    }, {
        threshold: 0.25
    });
    [
        ...animateInViewElements,
        ...animateInViewElementsBySelector
    ].forEach((item)=>{
        const { dataset: dataset } = item;
        item.style.transition = `all ease ${dataset.aivTime || 500}ms ${dataset.aivDelay || 0}ms`;
        observer.observe(item);
    });
};
var $3d18640b262d33cb$export$2e2bcd8739ae039 = $3d18640b262d33cb$var$aiv;


(0, $3d18640b262d33cb$export$2e2bcd8739ae039)({
    once: true
});

})();
//# sourceMappingURL=scripts.d2443f77.js.map
